/*
This list is compressed from the list published here https://github.com/lshk-org/jyutping-table .
The original list was:
- created by the 'Jyutping Workgroup of LSHK'
- had 38,306 rows
- had 29,144 unique chars
- 1 Chinese Character can have multiple rows.
- 1 row can list multiple Jyutpings, delimited by " ".

This json was generated on 2020.11.19.
Jyutpings for each char are delimited by 1. a forward slash "/", and a 2. ".".
*/ var cantojpmin_data = {
    "\u3400": "jau1",
    "\u3401": "dou6",
    "\u3402": "cat1",
    "\u3403": "zim1",
    "\u3404": "kwaa1",
    "\u3405": "ng5/m5",
    "\u3406": "ji1",
    "\u3407": "gau2",
    "\u3408": "jap6",
    "\u3409": "ding1",
    "\u340A": "si6",
    "\u340B": "tou2",
    "\u340C": "ji4",
    "\u340D": "zaau2",
    "\u340E": "man4",
    "\u340F": "ng5/m5",
    "\u3410": "nou4/lou4",
    "\u3411": "dung1",
    "\u3412": "ziu6",
    "\u3413": "ho2",
    "\u3414": "hang1",
    "\u3415": "jau4",
    "\u3416": "kit3",
    "\u3417": "lou5",
    "\u3418": "mai5",
    "\u3419": "dau6",
    "\u341A": "ng4/m4",
    "\u341B": "jau6",
    "\u341C": "sau4",
    "\u341D": "keoi1",
    "\u341E": "kei4",
    "\u341F": "fei1",
    "\u3420": "jyu5",
    "\u3421": "no6/lo6",
    "\u3422": "fau4",
    "\u3423": "fu3",
    "\u3424": "daan1",
    "\u3425": "co4",
    "\u3426": "geoi2",
    "\u3427": "coi4",
    "\u3428": "zeoi6",
    "\u3429": "jing4",
    "\u342A": "si2",
    "\u342B": "hung1",
    "\u342C": "lau4",
    "\u342D": "lam5",
    "\u342E": "soeng1",
    "\u342F": "jung4",
    "\u3430": "seon3",
    "\u3431": "can2",
    "\u3432": "daai6",
    "\u3433": "ngat6/at6",
    "\u3434": "paan1",
    "\u3435": "jyu4",
    "\u3436": "ci5",
    "\u3437": "maa6/maa3",
    "\u3438": "him3",
    "\u3439": "ngat6/at6",
    "\u343A": "jam4",
    "\u343B": "noi6/loi6",
    "\u343C": "cing2",
    "\u343D": "fung1",
    "\u343E": "wun6",
    "\u343F": "sau2",
    "\u3440": "taai3",
    "\u3441": "zeot1",
    "\u3442": "fong2",
    "\u3443": "aau2/ngaau2",
    "\u3444": "mou5",
    "\u3445": "zok3",
    "\u3446": "hing1",
    "\u3447": "zau3/cau1",
    "\u3448": "dung1",
    "\u3449": "suk1",
    "\u344A": "jik6",
    "\u344B": "hung3",
    "\u344C": "hong1/wong1",
    "\u344D": "loi6",
    "\u344E": "nou5/lou5",
    "\u344F": "cyu5",
    "\u3450": "suk1",
    "\u3451": "zat6",
    "\u3452": "cim1",
    "\u3453": "zeon3",
    "\u3454": "seoi2",
    "\u3455": "seoi3",
    "\u3456": "zung6",
    "\u3457": "san1",
    "\u3458": "gaai3",
    "\u3459": "dip3",
    "\u345A": "naa5/laa5",
    "\u345B": "suk1",
    "\u345C": "jai6",
    "\u345D": "lung6",
    "\u345E": "jing6",
    "\u345F": "bang2",
    "\u3460": "gin1",
    "\u3461": "zik1",
    "\u3462": "koek3",
    "\u3463": "laam4",
    "\u3464": "maau4",
    "\u3465": "ji6",
    "\u3466": "lai6",
    "\u3467": "gwai3",
    "\u3468": "jyu5",
    "\u3469": "lo4",
    "\u346A": "caai4",
    "\u346B": "nim6/lim6",
    "\u346C": "gu1/gwu1",
    "\u346D": "bei2",
    "\u346E": "wan4",
    "\u346F": "seoi2",
    "\u3470": "fui3",
    "\u3471": "jiu5",
    "\u3472": "naam4/laam4",
    "\u3473": "zau3/cau1",
    "\u3474": "cam1",
    "\u3475": "zat6",
    "\u3476": "hei3",
    "\u3477": "taai3",
    "\u3478": "jiu4",
    "\u3479": "wui6",
    "\u347A": "zeon3",
    "\u347B": "maat3",
    "\u347C": "loek6",
    "\u347D": "tong4",
    "\u347E": "jiu4",
    "\u347F": "zaau6",
    "\u3480": "zaak6",
    "\u3481": "jyu5",
    "\u3482": "zoek3",
    "\u3483": "ji6",
    "\u3484": "jin5",
    "\u3485": "kai2",
    "\u3486": "kap1",
    "\u3487": "mou5",
    "\u3488": "haam3",
    "\u3489": "cong2",
    "\u348A": "saap3",
    "\u348B": "si1",
    "\u348C": "king4",
    "\u348D": "leoi4",
    "\u348E": "saap3",
    "\u348F": "hon4",
    "\u3490": "seon2",
    "\u3491": "fui2",
    "\u3492": "buk6",
    "\u3493": "taat3",
    "\u3494": "suk6",
    "\u3495": "ong1/ngong1",
    "\u3496": "ngau5/au5",
    "\u3497": "toi4",
    "\u3498": "syu6",
    "\u3499": "min4",
    "\u349A": "jan3",
    "\u349B": "tiu5",
    "\u349C": "jyu5",
    "\u349D": "mit6",
    "\u349E": "wai6",
    "\u349F": "niu5/liu5",
    "\u34A0": "haai6",
    "\u34A1": "jau4",
    "\u34A2": "joek6",
    "\u34A3": "jing3",
    "\u34A4": "cip3",
    "\u34A5": "fung1",
    "\u34A6": "leoi5",
    "\u34A7": "lai6",
    "\u34A8": "sin1",
    "\u34A9": "lo2",
    "\u34AA": "sek3",
    "\u34AB": "gei3",
    "\u34AC": "wong1",
    "\u34AD": "kwan1",
    "\u34AE": "fui1",
    "\u34AF": "jip6",
    "\u34B0": "cyun4",
    "\u34B1": "zik6",
    "\u34B2": "coi4",
    "\u34B3": "loeng5",
    "\u34B4": "gwat1",
    "\u34B5": "maau6",
    "\u34B6": "gung1",
    "\u34B7": "hing1",
    "\u34B8": "seoi6",
    "\u34B9": "din1",
    "\u34BA": "mong5",
    "\u34BB": "mou6",
    "\u34BC": "mun4/mang4",
    "\u34BD": "hyun1",
    "\u34BE": "ci3",
    "\u34BF": "lei4",
    "\u34C0": "buk1",
    "\u34C1": "mong5/tuk1.tau4.jyut6",
    "\u34C2": "kau3",
    "\u34C3": "dou3",
    "\u34C4": "zam3",
    "\u34C5": "ting1",
    "\u34C6": "leon4",
    "\u34C7": "juk1",
    "\u34C8": "bing3",
    "\u34C9": "wut6",
    "\u34CA": "dung6",
    "\u34CB": "gung6",
    "\u34CC": "cang1",
    "\u34CD": "cung1",
    "\u34CE": "cam1",
    "\u34CF": "gwing2",
    "\u34D0": "luk6",
    "\u34D1": "jing6",
    "\u34D2": "cat1",
    "\u34D3": "naam4/laam4",
    "\u34D4": "ze6",
    "\u34D5": "mit6",
    "\u34D6": "bat1",
    "\u34D7": "git3",
    "\u34D8": "suk1",
    "\u34D9": "hung1",
    "\u34DA": "gung1",
    "\u34DB": "gung1",
    "\u34DC": "jau3",
    "\u34DD": "jing4",
    "\u34DE": "kit3",
    "\u34DF": "pai1",
    "\u34E0": "dim3",
    "\u34E1": "fu2",
    "\u34E2": "lok6",
    "\u34E3": "hap1",
    "\u34E4": "gat1/kit3",
    "\u34E5": "tong1",
    "\u34E6": "maak3/baak3",
    "\u34E7": "gam1",
    "\u34E8": "ci3/cik3",
    "\u34E9": "hyun1",
    "\u34EA": "long5",
    "\u34EB": "fu1",
    "\u34EC": "fu1",
    "\u34ED": "hot3",
    "\u34EE": "diu1",
    "\u34EF": "lei4",
    "\u34F0": "waak6",
    "\u34F1": "tau4",
    "\u34F2": "pin1",
    "\u34F3": "dai1",
    "\u34F4": "jyun5",
    "\u34F5": "ngok6/ok6",
    "\u34F6": "kit3",
    "\u34F7": "ji6",
    "\u34F8": "zoek3",
    "\u34F9": "jeoi6",
    "\u34FA": "kin4",
    "\u34FB": "gong1",
    "\u34FC": "cat1",
    "\u34FD": "sung4",
    "\u34FE": "sai1",
    "\u34FF": "syu2",
    "\u3500": "king4",
    "\u3501": "dang1",
    "\u3502": "leon4",
    "\u3503": "zyut6",
    "\u3504": "suk1",
    "\u3505": "siu3",
    "\u3506": "caam5",
    "\u3507": "put3",
    "\u3508": "fei6",
    "\u3509": "zuk1",
    "\u350A": "zin2",
    "\u350B": "gaam3",
    "\u350C": "zau6",
    "\u350D": "caat3",
    "\u350E": "sit3",
    "\u350F": "lik6",
    "\u3510": "cim1",
    "\u3511": "cat1",
    "\u3512": "kwai4",
    "\u3513": "gin2",
    "\u3514": "gaa1",
    "\u3515": "gat6",
    "\u3516": "gaa1",
    "\u3517": "fai6",
    "\u3518": "ceot1",
    "\u3519": "paang1",
    "\u351A": "hau2",
    "\u351B": "kit3",
    "\u351C": "but6",
    "\u351D": "loeng5",
    "\u351E": "gwaai1",
    "\u351F": "sai3",
    "\u3520": "hat6",
    "\u3521": "bit3",
    "\u3522": "dyut3",
    "\u3523": "leoi6",
    "\u3524": "san3",
    "\u3525": "baa6",
    "\u3526": "joeng5",
    "\u3527": "leoi6",
    "\u3528": "bui3",
    "\u3529": "ap1/ngap1/hap6",
    "\u352A": "lou5",
    "\u352B": "lung4",
    "\u352C": "coek3",
    "\u352D": "ci4",
    "\u352E": "no4/lo4",
    "\u352F": "syun4",
    "\u3530": "hang4",
    "\u3531": "jyu4",
    "\u3532": "gwai2",
    "\u3533": "gwai2",
    "\u3534": "jik6",
    "\u3535": "syun2",
    "\u3536": "gung3",
    "\u3537": "lau6",
    "\u3538": "tai1",
    "\u3539": "lak6",
    "\u353A": "sai3",
    "\u353B": "pei1",
    "\u353C": "seon2",
    "\u353D": "jau5",
    "\u353E": "cim1/ngau1.zi6.pong4",
    "\u353F": "zau3",
    "\u3540": "wai3",
    "\u3541": "koek3",
    "\u3542": "jam4",
    "\u3543": "kai1",
    "\u3544": "zi2",
    "\u3545": "gaap3",
    "\u3546": "wu6",
    "\u3547": "laap6",
    "\u3548": "ji2",
    "\u3549": "hap6",
    "\u354A": "bou1",
    "\u354B": "kam4",
    "\u354C": "ngoi6/oi6",
    "\u354D": "deoi1",
    "\u354E": "hap6",
    "\u354F": "cyu4",
    "\u3550": "se2",
    "\u3551": "cyu4/ceoi4",
    "\u3552": "ngai4/ai4",
    "\u3553": "cin4",
    "\u3554": "teng1/ting1",
    "\u3555": "waan6",
    "\u3556": "sou3",
    "\u3557": "jau5",
    "\u3558": "saam1/saam3/caam1/sam1/cam1",
    "\u3559": "zeon3",
    "\u355A": "zaau2",
    "\u355B": "jau5",
    "\u355C": "si2",
    "\u355D": "si6",
    "\u355E": "caat3",
    "\u355F": "wai2",
    "\u3560": "soeng1/sung1",
    "\u3561": "kok3",
    "\u3562": "haai6",
    "\u3563": "jin5",
    "\u3564": "kau4",
    "\u3565": "ji5",
    "\u3566": "waa6",
    "\u3567": "si1",
    "\u3568": "faan6",
    "\u3569": "pong3",
    "\u356A": "dam2",
    "\u356B": "fung1",
    "\u356C": "zung1",
    "\u356D": "aau3/ngaau3/jiu1/jaau1",
    "\u356E": "fu2",
    "\u356F": "neot6/leot6",
    "\u3570": "hok3",
    "\u3571": "jau4",
    "\u3572": "muk1",
    "\u3573": "hung1",
    "\u3574": "sam2",
    "\u3575": "gwok3/gok3",
    "\u3576": "ng4/m4/ng6/m6",
    "\u3577": "waak1",
    "\u3578": "lap1",
    "\u3579": "fat6",
    "\u357A": "hiu1",
    "\u357B": "tau3",
    "\u357C": "hung1",
    "\u357D": "ci5",
    "\u357E": "siu2",
    "\u357F": "wo4",
    "\u3580": "leot6",
    "\u3581": "leon6",
    "\u3582": "jai6",
    "\u3583": "hau2",
    "\u3584": "zau1",
    "\u3585": "seot1",
    "\u3586": "kuk1",
    "\u3587": "ji4",
    "\u3588": "lou5",
    "\u3589": "kei5",
    "\u358A": "cam4/jing1.cam4",
    "\u358B": "gaai3",
    "\u358C": "sau4",
    "\u358D": "dau2",
    "\u358E": "gaai3",
    "\u358F": "nit6/lit6",
    "\u3590": "wai5",
    "\u3591": "haai3",
    "\u3592": "tai4",
    "\u3593": "hung4",
    "\u3594": "tan3",
    "\u3595": "san1",
    "\u3596": "ngot6/ot6",
    "\u3597": "jam4",
    "\u3598": "seon2/san2",
    "\u3599": "gaa1",
    "\u359A": "fu6",
    "\u359B": "gu2/gwu2",
    "\u359C": "jing1",
    "\u359D": "mei6",
    "\u359E": "waa1/wo5/wo3",
    "\u359F": "sau6",
    "\u35A0": "naa5/laa5",
    "\u35A1": "je6/e6/nge6",
    "\u35A2": "ci1",
    "\u35A3": "tau3",
    "\u35A4": "haam4",
    "\u35A5": "leon1",
    "\u35A6": "dung2",
    "\u35A7": "fan1/man5",
    "\u35A8": "luk6",
    "\u35A9": "zeoi1",
    "\u35AA": "waak6",
    "\u35AB": "ling4",
    "\u35AC": "sau1",
    "\u35AD": "tim1",
    "\u35AE": "leon4",
    "\u35AF": "tung4",
    "\u35B0": "tung4",
    "\u35B1": "je6",
    "\u35B2": "jyu4",
    "\u35B3": "jyu5",
    "\u35B4": "man5",
    "\u35B5": "got3",
    "\u35B6": "jin1",
    "\u35B7": "si4",
    "\u35B8": "laa1",
    "\u35B9": "pan3",
    "\u35BA": "ceon2",
    "\u35BB": "nau4/lau4",
    "\u35BC": "mau4",
    "\u35BD": "zaak3",
    "\u35BE": "ngok6/ok6",
    "\u35BF": "je5",
    "\u35C0": "jau1",
    "\u35C1": "ngok6/ok6",
    "\u35C2": "saang2",
    "\u35C3": "man5",
    "\u35C4": "ku1/kwu1",
    "\u35C5": "wu4",
    "\u35C6": "gaak3",
    "\u35C7": "haa1/gaa5",
    "\u35C8": "maan6",
    "\u35C9": "loek6",
    "\u35CA": "leoi4",
    "\u35CB": "hau4",
    "\u35CC": "zat1",
    "\u35CD": "zaai1",
    "\u35CE": "gaa3/gaa4/gaa2",
    "\u35CF": "waai1",
    "\u35D0": "haap3",
    "\u35D1": "baai3",
    "\u35D2": "oi1/ngoi1",
    "\u35D3": "zeoi1",
    "\u35D4": "hin1",
    "\u35D5": "gau3",
    "\u35D6": "daam6",
    "\u35D7": "bei2",
    "\u35D8": "bok3",
    "\u35D9": "co1",
    "\u35DA": "leot6",
    "\u35DB": "siu3",
    "\u35DC": "cau3",
    "\u35DD": "gou1",
    "\u35DE": "po3",
    "\u35DF": "zyu3",
    "\u35E0": "ci2",
    "\u35E1": "jing4",
    "\u35E2": "hung4",
    "\u35E3": "tai3",
    "\u35E4": "zuk1",
    "\u35E5": "kwok3/kok3",
    "\u35E6": "lou4",
    "\u35E7": "zat1",
    "\u35E8": "haai1",
    "\u35E9": "sap1",
    "\u35EA": "pei1",
    "\u35EB": "cit3",
    "\u35EC": "zaa1",
    "\u35ED": "sik1",
    "\u35EE": "gang1",
    "\u35EF": "ze2",
    "\u35F0": "cung4",
    "\u35F1": "zaap6/zep6",
    "\u35F2": "waak1",
    "\u35F3": "dap1",
    "\u35F4": "ngaan4/aan4",
    "\u35F5": "fat1",
    "\u35F6": "put3",
    "\u35F7": "coi3",
    "\u35F8": "haam4",
    "\u35F9": "wai4",
    "\u35FA": "saap3",
    "\u35FB": "go6",
    "\u35FC": "jip6",
    "\u35FD": "hoeng2",
    "\u35FE": "hoe1/hoe4",
    "\u35FF": "ho1",
    "\u3600": "zok3",
    "\u3601": "jik6",
    "\u3602": "ci4",
    "\u3603": "je5",
    "\u3604": "lang1",
    "\u3605": "haam4",
    "\u3606": "toi2",
    "\u3607": "wing4",
    "\u3608": "jik6",
    "\u3609": "zik1/zit1",
    "\u360A": "kap1",
    "\u360B": "jin4",
    "\u360C": "koek6",
    "\u360D": "zat1",
    "\u360E": "haam3/haam2",
    "\u360F": "dou6",
    "\u3610": "paau3",
    "\u3611": "lai6",
    "\u3612": "zung2",
    "\u3613": "laan4",
    "\u3614": "coi3",
    "\u3615": "haam3",
    "\u3616": "ngaan4/aan4",
    "\u3617": "keoi1",
    "\u3618": "lyun2",
    "\u3619": "ngaam4/aam4",
    "\u361A": "haam3/haam2",
    "\u361B": "ham1",
    "\u361C": "cau4",
    "\u361D": "naap6/laap6",
    "\u361E": "wo6",
    "\u361F": "coeng1",
    "\u3620": "bik1",
    "\u3621": "haap6",
    "\u3622": "wang2",
    "\u3623": "syun4",
    "\u3624": "waan1",
    "\u3625": "jau4/ngo4/o4",
    "\u3626": "kan4",
    "\u3627": "zeoi6",
    "\u3628": "nip6/lip6",
    "\u3629": "bei6",
    "\u362A": "hou3",
    "\u362B": "ging2",
    "\u362C": "aau3/ngaau3",
    "\u362D": "aau3/ngaau3/aau1/ngaau1",
    "\u362E": "jik6",
    "\u362F": "coeng4",
    "\u3630": "zam1",
    "\u3631": "taan1",
    "\u3632": "guk1",
    "\u3633": "jau1",
    "\u3634": "zo6",
    "\u3635": "bou3",
    "\u3636": "git6",
    "\u3637": "ngaai6/aai6",
    "\u3638": "zong3",
    "\u3639": "ci4",
    "\u363A": "fat6",
    "\u363B": "jan1",
    "\u363C": "haau2",
    "\u363D": "zoi1",
    "\u363E": "jyu5",
    "\u363F": "nit6/lit6",
    "\u3640": "lau6",
    "\u3641": "mui4",
    "\u3642": "deoi6",
    "\u3643": "bang1",
    "\u3644": "bai6",
    "\u3645": "bou2",
    "\u3646": "wang4",
    "\u3647": "cuk1",
    "\u3648": "haa3",
    "\u3649": "tin2",
    "\u364A": "coeng4",
    "\u364B": "gei1",
    "\u364C": "suk1",
    "\u364D": "zeoi3",
    "\u364E": "wai1",
    "\u364F": "fuk1",
    "\u3650": "do2",
    "\u3651": "jyu5",
    "\u3652": "je5",
    "\u3653": "kwai4",
    "\u3654": "wai5",
    "\u3655": "faai3",
    "\u3656": "jyu5",
    "\u3657": "wui1",
    "\u3658": "jiu1",
    "\u3659": "lung5",
    "\u365A": "sing1",
    "\u365B": "bou2",
    "\u365C": "kok3",
    "\u365D": "hip3",
    "\u365E": "ngat6/at6",
    "\u365F": "long5",
    "\u3660": "ai1/ngai1",
    "\u3661": "zung1",
    "\u3662": "mun4",
    "\u3663": "zoeng3",
    "\u3664": "laa3",
    "\u3665": "gwan3",
    "\u3666": "ce4",
    "\u3667": "lau6",
    "\u3668": "gei1",
    "\u3669": "liu4",
    "\u366A": "ai3/ngai3",
    "\u366B": "cap1",
    "\u366C": "ngan4/an4",
    "\u366D": "kyut3",
    "\u366E": "daap3",
    "\u366F": "ngai6/ai6",
    "\u3670": "haai5",
    "\u3671": "gou2",
    "\u3672": "jung1",
    "\u3673": "ham2",
    "\u3674": "cim3",
    "\u3675": "toi4",
    "\u3676": "tong4",
    "\u3677": "zaap6",
    "\u3678": "pok3",
    "\u3679": "mung6",
    "\u367A": "kwai4",
    "\u367B": "cin4",
    "\u367C": "leoi5",
    "\u367D": "sik1",
    "\u367E": "hok6",
    "\u367F": "hei1",
    "\u3680": "hei1",
    "\u3681": "kiu3",
    "\u3682": "nong6/long6",
    "\u3683": "wan1",
    "\u3684": "zi3",
    "\u3685": "lung4",
    "\u3686": "fuk6",
    "\u3687": "zung1",
    "\u3688": "ngoi6/oi6",
    "\u3689": "gu2/gwu2",
    "\u368A": "hoi1",
    "\u368B": "diu1",
    "\u368C": "fo2",
    "\u368D": "fui2",
    "\u368E": "heoi3",
    "\u368F": "gou2",
    "\u3690": "tou3",
    "\u3691": "ling4",
    "\u3692": "sim2",
    "\u3693": "loi4",
    "\u3694": "nip6/lip6",
    "\u3695": "bat6",
    "\u3696": "gou2",
    "\u3697": "ce4",
    "\u3698": "bun6",
    "\u3699": "gaa1",
    "\u369A": "kwang1",
    "\u369B": "hai3",
    "\u369C": "wik6",
    "\u369D": "zeoi1",
    "\u369E": "sam2",
    "\u369F": "coek3",
    "\u36A0": "hiu1",
    "\u36A1": "gei2",
    "\u36A2": "nou4/lou4",
    "\u36A3": "gaau2",
    "\u36A4": "jik6",
    "\u36A5": "jyu1",
    "\u36A6": "gei1",
    "\u36A7": "cim1",
    "\u36A8": "san1",
    "\u36A9": "jim5",
    "\u36AA": "hou3",
    "\u36AB": "saap3",
    "\u36AC": "gwan1",
    "\u36AD": "jau4",
    "\u36AE": "daam1",
    "\u36AF": "cam4",
    "\u36B0": "pui1",
    "\u36B1": "jau1",
    "\u36B2": "cim1",
    "\u36B3": "aa3/ngaa3",
    "\u36B4": "pou3",
    "\u36B5": "dung1",
    "\u36B6": "ci5",
    "\u36B7": "naai5/laai5",
    "\u36B8": "si1",
    "\u36B9": "maau4",
    "\u36BA": "jan6",
    "\u36BB": "gai1",
    "\u36BC": "nau2/lau2",
    "\u36BD": "haau2",
    "\u36BE": "hing1",
    "\u36BF": "baau1",
    "\u36C0": "co4",
    "\u36C1": "paang1",
    "\u36C2": "no4/lo4",
    "\u36C3": "git3",
    "\u36C4": "ji1",
    "\u36C5": "nei6/lei6",
    "\u36C6": "do3",
    "\u36C7": "zong1",
    "\u36C8": "haau2",
    "\u36C9": "jiu3",
    "\u36CA": "do3",
    "\u36CB": "nei5/lei5",
    "\u36CC": "mau4",
    "\u36CD": "hip3",
    "\u36CE": "leoi5",
    "\u36CF": "kau4",
    "\u36D0": "sou2",
    "\u36D1": "caan3",
    "\u36D2": "dau6",
    "\u36D3": "hei1",
    "\u36D4": "fung1",
    "\u36D5": "jap1",
    "\u36D6": "so1",
    "\u36D7": "ce1",
    "\u36D8": "put3",
    "\u36D9": "san1",
    "\u36DA": "tung2",
    "\u36DB": "san1",
    "\u36DC": "jau4",
    "\u36DD": "bui3",
    "\u36DE": "lung6",
    "\u36DF": "wun6",
    "\u36E0": "haan5",
    "\u36E1": "wan6",
    "\u36E2": "sau3",
    "\u36E3": "wan4",
    "\u36E4": "lei4",
    "\u36E5": "taap3",
    "\u36E6": "lam5",
    "\u36E7": "man5",
    "\u36E8": "koeng2",
    "\u36E9": "zuk6",
    "\u36EA": "jim3",
    "\u36EB": "sik1",
    "\u36EC": "luk6",
    "\u36ED": "sik1",
    "\u36EE": "sou2",
    "\u36EF": "faan3",
    "\u36F0": "fan1",
    "\u36F1": "wui2",
    "\u36F2": "faat3",
    "\u36F3": "jai6",
    "\u36F4": "nou5/lou5",
    "\u36F5": "cing1",
    "\u36F6": "taan3",
    "\u36F7": "gai1",
    "\u36F8": "syu6",
    "\u36F9": "pin4",
    "\u36FA": "jam1",
    "\u36FB": "waai1",
    "\u36FC": "caap3",
    "\u36FD": "saan1",
    "\u36FE": "haam4",
    "\u36FF": "daai3",
    "\u3700": "soeng1",
    "\u3701": "caa4",
    "\u3702": "fung1",
    "\u3703": "lyun2",
    "\u3704": "cam4",
    "\u3705": "huk1",
    "\u3706": "mai6",
    "\u3707": "wai3",
    "\u3708": "muk6",
    "\u3709": "jung1",
    "\u370A": "zin2",
    "\u370B": "jik1",
    "\u370C": "nau5/lau5",
    "\u370D": "tong4",
    "\u370E": "hai4",
    "\u370F": "wan4",
    "\u3710": "syu6",
    "\u3711": "po4",
    "\u3712": "ngai6/ai6",
    "\u3713": "daap3",
    "\u3714": "ging2",
    "\u3715": "lin4",
    "\u3716": "cou4",
    "\u3717": "caam1",
    "\u3718": "ze1",
    "\u3719": "luk6",
    "\u371A": "suk1",
    "\u371B": "jyun5",
    "\u371C": "ngou6/ou6",
    "\u371D": "ngam5/am5",
    "\u371E": "cim3",
    "\u371F": "haam3",
    "\u3720": "ceoi1",
    "\u3721": "cung1",
    "\u3722": "leoi5",
    "\u3723": "jin4",
    "\u3724": "nim5/lim5",
    "\u3725": "maai4",
    "\u3726": "cam4",
    "\u3727": "jyut3",
    "\u3728": "naai4/laai4",
    "\u3729": "ou3/ngou3",
    "\u372A": "san1",
    "\u372B": "mei5",
    "\u372C": "daam1",
    "\u372D": "dong1",
    "\u372E": "laam6",
    "\u372F": "hei1",
    "\u3730": "joek6",
    "\u3731": "zat1",
    "\u3732": "jing4",
    "\u3733": "waai4",
    "\u3734": "mang6",
    "\u3735": "niu5/liu5",
    "\u3736": "min5",
    "\u3737": "naai5/laai5",
    "\u3738": "jit6/jip6",
    "\u3739": "keoi4",
    "\uD853\uDF86": "dau1",
    "\uD841\uDF79": "gaai3",
    "\uD854\uDC2C": "jim2",
    "\uD854\uDE99": "zong1",
    "\uD855\uDC19": "paat3",
    "\uD84F\uDF4A": "zeon3",
    "\uD852\uDEA7": "fung6",
    "\uD855\uDC46": "gaa1",
    "\uD855\uDC6E": "gu2/gwu2",
    "\uD85A\uDF52": "zing3",
    "\uD855\uDD3F": "ham2",
    "\uD85D\uDE32": "zi2",
    "\uD855\uDD5E": "zoeng1",
    "\uD855\uDD62": "cou4",
    "\uD855\uDD66": "gwan2",
    "\uD855\uDFC7": "kau4",
    "\uD852\uDD3F": "baak3",
    "\uD856\uDC5D": "gim1",
    "\uD84C\uDFCC": "zi6",
    "\uD856\uDD03": "jau5",
    "\uD862\uDD48": "gei2",
    "\uD856\uDEAE": "zoeng1",
    "\uD856\uDF89": "pou4",
    "\uD857\uDC06": "dai3",
    "\uD847\uDD90": "ke4",
    "\uD858\uDD02": "daai3",
    "\uD85F\uDC12": "gwok3/gok3",
    "\uD858\uDDB2": "liu6",
    "\uD853\uDF9A": "jit6",
    "\uD859\uDC02": "jik6",
    "\uD859\uDC4A": "zing1",
    "\uD85A\uDFF7": "miu6",
    "\uD859\uDC84": "wai6",
    "\uD846\uDD1C": "ji3",
    "\uD852\uDDF6": "haa6",
    "\uD859\uDC88": "si1",
    "\uD84F\uDFEF": "sam1",
    "\uD859\uDD12": "zi1",
    "\uD859\uDDBF": "dap1",
    "\uD859\uDEB5": "sai1",
    "\uD849\uDF1B": "jan1",
    "\uD855\uDFE1": "zung1",
    "\uD87E\uDCCD": "zeon3",
    "\uD851\uDD21": "wai4",
    "\uD859\uDEFC": "bing1",
    "\uD852\uDD34": "gok3",
    "\uD85B\uDCBD": "jan1",
    "\uD859\uDF99": "deoi2",
    "\uD85A\uDC6E": "pou2",
    "\uD859\uDC11": "ci3",
    "\uD85A\uDC5E": "gam3",
    "\uD85A\uDCC7": "lo1",
    "\uD864\uDCC0": "jin6",
    "\uD842\uDE11": "mong4",
    "\uD85A\uDD26": "hot3",
    "\uD85A\uDD39": "zi3",
    "\uD85A\uDDFA": "laai2",
    "\uD85A\uDE2D": "pei4",
    "\uD859\uDC69": "fai1",
    "\uD840\uDC21": "tin1",
    "\uD85A\uDE34": "tung4",
    "\uD85A\uDF5B": "cin1",
    "\uD84D\uDD19": "him1/hin1",
    "\uD85A\uDF9D": "mong4",
    "\uD85B\uDCA4": "ji1",
    "\uD85B\uDDAE": "wan4",
    "\uD849\uDD8D": "hang4",
    "\uD85C\uDC4B": "man5",
    "\uD85C\uDDCD": "haa1",
    "\uD85C\uDE80": "gaa1",
    "\uD85C\uDE85": "gwaai2",
    "\uD848\uDD7A": "zin2",
    "\uD85C\uDE8B": "san1",
    "\uD85C\uDEE6": "mei1",
    "\uD852\uDDD0": "cau1",
    "\uD85D\uDC50": "jyut6",
    "\uD843\uDEF8": "zi6",
    "\uD84A\uDD26": "dung2",
    "\uD861\uDC73": "ting4",
    "\uD845\uDFB1": "leoi5",
    "\uD852\uDE2A": "caan3",
    "\uD846\uDC20": "tong4",
    "\uD867\uDCAD": "jung4",
    "\uD866\uDCA4": "juk6",
    "\uD85D\uDFCC": "lo6",
    "\uD85E\uDC58": "kai3",
    "\uD845\uDE0A": "fan5",
    "\uD84D\uDF2F": "hyun1",
    "\uD860\uDCE8": "nin5/lin5/zin2",
    "\uD844\uDFC5": "long5",
    "\uD85E\uDDDD": "ngaa6/aa6",
    "\uD864\uDDA8": "fung1",
    "\uD85C\uDCAF": "wan5",
    "\uD862\uDDAB": "jyu5",
    "\uD85E\uDDFD": "fung1",
    "\uD85E\uDE0A": "zaa6",
    "\uD85E\uDF0B": "faat3",
    "\uD85F\uDD66": "fong3",
    "\uD850\uDD7A": "jam1",
    "\uD860\uDC09": "cyu5",
    "\uD868\uDEDF": "zoeng1",
    "\uD860\uDF18": "zeon3",
    "\uD85B\uDE07": "seot6",
    "\uD860\uDD6F": "waa4",
    "\uD860\uDC23": "kei2",
    "\uD85A\uDDB5": "cung4",
    "\uD844\uDFED": "hiu1",
    "\uD84C\uDE2F": "jyu4",
    "\uD860\uDC48": "gaang3",
    "\uD863\uDC30": "bou2",
    "\uD860\uDC83": "pang4",
    "\uD862\uDD49": "saan3",
    "\uD852\uDD88": "fan1",
    "\uD852\uDEA5": "ning4/ling4",
    "\uD84F\uDF81": "kei4",
    "\uD860\uDC90": "leoi1",
    "\uD860\uDCF4": "gwat1",
    "\uD860\uDD2E": "seot1",
    "\uD847\uDFA1": "zam1",
    "\uD860\uDD4F": "laam3",
    "\uD860\uDD89": "tek3",
    "\uD860\uDDAF": "buk6",
    "\uD860\uDE1A": "pei4",
    "\uD860\uDF06": "wang4",
    "\uD860\uDF2F": "juk6",
    "\uD860\uDF8A": "gwan2",
    "\uD861\uDC68": "zat1",
    "\uD861\uDEAA": "lap6",
    "\uD862\uDD56": "jam1",
    "\uD862\uDDB8": "zan3",
    "\uD862\uDDE7": "zoek3",
    "\uD862\uDDE8": "jeoi6",
    "\uD862\uDF46": "hak1",
    "\uD862\uDFD4": "leoi4",
    "\uD863\uDC09": "zaap6",
    "\uD863\uDFC5": "lok6",
    "\uD864\uDCEC": "jam1",
    "\uD864\uDD10": "gong3",
    "\uD864\uDD3C": "fei2",
    "\uD864\uDD5E": "zung1",
    "\uD852\uDECA": "ling4",
    "\uD865\uDCE7": "ji4",
    "\uD865\uDDE9": "lau4",
    "\uD865\uDDB0": "cam4",
    "\uD865\uDDB8": "hou4",
    "\uD865\uDF32": "fuk1",
    "\uD866\uDCD1": "on1/ngon1",
    "\uD866\uDD49": "gei3",
    "\uD866\uDD6A": "fung1",
    "\uD866\uDDC3": "lai6",
    "\uD866\uDE28": "zi6",
    "\uD866\uDF0E": "jam1/jam4",
    "\uD867\uDD5A": "tou2",
    "\uD867\uDD9B": "gaa1",
    "\uD867\uDEF8": "dai6",
    "\uD867\uDF23": "gwo3/go3",
    "\uD868\uDE93": "leon4",
    "\uD868\uDEFF": "buk1",
    "\uD869\uDDCB": "zi1",
    "\uD843\uDC9C": "zaang1",
    "\uD849\uDCB0": "juk1",
    "\uD852\uDE93": "syun4",
    "\uD862\uDF2C": "fu3",
    "\uD85E\uDC9D": "lai6",
    "\uD845\uDFF5": "go1",
    "\uD860\uDC24": "leoi1",
    "\uD862\uDF6C": "maan6",
    "\uD862\uDF99": "hou4",
    "\uD85E\uDE3E": "tam1/tam3",
    "\uD859\uDEAF": "jan6",
    "\uD85D\uDE55": "mei6",
    "\uD84F\uDCB7": "nap6/lap6",
    "\uD855\uDE35": "taan2",
    "\uD856\uDD56": "gu2/gwu2",
    "\uD857\uDE81": "zong1",
    "\uD858\uDE58": "caang1",
    "\uD843\uDE6D": "ko1",
    "\uD84F\uDE88": "ji2",
    "\uD853\uDC9E": "jyu4",
    "\uD845\uDFF6": "ngo4/o4",
    "\uD846\uDC7B": "mei4",
    "\uD857\uDC4A": "zik6",
    "\uD854\uDF11": "jeoi6",
    "\uD867\uDD98": "lap6",
    "\uD857\uDED8": "leon4",
    "\uD84F\uDD40": "nit6/lit6",
    "\uD843\uDFEA": "gaa2",
    "\uD843\uDD49": "hong4",
    "\uD84D\uDEBA": "hong6/hong2",
    "\uD843\uDE9D": "gaak3",
    "\uD860\uDEE2": "lip1",
    "\uD843\uDC41": "tam3",
    "\uD843\uDC96": "ji1",
    "\uD854\uDD48": "laap3",
    "\uD843\uDE76": "ping1",
    "\uD84B\uDC62": "sok3/sok1/saak3",
    "\uD843\uDEA2": "gaa1/gaa2",
    "\uD844\uDC75": "gan2",
    "\uD84A\uDF43": "dau6/dau3",
    "\uD84B\uDEB3": "maan1",
    "\uD843\uDDA7": "dim6",
    "\uD85A\uDC8A": "pok1",
    "\uD844\uDCC1": "leng1",
    "\uD851\uDF06": "lung4",
    "\uD85A\uDC93": "mak6/mak2",
    "\uD849\uDEF4": "mang2",
    "\uD85F\uDD2F": "me1",
    "\uD850\uDDA3": "saap6",
    "\uD85F\uDD73": "sit6",
    "\uD85B\uDED0": "zaau3",
    "\uD85C\uDEB6": "doe3",
    "\uD844\uDDD9": "doe4",
    "\uD84F\uDCFC": "doe4",
    "\uD869\uDEA9": "gwi1",
    "\uD843\uDEAC": "he2",
    "\uD843\uDEF9": "tim1",
    "\uD847\uDCA2": "ke1",
    "\uD853\uDFC2": "saai4",
    "\uD85F\uDFF9": "mou5",
    "\uD843\uDFEB": "saau4",
    "\uD84B\uDDA0": "saau4",
    "\uD851\uDFE0": "seoi1",
    "\uD867\uDD7C": "jau5",
    "\uD843\uDFEC": "soe4",
    "\uD843\uDE0A": "tap1",
    "\uD85D\uDDA3": "maan4",
    "\uD843\uDFED": "wet1",
    "\uD858\uDC48": "hung3",
    "\uD844\uDD87": "wok1",
    "\uD851\uDE18": "hau2",
    "\uD852\uDF6E": "cung5",
    "\uD856\uDE95": "cin1.sing1",
    "\uD842\uDD79": "au1/ngau1",
    "\uD849\uDC65": "wui6",
    "\uD867\uDEAC": "zeoi1",
    "\uD84F\uDCFE": "taai3",
    "\uD867\uDF30": "ci4",
    "\uD853\uDFA9": "bik1",
    "\uD865\uDD9E": "laam4",
    "\uD867\uDFDE": "zaa6",
    "\uD84F\uDDB6": "coi2",
    "\uD85C\uDEB2": "cyun4",
    "\uD859\uDFB3": "jung4",
    "\uD84D\uDF20": "hei1",
    "\uD84F\uDEF7": "wai3",
    "\uD84F\uDE2C": "ciu1",
    "\uD841\uDC8E": "fu4",
    "\uD843\uDEB6": "naap6/laap6",
    "\uD869\uDC34": "zyu2",
    "\uD84C\uDCDA": "hong4",
    "\uD850\uDFF2": "zoek6",
    "\uD844\uDEA9": "juk6",
    "\uD852\uDD63": "hak1",
    "\uD867\uDE06": "jip3",
    "\uD85C\uDCAE": "zing6",
    "\uD845\uDF6C": "bou2",
    "\uD865\uDCD0": "but6",
    "\uD858\uDF35": "leoi4",
    "\uD85C\uDD64": "bou2",
    "\uD843\uDD28": "gwaan1",
    "\uD85B\uDD22": "ci2",
    "\uD852\uDEE2": "lou6",
    "\uD843\uDD71": "ji1",
    "\uD847\uDF0F": "gaan3",
    "\uD847\uDDD1": "ci3",
    "\uD852\uDD3E": "jin2",
    "\uD845\uDF6D": "mou6",
    "\uD863\uDE97": "dau2",
    "\uD85B\uDD23": "ji1",
    "\uD840\uDFFC": "gaa1",
    "\uD857\uDC21": "caak3",
    "\uD84F\uDCFD": "pui3",
    "\uD852\uDD19": "jai6",
    "\uD843\uDCD4": "keoi5",
    "\uD840\uDDF2": "jau1",
    "\uD869\uDE4A": "jim6",
    "\uD860\uDF7D": "gwan2",
    "\uD852\uDE77": "syun4",
    "\uD862\uDE5A": "bou2",
    "\uD868\uDEB2": "leon4",
    "\uD87E\uDC40": "ngok6/ok6",
    "\uD852\uDEBB": "syun4",
    "\uD846\uDC3B": "zou6",
    "\uD85B\uDE05": "kau3",
    "\uD849\uDD1B": "hang6",
    "\uD858\uDD59": "man4",
    "\uD84C\uDFF5": "naam4/laam4",
    "\uD862\uDFC2": "zan3",
    "\uD863\uDE39": "pei4",
    "\uD847\uDD46": "zi6",
    "\uD843\uDF3B": "gi1",
    "\uD857\uDF1A": "zoek3",
    "\uD85D\uDC86": "zyun1",
    "\uD859\uDFCC": "zin2",
    "\uD85B\uDED1": "wing6",
    "\uD850\uDC11": "ning6/ling6",
    "\uD862\uDF2D": "zok6",
    "\uD84F\uDCC7": "zo2",
    "\uD857\uDED7": "caa4",
    "\uD85D\uDE56": "wu2",
    "\uD855\uDD31": "sin3",
    "\uD846\uDD44": "zi2",
    "\uD844\uDEFE": "bit6",
    "\uD866\uDD03": "aa3/ngaa3",
    "\uD85B\uDDDC": "haa6",
    "\uD85C\uDCAD": "nau6/lau6",
    "\uD858\uDDAD": "cyu5",
    "\uD862\uDE0F": "bo1",
    "\uD84D\uDE77": "mong5",
    "\uD840\uDCEE": "tam5",
    "\uD85A\uDC46": "fat1",
    "\uD853\uDF0E": "mak6",
    "\uD858\uDF4C": "jam5",
    "\uD858\uDE6B": "mong5/hoi1.hau2.ming5",
    "\uD840\uDD0C": "kyut3",
    "\uD840\uDCD1": "saam1.zit3.syu6",
    "\uD840\uDCCD": "waang4.syu6.gok3",
    "\uD840\uDCCB": "gwang1",
    "\uD847\uDFE8": "hyun2",
    "\uD840\uDCCA": "jan2",
    "\uD840\uDD0E": "naai5/laai5",
    "\uD868\uDFA9": "waa1",
    "\uD844\uDD45": "ngaak6/aak6",
    "\uD85D\uDF35": "daai3",
    "\uD842\uDDE7": "sai1",
    "\uD867\uDDF6": "mong4",
    "\uD85C\uDC0E": "gou1",
    "\uD868\uDD33": "mak6",
    "\uD861\uDC6C": "lit6",
    "\uD847\uDDCA": "dou2",
    "\uD841\uDDD0": "ng4/m4",
    "\uD84A\uDEE6": "paak3",
    "\uD85F\uDD84": "zaang1",
    "\uD843\uDC42": "dat1",
    "\uD843\uDD15": "miu2",
    "\uD854\uDD2B": "gap6",
    "\uD84B\uDCC6": "ngou4/ou4",
    "\uD840\uDF41": "man3",
    "\uD853\uDDB8": "naa1/laa1",
    "\uD865\uDCE5": "ngok6/ok6",
    "\uD860\uDCBE": "naam3/laam3",
    "\uD84B\uDC38": "wo5",
    "\uD860\uDD5D": "jaang3",
    "\uD85A\uDDF2": "loe1/loe2",
    "\uD853\uDDEA": "mang2",
    "\uD843\uDD7C": "mang1/mang4",
    "\uD843\uDFB4": "baang6/baang4",
    "\uD843\uDCD5": "caau3",
    "\uD844\uDCF4": "ceoi4",
    "\uD843\uDE96": "mau5/jing1.mau5",
    "\uD843\uDC0B": "jaau1",
    "\uD843\uDF64": "kik1",
    "\uD84B\uDCA9": "kap1",
    "\uD860\uDE56": "ni1/li1",
    "\uD851\uDCD3": "lo3",
    "\uD843\uDD46": "daam3",
    "\uD866\uDE4D": "peng1",
    "\uD860\uDCE9": "sin3",
    "\uD853\uDEA7": "zang2",
    "\uD84B\uDCC2": "bat1/pat1",
    "\uD865\uDDF4": "bung6",
    "\uD854\uDEC7": "caang3",
    "\uD865\uDFD4": "caat3",
    "\uD85E\uDCC8": "caau1",
    "\uD84B\uDD44": "cou5",
    "\uD858\uDCA5": "dam3",
    "\uD84B\uDD4C": "deoi2",
    "\uD84A\uDFCA": "dik1",
    "\uD844\uDC77": "doeng1",
    "\uD844\uDC6F": "dyut1",
    "\uD859\uDEDA": "nam6/lam6",
    "\uD859\uDF16": "ngaa6/aa6",
    "\uD85E\uDDA0": "aak1/ngaak1",
    "\uD854\uDC52": "ngaau4/aau4",
    "\uD843\uDC43": "nip1/lip1",
    "\uD848\uDDA1": "nin1/lin1",
    "\uD862\uDF4C": "paang1/baang1",
    "\uD841\uDF31": "pai1",
    "\uD840\uDDA9": "faan2",
    "\uD84B\uDD8D": "saap3",
    "\uD851\uDDC8": "sip3",
    "\uD841\uDCFC": "sip3",
    "\uD858\uDC97": "sok3",
    "\uD843\uDF4C": "syut1",
    "\uD843\uDD96": "wong2",
    "\uD84A\uDE66": "zit1",
    "\uD844\uDC9D": "zuk6",
    "\uD843\uDD9C": "zai3",
    "\uD849\uDF75": "fit1",
    "\uD869\uDE01": "kap6",
    "\uD843\uDE09": "kak1",
    "\uD84A\uDECF": "kam2",
    "\uD84B\uDCC9": "keoi1",
    "\uD844\uDCC8": "kwaak1/kwaak3",
    "\uD84E\uDDC2": "laai5",
    "\uD860\uDE9B": "laak3",
    "\uD857\uDE49": "nap6/lap6",
    "\uD848\uDCC7": "lei5",
    "\uD843\uDF31": "loe1/loe2",
    "\uD84B\uDCB2": "long3",
    "\uD865\uDF20": "ngam1/mam1/am1",
    "\uD853\uDE3B": "naa1/laa1",
    "\uD85D\uDD74": "naan3/laan3",
    "\uD84B\uDE8B": "naan3/laan3",
    "\uD848\uDE08": "hap6/nap1/lap1",
    "\uD869\uDE5B": "nak1/lak1",
    "\uD863\uDCCD": "cat6",
    "\uD843\uDE7A": "maai4",
    "\uD843\uDC34": "sek6/jing1.sek6",
    "\uD85A\uDC1C": "jip6",
    "\uD844\uDCCF": "doe6",
    "\uD84A\uDC03": "geng6",
    "\uD84A\uDD39": "goe4",
    "\uD854\uDDE3": "gwat6",
    "\uD843\uDE8C": "gwe1",
    "\uD843\uDF8D": "he3",
    "\uD843\uDEAA": "he3/hi1",
    "\uD843\uDF30": "kang3",
    "\uD843\uDD47": "keu4",
    "\uD844\uDD4F": "lai2",
    "\uD843\uDE4C": "lang1/lang3/nang3/lan2",
    "\uD843\uDEAB": "leu1",
    "\uD842\uDFA9": "liu1/aa1/ngaa1",
    "\uD843\uDD48": "mui2",
    "\uD844\uDCC0": "nge4/e4",
    "\uD844\uDD3D": "soe4",
    "\uD849\uDE96": "ti4",
    "\uD843\uDFAD": "we5",
    "\uD84C\uDFF4": "jan4",
    "\uD85D\uDE39": "taai1",
    "\uD84A\uDFCE": "ngaau1/aau1",
    "\uD843\uDD7E": "waak1",
    "\uD843\uDD7F": "pe1/pe5",
    "\uD84B\uDC51": "waa2",
    "\uD84B\uDC55": "dap6",
    "\uD843\uDE98": "long2/long1",
    "\uD844\uDCC7": "bai6",
    "\uD843\uDF2E": "ngai1/ai1",
    "\uD869\uDE32": "ji1",
    "\uD85A\uDF50": "cik1",
    "\uD863\uDCD2": "diu2",
    "\uD863\uDD99": "lan2",
    "\uD863\uDCCA": "gau1",
    "\uD867\uDEC3": "sung4",
    "\uD85D\uDF5E": "gei1",
    "\uD84B\uDDEE": "deoi2",
    "\uD859\uDD72": "gaap3",
    "\uD860\uDCBD": "dam6",
    "\uD843\uDEFA": "aa6/ngaa6",
    "\uD843\uDE0F": "ge2",
    "\uD843\uDE77": "ngo4/o4",
    "\uD843\uDEFB": "bai3",
    "\uD853\uDDEB": "ci3",
    "\uD843\uDCD6": "dap6",
    "\uD849\uDFB5": "fit1",
    "\uD844\uDCC9": "gaa3",
    "\uD843\uDE10": "kam1",
    "\uD843\uDE78": "kam2",
    "\uD844\uDC78": "kwaak1",
    "\uD844\uDD48": "laa3",
    "\uD860\uDE07": "laam3",
    "\uD845\uDC55": "sam1",
    "\uD843\uDE79": "lan4",
    "\uD853\uDE50": "lit3",
    "\uD84B\uDDA4": "loe2",
    "\uD844\uDC1D": "nam6/lam6",
    "\uD844\uDC1E": "jaap3/zip1",
    "\uD844\uDCF5": "ung2/ngung2/ung1/ngung1",
    "\uD844\uDCF6": "sek3",
    "\uD843\uDE11": "soek3",
    "\uD85D\uDE94": "tung2",
    "\uD860\uDECD": "wan1",
    "\uD843\uDFB5": "zaa2/zaa5/zaa1",
    "\uD843\uDE7B": "zam6",
    "\uD854\uDD7E": "zong1",
    "\uD843\uDFB6": "ging2",
    "\uD844\uDD80": "gwang2",
    "\uD854\uDED8": "saau4",
    "\uD868\uDEBD": "gwan1",
    "\uD852\uDDDA": "cung1",
    "\uD846\uDC3A": "wing4",
    "\uD850\uDD77": "ling4",
    "\uD860\uDE7C": "wu3",
    "\uD855\uDF3D": "sit3",
    "\uD856\uDF74": "san1",
    "\uD84C\uDD3D": "doek3",
    "\uD846\uDFC1": "wong1",
    "\uD87E\uDC78": "cit3",
    "\uD840\uDC86": "jai6",
    "\uD852\uDCE9": "juk6/juk6.wong4.bin1",
    "\uD858\uDE6A": "mong5/hoi1.hau2.sei3",
    "\uD858\uDF4B": "me1",
    "\uD859\uDE12": "nip6/lip6",
    "\uD85A\uDD51": "guk1",
    "\uD85E\uDCB2": "gok3",
    "\uD863\uDE0F": "fau6",
    "\uD866\uDC10": "sau2",
    "\uD840\uDC87": "zo2",
    "\uD867\uDC73": "zaai1",
    "\u9FA6": "soeng4",
    "\uD850\uDD4E": "maan6",
    "\uD854\uDDCD": "coek3",
    "\uD857\uDD30": "zing6",
    "\uD862\uDE32": "ci4",
    "\uD84C\uDE81": "ngou4/ou4",
    "\uD868\uDD07": "fu2",
    "\uD846\uDD80": "long5",
    "\uD861\uDF0F": "jing4",
    "\uD868\uDEBA": "leon4",
    "\uD866\uDD47": "zin3",
    "\uD862\uDEEA": "hon3",
    "\uD848\uDC7E": "ciu1",
    "\uD862\uDDE3": "hok3",
    "\u9FA7": "syu2",
    "\u9FA8": "zeoi1",
    "\uD847\uDDB6": "gong3",
    "\uD849\uDF12": "leon4",
    "\uD84C\uDFF9": "zoi1",
    "\uD84F\uDC63": "kwan3",
    "\uD851\uDD05": "dit6",
    "\uD852\uDE13": "caa4",
    "\uD857\uDCA4": "heoi1",
    "\uD855\uDE95": "coeng1",
    "\u9FA9": "gan3",
    "\u9FAA": "jan4",
    "\u9FAB": "gon3",
    "\u9FAC": "mong5",
    "\uD863\uDDB9": "si1",
    "\uD845\uDC3F": "daat6",
    "\uD852\uDD7B": "jin4",
    "\uD85C\uDD0D": "kiu4",
    "\uD85B\uDD74": "git6",
    "\uD85A\uDF15": "zung1",
    "\uD85B\uDFBE": "jiu4",
    "\u9FAD": "ji6",
    "\u9FAE": "jik6",
    "\u9FAF": "mou6",
    "\uD862\uDDC0": "dou6",
    "\uD84F\uDF41": "zung1",
    "\uD840\uDF25": "wu3",
    "\uD843\uDED8": "zoet6/zoet2",
    "\uD840\uDCCC": "gwan2",
    "\uD840\uDC8A": "kyut3.naat6.gau2",
    "\uD85D\uDE07": "ji1.zi6.dai2",
    "\uD853\uDF82": "jyun2",
    "\uD853\uDD13": "zing3/zing1",
    "\uD858\uDFF5": "jik6",
    "\uD85A\uDD11": "gou1",
    "\uD85A\uDD0E": "gou1",
    "\uD85B\uDF9F": "zaan2",
    "\uD854\uDC9D": "am1/ngam1",
    "\uD854\uDD7D": "daap3",
    "\uD847\uDE1C": "zik6",
    "\uD854\uDE20": "jeoi6",
    "\uD84C\uDEAC": "seon3",
    "\uD862\uDD64": "syu1",
    "\uD862\uDD68": "maau4",
    "\uD845\uDEC1": "mat6",
    "\uD844\uDF76": "zi6",
    "\uD852\uDE12": "jan1",
    "\uD855\uDDE0": "lai6",
    "\uD85D\uDE0C": "jing4",
    "\uD862\uDF2B": "hoi2",
    "\uD858\uDC83": "ting1",
    "\uD849\uDE1C": "si1",
    "\uD856\uDC57": "maa5",
    "\uD85E\uDF39": "lai5",
    "\uD85C\uDD26": "fuk1",
    "\uD864\uDD0D": "cau1",
    "\uD84F\uDED7": "ji4",
    "\uD85B\uDED3": "cing4",
    "\uD855\uDFE0": "gaai1",
    "\uD862\uDFE9": "zaam1",
    "\uD856\uDCE1": "leon6",
    "\uD865\uDCD9": "wing6",
    "\uD856\uDDAC": "coeng1",
    "\uD859\uDC8D": "tung4",
    "\uD857\uDC01": "zing1",
    "\uD854\uDF0E": "seon4",
    "\uD857\uDCFE": "gwan1",
    "\uD856\uDFB4": "dung1",
    "\uD85B\uDC7F": "diu6",
    "\uD857\uDD20": "zyun2",
    "\uD857\uDC65": "ceoi4",
    "\uD857\uDCC1": "geoi6",
    "\uD852\uDC82": "suk1",
    "\uD851\uDD78": "zong1",
    "\uD85B\uDE44": "siu6",
    "\uD85B\uDED6": "hyun3",
    "\uD850\uDC57": "min4",
    "\uD858\uDC29": "dyun6",
    "\uD845\uDFF9": "zi3",
    "\uD860\uDF6D": "bok3",
    "\uD858\uDD21": "maan6",
    "\uD858\uDD5A": "jau4",
    "\uD858\uDED0": "coek3",
    "\uD858\uDF51": "goeng1",
    "\uD845\uDE61": "gang1",
    "\uD840\uDC68": "cung1",
    "\uD84D\uDF66": "ceoi3",
    "\uD860\uDF3A": "hon6",
    "\uD859\uDC89": "jap1",
    "\uD868\uDC87": "coeng1",
    "\uD85B\uDCC3": "ce4",
    "\uD849\uDF14": "zi3",
    "\uD859\uDE26": "siu6",
    "\uD84F\uDDE3": "gong1",
    "\uD859\uDEE8": "lou4",
    "\uD862\uDE48": "bui3",
    "\uD849\uDEF6": "ngo6/o6",
    "\uD859\uDC98": "cin1",
    "\uD853\uDFB8": "faa1",
    "\uD845\uDC8A": "jyu6",
    "\uD846\uDC5E": "seon3",
    "\uD852\uDE65": "seon3",
    "\uD852\uDE95": "mou5",
    "\uD842\uDF0D": "zeon3",
    "\uD85A\uDE52": "aa3/ngaa3",
    "\uD84F\uDD7E": "gwai1",
    "\uD845\uDCFD": "fan1",
    "\uD85A\uDF0A": "zi6",
    "\uD852\uDDA7": "zi1",
    "\uD84D\uDD30": "zi1",
    "\uD845\uDF73": "zi1",
    "\uD84F\uDDF8": "zi1",
    "\uD87E\uDD94": "fong1",
    "\uD843\uDE16": "ling4",
    "\uD845\uDFB4": "ping4",
    "\uD84C\uDD7D": "pui3",
    "\uD84D\uDD5A": "mau6",
    "\uD84F\uDE8B": "sin6",
    "\uD85B\uDDA3": "lit6",
    "\uD85A\uDF05": "kau1",
    "\uD85A\uDF97": "naam4/laam4",
    "\uD84D\uDDCE": "cyun4",
    "\uD85B\uDDA5": "ngo4/o4",
    "\uD85B\uDED4": "fei2",
    "\uD85B\uDE42": "bou2",
    "\uD84B\uDEEF": "hok6",
    "\uD856\uDFE4": "wai5",
    "\uD84F\uDCB5": "zi2",
    "\uD85A\uDF96": "jau5",
    "\uD85B\uDE77": "pui4",
    "\uD85B\uDE43": "fau4",
    "\uD857\uDC91": "maan4",
    "\uD857\uDCC0": "wai3",
    "\uD85B\uDE99": "lai4",
    "\uD861\uDE25": "zou6",
    "\uD861\uDE3B": "jyun5",
    "\uD85C\uDC88": "ziu2",
    "\uD845\uDD82": "kwai4",
    "\uD85C\uDCCD": "kwai4",
    "\uD87E\uDDB2": "kwai4",
    "\uD846\uDCA2": "jyu4",
    "\uD85C\uDF9A": "haa1",
    "\uD868\uDCF8": "jip6",
    "\uD84B\uDC27": "jau4",
    "\uD85D\uDDE0": "jin2",
    "\uD84F\uDDB9": "jin2",
    "\uD85D\uDDE4": "hon3",
    "\uD85D\uDF0F": "pui4",
    "\uD862\uDE25": "sam1",
    "\uD85E\uDD24": "kwai4",
    "\uD85E\uDEBD": "zeon3",
    "\uD85E\uDE59": "daan3",
    "\uD85E\uDF3A": "dai3",
    "\uD84F\uDF8F": "kei4",
    "\uD85E\uDF38": "tang4",
    "\uD855\uDC30": "keoi1",
    "\uD855\uDD65": "keoi1",
    "\uD852\uDE7A": "ji6",
    "\uD845\uDEDF": "jyut6",
    "\uD85F\uDD54": "bui3",
    "\uD85F\uDD8F": "fau2",
    "\uD87E\uDDD4": "gun3/gwun3",
    "\uD85F\uDD53": "ziu6",
    "\uD85F\uDD98": "loi6",
    "\uD85F\uDDBD": "ci3",
    "\uD846\uDD10": "coi3",
    "\uD853\uDCC9": "hon3",
    "\uD860\uDC02": "cuk1",
    "\uD844\uDC14": "lou6",
    "\uD852\uDD8A": "daap6",
    "\uD860\uDDBC": "cyu4",
    "\uD85C\uDD0C": "dan2",
    "\uD860\uDF65": "jyun5",
    "\uD861\uDC12": "ci4",
    "\uD868\uDE9F": "sang1",
    "\uD842\uDE50": "san4",
    "\uD862\uDDDE": "jing4",
    "\uD861\uDD3D": "ke2",
    "\uD84F\uDDBB": "dik6",
    "\uD84C\uDE62": "mai4",
    "\uD868\uDC14": "si1",
    "\uD861\uDEBC": "juk1",
    "\uD861\uDD01": "jau4",
    "\uD848\uDF25": "cing2",
    "\uD85B\uDED7": "zeon3",
    "\uD861\uDD3C": "jau4",
    "\uD85E\uDEBE": "syun1",
    "\uD861\uDD6C": "ngok6/ok6",
    "\uD861\uDE0B": "jiu1",
    "\uD861\uDF13": "zing1",
    "\uD861\uDEE6": "gwan6",
    "\uD862\uDD33": "lei4",
    "\uD847\uDE89": "lei4",
    "\uD855\uDDB9": "tung4",
    "\uD862\uDEC6": "ting4",
    "\uD84F\uDC9B": "sing4",
    "\uD862\uDF0C": "kwan1",
    "\uD855\uDDDB": "cin4",
    "\uD843\uDD31": "wu4",
    "\uD862\uDEE1": "gin6",
    "\uD862\uDFEB": "ngok6/ok6",
    "\uD862\uDEE2": "soeng1",
    "\uD862\uDEE5": "coeng1",
    "\uD862\uDFEC": "jyun4",
    "\uD863\uDC39": "gaam3",
    "\uD862\uDFFF": "gaam3",
    "\uD849\uDE7A": "zi3",
    "\uD861\uDED8": "sing1",
    "\uD844\uDE7C": "sing1",
    "\uD84F\uDE2E": "jam1",
    "\uD85B\uDED5": "jan2",
    "\uD862\uDEE0": "zoek3",
    "\uD85B\uDCB8": "jyu5",
    "\uD840\uDE74": "jyu5",
    "\uD859\uDC10": "man4",
    "\uD864\uDCAF": "jau1",
    "\uD864\uDCE5": "pui3",
    "\uD852\uDED1": "haa4",
    "\uD846\uDD15": "haa4",
    "\uD84C\uDF0A": "haa4",
    "\uD852\uDEE9": "ling4",
    "\uD864\uDDD5": "zing6",
    "\uD864\uDDEB": "fei1",
    "\uD84C\uDCB7": "kan4",
    "\uD84C\uDCBC": "kan4",
    "\uD855\uDC6C": "caak3",
    "\uD865\uDC33": "wan6",
    "\uD865\uDC1D": "wan6",
    "\uD85E\uDD7A": "gwan3/kwan1",
    "\uD85C\uDD75": "pan4",
    "\uD841\uDE30": "fung1",
    "\uD850\uDD5C": "piu1",
    "\uD855\uDF06": "lau4",
    "\uD85B\uDD27": "fei1",
    "\uD845\uDED3": "daan1",
    "\uD852\uDE29": "sau1",
    "\uD866\uDC57": "cau3",
    "\uD866\uDD05": "geoi1",
    "\uD855\uDF25": "zi6",
    "\uD864\uDCB1": "ji1",
    "\uD866\uDFD5": "so1",
    "\uD866\uDF05": "jim4",
    "\uD861\uDE00": "juk1",
    "\uD85A\uDDA8": "jim6",
    "\uD84C\uDC7D": "fui1",
    "\uD867\uDD3E": "mit6",
    "\uD846\uDC63": "guk1",
    "\uD850\uDE4B": "zing1",
    "\uD867\uDE68": "dyun6",
    "\uD867\uDFB7": "gwo1/go1",
    "\uD868\uDD92": "ngaan6/aan6",
    "\uD868\uDDAB": "keoi4",
    "\uD868\uDCE1": "hung4",
    "\uD868\uDD23": "huk6",
    "\uD868\uDDDF": "juk6",
    "\uD868\uDD34": "faan4",
    "\uD848\uDD5B": "lung4",
    "\uD868\uDD93": "si1",
    "\uD868\uDE20": "jing3",
    "\uD846\uDD3B": "lyun4",
    "\uD868\uDE33": "lei4",
    "\uD868\uDCB9": "ceon1",
    "\uD868\uDEB4": "syun1",
    "\uD850\uDF64": "zoeng1",
    "\uD863\uDC2B": "jim4",
    "\uD85B\uDDA2": "hong4",
    "\uD864\uDC8B": "gan1",
    "\uD852\uDD75": "gaap3",
    "\uD852\uDDBB": "loeng6",
    "\uD852\uDDF8": "hei2",
    "\uD850\uDF48": "hei2",
    "\uD852\uDE51": "hoi2",
    "\uD862\uDFDA": "wai6",
    "\uD846\uDCFA": "wai6",
    "\uD862\uDD7E": "ping4",
    "\uD863\uDE36": "ping4",
    "\uD862\uDE44": "juk1",
    "\uD862\uDD6C": "nou4/lou4",
    "\uD851\uDCB9": "bat1",
    "\uD851\uDC73": "siu1",
    "\uD850\uDFF8": "zyu3",
    "\uD845\uDFEF": "jan1",
    "\uD846\uDCBE": "gam3",
    "\uD84D\uDD99": "mei5",
    "\uD846\uDC85": "wan4",
    "\uD855\uDC2F": "taan4",
    "\uD845\uDFF8": "ong2/ngong2",
    "\uD845\uDEFB": "wing5",
    "\uD846\uDC39": "daai3",
    "\uD845\uDF74": "jyun4",
    "\uD846\uDCD1": "pan4",
    "\uD857\uDF4B": "cim1",
    "\uD845\uDEC0": "tong2",
    "\uD852\uDE25": "gei3",
    "\uD844\uDFFE": "gei3",
    "\uD844\uDEA8": "jyun4",
    "\uD844\uDFC6": "joeng5",
    "\uD845\uDCB6": "joeng5",
    "\uD84D\uDEA6": "goeng6",
    "\uD852\uDD94": "gyun2",
    "\uD85C\uDD65": "hing1",
    "\uD84F\uDE31": "jyun2",
    "\uD855\uDD5C": "gun1/gwun1",
    "\uD84F\uDEFB": "gun1/gwun1",
    "\uD85C\uDC52": "joeng6",
    "\uD84D\uDEEE": "sing6",
    "\uD866\uDD9D": "sing6",
    "\uD85B\uDF26": "sing6",
    "\uD846\uDD22": "lo4",
    "\uD84D\uDF3F": "jip6",
    "\uD850\uDCE1": "wing6",
    "\uD850\uDC8B": "ziu2",
    "\uD850\uDD0F": "hung4",
    "\uD85B\uDC21": "naa5/laa5",
    "\uD859\uDEB1": "lou5",
    "\uD843\uDFDF": "ak1/ngak1",
    "\uD842\uDFA8": "naai3/laai3",
    "\uD843\uDE0D": "mei5",
    "\uD862\uDF13": "jyut6",
    "\uD851\uDC36": "hou4",
    "\uD841\uDC65": "cau4",
    "\uD840\uDF7F": "gun3/gwun3",
    "\uD855\uDE51": "gwong1/gong1",
    "\uD840\uDDAB": "coi4",
    "\uD840\uDFCB": "jyu4",
    "\uD840\uDF0A": "paa4",
    "\uD841\uDC14": "lou5",
    "\uD840\uDEC0": "jung5",
    "\uD863\uDEB3": "jung5",
    "\uD840\uDE75": "ding6",
    "\uD840\uDE0C": "jyu4",
    "\uD852\uDE0E": "keoi4",
    "\uD84F\uDE8A": "gaa1",
    "\uD84D\uDD95": "peng1",
    "\uD84F\uDE39": "ping4",
    "\uD84F\uDEBF": "fung1",
    "\uD846\uDC84": "man5",
    "\uD84F\uDE89": "lam1",
    "\uD841\uDDE0": "maang6",
    "\uD841\uDCA3": "hang4",
    "\uD841\uDC92": "jan5",
    "\uD841\uDC91": "jyun4",
    "\uD862\uDE9C": "jan1",
    "\uD841\uDF0E": "sin3",
    "\uD842\uDC73": "min5",
    "\uD850\uDF8C": "tong4",
    "\uD843\uDC20": "keoi5",
    "\uD852\uDDAC": "nim6/lim6",
    "\uD844\uDCE4": "laai6/lai4",
    "\uD843\uDE1D": "saap3",
    "\uD852\uDEBC": "lin4",
    "\uD850\uDC8D": "lin4",
    "\uD850\uDCC9": "lik6",
    "\uD840\uDF45": "mak6",
    "\uD842\uDFC6": "jyu4",
    "\uD862\uDE46": "wai1",
    "\uD845\uDEFA": "jau4",
    "\uD845\uDF6F": "dai6",
    "\uD845\uDF10": "syu3",
    "\uD856\uDD46": "miu5",
    "\uD846\uDDF3": "coi3",
    "\uD846\uDC61": "ging2",
    "\uD850\uDE95": "coi2",
    "\uD857\uDE83": "zi3",
    "\uD862\uDFD7": "jing4",
    "\uD841\uDC13": "jing4",
    "\uD844\uDF03": "kok3",
    "\uD862\uDDFB": "jin4",
    "\uD846\uDD96": "mun5",
    "\uD846\uDD7C": "me1",
    "\uD84E\uDEEE": "hou2",
    "\uD846\uDD03": "gaan1",
    "\uD846\uDD04": "haan4",
    "\uD846\uDCA0": "wo1",
    "\uD845\uDEFE": "naai5/laai5",
    "\uD862\uDE47": "naam4/laam4",
    "\uD847\uDDBA": "pui3",
    "\uD84D\uDC72": "pui3",
    "\uD862\uDDA8": "pui3",
    "\uD846\uDD27": "bou2",
    "\uD845\uDFAB": "noi6/loi6",
    "\uD845\uDF3B": "saam3",
    "\uD85D\uDDFD": "hang4",
    "\uD84A\uDC60": "ci3",
    "\uD849\uDE2B": "zing1",
    "\uD849\uDDAF": "gei1",
    "\uD849\uDDBE": "faan4",
    "\uD864\uDC88": "cam3",
    "\uD85B\uDF73": "jyu4",
    "\uD840\uDC3E": "bui5",
    "\uD840\uDC46": "bik6",
    "\uD849\uDE1B": "cik1",
    "\uD84B\uDC9B": "tou4",
    "\uD84B\uDD07": "zap1",
    "\uD851\uDED4": "maan6",
    "\uD864\uDD4D": "maan6",
    "\uD851\uDE65": "hak1",
    "\uD84A\uDF6A": "hak1",
    "\uD84A\uDF22": "diu3",
    "\uD84D\uDC50": "diu3",
    "\uD866\uDCEA": "hang1",
    "\uD84B\uDE78": "cung4",
    "\uD869\uDC5B": "mei4",
    "\uD852\uDDE3": "gin3",
    "\uD84B\uDD67": "gaan3/haan6/haan5",
    "\uD84B\uDCA1": "laa2/naa1/laa1",
    "\uD84C\uDC8E": "mun5",
    "\uD84C\uDEAD": "luk6",
    "\uD852\uDD89": "hyun1",
    "\uD84C\uDEAB": "luk6",
    "\uD84C\uDEE0": "cai4",
    "\uD846\uDCD9": "caai4",
    "\uD865\uDC3F": "hoeng2",
    "\uD84C\uDE89": "gei2",
    "\uD84C\uDDB3": "gang2",
    "\uD855\uDD84": "sin6",
    "\uD862\uDF22": "sin6",
    "\uD855\uDD8F": "gun3/gwun3",
    "\uD845\uDEFC": "juk6",
    "\uD855\uDD5B": "gei1",
    "\uD855\uDC25": "faan4",
    "\uD84C\uDD03": "kei4",
    "\uD846\uDC2A": "mun5",
    "\uD84C\uDE34": "miu4",
    "\uD84C\uDE0F": "sik1",
    "\uD84C\uDD82": "jyun6",
    "\uD850\uDEC9": "jyun6",
    "\uD85B\uDD24": "jing2",
    "\uD85E\uDC70": "tai4",
    "\uD847\uDDEB": "sing4",
    "\uD84C\uDED2": "kwai4",
    "\uD84C\uDEE1": "mung4",
    "\uD856\uDC72": "jung4",
    "\uD84E\uDC3A": "cip3",
    "\uD84D\uDFBC": "joeng5",
    "\uD84D\uDFA2": "ze3",
    "\uD84C\uDFFE": "dak6/dak2",
    "\uD851\uDE2A": "daan1",
    "\uD84D\uDFD5": "san1",
    "\uD851\uDC87": "san1",
    "\uD846\uDD12": "geoi2",
    "\uD84F\uDFC0": "pou2",
    "\uD84F\uDC9A": "jan4",
    "\uD862\uDFEA": "hon6",
    "\uD862\uDECB": "gung3",
    "\uD860\uDC1E": "leot6",
    "\uD862\uDDDC": "bong1",
    "\uD852\uDDEC": "wun3",
    "\uD84F\uDF7F": "cing4",
    "\uD850\uDC3C": "luk6",
    "\uD850\uDF1A": "wui4",
    "\uD850\uDE76": "ngaau4/aau4",
    "\uD851\uDF8F": "si1",
    "\uD851\uDF25": "ji6",
    "\uD852\uDEA4": "wing4",
    "\uD841\uDDEB": "wun6",
    "\uD84F\uDEF8": "soeng4",
    "\uD84D\uDE5F": "soeng4",
    "\uD852\uDE4A": "jiu4",
    "\uD852\uDD17": "nei4/lei4",
    "\uD857\uDFE1": "nei4/lei4",
    "\uD852\uDEDF": "lai6",
    "\uD863\uDC23": "lai6",
    "\uD84F\uDF35": "lei6",
    "\uD85B\uDDEA": "seoi1",
    "\uD853\uDCD9": "jyun2",
    "\uD853\uDD06": "cau4",
    "\uD869\uDDC6": "cai4",
    "\uD862\uDECC": "zeon3",
    "\uD852\uDDAB": "ling4",
    "\uD852\uDD8E": "leon4",
    "\uD852\uDE4E": "gaan1",
    "\uD852\uDDC5": "ping4",
    "\uD852\uDCF3": "cin1",
    "\uD862\uDEE3": "kau4",
    "\uD846\uDC64": "gei2",
    "\uD854\uDE21": "noi6/loi6",
    "\uD854\uDDE7": "noi6/loi6",
    "\uD84C\uDE32": "mei4",
    "\uD851\uDE97": "syun1",
    "\uD84D\uDF81": "wing4",
    "\uD852\uDCF0": "bou2",
    "\uD852\uDEBA": "sam2",
    "\uD852\uDEC7": "jin3",
    "\uD852\uDE96": "fai1",
    "\uD858\uDDAE": "fai1",
    "\uD855\uDD81": "zyun1",
    "\uD85D\uDF41": "hyun1",
    "\uD855\uDEE3": "daai3",
    "\uD84F\uDEFA": "gei1",
    "\uD845\uDEE6": "bing2",
    "\uD843\uDD4C": "ji4",
    "\uD852\uDD8C": "ji4",
    "\uD840\uDE99": "ji4",
    "\uD84F\uDDBA": "ji4",
    "\uD845\uDF6E": "ji4",
    "\uD840\uDDD4": "mou4",
    "\uD843\uDC0D": "zyu2",
    "\uD849\uDEF5": "zang2",
    "\uD856\uDEAF": "jiu4",
    "\uD856\uDE9C": "ting4",
    "\uD840\uDE5B": "sing4",
    "\uD856\uDFC6": "sung1",
    "\uD856\uDFB3": "aa3/ngaa3",
    "\uD857\uDEBC": "aa3/ngaa3",
    "\uD857\uDEA6": "dim3",
    "\uD852\uDDF9": "ci4",
    "\uD845\uDFB0": "ci4",
    "\uD858\uDE61": "taam4",
    "\uD858\uDD5C": "cyu5",
    "\uD85E\uDF48": "ning4/ling4",
    "\uD857\uDE82": "gwing2",
    "\uD85A\uDF75": "joeng4",
    "\uD842\uDD16": "me1",
    "\uD840\uDC4E": "lin4",
    "\uD84D\uDDCF": "fung1",
    "\uD859\uDC12": "ngai6/ai6",
    "\uD858\uDFF8": "jai6",
    "\uD852\uDD62": "kok3",
    "\uD842\uDC2C": "cim1",
    "\uD856\uDEE9": "zoek3",
    "\uD857\uDD43": "zaan2",
    "\uD857\uDE0E": "tang4",
    "\uD84D\uDC3F": "ji1",
    "\uD852\uDDF7": "zin2",
    "\uD859\uDDAD": "jyu4",
    "\uD859\uDDA0": "sim2",
    "\uD85C\uDD27": "wan3",
    "\uD85B\uDCD1": "mau5",
    "\uD859\uDFB4": "jim1",
    "\uD85A\uDE42": "syun4",
    "\uD85A\uDE51": "loi4",
    "\uD85B\uDDA7": "gwan2",
    "\uD85C\uDE1B": "si1",
    "\uD846\uDC40": "gyun3",
    "\uD846\uDCA1": "kwan4",
    "\uD846\uDCD8": "mung4",
    "\uD87E\uDDBC": "sip3",
    "\uD84F\uDD8F": "zip3",
    "\uD85D\uDC22": "hou4",
    "\uD855\uDE83": "leoi5",
    "\uD85D\uDF85": "daat6",
    "\uD85D\uDF84": "jyut6",
    "\uD862\uDFF5": "hing1",
    "\uD862\uDFD9": "hing3",
    "\uD862\uDF9C": "zim6",
    "\uD862\uDDF9": "ming4",
    "\uD865\uDC48": "gwong3/gong3",
    "\uD850\uDE84": "kei4",
    "\uD846\uDC45": "niu5/liu5",
    "\uD85F\uDDDC": "jung1",
    "\uD853\uDC09": "jung6",
    "\uD848\uDF21": "gwing2",
    "\uD845\uDFDA": "jing4",
    "\uD852\uDD2F": "wing5",
    "\uD862\uDE4B": "wai6",
    "\uD862\uDEFC": "ngou6/ou6",
    "\uD863\uDC1D": "gaan2",
    "\uD863\uDC3B": "bou2",
    "\uD863\uDD34": "bing1",
    "\uD852\uDCFF": "hoi1",
    "\uD852\uDE42": "lou4",
    "\uD850\uDFEA": "lou4",
    "\uD84C\uDE25": "tou1",
    "\uD863\uDEE7": "lau4",
    "\uD863\uDE66": "ngoi4/oi4",
    "\uD863\uDE65": "dai6",
    "\uD852\uDDED": "pong4",
    "\uD852\uDE78": "kwai4",
    "\uD84F\uDFEE": "kwai4",
    "\uD864\uDCB0": "dou3",
    "\uD864\uDC93": "dung1",
    "\uD855\uDFDF": "muk6",
    "\uD862\uDD89": "ci3",
    "\uD863\uDC26": "bou2",
    "\uD862\uDF2F": "sai1",
    "\uD858\uDFBE": "sai1",
    "\uD850\uDE1B": "gwong1/gong1",
    "\uD843\uDF26": "maan4",
    "\uD862\uDFC5": "lai6",
    "\uD852\uDEB2": "lai6",
    "\uD865\uDCDA": "kwai4",
    "\uD865\uDDD7": "geoi6",
    "\uD862\uDF50": "daan1",
    "\uD852\uDE67": "daan1",
    "\uD862\uDF64": "ou1/ngou1",
    "\uD862\uDE45": "hung4",
    "\uD85E\uDF06": "zin2",
    "\uD862\uDF65": "jip6",
    "\uD856\uDCC8": "buk6",
    "\uD866\uDCF1": "luk6",
    "\uD866\uDD48": "wan1",
    "\uD844\uDF02": "fan4",
    "\uD852\uDDB8": "bou2",
    "\uD845\uDCE8": "wan2",
    "\uD849\uDF1F": "gong1",
    "\uD84F\uDDB8": "bing2",
    "\uD849\uDF81": "fung1",
    "\uD84A\uDD6B": "wan6",
    "\uD867\uDE2D": "leoi6",
    "\uD868\uDDF5": "gwong2/gong2",
    "\uD868\uDCFE": "jung4",
    "\uD850\uDD04": "gau1",
    "\uD868\uDDB4": "kwai4",
    "\uD868\uDCED": "haak3",
    "\uD868\uDCF3": "jing1",
    "\uD866\uDD2F": "jing1",
    "\uD85B\uDE12": "ji1",
    "\uD85B\uDFDF": "ji2",
    "\uD85A\uDF82": "si1",
    "\uD85B\uDDA4": "jyun2",
    "\uD85B\uDE84": "hing1",
    "\uD85B\uDDF0": "fau4",
    "\uD85B\uDE00": "kei4",
    "\uD84D\uDFD7": "ji4",
    "\uD858\uDC64": "nim6/lim6",
    "\uD84D\uDD9C": "wai6",
    "\uD84D\uDE40": "zap1",
    "\uD852\uDDDE": "mei5",
    "\uD840\uDEBF": "syun1",
    "\uD855\uDD5D": "zaat3",
    "\uD845\uDF57": "kwan3",
    "\uD84C\uDDC9": "gwan1",
    "\uD852\uDD41": "ming4",
    "\uD850\uDDB5": "baa1",
    "\uD850\uDDAC": "mou4",
    "\uD85B\uDC40": "juk6",
    "\uD853\uDF97": "wong4",
    "\uD845\uDFB5": "wun6",
    "\uD862\uDE49": "wun6",
    "\uD851\uDC88": "jin3",
    "\uD862\uDDFC": "fan1",
    "\uD846\uDCD6": "soeng4",
    "\uD843\uDF1D": "lei4",
    "\uD85B\uDCC0": "mui6",
    "\uD845\uDC13": "hong1",
    "\uD850\uDEFA": "zing1",
    "\uD84B\uDC26": "ceon1",
    "\uD850\uDFC1": "hei1",
    "\uD84F\uDDB7": "daam6",
    "\uD859\uDF41": "kei4",
    "\uD858\uDD5B": "cam4",
    "\uD858\uDCA4": "ping4",
    "\uD852\uDDB9": "zing1",
    "\uD852\uDD8B": "bing2",
    "\uD862\uDDFA": "bing2",
    "\uD862\uDF63": "co2",
    "\uD846\uDC9F": "co3",
    "\uD852\uDEB3": "wai6",
    "\uD852\uDE3E": "kwan1",
    "\uD852\uDE94": "gun2/gwun2",
    "\uD845\uDFD9": "sing1",
    "\uD852\uDE66": "git3",
    "\uD840\uDFA7": "git3",
    "\uD845\uDC24": "kit3",
    "\uD852\uDDE5": "paak3",
    "\uD852\uDD16": "fat1",
    "\uD852\uDD76": "naa5/laa5",
    "\uD841\uDCFE": "cyun4",
    "\uD862\uDECE": "zan1",
    "\uD862\uDE16": "kam4",
    "\uD862\uDFE7": "jin3",
    "\uD855\uDDD5": "jin3",
    "\uD862\uDE82": "seoi6",
    "\uD852\uDD43": "on1/ngon1",
    "\uD843\uDCFF": "mei5",
    "\uD841\uDE1A": "mo1",
    "\uD842\uDFEB": "gwo1/go1",
    "\uD843\uDCB8": "naam4/laam4",
    "\uD845\uDFFA": "haa6",
    "\uD845\uDEC2": "ji1",
    "\uD852\uDE50": "si1",
    "\uD846\uDC52": "si1",
    "\uD862\uDEC0": "zin2",
    "\uD852\uDDAD": "cing1",
    "\uD846\uDCBF": "nung4/lung4",
    "\uD846\uDC83": "haan5",
    "\uD85D\uDC84": "gaan1",
    "\uD84F\uDD5B": "sau3",
    "\uD862\uDE81": "jiu3",
    "\uD846\uDC62": "cong2",
    "\uD842\uDEB4": "co2",
    "\uD844\uDF9C": "naam4/laam4",
    "\uD860\uDE18": "saau2",
    "\uD864\uDCE4": "kei4",
    "\uD85F\uDE4F": "zaan3",
    "\uD84F\uDFED": "ji4",
    "\uD84F\uDE2D": "juk1",
    "\uD840\uDFF5": "fung6",
    "\uD863\uDC1C": "zoek3",
    "\uD85A\uDFC0": "ban6",
    "\uD845\uDC52": "gam2",
    "\uD850\uDF62": "jim6",
    "\uD852\uDE71": "din6",
    "\uD84B\uDFE3": "hiu1",
    "\uD844\uDEB0": "tin4",
    "\uD848\uDFBD": "kap6",
    "\uD844\uDF98": "jing1",
    "\uD84D\uDCE5": "jau4",
    "\uD85E\uDFF4": "lam4",
    "\uD84D\uDEDF": "zoeng2",
    "\uD862\uDE83": "ting4",
    "\uD84D\uDFD6": "mo4",
    "\uD84C\uDFFA": "hung2",
    "\uD853\uDC9F": "cing1",
    "\uD84D\uDEAD": "guk1",
    "\uD85B\uDCB7": "lei6",
    "\uD85B\uDD26": "haak3",
    "\uD85B\uDD51": "geoi2",
    "\uD85B\uDC82": "geoi2",
    "\uD85B\uDFDE": "cung1",
    "\uD85C\uDD09": "zung2",
    "\uD845\uDF3A": "hang6",
    "\uD85B\uDC80": "ji4",
    "\uD85C\uDC53": "nung4/lung4",
    "\uD845\uDFDB": "bing2",
    "\uD845\uDFB3": "gwai3",
    "\uD846\uDD05": "can1",
    "\uD850\uDDFC": "on1/ngon1",
    "\uD845\uDF3C": "wui4",
    "\uD850\uDEA5": "ling4",
    "\uD850\uDE93": "ngai4/ai4",
    "\uD84F\uDEF9": "gin1",
    "\uD85D\uDF36": "gin1",
    "\uD851\uDC5B": "fan1",
    "\uD850\uDECA": "ping4",
    "\uD850\uDE59": "fan1",
    "\uD862\uDDE1": "gwan1",
    "\uD85B\uDD28": "kwan3",
    "\uD851\uDCCE": "zaan3",
    "\uD85F\uDE4D": "zaan3",
    "\uD850\uDFBD": "gun3/gwun3",
    "\uD850\uDE56": "ce1",
    "\uD844\uDF04": "ce1",
    "\uD850\uDFE9": "fan1",
    "\uD87E\uDC25": "jung5",
    "\uD852\uDE4F": "cing4",
    "\uD852\uDE5D": "kiu4",
    "\uD845\uDFDF": "cung1",
    "\uD84E\uDEFA": "juk6",
    "\uD84C\uDF00": "hei1",
    "\uD840\uDE14": "lap6",
    "\uD842\uDCD5": "gwan1",
    "\uD841\uDE19": "lok6",
    "\uD847\uDF9E": "hei1",
    "\uD868\uDEB6": "ting2",
    "\uD864\uDD5B": "fung4",
    "\uD862\uDE59": "jing4",
    "\uD865\uDC20": "hung1",
    "\uD85E\uDEF4": "gan2",
    "\uD855\uDEF6": "sin6",
    "\uD85E\uDF18": "gaan1",
    "\uD852\uDCF2": "seon3",
    "\uD853\uDF5C": "mui6",
    "\uD855\uDD35": "ci4",
    "\uD843\uDCCF": "ce2",
    "\uD85E\uDD67": "jiu4",
    "\uD846\uDFC2": "wong1/baat3.gei1",
    "\uD840\uDC94": "zi2",
    "\uD840\uDEB7": "zi6",
    "\uD840\uDFA0": "ging2",
    "\uD841\uDCD7": "fu3",
    "\uD841\uDDD5": "zeon3",
    "\uD841\uDE15": "hei1",
    "\uD841\uDE76": "au2/ngau2",
    "\uD845\uDEBA": "jyun4",
    "\uD842\uDEC2": "lou4",
    "\uD842\uDECD": "ai3/ngai3",
    "\uD842\uDFBF": "saan1",
    "\uD87E\uDC3B": "jiu1",
    "\uD842\uDFCB": "jai5",
    "\uD842\uDFFB": "waan6",
    "\uD843\uDC3B": "ngoi6/oi6",
    "\uD843\uDC53": "ngai1/ai1",
    "\uD843\uDC65": "fik1/we5",
    "\uD843\uDC7C": "haau2",
    "\uD843\uDC8D": "diu1",
    "\uD843\uDCB5": "gip3",
    "\uD843\uDCDD": "fau2",
    "\uD843\uDCED": "hak1",
    "\uD843\uDD6F": "gwit1",
    "\uD843\uDDB2": "gap6/kap6",
    "\uD843\uDDC8": "leot6",
    "\uD843\uDE04": "jing1",
    "\uD843\uDE0E": "naa1/laa1",
    "\uD843\uDED7": "le4/lei4",
    "\uD843\uDF90": "lung4",
    "\uD843\uDF2D": "but1",
    "\uD843\uDE73": "git6",
    "\uD843\uDFBC": "cyut2/cyut1/cyut4/cyut6",
    "\uD844\uDC5C": "wo5",
    "\uD844\uDC4F": "am1/ngam1",
    "\uD844\uDC76": "zit1",
    "\uD844\uDC7B": "ziu6",
    "\uD844\uDC88": "buk6",
    "\uD844\uDC96": "lai2",
    "\uD844\uDCBF": "au1/ngau1",
    "\uD844\uDCD3": "bo3",
    "\uD844\uDD2F": "jik1",
    "\uD844\uDD3B": "ji3",
    "\uD844\uDEE3": "kwai4",
    "\uD844\uDF75": "zeon3",
    "\uD844\uDF36": "baan6",
    "\uD845\uDD77": "hing3",
    "\uD845\uDE19": "taai3",
    "\uD845\uDFC3": "jyun2",
    "\uD845\uDFC7": "fui3",
    "\uD846\uDC2D": "syut3",
    "\uD846\uDD6A": "seon3",
    "\uD846\uDE2D": "cung4",
    "\uD846\uDE45": "gaa1",
    "\uD847\uDC2A": "duk1",
    "\uD847\uDC70": "tyun4",
    "\uD847\uDCAC": "gwat6",
    "\uD847\uDEC8": "ceon4",
    "\uD847\uDED5": "seoi3",
    "\uD847\uDF15": "zeon3",
    "\uD848\uDC45": "seon3",
    "\uD848\uDE7C": "gang1",
    "\uD848\uDFD7": "ngai6/ai6",
    "\uD848\uDFFA": "bat6",
    "\uD849\uDF2A": "nok6/lok6",
    "\uD84A\uDC71": "kok3",
    "\uD84A\uDD4F": "jing4",
    "\uD84A\uDD67": "jyun6",
    "\uD84A\uDD93": "ngo5/o5",
    "\uD84A\uDED5": "wing1/wing6",
    "\uD84A\uDEE8": "ung2/ngung2",
    "\uD84A\uDF0E": "wun4",
    "\uD84A\uDF3F": "kaai2/kaai5",
    "\uD84B\uDC4C": "gaa3",
    "\uD84B\uDC88": "kik1",
    "\uD84B\uDCB7": "aau1/ngaau1",
    "\uD856\uDFE8": "si1",
    "\uD84B\uDD08": "daat3",
    "\uD84B\uDD12": "paang1",
    "\uD84B\uDDB7": "co1",
    "\uD84B\uDD95": "zin2",
    "\uD84B\uDE42": "kwai4",
    "\uD84B\uDF74": "duk1",
    "\uD84B\uDFCC": "hing3",
    "\uD84C\uDC33": "nip6/lip6",
    "\uD84C\uDC66": "pun4",
    "\uD84C\uDF1F": "ling4",
    "\uD84C\uDFDE": "jau4",
    "\uD85E\uDE79": "si1",
    "\uD84D\uDD67": "gaa3",
    "\uD84D\uDDF3": "syu6",
    "\uD852\uDDBA": "kei4",
    "\uD84D\uDE1A": "seot1",
    "\uD84D\uDF16": "dip6",
    "\uD840\uDF46": "lei6",
    "\uD84E\uDEA7": "jan1",
    "\uD85D\uDE57": "jau6",
    "\uD857\uDFE2": "wang4",
    "\uD84F\uDE11": "loeng4",
    "\uD84F\uDEB9": "zin2",
    "\uD85D\uDDFE": "hang4",
    "\uD848\uDC9A": "coek3",
    "\uD850\uDD19": "siu1",
    "\uD862\uDE9A": "hin1",
    "\uD850\uDEEE": "hei1",
    "\uD850\uDF0D": "hok3",
    "\uD850\uDC3B": "sam1",
    "\uD850\uDF34": "git6",
    "\uD850\uDF96": "hong1",
    "\uD852\uDE45": "syun4",
    "\uD841\uDDCA": "ging6",
    "\uD841\uDE11": "hei1",
    "\uD847\uDEA8": "wai4",
    "\uD84F\uDCFF": "jyu5",
    "\uD851\uDC04": "zin1",
    "\uD851\uDCD6": "lyun4",
    "\uD851\uDE74": "caau1",
    "\uD851\uDF2F": "kap6",
    "\uD861\uDDE8": "wai5",
    "\uD866\uDDC9": "gwong1/gong1",
    "\uD848\uDDC3": "si1",
    "\uD862\uDF4E": "hei2",
    "\uD852\uDC12": "si1",
    "\uD852\uDCFB": "mut6",
    "\uD852\uDE15": "lak6",
    "\uD852\uDEC0": "syun4",
    "\uD843\uDC78": "seon2/san2",
    "\uD853\uDEA5": "daap3",
    "\u9DE4": "taan4/tai4",
    "\u9DE5": "si1",
    "\u9DE6": "ziu1",
    "\u9DE7": "ji3",
    "\u9DE8": "waa4",
    "\u9DE9": "bai3/bit3",
    "\u9DEA": "ang1/ngang1",
    "\u9DEB": "suk1",
    "\u9DEC": "wong4",
    "\u9DED": "faan4",
    "\u9DEE": "giu1",
    "\u9DEF": "liu4/liu1",
    "\u9DF0": "jin3",
    "\u9DF1": "gou1",
    "\u9DF2": "zau6",
    "\u9DF3": "haan4",
    "\u9DF4": "haan4",
    "\u9DF5": "tou4",
    "\u9DF6": "maai5",
    "\u9DF7": "zeon1",
    "\u9DF8": "wat6/neot6/leot6",
    "\u9DF9": "jing1",
    "\u9DFA": "lou6",
    "\u9DFB": "tyun4",
    "\u9DFC": "haan4",
    "\u9DFD": "hok6",
    "\u9DFE": "ji3",
    "\u9DFF": "pik1",
    "\u9E00": "suk6/zok6/zuk1",
    "\u9E01": "lo4",
    "\u9E02": "kai1",
    "\u9E03": "ji4",
    "\u9E04": "gik1",
    "\u9E05": "zaak6",
    "\u9E06": "jyu4",
    "\u9E07": "zin1",
    "\u9E08": "jip6",
    "\u9E09": "joeng4",
    "\u9E0A": "pik1",
    "\u9E0B": "ning4/ling4",
    "\u9E0C": "wok3/wok6",
    "\u9E0D": "mei4",
    "\u9E0E": "ang1/ngang1",
    "\u9E0F": "mung4",
    "\u9E10": "dik6",
    "\u9E11": "ngok6/ok6",
    "\u9E12": "jyu6/jyu4",
    "\u9E13": "leoi5",
    "\u9E14": "buk1",
    "\u9E15": "lou4",
    "\u9E16": "hok6",
    "\u9E17": "lung4",
    "\u9E18": "soeng1",
    "\u9E19": "joek6",
    "\u9E1A": "jing1",
    "\u9E1B": "gun3/gwun3",
    "\u9E1C": "keoi4",
    "\u9E1D": "lei4",
    "\u9E1E": "lyun4",
    "\u9E1F": "niu5/liu5/diu2",
    "\u9E20": "gau1/kau1",
    "\u9E21": "gai1",
    "\u9E22": "jyun1/jyun4",
    "\u9E23": "ming4",
    "\u9E24": "si1",
    "\u9E25": "au1/ngau1",
    "\u9E26": "aa1/ngaa1",
    "\u9E27": "cong1/coeng1",
    "\u9E28": "bou2",
    "\u9E29": "zam6",
    "\u9E2A": "gu1/gwu1",
    "\u9E2B": "dung1",
    "\u9E2C": "lou4",
    "\u9E2D": "aap3/ngaap3/aap2/ngaap2",
    "\u9E2E": "hiu1",
    "\u9E2F": "joeng1",
    "\u9E30": "ling4",
    "\u9E31": "ci1",
    "\u9E32": "keoi4",
    "\u9E33": "jyun1/jin1",
    "\u9E34": "hok6/ang1/ngang1",
    "\u9E35": "to4",
    "\u9E36": "si1",
    "\u9E37": "zi3",
    "\u9E38": "ji4",
    "\u9E39": "kut3/kwut3/gwaat3",
    "\u9E3A": "jau1",
    "\u9E3B": "hang4/hong4",
    "\u9E3C": "zau1",
    "\u9E3D": "gap3/gap2/gaap3",
    "\u9E3E": "lyun4",
    "\u9E3F": "hung4",
    "\u9E40": "mou4",
    "\u9E41": "but6",
    "\u9E42": "lei4",
    "\u9E43": "gyun1",
    "\u9E44": "huk6/guk1",
    "\u9E45": "ngo4/o4/ngo2/o2",
    "\u9E46": "juk6",
    "\u9E47": "haan4",
    "\u9E48": "tai4",
    "\u9E49": "mou5",
    "\u9E4A": "zoek3/zoek2/coek3",
    "\u9E4B": "miu4",
    "\u9E4C": "am1/ngam1/aan3/ngaan3",
    "\u9E4D": "kwan1",
    "\u9E4E": "bei1/pat1",
    "\u9E4F": "paang4",
    "\u9E50": "zaam1",
    "\u9E51": "seon4/ceon1",
    "\u9E52": "gang1",
    "\u9E53": "jyun1",
    "\u9E54": "suk1",
    "\u9E55": "wu4",
    "\u9E56": "hot3",
    "\u9E57": "ngok6/ok6",
    "\u9E58": "gwat1/wat6",
    "\u9E59": "cau1",
    "\u9E5A": "ci4",
    "\u9E5B": "mei4",
    "\u9E5C": "mou6",
    "\u9E5D": "jik6",
    "\u9E5E": "jiu6/jiu2/jiu4",
    "\u9E5F": "jung1",
    "\u9E60": "lau4",
    "\u9E61": "zik3/zek3",
    "\u9E62": "jik6",
    "\u9E63": "gim1",
    "\u9E64": "hok6/hok2",
    "\u9E65": "ji1",
    "\u9E66": "jing1",
    "\u9E67": "ze3",
    "\u9E68": "lau6",
    "\u9E69": "liu4/liu1",
    "\u9E6A": "ziu1",
    "\u9E6B": "zau6",
    "\u9E6C": "wat6/neot6/leot6",
    "\u9E6D": "lou6",
    "\u9E6E": "syun4/waan4",
    "\u9E6F": "zin1",
    "\u9E70": "jing1",
    "\u9E71": "wok3/wok6",
    "\u9E72": "mung4",
    "\u9E73": "gun3/gwun3",
    "\u9E74": "soeng1",
    "\u9E75": "lou5",
    "\u9E76": "ging1",
    "\u9E77": "ling4",
    "\u9E78": "gaan2",
    "\u9E79": "haam4/haam2",
    "\u9E7A": "co4",
    "\u9E7B": "gaan2",
    "\u9E7C": "gaan2",
    "\u9E7D": "jim4/jim1/jim6",
    "\u9E7E": "co4",
    "\u9E7F": "luk6/luk2",
    "\u9E80": "jau1",
    "\u9E81": "cou1",
    "\u9E82": "gei2",
    "\u9E83": "biu1/paau4",
    "\u9E84": "cou1",
    "\u9E85": "paau4",
    "\u9E86": "cyu4",
    "\u9E87": "gwan1/kwan4/kwan2",
    "\u9E88": "zyu2",
    "\u9E89": "gin1",
    "\u9E8A": "mei4",
    "\u9E8B": "mei4",
    "\u9E8C": "jyu5",
    "\u9E8D": "lau4",
    "\u9E8E": "san4",
    "\u9E8F": "gwan1",
    "\u9E90": "leon4",
    "\u9E91": "ngai4/ai4",
    "\u9E92": "kei4",
    "\u9E93": "luk1",
    "\u9E94": "kau5",
    "\u9E95": "gwan1/kwan4",
    "\u9E96": "ging1",
    "\u9E97": "lai6/lai4/lei4",
    "\u9E98": "hoeng1",
    "\u9E99": "ngaam4/aam4/haam4",
    "\u9E9A": "gaa1",
    "\u9E9B": "mai4",
    "\u9E9C": "leot6",
    "\u9E9D": "se6",
    "\u9E9E": "zoeng1",
    "\u9E9F": "leon4/leon2",
    "\u9EA0": "ging1",
    "\u9EA1": "cai4",
    "\u9EA2": "ling4",
    "\u9EA3": "ngaam4/aam4",
    "\u9EA4": "cou1",
    "\u9EA5": "mak6/maak6",
    "\u9EA6": "mak6/maak6",
    "\u9EA7": "hat6",
    "\u9EA8": "ciu2",
    "\u9EA9": "fu1",
    "\u9EAA": "min6",
    "\u9EAB": "min6",
    "\u9EAC": "fu1",
    "\u9EAD": "paau3",
    "\u9EAE": "heoi3",
    "\u9EAF": "kuk1/guk1",
    "\u9EB0": "mau4",
    "\u9EB1": "fu1",
    "\u9EB2": "haan6",
    "\u9EB3": "loi4",
    "\u9EB4": "kuk1/guk1",
    "\u9EB5": "min6",
    "\u9EB6": "ci1",
    "\u9EB7": "fung1",
    "\u9EB8": "fu1",
    "\u9EB9": "kuk1/guk1",
    "\u9EBA": "min6",
    "\u9EBB": "maa4/maa2",
    "\u9EBC": "mo1",
    "\u9EBD": "mo1",
    "\u9EBE": "fai1",
    "\u9EBF": "leoi5",
    "\u9EC0": "zau1",
    "\u9EC1": "nyun5/lyun5",
    "\u9EC2": "fan4",
    "\u9EC3": "wong4/wong2",
    "\u9EC4": "wong4",
    "\u9EC5": "gam1",
    "\u9EC6": "gwong1/gong1",
    "\u9EC7": "tim1",
    "\u9EC8": "tau2",
    "\u9EC9": "hung4",
    "\u9ECA": "waa6",
    "\u9ECB": "kong3/kwong3",
    "\u9ECC": "hung4",
    "\u9ECD": "syu2",
    "\u9ECE": "lai4",
    "\u9ECF": "nim1/lim1/zim1/nim4/lim4",
    "\u9ED0": "ci1",
    "\u9ED1": "hak1/haak1",
    "\u9ED2": "hak1",
    "\u9ED3": "jik6",
    "\u9ED4": "kim4",
    "\u9ED5": "dam2",
    "\u9ED6": "hei3",
    "\u9ED7": "tan1",
    "\u9ED8": "mak6",
    "\u9ED9": "mak6",
    "\u9EDA": "kim4",
    "\u9EDB": "doi6",
    "\u9EDC": "zeot1/ceot1/zyut3/zyut6",
    "\u9EDD": "jau2",
    "\u9EDE": "dim2",
    "\u9EDF": "ji1",
    "\u9EE0": "kit3/hat6/waat6",
    "\u9EE1": "jim2",
    "\u9EE2": "zeot1/ceot1",
    "\u9EE3": "mui5",
    "\u9EE4": "am2/ngam2/jim2",
    "\u9EE5": "king4",
    "\u9EE6": "wat1/jyut3/jit3",
    "\u9EE7": "lai4",
    "\u9EE8": "dong2/tong2",
    "\u9EE9": "duk6",
    "\u9EEA": "caam2",
    "\u9EEB": "jan1",
    "\u9EEC": "am2/ngam2/am3/ngam3",
    "\u9EED": "am2/ngam2/jim2",
    "\u9EEE": "dam2/taam5/sam6",
    "\u9EEF": "am2/ngam2",
    "\u9EF0": "can2/zan2",
    "\u9EF1": "doi6",
    "\u9EF2": "caam2",
    "\u9EF3": "ji1",
    "\u9EF4": "mei4/mui4",
    "\u9EF5": "daam2/zaam2",
    "\u9EF6": "jim2",
    "\u9EF7": "duk6",
    "\u9EF8": "lou1",
    "\u9EF9": "zi2",
    "\u9EFA": "fan2",
    "\u9EFB": "fat1",
    "\u9EFC": "fu2",
    "\u9EFD": "man5/maang5",
    "\u9EFE": "man5/maang5",
    "\u9EFF": "jyun4",
    "\u9F00": "cuk1",
    "\u9F01": "heoi3",
    "\u9F02": "ciu4/ziu1",
    "\u9F03": "waa1",
    "\u9F04": "zyu1",
    "\u9F05": "zi1",
    "\u9F06": "man4",
    "\u9F07": "ngou4/ou4",
    "\u9F08": "bit3",
    "\u9F09": "to4",
    "\u9F0A": "bik1",
    "\u9F0B": "jyun4",
    "\u9F0C": "ciu4/ziu1",
    "\u9F0D": "to4",
    "\u9F0E": "ding2",
    "\u9F0F": "mik6",
    "\u9F10": "naai5/laai5",
    "\u9F11": "ding2",
    "\u9F12": "zi1",
    "\u9F13": "gu2/gwu2",
    "\u9F14": "gu2/gwu2",
    "\u9F15": "dung1",
    "\u9F16": "fan4",
    "\u9F17": "tou4",
    "\u9F18": "jyun1",
    "\u9F19": "pei4",
    "\u9F1A": "coeng1",
    "\u9F1B": "gou1",
    "\u9F1C": "cik1",
    "\u9F1D": "jyun1",
    "\u9F1E": "tong1",
    "\u9F1F": "tang1/dang1",
    "\u9F20": "syu2",
    "\u9F21": "lip6",
    "\u9F22": "fan4",
    "\u9F23": "fai6",
    "\u9F24": "man4",
    "\u9F25": "bat6",
    "\u9F26": "diu1",
    "\u9F27": "to4",
    "\u9F28": "zung1",
    "\u9F29": "keoi4",
    "\u9F2A": "sang1",
    "\u9F2B": "sek6",
    "\u9F2C": "jau6",
    "\u9F2D": "si4",
    "\u9F2E": "ting4",
    "\u9F2F": "ng4/m4",
    "\u9F30": "gwik1",
    "\u9F31": "zing1/cing1",
    "\u9F32": "wan4",
    "\u9F33": "gwik1",
    "\u9F34": "jin2",
    "\u9F35": "dat6",
    "\u9F36": "si1",
    "\u9F37": "hai4",
    "\u9F38": "jim6",
    "\u9F39": "jin2",
    "\u9F3A": "leoi4",
    "\u9F3B": "bei6",
    "\u9F3C": "jiu6",
    "\u9F3D": "kau4",
    "\u9F3E": "hon4",
    "\u9F3F": "ngat6/at6",
    "\u9F40": "ngat6/at6",
    "\u9F41": "hau1",
    "\u9F42": "haai3",
    "\u9F43": "aat3/ngaat3",
    "\u9F44": "zaa1",
    "\u9F45": "cau3/hung3",
    "\u9F46": "ung3/ngung3",
    "\u9F47": "zaa1",
    "\u9F48": "nung6/lung6",
    "\u9F49": "nong6/long6",
    "\u9F4A": "cai4/cai2/zai6/zi1/zaai1",
    "\u9F4B": "zaai1",
    "\u9F4C": "zai6/cai1/zai1",
    "\u9F4D": "zi1",
    "\u9F4E": "zai1/cai4",
    "\u9F4F": "zai1",
    "\u9F50": "cai4/cai2/zai6/zi1/zaai1",
    "\u9F51": "zai1",
    "\u9F52": "ci2",
    "\u9F53": "can3",
    "\u9F54": "can3",
    "\u9F55": "hat6/ngaat6/aat6",
    "\u9F56": "ngaa4/aa4",
    "\u9F57": "ngan4/an4",
    "\u9F58": "haai6",
    "\u9F59": "baau6",
    "\u9F5A": "zaak3/zaak6",
    "\u9F5B": "sit3",
    "\u9F5C": "zi1/caai4",
    "\u9F5D": "ci1/si1",
    "\u9F5E": "jin6",
    "\u9F5F": "zeoi2/zaa1",
    "\u9F60": "tiu4",
    "\u9F61": "ling4/ling2",
    "\u9F62": "ling4",
    "\u9F63": "ceot1",
    "\u9F64": "kyun4",
    "\u9F65": "sit3",
    "\u9F66": "ngan4/an4/hang2",
    "\u9F67": "ngit6/it6/jit6/ngaat6/aat6",
    "\u9F68": "kau5",
    "\u9F69": "ngaau5/aau5",
    "\u9F6A": "cuk1",
    "\u9F6B": "wan5",
    "\u9F6C": "jyu5",
    "\u9F6D": "co2",
    "\u9F6E": "ji2",
    "\u9F6F": "ngai4/ai4",
    "\u9F70": "zaak3/zaak6",
    "\u9F71": "cuk1/zau1",
    "\u9F72": "geoi2",
    "\u9F73": "wan5",
    "\u9F74": "jin6/ngaan5/aan5",
    "\u9F75": "jyu4",
    "\u9F76": "ngok6/ok6",
    "\u9F77": "ak1/ngak1/aak1/ngaak1",
    "\u9F78": "jik1",
    "\u9F79": "ci1",
    "\u9F7A": "zau1",
    "\u9F7B": "din1",
    "\u9F7C": "co2",
    "\u9F7D": "gam6",
    "\u9F7E": "aat3/ngaat3/ngaa3/aa3",
    "\u9F7F": "ci2",
    "\u9F80": "can3",
    "\u9F81": "hat6/ngaat6/aat6",
    "\u9F82": "ngan4/an4",
    "\u9F83": "zeoi2/zaa1",
    "\u9F84": "ling4/ling2",
    "\u9F85": "baau6",
    "\u9F86": "tiu4",
    "\u9F87": "zi1/caai4",
    "\u9F88": "ngan4/an4/hang2",
    "\u9F89": "jyu5",
    "\u9F8A": "cuk1",
    "\u9F8B": "geoi2",
    "\u9F8C": "ak1/ngak1/aak1/ngaak1",
    "\u9F8D": "lung4/lung2",
    "\u9F8E": "pong4",
    "\u9F8F": "gung1",
    "\u9F90": "pong4",
    "\u9F91": "jim5/jim2",
    "\u9F92": "lung4",
    "\u9F93": "lung5",
    "\u9F94": "gung1",
    "\u9F95": "ham1",
    "\u9F96": "daap6",
    "\u9F97": "ling4",
    "\u9F98": "daap6",
    "\u9F99": "lung4/lung2",
    "\u9F9A": "gung1",
    "\u9F9B": "ham1",
    "\u9F9C": "gwai1/gwan1/kau1/gau1",
    "\u9F9D": "cau1",
    "\u9F9E": "bit3",
    "\u9F9F": "gwai1/gwan1/kau1/gau1",
    "\u9FA0": "joek6",
    "\u9FA1": "ceoi1/ceoi3",
    "\u9FA2": "wo4",
    "\u9FA3": "gok3",
    "\u9FA4": "haai4",
    "\u9FA5": "jyu6/joek6",
    "\uD841\uDD47": "mou5",
    "\uD841\uDDDF": "mui5",
    "\uD84F\uDFC5": "dung2",
    "\uD852\uDD42": "jik6",
    "\uD862\uDDE4": "hang1",
    "\uD846\uDDDB": "fu6",
    "\uD84F\uDCC8": "sin1",
    "\uD852\uDD33": "ji5",
    "\uD862\uDDAA": "joeng5",
    "\uD840\uDEA0": "fan1",
    "\uD85A\uDFB3": "kei5",
    "\uD844\uDF05": "fat6",
    "\uD849\uDCED": "seon1",
    "\uD85B\uDD29": "seon3",
    "\uD85E\uDE84": "gei3",
    "\uD84D\uDE00": "sau1",
    "\uD852\uDEB1": "sau1",
    "\uD849\uDD13": "fung6",
    "\uD840\uDF7E": "jin2",
    "\uD840\uDF80": "git6",
    "\uD840\uDF47": "caan3",
    "\uD841\uDC1F": "liu4",
    "\uD852\uDDA4": "ji4",
    "\uD841\uDC87": "maau6",
    "\uD84C\uDFB4": "dan2/nip6/lip6",
    "\uD842\uDFFF": "luk6",
    "\uD848\uDCFC": "mei4",
    "\uD840\uDEE5": "mei4",
    "\uD849\uDD30": "mei4",
    "\uD841\uDD8E": "zeot1",
    "\uD84C\uDE33": "min5",
    "\uD846\uDD83": "waan4",
    "\uD841\uDDB3": "mat6",
    "\uD84F\uDC99": "zeoi2",
    "\uD852\uDEA6": "ji4",
    "\uD84D\uDF2D": "zin2",
    "\uD85A\uDF13": "jau4",
    "\uD862\uDEDE": "ci4",
    "\uD84F\uDF80": "wui6",
    "\uD842\uDD54": "wui6",
    "\uD84F\uDFEC": "wui6",
    "\uD842\uDFE2": "saa1.aa6",
    "\uD845\uDF26": "wai3",
    "\uD845\uDEE8": "kaa1",
    "\uD861\uDEAB": "koek3",
    "\uD845\uDD96": "hing1",
    "\uD845\uDE13": "hau4",
    "\uD862\uDE9B": "jyun4",
    "\uD855\uDF72": "wan5",
    "\uD842\uDF8F": "jeoi6",
    "\uD84F\uDFEB": "dip6",
    "\uD84B\uDDA3": "dip6",
    "\uD843\uDC77": "ming4",
    "\uD85A\uDF53": "sai3",
    "\uD843\uDD74": "ming6",
    "\uD845\uDF0D": "zat6",
    "\uD843\uDEDD": "caam1",
    "\uD843\uDD4D": "zaat3",
    "\uD862\uDDBC": "jin4",
    "\uD849\uDE98": "ji3",
    "\uD846\uDCD7": "gaa1",
    "\uD850\uDC3A": "gaa1",
    "\uD851\uDC35": "gaa1",
    "\uD844\uDCB4": "lin4",
    "\uD84C\uDE8A": "hou6",
    "\uD862\uDF66": "jyun4",
    "\uD844\uDE4F": "ji5",
    "\uD850\uDDA5": "wan4",
    "\uD85B\uDC7E": "ping4",
    "\uD845\uDC16": "haam5",
    "\uD845\uDC54": "kwan1",
    "\uD850\uDF63": "kwan1",
    "\uD852\uDFF5": "jing4",
    "\uD844\uDE3C": "ting2",
    "\uD868\uDD50": "mok6",
    "\uD850\uDE78": "geoi1",
    "\uD845\uDE3E": "zong6",
    "\uD845\uDE92": "fan5",
    "\uD843\uDD4E": "gu1/gwu1",
    "\uD85B\uDC81": "nei4/lei4",
    "\uD85B\uDD2A": "nei5/lei5",
    "\uD845\uDFDC": "goeng1",
    "\uD845\uDFFB": "jan1",
    "\uD845\uDFB2": "ping1",
    "\uD85B\uDDA6": "no5/lo5",
    "\uD846\uDC28": "tai5",
    "\uD845\uDED5": "taai3",
    "\uD85B\uDE45": "jyun2",
    "\uD852\uDDA9": "ok3/ngok3",
    "\uD85B\uDFA1": "mei5",
    "\uD849\uDD54": "zoeng1",
    "\uD846\uDD11": "coeng4",
    "\uD845\uDEB8": "maa1",
    "\uD85E\uDE0E": "jyun4",
    "\uD840\uDE04": "waan6",
    "\uD846\uDE34": "ning4/ling4/ning6/ling6",
    "\uD856\uDDCC": "mei6",
    "\uD841\uDDA5": "cung2",
    "\uD846\uDF44": "cyun3",
    "\uD847\uDCA5": "sang1",
    "\uD85A\uDF28": "cek3",
    "\uD847\uDDF9": "jin6",
    "\uD847\uDE37": "kei4",
    "\uD847\uDEA4": "laam4",
    "\uD852\uDD01": "fong1",
    "\uD848\uDC49": "seon3",
    "\uD848\uDD73": "lim4",
    "\uD851\uDCBC": "fong2",
    "\uD843\uDCD3": "bei3",
    "\uD845\uDF71": "fan1",
    "\uD861\uDC82": "jin4",
    "\uD840\uDDC1": "jan5",
    "\uD87E\uDC94": "tou1",
    "\uD844\uDF3A": "mang4",
    "\uD85A\uDC88": "ji5",
    "\uD848\uDFD0": "wang4",
    "\uD849\uDC71": "ji4",
    "\uD85B\uDE6E": "coi2",
    "\uD862\uDE36": "jyu5",
    "\uD854\uDE50": "hai5",
    "\uD847\uDF6A": "fai1",
    "\uD85C\uDCF8": "fai1",
    "\uD849\uDE68": "cyun4",
    "\uD840\uDE9E": "zung1",
    "\uD862\uDE29": "zung1",
    "\uD846\uDC77": "ling4",
    "\uD849\uDFB4": "jan1",
    "\uD852\uDD82": "gwok3/gok3",
    "\uD852\uDD8F": "fat1",
    "\uD85E\uDE53": "fat1",
    "\uD87E\uDCA6": "ci4",
    "\uD85B\uDED2": "mou6",
    "\uD841\uDE56": "pang4",
    "\uD84F\uDFB7": "kiu4",
    "\uD84A\uDC5F": "mau6",
    "\uD862\uDF9D": "deoi3",
    "\uD866\uDD5D": "zi3",
    "\uD84A\uDD80": "zong3",
    "\uD84A\uDCC1": "gung1",
    "\uD840\uDD18": "sing4",
    "\uD845\uDF70": "laai1",
    "\uD84B\uDE0D": "zan3",
    "\uD852\uDDDF": "ting4",
    "\uD844\uDF8E": "sai3",
    "\uD845\uDFFC": "fui3",
    "\uD84B\uDE36": "cyut3",
    "\uD850\uDC8C": "kit3",
    "\uD855\uDF1D": "kit3",
    "\uD852\uDE28": "man5",
    "\uD852\uDE23": "gau3",
    "\uD84C\uDC7E": "dau2",
    "\uD852\uDD40": "do1",
    "\uD846\uDC29": "gin1",
    "\uD84D\uDC00": "man4",
    "\uD84C\uDDF7": "fong1",
    "\uD84C\uDDF8": "ceon1",
    "\uD84C\uDDA4": "fong2",
    "\uD84C\uDDA5": "fong2",
    "\uD843\uDE75": "aan3/ngaan3",
    "\uD854\uDDE6": "sik1",
    "\uD847\uDE3D": "zik6",
    "\uD84C\uDE31": "coeng3",
    "\uD861\uDDF4": "cim3",
    "\uD84C\uDDC8": "hiu2",
    "\uD854\uDF13": "cyu5",
    "\uD84A\uDCF7": "dik6",
    "\uD850\uDF9C": "long5",
    "\uD852\uDE21": "long5",
    "\uD84D\uDFC2": "fun1",
    "\uD850\uDDCD": "seot6",
    "\uD864\uDCED": "cung4",
    "\uD84C\uDFE6": "muk6",
    "\uD85B\uDDA0": "gan1",
    "\uD84D\uDC6F": "tou4",
    "\uD862\uDEDF": "loeng4",
    "\uD84D\uDDCD": "kei4",
    "\uD84D\uDE3C": "kai2",
    "\uD862\uDE4A": "jau4",
    "\uD840\uDFC9": "gon3",
    "\uD84D\uDE59": "cuk1",
    "\uD848\uDD2A": "lau6",
    "\uD84D\uDF03": "jau5",
    "\uD864\uDD9C": "ling4",
    "\uD842\uDD23": "ci3",
    "\uD849\uDFCD": "lik6",
    "\uD84E\uDEDB": "ngai6/ai6",
    "\uD840\uDFB5": "ngai6/ai6",
    "\uD846\uDD58": "hou2",
    "\uD84E\uDF5A": "bou6",
    "\uD84F\uDEFC": "hou4",
    "\uD849\uDC8B": "wing5",
    "\uD852\uDCF1": "ji5",
    "\uD85A\uDF51": "ting1",
    "\uD84F\uDDBC": "fan1",
    "\uD84F\uDDBD": "wan4",
    "\uD850\uDDA4": "jung2",
    "\uD852\uDD0C": "jung2",
    "\uD852\uDD00": "tyun4",
    "\uD84F\uDCC9": "si3",
    "\uD843\uDD32": "daap6",
    "\uD84C\uDDF9": "man5",
    "\uD849\uDC91": "coeng4",
    "\uD85B\uDD25": "seon1",
    "\uD85B\uDDA1": "hou6",
    "\uD85B\uDDEB": "hoi2",
    "\uD852\uDD7F": "jik6",
    "\uD850\uDC85": "zing6",
    "\uD85B\uDE72": "wan6",
    "\uD85B\uDF74": "zing6",
    "\uD862\uDF21": "keoi4",
    "\uD84F\uDE2F": "jau4",
    "\uD84F\uDF82": "gaai1",
    "\uD84C\uDC4B": "mei4",
    "\uD84F\uDE30": "jim1",
    "\uD845\uDC97": "mun5",
    "\uD850\uDC3D": "ji2",
    "\uD864\uDD70": "si1",
    "\uD850\uDD44": "lim4",
    "\uD850\uDC91": "nung4/lung4",
    "\uD850\uDD55": "cau4",
    "\uD850\uDC39": "zeon3",
    "\uD84F\uDFF0": "zeon3",
    "\uD84F\uDFB4": "buk6",
    "\uD850\uDD3F": "lik1",
    "\uD850\uDD56": "pan4",
    "\uD850\uDD57": "jing4",
    "\uD850\uDD40": "jing4",
    "\uD858\uDDDD": "jing4",
    "\uD850\uDE77": "jin4",
    "\uD850\uDF65": "heoi2",
    "\uD850\uDEC1": "joeng4",
    "\uD851\uDC5A": "jing4",
    "\uD852\uDE27": "piu3",
    "\uD852\uDE22": "taan3",
    "\uD862\uDFE8": "hei1",
    "\uD855\uDE05": "si6",
    "\uD852\uDD74": "zi3",
    "\uD84C\uDC44": "geoi2",
    "\uD852\uDC23": "hau4",
    "\uD862\uDC2B": "jau4",
    "\uD862\uDC04": "jau4",
    "\uD843\uDC3A": "doi6",
    "\uD85A\uDE2E": "doi6",
    "\uD850\uDDE2": "baak6",
    "\uD845\uDEE7": "nei5/lei5",
    "\uD852\uDE24": "zan1",
    "\uD852\uDDB7": "jin2",
    "\uD852\uDD8D": "pui3",
    "\uD852\uDDFB": "ting4",
    "\uD852\uDE26": "ji1",
    "\uD841\uDDC3": "jan1",
    "\uD84A\uDCAD": "jyu4",
    "\uD863\uDEB2": "jyu5",
    "\uD852\uDE8C": "kei4",
    "\uD850\uDD5F": "lou6",
    "\uD852\uDE79": "bik1",
    "\uD862\uDF8F": "caan3",
    "\uD863\uDC03": "jing1",
    "\uD846\uDC9E": "jing1",
    "\uD846\uDD88": "gu1/gwu1",
    "\uD863\uDED9": "fong2",
    "\uD846\uDE4B": "ning4/ling4",
    "\uD863\uDEAC": "gaai3",
    "\u9B14": "pung4",
    "\u9B15": "maa6",
    "\u9B16": "saam1",
    "\u9B17": "mun4",
    "\u9B18": "maan4",
    "\u9B19": "zang1",
    "\u9B1A": "sou1",
    "\u9B1B": "lip6",
    "\u9B1C": "haan1",
    "\u9B1D": "haan1",
    "\u9B1E": "nong4/long4",
    "\u9B1F": "waan4",
    "\u9B20": "kut3/kwut3",
    "\u9B21": "ning4/ling4",
    "\u9B22": "ban3",
    "\u9B23": "lip6",
    "\u9B24": "joeng4",
    "\u9B25": "dau3",
    "\u9B26": "dau3",
    "\u9B27": "naau6/laau6",
    "\u9B28": "hung3/hung6",
    "\u9B29": "jik1",
    "\u9B2A": "dau3",
    "\u9B2B": "ham3/haam3/haam2",
    "\u9B2C": "dau3",
    "\u9B2D": "dau3",
    "\u9B2E": "gau1",
    "\u9B2F": "coeng3",
    "\u9B30": "wat1",
    "\u9B31": "wat1",
    "\u9B32": "lik6/gaak3/ak1/ngak1",
    "\u9B33": "jin6",
    "\u9B34": "fu2",
    "\u9B35": "cam4/cim4",
    "\u9B36": "kwai1",
    "\u9B37": "zung1",
    "\u9B38": "lau6",
    "\u9B39": "kwai1",
    "\u9B3A": "soeng1",
    "\u9B3B": "juk6/zuk1",
    "\u9B3C": "gwai2",
    "\u9B3D": "mei6/mui6",
    "\u9B3E": "gei6",
    "\u9B3F": "kei4",
    "\u9B40": "gaai3",
    "\u9B41": "fui1",
    "\u9B42": "wan4",
    "\u9B43": "bat6/baat6",
    "\u9B44": "paak3/tok3/bok6",
    "\u9B45": "mei6/mui6",
    "\u9B46": "wat1/fat1",
    "\u9B47": "jim2",
    "\u9B48": "siu1",
    "\u9B49": "loeng5",
    "\u9B4A": "wik6",
    "\u9B4B": "teoi4/zeoi1",
    "\u9B4C": "hei1",
    "\u9B4D": "mong5",
    "\u9B4E": "loeng5",
    "\u9B4F": "ngai6/ai6",
    "\u9B50": "gaam1",
    "\u9B51": "ci1",
    "\u9B52": "piu1",
    "\u9B53": "bat1",
    "\u9B54": "mo1",
    "\u9B55": "kei4",
    "\u9B56": "heoi1",
    "\u9B57": "cau4/cau2",
    "\u9B58": "jim2",
    "\u9B59": "zim6",
    "\u9B5A": "jyu4/jyu2",
    "\u9B5B": "dou1",
    "\u9B5C": "jan4",
    "\u9B5D": "git3",
    "\u9B5E": "jap6",
    "\u9B5F": "hung4/gung1",
    "\u9B60": "tok3",
    "\u9B61": "diu3",
    "\u9B62": "gei2",
    "\u9B63": "jyu4",
    "\u9B64": "ngo4/o4",
    "\u9B65": "ngap6/ap6",
    "\u9B66": "saa1",
    "\u9B67": "hong4",
    "\u9B68": "tyun4",
    "\u9B69": "mut6",
    "\u9B6A": "gaai3",
    "\u9B6B": "sam2",
    "\u9B6C": "baan2",
    "\u9B6D": "jyun4",
    "\u9B6E": "pei4",
    "\u9B6F": "lou5",
    "\u9B70": "man4",
    "\u9B71": "wu4",
    "\u9B72": "lou4",
    "\u9B73": "zaap3",
    "\u9B74": "fong4",
    "\u9B75": "fan4/fan5",
    "\u9B76": "naap6/laap6",
    "\u9B77": "jau4/jau2",
    "\u9B78": "pin3",
    "\u9B79": "mou4",
    "\u9B7A": "ho4",
    "\u9B7B": "haap6",
    "\u9B7C": "keoi1",
    "\u9B7D": "haam4",
    "\u9B7E": "pei1/pei4",
    "\u9B7F": "ling4",
    "\u9B80": "to4",
    "\u9B81": "bat6/bat3/but3",
    "\u9B82": "cau4",
    "\u9B83": "ping4",
    "\u9B84": "fat1/fat6",
    "\u9B85": "bit1",
    "\u9B86": "cai5/zai1/ci2",
    "\u9B87": "mei6",
    "\u9B88": "keoi1",
    "\u9B89": "diu1",
    "\u9B8A": "baak6/bat6",
    "\u9B8B": "jau4",
    "\u9B8C": "gwan2",
    "\u9B8D": "pei4",
    "\u9B8E": "nim4/lim4",
    "\u9B8F": "sing1",
    "\u9B90": "toi4",
    "\u9B91": "baau1/baau6",
    "\u9B92": "fu6",
    "\u9B93": "zaa2/zaa3",
    "\u9B94": "geoi6",
    "\u9B95": "gu1/gwu1",
    "\u9B96": "sek6",
    "\u9B97": "dung1",
    "\u9B98": "doi6",
    "\u9B99": "taap3",
    "\u9B9A": "git3",
    "\u9B9B": "suk1",
    "\u9B9C": "hau6",
    "\u9B9D": "soeng2",
    "\u9B9E": "ji4",
    "\u9B9F": "on1/ngon1/jin2",
    "\u9BA0": "wai4",
    "\u9BA1": "siu6",
    "\u9BA2": "zyu1",
    "\u9BA3": "jan3",
    "\u9BA4": "lit6",
    "\u9BA5": "lok6",
    "\u9BA6": "tung4/zau6",
    "\u9BA7": "ji4/tai4",
    "\u9BA8": "ngai6/ai6/zi1/kei4",
    "\u9BA9": "bing6",
    "\u9BAA": "fui2",
    "\u9BAB": "gaau1",
    "\u9BAC": "fu1",
    "\u9BAD": "gwai1/haai4/waa1",
    "\u9BAE": "sin1/sin2",
    "\u9BAF": "gap3",
    "\u9BB0": "wui4",
    "\u9BB1": "lou5",
    "\u9BB2": "fuk6",
    "\u9BB3": "kaau3",
    "\u9BB4": "jau1",
    "\u9BB5": "dyut6",
    "\u9BB6": "gwan1",
    "\u9BB7": "tai4",
    "\u9BB8": "min5",
    "\u9BB9": "saau1",
    "\u9BBA": "zaa2",
    "\u9BBB": "so1",
    "\u9BBC": "cam1",
    "\u9BBD": "jyu4",
    "\u9BBE": "neoi5/leoi5",
    "\u9BBF": "zip3",
    "\u9BC0": "gwan2",
    "\u9BC1": "gang2/kang2",
    "\u9BC2": "sou1",
    "\u9BC3": "ng4/m4",
    "\u9BC4": "kau4",
    "\u9BC5": "saan1",
    "\u9BC6": "pou1",
    "\u9BC7": "waan5",
    "\u9BC8": "jau4/tiu4",
    "\u9BC9": "lei5",
    "\u9BCA": "saa1",
    "\u9BCB": "saa1",
    "\u9BCC": "hou3",
    "\u9BCD": "mang4",
    "\u9BCE": "sing4",
    "\u9BCF": "lei6",
    "\u9BD0": "zau2",
    "\u9BD1": "hei1",
    "\u9BD2": "jung2",
    "\u9BD3": "san1",
    "\u9BD4": "zi1",
    "\u9BD5": "kei4",
    "\u9BD6": "cing1/zing1",
    "\u9BD7": "soeng2",
    "\u9BD8": "neoi5/leoi5",
    "\u9BD9": "seon4",
    "\u9BDA": "gwai3",
    "\u9BDB": "diu1",
    "\u9BDC": "cip3",
    "\u9BDD": "gu3/gwu3",
    "\u9BDE": "zau2",
    "\u9BDF": "dung1",
    "\u9BE0": "loi4",
    "\u9BE1": "fei1",
    "\u9BE2": "ngai4/ai4",
    "\u9BE3": "jik6",
    "\u9BE4": "kwan1",
    "\u9BE5": "luk6",
    "\u9BE6": "gau6",
    "\u9BE7": "coeng1",
    "\u9BE8": "king4",
    "\u9BE9": "leon4",
    "\u9BEA": "ling4/leng4",
    "\u9BEB": "zau1",
    "\u9BEC": "lei4",
    "\u9BED": "maang1",
    "\u9BEE": "zung1",
    "\u9BEF": "zai3",
    "\u9BF0": "nim4/lim4",
    "\u9BF1": "fu2",
    "\u9BF2": "jyu1",
    "\u9BF3": "dai2",
    "\u9BF4": "sat1",
    "\u9BF5": "sam1",
    "\u9BF6": "waan5",
    "\u9BF7": "tai4",
    "\u9BF8": "hau4",
    "\u9BF9": "sing1",
    "\u9BFA": "zyu1",
    "\u9BFB": "laat6",
    "\u9BFC": "zung1",
    "\u9BFD": "zik1/zak1",
    "\u9BFE": "bin1/bin2",
    "\u9BFF": "bin1/bin2",
    "\u9C00": "waan5",
    "\u9C01": "cyun4",
    "\u9C02": "caak6/zak1",
    "\u9C03": "wai1/wui1",
    "\u9C04": "wai1",
    "\u9C05": "jyu4/jung4",
    "\u9C06": "ceon1",
    "\u9C07": "jau4",
    "\u9C08": "dip6",
    "\u9C09": "wong4",
    "\u9C0A": "lin6",
    "\u9C0B": "jin2",
    "\u9C0C": "cau1",
    "\u9C0D": "cau1",
    "\u9C0E": "gin2",
    "\u9C0F": "bik1",
    "\u9C10": "ngok6/ok6",
    "\u9C11": "joeng4",
    "\u9C12": "fuk1",
    "\u9C13": "soi1",
    "\u9C14": "gam2",
    "\u9C15": "haa1",
    "\u9C16": "to2",
    "\u9C17": "wu4",
    "\u9C18": "sat1",
    "\u9C19": "joek6",
    "\u9C1A": "syun1",
    "\u9C1B": "wan1",
    "\u9C1C": "gim1",
    "\u9C1D": "hou6",
    "\u9C1E": "wu1",
    "\u9C1F": "pong4/fong4",
    "\u9C20": "sou1",
    "\u9C21": "lau4",
    "\u9C22": "maa5",
    "\u9C23": "si4",
    "\u9C24": "si1",
    "\u9C25": "gwaan1",
    "\u9C26": "zi1",
    "\u9C27": "tang4",
    "\u9C28": "taap3/dip6/taat3",
    "\u9C29": "jiu4",
    "\u9C2A": "ap1/ngap1",
    "\u9C2B": "jung4/sung4",
    "\u9C2C": "kin4",
    "\u9C2D": "kei4",
    "\u9C2E": "wan1",
    "\u9C2F": "joek6",
    "\u9C30": "san4",
    "\u9C31": "lin4",
    "\u9C32": "ngou4/ou4",
    "\u9C33": "lak6/laak6",
    "\u9C34": "fai1",
    "\u9C35": "man5",
    "\u9C36": "zai3/man5",
    "\u9C37": "tiu4",
    "\u9C38": "keoi1",
    "\u9C39": "gin1",
    "\u9C3A": "sam1",
    "\u9C3B": "maan6/maan4",
    "\u9C3C": "zaap6",
    "\u9C3D": "cau4",
    "\u9C3E": "piu5",
    "\u9C3F": "zik1",
    "\u9C40": "kei3",
    "\u9C41": "zuk6",
    "\u9C42": "zoeng1",
    "\u9C43": "sau1",
    "\u9C44": "zyun1/tyun4",
    "\u9C45": "jung4/sung4",
    "\u9C46": "zoeng1",
    "\u9C47": "hong1",
    "\u9C48": "syut3",
    "\u9C49": "bit3",
    "\u9C4A": "wat6",
    "\u9C4B": "keoi1",
    "\u9C4C": "zoeng6",
    "\u9C4D": "but6/but3",
    "\u9C4E": "giu2",
    "\u9C4F": "cam4",
    "\u9C50": "suk1",
    "\u9C51": "wong4",
    "\u9C52": "zyun1/zyun3",
    "\u9C53": "to4/sin5",
    "\u9C54": "sin5/sin2",
    "\u9C55": "faan1",
    "\u9C56": "gwai3/kyut3",
    "\u9C57": "leon4",
    "\u9C58": "cam4",
    "\u9C59": "jiu4",
    "\u9C5A": "hei1",
    "\u9C5B": "zang1",
    "\u9C5C": "hoeng1",
    "\u9C5D": "fan5",
    "\u9C5E": "gwaan1",
    "\u9C5F": "hau6",
    "\u9C60": "kui2/kwui2",
    "\u9C61": "caak6",
    "\u9C62": "sou1",
    "\u9C63": "zin1/sin5",
    "\u9C64": "gam2",
    "\u9C65": "gwai3",
    "\u9C66": "jing6",
    "\u9C67": "lai5",
    "\u9C68": "soeng4",
    "\u9C69": "leoi4",
    "\u9C6A": "syu2",
    "\u9C6B": "oi3/ngoi3",
    "\u9C6C": "jyu4",
    "\u9C6D": "cai5/cai4",
    "\u9C6E": "zeoi6",
    "\u9C6F": "wu6",
    "\u9C70": "cyu5",
    "\u9C71": "lai6",
    "\u9C72": "lip6/lap6/laap6",
    "\u9C73": "lik6",
    "\u9C74": "mit6",
    "\u9C75": "zam1",
    "\u9C76": "soeng2",
    "\u9C77": "ngok6/ok6",
    "\u9C78": "lou4",
    "\u9C79": "gun3/gwun3",
    "\u9C7A": "lei4",
    "\u9C7B": "sin1",
    "\u9C7C": "jyu4/jyu2",
    "\u9C7D": "dou1",
    "\u9C7E": "gei2",
    "\u9C7F": "jau4/jau2",
    "\u9C80": "tyun4",
    "\u9C81": "lou5",
    "\u9C82": "fong4",
    "\u9C83": "baa1/bat6",
    "\u9C84": "ho4",
    "\u9C85": "bat6/bat3/but3",
    "\u9C86": "ping4",
    "\u9C87": "nim4/lim4",
    "\u9C88": "lou4",
    "\u9C89": "jau4",
    "\u9C8A": "zaa2/zaa3",
    "\u9C8B": "fu6",
    "\u9C8C": "baak6/bat6",
    "\u9C8D": "baau1/baau6",
    "\u9C8E": "hau6",
    "\u9C8F": "pei4",
    "\u9C90": "toi4",
    "\u9C91": "gwai1/haai4/waa1",
    "\u9C92": "git3",
    "\u9C93": "kaau3",
    "\u9C94": "fui2",
    "\u9C95": "ji4",
    "\u9C96": "tung4/zau6",
    "\u9C97": "caak6/zak1",
    "\u9C98": "hau6",
    "\u9C99": "kui2/kwui2",
    "\u9C9A": "cai5/cai4",
    "\u9C9B": "gaau1",
    "\u9C9C": "sin1/sin2",
    "\u9C9D": "zaa2",
    "\u9C9E": "soeng2",
    "\u9C9F": "cam4",
    "\u9CA0": "gang2/kang2",
    "\u9CA1": "lei4",
    "\u9CA2": "lin4",
    "\u9CA3": "gin1",
    "\u9CA4": "lei5",
    "\u9CA5": "si4",
    "\u9CA6": "tiu4",
    "\u9CA7": "gwan2",
    "\u9CA8": "saa1",
    "\u9CA9": "waan5",
    "\u9CAA": "gwan1",
    "\u9CAB": "zik1/zak1",
    "\u9CAC": "jung2",
    "\u9CAD": "cing1/zing1",
    "\u9CAE": "ling4/leng4",
    "\u9CAF": "kei4",
    "\u9CB0": "zau1",
    "\u9CB1": "fei1",
    "\u9CB2": "kwan1",
    "\u9CB3": "coeng1",
    "\u9CB4": "gu3/gwu3",
    "\u9CB5": "ngai4/ai4",
    "\u9CB6": "nim4/lim4",
    "\u9CB7": "diu1",
    "\u9CB8": "king4",
    "\u9CB9": "sam1",
    "\u9CBA": "sat1",
    "\u9CBB": "zi1",
    "\u9CBC": "fan5",
    "\u9CBD": "dip6",
    "\u9CBE": "bik1",
    "\u9CBF": "soeng4",
    "\u9CC0": "tai4",
    "\u9CC1": "wan1",
    "\u9CC2": "wai1/wui1",
    "\u9CC3": "soi1",
    "\u9CC4": "ngok6/ok6",
    "\u9CC5": "cau1",
    "\u9CC6": "fuk1",
    "\u9CC7": "wong4",
    "\u9CC8": "cyun4",
    "\u9CC9": "zoeng1",
    "\u9CCA": "bin1/bin2",
    "\u9CCB": "sou1",
    "\u9CCC": "ngou4/ou4",
    "\u9CCD": "kei4",
    "\u9CCE": "taap3/dip6/taat3",
    "\u9CCF": "gwaan1",
    "\u9CD0": "jiu4",
    "\u9CD1": "pong4/fong4",
    "\u9CD2": "gim1",
    "\u9CD3": "lak6/laak6",
    "\u9CD4": "piu5",
    "\u9CD5": "syut3",
    "\u9CD6": "bit3",
    "\u9CD7": "maan6/maan4",
    "\u9CD8": "man5",
    "\u9CD9": "jung4/sung4",
    "\u9CDA": "wai3",
    "\u9CDB": "zaap6",
    "\u9CDC": "gwai3/kyut3",
    "\u9CDD": "sin5/sin2",
    "\u9CDE": "leon4",
    "\u9CDF": "zyun1/zyun3",
    "\u9CE0": "wu6",
    "\u9CE1": "gam2",
    "\u9CE2": "lai5",
    "\u9CE3": "zin1/sin5",
    "\u9CE4": "gun2/gwun2",
    "\u9CE5": "niu5/liu5/diu2",
    "\u9CE6": "jyut6/jyut3",
    "\u9CE7": "fu4",
    "\u9CE8": "lik6",
    "\u9CE9": "gau1/kau1",
    "\u9CEA": "buk1",
    "\u9CEB": "ngaan6/aan6",
    "\u9CEC": "fu4",
    "\u9CED": "dou1",
    "\u9CEE": "gai1",
    "\u9CEF": "fung6",
    "\u9CF0": "jap6",
    "\u9CF1": "gon1/hon6",
    "\u9CF2": "si1",
    "\u9CF3": "fung6/fung2",
    "\u9CF4": "ming4",
    "\u9CF5": "bou2",
    "\u9CF6": "jyun1/jyun4",
    "\u9CF7": "zi1",
    "\u9CF8": "wu6",
    "\u9CF9": "kam4",
    "\u9CFA": "fu1",
    "\u9CFB": "baan1",
    "\u9CFC": "man4",
    "\u9CFD": "gin1",
    "\u9CFE": "si1",
    "\u9CFF": "juk6",
    "\u9D00": "fau4/fau2",
    "\u9D01": "jiu1",
    "\u9D02": "kyut3",
    "\u9D03": "gwik1/kyut3",
    "\u9D04": "pat1",
    "\u9D05": "fun1",
    "\u9D06": "zam6",
    "\u9D07": "bou2",
    "\u9D08": "ngaan6/aan6",
    "\u9D09": "aa1/ngaa1",
    "\u9D0A": "zing3",
    "\u9D0B": "fong1",
    "\u9D0C": "fung6",
    "\u9D0D": "man4",
    "\u9D0E": "au1/ngau1",
    "\u9D0F": "dak6",
    "\u9D10": "gaa1",
    "\u9D11": "jyu4",
    "\u9D12": "ling4",
    "\u9D13": "bat6/mit6/mat6",
    "\u9D14": "fuk6",
    "\u9D15": "to4",
    "\u9D16": "man4",
    "\u9D17": "laap6/lap6",
    "\u9D18": "bin2",
    "\u9D19": "zi6",
    "\u9D1A": "go1/gaa1",
    "\u9D1B": "jyun1/jin1",
    "\u9D1C": "ci4",
    "\u9D1D": "keoi4",
    "\u9D1E": "hiu1",
    "\u9D1F": "ci1",
    "\u9D20": "daan3",
    "\u9D21": "zeoi1",
    "\u9D22": "jiu2",
    "\u9D23": "gu1/gwu1",
    "\u9D24": "zung1",
    "\u9D25": "wat6",
    "\u9D26": "joeng1",
    "\u9D27": "wat6",
    "\u9D28": "aap3/ngaap3/aap2/ngaap2",
    "\u9D29": "tit3",
    "\u9D2A": "wat6",
    "\u9D2B": "tin4",
    "\u9D2C": "ang1/ngang1",
    "\u9D2D": "deoi1",
    "\u9D2E": "wu1",
    "\u9D2F": "ji4",
    "\u9D30": "kut3/kwut3/gwaat3",
    "\u9D31": "ngaai6/aai6",
    "\u9D32": "zi1",
    "\u9D33": "aan3/ngaan3",
    "\u9D34": "hang4/hong4",
    "\u9D35": "giu1",
    "\u9D36": "gat1",
    "\u9D37": "lit6",
    "\u9D38": "zyu1",
    "\u9D39": "joeng4",
    "\u9D3A": "ji4/tai4",
    "\u9D3B": "hung4",
    "\u9D3C": "lou6",
    "\u9D3D": "jyu4",
    "\u9D3E": "mau4",
    "\u9D3F": "gap3/gap2/gaap3",
    "\u9D40": "jam4/jam6",
    "\u9D41": "gaau1",
    "\u9D42": "jau1",
    "\u9D43": "zau1",
    "\u9D44": "ci1",
    "\u9D45": "lok6",
    "\u9D46": "hang4",
    "\u9D47": "nin4/lin4",
    "\u9D48": "diu1",
    "\u9D49": "lyun4",
    "\u9D4A": "gaap3",
    "\u9D4B": "gei6",
    "\u9D4C": "tou4",
    "\u9D4D": "fun1",
    "\u9D4E": "to2",
    "\u9D4F": "bou2",
    "\u9D50": "mou4",
    "\u9D51": "gyun1",
    "\u9D52": "juk6",
    "\u9D53": "but6",
    "\u9D54": "zeon3",
    "\u9D55": "zeon3",
    "\u9D56": "gip3",
    "\u9D57": "hei1",
    "\u9D58": "gwan6",
    "\u9D59": "gwik1",
    "\u9D5A": "tuk1",
    "\u9D5B": "ging1",
    "\u9D5C": "tai4",
    "\u9D5D": "ngo4/o4/ngo2/o2",
    "\u9D5E": "ngo4/o4",
    "\u9D5F": "kwong4/kong4",
    "\u9D60": "huk6/guk1",
    "\u9D61": "mou5",
    "\u9D62": "san1",
    "\u9D63": "laai6",
    "\u9D64": "gok3",
    "\u9D65": "pun3",
    "\u9D66": "luk6",
    "\u9D67": "pei4",
    "\u9D68": "syu1",
    "\u9D69": "fuk6",
    "\u9D6A": "am1/ngam1/aan3/ngaan3",
    "\u9D6B": "zok6",
    "\u9D6C": "paang4",
    "\u9D6D": "kam4",
    "\u9D6E": "zaam1",
    "\u9D6F": "bei1/pat1",
    "\u9D70": "diu1",
    "\u9D71": "luk6",
    "\u9D72": "zoek3/zoek2/coek3",
    "\u9D73": "gin1",
    "\u9D74": "guk1",
    "\u9D75": "tou3",
    "\u9D76": "aa1/ngaa1",
    "\u9D77": "jyun1",
    "\u9D78": "kei4",
    "\u9D79": "lei4",
    "\u9D7A": "je6",
    "\u9D7B": "zeoi1",
    "\u9D7C": "hung1",
    "\u9D7D": "zyut3",
    "\u9D7E": "kwan1",
    "\u9D7F": "sing1",
    "\u9D80": "kei4",
    "\u9D81": "ging1",
    "\u9D82": "jik6",
    "\u9D83": "jik6",
    "\u9D84": "zing1",
    "\u9D85": "zi1",
    "\u9D86": "loi4",
    "\u9D87": "dung1",
    "\u9D88": "cai1",
    "\u9D89": "seon4/ceon1",
    "\u9D8A": "gang1",
    "\u9D8B": "geoi1",
    "\u9D8C": "gwat6",
    "\u9D8D": "ji6",
    "\u9D8E": "zung1",
    "\u9D8F": "gai1",
    "\u9D90": "wat6",
    "\u9D91": "ang1/ngang1",
    "\u9D92": "cik1",
    "\u9D93": "miu4",
    "\u9D94": "jau4",
    "\u9D95": "am1/ngam1",
    "\u9D96": "cau1",
    "\u9D97": "tai4",
    "\u9D98": "wu4",
    "\u9D99": "tai4",
    "\u9D9A": "ngok6/ok6",
    "\u9D9B": "gaai1",
    "\u9D9C": "maau4",
    "\u9D9D": "fuk1",
    "\u9D9E": "ceon1",
    "\u9D9F": "dat6",
    "\u9DA0": "jin2/aan3/ngaan3",
    "\u9DA1": "hot3",
    "\u9DA2": "wun4",
    "\u9DA3": "pin1",
    "\u9DA4": "kwan1",
    "\u9DA5": "mei4",
    "\u9DA6": "wu4",
    "\u9DA7": "jing1",
    "\u9DA8": "cyun3",
    "\u9DA9": "mou6",
    "\u9DAA": "gwik1",
    "\u9DAB": "gaan2",
    "\u9DAC": "cong1/coeng1",
    "\u9DAD": "fong2",
    "\u9DAE": "hok6",
    "\u9DAF": "ang1/ngang1",
    "\u9DB0": "jyun4",
    "\u9DB1": "hin1",
    "\u9DB2": "jung1",
    "\u9DB3": "si1",
    "\u9DB4": "hok6/hok2",
    "\u9DB5": "co1/co4",
    "\u9DB6": "tong4",
    "\u9DB7": "hat6",
    "\u9DB8": "joek6",
    "\u9DB9": "lau4",
    "\u9DBA": "zik3/zek3",
    "\u9DBB": "gwat1/wat6",
    "\u9DBC": "gim1",
    "\u9DBD": "zeon2",
    "\u9DBE": "hon6",
    "\u9DBF": "ci4",
    "\u9DC0": "ci4",
    "\u9DC1": "jik6",
    "\u9DC2": "jiu6/jiu2/jiu4",
    "\u9DC3": "aan3/ngaan3",
    "\u9DC4": "gai1",
    "\u9DC5": "leot6",
    "\u9DC6": "tin4",
    "\u9DC7": "kau3/gau3",
    "\u9DC8": "tai1",
    "\u9DC9": "tai1",
    "\u9DCA": "jik6",
    "\u9DCB": "tou4",
    "\u9DCC": "maa5",
    "\u9DCD": "hiu1",
    "\u9DCE": "gou1",
    "\u9DCF": "tin4",
    "\u9DD0": "san4",
    "\u9DD1": "gap6",
    "\u9DD2": "tyun4",
    "\u9DD3": "ze3",
    "\u9DD4": "ngou4/ou4",
    "\u9DD5": "jiu5/jiu6/wai5",
    "\u9DD6": "ji1",
    "\u9DD7": "au1/ngau1",
    "\u9DD8": "cik1",
    "\u9DD9": "zi3",
    "\u9DDA": "lau6",
    "\u9DDB": "jung4",
    "\u9DDC": "leoi4",
    "\u9DDD": "bat1",
    "\u9DDE": "soeng1",
    "\u9DDF": "zok6",
    "\u9DE0": "jyu4",
    "\u9DE1": "mou4",
    "\u9DE2": "kyut3",
    "\u9DE3": "jam4",
    "\u9864": "jiu4",
    "\u9865": "hou6",
    "\u9866": "ciu4",
    "\u9867": "gu3/gwu3",
    "\u9868": "seon3",
    "\u9869": "jim5",
    "\u986A": "fui3",
    "\u986B": "zin3",
    "\u986C": "jyu4",
    "\u986D": "mang6",
    "\u986E": "ban1",
    "\u986F": "hin2",
    "\u9870": "pan4",
    "\u9871": "lou4",
    "\u9872": "lam5",
    "\u9873": "nip6/lip6",
    "\u9874": "kyun4",
    "\u9875": "jip6",
    "\u9876": "ding2/deng2",
    "\u9877": "king2/king1",
    "\u9878": "hon1",
    "\u9879": "hong6/hong2",
    "\u987A": "seon6/seon2",
    "\u987B": "seoi1/sou1",
    "\u987C": "juk1",
    "\u987D": "waan4",
    "\u987E": "gu3/gwu3",
    "\u987F": "deon6/deon2/duk6",
    "\u9880": "kei4",
    "\u9881": "baan1/paan1",
    "\u9882": "zung6",
    "\u9883": "hong4",
    "\u9884": "jyu6",
    "\u9885": "lou4",
    "\u9886": "ling5/leng5/leng2",
    "\u9887": "po2/po1",
    "\u9888": "geng2",
    "\u9889": "kit3/git3",
    "\u988A": "gaap3/haap3",
    "\u988B": "ting5",
    "\u988C": "hap6/gap3",
    "\u988D": "wing6",
    "\u988E": "gwing2/gang2",
    "\u988F": "hoi4/hoi5",
    "\u9890": "ji4",
    "\u9891": "pan4/ban1",
    "\u9892": "fui3",
    "\u9893": "teoi4",
    "\u9894": "ham5",
    "\u9895": "wing6",
    "\u9896": "wing6",
    "\u9897": "fo2",
    "\u9898": "tai4/tai2",
    "\u9899": "jung4",
    "\u989A": "ngok6/ok6/ngok2/ok2",
    "\u989B": "zyun1",
    "\u989C": "ngaan4/aan4",
    "\u989D": "ngaak6/aak6/ngaak2/aak2",
    "\u989E": "nip6/lip6",
    "\u989F": "mun4/mun1",
    "\u98A0": "din1",
    "\u98A1": "song2",
    "\u98A2": "hou6",
    "\u98A3": "leoi6",
    "\u98A4": "zin3",
    "\u98A5": "jyu4",
    "\u98A6": "pan4",
    "\u98A7": "kyun4",
    "\u98A8": "fung1/fung3",
    "\u98A9": "biu1",
    "\u98AA": "haa6",
    "\u98AB": "fu4",
    "\u98AC": "haa1",
    "\u98AD": "zim2",
    "\u98AE": "paau4/biu1",
    "\u98AF": "saap3",
    "\u98B0": "bat6",
    "\u98B1": "toi4",
    "\u98B2": "lit6",
    "\u98B3": "gwaat3",
    "\u98B4": "syun4",
    "\u98B5": "saau1",
    "\u98B6": "geoi6",
    "\u98B7": "biu1",
    "\u98B8": "si1",
    "\u98B9": "wai5",
    "\u98BA": "joeng4",
    "\u98BB": "jiu4",
    "\u98BC": "sau1",
    "\u98BD": "hoi2",
    "\u98BE": "sau1",
    "\u98BF": "faan4",
    "\u98C0": "lau4",
    "\u98C1": "zaap6",
    "\u98C2": "lau4/lau6/liu4",
    "\u98C3": "piu1",
    "\u98C4": "piu1",
    "\u98C5": "lau4",
    "\u98C6": "biu1",
    "\u98C7": "biu1",
    "\u98C8": "biu1",
    "\u98C9": "liu4",
    "\u98CA": "biu1",
    "\u98CB": "sat1",
    "\u98CC": "fung1/fung3",
    "\u98CD": "haau1",
    "\u98CE": "fung1/fung3",
    "\u98CF": "joeng4",
    "\u98D0": "zim2",
    "\u98D1": "paau4/biu1",
    "\u98D2": "saap3",
    "\u98D3": "geoi6",
    "\u98D4": "si1",
    "\u98D5": "sau1",
    "\u98D6": "jiu4",
    "\u98D7": "lau4",
    "\u98D8": "piu1",
    "\u98D9": "biu1",
    "\u98DA": "biu1",
    "\u98DB": "fei1",
    "\u98DC": "faan1",
    "\u98DD": "fei1",
    "\u98DE": "fei1",
    "\u98DF": "sik6/sik2/zi6/ji6",
    "\u98E0": "sik6.zi6.bin1",
    "\u98E1": "syun1/caan1",
    "\u98E2": "gei1",
    "\u98E3": "ding3",
    "\u98E4": "zi6",
    "\u98E5": "tok3",
    "\u98E6": "zin1/zi1",
    "\u98E7": "syun1",
    "\u98E8": "hoeng2",
    "\u98E9": "tan1/tan4",
    "\u98EA": "jam6/jam5",
    "\u98EB": "jyu3",
    "\u98EC": "gyun3",
    "\u98ED": "cik1/sik1",
    "\u98EE": "jam2/jam3",
    "\u98EF": "faan6/faan2",
    "\u98F0": "faan6",
    "\u98F1": "syun1",
    "\u98F2": "jam2/jam3",
    "\u98F3": "tau2",
    "\u98F4": "ji4/zi6",
    "\u98F5": "zok6/zok3",
    "\u98F6": "bit6/bit1",
    "\u98F7": "ze2",
    "\u98F8": "tou1",
    "\u98F9": "baau2",
    "\u98FA": "ci1",
    "\u98FB": "tit3",
    "\u98FC": "zi6",
    "\u98FD": "baau2",
    "\u98FE": "sik1/cik1",
    "\u98FF": "deot1",
    "\u9900": "hoi3",
    "\u9901": "jam6/jam5",
    "\u9902": "tim5/tim2/tim4",
    "\u9903": "gaau2",
    "\u9904": "gaap3/hap6",
    "\u9905": "beng2/bing2",
    "\u9906": "jiu4",
    "\u9907": "tung4",
    "\u9908": "ci4",
    "\u9909": "hoeng2",
    "\u990A": "joeng5/joeng6",
    "\u990B": "gyun3",
    "\u990C": "nei6/lei6",
    "\u990D": "jim3",
    "\u990E": "lok3",
    "\u990F": "si1",
    "\u9910": "caan1",
    "\u9911": "but6",
    "\u9912": "neoi5/leoi5/noi5/loi5",
    "\u9913": "ngo6/o6",
    "\u9914": "bou1/bou3",
    "\u9915": "zeon3",
    "\u9916": "dau6",
    "\u9917": "cuk1",
    "\u9918": "jyu4",
    "\u9919": "sik1",
    "\u991A": "ngaau4/aau4",
    "\u991B": "wan4",
    "\u991C": "gwo2/go2",
    "\u991D": "sik1",
    "\u991E": "zin3",
    "\u991F": "zeoi3/zyut3",
    "\u9920": "beng2/bing2",
    "\u9921": "haam2/haam6",
    "\u9922": "bau6",
    "\u9923": "jip3",
    "\u9924": "daam6/taam4",
    "\u9925": "fei1",
    "\u9926": "zoeng1",
    "\u9927": "neoi5/leoi5/noi5/loi5/wai3",
    "\u9928": "gun2/gwun2",
    "\u9929": "ak1/ngak1",
    "\u992A": "nyun5/lyun5",
    "\u992B": "wan6/wan4",
    "\u992C": "wu4",
    "\u992D": "wong4",
    "\u992E": "tit3",
    "\u992F": "fui3",
    "\u9930": "gin1",
    "\u9931": "hau4",
    "\u9932": "aai3/ngaai3/aat3/ngaat3/hot3",
    "\u9933": "cing4/tong4",
    "\u9934": "ban1/fan1",
    "\u9935": "wai3",
    "\u9936": "gwat1",
    "\u9937": "caa4",
    "\u9938": "sung3",
    "\u9939": "tong4",
    "\u993A": "bok3",
    "\u993B": "gou1",
    "\u993C": "hei3",
    "\u993D": "gwai6/gwai3",
    "\u993E": "lau6/lau4",
    "\u993F": "sau1/suk1",
    "\u9940": "tou4",
    "\u9941": "jip3",
    "\u9942": "wan1",
    "\u9943": "mo4",
    "\u9944": "tong4",
    "\u9945": "maan6/maan4",
    "\u9946": "bat1",
    "\u9947": "jyu3",
    "\u9948": "sau1",
    "\u9949": "gan2",
    "\u994A": "saan2",
    "\u994B": "gwai6/gwai3",
    "\u994C": "zaan6/syun2",
    "\u994D": "sin6",
    "\u994E": "ci3",
    "\u994F": "daam6",
    "\u9950": "ji3/jik1",
    "\u9951": "gei1",
    "\u9952": "jiu4",
    "\u9953": "caang1",
    "\u9954": "jung1",
    "\u9955": "tou1",
    "\u9956": "wai3",
    "\u9957": "hoeng2",
    "\u9958": "zin1",
    "\u9959": "fan1",
    "\u995A": "hoi3",
    "\u995B": "mung4",
    "\u995C": "jim3",
    "\u995D": "mo4",
    "\u995E": "caam4",
    "\u995F": "hoeng2",
    "\u9960": "lo4",
    "\u9961": "zaan3",
    "\u9962": "nong4/long4/nong5/long5",
    "\u9963": "gaan2.faa3.sik6.zi6.bin1",
    "\u9964": "ding3",
    "\u9965": "gei1",
    "\u9966": "tok3",
    "\u9967": "cing4/tong4",
    "\u9968": "tan1/tan4",
    "\u9969": "hei3",
    "\u996A": "jam6/jam5",
    "\u996B": "jyu3",
    "\u996C": "cik1/sik1",
    "\u996D": "faan6/faan2",
    "\u996E": "jam2/jam3",
    "\u996F": "zin3",
    "\u9970": "sik1/cik1",
    "\u9971": "baau2",
    "\u9972": "zi6",
    "\u9973": "deot1",
    "\u9974": "ji4/zi6",
    "\u9975": "nei6/lei6",
    "\u9976": "jiu4",
    "\u9977": "hoeng2",
    "\u9978": "gaap3/hap6",
    "\u9979": "lok3",
    "\u997A": "gaau2",
    "\u997B": "si1",
    "\u997C": "beng2/bing2",
    "\u997D": "but6",
    "\u997E": "dau6",
    "\u997F": "ngo6/o6",
    "\u9980": "jyu4",
    "\u9981": "neoi5/leoi5/noi5/loi5",
    "\u9982": "zeon3",
    "\u9983": "gwo2/go2",
    "\u9984": "wan4",
    "\u9985": "haam2/haam6",
    "\u9986": "gun2/gwun2",
    "\u9987": "caa4",
    "\u9988": "gwai6/gwai3",
    "\u9989": "gwat1",
    "\u998A": "sau1/suk1",
    "\u998B": "caam4",
    "\u998C": "jip3",
    "\u998D": "mo4",
    "\u998E": "bok3",
    "\u998F": "lau6/lau4",
    "\u9990": "sau1",
    "\u9991": "gan2",
    "\u9992": "maan6/maan4",
    "\u9993": "saan2",
    "\u9994": "zaan6/syun2",
    "\u9995": "nong4/long4/nong5/long5",
    "\u9996": "sau2",
    "\u9997": "kwai4",
    "\u9998": "gwok3/gok3/gwik1",
    "\u9999": "hoeng1",
    "\u999A": "fan4",
    "\u999B": "bat6",
    "\u999C": "nei5/lei5",
    "\u999D": "bit6/bat6",
    "\u999E": "but6",
    "\u999F": "tou4",
    "\u99A0": "ham4",
    "\u99A1": "fei1",
    "\u99A2": "zin1",
    "\u99A3": "am1/ngam1",
    "\u99A4": "oi3/ngoi3",
    "\u99A5": "fuk1",
    "\u99A6": "him1",
    "\u99A7": "wan1",
    "\u99A8": "hing1",
    "\u99A9": "fan4",
    "\u99AA": "pan1",
    "\u99AB": "hing1",
    "\u99AC": "maa5/maa1",
    "\u99AD": "jyu6",
    "\u99AE": "fung4/pang4",
    "\u99AF": "hon6/hon4",
    "\u99B0": "dik1",
    "\u99B1": "to4/do6",
    "\u99B2": "tok3",
    "\u99B3": "ci4",
    "\u99B4": "seon4/ceon4",
    "\u99B5": "zyu3",
    "\u99B6": "zi1",
    "\u99B7": "pui3",
    "\u99B8": "jan6",
    "\u99B9": "jat6",
    "\u99BA": "saap3",
    "\u99BB": "wan5",
    "\u99BC": "man4",
    "\u99BD": "zap1",
    "\u99BE": "daam3",
    "\u99BF": "lou4",
    "\u99C0": "jau6",
    "\u99C1": "bok3",
    "\u99C2": "bou2",
    "\u99C3": "kyut3/faai3",
    "\u99C4": "to4",
    "\u99C5": "jik6",
    "\u99C6": "keoi1",
    "\u99C7": "man4",
    "\u99C8": "keoi1",
    "\u99C9": "gwing1",
    "\u99CA": "po2",
    "\u99CB": "ziu1",
    "\u99CC": "jyun1",
    "\u99CD": "pei4",
    "\u99CE": "zau6",
    "\u99CF": "geoi6",
    "\u99D0": "zyu3",
    "\u99D1": "nou4/lou4",
    "\u99D2": "keoi1",
    "\u99D3": "pei1",
    "\u99D4": "zou2/zong2/cong2",
    "\u99D5": "gaa3/gaa2",
    "\u99D6": "ling4",
    "\u99D7": "can2",
    "\u99D8": "toi4/toi5",
    "\u99D9": "fu6",
    "\u99DA": "joeng2",
    "\u99DB": "sai2",
    "\u99DC": "bat6/bit1",
    "\u99DD": "to4/to2",
    "\u99DE": "to4",
    "\u99DF": "si3",
    "\u99E0": "lau4",
    "\u99E1": "maa6/maa3",
    "\u99E2": "pin4/ping4",
    "\u99E3": "tou4",
    "\u99E4": "zi3",
    "\u99E5": "jung4",
    "\u99E6": "tang4",
    "\u99E7": "dung6",
    "\u99E8": "seon1",
    "\u99E9": "cyun1",
    "\u99EA": "san1",
    "\u99EB": "gwing1",
    "\u99EC": "ji5",
    "\u99ED": "haai5/hoi5",
    "\u99EE": "bok3",
    "\u99EF": "zyu1",
    "\u99F0": "jan1",
    "\u99F1": "lok3/lok6",
    "\u99F2": "zau1",
    "\u99F3": "daan6",
    "\u99F4": "haai5",
    "\u99F5": "lau4",
    "\u99F6": "guk6",
    "\u99F7": "sung2",
    "\u99F8": "cam1",
    "\u99F9": "mong4",
    "\u99FA": "long4",
    "\u99FB": "hon6",
    "\u99FC": "tou4",
    "\u99FD": "hyun1",
    "\u99FE": "teoi3",
    "\u99FF": "zeon3",
    "\u9A00": "ngo5/o5",
    "\u9A01": "cing2/ping3",
    "\u9A02": "sing1",
    "\u9A03": "zi6/ngoi4/oi4/daai1",
    "\u9A04": "luk6",
    "\u9A05": "zeoi1",
    "\u9A06": "zau1",
    "\u9A07": "se3",
    "\u9A08": "pin4/ping4",
    "\u9A09": "kwan1",
    "\u9A0A": "tou4",
    "\u9A0B": "loi4",
    "\u9A0C": "zung1",
    "\u9A0D": "fo3",
    "\u9A0E": "ke4/kei4/kei3/gei6",
    "\u9A0F": "kei4",
    "\u9A10": "jim6",
    "\u9A11": "fei1",
    "\u9A12": "sou1",
    "\u9A13": "jim6",
    "\u9A14": "got3",
    "\u9A15": "jiu5",
    "\u9A16": "mou6",
    "\u9A17": "pin3",
    "\u9A18": "cung1",
    "\u9A19": "pin3",
    "\u9A1A": "cin4",
    "\u9A1B": "fei1",
    "\u9A1C": "wong4",
    "\u9A1D": "kin4",
    "\u9A1E": "waak6",
    "\u9A1F": "jyu4",
    "\u9A20": "tai4",
    "\u9A21": "cyun1",
    "\u9A22": "haa4",
    "\u9A23": "zung1",
    "\u9A24": "kwai4",
    "\u9A25": "jau4",
    "\u9A26": "si1",
    "\u9A27": "waa1",
    "\u9A28": "to4",
    "\u9A29": "gwai1/kwai3",
    "\u9A2A": "sau1",
    "\u9A2B": "hin1",
    "\u9A2C": "sing4",
    "\u9A2D": "zat1",
    "\u9A2E": "lau4/lau1",
    "\u9A2F": "paang4",
    "\u9A30": "tang4",
    "\u9A31": "hai4",
    "\u9A32": "cou2",
    "\u9A33": "duk6",
    "\u9A34": "aan3/ngaan3",
    "\u9A35": "jyun4",
    "\u9A36": "zau1",
    "\u9A37": "sou1",
    "\u9A38": "sin3",
    "\u9A39": "kei4",
    "\u9A3A": "zi3",
    "\u9A3B": "soeng1",
    "\u9A3C": "luk6",
    "\u9A3D": "zaap6",
    "\u9A3E": "leoi4/lo4",
    "\u9A3F": "zoeng1",
    "\u9A40": "mak6",
    "\u9A41": "ngou4/ou4",
    "\u9A42": "caam1",
    "\u9A43": "biu1/piu3",
    "\u9A44": "cung1",
    "\u9A45": "keoi1",
    "\u9A46": "bit1",
    "\u9A47": "ngai6/ai6",
    "\u9A48": "wat6",
    "\u9A49": "heoi1",
    "\u9A4A": "waa4",
    "\u9A4B": "but3",
    "\u9A4C": "suk1",
    "\u9A4D": "hiu1",
    "\u9A4E": "leon4",
    "\u9A4F": "zaan2",
    "\u9A50": "deon1",
    "\u9A51": "lau4",
    "\u9A52": "to4/taan4",
    "\u9A53": "cang4",
    "\u9A54": "tim5",
    "\u9A55": "giu1",
    "\u9A56": "tit3",
    "\u9A57": "jim6",
    "\u9A58": "leoi4/lo4",
    "\u9A59": "zin1",
    "\u9A5A": "ging1/geng1",
    "\u9A5B": "jik6",
    "\u9A5C": "jip6",
    "\u9A5D": "tok3",
    "\u9A5E": "pan1",
    "\u9A5F": "zaau6/zau6",
    "\u9A60": "jin3",
    "\u9A61": "lung4",
    "\u9A62": "lou4/leoi4/leoi2",
    "\u9A63": "tang4",
    "\u9A64": "soeng1",
    "\u9A65": "kei3",
    "\u9A66": "soeng1",
    "\u9A67": "guk6",
    "\u9A68": "kwai4",
    "\u9A69": "fun1",
    "\u9A6A": "lei4",
    "\u9A6B": "biu1",
    "\u9A6C": "maa5/maa1",
    "\u9A6D": "jyu6",
    "\u9A6E": "to4/do6",
    "\u9A6F": "seon4/ceon4",
    "\u9A70": "ci4",
    "\u9A71": "keoi1",
    "\u9A72": "jat6",
    "\u9A73": "bok3",
    "\u9A74": "lou4/leoi4/leoi2",
    "\u9A75": "zou2/zong2/cong2",
    "\u9A76": "sai2",
    "\u9A77": "si3",
    "\u9A78": "fu6",
    "\u9A79": "keoi1",
    "\u9A7A": "zau1",
    "\u9A7B": "zyu3",
    "\u9A7C": "to4/to2",
    "\u9A7D": "nou4/lou4",
    "\u9A7E": "gaa3/gaa2",
    "\u9A7F": "jik6",
    "\u9A80": "toi4/toi5",
    "\u9A81": "hiu1",
    "\u9A82": "maa6/maa3",
    "\u9A83": "jan1",
    "\u9A84": "giu1",
    "\u9A85": "waa4",
    "\u9A86": "lok3/lok6",
    "\u9A87": "haai5/hoi5",
    "\u9A88": "pin4/ping4",
    "\u9A89": "biu1",
    "\u9A8A": "lei4",
    "\u9A8B": "cing2/ping3",
    "\u9A8C": "jim6",
    "\u9A8D": "sing1",
    "\u9A8E": "cam1",
    "\u9A8F": "zeon3",
    "\u9A90": "kei4",
    "\u9A91": "ke4/kei4/kei3/gei6",
    "\u9A92": "fo3",
    "\u9A93": "zeoi1",
    "\u9A94": "zung1",
    "\u9A95": "suk1",
    "\u9A96": "caam1",
    "\u9A97": "pin3",
    "\u9A98": "zat1",
    "\u9A99": "kwai4",
    "\u9A9A": "sou1",
    "\u9A9B": "mou6",
    "\u9A9C": "ngou4/ou4",
    "\u9A9D": "lau4/lau1",
    "\u9A9E": "hin1",
    "\u9A9F": "sin3",
    "\u9AA0": "biu1/piu3",
    "\u9AA1": "leoi4/lo4",
    "\u9AA2": "cung1",
    "\u9AA3": "zaan2",
    "\u9AA4": "zaau6/zau6",
    "\u9AA5": "kei3",
    "\u9AA6": "soeng1",
    "\u9AA7": "soeng1",
    "\u9AA8": "gwat1",
    "\u9AA9": "wai2",
    "\u9AAA": "wai2",
    "\u9AAB": "wai2",
    "\u9AAC": "jyu4",
    "\u9AAD": "gon3",
    "\u9AAE": "jik6",
    "\u9AAF": "kon3/ong1/ngong1/ong3/ngong3",
    "\u9AB0": "sik1/tau4/gu2/gwu2",
    "\u9AB1": "gaai3/haai6",
    "\u9AB2": "baau6",
    "\u9AB3": "bei6",
    "\u9AB4": "ci1",
    "\u9AB5": "tai2",
    "\u9AB6": "dai2",
    "\u9AB7": "fu1",
    "\u9AB8": "haai4/hoi4",
    "\u9AB9": "haau1",
    "\u9ABA": "hau4",
    "\u9ABB": "kwaa3/kwaa2",
    "\u9ABC": "gaak3",
    "\u9ABD": "teoi2",
    "\u9ABE": "gang2/kang2",
    "\u9ABF": "pin4",
    "\u9AC0": "bei2",
    "\u9AC1": "fo1/kwaa3",
    "\u9AC2": "kaa3",
    "\u9AC3": "jyu4",
    "\u9AC4": "seoi5",
    "\u9AC5": "lau4",
    "\u9AC6": "bok3/bok6/pok3",
    "\u9AC7": "haau1/hou1",
    "\u9AC8": "bong2",
    "\u9AC9": "bok1",
    "\u9ACA": "ci1",
    "\u9ACB": "fun1",
    "\u9ACC": "ban3",
    "\u9ACD": "mo4",
    "\u9ACE": "liu4",
    "\u9ACF": "lau4",
    "\u9AD0": "haau1",
    "\u9AD1": "duk6",
    "\u9AD2": "zong1/zong3",
    "\u9AD3": "seoi5/seoi2",
    "\u9AD4": "tai2",
    "\u9AD5": "ban3",
    "\u9AD6": "fun1",
    "\u9AD7": "lou4",
    "\u9AD8": "gou1",
    "\u9AD9": "gou1",
    "\u9ADA": "hiu3",
    "\u9ADB": "hou1",
    "\u9ADC": "hiu2",
    "\u9ADD": "lou4",
    "\u9ADE": "cou3",
    "\u9ADF": "biu1/faat3.zi6.tau4",
    "\u9AE0": "kwan1",
    "\u9AE1": "kwan1",
    "\u9AE2": "tai3",
    "\u9AE3": "fong2",
    "\u9AE4": "jau1",
    "\u9AE5": "jim4",
    "\u9AE6": "mou4/mou1",
    "\u9AE7": "daam6/dam3",
    "\u9AE8": "kwan1",
    "\u9AE9": "ban3",
    "\u9AEA": "faat3",
    "\u9AEB": "tiu4",
    "\u9AEC": "pei1",
    "\u9AED": "zi1",
    "\u9AEE": "faat3",
    "\u9AEF": "jim4",
    "\u9AF0": "tai3",
    "\u9AF1": "baau6",
    "\u9AF2": "bei6",
    "\u9AF3": "maau4/mau4",
    "\u9AF4": "fai3/fat1",
    "\u9AF5": "ji4",
    "\u9AF6": "jung4",
    "\u9AF7": "kuk1",
    "\u9AF8": "gung1",
    "\u9AF9": "jau1",
    "\u9AFA": "kut3/kwut3",
    "\u9AFB": "gai3/gai2",
    "\u9AFC": "pung4",
    "\u9AFD": "zaa1",
    "\u9AFE": "saau1",
    "\u9AFF": "so1/saa1",
    "\u9B00": "tai3",
    "\u9B01": "lei1",
    "\u9B02": "ban3",
    "\u9B03": "zung1",
    "\u9B04": "tai3",
    "\u9B05": "pang4",
    "\u9B06": "sung1",
    "\u9B07": "zang1/zaang1",
    "\u9B08": "kyun4",
    "\u9B09": "zung1",
    "\u9B0A": "seon3",
    "\u9B0B": "zin1/zin2",
    "\u9B0C": "do2/do6/ceoi4",
    "\u9B0D": "wu4",
    "\u9B0E": "laat3/laat6",
    "\u9B0F": "zau1/cau1",
    "\u9B10": "kei4",
    "\u9B11": "lim4",
    "\u9B12": "can2/zan2",
    "\u9B13": "ban3",
    "\u95FF": "hoi2",
    "\u9600": "fat6",
    "\u9601": "gok3/gok2",
    "\u9602": "hat6/goi1/ngoi6/oi6",
    "\u9603": "kwan2",
    "\u9604": "gau1",
    "\u9605": "jyut6",
    "\u9606": "long6/long4/long5",
    "\u9607": "dou1/se4/ze1",
    "\u9608": "wik6",
    "\u9609": "jim1",
    "\u960A": "coeng1",
    "\u960B": "jik1",
    "\u960C": "man4",
    "\u960D": "fan1",
    "\u960E": "jim4",
    "\u960F": "aat3/ngaat3/aat1/ngaat1/jin1",
    "\u9610": "zin2/cin2/sin6",
    "\u9611": "laan4",
    "\u9612": "gwik1",
    "\u9613": "kui2/kwui2/gwai6",
    "\u9614": "fut3",
    "\u9615": "kyut3",
    "\u9616": "hap6",
    "\u9617": "tin4",
    "\u9618": "taap3/daap6",
    "\u9619": "kyut3/gwat6",
    "\u961A": "ham3/haam3/haam2",
    "\u961B": "waan4",
    "\u961C": "fau6",
    "\u961D": "ji5.zai2.bin1",
    "\u961E": "lak6",
    "\u961F": "deoi6/deoi2/zeoi6",
    "\u9620": "seon3",
    "\u9621": "cin1",
    "\u9622": "ngat6/at6",
    "\u9623": "goi3",
    "\u9624": "zi6/to4/ji5",
    "\u9625": "jam1",
    "\u9626": "joeng4",
    "\u9627": "dau2",
    "\u9628": "aai3/ai3/ngai3/ngaai3/ak1/aak1/ngaak1/ngak1",
    "\u9629": "sing1",
    "\u962A": "baan2/faan2",
    "\u962B": "pei1/pui4",
    "\u962C": "gong1/gon1/haang1",
    "\u962D": "wan5",
    "\u962E": "jyun2/jyun5",
    "\u962F": "zi2",
    "\u9630": "pei4",
    "\u9631": "zing6/zeng2/zeng6",
    "\u9632": "fong4",
    "\u9633": "joeng4/joeng2",
    "\u9634": "jam1/jam3/am1/ngam1",
    "\u9635": "zan6/zan2",
    "\u9636": "gaai1",
    "\u9637": "cing1",
    "\u9638": "ak1/aak1/ngaak1/ngak1/aai3/ai3/ngai3/ngaai3",
    "\u9639": "keoi1",
    "\u963A": "dai2",
    "\u963B": "zo2",
    "\u963C": "zou6",
    "\u963D": "dim3/jim4",
    "\u963E": "ling5",
    "\u963F": "aa3/ngaa3/o1/ngo1/aa2/ngaa2",
    "\u9640": "to4/to2",
    "\u9641": "to4/ji5",
    "\u9642": "bei1/po1/pei4",
    "\u9643": "bing2",
    "\u9644": "fu6",
    "\u9645": "zai3",
    "\u9646": "luk6",
    "\u9647": "lung5",
    "\u9648": "can4/can2/zan6",
    "\u9649": "jing4/ging3",
    "\u964A": "do6/to5",
    "\u964B": "lau6",
    "\u964C": "mak6",
    "\u964D": "gong3/hong4",
    "\u964E": "syu4",
    "\u964F": "do6",
    "\u9650": "haan6",
    "\u9651": "ji4",
    "\u9652": "gwai2",
    "\u9653": "jyu1/wu1",
    "\u9654": "goi1",
    "\u9655": "sim2",
    "\u9656": "zeon3",
    "\u9657": "ciu3",
    "\u9658": "jing4/ging3",
    "\u9659": "seon4",
    "\u965A": "fu3",
    "\u965B": "bai6",
    "\u965C": "haap6/haap3",
    "\u965D": "sim2",
    "\u965E": "sing1",
    "\u965F": "zik1",
    "\u9660": "pou1",
    "\u9661": "dau2",
    "\u9662": "jyun2/jyun6",
    "\u9663": "zan6/zan2",
    "\u9664": "ceoi4/cyu4",
    "\u9665": "haam6",
    "\u9666": "dou2",
    "\u9667": "nip6/lip6/nit6/lit6",
    "\u9668": "wan5/jyun4",
    "\u9669": "him2",
    "\u966A": "pui4",
    "\u966B": "fei2",
    "\u966C": "zau1",
    "\u966D": "kei1/ji2",
    "\u966E": "deoi6",
    "\u966F": "leon4",
    "\u9670": "jam1/jam3/am1/ngam1",
    "\u9671": "guk1",
    "\u9672": "seoi4",
    "\u9673": "can4/can2/zan6",
    "\u9674": "pei4",
    "\u9675": "ling4",
    "\u9676": "tou4/jiu4",
    "\u9677": "haam6/ham6",
    "\u9678": "luk6",
    "\u9679": "sing1",
    "\u967A": "him2",
    "\u967B": "jan1",
    "\u967C": "zyu2",
    "\u967D": "joeng4/joeng2",
    "\u967E": "jing4",
    "\u967F": "haap6/haap3/hap6/gip6",
    "\u9680": "cung4",
    "\u9681": "jin2",
    "\u9682": "jam1/jam3/am1/ngam1",
    "\u9683": "jyu4",
    "\u9684": "tai4",
    "\u9685": "jyu4/jyu6",
    "\u9686": "lung4",
    "\u9687": "wai1",
    "\u9688": "wui1",
    "\u9689": "nip6/lip6/nit6/lit6",
    "\u968A": "deoi6/deoi2/zeoi6",
    "\u968B": "ceoi4/do6",
    "\u968C": "am2/ngam2",
    "\u968D": "wong4",
    "\u968E": "gaai1",
    "\u968F": "ceoi4",
    "\u9690": "jan2",
    "\u9691": "kei4/goi1",
    "\u9692": "jim5/jim2",
    "\u9693": "fai1",
    "\u9694": "gaak3/gik1",
    "\u9695": "wan5/jyun4",
    "\u9696": "wu2/ou3/ngou3",
    "\u9697": "ngai5/ai5/ngaai5/aai5/wai5/kwai4",
    "\u9698": "aai3/ai3/ngai3/ngaai3",
    "\u9699": "gwik1/kwik1",
    "\u969A": "tong4",
    "\u969B": "zai3",
    "\u969C": "zoeng3",
    "\u969D": "dou2",
    "\u969E": "ngou4/ou4",
    "\u969F": "gwik1/kwik1",
    "\u96A0": "jan2",
    "\u96A1": "saat3",
    "\u96A2": "jiu5",
    "\u96A3": "leon4",
    "\u96A4": "teoi4",
    "\u96A5": "dang3",
    "\u96A6": "pei4",
    "\u96A7": "seoi6",
    "\u96A8": "ceoi4",
    "\u96A9": "juk1/ou3/ngou3",
    "\u96AA": "him2",
    "\u96AB": "fan4",
    "\u96AC": "nei5/lei5",
    "\u96AD": "ji4",
    "\u96AE": "zai1",
    "\u96AF": "dou2",
    "\u96B0": "zaap6",
    "\u96B1": "jan2",
    "\u96B2": "zat1",
    "\u96B3": "fai1/fui1",
    "\u96B4": "lung5",
    "\u96B5": "hei1",
    "\u96B6": "dai6/doi6/lai6",
    "\u96B7": "dai6",
    "\u96B8": "dai6/doi6/lai6",
    "\u96B9": "zeoi1",
    "\u96BA": "hok6",
    "\u96BB": "zek3",
    "\u96BC": "zeon2",
    "\u96BD": "zeon3/syun5",
    "\u96BE": "naan4/laan4/naan6/laan6/no4/lo4",
    "\u96BF": "jik6",
    "\u96C0": "zoek3/zoek2",
    "\u96C1": "ngaan6/aan6/ngaan2/aan2",
    "\u96C2": "kam4",
    "\u96C3": "hin1",
    "\u96C4": "hung4",
    "\u96C5": "ngaa5/aa5",
    "\u96C6": "zaap6/zaap2/zap6",
    "\u96C7": "gu3/gwu3",
    "\u96C8": "wun4",
    "\u96C9": "zi6",
    "\u96CA": "gau3",
    "\u96CB": "zeon3/syun5",
    "\u96CC": "ci1",
    "\u96CD": "jung1",
    "\u96CE": "zeoi1",
    "\u96CF": "co1/co4",
    "\u96D0": "fu1",
    "\u96D1": "zaap6",
    "\u96D2": "lok3",
    "\u96D3": "jyu4",
    "\u96D4": "cau4",
    "\u96D5": "diu1",
    "\u96D6": "seoi1",
    "\u96D7": "hon6",
    "\u96D8": "wok3",
    "\u96D9": "soeng1/sung1",
    "\u96DA": "gun3/gwun3",
    "\u96DB": "co1/co4",
    "\u96DC": "zaap6/zaap2",
    "\u96DD": "jung1",
    "\u96DE": "gai1",
    "\u96DF": "kwai1",
    "\u96E0": "cau4/sau4",
    "\u96E1": "lau6",
    "\u96E2": "lei4",
    "\u96E3": "naan4/laan4/naan6/laan6/no4/lo4",
    "\u96E4": "hok6",
    "\u96E5": "zaap6",
    "\u96E6": "zaap6",
    "\u96E7": "zaap6/zap6",
    "\u96E8": "jyu5/jyu6",
    "\u96E9": "jyu4/jyu6",
    "\u96EA": "syut3",
    "\u96EB": "no5/lo5",
    "\u96EC": "fau2",
    "\u96ED": "saap3",
    "\u96EE": "muk6",
    "\u96EF": "man4/man2",
    "\u96F0": "fan1",
    "\u96F1": "pong1/pong4",
    "\u96F2": "wan4/wan2",
    "\u96F3": "lik1/lik6",
    "\u96F4": "cap1",
    "\u96F5": "joeng1",
    "\u96F6": "ling4/leng4/ling1/ling2",
    "\u96F7": "leoi4",
    "\u96F8": "ngam4/am4",
    "\u96F9": "bok6",
    "\u96FA": "mung4/mung6/mou6",
    "\u96FB": "din6",
    "\u96FC": "dong6",
    "\u96FD": "wu6",
    "\u96FE": "mou6",
    "\u96FF": "diu6",
    "\u9700": "seoi1",
    "\u9701": "zai3",
    "\u9702": "muk6",
    "\u9703": "cam4",
    "\u9704": "siu1",
    "\u9705": "zip3/saap3",
    "\u9706": "ting4",
    "\u9707": "zan3",
    "\u9708": "pui3",
    "\u9709": "mui4/mei4",
    "\u970A": "ling4",
    "\u970B": "cai1",
    "\u970C": "zau1",
    "\u970D": "fok3",
    "\u970E": "saap3",
    "\u970F": "fei1",
    "\u9710": "wang4",
    "\u9711": "zim1",
    "\u9712": "jam1",
    "\u9713": "ngai4/ai4",
    "\u9714": "zyu3",
    "\u9715": "tyun4",
    "\u9716": "lam4",
    "\u9717": "ling4",
    "\u9718": "dung6",
    "\u9719": "jing1",
    "\u971A": "mou6",
    "\u971B": "ling4/leng4",
    "\u971C": "soeng1",
    "\u971D": "ling4",
    "\u971E": "haa4",
    "\u971F": "hung4",
    "\u9720": "jam1",
    "\u9721": "mak6",
    "\u9722": "mak6",
    "\u9723": "wan5",
    "\u9724": "lau6",
    "\u9725": "mung6",
    "\u9726": "ban1",
    "\u9727": "mou6",
    "\u9728": "wai3",
    "\u9729": "gwok3/gok3",
    "\u972A": "jam4",
    "\u972B": "zaap6/zap6",
    "\u972C": "jik6",
    "\u972D": "oi2/ngoi2",
    "\u972E": "daam6",
    "\u972F": "tang3",
    "\u9730": "sin3",
    "\u9731": "wat6",
    "\u9732": "lou6/lau6",
    "\u9733": "lung4",
    "\u9734": "doi6",
    "\u9735": "zap1",
    "\u9736": "pong4/pong1",
    "\u9737": "joeng4",
    "\u9738": "baa3",
    "\u9739": "pik1",
    "\u973A": "mei4",
    "\u973B": "fung1",
    "\u973C": "hei3",
    "\u973D": "zai3",
    "\u973E": "maai4/mai4/lei4",
    "\u973F": "mung4/mung6",
    "\u9740": "mung4",
    "\u9741": "leoi4",
    "\u9742": "lik1/lik6",
    "\u9743": "fok3/seoi5",
    "\u9744": "oi2/ngoi2",
    "\u9745": "fai3",
    "\u9746": "doi6",
    "\u9747": "lung4",
    "\u9748": "ling4/ling2/leng4",
    "\u9749": "oi2/ngoi2",
    "\u974A": "fung1",
    "\u974B": "lik6",
    "\u974C": "bou2",
    "\u974D": "fok3",
    "\u974E": "kam4",
    "\u974F": "hok6",
    "\u9750": "bang6",
    "\u9751": "cing1/ceng1",
    "\u9752": "cing1/ceng1",
    "\u9753": "leng3/leng1/zing6",
    "\u9754": "tin1",
    "\u9755": "zan1",
    "\u9756": "zing6",
    "\u9757": "cang1",
    "\u9758": "cing3",
    "\u9759": "zing6",
    "\u975A": "leng3/leng1/zing6",
    "\u975B": "din6",
    "\u975C": "zing6",
    "\u975D": "tin1",
    "\u975E": "fei1",
    "\u975F": "fei1",
    "\u9760": "kaau3",
    "\u9761": "mei5/mei4",
    "\u9762": "min6/min2",
    "\u9763": "min6",
    "\u9764": "paau3",
    "\u9765": "jip3/jim2",
    "\u9766": "tin2/min5",
    "\u9767": "fui3",
    "\u9768": "jip3/jim2",
    "\u9769": "gaak3/gaap3/gik1",
    "\u976A": "ding1",
    "\u976B": "caai1/caa1",
    "\u976C": "gin1",
    "\u976D": "jan6/ngan6/an6",
    "\u976E": "dik1",
    "\u976F": "dou6",
    "\u9770": "wu1",
    "\u9771": "jan6/ngan6/an6",
    "\u9772": "kam4",
    "\u9773": "gan3",
    "\u9774": "hoe1",
    "\u9775": "nau2/lau2",
    "\u9776": "baa2/baa3",
    "\u9777": "jan5",
    "\u9778": "saap3/taat3/cap1",
    "\u9779": "noi6/loi6",
    "\u977A": "mut6",
    "\u977B": "zou2",
    "\u977C": "daat3",
    "\u977D": "bun3",
    "\u977E": "jai6/sit3",
    "\u977F": "aau3/ngaau3",
    "\u9780": "tou4",
    "\u9781": "bei6",
    "\u9782": "gaai1",
    "\u9783": "wang4",
    "\u9784": "pok3/paau4",
    "\u9785": "joeng1/joeng2",
    "\u9786": "bing2",
    "\u9787": "jan1",
    "\u9788": "gaap3",
    "\u9789": "tou4",
    "\u978A": "kit3",
    "\u978B": "haai4/haai2",
    "\u978C": "on1/ngon1",
    "\u978D": "on1/ngon1",
    "\u978E": "han4",
    "\u978F": "gung2",
    "\u9790": "lung6",
    "\u9791": "taat3/daat3",
    "\u9792": "kiu4",
    "\u9793": "ting1",
    "\u9794": "mun4/mun6",
    "\u9795": "ngaang6/aang6",
    "\u9796": "seoi1",
    "\u9797": "tiu4",
    "\u9798": "ciu3/saau1/sau1",
    "\u9799": "jyun5/gyun1",
    "\u979A": "hung3",
    "\u979B": "bung2",
    "\u979C": "daap6",
    "\u979D": "soeng5",
    "\u979E": "bing2/bei2/pei4",
    "\u979F": "kwok3/kok3",
    "\u97A0": "guk1",
    "\u97A1": "laai1/laa1",
    "\u97A2": "sip3",
    "\u97A3": "jau4",
    "\u97A4": "bong1",
    "\u97A5": "ang1/ngang1",
    "\u97A6": "cau1",
    "\u97A7": "cau1",
    "\u97A8": "hot3/maat3",
    "\u97A9": "ciu3",
    "\u97AA": "mau4/muk6",
    "\u97AB": "guk1",
    "\u97AC": "gin1",
    "\u97AD": "bin1",
    "\u97AE": "dai1",
    "\u97AF": "zin1",
    "\u97B0": "wan3",
    "\u97B1": "tou1",
    "\u97B2": "gau1/kau1",
    "\u97B3": "taap3/daap6",
    "\u97B4": "bei6/bou6",
    "\u97B5": "haai4",
    "\u97B6": "pun4",
    "\u97B7": "lik6",
    "\u97B8": "bat1/bei2",
    "\u97B9": "kwok3/kok3",
    "\u97BA": "tong1",
    "\u97BB": "lau4",
    "\u97BC": "gwai6",
    "\u97BD": "kiu4",
    "\u97BE": "hoe1",
    "\u97BF": "gei1",
    "\u97C0": "zin1",
    "\u97C1": "goeng1",
    "\u97C2": "cim3",
    "\u97C3": "taat3/daat3",
    "\u97C4": "waak6/wu6",
    "\u97C5": "hin2",
    "\u97C6": "cin1",
    "\u97C7": "duk6",
    "\u97C8": "mat6/maat6",
    "\u97C9": "zin1",
    "\u97CA": "laan4",
    "\u97CB": "wai4/wai5",
    "\u97CC": "jan6/ngan6/an6/ngan1/an1",
    "\u97CD": "fat1",
    "\u97CE": "mui6/mut6",
    "\u97CF": "hyun3",
    "\u97D0": "gaap3",
    "\u97D1": "wai5",
    "\u97D2": "ciu3",
    "\u97D3": "hon4",
    "\u97D4": "coeng3",
    "\u97D5": "hoeng2",
    "\u97D6": "jau5",
    "\u97D7": "wan6",
    "\u97D8": "sip3",
    "\u97D9": "wai5",
    "\u97DA": "gaak3",
    "\u97DB": "bai6/baai6",
    "\u97DC": "tou1",
    "\u97DD": "gau1",
    "\u97DE": "wan3",
    "\u97DF": "gou1",
    "\u97E0": "bat1",
    "\u97E1": "wai5",
    "\u97E2": "ceoi3",
    "\u97E3": "duk6",
    "\u97E4": "mat6/maat6",
    "\u97E5": "duk6",
    "\u97E6": "wai4/wai5",
    "\u97E7": "jan6/ngan6/an6/ngan1/an1",
    "\u97E8": "fat1",
    "\u97E9": "hon4",
    "\u97EA": "wai5",
    "\u97EB": "wan3",
    "\u97EC": "tou1",
    "\u97ED": "gau2",
    "\u97EE": "gau2",
    "\u97EF": "cim1",
    "\u97F0": "haai6",
    "\u97F1": "cim1",
    "\u97F2": "zai1",
    "\u97F3": "jam1",
    "\u97F4": "zaap6",
    "\u97F5": "wan6/wan5",
    "\u97F6": "siu4",
    "\u97F7": "lyut3",
    "\u97F8": "pung4",
    "\u97F9": "wong4",
    "\u97FA": "jing1",
    "\u97FB": "wan6/wan5/wan2",
    "\u97FC": "pung4",
    "\u97FD": "am1/ngam1",
    "\u97FE": "jam1",
    "\u97FF": "hoeng2",
    "\u9800": "wu6",
    "\u9801": "jip6",
    "\u9802": "ding2/deng2",
    "\u9803": "king2/king1",
    "\u9804": "kwai4/kau4",
    "\u9805": "hong6/hong2",
    "\u9806": "seon6/seon2",
    "\u9807": "hon1",
    "\u9808": "seoi1",
    "\u9809": "ji4",
    "\u980A": "juk1",
    "\u980B": "gu3/gwu3",
    "\u980C": "zung6",
    "\u980D": "kwai2",
    "\u980E": "kei4",
    "\u980F": "hong4",
    "\u9810": "jyu6",
    "\u9811": "waan4",
    "\u9812": "baan1/paan1",
    "\u9813": "deon6/deon2/duk6",
    "\u9814": "dik6/king2",
    "\u9815": "daam1",
    "\u9816": "pun3",
    "\u9817": "po2/po1",
    "\u9818": "ling5/leng5/leng2",
    "\u9819": "caak3",
    "\u981A": "geng2",
    "\u981B": "leoi5",
    "\u981C": "hap6/gap3",
    "\u981D": "haau1",
    "\u981E": "aat3/ngaat3",
    "\u981F": "ngaak6/aak6",
    "\u9820": "ngai5/ai5",
    "\u9821": "kit3/git3",
    "\u9822": "kut3/kwut3",
    "\u9823": "can2",
    "\u9824": "ji4",
    "\u9825": "ji4",
    "\u9826": "hoi4/hoi5",
    "\u9827": "deoi2",
    "\u9828": "jyu5",
    "\u9829": "ping1",
    "\u982A": "loi6",
    "\u982B": "tiu3/fu2",
    "\u982C": "gaap3",
    "\u982D": "tau4/tau2",
    "\u982E": "fui3",
    "\u982F": "kwai4/kau4",
    "\u9830": "gaap3/haap3",
    "\u9831": "lyut3",
    "\u9832": "ting5",
    "\u9833": "cing1",
    "\u9834": "wing6",
    "\u9835": "wan1/gwan1",
    "\u9836": "huk6",
    "\u9837": "ham5",
    "\u9838": "geng2",
    "\u9839": "teoi4",
    "\u983A": "teoi4",
    "\u983B": "pan4/ban1",
    "\u983C": "laai6",
    "\u983D": "teoi4",
    "\u983E": "zi1",
    "\u983F": "zi1",
    "\u9840": "ceoi4",
    "\u9841": "ding3",
    "\u9842": "laai6",
    "\u9843": "taam4",
    "\u9844": "ham5",
    "\u9845": "haan1",
    "\u9846": "fo2",
    "\u9847": "seoi6/seoi5",
    "\u9848": "gwing2",
    "\u9849": "ham6/jam1",
    "\u984A": "ji4",
    "\u984B": "soi1",
    "\u984C": "tai4/tai2",
    "\u984D": "ngaak6/aak6/ngaak2/aak2",
    "\u984E": "ngok6/ok6/ngok2/ok2",
    "\u984F": "ngaan4/aan4",
    "\u9850": "wan6",
    "\u9851": "ham2",
    "\u9852": "jung4",
    "\u9853": "zyun1",
    "\u9854": "ngaan4/aan4",
    "\u9855": "hin2",
    "\u9856": "seon3/seon2",
    "\u9857": "ngai5/ai5",
    "\u9858": "jyun6/jyun2",
    "\u9859": "song2",
    "\u985A": "din1",
    "\u985B": "din1",
    "\u985C": "gong2/gok3",
    "\u985D": "fui1",
    "\u985E": "leoi6/leoi2",
    "\u985F": "laau4",
    "\u9860": "piu5",
    "\u9861": "wui6",
    "\u9862": "mun4/mun1",
    "\u9863": "cuk1",
    "\u9384": "oi1/ngoi1",
    "\u9385": "gaai3",
    "\u9386": "zin2",
    "\u9387": "mei4",
    "\u9388": "so2",
    "\u9389": "taap3",
    "\u938A": "bong6/bong2",
    "\u938B": "hat6",
    "\u938C": "lim4",
    "\u938D": "sok3",
    "\u938E": "hei3",
    "\u938F": "lau4",
    "\u9390": "jiu4",
    "\u9391": "jip6",
    "\u9392": "nau6/lau6",
    "\u9393": "jung1",
    "\u9394": "jung4",
    "\u9395": "tong4",
    "\u9396": "so2",
    "\u9397": "coeng1",
    "\u9398": "gaak3/lik6",
    "\u9399": "sok3",
    "\u939A": "ceoi4/ceoi2",
    "\u939B": "bok3",
    "\u939C": "pun4",
    "\u939D": "saap3/daap3",
    "\u939E": "bai1/pai1/pei1",
    "\u939F": "song2",
    "\u93A0": "gong3",
    "\u93A1": "zi1",
    "\u93A2": "wu1",
    "\u93A3": "jing4",
    "\u93A4": "fong2",
    "\u93A5": "tiu4",
    "\u93A6": "lau4/lau6",
    "\u93A7": "hoi2",
    "\u93A8": "seon2",
    "\u93A9": "saat3",
    "\u93AA": "sau1/sau2",
    "\u93AB": "faan6",
    "\u93AC": "gou2/hou6",
    "\u93AD": "zan3",
    "\u93AE": "zan3",
    "\u93AF": "long4",
    "\u93B0": "jat6",
    "\u93B1": "jyun4",
    "\u93B2": "tong2",
    "\u93B3": "nip1/lip1/nip6/lip6",
    "\u93B4": "sik1",
    "\u93B5": "gaa1",
    "\u93B6": "go1",
    "\u93B7": "maa5",
    "\u93B8": "zyun1/zeon3",
    "\u93B9": "sung3",
    "\u93BA": "zou2",
    "\u93BB": "so2",
    "\u93BC": "laa3",
    "\u93BD": "fung1",
    "\u93BE": "wan1",
    "\u93BF": "naa4/laa4",
    "\u93C0": "lou5",
    "\u93C1": "so2",
    "\u93C2": "au1/ngau1",
    "\u93C3": "zuk6",
    "\u93C4": "tyun4",
    "\u93C5": "sau1",
    "\u93C6": "gun3/gwun3",
    "\u93C7": "syun4/syun6",
    "\u93C8": "lin6/lin2",
    "\u93C9": "sau3",
    "\u93CA": "ngou6/ou6/ngou4/ou4",
    "\u93CB": "mun5",
    "\u93CC": "mok6",
    "\u93CD": "lo4",
    "\u93CE": "bat1",
    "\u93CF": "wai6",
    "\u93D0": "lau4",
    "\u93D1": "dik1/dik6",
    "\u93D2": "saam2",
    "\u93D3": "cung1",
    "\u93D4": "ji4",
    "\u93D5": "luk6",
    "\u93D6": "ngou4/ou4/ou1/ngou1",
    "\u93D7": "hang1",
    "\u93D8": "coeng1",
    "\u93D9": "ceoi1",
    "\u93DA": "cik1",
    "\u93DB": "soeng4",
    "\u93DC": "tong1/tong4",
    "\u93DD": "maan6",
    "\u93DE": "jung4",
    "\u93DF": "caan2",
    "\u93E0": "fung1",
    "\u93E1": "geng3/geng2",
    "\u93E2": "biu1",
    "\u93E3": "syu3",
    "\u93E4": "lau6",
    "\u93E5": "sau3",
    "\u93E6": "cung1",
    "\u93E7": "lung4",
    "\u93E8": "zaam6",
    "\u93E9": "zim6",
    "\u93EA": "cou4",
    "\u93EB": "lei4",
    "\u93EC": "laa3",
    "\u93ED": "sik1",
    "\u93EE": "hong1",
    "\u93EF": "song2",
    "\u93F0": "bang1",
    "\u93F1": "gam2",
    "\u93F2": "cim1",
    "\u93F3": "caang4",
    "\u93F4": "lou6",
    "\u93F5": "waa4",
    "\u93F6": "cip3",
    "\u93F7": "pok3/buk6",
    "\u93F8": "wai6",
    "\u93F9": "koeng5",
    "\u93FA": "put3",
    "\u93FB": "leon4",
    "\u93FC": "saak3",
    "\u93FD": "sau3",
    "\u93FE": "sin3",
    "\u93FF": "coeng1",
    "\u9400": "gwai6",
    "\u9401": "si1",
    "\u9402": "lau4/lau6",
    "\u9403": "naau4/laau4",
    "\u9404": "waang4/wong4",
    "\u9405": "pit3",
    "\u9406": "seoi6",
    "\u9407": "faan4",
    "\u9408": "kiu4",
    "\u9409": "cyun1",
    "\u940A": "joeng4",
    "\u940B": "tong1/tong3/tong2",
    "\u940C": "zoeng6",
    "\u940D": "kyut3",
    "\u940E": "ziu1",
    "\u940F": "zeon1/zyun3",
    "\u9410": "liu4",
    "\u9411": "kit3",
    "\u9412": "lou4",
    "\u9413": "deoi6/deoi1/deon1",
    "\u9414": "taam4/cam4",
    "\u9415": "zaam1",
    "\u9416": "gei1",
    "\u9417": "gaan2",
    "\u9418": "zung1",
    "\u9419": "dang3/dang1",
    "\u941A": "aa1/ngaa1",
    "\u941B": "jing2",
    "\u941C": "deoi6",
    "\u941D": "kyut3",
    "\u941E": "nau6/lau6",
    "\u941F": "zaam1",
    "\u9420": "pou2",
    "\u9421": "tit3",
    "\u9422": "faan4",
    "\u9423": "zoeng2",
    "\u9424": "ding2",
    "\u9425": "sin3/sin6",
    "\u9426": "hoi1",
    "\u9427": "gaan2/gaan3",
    "\u9428": "fai3",
    "\u9429": "seoi6",
    "\u942A": "lou5",
    "\u942B": "zyun1/zeon3",
    "\u942C": "wai3",
    "\u942D": "ou3/ngou3/juk1",
    "\u942E": "lim4",
    "\u942F": "zoek3/zoek6",
    "\u9430": "ciu1",
    "\u9431": "gim3",
    "\u9432": "zuk6",
    "\u9433": "leoi4",
    "\u9434": "bik1",
    "\u9435": "tit3",
    "\u9436": "waan4",
    "\u9437": "jip6",
    "\u9438": "dok6",
    "\u9439": "gwo2/go2",
    "\u943A": "dong1/caang1",
    "\u943B": "geoi6/keoi4",
    "\u943C": "fan4",
    "\u943D": "daat6",
    "\u943E": "bai3",
    "\u943F": "ji3",
    "\u9440": "oi3/ngoi3",
    "\u9441": "zung1",
    "\u9442": "fan3",
    "\u9443": "diu6",
    "\u9444": "zyu3",
    "\u9445": "waang4",
    "\u9446": "zeoi6",
    "\u9447": "zai1",
    "\u9448": "nip6/lip6",
    "\u9449": "hap6",
    "\u944A": "wok6/wok2",
    "\u944B": "hing1",
    "\u944C": "ban1",
    "\u944D": "jing1",
    "\u944E": "gwai6",
    "\u944F": "ning4/ling4",
    "\u9450": "seoi1",
    "\u9451": "gaam3",
    "\u9452": "gaam3",
    "\u9453": "hin2",
    "\u9454": "caa2",
    "\u9455": "zat1",
    "\u9456": "mit6",
    "\u9457": "lei4",
    "\u9458": "leoi4",
    "\u9459": "kai1",
    "\u945A": "zyun3/zyun1",
    "\u945B": "kong3/kwong3",
    "\u945C": "soeng2",
    "\u945D": "pung4",
    "\u945E": "laap6",
    "\u945F": "duk6",
    "\u9460": "soek3",
    "\u9461": "cuk1",
    "\u9462": "leoi6",
    "\u9463": "biu1",
    "\u9464": "paau4",
    "\u9465": "lou5",
    "\u9466": "jin4",
    "\u9467": "jin6",
    "\u9468": "lung4",
    "\u9469": "ngok6/ok6",
    "\u946A": "lou4",
    "\u946B": "jam1",
    "\u946C": "gaam3",
    "\u946D": "laan4",
    "\u946E": "bok3",
    "\u946F": "zim1",
    "\u9470": "joek6",
    "\u9471": "caam4",
    "\u9472": "soeng1",
    "\u9473": "gin6",
    "\u9474": "kwai4",
    "\u9475": "gun3/gwun3",
    "\u9476": "cong4",
    "\u9477": "nip6/lip6",
    "\u9478": "leoi5",
    "\u9479": "cyun1",
    "\u947A": "keoi4",
    "\u947B": "paan3",
    "\u947C": "lo4/lo2",
    "\u947D": "zyun3/zyun2/zyun1",
    "\u947E": "lyun4",
    "\u947F": "zok6/zok2",
    "\u9480": "jit6",
    "\u9481": "fok3/kyut3",
    "\u9482": "tong2",
    "\u9483": "suk6/zuk1",
    "\u9484": "laan4",
    "\u9485": "gaan2.faa3.gam1.zi6.bin1",
    "\u9486": "gaa1/gaat3",
    "\u9487": "jyut6/jyut3",
    "\u9488": "zam1",
    "\u9489": "ding1/deng1",
    "\u948A": "ciu1",
    "\u948B": "pok3/puk3",
    "\u948C": "liu5/liu6",
    "\u948D": "tou2",
    "\u948E": "cin1",
    "\u948F": "cyun3/cyun1",
    "\u9490": "saam1/saam3/sin3",
    "\u9491": "zaap6/saap3/kap1",
    "\u9492": "faan4",
    "\u9493": "diu3",
    "\u9494": "mun4",
    "\u9495": "neoi5/leoi5/neoi4/leoi4",
    "\u9496": "joeng4",
    "\u9497": "caai1",
    "\u9498": "jing4/gin1",
    "\u9499": "koi3",
    "\u949A": "bat1",
    "\u949B": "taai3",
    "\u949C": "geoi6",
    "\u949D": "deon6",
    "\u949E": "caau1",
    "\u949F": "zung1",
    "\u94A0": "naap6/laap6",
    "\u94A1": "bui3",
    "\u94A2": "gong3/gong1",
    "\u94A3": "baan2",
    "\u94A4": "kim4",
    "\u94A5": "joek6/jyut6",
    "\u94A6": "jam1",
    "\u94A7": "gwan1/kwan1",
    "\u94A8": "wu1",
    "\u94A9": "ngau1/au1",
    "\u94AA": "kong3",
    "\u94AB": "fong1",
    "\u94AC": "fo2",
    "\u94AD": "dau2",
    "\u94AE": "nau2/lau2",
    "\u94AF": "baa2/paa4",
    "\u94B0": "juk6",
    "\u94B1": "cin4/cin2/zin2",
    "\u94B2": "zing1/zing3",
    "\u94B3": "kim4/kim2",
    "\u94B4": "gu2/gwu2/gu1/gwu1",
    "\u94B5": "but3",
    "\u94B6": "ko1",
    "\u94B7": "po2",
    "\u94B8": "bou1",
    "\u94B9": "bat6/but6",
    "\u94BA": "jyut6",
    "\u94BB": "zyun3/zyun2/zyun1/cim1",
    "\u94BC": "muk6",
    "\u94BD": "taan2/daan3",
    "\u94BE": "gaap3",
    "\u94BF": "tin4/din6",
    "\u94C0": "jau4/jau2",
    "\u94C1": "tit3",
    "\u94C2": "bok6",
    "\u94C3": "ling4/ling1/ling2",
    "\u94C4": "soek3",
    "\u94C5": "jyun4",
    "\u94C6": "maau5",
    "\u94C7": "paau4",
    "\u94C8": "si5",
    "\u94C9": "jyun5",
    "\u94CA": "taa1/to4/to2/si1/se4",
    "\u94CB": "bei3/bit1",
    "\u94CC": "nei4/lei4/nei6/lei6",
    "\u94CD": "pei4/pei1",
    "\u94CE": "dok6",
    "\u94CF": "jing4",
    "\u94D0": "kaau3/kau3",
    "\u94D1": "lou5",
    "\u94D2": "ji5",
    "\u94D3": "mong4",
    "\u94D4": "aa1/ngaa1",
    "\u94D5": "jau5",
    "\u94D6": "sing4",
    "\u94D7": "gaap3",
    "\u94D8": "je4",
    "\u94D9": "naau4/laau4",
    "\u94DA": "zat6",
    "\u94DB": "dong1/caang1",
    "\u94DC": "tung4",
    "\u94DD": "leoi5",
    "\u94DE": "diu3",
    "\u94DF": "jan1",
    "\u94E0": "hoi2",
    "\u94E1": "zaap6/zaat3",
    "\u94E2": "zyu1",
    "\u94E3": "sin2",
    "\u94E4": "ding3/ding6/ting5",
    "\u94E5": "diu1",
    "\u94E6": "cim1",
    "\u94E7": "waa4",
    "\u94E8": "cyun4",
    "\u94E9": "saat3",
    "\u94EA": "haa1/hap6/hap1/gaap3",
    "\u94EB": "diu6/jiu4/tiu4",
    "\u94EC": "lok3/gok3/lok6",
    "\u94ED": "ming4/ming2/ming5",
    "\u94EE": "zang1/zaang1",
    "\u94EF": "sik1",
    "\u94F0": "gaau2/gaau3",
    "\u94F1": "ji1",
    "\u94F2": "caan2",
    "\u94F3": "cung3",
    "\u94F4": "tong1/tong3/tong2",
    "\u94F5": "on1/ngon1/on2/ngon2",
    "\u94F6": "ngan4/an4/ngan2/an2",
    "\u94F7": "jyu4/jyu6",
    "\u94F8": "zyu3",
    "\u94F9": "lou4",
    "\u94FA": "pou1/pou3/pou2",
    "\u94FB": "jyu5/ng4/m4",
    "\u94FC": "loi4",
    "\u94FD": "tik1",
    "\u94FE": "lin6/lin2",
    "\u94FF": "hang1",
    "\u9500": "siu1",
    "\u9501": "so2",
    "\u9502": "lei5",
    "\u9503": "caang3/cang3",
    "\u9504": "co4",
    "\u9505": "wo1",
    "\u9506": "gou3",
    "\u9507": "ngo4/o4",
    "\u9508": "sau3",
    "\u9509": "co3/co2",
    "\u950A": "lyut3",
    "\u950B": "fung1",
    "\u950C": "san1",
    "\u950D": "lau5",
    "\u950E": "hoi1",
    "\u950F": "gaan2/gaan3",
    "\u9510": "jeoi6",
    "\u9511": "tai1",
    "\u9512": "long4",
    "\u9513": "cim1",
    "\u9514": "guk1/guk6",
    "\u9515": "aa3/ngaa3/aa1/ngaa1/o1/ngo1",
    "\u9516": "coeng1",
    "\u9517": "ze2",
    "\u9518": "nok6/lok6",
    "\u9519": "co3/cok3/cou3",
    "\u951A": "naau4/laau4/maau4",
    "\u951B": "ban1",
    "\u951C": "kei4",
    "\u951D": "dak1",
    "\u951E": "gwo2/go2/fo3",
    "\u951F": "kwan1",
    "\u9520": "coeng1",
    "\u9521": "sek3/sik3",
    "\u9522": "gu3/gwu3",
    "\u9523": "lo4/lo2",
    "\u9524": "ceoi4/ceoi2",
    "\u9525": "zeoi1",
    "\u9526": "gam2",
    "\u9527": "zat1",
    "\u9528": "him1/hin1",
    "\u9529": "gyun2",
    "\u952A": "fat1/kut3/kwut3",
    "\u952B": "pui4",
    "\u952C": "taam4/cim1",
    "\u952D": "ding3/ding6",
    "\u952E": "gin6",
    "\u952F": "geoi3/goe3/guk1",
    "\u9530": "maang5",
    "\u9531": "zi1",
    "\u9532": "kit3",
    "\u9533": "joeng1",
    "\u9534": "kaai2/gaai1",
    "\u9535": "coeng1",
    "\u9536": "si1",
    "\u9537": "ngok6/ok6",
    "\u9538": "caap3",
    "\u9539": "ciu1",
    "\u953A": "zung1",
    "\u953B": "dyun3",
    "\u953C": "sau1/sau2",
    "\u953D": "wong4",
    "\u953E": "waan4/wun4",
    "\u953F": "oi1/ngoi1",
    "\u9540": "dou6",
    "\u9541": "mei5",
    "\u9542": "lau6",
    "\u9543": "zi1",
    "\u9544": "fai3",
    "\u9545": "mei4",
    "\u9546": "mok6",
    "\u9547": "zan3",
    "\u9548": "bok3",
    "\u9549": "gaak3/lik6",
    "\u954A": "nip6/lip6",
    "\u954B": "tong2",
    "\u954C": "zyun1/zeon3",
    "\u954D": "nip1/lip1/nip6/lip6",
    "\u954E": "naa4/laa4",
    "\u954F": "lau4/lau6",
    "\u9550": "gou2/hou6",
    "\u9551": "bong6/bong2",
    "\u9552": "jat6",
    "\u9553": "gaa1",
    "\u9554": "ban1",
    "\u9555": "jung4",
    "\u9556": "biu1",
    "\u9557": "tong1/tong4",
    "\u9558": "maan6",
    "\u9559": "lo4",
    "\u955A": "bang1",
    "\u955B": "jung4",
    "\u955C": "geng3/geng2",
    "\u955D": "dik1/dik6",
    "\u955E": "zuk6",
    "\u955F": "syun4/syun6",
    "\u9560": "lau4",
    "\u9561": "taam4/cam4",
    "\u9562": "kyut3",
    "\u9563": "liu4",
    "\u9564": "pok3/buk6",
    "\u9565": "lou5",
    "\u9566": "deoi6/deoi1/deon1",
    "\u9567": "laan4",
    "\u9568": "pou2",
    "\u9569": "cyun1",
    "\u956A": "koeng5",
    "\u956B": "dang3/dang1",
    "\u956C": "wok6/wok2",
    "\u956D": "leoi4",
    "\u956E": "waan4",
    "\u956F": "zuk6",
    "\u9570": "lim4",
    "\u9571": "ji3",
    "\u9572": "caa2",
    "\u9573": "biu1",
    "\u9574": "laap6",
    "\u9575": "caam4",
    "\u9576": "soeng1",
    "\u9577": "coeng4/coeng1/coeng2/zoeng6/zoeng2",
    "\u9578": "coeng4",
    "\u9579": "gau2",
    "\u957A": "ou2/ngou2",
    "\u957B": "dit6",
    "\u957C": "gwat6",
    "\u957D": "liu5",
    "\u957E": "nei4/lei4",
    "\u957F": "coeng4/coeng1/coeng2/zoeng6/zoeng2",
    "\u9580": "mun4/mun2",
    "\u9581": "maat3",
    "\u9582": "saan1",
    "\u9583": "sim2",
    "\u9584": "wik6",
    "\u9585": "mun4",
    "\u9586": "jim4",
    "\u9587": "bai3",
    "\u9588": "hon6",
    "\u9589": "bai3",
    "\u958A": "saan1",
    "\u958B": "hoi1",
    "\u958C": "kong3",
    "\u958D": "paang1",
    "\u958E": "wang4",
    "\u958F": "jeon6",
    "\u9590": "saam3",
    "\u9591": "haan4/haan2",
    "\u9592": "haan4/gaan1/gaan3",
    "\u9593": "gaan1/gaan3",
    "\u9594": "man5",
    "\u9595": "ngaa6/aa6/haa1",
    "\u9596": "seoi2",
    "\u9597": "dau3",
    "\u9598": "zaap6",
    "\u9599": "naau6/laau6",
    "\u959A": "zaam1",
    "\u959B": "ping1",
    "\u959C": "haa1/ho2",
    "\u959D": "ling4",
    "\u959E": "bin6",
    "\u959F": "bei3",
    "\u95A0": "jeon6",
    "\u95A1": "hat6/goi1/ngoi6/oi6",
    "\u95A2": "gwaan1",
    "\u95A3": "gok3/gok2",
    "\u95A4": "gap3/gok3/hap6",
    "\u95A5": "fat6",
    "\u95A6": "cuk1",
    "\u95A7": "hung3/hung6",
    "\u95A8": "gwai1",
    "\u95A9": "man5",
    "\u95AA": "hai1",
    "\u95AB": "kwan2",
    "\u95AC": "long6/long4/long5",
    "\u95AD": "leoi4/leoi5",
    "\u95AE": "ting4",
    "\u95AF": "saa3",
    "\u95B0": "guk1",
    "\u95B1": "jyut6",
    "\u95B2": "jyut6",
    "\u95B3": "zin2",
    "\u95B4": "gwik1",
    "\u95B5": "leon6",
    "\u95B6": "coeng1",
    "\u95B7": "saat3/saai3",
    "\u95B8": "kwan2",
    "\u95B9": "jim1",
    "\u95BA": "man4",
    "\u95BB": "jim4",
    "\u95BC": "aat3/ngaat3/aat1/ngaat1/jin1",
    "\u95BD": "fan1",
    "\u95BE": "wik6",
    "\u95BF": "man4",
    "\u95C0": "hung3",
    "\u95C1": "bou1",
    "\u95C2": "hung3",
    "\u95C3": "gwik1",
    "\u95C4": "jiu2",
    "\u95C5": "man4",
    "\u95C6": "baan2",
    "\u95C7": "am2/ngam2/am1/ngam1/am3/ngam3",
    "\u95C8": "wai4",
    "\u95C9": "jan1",
    "\u95CA": "fut3",
    "\u95CB": "kyut3",
    "\u95CC": "laan4",
    "\u95CD": "dou1/se4/ze1",
    "\u95CE": "cyun4",
    "\u95CF": "fung1",
    "\u95D0": "tin4",
    "\u95D1": "jit6/nip6/lip6",
    "\u95D2": "taap3/daap6",
    "\u95D3": "hoi2",
    "\u95D4": "hap6",
    "\u95D5": "kyut3/gwat6",
    "\u95D6": "cong2",
    "\u95D7": "gwaan1",
    "\u95D8": "dau3",
    "\u95D9": "kai2",
    "\u95DA": "kwai1",
    "\u95DB": "tong1/tong4/coeng1",
    "\u95DC": "gwaan1",
    "\u95DD": "piu4",
    "\u95DE": "ham3/haam3/haam2",
    "\u95DF": "kap1/taap3",
    "\u95E0": "kui2/kwui2/gwai6",
    "\u95E1": "zin2/cin2/sin6",
    "\u95E2": "pik1/bei6",
    "\u95E3": "dong3",
    "\u95E4": "waan4",
    "\u95E5": "taat3",
    "\u95E6": "ngan4/an4",
    "\u95E7": "jyun5",
    "\u95E8": "mun4/mun2",
    "\u95E9": "saan1",
    "\u95EA": "sim2",
    "\u95EB": "jim4",
    "\u95EC": "hon6",
    "\u95ED": "bai3",
    "\u95EE": "man6",
    "\u95EF": "cong2",
    "\u95F0": "jeon6",
    "\u95F1": "wai4",
    "\u95F2": "haan4/haan2",
    "\u95F3": "wang4",
    "\u95F4": "gaan1/gaan3",
    "\u95F5": "man5",
    "\u95F6": "kong3",
    "\u95F7": "mun6",
    "\u95F8": "zaap6",
    "\u95F9": "naau6/laau6",
    "\u95FA": "gwai1",
    "\u95FB": "man4/man2/man6",
    "\u95FC": "taat3",
    "\u95FD": "man5",
    "\u95FE": "leoi4/leoi5",
    "\u90CA": "gaau1",
    "\u90CB": "hai4",
    "\u90CC": "gwai1",
    "\u90CD": "naa5/laa5",
    "\u90CE": "long4/long2",
    "\u90CF": "gaap3",
    "\u90D0": "kui2/kwui2/kui3/kwui3",
    "\u90D1": "zeng6/zing6",
    "\u90D2": "long4",
    "\u90D3": "wan6",
    "\u90D4": "jin4",
    "\u90D5": "sing4",
    "\u90D6": "dau1/dau6",
    "\u90D7": "ci1/hei1",
    "\u90D8": "leoi5",
    "\u90D9": "fu2",
    "\u90DA": "ng4/m4",
    "\u90DB": "fu1",
    "\u90DC": "gou3",
    "\u90DD": "kok3/gok3",
    "\u90DE": "long4",
    "\u90DF": "gaap3",
    "\u90E0": "gang2",
    "\u90E1": "gwan6",
    "\u90E2": "jing5/cing2",
    "\u90E3": "but6",
    "\u90E4": "gwik1",
    "\u90E5": "kwik1",
    "\u90E6": "lik6",
    "\u90E7": "wan4",
    "\u90E8": "bou6",
    "\u90E9": "haau4",
    "\u90EA": "cai1",
    "\u90EB": "pei4",
    "\u90EC": "cing1",
    "\u90ED": "gwok3/gok3/gwik1",
    "\u90EE": "zau1",
    "\u90EF": "taam4",
    "\u90F0": "zau1",
    "\u90F1": "ping4",
    "\u90F2": "loi4",
    "\u90F3": "ngai4/ai4",
    "\u90F4": "sam1",
    "\u90F5": "jau4",
    "\u90F6": "bou6",
    "\u90F7": "hoeng1",
    "\u90F8": "daan1",
    "\u90F9": "gwik1",
    "\u90FA": "jung1",
    "\u90FB": "hiu1",
    "\u90FC": "ji1",
    "\u90FD": "dou1",
    "\u90FE": "jin2",
    "\u90FF": "mei4",
    "\u9100": "joek6",
    "\u9101": "bui3",
    "\u9102": "ngok6/ok6",
    "\u9103": "syu1",
    "\u9104": "gyun3",
    "\u9105": "jyu5",
    "\u9106": "wan6",
    "\u9107": "hau6",
    "\u9108": "kwai4",
    "\u9109": "hoeng1/hoeng3",
    "\u910A": "hoeng1",
    "\u910B": "sau1",
    "\u910C": "tong4",
    "\u910D": "ming4",
    "\u910E": "sik1",
    "\u910F": "juk6",
    "\u9110": "cuk1",
    "\u9111": "zi1",
    "\u9112": "zau1",
    "\u9113": "jip3",
    "\u9114": "wu1",
    "\u9115": "hoeng1/hoeng3",
    "\u9116": "wan4",
    "\u9117": "hou6/haau1",
    "\u9118": "jung4",
    "\u9119": "pei2",
    "\u911A": "mok6",
    "\u911B": "caau4",
    "\u911C": "fu1",
    "\u911D": "liu5",
    "\u911E": "ngan4/an4",
    "\u911F": "zyun1",
    "\u9120": "wu6",
    "\u9121": "hiu1",
    "\u9122": "jin1",
    "\u9123": "zoeng1/zoeng3",
    "\u9124": "maan6",
    "\u9125": "hiu1",
    "\u9126": "heoi2",
    "\u9127": "dang6",
    "\u9128": "bai3",
    "\u9129": "cam4",
    "\u912A": "bei3",
    "\u912B": "cang4",
    "\u912C": "wai4",
    "\u912D": "zeng6/zing6",
    "\u912E": "mau6",
    "\u912F": "sin6",
    "\u9130": "leon4",
    "\u9131": "po4/bo3",
    "\u9132": "daan1",
    "\u9133": "maang4",
    "\u9134": "jip6",
    "\u9135": "cou3",
    "\u9136": "kui2/kwui2/kui3/kwui3",
    "\u9137": "fung1",
    "\u9138": "mung4",
    "\u9139": "zau1",
    "\u913A": "kwong3/kong3/kwong2/kong2",
    "\u913B": "lin5",
    "\u913C": "zaan3/co4",
    "\u913D": "cin4",
    "\u913E": "jau1",
    "\u913F": "gei1",
    "\u9140": "jin3",
    "\u9141": "caam4",
    "\u9142": "zaan3/co4",
    "\u9143": "ling4",
    "\u9144": "fun1",
    "\u9145": "kwai4",
    "\u9146": "fung1",
    "\u9147": "zaan3/co4",
    "\u9148": "lik6",
    "\u9149": "jau5",
    "\u914A": "ding2/ding1",
    "\u914B": "jau4/cau4",
    "\u914C": "zoek3",
    "\u914D": "pui3",
    "\u914E": "zau6",
    "\u914F": "ji4",
    "\u9150": "gon1/hong5",
    "\u9151": "jyu1",
    "\u9152": "zau2",
    "\u9153": "jim2",
    "\u9154": "zeoi3",
    "\u9155": "mou4",
    "\u9156": "daam1/zam6",
    "\u9157": "jyu3/heoi3/heoi2",
    "\u9158": "tau4",
    "\u9159": "zam1",
    "\u915A": "fan1",
    "\u915B": "jyun4",
    "\u915C": "fu1",
    "\u915D": "wan5/wan3",
    "\u915E": "taai3",
    "\u915F": "tim1",
    "\u9160": "kaa2",
    "\u9161": "to4",
    "\u9162": "zok6/cou3",
    "\u9163": "ham4",
    "\u9164": "gu1/gwu1",
    "\u9165": "sou1",
    "\u9166": "put3/faat3/but3",
    "\u9167": "cau4",
    "\u9168": "doi6/zoi6",
    "\u9169": "ming5/ming4",
    "\u916A": "lok3/lou6",
    "\u916B": "cyut3",
    "\u916C": "cau4",
    "\u916D": "jau6",
    "\u916E": "tung4",
    "\u916F": "zi2",
    "\u9170": "sin1",
    "\u9171": "zoeng3",
    "\u9172": "cing4",
    "\u9173": "jan6",
    "\u9174": "tou4",
    "\u9175": "haau1/gaau3",
    "\u9176": "mui4",
    "\u9177": "huk6",
    "\u9178": "syun1",
    "\u9179": "lyut3/lyut6/laai6",
    "\u917A": "pou4",
    "\u917B": "zeoi1",
    "\u917C": "hoi2",
    "\u917D": "jim6",
    "\u917E": "si1",
    "\u917F": "joeng6/joeng2",
    "\u9180": "wai4",
    "\u9181": "luk6",
    "\u9182": "lam5",
    "\u9183": "jim1/jip3",
    "\u9184": "tou4",
    "\u9185": "pui1",
    "\u9186": "zaan2",
    "\u9187": "seon4",
    "\u9188": "taam4",
    "\u9189": "zeoi3",
    "\u918A": "zyut3/zeoi3",
    "\u918B": "cou3",
    "\u918C": "kwan1",
    "\u918D": "tai4/tai2",
    "\u918E": "haam4",
    "\u918F": "dou1",
    "\u9190": "wu4",
    "\u9191": "seoi2",
    "\u9192": "sing2/seng2",
    "\u9193": "taam2",
    "\u9194": "jau4",
    "\u9195": "seon4",
    "\u9196": "wan5/wan3",
    "\u9197": "put3",
    "\u9198": "hap1",
    "\u9199": "sau1",
    "\u919A": "mai4",
    "\u919B": "cyun4",
    "\u919C": "cau2",
    "\u919D": "co4",
    "\u919E": "wan5/wan3",
    "\u919F": "wing6",
    "\u91A0": "ong3/ngong3",
    "\u91A1": "zaa3",
    "\u91A2": "hoi2",
    "\u91A3": "tong4",
    "\u91A4": "zoeng3",
    "\u91A5": "piu2",
    "\u91A6": "cam2",
    "\u91A7": "jyu3",
    "\u91A8": "lei4",
    "\u91A9": "zou1",
    "\u91AA": "lou4",
    "\u91AB": "ji1",
    "\u91AC": "zoeng3",
    "\u91AD": "buk6/pok3",
    "\u91AE": "ziu3",
    "\u91AF": "hei1",
    "\u91B0": "taam4",
    "\u91B1": "put3/faat3/but3",
    "\u91B2": "nung4/lung4",
    "\u91B3": "jik6/sik1",
    "\u91B4": "lai5",
    "\u91B5": "geoi6/koek6",
    "\u91B6": "jim6",
    "\u91B7": "jik1",
    "\u91B8": "joeng6",
    "\u91B9": "jyu4",
    "\u91BA": "fan1",
    "\u91BB": "cau4",
    "\u91BC": "jin3",
    "\u91BD": "ling4",
    "\u91BE": "mei4",
    "\u91BF": "mei4",
    "\u91C0": "joeng6/joeng2",
    "\u91C1": "jan6",
    "\u91C2": "ziu3",
    "\u91C3": "si1",
    "\u91C4": "mei4",
    "\u91C5": "jim6",
    "\u91C6": "bin6",
    "\u91C7": "coi2/coi3",
    "\u91C8": "sik1",
    "\u91C9": "jau6/jau2",
    "\u91CA": "sik1/jik6",
    "\u91CB": "sik1/jik6",
    "\u91CC": "lei5/lei2/leoi5",
    "\u91CD": "cung5/zung6/cung4",
    "\u91CE": "je5/je2",
    "\u91CF": "loeng4/loeng6",
    "\u91D0": "hei1/hei2/lei4",
    "\u91D1": "gam1",
    "\u91D2": "gam1.zi6.bin1",
    "\u91D3": "gaa1/gaat3",
    "\u91D4": "jyut6/jyut3",
    "\u91D5": "liu5/liu6",
    "\u91D6": "dou1",
    "\u91D7": "ciu1",
    "\u91D8": "ding1/deng1",
    "\u91D9": "pok3/puk3",
    "\u91DA": "kau4",
    "\u91DB": "baat3",
    "\u91DC": "fu2",
    "\u91DD": "zam1",
    "\u91DE": "zap1",
    "\u91DF": "baat3",
    "\u91E0": "lyun6",
    "\u91E1": "fu2",
    "\u91E2": "naai5/laai5",
    "\u91E3": "diu3",
    "\u91E4": "saam1/saam3/sin3",
    "\u91E5": "ciu2",
    "\u91E6": "kau3",
    "\u91E7": "cyun3/cyun1",
    "\u91E8": "zi2",
    "\u91E9": "faan4",
    "\u91EA": "waa4",
    "\u91EB": "waa4",
    "\u91EC": "hon6",
    "\u91ED": "gong1",
    "\u91EE": "cai4",
    "\u91EF": "mong4",
    "\u91F0": "jat6",
    "\u91F1": "dai6/daai6",
    "\u91F2": "zi6",
    "\u91F3": "hat1",
    "\u91F4": "jik6",
    "\u91F5": "caai1",
    "\u91F6": "si1/se4",
    "\u91F7": "tou2",
    "\u91F8": "zik6",
    "\u91F9": "neoi5/leoi5/neoi4/leoi4",
    "\u91FA": "cin1",
    "\u91FB": "jyun4",
    "\u91FC": "jat6",
    "\u91FD": "pik1/zaau2",
    "\u91FE": "je4/ngaa4/aa4",
    "\u91FF": "gan1",
    "\u9200": "baa2/paa4",
    "\u9201": "fong1",
    "\u9202": "cam4",
    "\u9203": "jing4/gin1",
    "\u9204": "dau2",
    "\u9205": "jyut6",
    "\u9206": "jyun4",
    "\u9207": "fu1/fu2",
    "\u9208": "bat1",
    "\u9209": "naap6/laap6",
    "\u920A": "sam1",
    "\u920B": "ngo4/o4",
    "\u920C": "kyut3",
    "\u920D": "deon6",
    "\u920E": "ngau1/au1",
    "\u920F": "jan6",
    "\u9210": "kim4",
    "\u9211": "baan2",
    "\u9212": "zaap6/saap3/kap1",
    "\u9213": "jam5",
    "\u9214": "caau1",
    "\u9215": "nau2/lau2",
    "\u9216": "fan1",
    "\u9217": "wan5",
    "\u9218": "ngai5/ai5",
    "\u9219": "kam4",
    "\u921A": "pai1/pei1",
    "\u921B": "gwo1/go1",
    "\u921C": "wang4",
    "\u921D": "jam4",
    "\u921E": "gwan1/kwan1",
    "\u921F": "diu3",
    "\u9220": "jik6",
    "\u9221": "zung1",
    "\u9222": "saai2",
    "\u9223": "koi3",
    "\u9224": "jat6",
    "\u9225": "fo2",
    "\u9226": "taai3",
    "\u9227": "kong3",
    "\u9228": "jyun4",
    "\u9229": "lou4",
    "\u922A": "aak3/aak2/ngaak3/ngaak2",
    "\u922B": "man4",
    "\u922C": "dok6",
    "\u922D": "zi1",
    "\u922E": "nei4/lei4/nei6/lei6",
    "\u922F": "dat6",
    "\u9230": "si5",
    "\u9231": "man4",
    "\u9232": "gu1/gwu1",
    "\u9233": "ko1",
    "\u9234": "ling4/ling1/ling2",
    "\u9235": "bing3",
    "\u9236": "zi6",
    "\u9237": "gu2/gwu2/gu1/gwu1",
    "\u9238": "bat6/but6",
    "\u9239": "pei4/pei1",
    "\u923A": "juk6",
    "\u923B": "zi6",
    "\u923C": "zok6",
    "\u923D": "bou1",
    "\u923E": "jau4/jau2",
    "\u923F": "tin4/din6",
    "\u9240": "gaap3",
    "\u9241": "zan1",
    "\u9242": "si2",
    "\u9243": "si6",
    "\u9244": "tit3",
    "\u9245": "geoi6",
    "\u9246": "cim1",
    "\u9247": "si1/se4",
    "\u9248": "taa1/to4/to2/si1/se4",
    "\u9249": "jyun5",
    "\u924A": "ziu1",
    "\u924B": "paau4",
    "\u924C": "wo4",
    "\u924D": "bei3/bit1",
    "\u924E": "sang1",
    "\u924F": "co4/ceoi4/zeoi2",
    "\u9250": "sek6",
    "\u9251": "bok6",
    "\u9252": "zyu3",
    "\u9253": "cik1",
    "\u9254": "zaap3",
    "\u9255": "po2",
    "\u9256": "tung4",
    "\u9257": "kim4/kim2",
    "\u9258": "fat6",
    "\u9259": "zaai2",
    "\u925A": "maau5",
    "\u925B": "jyun4",
    "\u925C": "fau4",
    "\u925D": "laap6",
    "\u925E": "jyut6",
    "\u925F": "pei1",
    "\u9260": "joeng1",
    "\u9261": "bun6",
    "\u9262": "but3",
    "\u9263": "gip3",
    "\u9264": "ngau1/au1",
    "\u9265": "seot6",
    "\u9266": "zing1/zing3",
    "\u9267": "mou5",
    "\u9268": "nai5/lai5",
    "\u9269": "saai2",
    "\u926A": "dai6",
    "\u926B": "gaa1",
    "\u926C": "muk6",
    "\u926D": "taan2/daan3",
    "\u926E": "san4",
    "\u926F": "ji5",
    "\u9270": "si1",
    "\u9271": "kong3",
    "\u9272": "kaa1",
    "\u9273": "bak1",
    "\u9274": "gaam3",
    "\u9275": "tung4",
    "\u9276": "jing4",
    "\u9277": "hung4",
    "\u9278": "gaau2/gaau3",
    "\u9279": "ci2",
    "\u927A": "ji5",
    "\u927B": "lok3/gok3/lok6",
    "\u927C": "beng2/ping4",
    "\u927D": "sik1",
    "\u927E": "mau4",
    "\u927F": "haa1/hap6/hap1/gaap3",
    "\u9280": "ngan4/an4/ngan2/an2",
    "\u9281": "gwan1",
    "\u9282": "zau1",
    "\u9283": "cung3",
    "\u9284": "hoeng2",
    "\u9285": "tung4",
    "\u9286": "mak6",
    "\u9287": "loi6",
    "\u9288": "gwai1",
    "\u9289": "jyut6",
    "\u928A": "seot1",
    "\u928B": "jam5/jam4",
    "\u928C": "zyun6",
    "\u928D": "zat6",
    "\u928E": "kung4",
    "\u928F": "saan3",
    "\u9290": "cai3",
    "\u9291": "sin2",
    "\u9292": "jing4/gin1",
    "\u9293": "cyun4",
    "\u9294": "pei1",
    "\u9295": "tit3",
    "\u9296": "zyu1",
    "\u9297": "hong6/hau6/hau4",
    "\u9298": "ming4/ming2/ming5",
    "\u9299": "kwaa1",
    "\u929A": "diu6/jiu4/tiu4",
    "\u929B": "cim1",
    "\u929C": "haam4/ham4",
    "\u929D": "jau1",
    "\u929E": "gwan1",
    "\u929F": "caa1",
    "\u92A0": "lou5",
    "\u92A1": "gat1",
    "\u92A2": "pik1",
    "\u92A3": "jyu4/jyu6",
    "\u92A4": "mai5",
    "\u92A5": "ji1",
    "\u92A6": "jan1",
    "\u92A7": "gwong1/gong1",
    "\u92A8": "on1/ngon1/on2/ngon2",
    "\u92A9": "diu1",
    "\u92AA": "jau5",
    "\u92AB": "sik1",
    "\u92AC": "kaau3/kau3",
    "\u92AD": "cin4",
    "\u92AE": "lyun4",
    "\u92AF": "mik6",
    "\u92B0": "ngaai6/aai6",
    "\u92B1": "diu3",
    "\u92B2": "hon6",
    "\u92B3": "jeoi6",
    "\u92B4": "sai6",
    "\u92B5": "hang1",
    "\u92B6": "kau4",
    "\u92B7": "siu1",
    "\u92B8": "zip3",
    "\u92B9": "sau3",
    "\u92BA": "zong6",
    "\u92BB": "tai1",
    "\u92BC": "co3/co2",
    "\u92BD": "cim1",
    "\u92BE": "hung3",
    "\u92BF": "zung1",
    "\u92C0": "tau1/dau6",
    "\u92C1": "leoi5",
    "\u92C2": "mui4",
    "\u92C3": "long4",
    "\u92C4": "faan6",
    "\u92C5": "san1",
    "\u92C6": "wan4",
    "\u92C7": "bui3",
    "\u92C8": "juk1",
    "\u92C9": "suk1",
    "\u92CA": "juk6",
    "\u92CB": "sin4/jin4",
    "\u92CC": "ding3/ding6/ting5",
    "\u92CD": "but6",
    "\u92CE": "waan5",
    "\u92CF": "gaap3",
    "\u92D0": "wang4",
    "\u92D1": "cyun1",
    "\u92D2": "fung1",
    "\u92D3": "cim1",
    "\u92D4": "waan5",
    "\u92D5": "zi3",
    "\u92D6": "si1",
    "\u92D7": "hyun1",
    "\u92D8": "waa4/ng4/m4",
    "\u92D9": "jyu5/ng4/m4",
    "\u92DA": "tiu4",
    "\u92DB": "kong3",
    "\u92DC": "zok6/zuk1/zuk6",
    "\u92DD": "lyut3",
    "\u92DE": "jing4",
    "\u92DF": "cim1",
    "\u92E0": "san6",
    "\u92E1": "ham4",
    "\u92E2": "lyut3",
    "\u92E3": "je4",
    "\u92E4": "co4",
    "\u92E5": "caang3/cang3",
    "\u92E6": "guk1/guk6",
    "\u92E7": "jin6",
    "\u92E8": "ngo4/o4",
    "\u92E9": "mong4",
    "\u92EA": "pou1/pou3",
    "\u92EB": "lei4",
    "\u92EC": "paan3",
    "\u92ED": "jeoi6",
    "\u92EE": "sing4",
    "\u92EF": "gou3",
    "\u92F0": "lei5",
    "\u92F1": "tik1",
    "\u92F2": "bing1",
    "\u92F3": "zyu3",
    "\u92F4": "hak1",
    "\u92F5": "tuk1",
    "\u92F6": "lau5",
    "\u92F7": "je4",
    "\u92F8": "geoi3/goe3/guk1",
    "\u92F9": "cong2/coeng2",
    "\u92FA": "jyun2",
    "\u92FB": "gin3",
    "\u92FC": "gong3/gong1",
    "\u92FD": "tiu3",
    "\u92FE": "tou4",
    "\u92FF": "soeng4",
    "\u9300": "leon4",
    "\u9301": "gwo2/go2/fo3",
    "\u9302": "ling4",
    "\u9303": "bei1",
    "\u9304": "luk6/luk2",
    "\u9305": "lei4",
    "\u9306": "coeng1",
    "\u9307": "pui4",
    "\u9308": "gyun2",
    "\u9309": "man4",
    "\u930A": "zeoi3",
    "\u930B": "paang4",
    "\u930C": "ngon6/on6",
    "\u930D": "pai1",
    "\u930E": "haam6",
    "\u930F": "aa1/ngaa1",
    "\u9310": "zeoi1",
    "\u9311": "leoi6",
    "\u9312": "aa3/ngaa3/aa1/ngaa1/o1/ngo1",
    "\u9313": "kwang1",
    "\u9314": "taap3/daap6",
    "\u9315": "kwan1",
    "\u9316": "duk1",
    "\u9317": "neoi6/leoi6",
    "\u9318": "ceoi4/ceoi2",
    "\u9319": "zi1",
    "\u931A": "zang1/zaang1",
    "\u931B": "ban1",
    "\u931C": "nip6/lip6",
    "\u931D": "zung3",
    "\u931E": "deoi6/seon4",
    "\u931F": "taam4/cim1",
    "\u9320": "ding3/ding6",
    "\u9321": "kei4",
    "\u9322": "cin4/cin2/zin2",
    "\u9323": "zyut3",
    "\u9324": "gei1",
    "\u9325": "juk6",
    "\u9326": "gam2",
    "\u9327": "gun2/gwun2",
    "\u9328": "naau4/laau4/maau4",
    "\u9329": "coeng1",
    "\u932A": "tin2",
    "\u932B": "sek3/sik3",
    "\u932C": "lin6",
    "\u932D": "diu1",
    "\u932E": "gu3/gwu3",
    "\u932F": "co3/cok3/cou3",
    "\u9330": "seot6",
    "\u9331": "zan1",
    "\u9332": "luk6",
    "\u9333": "maang5",
    "\u9334": "luk6",
    "\u9335": "waa4",
    "\u9336": "biu1",
    "\u9337": "aat3/ngaat3",
    "\u9338": "loi4",
    "\u9339": "hang2",
    "\u933A": "fong1",
    "\u933B": "mou5",
    "\u933C": "noi6/loi6",
    "\u933D": "faan6",
    "\u933E": "zaam6",
    "\u933F": "fu2",
    "\u9340": "dak1",
    "\u9341": "him1/hin1",
    "\u9342": "gam1",
    "\u9343": "fat1/kut3/kwut3",
    "\u9344": "loeng6",
    "\u9345": "faat3",
    "\u9346": "mun4",
    "\u9347": "kaai2/gaai1",
    "\u9348": "joeng1",
    "\u9349": "dik6/si4",
    "\u934A": "lin6/lin2",
    "\u934B": "wo1",
    "\u934C": "sin2",
    "\u934D": "dou6",
    "\u934E": "dat6",
    "\u934F": "wai4",
    "\u9350": "zung1",
    "\u9351": "fuk1/fu3",
    "\u9352": "jau4",
    "\u9353": "cip3",
    "\u9354": "ngok6/ok6",
    "\u9355": "gwan1",
    "\u9356": "zam1/cam2",
    "\u9357": "tai4",
    "\u9358": "zaap6/zaat3",
    "\u9359": "huk1",
    "\u935A": "joeng4",
    "\u935B": "dyun3",
    "\u935C": "haa4",
    "\u935D": "jyu4",
    "\u935E": "hang1",
    "\u935F": "seng3",
    "\u9360": "wong4",
    "\u9361": "wui2",
    "\u9362": "fuk1",
    "\u9363": "ziu1",
    "\u9364": "caap3",
    "\u9365": "kit3",
    "\u9366": "se4/si1",
    "\u9367": "gwang1",
    "\u9368": "kwai4",
    "\u9369": "nok6/lok6",
    "\u936A": "mau4",
    "\u936B": "ciu1",
    "\u936C": "ciu1",
    "\u936D": "hau4",
    "\u936E": "tau1",
    "\u936F": "cung1",
    "\u9370": "waan4/wun4",
    "\u9371": "jip6",
    "\u9372": "man4",
    "\u9373": "gaam3",
    "\u9374": "dyun1",
    "\u9375": "gin6",
    "\u9376": "si1",
    "\u9377": "fui1",
    "\u9378": "wu4",
    "\u9379": "syun1",
    "\u937A": "ze2",
    "\u937B": "git3",
    "\u937C": "kim4/zam1",
    "\u937D": "bin1",
    "\u937E": "zung1",
    "\u937F": "zi1",
    "\u9380": "sau1",
    "\u9381": "je4",
    "\u9382": "mei5",
    "\u9383": "paai3",
    "\u8E48": "dou6/tou1",
    "\u8E49": "co1",
    "\u8E4A": "hai4/kei1/kai1",
    "\u8E4B": "daap6/taap3",
    "\u8E4C": "coeng1/coeng3",
    "\u8E4D": "nin5/lin5/zin2",
    "\u8E4E": "din1",
    "\u8E4F": "tai4/dai6",
    "\u8E50": "zik3/zek3",
    "\u8E51": "nip6/lip6",
    "\u8E52": "pun4/mun4",
    "\u8E53": "lau6/lau4",
    "\u8E54": "zaam6",
    "\u8E55": "bat1",
    "\u8E56": "zung1",
    "\u8E57": "luk6",
    "\u8E58": "laau4",
    "\u8E59": "cuk1",
    "\u8E5A": "tong3/tong2/tong1",
    "\u8E5B": "zai6/daai3",
    "\u8E5C": "suk1",
    "\u8E5D": "saai2",
    "\u8E5E": "kwai2",
    "\u8E5F": "zik1",
    "\u8E60": "zik3/zek3",
    "\u8E61": "coeng1/coeng3",
    "\u8E62": "zaak6/dik1",
    "\u8E63": "pun4/mun4",
    "\u8E64": "zung1",
    "\u8E65": "lin4",
    "\u8E66": "bang1",
    "\u8E67": "zou1",
    "\u8E68": "nim3/lim3",
    "\u8E69": "bit6",
    "\u8E6A": "teoi4",
    "\u8E6B": "gwat1",
    "\u8E6C": "dang1/dang6",
    "\u8E6D": "sang3",
    "\u8E6E": "sin1",
    "\u8E6F": "faan4",
    "\u8E70": "cyu4",
    "\u8E71": "zung1",
    "\u8E72": "cyun4/deon1/zeon1",
    "\u8E73": "but6",
    "\u8E74": "cuk1",
    "\u8E75": "cuk1",
    "\u8E76": "kyut3/gwai3",
    "\u8E77": "kyut3",
    "\u8E78": "leon6",
    "\u8E79": "daap6",
    "\u8E7A": "kiu5/hiu1/kiu1/kiu2",
    "\u8E7B": "giu2/kiu5/hiu1/kiu1/kiu2/goek3",
    "\u8E7C": "buk6/puk3",
    "\u8E7D": "liu1/liu4",
    "\u8E7E": "dan3/dan1",
    "\u8E7F": "cyun1",
    "\u8E80": "gwaan3",
    "\u8E81": "cou3",
    "\u8E82": "taat3",
    "\u8E83": "bik1",
    "\u8E84": "bik1",
    "\u8E85": "zuk6/zok6",
    "\u8E86": "geoi3",
    "\u8E87": "cyu4/coek3",
    "\u8E88": "kiu3",
    "\u8E89": "dan2",
    "\u8E8A": "cau4",
    "\u8E8B": "zai1",
    "\u8E8C": "mou5",
    "\u8E8D": "joek6/joek3/tik1",
    "\u8E8E": "nin2/lin2",
    "\u8E8F": "leon6",
    "\u8E90": "lip6",
    "\u8E91": "zaak6",
    "\u8E92": "lik1/lok6/lok3",
    "\u8E93": "zi3",
    "\u8E94": "cin4",
    "\u8E95": "cyu4",
    "\u8E96": "teon2",
    "\u8E97": "wai6",
    "\u8E98": "lung4",
    "\u8E99": "leon6",
    "\u8E9A": "sin1",
    "\u8E9B": "wai6",
    "\u8E9C": "zyun1",
    "\u8E9D": "laan1",
    "\u8E9E": "sip3/sit3",
    "\u8E9F": "joeng4",
    "\u8EA0": "sit3",
    "\u8EA1": "nip6/lip6",
    "\u8EA2": "daap6/taap3",
    "\u8EA3": "keoi4",
    "\u8EA4": "zik6",
    "\u8EA5": "cyun1",
    "\u8EA6": "zyun1",
    "\u8EA7": "saai2",
    "\u8EA8": "kwai4",
    "\u8EA9": "fok3",
    "\u8EAA": "leon6",
    "\u8EAB": "san1/gyun1",
    "\u8EAC": "gung1",
    "\u8EAD": "daam1",
    "\u8EAE": "fan1",
    "\u8EAF": "keoi1",
    "\u8EB0": "tai2",
    "\u8EB1": "do2",
    "\u8EB2": "do2",
    "\u8EB3": "gung1",
    "\u8EB4": "long4",
    "\u8EB5": "jan2",
    "\u8EB6": "lo2",
    "\u8EB7": "ai2/ngai2",
    "\u8EB8": "gei1",
    "\u8EB9": "guk1",
    "\u8EBA": "tong2",
    "\u8EBB": "hung1",
    "\u8EBC": "lou6",
    "\u8EBD": "jin2",
    "\u8EBE": "mei5",
    "\u8EBF": "hong1",
    "\u8EC0": "keoi1",
    "\u8EC1": "lau4",
    "\u8EC2": "lou6",
    "\u8EC3": "do2",
    "\u8EC4": "zik1",
    "\u8EC5": "ngaan6/aan6",
    "\u8EC6": "tai2",
    "\u8EC7": "dou6",
    "\u8EC8": "jing3",
    "\u8EC9": "juk6",
    "\u8ECA": "ce1/geoi1",
    "\u8ECB": "aat3/ngaat3/zaat3/gaat3",
    "\u8ECC": "gwai2",
    "\u8ECD": "gwan1",
    "\u8ECE": "wai6",
    "\u8ECF": "jyut6",
    "\u8ED0": "seon3",
    "\u8ED1": "dai6/daai6",
    "\u8ED2": "hin1",
    "\u8ED3": "faan6",
    "\u8ED4": "jan6",
    "\u8ED5": "sim1",
    "\u8ED6": "kwong4/kong4",
    "\u8ED7": "syu4",
    "\u8ED8": "tyun4",
    "\u8ED9": "can4",
    "\u8EDA": "taai5",
    "\u8EDB": "aak1/ngaak1",
    "\u8EDC": "naap6/laap6",
    "\u8EDD": "kei4",
    "\u8EDE": "mou4",
    "\u8EDF": "jyun5",
    "\u8EE0": "kwong4/kong4",
    "\u8EE1": "kim4",
    "\u8EE2": "zyun2",
    "\u8EE3": "gwang1",
    "\u8EE4": "fu1",
    "\u8EE5": "keoi4/gau1",
    "\u8EE6": "fong3",
    "\u8EE7": "dai2",
    "\u8EE8": "ling4",
    "\u8EE9": "toi5",
    "\u8EEA": "au1/ngau1",
    "\u8EEB": "zan2/can2",
    "\u8EEC": "faan6",
    "\u8EED": "waang1",
    "\u8EEE": "ong2/ngong2/ong3/ngong3",
    "\u8EEF": "paang1",
    "\u8EF0": "bui3",
    "\u8EF1": "gu1/gwu1",
    "\u8EF2": "gu1/gwu1",
    "\u8EF3": "pou4",
    "\u8EF4": "zyu3",
    "\u8EF5": "fu2/jung5",
    "\u8EF6": "aak1/ngaak1",
    "\u8EF7": "bat6",
    "\u8EF8": "zuk6",
    "\u8EF9": "zi2",
    "\u8EFA": "jiu4",
    "\u8EFB": "o1/ngo1/ho2",
    "\u8EFC": "jat6/dit6",
    "\u8EFD": "zi3",
    "\u8EFE": "sik1",
    "\u8EFF": "ping4",
    "\u8F00": "ji4",
    "\u8F01": "gung2",
    "\u8F02": "guk1/guk6",
    "\u8F03": "gaau3",
    "\u8F04": "gwong1/gong1",
    "\u8F05": "lou6",
    "\u8F06": "hoi2",
    "\u8F07": "cyun4",
    "\u8F08": "zau1",
    "\u8F09": "zoi3/zoi2",
    "\u8F0A": "zi3",
    "\u8F0B": "se4/ce4",
    "\u8F0C": "loeng6",
    "\u8F0D": "juk6",
    "\u8F0E": "saau1",
    "\u8F0F": "jau4",
    "\u8F10": "wun6",
    "\u8F11": "wan5",
    "\u8F12": "zip3/zit3",
    "\u8F13": "waan5/maan5",
    "\u8F14": "fu6",
    "\u8F15": "hing1/heng1/heng6",
    "\u8F16": "zau1",
    "\u8F17": "ngai4/ai4",
    "\u8F18": "ling4",
    "\u8F19": "zip3/zit3",
    "\u8F1A": "zaan6",
    "\u8F1B": "loeng6/loeng2",
    "\u8F1C": "zi1",
    "\u8F1D": "fai1",
    "\u8F1E": "mong5",
    "\u8F1F": "zyut3/zyut6",
    "\u8F20": "gwo2/go2/waa5",
    "\u8F21": "ham2",
    "\u8F22": "ji2",
    "\u8F23": "paang4",
    "\u8F24": "sin3",
    "\u8F25": "gwan2",
    "\u8F26": "lin5",
    "\u8F27": "ping4",
    "\u8F28": "gun2/gwun2",
    "\u8F29": "bui3",
    "\u8F2A": "leon4/leon2",
    "\u8F2B": "paai4/pui4",
    "\u8F2C": "loeng4",
    "\u8F2D": "jyun5",
    "\u8F2E": "jau4",
    "\u8F2F": "cap1",
    "\u8F30": "joeng4",
    "\u8F31": "haam4",
    "\u8F32": "cyun4/syun4",
    "\u8F33": "cau3",
    "\u8F34": "ceon1",
    "\u8F35": "got3",
    "\u8F36": "jau4",
    "\u8F37": "gwang1",
    "\u8F38": "syu1",
    "\u8F39": "fuk1",
    "\u8F3A": "zi1",
    "\u8F3B": "fuk1",
    "\u8F3C": "wan1",
    "\u8F3D": "ban6",
    "\u8F3E": "zin2/nin5/lin5",
    "\u8F3F": "jyu4",
    "\u8F40": "wan1",
    "\u8F41": "tou1",
    "\u8F42": "guk1/gu1/gwu1",
    "\u8F43": "zeon1",
    "\u8F44": "hat6",
    "\u8F45": "jyun4",
    "\u8F46": "luk1",
    "\u8F47": "gaau1",
    "\u8F48": "caau4",
    "\u8F49": "zyun2/zyun3",
    "\u8F4A": "wai6",
    "\u8F4B": "wan4",
    "\u8F4C": "syut3",
    "\u8F4D": "cit3",
    "\u8F4E": "giu2/giu6/kiu2",
    "\u8F4F": "zaan6",
    "\u8F50": "buk6",
    "\u8F51": "lou5/lou4/liu4",
    "\u8F52": "fan4",
    "\u8F53": "faan1",
    "\u8F54": "leon4/leon6",
    "\u8F55": "got3",
    "\u8F56": "sik1",
    "\u8F57": "ham2",
    "\u8F58": "waan4/waan6",
    "\u8F59": "ngai5/ai5",
    "\u8F5A": "gik1",
    "\u8F5B": "deoi3",
    "\u8F5C": "ji4",
    "\u8F5D": "jyu4",
    "\u8F5E": "laam6",
    "\u8F5F": "gwang1",
    "\u8F60": "leoi4",
    "\u8F61": "bei3",
    "\u8F62": "lik1",
    "\u8F63": "lit6/lik6",
    "\u8F64": "lou4",
    "\u8F65": "leon6",
    "\u8F66": "ce1/geoi1",
    "\u8F67": "aat3/ngaat3/zaat3/gaat3",
    "\u8F68": "gwai2",
    "\u8F69": "hin1",
    "\u8F6A": "dai6/daai6",
    "\u8F6B": "jan6",
    "\u8F6C": "zyun2/zyun3",
    "\u8F6D": "aak1/ngaak1",
    "\u8F6E": "leon4/leon2",
    "\u8F6F": "jyun5",
    "\u8F70": "gwang1",
    "\u8F71": "gu1/gwu1",
    "\u8F72": "o1/ngo1/ho2",
    "\u8F73": "lou4",
    "\u8F74": "zuk6",
    "\u8F75": "zi2",
    "\u8F76": "jat6/dit6",
    "\u8F77": "fu1",
    "\u8F78": "zan2/can2",
    "\u8F79": "lik1",
    "\u8F7A": "jiu4",
    "\u8F7B": "hing1/heng1/heng6",
    "\u8F7C": "sik1",
    "\u8F7D": "zoi3/zoi2",
    "\u8F7E": "zi3",
    "\u8F7F": "giu2/giu6/kiu2",
    "\u8F80": "zau1",
    "\u8F81": "cyun4",
    "\u8F82": "lou6",
    "\u8F83": "gaau3",
    "\u8F84": "zip3/zit3",
    "\u8F85": "fu6",
    "\u8F86": "loeng6/loeng2",
    "\u8F87": "lin5",
    "\u8F88": "bui3",
    "\u8F89": "fai1",
    "\u8F8A": "gwan2",
    "\u8F8B": "mong5",
    "\u8F8C": "loeng4",
    "\u8F8D": "zyut3/zyut6",
    "\u8F8E": "zi1",
    "\u8F8F": "cau3",
    "\u8F90": "fuk1",
    "\u8F91": "cap1",
    "\u8F92": "wan1",
    "\u8F93": "syu1",
    "\u8F94": "bei3",
    "\u8F95": "jyun4",
    "\u8F96": "hat6",
    "\u8F97": "zin2/nin5/lin5",
    "\u8F98": "luk1",
    "\u8F99": "cit3",
    "\u8F9A": "leon4/leon6",
    "\u8F9B": "san1",
    "\u8F9C": "gu1/gwu1",
    "\u8F9D": "ci4",
    "\u8F9E": "ci4",
    "\u8F9F": "pik1/bik1/bei6",
    "\u8FA0": "zeoi6",
    "\u8FA1": "bin6",
    "\u8FA2": "laat6",
    "\u8FA3": "laat6/laat2",
    "\u8FA4": "ci4",
    "\u8FA5": "sit3",
    "\u8FA6": "baan6/baan2",
    "\u8FA7": "bin6",
    "\u8FA8": "bin6",
    "\u8FA9": "bin6",
    "\u8FAA": "sit3",
    "\u8FAB": "bin1",
    "\u8FAC": "baan1",
    "\u8FAD": "ci4",
    "\u8FAE": "bin1",
    "\u8FAF": "bin6",
    "\u8FB0": "san4",
    "\u8FB1": "juk6",
    "\u8FB2": "nung4/lung4",
    "\u8FB3": "nung4/lung4",
    "\u8FB4": "can2/zin2",
    "\u8FB5": "coek3",
    "\u8FB6": "caang1.teng5",
    "\u8FB7": "jat1",
    "\u8FB8": "jing4",
    "\u8FB9": "bin1/bin6",
    "\u8FBA": "dou6",
    "\u8FBB": "sap6",
    "\u8FBC": "jyu1",
    "\u8FBD": "liu4",
    "\u8FBE": "daat6/taat3/dai3",
    "\u8FBF": "cin4",
    "\u8FC0": "gon1",
    "\u8FC1": "cin1",
    "\u8FC2": "jyu1",
    "\u8FC3": "jyu1",
    "\u8FC4": "ngat6/at6/hat1",
    "\u8FC5": "seon3",
    "\u8FC6": "ji5/ji4/to1",
    "\u8FC7": "gwo3/go3/gwo2/go2/gwo1/go1",
    "\u8FC8": "maai6",
    "\u8FC9": "cai1",
    "\u8FCA": "jing4",
    "\u8FCB": "wong6/gwong2/gong2/kwaang3",
    "\u8FCC": "teot1",
    "\u8FCD": "zeon1/tyun4",
    "\u8FCE": "jing4/jing6",
    "\u8FCF": "dai3",
    "\u8FD0": "wan6",
    "\u8FD1": "gan6/gan2/kan5",
    "\u8FD2": "hong4",
    "\u8FD3": "ngaa6/aa6",
    "\u8FD4": "faan2/faan1",
    "\u8FD5": "ng5/m5/ng6/m6",
    "\u8FD6": "dai3",
    "\u8FD7": "ngo4/o4",
    "\u8FD8": "waan4/syun4",
    "\u8FD9": "ze5/ze3/ze2",
    "\u8FDA": "zung1",
    "\u8FDB": "zeon3",
    "\u8FDC": "jyun5/jyun2/jyun6",
    "\u8FDD": "wai4",
    "\u8FDE": "lin4",
    "\u8FDF": "ci4",
    "\u8FE0": "gin3",
    "\u8FE1": "nai6/lai6",
    "\u8FE2": "tiu4/siu4",
    "\u8FE3": "lit6/lai6",
    "\u8FE4": "ji5/ji4/to1",
    "\u8FE5": "gwing2",
    "\u8FE6": "haai6/gaa1",
    "\u8FE7": "can4",
    "\u8FE8": "doi6/toi5",
    "\u8FE9": "ji5",
    "\u8FEA": "dik6",
    "\u8FEB": "baak1/bik1",
    "\u8FEC": "zyu3",
    "\u8FED": "dit6/jat6",
    "\u8FEE": "zaak3",
    "\u8FEF": "tou4",
    "\u8FF0": "seot6",
    "\u8FF1": "to4",
    "\u8FF2": "heoi3",
    "\u8FF3": "ging3/gaang3",
    "\u8FF4": "wui4",
    "\u8FF5": "dung6",
    "\u8FF6": "jau6",
    "\u8FF7": "mai4",
    "\u8FF8": "bing3/bing2",
    "\u8FF9": "zik1",
    "\u8FFA": "naai5/laai5",
    "\u8FFB": "ji4",
    "\u8FFC": "kit3",
    "\u8FFD": "zeoi1",
    "\u8FFE": "lit6/laat6",
    "\u8FFF": "seon6",
    "\u9000": "teoi3",
    "\u9001": "sung3",
    "\u9002": "sik1/dik1/tik1/zaak3/zaak6/kut3/kwut3",
    "\u9003": "tou4",
    "\u9004": "pong4",
    "\u9005": "hau6",
    "\u9006": "jik6/ngaak6/aak6",
    "\u9007": "deon6",
    "\u9008": "gwing2",
    "\u9009": "syun2/syun3",
    "\u900A": "seon3",
    "\u900B": "bou1",
    "\u900C": "jau4",
    "\u900D": "siu1",
    "\u900E": "cau4",
    "\u900F": "tau3",
    "\u9010": "zuk6/dik6",
    "\u9011": "kau4",
    "\u9012": "dai6",
    "\u9013": "dai6",
    "\u9014": "tou4",
    "\u9015": "ging3/gaang3",
    "\u9016": "tik1",
    "\u9017": "dau6",
    "\u9018": "ji4",
    "\u9019": "ze5/ze3/ze2",
    "\u901A": "tung1",
    "\u901B": "kwaang3/gwaang6",
    "\u901C": "ng6/m6",
    "\u901D": "sai6",
    "\u901E": "cing2",
    "\u901F": "cuk1",
    "\u9020": "zou6/zou2/cou3/cou5",
    "\u9021": "seon1/ceon1",
    "\u9022": "fung4/pung4",
    "\u9023": "lin4",
    "\u9024": "so3",
    "\u9025": "wui4",
    "\u9026": "lei5",
    "\u9027": "guk1",
    "\u9028": "loi4",
    "\u9029": "ban3/ban1",
    "\u902A": "cok3",
    "\u902B": "zyut3",
    "\u902C": "bing3/bing2",
    "\u902D": "wun6",
    "\u902E": "dai6/doi6",
    "\u902F": "luk6",
    "\u9030": "jau4",
    "\u9031": "zau1",
    "\u9032": "zeon3",
    "\u9033": "juk1",
    "\u9034": "coek3",
    "\u9035": "kwai4",
    "\u9036": "wai1/wai2",
    "\u9037": "tik1",
    "\u9038": "jat6/jat2",
    "\u9039": "daat6",
    "\u903A": "jyun5",
    "\u903B": "lo4",
    "\u903C": "bik1",
    "\u903D": "noek6/loek6",
    "\u903E": "jyu4",
    "\u903F": "dong6/tik1/tong4",
    "\u9040": "ceoi4",
    "\u9041": "deon6",
    "\u9042": "seoi6",
    "\u9043": "jin5",
    "\u9044": "cyun4",
    "\u9045": "ci4",
    "\u9046": "tai4",
    "\u9047": "jyu6",
    "\u9048": "zik6",
    "\u9049": "zing1",
    "\u904A": "jau4",
    "\u904B": "wan6",
    "\u904C": "ngok6/ok6",
    "\u904D": "pin3",
    "\u904E": "gwo3/go3/gwo2/go2/gwo1/go1",
    "\u904F": "aat3/ngaat3/kit3",
    "\u9050": "haa4",
    "\u9051": "wong4",
    "\u9052": "cau4",
    "\u9053": "dou6/dou2/dou3",
    "\u9054": "daat6/taat3",
    "\u9055": "wai4",
    "\u9056": "naam4/laam4",
    "\u9057": "wai4/wai6",
    "\u9058": "gau3",
    "\u9059": "jiu4",
    "\u905A": "cau3",
    "\u905B": "lau6/lau4/liu4",
    "\u905C": "seon3",
    "\u905D": "daap6",
    "\u905E": "dai6",
    "\u905F": "ci4",
    "\u9060": "jyun5/jyun2/jyun6",
    "\u9061": "sou3",
    "\u9062": "taap3/taat3",
    "\u9063": "hin2",
    "\u9064": "maa5",
    "\u9065": "jiu4",
    "\u9066": "gwaan3",
    "\u9067": "zoeng1",
    "\u9068": "ngou4/ou4/ngou6/ou6",
    "\u9069": "sik1/dik1/tik1/zaak3/zaak6",
    "\u906A": "caap3",
    "\u906B": "cik1",
    "\u906C": "cuk1",
    "\u906D": "zou1",
    "\u906E": "ze1",
    "\u906F": "deon6",
    "\u9070": "dai6/sai6",
    "\u9071": "lau4",
    "\u9072": "ci4",
    "\u9073": "co1",
    "\u9074": "leon4/leon6",
    "\u9075": "zeon1/zyun1",
    "\u9076": "jiu2/jiu5",
    "\u9077": "cin1",
    "\u9078": "syun2/syun3",
    "\u9079": "wat6",
    "\u907A": "wai4/wai6",
    "\u907B": "ngok6/ok6/ng6/m6",
    "\u907C": "liu4",
    "\u907D": "geoi6",
    "\u907E": "sai6",
    "\u907F": "bei6",
    "\u9080": "jiu1",
    "\u9081": "maai6",
    "\u9082": "haai5/haai6",
    "\u9083": "seoi6",
    "\u9084": "waan4/syun4",
    "\u9085": "zin1",
    "\u9086": "tang4",
    "\u9087": "ji5",
    "\u9088": "miu5/mok6",
    "\u9089": "bin1",
    "\u908A": "bin1/bin6",
    "\u908B": "laap6/laat6/laat3/lip6",
    "\u908C": "lai4",
    "\u908D": "jyun4",
    "\u908E": "jau4",
    "\u908F": "lo4",
    "\u9090": "lei5",
    "\u9091": "jap1/ap1/ngap1",
    "\u9092": "ting4",
    "\u9093": "dang6",
    "\u9094": "hei2",
    "\u9095": "jung1",
    "\u9096": "saan1",
    "\u9097": "hon4",
    "\u9098": "jyu1",
    "\u9099": "mong4",
    "\u909A": "jyu4",
    "\u909B": "kung4",
    "\u909C": "zik6",
    "\u909D": "kwong3/kong3/kwong2/kong2",
    "\u909E": "fu1",
    "\u909F": "kong3",
    "\u90A0": "ban1",
    "\u90A1": "fong1",
    "\u90A2": "jing4",
    "\u90A3": "naa5/laa5/no4/lo4/naa4/laa4/naa1/laa1/no1/lo1",
    "\u90A4": "jan1",
    "\u90A5": "sam2",
    "\u90A6": "bong1",
    "\u90A7": "jyun4",
    "\u90A8": "cyun1",
    "\u90A9": "fo2",
    "\u90AA": "ce4/je4",
    "\u90AB": "bong1",
    "\u90AC": "wu1",
    "\u90AD": "geoi3",
    "\u90AE": "jau4",
    "\u90AF": "hon4",
    "\u90B0": "toi4",
    "\u90B1": "jau1",
    "\u90B2": "bei3/bat6/bin6",
    "\u90B3": "pei4",
    "\u90B4": "bing2",
    "\u90B5": "siu6",
    "\u90B6": "bui3",
    "\u90B7": "ngaa5/aa5",
    "\u90B8": "dai2",
    "\u90B9": "zau1",
    "\u90BA": "jip6",
    "\u90BB": "leon4",
    "\u90BC": "hong1",
    "\u90BD": "gwai1",
    "\u90BE": "zyu1",
    "\u90BF": "si1",
    "\u90C0": "fu1",
    "\u90C1": "juk1/wat1",
    "\u90C2": "goi1",
    "\u90C3": "hap6/gap3",
    "\u90C4": "gwik1",
    "\u90C5": "zat6/gat1",
    "\u90C6": "gat1",
    "\u90C7": "seon1/wan4",
    "\u90C8": "hau6",
    "\u90C9": "jing4",
    "\u8BC7": "hing3/gwing2",
    "\u8BC8": "zaa3",
    "\u8BC9": "sou3",
    "\u8BCA": "can2/zan2",
    "\u8BCB": "dai2",
    "\u8BCC": "zau1/zau3",
    "\u8BCD": "ci4",
    "\u8BCE": "wat1/zeot1",
    "\u8BCF": "ziu3/ziu6",
    "\u8BD0": "bei3/bei1",
    "\u8BD1": "jik6/jik2",
    "\u8BD2": "ji4/doi6",
    "\u8BD3": "hong1/kwong4/kong4/gwong2/gong2",
    "\u8BD4": "loi6/leoi6",
    "\u8BD5": "si3/si5",
    "\u8BD6": "gwaa3",
    "\u8BD7": "si1",
    "\u8BD8": "kit3/gat1",
    "\u8BD9": "fui1",
    "\u8BDA": "sing4/sing2",
    "\u8BDB": "zyu1",
    "\u8BDC": "san1",
    "\u8BDD": "waa6/waa2",
    "\u8BDE": "daan3",
    "\u8BDF": "gau3",
    "\u8BE0": "cyun4",
    "\u8BE1": "gwai2",
    "\u8BE2": "seon1",
    "\u8BE3": "ngai6/ai6",
    "\u8BE4": "zaang3/zang3/zaang1/zang1",
    "\u8BE5": "goi1",
    "\u8BE6": "coeng4",
    "\u8BE7": "caa3",
    "\u8BE8": "wan6",
    "\u8BE9": "heoi2",
    "\u8BEA": "zau1",
    "\u8BEB": "gaai3",
    "\u8BEC": "mou4",
    "\u8BED": "jyu5/jyu6",
    "\u8BEE": "ciu3",
    "\u8BEF": "ng6/m6",
    "\u8BF0": "gou3",
    "\u8BF1": "jau5",
    "\u8BF2": "fui3",
    "\u8BF3": "gwong2/gong2/kong4/kwong4",
    "\u8BF4": "syut3/seoi3/jyut6",
    "\u8BF5": "zung6",
    "\u8BF6": "ei6/ngei6/ei1/ngei1/ei3/ngei3/oi1/ngoi1/aai2/ngaai2/e6/nge6",
    "\u8BF7": "cing2/ceng2",
    "\u8BF8": "zyu1",
    "\u8BF9": "zau1",
    "\u8BFA": "nok6/lok6",
    "\u8BFB": "duk6/dau6",
    "\u8BFC": "doek3",
    "\u8BFD": "fei2",
    "\u8BFE": "fo3",
    "\u8BFF": "wai2",
    "\u8C00": "jyu4",
    "\u8C01": "seoi4/seoi2",
    "\u8C02": "sam2/nam2/lam2",
    "\u8C03": "diu6/diu2/deu6/tiu4",
    "\u8C04": "cim2",
    "\u8C05": "loeng6/loeng4",
    "\u8C06": "zeon1/deon1",
    "\u8C07": "seoi6",
    "\u8C08": "taam4",
    "\u8C09": "sam2",
    "\u8C0A": "ji4/ji6",
    "\u8C0B": "mau4",
    "\u8C0C": "sam4",
    "\u8C0D": "dip6",
    "\u8C0E": "fong1/fong2",
    "\u8C0F": "gaan3",
    "\u8C10": "haai4",
    "\u8C11": "joek6",
    "\u8C12": "jit3/kit3",
    "\u8C13": "wai6",
    "\u8C14": "ngok6/ok6",
    "\u8C15": "jyu6",
    "\u8C16": "hyun1",
    "\u8C17": "caam4",
    "\u8C18": "zi1",
    "\u8C19": "am1/ngam1/am2/ngam2",
    "\u8C1A": "jin6",
    "\u8C1B": "dai3",
    "\u8C1C": "mai4/mai2",
    "\u8C1D": "pin4/pin5",
    "\u8C1E": "seoi1/seoi2",
    "\u8C1F": "mou4",
    "\u8C20": "dong2",
    "\u8C21": "suk1",
    "\u8C22": "ze6",
    "\u8C23": "jiu4",
    "\u8C24": "pong3",
    "\u8C25": "si3",
    "\u8C26": "him1",
    "\u8C27": "mat6",
    "\u8C28": "gan2",
    "\u8C29": "maan4/maan6",
    "\u8C2A": "zaak6",
    "\u8C2B": "zin2",
    "\u8C2C": "mau6",
    "\u8C2D": "taam4",
    "\u8C2E": "zam3/cam3",
    "\u8C2F": "ciu4/ciu3",
    "\u8C30": "laan4",
    "\u8C31": "pou2",
    "\u8C32": "kyut3/gwat1",
    "\u8C33": "jin6",
    "\u8C34": "hin2",
    "\u8C35": "zim1",
    "\u8C36": "cam3/caam3",
    "\u8C37": "guk1/juk6/luk6",
    "\u8C38": "cin1",
    "\u8C39": "wang4",
    "\u8C3A": "haa1",
    "\u8C3B": "gik1",
    "\u8C3C": "hung4",
    "\u8C3D": "ham4",
    "\u8C3E": "hung1",
    "\u8C3F": "kai1",
    "\u8C40": "hai4/kai1",
    "\u8C41": "kut3/kwut3/waa1/waak6",
    "\u8C42": "liu4",
    "\u8C43": "haam2",
    "\u8C44": "duk6",
    "\u8C45": "lung4",
    "\u8C46": "dau6/dau2/dau4",
    "\u8C47": "gong1",
    "\u8C48": "hei2/hoi2",
    "\u8C49": "si6/si2",
    "\u8C4A": "lai5",
    "\u8C4B": "dang1",
    "\u8C4C": "wun1/wun2",
    "\u8C4D": "bai1",
    "\u8C4E": "syu6",
    "\u8C4F": "haam5",
    "\u8C50": "fung1",
    "\u8C51": "dit6",
    "\u8C52": "dit6",
    "\u8C53": "jim6",
    "\u8C54": "jim6",
    "\u8C55": "ci2",
    "\u8C56": "cuk1",
    "\u8C57": "fui1",
    "\u8C58": "tyun4",
    "\u8C59": "ngai6/ai6",
    "\u8C5A": "tyun4",
    "\u8C5B": "jik6",
    "\u8C5C": "gin1",
    "\u8C5D": "baa1",
    "\u8C5E": "kau3",
    "\u8C5F": "ak1/ngak1",
    "\u8C60": "co4",
    "\u8C61": "zoeng6",
    "\u8C62": "waan6",
    "\u8C63": "gin1",
    "\u8C64": "han2",
    "\u8C65": "goi1",
    "\u8C66": "geoi3",
    "\u8C67": "fu1",
    "\u8C68": "hei1",
    "\u8C69": "ban1",
    "\u8C6A": "hou4",
    "\u8C6B": "jyu6",
    "\u8C6C": "zyu1",
    "\u8C6D": "gaa1",
    "\u8C6E": "fan4",
    "\u8C6F": "hai4",
    "\u8C70": "bok6",
    "\u8C71": "wan1",
    "\u8C72": "jyun4/wun4",
    "\u8C73": "ban1",
    "\u8C74": "dik1",
    "\u8C75": "zung1",
    "\u8C76": "fan4",
    "\u8C77": "ai3/ngai3",
    "\u8C78": "zi6/zaai6",
    "\u8C79": "paau3",
    "\u8C7A": "caai4",
    "\u8C7B": "ngon6/on6/hon6",
    "\u8C7C": "pei4",
    "\u8C7D": "neot6/leot6",
    "\u8C7E": "pei1",
    "\u8C7F": "gau2",
    "\u8C80": "neot6/leot6",
    "\u8C81": "jau6",
    "\u8C82": "diu1",
    "\u8C83": "mak6",
    "\u8C84": "si3",
    "\u8C85": "jau1",
    "\u8C86": "wun4/hyun1/fun1",
    "\u8C87": "han2",
    "\u8C88": "hok6/mak6",
    "\u8C89": "hok6/mak6",
    "\u8C8A": "mak6",
    "\u8C8B": "ngon6/on6",
    "\u8C8C": "maau6",
    "\u8C8D": "lei4",
    "\u8C8E": "maau6",
    "\u8C8F": "bei2",
    "\u8C90": "jyu5",
    "\u8C91": "gaa1",
    "\u8C92": "teon1",
    "\u8C93": "maau1",
    "\u8C94": "pei4",
    "\u8C95": "hai4",
    "\u8C96": "jik1",
    "\u8C97": "geoi6",
    "\u8C98": "mak6/mok6",
    "\u8C99": "ceoi1",
    "\u8C9A": "taan4",
    "\u8C9B": "fun1",
    "\u8C9C": "fok3",
    "\u8C9D": "bui3",
    "\u8C9E": "zing1",
    "\u8C9F": "jyun4/wan6",
    "\u8CA0": "fu6",
    "\u8CA1": "coi4/coi2",
    "\u8CA2": "gung3",
    "\u8CA3": "tik1",
    "\u8CA4": "ji6/ji4/ji2",
    "\u8CA5": "hong4",
    "\u8CA6": "wun6",
    "\u8CA7": "pan4",
    "\u8CA8": "fo3",
    "\u8CA9": "faan3/faan2/faan5",
    "\u8CAA": "taam1",
    "\u8CAB": "gun3/gwun3/gwaan3",
    "\u8CAC": "zaak3/zaai3",
    "\u8CAD": "zat1",
    "\u8CAE": "ji6",
    "\u8CAF": "cyu5",
    "\u8CB0": "sai3",
    "\u8CB1": "bei3",
    "\u8CB2": "zi1",
    "\u8CB3": "ji6",
    "\u8CB4": "gwai3",
    "\u8CB5": "pin2",
    "\u8CB6": "bin2",
    "\u8CB7": "maai5",
    "\u8CB8": "taai3/tik1",
    "\u8CB9": "sang3",
    "\u8CBA": "fong3",
    "\u8CBB": "fai3/bei3",
    "\u8CBC": "tip3/tip1",
    "\u8CBD": "ji4",
    "\u8CBE": "ci4",
    "\u8CBF": "mau6",
    "\u8CC0": "ho6",
    "\u8CC1": "bei3/fan4/ban1/fan5",
    "\u8CC2": "lou6",
    "\u8CC3": "jam6",
    "\u8CC4": "kui2/kwui2/fui2",
    "\u8CC5": "goi1",
    "\u8CC6": "pin4",
    "\u8CC7": "zi1",
    "\u8CC8": "gaa2/gaa3/gu2/gwu2",
    "\u8CC9": "seot1",
    "\u8CCA": "caak3/caak6/caak2",
    "\u8CCB": "gaau2",
    "\u8CCC": "goi1",
    "\u8CCD": "zong6",
    "\u8CCE": "zin6",
    "\u8CCF": "jing1",
    "\u8CD0": "seon3",
    "\u8CD1": "zan3",
    "\u8CD2": "se1",
    "\u8CD3": "ban1/ban3",
    "\u8CD4": "ban1",
    "\u8CD5": "kau4",
    "\u8CD6": "se1",
    "\u8CD7": "cyun3",
    "\u8CD8": "zong1",
    "\u8CD9": "zau1",
    "\u8CDA": "loi6",
    "\u8CDB": "zaan3",
    "\u8CDC": "ci3",
    "\u8CDD": "cam1",
    "\u8CDE": "soeng2",
    "\u8CDF": "tin2",
    "\u8CE0": "pui4",
    "\u8CE1": "gang1",
    "\u8CE2": "jin4",
    "\u8CE3": "maai6/maai2",
    "\u8CE4": "zin6",
    "\u8CE5": "seoi6",
    "\u8CE6": "fu3",
    "\u8CE7": "daam6",
    "\u8CE8": "cung4",
    "\u8CE9": "cung4",
    "\u8CEA": "zat1/zi3",
    "\u8CEB": "zai1/cai4",
    "\u8CEC": "zoeng3",
    "\u8CED": "dou2",
    "\u8CEE": "zeon2",
    "\u8CEF": "hing1",
    "\u8CF0": "seon2",
    "\u8CF1": "wan2",
    "\u8CF2": "bou2",
    "\u8CF3": "zoi1",
    "\u8CF4": "laai6/laai2/laai3",
    "\u8CF5": "fung3/fung6",
    "\u8CF6": "cong3",
    "\u8CF7": "zai1/cai4",
    "\u8CF8": "sing6/zing6",
    "\u8CF9": "jat6",
    "\u8CFA": "zaan6/zaan2",
    "\u8CFB": "fu6",
    "\u8CFC": "gau3/kau3",
    "\u8CFD": "coi3",
    "\u8CFE": "zaak3",
    "\u8CFF": "laau4",
    "\u8D00": "ji3",
    "\u8D01": "baai6",
    "\u8D02": "cam2",
    "\u8D03": "taan3",
    "\u8D04": "zi3",
    "\u8D05": "zeoi6",
    "\u8D06": "biu1",
    "\u8D07": "wan1",
    "\u8D08": "zang6",
    "\u8D09": "taam5",
    "\u8D0A": "zaan3",
    "\u8D0B": "ngaan6/aan6/ngan3/an3",
    "\u8D0C": "duk6",
    "\u8D0D": "sin6/sim6",
    "\u8D0E": "maan6",
    "\u8D0F": "jing4/jeng4",
    "\u8D10": "zeon2",
    "\u8D11": "gam3",
    "\u8D12": "jin4",
    "\u8D13": "zong1",
    "\u8D14": "bai3/bei6",
    "\u8D15": "duk6",
    "\u8D16": "suk6/zuk6",
    "\u8D17": "ngaan6/aan6/ngan3/an3",
    "\u8D18": "soeng2",
    "\u8D19": "jyun5",
    "\u8D1A": "lung6",
    "\u8D1B": "gam3/gung3",
    "\u8D1C": "zong1",
    "\u8D1D": "bui3",
    "\u8D1E": "zing1",
    "\u8D1F": "fu6",
    "\u8D20": "jyun4/wan6",
    "\u8D21": "gung3",
    "\u8D22": "coi4/coi2",
    "\u8D23": "zaak3/zaai3",
    "\u8D24": "jin4",
    "\u8D25": "baai6",
    "\u8D26": "zoeng3",
    "\u8D27": "fo3",
    "\u8D28": "zat1/zi3",
    "\u8D29": "faan3/faan2/faan5",
    "\u8D2A": "taam1",
    "\u8D2B": "pan4",
    "\u8D2C": "bin2",
    "\u8D2D": "gau3/kau3",
    "\u8D2E": "cyu5",
    "\u8D2F": "gun3/gwun3/gwaan3",
    "\u8D30": "ji6",
    "\u8D31": "zin6",
    "\u8D32": "bei3/fan4/ban1/fan5",
    "\u8D33": "sai3",
    "\u8D34": "tip3/tip1",
    "\u8D35": "gwai3",
    "\u8D36": "fong3",
    "\u8D37": "taai3/tik1",
    "\u8D38": "mau6",
    "\u8D39": "fai3/bei3",
    "\u8D3A": "ho6",
    "\u8D3B": "ji4",
    "\u8D3C": "caak3/caak6/caak2",
    "\u8D3D": "zi3",
    "\u8D3E": "gaa2/gaa3/gu2/gwu2",
    "\u8D3F": "kui2/kwui2/fui2",
    "\u8D40": "zi1",
    "\u8D41": "jam6",
    "\u8D42": "lou6",
    "\u8D43": "zong1/zong6",
    "\u8D44": "zi1",
    "\u8D45": "goi1",
    "\u8D46": "zeon2",
    "\u8D47": "kau4",
    "\u8D48": "zan3",
    "\u8D49": "loi6",
    "\u8D4A": "se1",
    "\u8D4B": "fu3",
    "\u8D4C": "dou2",
    "\u8D4D": "zai1/cai4",
    "\u8D4E": "suk6/zuk6",
    "\u8D4F": "soeng2",
    "\u8D50": "ci3",
    "\u8D51": "bai3/bei6",
    "\u8D52": "zau1",
    "\u8D53": "gang1",
    "\u8D54": "pui4",
    "\u8D55": "daam6",
    "\u8D56": "laai6/laai2/laai3",
    "\u8D57": "fung3/fung6",
    "\u8D58": "zeoi6",
    "\u8D59": "fu6",
    "\u8D5A": "zaan6/zaan2",
    "\u8D5B": "coi3",
    "\u8D5C": "zaak3",
    "\u8D5D": "ngaan6/aan6/ngan3/an3",
    "\u8D5E": "zaan3/zaan2",
    "\u8D5F": "wan1",
    "\u8D60": "zang6",
    "\u8D61": "sin6/sim6",
    "\u8D62": "jing4/jeng4",
    "\u8D63": "gam3/gung3",
    "\u8D64": "cek3/cik3",
    "\u8D65": "hik1",
    "\u8D66": "se3",
    "\u8D67": "naan5/laan5",
    "\u8D68": "tung4",
    "\u8D69": "sik1",
    "\u8D6A": "cing1",
    "\u8D6B": "haak1/hak1",
    "\u8D6C": "cing1",
    "\u8D6D": "ze2",
    "\u8D6E": "haa4",
    "\u8D6F": "tong4",
    "\u8D70": "zau2",
    "\u8D71": "zau2",
    "\u8D72": "lik6",
    "\u8D73": "gau2/dau2",
    "\u8D74": "fu6",
    "\u8D75": "ziu6",
    "\u8D76": "gon2",
    "\u8D77": "hei2",
    "\u8D78": "saan3",
    "\u8D79": "king4",
    "\u8D7A": "jam5",
    "\u8D7B": "sin2",
    "\u8D7C": "zi1",
    "\u8D7D": "kyut3",
    "\u8D7E": "jan2",
    "\u8D7F": "ci4",
    "\u8D80": "zi1",
    "\u8D81": "can3",
    "\u8D82": "ji5/can3",
    "\u8D83": "dit6",
    "\u8D84": "zeoi1/ce3/cit3",
    "\u8D85": "ciu1",
    "\u8D86": "dai1",
    "\u8D87": "sap1",
    "\u8D88": "zaam6",
    "\u8D89": "gwat6",
    "\u8D8A": "jyut6",
    "\u8D8B": "ceoi1/cuk1",
    "\u8D8C": "gat1/gat6",
    "\u8D8D": "ceoi1/cuk1",
    "\u8D8E": "zyu1",
    "\u8D8F": "gwaat3",
    "\u8D90": "hyut3",
    "\u8D91": "zi1",
    "\u8D92": "tiu4",
    "\u8D93": "do2",
    "\u8D94": "lit6",
    "\u8D95": "gon2",
    "\u8D96": "so1",
    "\u8D97": "cuk1",
    "\u8D98": "hat6",
    "\u8D99": "ziu6",
    "\u8D9A": "suk1",
    "\u8D9B": "jam5",
    "\u8D9C": "guk1",
    "\u8D9D": "gim3",
    "\u8D9E": "coek3",
    "\u8D9F": "tong3/tong2/tong1/caang1",
    "\u8DA0": "coek3",
    "\u8DA1": "ceoi2",
    "\u8DA2": "luk6",
    "\u8DA3": "ceoi3/ceoi2/cuk1/ceoi1",
    "\u8DA4": "dong6",
    "\u8DA5": "cau1",
    "\u8DA6": "zi1",
    "\u8DA7": "tai4",
    "\u8DA8": "ceoi1/cuk1",
    "\u8DA9": "cik1",
    "\u8DAA": "wong4",
    "\u8DAB": "kiu4",
    "\u8DAC": "hiu1",
    "\u8DAD": "ziu3",
    "\u8DAE": "cou3",
    "\u8DAF": "tik1/joek3/dek3",
    "\u8DB0": "ji5",
    "\u8DB1": "zaan2/zaan3",
    "\u8DB2": "zaan2/zaan3",
    "\u8DB3": "zuk1/zeoi3",
    "\u8DB4": "paa1",
    "\u8DB5": "paau3/bok3",
    "\u8DB6": "fu3",
    "\u8DB7": "gat6",
    "\u8DB8": "dan2",
    "\u8DB9": "kyut3",
    "\u8DBA": "fu1",
    "\u8DBB": "cam2",
    "\u8DBC": "gaan2/gin2",
    "\u8DBD": "fong3",
    "\u8DBE": "zi2",
    "\u8DBF": "taat3/saap3/cap1",
    "\u8DC0": "gat6/jyut6",
    "\u8DC1": "baa6",
    "\u8DC2": "kei4/kei5",
    "\u8DC3": "joek6/joek3/tik1",
    "\u8DC4": "coeng1/coeng3",
    "\u8DC5": "tok3",
    "\u8DC6": "toi4",
    "\u8DC7": "jai6",
    "\u8DC8": "nin2/lin2",
    "\u8DC9": "ling4",
    "\u8DCA": "mui6",
    "\u8DCB": "bat6",
    "\u8DCC": "dit3",
    "\u8DCD": "fu1",
    "\u8DCE": "to4",
    "\u8DCF": "gaa1",
    "\u8DD0": "ci2/caai2",
    "\u8DD1": "paau2/paau4",
    "\u8DD2": "kaa2",
    "\u8DD3": "cyu5",
    "\u8DD4": "keoi1/koe4",
    "\u8DD5": "tip3/dip3/dip6/zaam6/dim2",
    "\u8DD6": "zik3/zek3",
    "\u8DD7": "fu1",
    "\u8DD8": "pun4",
    "\u8DD9": "zeoi2/zeoi1",
    "\u8DDA": "saan1",
    "\u8DDB": "bai1/bo2/bei3",
    "\u8DDC": "nei4/lei4",
    "\u8DDD": "keoi5",
    "\u8DDE": "lik1/lok6/lok3",
    "\u8DDF": "gan1",
    "\u8DE0": "ji4",
    "\u8DE1": "zik1",
    "\u8DE2": "do2",
    "\u8DE3": "sin2",
    "\u8DE4": "gaau1/haau1",
    "\u8DE5": "do2",
    "\u8DE6": "zyu1",
    "\u8DE7": "cyun4",
    "\u8DE8": "kwaa3/kwaa1",
    "\u8DE9": "jai6",
    "\u8DEA": "gwai6",
    "\u8DEB": "kung4",
    "\u8DEC": "kwai2",
    "\u8DED": "hong4",
    "\u8DEE": "dit6/ci3",
    "\u8DEF": "lou6/lou2",
    "\u8DF0": "pin4",
    "\u8DF1": "zi6/ci5/si6",
    "\u8DF2": "gaap3",
    "\u8DF3": "tiu3/tiu2/tiu4/tou4",
    "\u8DF4": "caai2",
    "\u8DF5": "cin5/zin6",
    "\u8DF6": "taat3",
    "\u8DF7": "kiu5/hiu1/kiu1/kiu2",
    "\u8DF8": "bat1",
    "\u8DF9": "sin1",
    "\u8DFA": "do2",
    "\u8DFB": "zai1",
    "\u8DFC": "guk6",
    "\u8DFD": "gei6",
    "\u8DFE": "suk1",
    "\u8DFF": "tou4",
    "\u8E00": "cuk1",
    "\u8E01": "hing5/ging3",
    "\u8E02": "nip6/lip6",
    "\u8E03": "siu1",
    "\u8E04": "bok6",
    "\u8E05": "cyut3/zai6/ci3",
    "\u8E06": "cyun4/cyun1/seon1",
    "\u8E07": "mou5",
    "\u8E08": "so1",
    "\u8E09": "loeng6/long4/loeng4",
    "\u8E0A": "jung2",
    "\u8E0B": "goek3",
    "\u8E0C": "cau4",
    "\u8E0D": "haau1",
    "\u8E0E": "mau1",
    "\u8E0F": "daap6",
    "\u8E10": "cin5/zin6",
    "\u8E11": "gei1/kei1",
    "\u8E12": "wo1",
    "\u8E13": "wai5",
    "\u8E14": "coek3/diu6",
    "\u8E15": "zit6",
    "\u8E16": "zik1/zik6/cik1",
    "\u8E17": "nip6/lip6",
    "\u8E18": "guk1",
    "\u8E19": "nip6/lip6",
    "\u8E1A": "leon4",
    "\u8E1B": "luk6",
    "\u8E1C": "ling6",
    "\u8E1D": "waa5",
    "\u8E1E": "geoi3",
    "\u8E1F": "ci4",
    "\u8E20": "jyun2",
    "\u8E21": "kyun4",
    "\u8E22": "tek3",
    "\u8E23": "baak6",
    "\u8E24": "zeot1/seoi6",
    "\u8E25": "cip3",
    "\u8E26": "kei1/hei1/gei1/gei2/ji2",
    "\u8E27": "cuk1/dik6",
    "\u8E28": "zung1",
    "\u8E29": "caai2",
    "\u8E2A": "zung1",
    "\u8E2B": "pung3",
    "\u8E2C": "zi3",
    "\u8E2D": "zaang1",
    "\u8E2E": "dim2",
    "\u8E2F": "zaak6",
    "\u8E30": "jyu4",
    "\u8E31": "dok6",
    "\u8E32": "dan6",
    "\u8E33": "ceon1/ceon2/cyun2",
    "\u8E34": "jung2",
    "\u8E35": "zung2/dung2",
    "\u8E36": "dai6/tai4/ci2",
    "\u8E37": "zaa2",
    "\u8E38": "cam2",
    "\u8E39": "cyun2/caai2/jaai2",
    "\u8E3A": "gin6",
    "\u8E3B": "gwaa1",
    "\u8E3C": "tong4/dong6",
    "\u8E3D": "geoi2",
    "\u8E3E": "fuk1",
    "\u8E3F": "zuk1",
    "\u8E40": "dip6",
    "\u8E41": "pin4/pin1",
    "\u8E42": "jau4",
    "\u8E43": "noek6/loek6",
    "\u8E44": "tai4/tai2/dai6",
    "\u8E45": "caa5/caa1",
    "\u8E46": "tan3",
    "\u8E47": "gin2/zin2/hin1",
    "\u8944": "soeng1",
    "\u8945": "bat1",
    "\u8946": "fuk6/buk6",
    "\u8947": "gaan2/gaan3",
    "\u8948": "zyun6",
    "\u8949": "gaan3",
    "\u894A": "ceoi3",
    "\u894B": "gik1",
    "\u894C": "daan1",
    "\u894D": "zaap6",
    "\u894E": "faan4",
    "\u894F": "but6/but3",
    "\u8950": "zoeng6",
    "\u8951": "cam4",
    "\u8952": "bit6",
    "\u8953": "jiu4",
    "\u8954": "loeng5",
    "\u8955": "laan4",
    "\u8956": "ou2/ngou2/ou3/ngou3",
    "\u8957": "zaak6/dok6",
    "\u8958": "kui2/kwui2",
    "\u8959": "cou3",
    "\u895A": "seoi6",
    "\u895B": "nung4/lung4",
    "\u895C": "cim1/sim4",
    "\u895D": "lim5/lim6",
    "\u895E": "bik1",
    "\u895F": "kam1",
    "\u8960": "dong1",
    "\u8961": "suk6/duk6",
    "\u8962": "zin3/taan2",
    "\u8963": "bei6",
    "\u8964": "laam4",
    "\u8965": "fuk6/buk6",
    "\u8966": "jyu4",
    "\u8967": "zi2",
    "\u8968": "deoi3",
    "\u8969": "suk6",
    "\u896A": "mat6/mat2/maat6",
    "\u896B": "sik1",
    "\u896C": "baai2/bei1",
    "\u896D": "kit3",
    "\u896E": "bok3/buk6",
    "\u896F": "can3",
    "\u8970": "laai6",
    "\u8971": "lung4/lung5",
    "\u8972": "zaap6",
    "\u8973": "cim1/sim1/sam1",
    "\u8974": "laan4",
    "\u8975": "zip3/zaap3",
    "\u8976": "daai3/de2",
    "\u8977": "geoi2",
    "\u8978": "zaan3",
    "\u8979": "si1",
    "\u897A": "gaan2",
    "\u897B": "paan3",
    "\u897C": "ngai6/ai6",
    "\u897D": "laan4",
    "\u897E": "aa3/ngaa3",
    "\u897F": "sai1",
    "\u8980": "sai1.zi6.tau4",
    "\u8981": "jiu3/jiu1",
    "\u8982": "fung2",
    "\u8983": "taam4/cam4",
    "\u8984": "fuk1",
    "\u8985": "fiu3",
    "\u8986": "fuk1",
    "\u8987": "baa3",
    "\u8988": "hat6",
    "\u8989": "gei1",
    "\u898A": "gei1",
    "\u898B": "gin3/jin6",
    "\u898C": "gun1/gwun1",
    "\u898D": "bin6",
    "\u898E": "jim3/jin6",
    "\u898F": "kwai1",
    "\u8990": "gok3",
    "\u8991": "pin2",
    "\u8992": "mou6",
    "\u8993": "mik6",
    "\u8994": "mik6",
    "\u8995": "pit3",
    "\u8996": "si6/si2",
    "\u8997": "zi6",
    "\u8998": "zim1",
    "\u8999": "can2",
    "\u899A": "gok3",
    "\u899B": "mik6/mak6",
    "\u899C": "tiu3",
    "\u899D": "lim4",
    "\u899E": "jiu6",
    "\u899F": "zi3",
    "\u89A0": "gwan1",
    "\u89A1": "hat6",
    "\u89A2": "sim2",
    "\u89A3": "wai1",
    "\u89A4": "gwik1",
    "\u89A5": "tin2",
    "\u89A6": "jyu4",
    "\u89A7": "laam5",
    "\u89A8": "ngok6/ok6",
    "\u89A9": "dou2",
    "\u89AA": "can1/can3",
    "\u89AB": "pong2",
    "\u89AC": "gei3",
    "\u89AD": "ming4",
    "\u89AE": "jing4",
    "\u89AF": "gau3",
    "\u89B0": "ceoi3",
    "\u89B1": "zaam3",
    "\u89B2": "gan3/gan2/gan6",
    "\u89B3": "gun1/gwun1",
    "\u89B4": "dang1",
    "\u89B5": "gaan3/haan2",
    "\u89B6": "lo4",
    "\u89B7": "ceoi3",
    "\u89B8": "gaan3",
    "\u89B9": "mei4",
    "\u89BA": "gok3/gaau3/gaau1/gaau4",
    "\u89BB": "ceoi3",
    "\u89BC": "lo4",
    "\u89BD": "laam5",
    "\u89BE": "sam2",
    "\u89BF": "dik6",
    "\u89C0": "gun1/gwun1/gun3/gwun3",
    "\u89C1": "gin3/jin6",
    "\u89C2": "gun1/gwun1/gun3/gwun3",
    "\u89C3": "jim3/jin6",
    "\u89C4": "kwai1",
    "\u89C5": "mik6",
    "\u89C6": "si6/si2",
    "\u89C7": "zim1",
    "\u89C8": "laam5",
    "\u89C9": "gok3/gaau3/gaau1/gaau4",
    "\u89CA": "gei3",
    "\u89CB": "hat6",
    "\u89CC": "dik6",
    "\u89CD": "tin2",
    "\u89CE": "jyu4",
    "\u89CF": "gau3",
    "\u89D0": "gan3/gan2/gan6",
    "\u89D1": "ceoi3",
    "\u89D2": "gok3/gok2/luk6",
    "\u89D3": "kau4",
    "\u89D4": "gan1",
    "\u89D5": "cou1",
    "\u89D6": "kyut3/kwai3",
    "\u89D7": "zi3",
    "\u89D8": "caau3",
    "\u89D9": "kap1",
    "\u89DA": "gu1/gwu1",
    "\u89DB": "daan6",
    "\u89DC": "zi1/zeoi2",
    "\u89DD": "dai2",
    "\u89DE": "soeng1",
    "\u89DF": "waa6/haai6",
    "\u89E0": "kyun4",
    "\u89E1": "gaak3",
    "\u89E2": "sai6",
    "\u89E3": "gaai2/gaai3/haai6/haai5",
    "\u89E4": "gwai2",
    "\u89E5": "gwang1",
    "\u89E6": "zuk1/cuk1",
    "\u89E7": "gaai3/gaai2",
    "\u89E8": "wan6",
    "\u89E9": "kau4",
    "\u89EA": "sing1",
    "\u89EB": "cuk1",
    "\u89EC": "ngai4/ai4",
    "\u89ED": "gei1/kei1",
    "\u89EE": "luk6",
    "\u89EF": "zi3",
    "\u89F0": "zaa1",
    "\u89F1": "bit1",
    "\u89F2": "sing1",
    "\u89F3": "huk6/gok3/kok3",
    "\u89F4": "soeng1",
    "\u89F5": "gwang1",
    "\u89F6": "zi3",
    "\u89F7": "hok6",
    "\u89F8": "zuk1/cuk1",
    "\u89F9": "kwai4",
    "\u89FA": "ji4",
    "\u89FB": "luk6",
    "\u89FC": "kyut3",
    "\u89FD": "kwai4",
    "\u89FE": "jin3",
    "\u89FF": "kwai4",
    "\u8A00": "jin4",
    "\u8A02": "ding3/ding6/deng6",
    "\u8A03": "fu6",
    "\u8A04": "kau4",
    "\u8A05": "kau4",
    "\u8A06": "giu3",
    "\u8A07": "gwang1",
    "\u8A08": "gai3/gai2/gei3",
    "\u8A09": "faan6",
    "\u8A0A": "seon3",
    "\u8A0B": "diu3",
    "\u8A0C": "hung6/hung3",
    "\u8A0D": "caai3",
    "\u8A0E": "tou2",
    "\u8A0F": "heoi1/heoi2",
    "\u8A10": "kit3/gai3",
    "\u8A11": "ji4/daan3/to4",
    "\u8A12": "jan6",
    "\u8A13": "fan3",
    "\u8A14": "ngan4/an4",
    "\u8A15": "saan3",
    "\u8A16": "ngat6/at6/gat1",
    "\u8A17": "tok3",
    "\u8A18": "gei3",
    "\u8A19": "seon3",
    "\u8A1A": "ngan4/an4",
    "\u8A1B": "ngo4/o4",
    "\u8A1C": "fan1",
    "\u8A1D": "ngaa6/aa6",
    "\u8A1E": "jiu1",
    "\u8A1F": "zung6",
    "\u8A20": "can2",
    "\u8A21": "jam4",
    "\u8A22": "jan1/hei1/ngan4/an4",
    "\u8A23": "kyut3",
    "\u8A24": "haau4",
    "\u8A25": "neot6/leot6/naap6/laap6/nat6/lat6",
    "\u8A26": "sam4",
    "\u8A27": "jau4",
    "\u8A28": "zi2",
    "\u8A29": "hung1",
    "\u8A2A": "fong2",
    "\u8A2B": "seon3",
    "\u8A2C": "caau2/miu5",
    "\u8A2D": "cit3",
    "\u8A2E": "ngaan4/aan4",
    "\u8A2F": "saa2",
    "\u8A30": "zeon3",
    "\u8A31": "heoi2/fu2",
    "\u8A32": "jik1",
    "\u8A33": "jik6",
    "\u8A34": "sou3",
    "\u8A35": "ci1",
    "\u8A36": "ho1",
    "\u8A37": "san1",
    "\u8A38": "wo4/wo6",
    "\u8A39": "seot1",
    "\u8A3A": "can2/zan2",
    "\u8A3B": "zyu3",
    "\u8A3C": "zing3",
    "\u8A3D": "gau3",
    "\u8A3E": "zi2/zi1/ci1/ci4",
    "\u8A3F": "zi2",
    "\u8A40": "zaam1/cip3",
    "\u8A41": "gu2/gwu2/gu3/gwu3",
    "\u8A42": "fu6",
    "\u8A43": "gyun2",
    "\u8A44": "dit6",
    "\u8A45": "ling4",
    "\u8A46": "dai2",
    "\u8A47": "joeng3",
    "\u8A48": "lei6",
    "\u8A49": "naau4/laau4",
    "\u8A4A": "pun3",
    "\u8A4B": "zau3",
    "\u8A4C": "gam3",
    "\u8A4D": "jai6",
    "\u8A4E": "geoi6",
    "\u8A4F": "aau3/aau2/ngaau2/ngaau3",
    "\u8A50": "zaa3",
    "\u8A51": "to4/ji4",
    "\u8A52": "ji4/doi6",
    "\u8A53": "heoi2",
    "\u8A54": "ziu3/ziu6",
    "\u8A55": "ping4",
    "\u8A56": "bei3/bei1",
    "\u8A57": "gwing2/hing3",
    "\u8A58": "wat1/zeot1",
    "\u8A59": "bat6",
    "\u8A5A": "daat3",
    "\u8A5B": "zo3/zo2",
    "\u8A5C": "tou1",
    "\u8A5D": "cyu5",
    "\u8A5E": "ci4",
    "\u8A5F": "sip3/zip3",
    "\u8A60": "wing6",
    "\u8A61": "heoi2",
    "\u8A62": "seon1",
    "\u8A63": "ngai6/ai6",
    "\u8A64": "fong1/fong2",
    "\u8A65": "hap6",
    "\u8A66": "si3/si5",
    "\u8A67": "caat3",
    "\u8A68": "haau6",
    "\u8A69": "si1",
    "\u8A6A": "han2",
    "\u8A6B": "caa3",
    "\u8A6C": "gau3",
    "\u8A6D": "gwai2",
    "\u8A6E": "cyun4",
    "\u8A6F": "fui3",
    "\u8A70": "kit3/gat1",
    "\u8A71": "waa6/waa2",
    "\u8A72": "goi1",
    "\u8A73": "coeng4",
    "\u8A74": "wui1",
    "\u8A75": "san1",
    "\u8A76": "zau3/cau4",
    "\u8A77": "tung4",
    "\u8A78": "mai4",
    "\u8A79": "zim1",
    "\u8A7A": "ming6",
    "\u8A7B": "ngaak6/aak6",
    "\u8A7C": "fui1",
    "\u8A7D": "ngaan4/aan4",
    "\u8A7E": "hung1",
    "\u8A7F": "gwaa3",
    "\u8A80": "nei6/lei6",
    "\u8A81": "bang2",
    "\u8A82": "tiu5/tiu1/diu3",
    "\u8A83": "ci4/ci2/ji4",
    "\u8A84": "loi6/leoi6",
    "\u8A85": "zyu1",
    "\u8A86": "hong1/kwong4/kong4/gwong2/gong2",
    "\u8A87": "kwaa1",
    "\u8A88": "mou4",
    "\u8A89": "jyu6",
    "\u8A8A": "tang4",
    "\u8A8B": "gei6",
    "\u8A8C": "zi3",
    "\u8A8D": "jing6/jing2",
    "\u8A8E": "cuk1",
    "\u8A8F": "long5",
    "\u8A90": "ngo4/o4",
    "\u8A91": "gwong2/gong2/kong4/kwong4",
    "\u8A92": "ei6/ngei6/ei1/ngei1/ei3/ngei3/oi1/ngoi1/aai2/ngaai2/e6/nge6",
    "\u8A93": "sai6",
    "\u8A94": "ting5",
    "\u8A95": "daan3",
    "\u8A96": "bui6/bui3/but6",
    "\u8A97": "cim4",
    "\u8A98": "jau5",
    "\u8A99": "hang1",
    "\u8A9A": "ciu3",
    "\u8A9B": "cam1",
    "\u8A9C": "saa3",
    "\u8A9D": "am1/ngam1",
    "\u8A9E": "jyu5/jyu6",
    "\u8A9F": "haau6",
    "\u8AA0": "sing4/sing2",
    "\u8AA1": "gaai3",
    "\u8AA2": "jin6",
    "\u8AA3": "mou4",
    "\u8AA4": "ng6/m6",
    "\u8AA5": "gou3",
    "\u8AA6": "zung6",
    "\u8AA7": "bou1",
    "\u8AA8": "fui3",
    "\u8AA9": "ging6",
    "\u8AAA": "syut3/seoi3/jyut6",
    "\u8AAB": "zan3",
    "\u8AAC": "syut3/seoi3/jyut6",
    "\u8AAD": "duk6",
    "\u8AAE": "waa1",
    "\u8AAF": "coeng3",
    "\u8AB0": "seoi4/seoi2",
    "\u8AB1": "zit6",
    "\u8AB2": "fo3",
    "\u8AB3": "wat1",
    "\u8AB4": "cung4",
    "\u8AB5": "haau4",
    "\u8AB6": "seoi6",
    "\u8AB7": "mong5",
    "\u8AB8": "jin4",
    "\u8AB9": "fei2",
    "\u8ABA": "ci1",
    "\u8ABB": "daap6/taap3",
    "\u8ABC": "ji4/ji6",
    "\u8ABD": "ngai6/ai6",
    "\u8ABE": "ngan4/an4",
    "\u8ABF": "diu6/diu2/deu6/tiu4",
    "\u8AC0": "pei2",
    "\u8AC1": "zyut3",
    "\u8AC2": "cim2",
    "\u8AC3": "cam1",
    "\u8AC4": "zeon1/deon1",
    "\u8AC5": "gei6",
    "\u8AC6": "hei1",
    "\u8AC7": "taam4",
    "\u8AC8": "zeoi3",
    "\u8AC9": "wai2",
    "\u8ACA": "guk1",
    "\u8ACB": "cing2/ceng2",
    "\u8ACC": "dung2",
    "\u8ACD": "zaang3/zang3/zaang1/zang1",
    "\u8ACE": "zaak3",
    "\u8ACF": "zau1",
    "\u8AD0": "hin1",
    "\u8AD1": "doek3",
    "\u8AD2": "loeng6/loeng4",
    "\u8AD3": "zin3/zin2",
    "\u8AD4": "cuk1",
    "\u8AD5": "haak3",
    "\u8AD6": "leon6/leon2/leon4",
    "\u8AD7": "sam2/nam2/lam2",
    "\u8AD8": "biu2",
    "\u8AD9": "waa6",
    "\u8ADA": "pin4",
    "\u8ADB": "jyu4",
    "\u8ADC": "dip6",
    "\u8ADD": "seoi1/seoi2",
    "\u8ADE": "pin4/pin5",
    "\u8ADF": "si6",
    "\u8AE0": "hyun1",
    "\u8AE1": "si3",
    "\u8AE2": "wan6",
    "\u8AE3": "faa3",
    "\u8AE4": "ngok6/ok6",
    "\u8AE5": "zung3",
    "\u8AE6": "dai3",
    "\u8AE7": "haai4",
    "\u8AE8": "fuk1",
    "\u8AE9": "pou2",
    "\u8AEA": "ting4",
    "\u8AEB": "gaan3",
    "\u8AEC": "kai2",
    "\u8AED": "jyu6",
    "\u8AEE": "zi1",
    "\u8AEF": "zyun1",
    "\u8AF0": "saai2/si2",
    "\u8AF1": "wai5",
    "\u8AF2": "jan1",
    "\u8AF3": "am1/ngam1/am2/ngam2",
    "\u8AF4": "haam4",
    "\u8AF5": "naam4/laam4",
    "\u8AF6": "sam4",
    "\u8AF7": "fung3",
    "\u8AF8": "zyu1",
    "\u8AF9": "joeng4",
    "\u8AFA": "jin6",
    "\u8AFB": "wong4",
    "\u8AFC": "hyun1",
    "\u8AFD": "gaak3",
    "\u8AFE": "nok6/lok6",
    "\u8AFF": "cap1",
    "\u8B00": "mau4",
    "\u8B01": "jit3/kit3",
    "\u8B02": "wai6",
    "\u8B03": "sing1",
    "\u8B04": "tang4",
    "\u8B05": "zau1/zau3",
    "\u8B06": "sin3",
    "\u8B07": "gin2/hin1",
    "\u8B08": "bok6",
    "\u8B09": "kwai5",
    "\u8B0A": "fong1/fong2",
    "\u8B0B": "waak6",
    "\u8B0C": "go1",
    "\u8B0D": "jing4/gwang1",
    "\u8B0E": "mai4/mai2",
    "\u8B0F": "siu2/sau2",
    "\u8B10": "mat6",
    "\u8B11": "hai5",
    "\u8B12": "coeng1",
    "\u8B13": "can1",
    "\u8B14": "joek6",
    "\u8B15": "tai4",
    "\u8B16": "suk1",
    "\u8B17": "pong3",
    "\u8B18": "ci4",
    "\u8B19": "him1",
    "\u8B1A": "si3",
    "\u8B1B": "gong2",
    "\u8B1C": "jyun4",
    "\u8B1D": "ze6",
    "\u8B1E": "hok6",
    "\u8B1F": "tou1",
    "\u8B20": "jiu4",
    "\u8B21": "jiu4",
    "\u8B22": "wu6",
    "\u8B23": "jyu4",
    "\u8B24": "biu1",
    "\u8B25": "cung3",
    "\u8B26": "hing3",
    "\u8B27": "lei4",
    "\u8B28": "mou4",
    "\u8B29": "mou4",
    "\u8B2A": "soeng1",
    "\u8B2B": "zaak6",
    "\u8B2C": "mau6",
    "\u8B2D": "zin2",
    "\u8B2E": "zaak3",
    "\u8B2F": "ze1",
    "\u8B30": "lin4",
    "\u8B31": "lau4/lou4/leoi5",
    "\u8B32": "cam3",
    "\u8B33": "au1/ngau1",
    "\u8B34": "gwan3",
    "\u8B35": "zaap6",
    "\u8B36": "zoek3",
    "\u8B37": "ngou4/ou4/ngou6/ou6",
    "\u8B38": "ngou6/ou6",
    "\u8B39": "gan2",
    "\u8B3A": "zip3",
    "\u8B3B": "ji4/ci2",
    "\u8B3C": "fu1",
    "\u8B3D": "koeng5",
    "\u8B3E": "maan4/maan6",
    "\u8B3F": "zaau1",
    "\u8B40": "ham6",
    "\u8B41": "waa1",
    "\u8B42": "cin2",
    "\u8B43": "jyu4",
    "\u8B44": "zang1",
    "\u8B45": "sap1",
    "\u8B46": "hei1",
    "\u8B47": "zaa1",
    "\u8B48": "deoi6",
    "\u8B49": "zing3",
    "\u8B4A": "naau4/laau4/hiu1",
    "\u8B4B": "laan4",
    "\u8B4C": "ngo4/o4",
    "\u8B4D": "jing1/jing3",
    "\u8B4E": "kyut3/gwat1",
    "\u8B4F": "gei1",
    "\u8B50": "zyun2",
    "\u8B51": "giu2",
    "\u8B52": "bo3",
    "\u8B53": "wai6",
    "\u8B54": "zaan6/zaan3",
    "\u8B55": "mou4",
    "\u8B56": "zam3/cam3",
    "\u8B57": "zaap3",
    "\u8B58": "sik1/zi3",
    "\u8B59": "ciu4/ciu3",
    "\u8B5A": "taam4",
    "\u8B5B": "zam3",
    "\u8B5C": "pou2",
    "\u8B5D": "sing4",
    "\u8B5E": "hyun1",
    "\u8B5F": "cou3",
    "\u8B60": "taan1",
    "\u8B61": "dong2",
    "\u8B62": "seoi6",
    "\u8B63": "him2",
    "\u8B64": "gik1",
    "\u8B65": "giu3",
    "\u8B66": "ging2",
    "\u8B67": "zaam1",
    "\u8B68": "nung4/lung4",
    "\u8B69": "ji1",
    "\u8B6A": "oi2/ngoi2",
    "\u8B6B": "zim1",
    "\u8B6C": "pei3",
    "\u8B6D": "wai2",
    "\u8B6E": "waa6",
    "\u8B6F": "jik6/jik2",
    "\u8B70": "ji5/ji3",
    "\u8B71": "sin6",
    "\u8B72": "joeng6",
    "\u8B73": "nau6/lau6",
    "\u8B74": "hin2",
    "\u8B75": "deoi6",
    "\u8B76": "daap6",
    "\u8B77": "wu6",
    "\u8B78": "zau1",
    "\u8B79": "haak3",
    "\u8B7A": "ngaai6/aai6",
    "\u8B7B": "jing1",
    "\u8B7C": "gaam1",
    "\u8B7D": "jyu6",
    "\u8B7E": "zin2",
    "\u8B7F": "wai6",
    "\u8B80": "duk6/dau6",
    "\u8B81": "zaak6",
    "\u8B82": "gyun3",
    "\u8B83": "zaan3",
    "\u8B84": "leoi5",
    "\u8B85": "sam2",
    "\u8B86": "wai6",
    "\u8B87": "cim2",
    "\u8B88": "lik6",
    "\u8B89": "wai4",
    "\u8B8A": "bin3",
    "\u8B8B": "sip3/zip3",
    "\u8B8C": "jin3",
    "\u8B8D": "ngok6/ok6",
    "\u8B8E": "cau4/sau4",
    "\u8B8F": "wai6",
    "\u8B90": "cau4/sau4",
    "\u8B91": "jiu6",
    "\u8B92": "caam4",
    "\u8B93": "joeng6",
    "\u8B94": "jan2",
    "\u8B95": "laan4",
    "\u8B96": "cam3/caam3",
    "\u8B97": "kwai4",
    "\u8B98": "zip3",
    "\u8B99": "fun1",
    "\u8B9A": "zaan3/zaan2",
    "\u8B9B": "ngai6/ai6",
    "\u8B9C": "dong2",
    "\u8B9D": "zim1",
    "\u8B9E": "jin6",
    "\u8B9F": "duk6",
    "\u8BA0": "gaan2.faa3.jin4.zi6.bin1",
    "\u8BA1": "gai3/gai2/gei3",
    "\u8BA2": "ding3/ding6/deng6",
    "\u8BA3": "fu6",
    "\u8BA4": "jing6/jing2",
    "\u8BA5": "gei1",
    "\u8BA6": "kit3/gai3",
    "\u8BA7": "hung6/hung3",
    "\u8BA8": "tou2",
    "\u8BA9": "joeng6",
    "\u8BAA": "saan3",
    "\u8BAB": "ngat6/at6/gat1",
    "\u8BAC": "tok3",
    "\u8BAD": "fan3",
    "\u8BAE": "ji5/ji3",
    "\u8BAF": "seon3",
    "\u8BB0": "gei3",
    "\u8BB1": "jan6",
    "\u8BB2": "gong2",
    "\u8BB3": "wai5",
    "\u8BB4": "au1/ngau1",
    "\u8BB5": "geoi6",
    "\u8BB6": "ngaa6/aa6",
    "\u8BB7": "neot6/leot6/naap6/laap6/nat6/lat6",
    "\u8BB8": "heoi2/fu2",
    "\u8BB9": "ngo4/o4",
    "\u8BBA": "leon6/leon2/leon4",
    "\u8BBB": "hung1",
    "\u8BBC": "zung6",
    "\u8BBD": "fung3",
    "\u8BBE": "cit3",
    "\u8BBF": "fong2",
    "\u8BC0": "kyut3",
    "\u8BC1": "zing3",
    "\u8BC2": "gu2/gwu2/gu3/gwu3",
    "\u8BC3": "ho1",
    "\u8BC4": "ping4",
    "\u8BC5": "zo3/zo2",
    "\u8BC6": "sik1/zi3/hei1",
    "\u8682": "maa6/maa1/maa5",
    "\u8683": "hoeng2",
    "\u8684": "fong1",
    "\u8685": "ak1/ngak1",
    "\u8686": "baa1",
    "\u8687": "cik3",
    "\u8688": "hin1",
    "\u8689": "man1",
    "\u868A": "man1/man4",
    "\u868B": "jeoi6",
    "\u868C": "pong5",
    "\u868D": "pei4",
    "\u868E": "jyut6",
    "\u868F": "jyut6",
    "\u8690": "gwan1",
    "\u8691": "kei4",
    "\u8692": "jim4",
    "\u8693": "jan5",
    "\u8694": "kei4",
    "\u8695": "caam4/caam2",
    "\u8696": "jyun4",
    "\u8697": "kyut3",
    "\u8698": "wui4",
    "\u8699": "kam4",
    "\u869A": "kei4",
    "\u869B": "zung6",
    "\u869C": "ngaa4/aa4",
    "\u869D": "ci3/hou4",
    "\u869E": "muk6",
    "\u869F": "wong4",
    "\u86A0": "fan4",
    "\u86A1": "fan4",
    "\u86A2": "hong4",
    "\u86A3": "gung1",
    "\u86A4": "zou2",
    "\u86A5": "fu6",
    "\u86A6": "jim4/naam4/laam4",
    "\u86A7": "gaai3/gaai2",
    "\u86A8": "fu4",
    "\u86A9": "ci1",
    "\u86AA": "dau2",
    "\u86AB": "baau1",
    "\u86AC": "hin2",
    "\u86AD": "nei4/lei4",
    "\u86AE": "taai3",
    "\u86AF": "jau1",
    "\u86B0": "jau4",
    "\u86B1": "zaak3/zaa3",
    "\u86B2": "ping4",
    "\u86B3": "ci4",
    "\u86B4": "jau2/jau1/jau3",
    "\u86B5": "ho4",
    "\u86B6": "ham1",
    "\u86B7": "geoi6",
    "\u86B8": "cik1",
    "\u86B9": "fu6",
    "\u86BA": "jim4/naam4/laam4",
    "\u86BB": "zaat3",
    "\u86BC": "ngau1/au1",
    "\u86BD": "pei4",
    "\u86BE": "pei4",
    "\u86BF": "jin4",
    "\u86C0": "zyu3",
    "\u86C1": "diu1",
    "\u86C2": "bit6",
    "\u86C3": "bing2",
    "\u86C4": "gu1/gwu1",
    "\u86C5": "jim4/zim1",
    "\u86C6": "zeoi1/ceoi1",
    "\u86C7": "se4/se2/ji4",
    "\u86C8": "tit3",
    "\u86C9": "ling4",
    "\u86CA": "gu2/gwu2",
    "\u86CB": "daan6/daan2",
    "\u86CC": "gu2/gwu2",
    "\u86CD": "jing4",
    "\u86CE": "lai6",
    "\u86CF": "cing1",
    "\u86D0": "kuk1",
    "\u86D1": "mau4",
    "\u86D2": "gaak3",
    "\u86D3": "ci3",
    "\u86D4": "wui4",
    "\u86D5": "wui4",
    "\u86D6": "mong4",
    "\u86D7": "fau6",
    "\u86D8": "joeng5/joeng4/mai5",
    "\u86D9": "waa1",
    "\u86DA": "lit6",
    "\u86DB": "zyu1",
    "\u86DC": "ji1",
    "\u86DD": "haan4",
    "\u86DE": "kut3/kwut3/fut3",
    "\u86DF": "gaau1",
    "\u86E0": "lai6",
    "\u86E1": "jik6",
    "\u86E2": "ping4",
    "\u86E3": "kit3",
    "\u86E4": "gap3/gaap3/haa4/haa1",
    "\u86E5": "sit6",
    "\u86E6": "ji4",
    "\u86E7": "mong5",
    "\u86E8": "mak6",
    "\u86E9": "kung4",
    "\u86EA": "kit3",
    "\u86EB": "gwai2",
    "\u86EC": "kung4/gung2",
    "\u86ED": "zat6",
    "\u86EE": "maan4",
    "\u86EF": "lou5",
    "\u86F0": "zat6/zik6/zit3",
    "\u86F1": "gaap3",
    "\u86F2": "jiu4/naau4/laau4",
    "\u86F3": "si1",
    "\u86F4": "cai4",
    "\u86F5": "hing1",
    "\u86F6": "lyut6",
    "\u86F7": "kau4",
    "\u86F8": "saau1/siu1",
    "\u86F9": "jung2",
    "\u86FA": "gaap3",
    "\u86FB": "teoi3/seoi3",
    "\u86FC": "ce1",
    "\u86FD": "bui3",
    "\u86FE": "ngo4/o4/ngai5/ai5",
    "\u86FF": "ham5",
    "\u8700": "suk6",
    "\u8701": "syun4",
    "\u8702": "fung1",
    "\u8703": "san6/san5/san4",
    "\u8704": "san6",
    "\u8705": "fu2",
    "\u8706": "hin2",
    "\u8707": "zit3",
    "\u8708": "ng4/m4",
    "\u8709": "fau4",
    "\u870A": "lei4",
    "\u870B": "long4",
    "\u870C": "bai6",
    "\u870D": "ceoi4/cyu4/syu4",
    "\u870E": "jyun1",
    "\u870F": "jau5",
    "\u8710": "gip3",
    "\u8711": "daan6",
    "\u8712": "jin4",
    "\u8713": "ting4",
    "\u8714": "tin4",
    "\u8715": "teoi3/seoi3",
    "\u8716": "wui4",
    "\u8717": "wo1",
    "\u8718": "zi1",
    "\u8719": "sung1",
    "\u871A": "fei2/fei1",
    "\u871B": "geoi1",
    "\u871C": "mat6",
    "\u871D": "kei4",
    "\u871E": "kei4/kei2",
    "\u871F": "juk6",
    "\u8720": "kwan5",
    "\u8721": "laap6/zaa3",
    "\u8722": "maang5/maang2",
    "\u8723": "goeng1",
    "\u8724": "si1",
    "\u8725": "sik1",
    "\u8726": "leon4",
    "\u8727": "lai6",
    "\u8728": "dip6",
    "\u8729": "tiu4",
    "\u872A": "tou1",
    "\u872B": "gwan1",
    "\u872C": "ham4",
    "\u872D": "ham5",
    "\u872E": "wik6",
    "\u872F": "pong5",
    "\u8730": "fei4",
    "\u8731": "pei4",
    "\u8732": "wai1",
    "\u8733": "deon1",
    "\u8734": "jik6",
    "\u8735": "jyun1",
    "\u8736": "seot1",
    "\u8737": "kyun4",
    "\u8738": "hin2",
    "\u8739": "jeoi6",
    "\u873A": "ngai4/ai4",
    "\u873B": "cing1/zing1",
    "\u873C": "wai2",
    "\u873D": "loeng5",
    "\u873E": "gwo2/go2",
    "\u873F": "jyun1/jyun2",
    "\u8740": "dung1/dung3",
    "\u8741": "ok3/ngok3",
    "\u8742": "baan2",
    "\u8743": "dai3",
    "\u8744": "mong5",
    "\u8745": "caam4",
    "\u8746": "me1",
    "\u8747": "jing4/jing1",
    "\u8748": "gwok3/gok3",
    "\u8749": "sim4/sim2/sin4",
    "\u874A": "ding6",
    "\u874B": "laap6",
    "\u874C": "fo1",
    "\u874D": "zik1",
    "\u874E": "hot3/hit3/kit3",
    "\u874F": "ting4",
    "\u8750": "mou6/mui6",
    "\u8751": "seoi1",
    "\u8752": "min4",
    "\u8753": "jyu4",
    "\u8754": "gaai1",
    "\u8755": "sik6/sit6",
    "\u8756": "hyun1",
    "\u8757": "wong4",
    "\u8758": "jin2",
    "\u8759": "bin1/pin1",
    "\u875A": "jau4",
    "\u875B": "wai1",
    "\u875C": "fu6",
    "\u875D": "jyun4",
    "\u875E": "mei6",
    "\u875F": "wai6",
    "\u8760": "fuk1",
    "\u8761": "jyu4",
    "\u8762": "kit3",
    "\u8763": "jau4",
    "\u8764": "jau4/cau4/zau1",
    "\u8765": "maau4",
    "\u8766": "haa1/haa4",
    "\u8767": "jing1",
    "\u8768": "sat1",
    "\u8769": "cung4",
    "\u876A": "tong1",
    "\u876B": "zyu1",
    "\u876C": "zung1",
    "\u876D": "tai4",
    "\u876E": "fuk1",
    "\u876F": "jyun4",
    "\u8770": "kwai1/fui1",
    "\u8771": "mang4/mong4",
    "\u8772": "laat6",
    "\u8773": "doi6",
    "\u8774": "wu4",
    "\u8775": "cau1",
    "\u8776": "dip6/dip2",
    "\u8777": "lik6",
    "\u8778": "wo1",
    "\u8779": "wan1",
    "\u877A": "geoi2",
    "\u877B": "naam4/laam4",
    "\u877C": "lau4",
    "\u877D": "ceon1",
    "\u877E": "wing4",
    "\u877F": "jing4",
    "\u8780": "zoeng1",
    "\u8781": "teoi3",
    "\u8782": "long4/long2",
    "\u8783": "pong4",
    "\u8784": "si1",
    "\u8785": "sik1",
    "\u8786": "zi1",
    "\u8787": "hai4",
    "\u8788": "jyun4",
    "\u8789": "jung1",
    "\u878A": "lim4/ham1",
    "\u878B": "sau1/sau3/sau2",
    "\u878C": "baan1/pun4",
    "\u878D": "jung4",
    "\u878E": "jung4",
    "\u878F": "zat6",
    "\u8790": "wu1",
    "\u8791": "jau3",
    "\u8792": "hon6",
    "\u8793": "ceon4",
    "\u8794": "ji4",
    "\u8795": "bai1",
    "\u8796": "waat6",
    "\u8797": "tong4",
    "\u8798": "ngai5/ai5",
    "\u8799": "dou3",
    "\u879A": "noi6/loi6",
    "\u879B": "hot6",
    "\u879C": "huk6",
    "\u879D": "gwai1",
    "\u879E": "maa5/maa6/maa1",
    "\u879F": "ming4",
    "\u87A0": "jik1/si3",
    "\u87A1": "man1/man4",
    "\u87A2": "jing4",
    "\u87A3": "dak6/tang4",
    "\u87A4": "zung1",
    "\u87A5": "cong1",
    "\u87A6": "sou3",
    "\u87A7": "kei4",
    "\u87A8": "mun5",
    "\u87A9": "tiu4",
    "\u87AA": "soeng1",
    "\u87AB": "sik1/cik1",
    "\u87AC": "cou4",
    "\u87AD": "ci1",
    "\u87AE": "dai3",
    "\u87AF": "ngou4/ou4",
    "\u87B0": "luk6",
    "\u87B1": "wai3",
    "\u87B2": "dit6/zat6",
    "\u87B3": "tong4",
    "\u87B4": "can4",
    "\u87B5": "piu1",
    "\u87B6": "keoi4",
    "\u87B7": "pei4",
    "\u87B8": "jyu4",
    "\u87B9": "zim6/caam4",
    "\u87BA": "lo4/lo2",
    "\u87BB": "lau4",
    "\u87BC": "jan2",
    "\u87BD": "zung1",
    "\u87BE": "jan5",
    "\u87BF": "zoeng1",
    "\u87C0": "seot1",
    "\u87C1": "man1/man4",
    "\u87C2": "giu1",
    "\u87C3": "maan6",
    "\u87C4": "zat6/zik6/zit3",
    "\u87C5": "ze3",
    "\u87C6": "maa4/mou1",
    "\u87C7": "maa4/mou1",
    "\u87C8": "gwok3/gok3",
    "\u87C9": "lau4",
    "\u87CA": "maau4",
    "\u87CB": "sik1",
    "\u87CC": "cung1",
    "\u87CD": "lei4",
    "\u87CE": "mun5",
    "\u87CF": "siu1",
    "\u87D0": "kei4",
    "\u87D1": "zoeng1",
    "\u87D2": "mong5",
    "\u87D3": "zoeng6",
    "\u87D4": "mat6",
    "\u87D5": "zai1",
    "\u87D6": "si1",
    "\u87D7": "cau1",
    "\u87D8": "dak6/dat6",
    "\u87D9": "zik1",
    "\u87DA": "paang4",
    "\u87DB": "paang4",
    "\u87DC": "giu2",
    "\u87DD": "keoi4/keoi2",
    "\u87DE": "bit3",
    "\u87DF": "liu4",
    "\u87E0": "pun4/faan4",
    "\u87E1": "wai1",
    "\u87E2": "hei2",
    "\u87E3": "gei2/kei4",
    "\u87E4": "zyun1",
    "\u87E5": "wong4",
    "\u87E6": "fei4",
    "\u87E7": "lou4/lou2",
    "\u87E8": "kyut3",
    "\u87E9": "kyut3",
    "\u87EA": "wai6",
    "\u87EB": "jam4/taam4/cam4",
    "\u87EC": "sim4/sim2/sin4",
    "\u87ED": "ziu1",
    "\u87EE": "sin6",
    "\u87EF": "jiu4/naau4/laau4",
    "\u87F0": "siu1",
    "\u87F1": "mou4",
    "\u87F2": "cung4/cung2",
    "\u87F3": "cing4",
    "\u87F4": "si1",
    "\u87F5": "cyu4",
    "\u87F6": "cing1",
    "\u87F7": "dong1",
    "\u87F8": "lai5",
    "\u87F9": "haai5",
    "\u87FA": "sin6",
    "\u87FB": "ngai5/ai5",
    "\u87FC": "ging2",
    "\u87FD": "daat6",
    "\u87FE": "sim4",
    "\u87FF": "kai3",
    "\u8800": "ci1",
    "\u8801": "hoeng2",
    "\u8802": "sip3",
    "\u8803": "lo2/lo4",
    "\u8804": "kam4",
    "\u8805": "jing4/jing1",
    "\u8806": "caai3",
    "\u8807": "lai6",
    "\u8808": "caak3",
    "\u8809": "hyun1",
    "\u880A": "lim4",
    "\u880B": "zuk1",
    "\u880C": "zaak6",
    "\u880D": "hit3/kit3",
    "\u880E": "mong5",
    "\u880F": "haai5",
    "\u8810": "cai4",
    "\u8811": "wing4",
    "\u8812": "gaan2",
    "\u8813": "mung5",
    "\u8814": "hou4",
    "\u8815": "jyu4",
    "\u8816": "wok6",
    "\u8817": "zok6",
    "\u8818": "zit6",
    "\u8819": "pan4/ban1",
    "\u881A": "kok3/hok3",
    "\u881B": "mit6",
    "\u881C": "faan4",
    "\u881D": "leoi5",
    "\u881E": "zit6",
    "\u881F": "laap6",
    "\u8820": "man5",
    "\u8821": "lai5/lai4",
    "\u8822": "ceon2",
    "\u8823": "lai6",
    "\u8824": "cau1",
    "\u8825": "jit6/jip6",
    "\u8826": "lou4",
    "\u8827": "dou3",
    "\u8828": "siu1",
    "\u8829": "zyu1",
    "\u882A": "lung4",
    "\u882B": "lai5",
    "\u882C": "lung4",
    "\u882D": "fung1",
    "\u882E": "jit3/jit6",
    "\u882F": "pei4",
    "\u8830": "joeng6",
    "\u8831": "gu2/gwu2",
    "\u8832": "gyun1",
    "\u8833": "ang1/ngang1",
    "\u8834": "syu4",
    "\u8835": "kwai4",
    "\u8836": "caam4/caam2",
    "\u8837": "keoi4",
    "\u8838": "kyun4",
    "\u8839": "dou3",
    "\u883A": "caam4",
    "\u883B": "maan4",
    "\u883C": "keoi4/fok3",
    "\u883D": "zit3",
    "\u883E": "zuk1",
    "\u883F": "zyut3",
    "\u8840": "hyut3",
    "\u8841": "fong1",
    "\u8842": "nuk6/luk6",
    "\u8843": "pui1",
    "\u8844": "nuk6/luk6",
    "\u8845": "jan6",
    "\u8846": "zung3",
    "\u8847": "mak6",
    "\u8848": "nei6/lei6",
    "\u8849": "haak3",
    "\u884A": "mit6",
    "\u884B": "sik1",
    "\u884C": "hang4/hang2/haang4/haang2/hong4/hong2/hang6",
    "\u884D": "jin2/hin2/jin5",
    "\u884E": "hon3",
    "\u884F": "jyun2/jyun6",
    "\u8850": "geoi6",
    "\u8851": "ling4",
    "\u8852": "jyun6/jyun4",
    "\u8853": "seot6/seot2",
    "\u8854": "haam4/ham4",
    "\u8855": "dung6/tung4",
    "\u8856": "hong6/hong2/lung6/nung6",
    "\u8857": "gaai1",
    "\u8858": "haam4/ham4",
    "\u8859": "ngaa4/aa4",
    "\u885A": "wu4",
    "\u885B": "wai6",
    "\u885C": "dou6/dou3",
    "\u885D": "cung1/cung3",
    "\u885E": "wai6",
    "\u885F": "dou6",
    "\u8860": "zeon1",
    "\u8861": "hang4/waang4",
    "\u8862": "keoi4",
    "\u8863": "ji1/ji3",
    "\u8864": "ji1.zi6.bin1",
    "\u8865": "bou2",
    "\u8866": "gon2",
    "\u8867": "jyu1",
    "\u8868": "biu2/biu1",
    "\u8869": "caa3/caa2",
    "\u886A": "ji5/ji4",
    "\u886B": "saam1",
    "\u886C": "can3",
    "\u886D": "fu1/fu3",
    "\u886E": "gwan2",
    "\u886F": "fan1",
    "\u8870": "seoi1/ceoi1",
    "\u8871": "gip3",
    "\u8872": "naap6/laap6/naap2/laap2",
    "\u8873": "zung1",
    "\u8874": "dam2",
    "\u8875": "nik1/lik1/jat6",
    "\u8876": "zung6",
    "\u8877": "zung1/cung1",
    "\u8878": "gaai3",
    "\u8879": "zi2",
    "\u887A": "ce4",
    "\u887B": "jim4",
    "\u887C": "zi1",
    "\u887D": "jam6/jam5",
    "\u887E": "kam1",
    "\u887F": "kam1/gam1",
    "\u8880": "gwan1",
    "\u8881": "jyun4",
    "\u8882": "mai6",
    "\u8883": "caai3",
    "\u8884": "ou2/ngou2/ou3/ngou3",
    "\u8885": "niu5/liu5",
    "\u8886": "fai1",
    "\u8887": "jim4",
    "\u8888": "gaa1",
    "\u8889": "to4",
    "\u888A": "ling5",
    "\u888B": "doi6/doi2",
    "\u888C": "pou5/pou4",
    "\u888D": "pou4/pou2",
    "\u888E": "jau3",
    "\u888F": "zo3",
    "\u8890": "bat1",
    "\u8891": "siu6",
    "\u8892": "taan2",
    "\u8893": "zeoi6",
    "\u8894": "ho6",
    "\u8895": "jyut6",
    "\u8896": "zau6",
    "\u8897": "zan1/can2/zan2",
    "\u8898": "ji5/ji4",
    "\u8899": "paa3",
    "\u889A": "fat1",
    "\u889B": "dai1/zi1",
    "\u889C": "mat6/mat2/maat6/mut6",
    "\u889D": "fu6",
    "\u889E": "gwan2",
    "\u889F": "dit6",
    "\u88A0": "dit6",
    "\u88A1": "jim4",
    "\u88A2": "faan4/paan3",
    "\u88A3": "ji3",
    "\u88A4": "mau6",
    "\u88A5": "tok3",
    "\u88A6": "neot6/leot6",
    "\u88A7": "kau1/gau1",
    "\u88A8": "jyun6",
    "\u88A9": "dim1",
    "\u88AA": "keoi1",
    "\u88AB": "bei6/pei5/pei1",
    "\u88AC": "juk6",
    "\u88AD": "zaap6",
    "\u88AE": "ji5",
    "\u88AF": "but6/but3",
    "\u88B0": "mou5",
    "\u88B1": "fuk6/fuk2",
    "\u88B2": "ji4",
    "\u88B3": "ci2",
    "\u88B4": "fu3",
    "\u88B5": "jam6/jam5",
    "\u88B6": "gong3",
    "\u88B7": "gip3/hap1/gaap3",
    "\u88B8": "zin6",
    "\u88B9": "baak3",
    "\u88BA": "git3",
    "\u88BB": "ji4",
    "\u88BC": "gok3",
    "\u88BD": "jyu4",
    "\u88BE": "zyu1",
    "\u88BF": "gwai1",
    "\u88C0": "jan1",
    "\u88C1": "coi4",
    "\u88C2": "lit6/lit3",
    "\u88C3": "lung6",
    "\u88C4": "hang4",
    "\u88C5": "zong1",
    "\u88C6": "dong1",
    "\u88C7": "seot1",
    "\u88C8": "gwan1",
    "\u88C9": "kang3",
    "\u88CA": "niu5/liu5",
    "\u88CB": "syu6",
    "\u88CC": "gaap3",
    "\u88CD": "kwan2",
    "\u88CE": "cing4",
    "\u88CF": "leoi5/lei5",
    "\u88D0": "gyun1",
    "\u88D1": "san1",
    "\u88D2": "pau4/fau4",
    "\u88D3": "gat1/gaai1",
    "\u88D4": "jeoi6",
    "\u88D5": "jyu6",
    "\u88D6": "zan3",
    "\u88D7": "lau4",
    "\u88D8": "kau4",
    "\u88D9": "kwan4/kwan2",
    "\u88DA": "zai3",
    "\u88DB": "jap1",
    "\u88DC": "bou2",
    "\u88DD": "zong1",
    "\u88DE": "seoi3",
    "\u88DF": "saa1",
    "\u88E0": "kwan4",
    "\u88E1": "leoi5/lei5",
    "\u88E2": "lin4",
    "\u88E3": "lim5/lim6",
    "\u88E4": "fu3",
    "\u88E5": "gaan2/gaan3",
    "\u88E6": "bou1",
    "\u88E7": "cim1/sim4",
    "\u88E8": "pei4/bei1",
    "\u88E9": "gwan1",
    "\u88EA": "tou4",
    "\u88EB": "jyun3",
    "\u88EC": "ling4",
    "\u88ED": "ci2",
    "\u88EE": "coeng1",
    "\u88EF": "cau4/dou1",
    "\u88F0": "zyut3",
    "\u88F1": "biu2",
    "\u88F2": "loeng5",
    "\u88F3": "soeng4",
    "\u88F4": "pui4",
    "\u88F5": "pui4",
    "\u88F6": "fei1",
    "\u88F7": "jyun1/gwan2",
    "\u88F8": "lo2",
    "\u88F9": "gwo2/go2",
    "\u88FA": "jim2",
    "\u88FB": "duk1",
    "\u88FC": "sik1/sik3/tik1/tai3",
    "\u88FD": "zai3",
    "\u88FE": "geoi1",
    "\u88FF": "ji2",
    "\u8900": "gei6",
    "\u8901": "gwo2/go2",
    "\u8902": "gwaa3/gwaa2/kwaa2",
    "\u8903": "kang3",
    "\u8904": "cai1",
    "\u8905": "tai3",
    "\u8906": "tai4",
    "\u8907": "fuk1",
    "\u8908": "cung4",
    "\u8909": "kit3",
    "\u890A": "bin2",
    "\u890B": "dip6",
    "\u890C": "gwan1",
    "\u890D": "dyun1",
    "\u890E": "zau6/jau6",
    "\u890F": "zau6/jau6",
    "\u8910": "hot3",
    "\u8911": "jyun6",
    "\u8912": "bou1",
    "\u8913": "bou2",
    "\u8914": "fu3",
    "\u8915": "jyu4",
    "\u8916": "teon3",
    "\u8917": "jin2",
    "\u8918": "fai1",
    "\u8919": "bui3",
    "\u891A": "cyu5/cyu2/ze2",
    "\u891B": "leoi5/lau5/lau1",
    "\u891C": "baau1",
    "\u891D": "daan1",
    "\u891E": "wan2",
    "\u891F": "taap3",
    "\u8920": "kau1",
    "\u8921": "daap3",
    "\u8922": "waai4",
    "\u8923": "jung4",
    "\u8924": "jyun6",
    "\u8925": "juk6/juk2",
    "\u8926": "naai6/laai6/le5/nang3/lang3",
    "\u8927": "gwing2",
    "\u8928": "so2",
    "\u8929": "bun1",
    "\u892A": "tan3/teoi3",
    "\u892B": "ci2",
    "\u892C": "song2",
    "\u892D": "niu5/liu5",
    "\u892E": "ang1/ngang1",
    "\u892F": "zik6",
    "\u8930": "hin1",
    "\u8931": "waai4",
    "\u8932": "fu3",
    "\u8933": "lin4",
    "\u8934": "laam4",
    "\u8935": "lei4",
    "\u8936": "zip3/zaap3/dip6/zaap6",
    "\u8937": "si1",
    "\u8938": "leoi5/lau5/lau1",
    "\u8939": "ngai6/ai6",
    "\u893A": "dip6",
    "\u893B": "sit3",
    "\u893C": "sin1",
    "\u893D": "wai3",
    "\u893E": "biu2",
    "\u893F": "cou4",
    "\u8940": "zik1",
    "\u8941": "koeng5",
    "\u8942": "sam1/saam1",
    "\u8943": "bou1",
    "\u83C0": "jyun2/wat1/wan5/wan3",
    "\u83C1": "zing1/cing1",
    "\u83C2": "dik1",
    "\u83C3": "keoi4",
    "\u83C4": "dung1",
    "\u83C5": "gaan1",
    "\u83C6": "zau1",
    "\u83C7": "gu1/gwu1",
    "\u83C8": "laap6",
    "\u83C9": "luk6",
    "\u83CA": "guk1",
    "\u83CB": "mei6",
    "\u83CC": "kwan2",
    "\u83CD": "nip6/lip6",
    "\u83CE": "kwan1",
    "\u83CF": "go1/ho4",
    "\u83D0": "duk6",
    "\u83D1": "zi1/ji1/zoi1",
    "\u83D2": "gou2",
    "\u83D3": "gwo2/go2",
    "\u83D4": "fuk6/baak6",
    "\u83D5": "leon4",
    "\u83D6": "coeng1",
    "\u83D7": "cau4",
    "\u83D8": "sung1",
    "\u83D9": "ceoi4",
    "\u83DA": "zaan6",
    "\u83DB": "mun4",
    "\u83DC": "coi3/coi2",
    "\u83DD": "bat6",
    "\u83DE": "lai4",
    "\u83DF": "tou3/tou4",
    "\u83E0": "bo1",
    "\u83E1": "haam5",
    "\u83E2": "bou6",
    "\u83E3": "jan3",
    "\u83E4": "gyun2",
    "\u83E5": "sik1",
    "\u83E6": "kan4",
    "\u83E7": "dai2",
    "\u83E8": "zip3",
    "\u83E9": "pou4",
    "\u83EA": "dong6",
    "\u83EB": "gan2/gan3",
    "\u83EC": "ciu4",
    "\u83ED": "toi4",
    "\u83EE": "gang1",
    "\u83EF": "waa4/waa2/waa6/faa1",
    "\u83F0": "gu1/gwu1",
    "\u83F1": "ling4",
    "\u83F2": "fei2/fei1",
    "\u83F3": "kan4",
    "\u83F4": "am1/ngam1",
    "\u83F5": "mong5",
    "\u83F6": "bung2",
    "\u83F7": "zau2/zaau2",
    "\u83F8": "jin1",
    "\u83F9": "zeoi1",
    "\u83FA": "gin1",
    "\u83FB": "lam5/lam4",
    "\u83FC": "taam2",
    "\u83FD": "suk6",
    "\u83FE": "tim4",
    "\u83FF": "dou3",
    "\u8400": "fu2",
    "\u8401": "kei4/gei1",
    "\u8402": "wo4",
    "\u8403": "seoi6",
    "\u8404": "tou4/tou2",
    "\u8405": "ceon1",
    "\u8406": "bai3/bei1/bei6",
    "\u8407": "coeng4",
    "\u8408": "wun4",
    "\u8409": "fai6",
    "\u840A": "loi4",
    "\u840B": "cai1",
    "\u840C": "mang4/maang4",
    "\u840D": "ping4",
    "\u840E": "wai2/wai1",
    "\u840F": "daam6",
    "\u8410": "saap3",
    "\u8411": "wun4/teoi1",
    "\u8412": "jin5",
    "\u8413": "ji4",
    "\u8414": "tiu4",
    "\u8415": "cai5",
    "\u8416": "gun1/gwun1",
    "\u8417": "caak3",
    "\u8418": "noi6/loi6",
    "\u8419": "zam2",
    "\u841A": "tok3",
    "\u841B": "syun3",
    "\u841C": "tip3",
    "\u841D": "lo4",
    "\u841E": "bei1",
    "\u841F": "ngai6/ai6",
    "\u8420": "pang4",
    "\u8421": "bok6",
    "\u8422": "paau1",
    "\u8423": "ding6",
    "\u8424": "jing4",
    "\u8425": "jing4",
    "\u8426": "jing4",
    "\u8427": "siu1",
    "\u8428": "saat3/saat2",
    "\u8429": "cau1",
    "\u842A": "fo1",
    "\u842B": "hoeng3",
    "\u842C": "maan6",
    "\u842D": "jyu5/geoi2",
    "\u842E": "jyu4",
    "\u842F": "fu6",
    "\u8430": "lin6",
    "\u8431": "hyun1",
    "\u8432": "hyun1",
    "\u8433": "naam5/laam5",
    "\u8434": "zak1",
    "\u8435": "wo1",
    "\u8436": "ceon2",
    "\u8437": "siu1/sok3",
    "\u8438": "jyu4",
    "\u8439": "pin1/bin1/bin2",
    "\u843A": "mou6",
    "\u843B": "jam1",
    "\u843C": "ngok6/ok6",
    "\u843D": "lok6/lok1/lok2/laai6",
    "\u843E": "jing4",
    "\u843F": "kut3/kwut3",
    "\u8440": "kut3/kwut3",
    "\u8441": "goeng1",
    "\u8442": "min5",
    "\u8443": "zok6",
    "\u8444": "zou6",
    "\u8445": "zeoi1",
    "\u8446": "bou2",
    "\u8447": "jau4",
    "\u8448": "saai2",
    "\u8449": "jip6/jip2/sip3",
    "\u844A": "am1/ngam1",
    "\u844B": "keoi4",
    "\u844C": "gaan1",
    "\u844D": "fuk1/fuk6",
    "\u844E": "leot6",
    "\u844F": "zin1",
    "\u8450": "pun4",
    "\u8451": "fung1/fung6",
    "\u8452": "hung4",
    "\u8453": "hung4",
    "\u8454": "hau4",
    "\u8455": "jin4",
    "\u8456": "dat6",
    "\u8457": "zyu3/zoek6/zoek3",
    "\u8458": "zi1",
    "\u8459": "soeng1",
    "\u845A": "sam6/sam4",
    "\u845B": "got3/got2",
    "\u845C": "kit3/hat6",
    "\u845D": "king4",
    "\u845E": "mei5",
    "\u845F": "wong4",
    "\u8460": "sam1",
    "\u8461": "pou4",
    "\u8462": "goi3/koi3/hap1/hap6/gap3",
    "\u8463": "dung2",
    "\u8464": "zau6",
    "\u8465": "zin3",
    "\u8466": "wai5",
    "\u8467": "but6",
    "\u8468": "wui1",
    "\u8469": "baa1/paa1",
    "\u846A": "gai3/gaai3",
    "\u846B": "wu4",
    "\u846C": "zong3",
    "\u846D": "gaa1",
    "\u846E": "dyun6",
    "\u846F": "joek6/joek3",
    "\u8470": "seoi1/zeon3",
    "\u8471": "cung1",
    "\u8472": "cyun4",
    "\u8473": "wai1",
    "\u8474": "zam1",
    "\u8475": "kwai4/kwai2",
    "\u8476": "ting4",
    "\u8477": "fan1",
    "\u8478": "saai2",
    "\u8479": "si1",
    "\u847A": "cap1",
    "\u847B": "laam4",
    "\u847C": "zung1",
    "\u847D": "jiu1",
    "\u847E": "jyun1",
    "\u847F": "mei4",
    "\u8480": "wan1",
    "\u8481": "wat6",
    "\u8482": "dai3",
    "\u8483": "syun6",
    "\u8484": "gun1/gwun1",
    "\u8485": "jim5",
    "\u8486": "zuk1",
    "\u8487": "cin2/zin2",
    "\u8488": "kaai2",
    "\u8489": "gwai6",
    "\u848A": "faa1",
    "\u848B": "zoeng1/zoeng2",
    "\u848C": "lau4/lau1/lau5",
    "\u848D": "wai2",
    "\u848E": "paai3",
    "\u848F": "wing6",
    "\u8490": "sau1/sau2",
    "\u8491": "jan1",
    "\u8492": "si1",
    "\u8493": "seon4",
    "\u8494": "si4/si2/si6",
    "\u8495": "wan1",
    "\u8496": "zan1",
    "\u8497": "long6",
    "\u8498": "neoi4/leoi4",
    "\u8499": "mung4/mung1/mung2",
    "\u849A": "lik6",
    "\u849B": "kyut3",
    "\u849C": "syun3",
    "\u849D": "jyun4",
    "\u849E": "lei6",
    "\u849F": "geoi2",
    "\u84A0": "sik1",
    "\u84A1": "pong4/bong2/bong6",
    "\u84A2": "ceoi4",
    "\u84A3": "ceoi4",
    "\u84A4": "tou4",
    "\u84A5": "lau4",
    "\u84A6": "wok6",
    "\u84A7": "dim2",
    "\u84A8": "sin6",
    "\u84A9": "zou1",
    "\u84AA": "pok3",
    "\u84AB": "co4",
    "\u84AC": "jyun1",
    "\u84AD": "co1",
    "\u84AE": "juk6",
    "\u84AF": "gwaai2",
    "\u84B0": "pun4",
    "\u84B1": "pou4",
    "\u84B2": "pou4/bok6",
    "\u84B3": "naap6/laap6",
    "\u84B4": "sok3",
    "\u84B5": "hai4",
    "\u84B6": "fan4",
    "\u84B7": "wan4",
    "\u84B8": "zing1",
    "\u84B9": "gim1",
    "\u84BA": "zat6",
    "\u84BB": "joek6",
    "\u84BC": "cong1/cong2",
    "\u84BD": "jan1",
    "\u84BE": "mai4",
    "\u84BF": "hou1",
    "\u84C0": "syun1",
    "\u84C1": "zeon1",
    "\u84C2": "ming4",
    "\u84C3": "sau1",
    "\u84C4": "cuk1",
    "\u84C5": "lau4",
    "\u84C6": "zik6/zek6",
    "\u84C7": "gwat1",
    "\u84C8": "long4",
    "\u84C9": "jung4",
    "\u84CA": "jung2",
    "\u84CB": "goi3/koi3/hap1/hap6/gap3",
    "\u84CC": "co3",
    "\u84CD": "si1",
    "\u84CE": "tong4",
    "\u84CF": "lo2",
    "\u84D0": "juk6",
    "\u84D1": "so1",
    "\u84D2": "hin1",
    "\u84D3": "pui5/pui4",
    "\u84D4": "jiu5",
    "\u84D5": "gwai3",
    "\u84D6": "bei1/bei6",
    "\u84D7": "zung2",
    "\u84D8": "gwan2",
    "\u84D9": "zo6",
    "\u84DA": "tiu4",
    "\u84DB": "cik1",
    "\u84DC": "pui3",
    "\u84DD": "laam4/laam2",
    "\u84DE": "daam6",
    "\u84DF": "gai3",
    "\u84E0": "lei4",
    "\u84E1": "sam1",
    "\u84E2": "long5",
    "\u84E3": "jyu6",
    "\u84E4": "ling4",
    "\u84E5": "jing4",
    "\u84E6": "mak6",
    "\u84E7": "diu6",
    "\u84E8": "tiu1/tiu4",
    "\u84E9": "mou6",
    "\u84EA": "tung1",
    "\u84EB": "zuk6",
    "\u84EC": "pung4/fung4",
    "\u84ED": "am1/ngam1",
    "\u84EE": "lin4/lin2",
    "\u84EF": "cung1",
    "\u84F0": "saai2",
    "\u84F1": "ping4",
    "\u84F2": "jau1",
    "\u84F3": "kan4",
    "\u84F4": "seon4",
    "\u84F5": "zit6",
    "\u84F6": "wai4",
    "\u84F7": "teoi1",
    "\u84F8": "cou4",
    "\u84F9": "jyu6",
    "\u84FA": "ngai6/ai6",
    "\u84FB": "cap1",
    "\u84FC": "liu5/luk6",
    "\u84FD": "bat1",
    "\u84FE": "lou5",
    "\u84FF": "suk1",
    "\u8500": "bou6",
    "\u8501": "zoeng1",
    "\u8502": "leoi4",
    "\u8503": "koeng2/goeng2",
    "\u8504": "maan6",
    "\u8505": "jin4",
    "\u8506": "ling4",
    "\u8507": "gei3",
    "\u8508": "biu1",
    "\u8509": "gwan2",
    "\u850A": "hon2/hon6",
    "\u850B": "dik6",
    "\u850C": "cuk1",
    "\u850D": "luk6",
    "\u850E": "cit3",
    "\u850F": "soeng1",
    "\u8510": "dik6",
    "\u8511": "mit6",
    "\u8512": "fan1",
    "\u8513": "maan6/maan4",
    "\u8514": "baak6",
    "\u8515": "dai3",
    "\u8516": "co4",
    "\u8517": "ze3",
    "\u8518": "sam1",
    "\u8519": "syun6",
    "\u851A": "wai3/wat1",
    "\u851B": "huk6",
    "\u851C": "ngou4/ou4",
    "\u851D": "mai5",
    "\u851E": "lau4/lau1/lau5",
    "\u851F": "cuk1/cau3/coek3",
    "\u8520": "zung1",
    "\u8521": "coi3",
    "\u8522": "po4",
    "\u8523": "zoeng1/zoeng2",
    "\u8524": "mat6",
    "\u8525": "cung1",
    "\u8526": "niu5/liu5",
    "\u8527": "seoi6/wai6",
    "\u8528": "gyun6",
    "\u8529": "jan4",
    "\u852A": "zim6",
    "\u852B": "jin1",
    "\u852C": "so1",
    "\u852D": "jam1/jam3",
    "\u852E": "gwok3/gok3",
    "\u852F": "can4",
    "\u8530": "wu6",
    "\u8531": "saat3",
    "\u8532": "kau3",
    "\u8533": "sin6",
    "\u8534": "maa4",
    "\u8535": "cong4",
    "\u8536": "zaak3",
    "\u8537": "coeng4",
    "\u8538": "dau1",
    "\u8539": "lim5/lim6",
    "\u853A": "leon6",
    "\u853B": "kau3",
    "\u853C": "oi2/ngoi2",
    "\u853D": "bai3",
    "\u853E": "lai4",
    "\u853F": "wai2",
    "\u8540": "gik1",
    "\u8541": "taam4/cam4/cim4",
    "\u8542": "sing3",
    "\u8543": "faan4/faan1",
    "\u8544": "mang4",
    "\u8545": "ngau5/au5",
    "\u8546": "cin2/zin2",
    "\u8547": "din2",
    "\u8548": "cam5/seon3/taam4",
    "\u8549": "ziu1/ciu4",
    "\u854A": "jeoi5/jeoi6",
    "\u854B": "jeoi5/jeoi6",
    "\u854C": "leoi5",
    "\u854D": "jyu4",
    "\u854E": "kiu4",
    "\u854F": "cyu4/zyu1",
    "\u8550": "waa4",
    "\u8551": "gaan1",
    "\u8552": "maai5",
    "\u8553": "wan4",
    "\u8554": "bou1",
    "\u8555": "jau4",
    "\u8556": "keoi4",
    "\u8557": "lou6",
    "\u8558": "jiu4",
    "\u8559": "wai6",
    "\u855A": "ngok6/ok6",
    "\u855B": "tai4",
    "\u855C": "fei2",
    "\u855D": "zyut6/zyut3",
    "\u855E": "zeoi3",
    "\u855F": "faat3",
    "\u8560": "jyu4",
    "\u8561": "fan4",
    "\u8562": "gwai6",
    "\u8563": "seon3",
    "\u8564": "jeoi6/jeoi4",
    "\u8565": "ngaa5/aa5",
    "\u8566": "seoi1",
    "\u8567": "fuk1/fuk6",
    "\u8568": "kyut3",
    "\u8569": "dong6",
    "\u856A": "mou4",
    "\u856B": "dung2",
    "\u856C": "si1",
    "\u856D": "siu1",
    "\u856E": "sik1",
    "\u856F": "saat3",
    "\u8570": "wan1",
    "\u8571": "saau2",
    "\u8572": "kei4",
    "\u8573": "gaan1",
    "\u8574": "wan3/wan5/wan2/wan1",
    "\u8575": "syun1",
    "\u8576": "ling4",
    "\u8577": "jyu6",
    "\u8578": "haa4",
    "\u8579": "ung3/ngung3",
    "\u857A": "cap1",
    "\u857B": "hung4/hung6",
    "\u857C": "sei3",
    "\u857D": "nung4/lung4",
    "\u857E": "leoi5/leoi4",
    "\u857F": "hyun1",
    "\u8580": "wan1",
    "\u8581": "juk1",
    "\u8582": "hat6",
    "\u8583": "hou6",
    "\u8584": "bok6/bok2",
    "\u8585": "hou1",
    "\u8586": "oi3/ngoi3",
    "\u8587": "mei4/mei2",
    "\u8588": "wai3/wui6/kui2/kwui2",
    "\u8589": "wai3",
    "\u858A": "gai3",
    "\u858B": "ci4",
    "\u858C": "hoeng1/hoeng2",
    "\u858D": "waan6",
    "\u858E": "mit6",
    "\u858F": "ji3",
    "\u8590": "ling4",
    "\u8591": "goeng1",
    "\u8592": "caan3",
    "\u8593": "sam1",
    "\u8594": "coeng4",
    "\u8595": "lim4",
    "\u8596": "gwo1/go1",
    "\u8597": "jyun4",
    "\u8598": "daat6",
    "\u8599": "tai3",
    "\u859A": "tong1",
    "\u859B": "sit3",
    "\u859C": "bai6",
    "\u859D": "zim1",
    "\u859E": "syun1",
    "\u859F": "cim1/lim5/lim6",
    "\u85A0": "faan4",
    "\u85A1": "ding2",
    "\u85A2": "haai6/gaai2/gaai1/haai5/gaai3",
    "\u85A3": "gu2/gwu2",
    "\u85A4": "haai6",
    "\u85A5": "suk6",
    "\u85A6": "zin3",
    "\u85A7": "haau2/hou1",
    "\u85A8": "gwang1",
    "\u85A9": "saat3/saat2",
    "\u85AA": "san1",
    "\u85AB": "fan1",
    "\u85AC": "joek6",
    "\u85AD": "baai6",
    "\u85AE": "sau2",
    "\u85AF": "syu4/syu2",
    "\u85B0": "fan1",
    "\u85B1": "deoi6",
    "\u85B2": "pan4",
    "\u85B3": "jyun5/wai2",
    "\u85B4": "ning4/ling4",
    "\u85B5": "cau4",
    "\u85B6": "maai4/wo1",
    "\u85B7": "jyu4",
    "\u85B8": "piu1/piu4/piu2",
    "\u85B9": "toi4",
    "\u85BA": "cai5/cai4/zai3/ci4",
    "\u85BB": "zou2",
    "\u85BC": "can4",
    "\u85BD": "zan1",
    "\u85BE": "ji5",
    "\u85BF": "ji5",
    "\u85C0": "jing4",
    "\u85C1": "gou2",
    "\u85C2": "cung4",
    "\u85C3": "hiu1/hou3",
    "\u85C4": "kei4",
    "\u85C5": "fat6",
    "\u85C6": "gin2",
    "\u85C7": "zeoi6/jyu6",
    "\u85C8": "kwai1",
    "\u85C9": "zik6/ze6/ze3",
    "\u85CA": "bin2",
    "\u85CB": "diu6/diu3",
    "\u85CC": "mat6",
    "\u85CD": "laam4/laam2",
    "\u85CE": "zeon2",
    "\u85CF": "cong4/zong6/zong1",
    "\u85D0": "miu5/miu2",
    "\u85D1": "king4",
    "\u85D2": "kit3",
    "\u85D3": "sin2",
    "\u85D4": "liu4",
    "\u85D5": "ngau5/au5/ngau2/au2",
    "\u85D6": "haan4",
    "\u85D7": "suk1",
    "\u85D8": "leoi4",
    "\u85D9": "ngai6/ai6",
    "\u85DA": "zuk6",
    "\u85DB": "se2",
    "\u85DC": "lai4",
    "\u85DD": "ngai6/ai6",
    "\u85DE": "laa5",
    "\u85DF": "leoi5",
    "\u85E0": "kiu2/kiu5",
    "\u85E1": "dik6",
    "\u85E2": "zi2",
    "\u85E3": "bei1",
    "\u85E4": "tang4",
    "\u85E5": "joek6/joek2",
    "\u85E6": "mo4",
    "\u85E7": "wun6",
    "\u85E8": "biu1",
    "\u85E9": "faan4",
    "\u85EA": "sau2",
    "\u85EB": "taam4",
    "\u85EC": "teoi1",
    "\u85ED": "kung4",
    "\u85EE": "ciu4",
    "\u85EF": "wai3",
    "\u85F0": "lau4",
    "\u85F1": "wui6",
    "\u85F2": "au1/ngau1",
    "\u85F3": "gou2",
    "\u85F4": "wan3/wan5/wan2/wan1",
    "\u85F5": "bou2",
    "\u85F6": "lik6",
    "\u85F7": "syu4",
    "\u85F8": "cyu4/zyu1",
    "\u85F9": "oi2/ngoi2",
    "\u85FA": "leon6",
    "\u85FB": "zou2",
    "\u85FC": "hyun1",
    "\u85FD": "can3",
    "\u85FE": "laai6",
    "\u85FF": "fok3",
    "\u8600": "tok3",
    "\u8601": "ng6/m6/ngok6/ok6",
    "\u8602": "jeoi5/jeoi6",
    "\u8603": "jeoi5",
    "\u8604": "kei4",
    "\u8605": "hang4",
    "\u8606": "lou4/lou2",
    "\u8607": "sou1",
    "\u8608": "teoi4",
    "\u8609": "mong4",
    "\u860A": "wan3/wan5/wan2/wan1",
    "\u860B": "pan4/ping4",
    "\u860C": "jyu5",
    "\u860D": "fan1",
    "\u860E": "kei3",
    "\u860F": "gwing2",
    "\u8610": "hyun1",
    "\u8611": "mo4",
    "\u8612": "cau1",
    "\u8613": "sou1",
    "\u8614": "gwing2",
    "\u8615": "pung4",
    "\u8616": "jit6/jip6/nip6/lip6",
    "\u8617": "baak3/paak3",
    "\u8618": "joeng4",
    "\u8619": "ai3/ngai3",
    "\u861A": "sin2",
    "\u861B": "juk6",
    "\u861C": "guk1",
    "\u861D": "lim5",
    "\u861E": "lim5/lim6",
    "\u861F": "jan2",
    "\u8620": "coeng4",
    "\u8621": "jing1",
    "\u8622": "lung4",
    "\u8623": "tau2",
    "\u8624": "faa1",
    "\u8625": "joek6",
    "\u8626": "ling4",
    "\u8627": "keoi4",
    "\u8628": "jiu4",
    "\u8629": "faan4",
    "\u862A": "mei4",
    "\u862B": "ham3",
    "\u862C": "kwai1",
    "\u862D": "laan4/laan1/laan2",
    "\u862E": "gai3",
    "\u862F": "dong6",
    "\u8630": "maan6",
    "\u8631": "leoi6",
    "\u8632": "leoi4",
    "\u8633": "fai1",
    "\u8634": "fung1",
    "\u8635": "zik1",
    "\u8636": "ngai6/ai6",
    "\u8637": "kwai4",
    "\u8638": "zaam3",
    "\u8639": "waai4",
    "\u863A": "lei4",
    "\u863B": "hai6",
    "\u863C": "mei4",
    "\u863D": "leoi5",
    "\u863E": "waai6",
    "\u863F": "lo4",
    "\u8640": "zai1",
    "\u8641": "kwai4",
    "\u8642": "lou6",
    "\u8643": "zim1",
    "\u8644": "saat3",
    "\u8645": "tang4",
    "\u8646": "leoi4",
    "\u8647": "hyun2",
    "\u8648": "hiu1",
    "\u8649": "jik6",
    "\u864A": "lyun4",
    "\u864B": "mun4",
    "\u864C": "bit3",
    "\u864D": "fu1/fu2.zi6.tau4",
    "\u864E": "fu2",
    "\u864F": "lou5",
    "\u8650": "joek6",
    "\u8651": "leoi6",
    "\u8652": "si1",
    "\u8653": "haau1",
    "\u8654": "kin4",
    "\u8655": "cyu5/cyu2/cyu3/syu2/syu3",
    "\u8656": "fu4/fu1",
    "\u8657": "heoi1",
    "\u8658": "co4",
    "\u8659": "fuk6",
    "\u865A": "heoi1",
    "\u865B": "heoi1",
    "\u865C": "lou5",
    "\u865D": "fu2",
    "\u865E": "jyu4",
    "\u865F": "hou6/hou2/hou4",
    "\u8660": "gaau2",
    "\u8661": "geoi6",
    "\u8662": "gwik1",
    "\u8663": "bou6",
    "\u8664": "ngaan4/aan4",
    "\u8665": "zaan6",
    "\u8666": "zaan6",
    "\u8667": "kwai1",
    "\u8668": "ban1",
    "\u8669": "gwik1",
    "\u866A": "suk1",
    "\u866B": "cung4/cung2/wai2",
    "\u866C": "kau4",
    "\u866D": "diu1",
    "\u866E": "gei1/gei2/kei4",
    "\u866F": "kau4",
    "\u8670": "ding1",
    "\u8671": "sat1",
    "\u8672": "buk1",
    "\u8673": "gwat1",
    "\u8674": "zaak3",
    "\u8675": "se4",
    "\u8676": "jyu1",
    "\u8677": "hon4/gon1",
    "\u8678": "zi2",
    "\u8679": "hung4",
    "\u867A": "wai2/fui1",
    "\u867B": "mong4",
    "\u867C": "gat1",
    "\u867D": "seoi1",
    "\u867E": "haa1/haa4",
    "\u867F": "caai3",
    "\u8680": "sik6/sit6",
    "\u8681": "ngai5/ai5",
    "\u8132": "niu6/liu6",
    "\u8133": "nou5/lou5",
    "\u8134": "pei2",
    "\u8135": "ng4/m4",
    "\u8136": "lo4",
    "\u8137": "lei6",
    "\u8138": "lim5",
    "\u8139": "zoeng3",
    "\u813A": "seoi6/seoi5",
    "\u813B": "zip3",
    "\u813C": "loeng5",
    "\u813D": "seoi4",
    "\u813E": "pei4/pei2",
    "\u813F": "biu2",
    "\u8140": "leon4",
    "\u8141": "pin4",
    "\u8142": "leoi5",
    "\u8143": "wai3",
    "\u8144": "ceoi4",
    "\u8145": "daam6",
    "\u8146": "tin2",
    "\u8147": "neoi5/leoi5",
    "\u8148": "cing1",
    "\u8149": "naai4/laai4",
    "\u814A": "laap6/lip6/sik1",
    "\u814B": "jik6",
    "\u814C": "jim1/jip3/ap1/ngap1",
    "\u814D": "nam5/lam5/nam4/lam4/jam6",
    "\u814E": "san5/san2/san6",
    "\u814F": "zyut3",
    "\u8150": "fu6",
    "\u8151": "fu2",
    "\u8152": "geoi1",
    "\u8153": "fei4",
    "\u8154": "hong1",
    "\u8155": "wun2",
    "\u8156": "dung3",
    "\u8157": "pei4",
    "\u8158": "gwok3/gok3",
    "\u8159": "zung1",
    "\u815A": "ding6",
    "\u815B": "ak1/ngak1",
    "\u815C": "mui4",
    "\u815D": "jyun5/ji4",
    "\u815E": "syun6",
    "\u815F": "cat1",
    "\u8160": "cau3/zau3",
    "\u8161": "lo4",
    "\u8162": "ngau5/au5",
    "\u8163": "dai3",
    "\u8164": "am1/ngam1/am3/ngam3",
    "\u8165": "sing1/seng1",
    "\u8166": "nou5/lou5",
    "\u8167": "syu3/syu6",
    "\u8168": "syun6",
    "\u8169": "naam5/laam5",
    "\u816A": "wan6",
    "\u816B": "zung2",
    "\u816C": "nau6/lau6",
    "\u816D": "ngok6/ok6",
    "\u816E": "soi1",
    "\u816F": "dat1/dyut1/dat6",
    "\u8170": "jiu1",
    "\u8171": "gin3",
    "\u8172": "wai2",
    "\u8173": "goek3/goek2",
    "\u8174": "jyu4",
    "\u8175": "gaa1",
    "\u8176": "dyun3",
    "\u8177": "bik1",
    "\u8178": "coeng4/coeng2",
    "\u8179": "fuk1",
    "\u817A": "sin3",
    "\u817B": "nei6/lei6/nau6/lau6",
    "\u817C": "min5",
    "\u817D": "wat1",
    "\u817E": "tang4",
    "\u817F": "teoi2",
    "\u8180": "bong2/pong4/pong1",
    "\u8181": "him2/hip3",
    "\u8182": "leoi5",
    "\u8183": "wat1",
    "\u8184": "sau3",
    "\u8185": "tong4",
    "\u8186": "sou3/seoi3",
    "\u8187": "zeoi6/deoi3",
    "\u8188": "gaak3",
    "\u8189": "jik1",
    "\u818A": "bok3",
    "\u818B": "liu4",
    "\u818C": "zek3/zik3",
    "\u818D": "pei4",
    "\u818E": "haai4",
    "\u818F": "gou1/gou3",
    "\u8190": "leoi5",
    "\u8191": "ban3",
    "\u8192": "au1/ngau1",
    "\u8193": "coeng4",
    "\u8194": "luk6",
    "\u8195": "gwok3/gok3",
    "\u8196": "pong1",
    "\u8197": "saai4/ceoi4",
    "\u8198": "biu1",
    "\u8199": "koeng5/zoeng2",
    "\u819A": "fu1",
    "\u819B": "tong4",
    "\u819C": "mok6/mok2/mou4",
    "\u819D": "sat1",
    "\u819E": "zyun1/seon4",
    "\u819F": "leot3/leot6",
    "\u81A0": "gaau1",
    "\u81A1": "jing6",
    "\u81A2": "leoi4/lau4",
    "\u81A3": "zat6",
    "\u81A4": "syut3",
    "\u81A5": "ceon1",
    "\u81A6": "leon6/leon4",
    "\u81A7": "tung4",
    "\u81A8": "paang4",
    "\u81A9": "nei6/lei6/nau6/lau6",
    "\u81AA": "zaai3/zaa6/ceoi2",
    "\u81AB": "liu4",
    "\u81AC": "ceoi3",
    "\u81AD": "gwai1",
    "\u81AE": "hiu1",
    "\u81AF": "tang1",
    "\u81B0": "faan4",
    "\u81B1": "zik1",
    "\u81B2": "ziu1",
    "\u81B3": "sin6",
    "\u81B4": "fu1/mou5",
    "\u81B5": "seoi6/seoi5",
    "\u81B6": "jeon2/jeon6",
    "\u81B7": "hoeng1",
    "\u81B8": "seoi5",
    "\u81B9": "fan5",
    "\u81BA": "jing1",
    "\u81BB": "zin1/saan1/taan2/daan6",
    "\u81BC": "zaa1",
    "\u81BD": "daam2",
    "\u81BE": "kui2/kwui2",
    "\u81BF": "nung4/lung4",
    "\u81C0": "tyun4",
    "\u81C1": "lim4",
    "\u81C2": "bei3",
    "\u81C3": "jung2",
    "\u81C4": "koek6",
    "\u81C5": "zuk1",
    "\u81C6": "jik1",
    "\u81C7": "zeon3",
    "\u81C8": "laap6",
    "\u81C9": "lim5",
    "\u81CA": "sou1/sou3",
    "\u81CB": "tyun4",
    "\u81CC": "gu2/gwu2",
    "\u81CD": "ci4",
    "\u81CE": "ceoi3",
    "\u81CF": "ban3",
    "\u81D0": "fan1",
    "\u81D1": "naau6/laau6/jyu4/ji4",
    "\u81D2": "wok3",
    "\u81D3": "zong6",
    "\u81D4": "jin6",
    "\u81D5": "biu1",
    "\u81D6": "hing3",
    "\u81D7": "fun1",
    "\u81D8": "laap6/lip6",
    "\u81D9": "jin1",
    "\u81DA": "lou4",
    "\u81DB": "fok3/kok3",
    "\u81DC": "zim1/zap1",
    "\u81DD": "lo2",
    "\u81DE": "keoi4",
    "\u81DF": "zong6",
    "\u81E0": "lyun5/lyun2/lyun4",
    "\u81E1": "nai4/lai4",
    "\u81E2": "zim1/zap1",
    "\u81E3": "san4/san2",
    "\u81E4": "haan1",
    "\u81E5": "ngo6/o6",
    "\u81E6": "gwong3/gong3",
    "\u81E7": "zong1/cong4/zong6",
    "\u81E8": "lam4/lam1",
    "\u81E9": "gwong3/gong3",
    "\u81EA": "zi6/zi2",
    "\u81EB": "giu2",
    "\u81EC": "jit6/nip6/lip6",
    "\u81ED": "cau3",
    "\u81EE": "kei3",
    "\u81EF": "gou1",
    "\u81F0": "cau3",
    "\u81F1": "min4",
    "\u81F2": "jit6/nip6/lip6",
    "\u81F3": "zi3",
    "\u81F4": "zi3",
    "\u81F5": "gaak3",
    "\u81F6": "zin6",
    "\u81F7": "dit6",
    "\u81F8": "zi1",
    "\u81F9": "sau1",
    "\u81FA": "toi4/toi2",
    "\u81FB": "zeon1",
    "\u81FC": "kau5/kau3",
    "\u81FD": "haam6",
    "\u81FE": "jyu4",
    "\u81FF": "caap3",
    "\u8200": "jiu5/jiu2",
    "\u8201": "jyu4",
    "\u8202": "zung1",
    "\u8203": "sik1",
    "\u8204": "sik1",
    "\u8205": "kau5/kau2/kau3",
    "\u8206": "jyu4",
    "\u8207": "jyu5/jyu4/jyu6",
    "\u8208": "hing1/hing3",
    "\u8209": "geoi2",
    "\u820A": "gau6",
    "\u820B": "jan6/man6",
    "\u820C": "sit3/sit6",
    "\u820D": "se3/se2/se5",
    "\u820E": "se3",
    "\u820F": "gau2",
    "\u8210": "saai5/saai2/laai2/lem2/lim2",
    "\u8211": "daam1",
    "\u8212": "syu1",
    "\u8213": "saai5",
    "\u8214": "tim2",
    "\u8215": "taam3",
    "\u8216": "pou3/pou2/pou1",
    "\u8217": "pou3",
    "\u8218": "gun2/gwun2",
    "\u8219": "jyu5",
    "\u821A": "daam1",
    "\u821B": "cyun2",
    "\u821C": "seon3",
    "\u821D": "hat6",
    "\u821E": "mou5",
    "\u821F": "zau1",
    "\u8220": "dou1",
    "\u8221": "hong1/syun4",
    "\u8222": "saan1",
    "\u8223": "ngai5/ai5",
    "\u8224": "faan4",
    "\u8225": "paa1",
    "\u8226": "taai5",
    "\u8227": "faan4",
    "\u8228": "baan2",
    "\u8229": "syun4",
    "\u822A": "hong4",
    "\u822B": "fong2",
    "\u822C": "bun1/bo1/baan1/pun4",
    "\u822D": "bei2",
    "\u822E": "lou4",
    "\u822F": "zung1",
    "\u8230": "laam6/cam1",
    "\u8231": "cong1",
    "\u8232": "ling4",
    "\u8233": "zuk6",
    "\u8234": "zaak3",
    "\u8235": "to4",
    "\u8236": "bok6/paak3/baak3/paak6",
    "\u8237": "jin4",
    "\u8238": "go2/ho2",
    "\u8239": "syun4/syun2",
    "\u823A": "gaap3",
    "\u823B": "lou4",
    "\u823C": "kung4",
    "\u823D": "pong4",
    "\u823E": "sai1",
    "\u823F": "kwaa1",
    "\u8240": "fau4",
    "\u8241": "zou6",
    "\u8242": "fung4",
    "\u8243": "lei4",
    "\u8244": "saau1",
    "\u8245": "jyu4",
    "\u8246": "long4",
    "\u8247": "ting5/teng5",
    "\u8248": "juk1",
    "\u8249": "mei5",
    "\u824A": "bok6",
    "\u824B": "maang5",
    "\u824C": "nim6/lim6",
    "\u824D": "geoi1",
    "\u824E": "wong4",
    "\u824F": "sau2",
    "\u8250": "ho3",
    "\u8251": "bin6",
    "\u8252": "muk6",
    "\u8253": "dip6",
    "\u8254": "dou6/dou2",
    "\u8255": "bong3/pong3",
    "\u8256": "caa1",
    "\u8257": "jik6",
    "\u8258": "sau1/sau2",
    "\u8259": "cong1",
    "\u825A": "cou4",
    "\u825B": "lau4",
    "\u825C": "daai3",
    "\u825D": "syut3",
    "\u825E": "jiu6",
    "\u825F": "cung1/tung4",
    "\u8260": "dang1",
    "\u8261": "dong1",
    "\u8262": "coeng4",
    "\u8263": "lou5",
    "\u8264": "ngai5/ai5",
    "\u8265": "zip3",
    "\u8266": "laam6",
    "\u8267": "wok6",
    "\u8268": "mung4",
    "\u8269": "cai4",
    "\u826A": "lou5",
    "\u826B": "lou4",
    "\u826C": "caam4",
    "\u826D": "soeng1",
    "\u826E": "gan3",
    "\u826F": "loeng4",
    "\u8270": "gaan1",
    "\u8271": "gaan1",
    "\u8272": "sik1",
    "\u8273": "jim6",
    "\u8274": "fat1/but6",
    "\u8275": "ping1",
    "\u8276": "jim6",
    "\u8277": "jim6",
    "\u8278": "cou2",
    "\u8279": "cou2.faa1.tau2",
    "\u827A": "ngai6/ai6",
    "\u827B": "lak6/gik1",
    "\u827C": "ding2",
    "\u827D": "kau4/gaau1",
    "\u827E": "ngaai6/aai6",
    "\u827F": "jing4/naai5/laai5",
    "\u8280": "tiu4/siu4",
    "\u8281": "kau4",
    "\u8282": "zit3",
    "\u8283": "pung4",
    "\u8284": "jyun4",
    "\u8285": "jik6",
    "\u8286": "ngaai6/aai6",
    "\u8287": "min4",
    "\u8288": "me1/me5/mei5/me2",
    "\u8289": "gon1",
    "\u828A": "cin1",
    "\u828B": "wu6/wu2/jyu1",
    "\u828C": "wu6",
    "\u828D": "coek3/zoek3",
    "\u828E": "gung1/hung1/kung4",
    "\u828F": "dou6",
    "\u8290": "wu6/haa6",
    "\u8291": "hei2",
    "\u8292": "mong4/mong1/fong2",
    "\u8293": "zi6/zi2",
    "\u8294": "wai2",
    "\u8295": "zik6",
    "\u8296": "zi6",
    "\u8297": "hoeng1/hoeng2",
    "\u8298": "pei4/bei3",
    "\u8299": "fu4",
    "\u829A": "tyun4/ceon1/teon1",
    "\u829B": "wai5",
    "\u829C": "mou4",
    "\u829D": "zi1/zi4",
    "\u829E": "hat1",
    "\u829F": "saam1/saan1",
    "\u82A0": "man4",
    "\u82A1": "him3/hin3",
    "\u82A2": "jan4",
    "\u82A3": "fau4",
    "\u82A4": "kau1/hau1",
    "\u82A5": "gaai3",
    "\u82A6": "lou4/lou2",
    "\u82A7": "zeoi6/cyu5",
    "\u82A8": "kap6/gap1",
    "\u82A9": "kam4/sam4",
    "\u82AA": "kei4",
    "\u82AB": "jyun4/jim4",
    "\u82AC": "fan1",
    "\u82AD": "baa1",
    "\u82AE": "jeoi6",
    "\u82AF": "sam1/seon3",
    "\u82B0": "gei6",
    "\u82B1": "faa1",
    "\u82B2": "faa1",
    "\u82B3": "fong1",
    "\u82B4": "mat6/fat1",
    "\u82B5": "kyut3",
    "\u82B6": "gau2",
    "\u82B7": "zi2",
    "\u82B8": "wan4",
    "\u82B9": "kan4/kan2",
    "\u82BA": "ou3/ngou3",
    "\u82BB": "co1",
    "\u82BC": "mou6/mou4",
    "\u82BD": "ngaa4/aa4/ngaa2/aa2",
    "\u82BE": "fai3/fat1",
    "\u82BF": "jing4",
    "\u82C0": "gong1",
    "\u82C1": "cung1",
    "\u82C2": "cim4",
    "\u82C3": "jau5",
    "\u82C4": "bin6",
    "\u82C5": "ngaai6/aai6",
    "\u82C6": "cit3",
    "\u82C7": "wai5",
    "\u82C8": "lik6",
    "\u82C9": "pat1",
    "\u82CA": "ak1/ngak1",
    "\u82CB": "jin6",
    "\u82CC": "coeng4",
    "\u82CD": "cong1/cong2",
    "\u82CE": "cyu5",
    "\u82CF": "sou1",
    "\u82D0": "dai6/tai4/ji4",
    "\u82D1": "jyun2",
    "\u82D2": "jim5",
    "\u82D3": "ling4",
    "\u82D4": "toi4/toi1",
    "\u82D5": "tiu4/siu4",
    "\u82D6": "miu4",
    "\u82D7": "miu4",
    "\u82D8": "king2/gwing2",
    "\u82D9": "lap1",
    "\u82DA": "jung6",
    "\u82DB": "ho1",
    "\u82DC": "muk6",
    "\u82DD": "bui6",
    "\u82DE": "baau1",
    "\u82DF": "gau2",
    "\u82E0": "man4",
    "\u82E1": "ji5",
    "\u82E2": "ji5",
    "\u82E3": "geoi6",
    "\u82E4": "pei2",
    "\u82E5": "joek6/je5",
    "\u82E6": "fu2/gu2/gwu2",
    "\u82E7": "ning4/ling4/cyu5",
    "\u82E8": "nei5/lei5",
    "\u82E9": "baak6",
    "\u82EA": "bing2",
    "\u82EB": "sim1/sim3",
    "\u82EC": "cau4",
    "\u82ED": "jiu2",
    "\u82EE": "sin1",
    "\u82EF": "bun2",
    "\u82F0": "wang4",
    "\u82F1": "jing1",
    "\u82F2": "zaa3",
    "\u82F3": "dung2",
    "\u82F4": "zeoi1/caa4/zaa2",
    "\u82F5": "dit6",
    "\u82F6": "nip6/lip6",
    "\u82F7": "gam1",
    "\u82F8": "fu1",
    "\u82F9": "ping4",
    "\u82FA": "mui4",
    "\u82FB": "fu4/pou4",
    "\u82FC": "sang1",
    "\u82FD": "gu1/gwu1",
    "\u82FE": "bat6/bit6",
    "\u82FF": "mei6",
    "\u8300": "fat1/bat6/but6",
    "\u8301": "zyut3/cyut3",
    "\u8302": "mau6",
    "\u8303": "faan6",
    "\u8304": "ke2/ke4/gaa1/ke1",
    "\u8305": "maau4",
    "\u8306": "maau5/maau4",
    "\u8307": "bat6/baat6/pui3",
    "\u8308": "zi2/ci4/caai4",
    "\u8309": "mut6",
    "\u830A": "zi1",
    "\u830B": "zi2",
    "\u830C": "ci4",
    "\u830D": "gik1",
    "\u830E": "hang1/ging3",
    "\u830F": "lung4",
    "\u8310": "cung1",
    "\u8311": "niu5/liu5",
    "\u8312": "jyun2",
    "\u8313": "jyut6",
    "\u8314": "jing4",
    "\u8315": "king4",
    "\u8316": "gaak3",
    "\u8317": "ming4/ming5",
    "\u8318": "lai6",
    "\u8319": "jung4",
    "\u831A": "jan3",
    "\u831B": "gan3",
    "\u831C": "sin6/sai1",
    "\u831D": "coi2/zi2",
    "\u831E": "coi2/zi2",
    "\u831F": "jyut6",
    "\u8320": "hou1/jau1",
    "\u8321": "zi6",
    "\u8322": "lit6",
    "\u8323": "ng4/m4",
    "\u8324": "gei6",
    "\u8325": "gwai1",
    "\u8326": "caak3/ci3",
    "\u8327": "gaan2",
    "\u8328": "ci4",
    "\u8329": "hau6",
    "\u832A": "gwong1/gong1",
    "\u832B": "mong4",
    "\u832C": "caa4/ci4",
    "\u832D": "gaau1",
    "\u832E": "ziu1",
    "\u832F": "fuk6",
    "\u8330": "jyu4",
    "\u8331": "zyu1",
    "\u8332": "zi1/ci4",
    "\u8333": "gong1",
    "\u8334": "wui4",
    "\u8335": "jan1",
    "\u8336": "caa4/caa2",
    "\u8337": "fat6/pui3",
    "\u8338": "jung4/jung2/jung5",
    "\u8339": "jyu4",
    "\u833A": "cung1",
    "\u833B": "mong5",
    "\u833C": "tung4",
    "\u833D": "zung6",
    "\u833E": "hin1",
    "\u833F": "zuk1",
    "\u8340": "seon1",
    "\u8341": "jyun4/wun4",
    "\u8342": "fu1",
    "\u8343": "cyun4",
    "\u8344": "goi1",
    "\u8345": "taap3/daap3",
    "\u8346": "ging1",
    "\u8347": "hang6",
    "\u8348": "cyun2",
    "\u8349": "cou2",
    "\u834A": "ging1",
    "\u834B": "ji4",
    "\u834C": "on3/ngon3",
    "\u834D": "kiu4",
    "\u834E": "ci4",
    "\u834F": "jam5/jam6",
    "\u8350": "zin3",
    "\u8351": "tai4/ji4",
    "\u8352": "fong1",
    "\u8353": "ping4",
    "\u8354": "lai6",
    "\u8355": "gan1",
    "\u8356": "lou5",
    "\u8357": "seot6",
    "\u8358": "zong1",
    "\u8359": "daat6",
    "\u835A": "gaap3",
    "\u835B": "jiu4",
    "\u835C": "bat1",
    "\u835D": "zak1",
    "\u835E": "kiu4",
    "\u835F": "wai3/wui6/kui2/kwui2",
    "\u8360": "cai5/cai4/zai3/ci4",
    "\u8361": "dong6",
    "\u8362": "zi6",
    "\u8363": "wing4",
    "\u8364": "fan1",
    "\u8365": "jing4",
    "\u8366": "lok3/lok6",
    "\u8367": "jing4",
    "\u8368": "taam4/cam4/cim4",
    "\u8369": "zeon2",
    "\u836A": "syun1",
    "\u836B": "jam1/jam3",
    "\u836C": "maai5",
    "\u836D": "hung4",
    "\u836E": "zau6",
    "\u836F": "joek6/joek2/joek3",
    "\u8370": "dou6",
    "\u8371": "mei5",
    "\u8372": "huk1",
    "\u8373": "dau6/dau2",
    "\u8374": "fu1",
    "\u8375": "jan2",
    "\u8376": "jam4",
    "\u8377": "ho4/ho2/ho6",
    "\u8378": "but6",
    "\u8379": "bou6",
    "\u837A": "wan5",
    "\u837B": "dik6",
    "\u837C": "tou4/caa4/syu1",
    "\u837D": "seoi1",
    "\u837E": "seoi1",
    "\u837F": "sing4",
    "\u8380": "san4",
    "\u8381": "mou4",
    "\u8382": "bit6",
    "\u8383": "hei1",
    "\u8384": "gang2",
    "\u8385": "lei6",
    "\u8386": "pou4/fu2",
    "\u8387": "zyu6",
    "\u8388": "mut6",
    "\u8389": "lei6/lei2",
    "\u838A": "zong1",
    "\u838B": "zok6",
    "\u838C": "tyut3",
    "\u838D": "kau4",
    "\u838E": "so1/saa1",
    "\u838F": "co1",
    "\u8390": "cam4",
    "\u8391": "pung4",
    "\u8392": "geoi2",
    "\u8393": "mui4",
    "\u8394": "maang4",
    "\u8395": "hang6",
    "\u8396": "hang1/ging3",
    "\u8397": "ce1",
    "\u8398": "san1",
    "\u8399": "gwan1",
    "\u839A": "jin4",
    "\u839B": "ting4",
    "\u839C": "diu6/jau4",
    "\u839D": "co3",
    "\u839E": "gun1/gwun1/gwaan1/gun2/gwun2/wun2/wun5",
    "\u839F": "ham6",
    "\u83A0": "jau5",
    "\u83A1": "cok3",
    "\u83A2": "gaap3",
    "\u83A3": "mong4",
    "\u83A4": "suk1",
    "\u83A5": "nau5/lau5",
    "\u83A6": "saau1",
    "\u83A7": "jin6",
    "\u83A8": "loeng4/long6/long4",
    "\u83A9": "fu1/piu5",
    "\u83AA": "ngo4/o4",
    "\u83AB": "mok6/mok2/mou6",
    "\u83AC": "man6",
    "\u83AD": "zit3",
    "\u83AE": "naam4/laam4",
    "\u83AF": "ping4",
    "\u83B0": "ham2",
    "\u83B1": "loi4",
    "\u83B2": "lin4/lin2",
    "\u83B3": "si4/si2/si6",
    "\u83B4": "wo1",
    "\u83B5": "tou3",
    "\u83B6": "cim1/lim5/lim6",
    "\u83B7": "wok6",
    "\u83B8": "jau4",
    "\u83B9": "jing4/jing2",
    "\u83BA": "ang1/ngang1",
    "\u83BB": "jing4",
    "\u83BC": "seon4",
    "\u83BD": "mong5",
    "\u83BE": "mong5",
    "\u83BF": "ci3/caak3",
    "\u7EB2": "mong5/gong1",
    "\u7EB3": "naap6/laap6",
    "\u7EB4": "jam6/jam4",
    "\u7EB5": "zung3/zung1",
    "\u7EB6": "leon4/gwaan1",
    "\u7EB7": "fan1",
    "\u7EB8": "zi2",
    "\u7EB9": "man4/man2/man6",
    "\u7EBA": "fong2",
    "\u7EBB": "cyu5",
    "\u7EBC": "zan6/zan3",
    "\u7EBD": "nau2/lau2",
    "\u7EBE": "syu1",
    "\u7EBF": "sin3/sin2",
    "\u7EC0": "gam3",
    "\u7EC1": "sit3/jai6",
    "\u7EC2": "fat1",
    "\u7EC3": "lin6",
    "\u7EC4": "zou2",
    "\u7EC5": "san1",
    "\u7EC6": "sai3/sai2",
    "\u7EC7": "zik1/zi3/ci3",
    "\u7EC8": "zung1",
    "\u7EC9": "zau3",
    "\u7ECA": "bun6",
    "\u7ECB": "fat1",
    "\u7ECC": "zyut3/zyut6/zeot1",
    "\u7ECD": "siu6",
    "\u7ECE": "jik6",
    "\u7ECF": "ging1",
    "\u7ED0": "doi6/toi5",
    "\u7ED1": "bong2",
    "\u7ED2": "jung2/jung4",
    "\u7ED3": "git3/lit3/gai3",
    "\u7ED4": "fu3",
    "\u7ED5": "jiu2/jiu5",
    "\u7ED6": "dit6",
    "\u7ED7": "hong4",
    "\u7ED8": "kui2/kwui2/kui3/kwui3",
    "\u7ED9": "kap1",
    "\u7EDA": "hyun3/seon1",
    "\u7EDB": "gong3",
    "\u7EDC": "lok3/lok2/lok6",
    "\u7EDD": "zyut6/zyut2",
    "\u7EDE": "gaau2",
    "\u7EDF": "tung2",
    "\u7EE0": "gang2",
    "\u7EE1": "siu1",
    "\u7EE2": "gyun3",
    "\u7EE3": "sau3",
    "\u7EE4": "gwik1",
    "\u7EE5": "seoi1",
    "\u7EE6": "tou1",
    "\u7EE7": "gai3",
    "\u7EE8": "tai4/tai3",
    "\u7EE9": "zik1",
    "\u7EEA": "seoi5",
    "\u7EEB": "ling4",
    "\u7EEC": "jing1",
    "\u7EED": "zuk6",
    "\u7EEE": "ji2",
    "\u7EEF": "fei1",
    "\u7EF0": "coek3/caau1",
    "\u7EF1": "soeng5",
    "\u7EF2": "gwan2",
    "\u7EF3": "sing4/sing2",
    "\u7EF4": "wai4",
    "\u7EF5": "min4",
    "\u7EF6": "sau6",
    "\u7EF7": "bang1/mang2/maang1",
    "\u7EF8": "cau4/cau2",
    "\u7EF9": "tou4",
    "\u7EFA": "lau5",
    "\u7EFB": "hyun3",
    "\u7EFC": "zung1/zung3",
    "\u7EFD": "zaan6",
    "\u7EFE": "waan2",
    "\u7EFF": "luk6/luk2",
    "\u7F00": "zeoi3/zeoi6/zyut3/zyut6",
    "\u7F01": "zi1",
    "\u7F02": "kaak1/kaak3",
    "\u7F03": "soeng1",
    "\u7F04": "gaam1/zin1",
    "\u7F05": "min5",
    "\u7F06": "laam6",
    "\u7F07": "tai4",
    "\u7F08": "miu5",
    "\u7F09": "cap1",
    "\u7F0A": "wan3/wan1",
    "\u7F0B": "kui2/kwui2",
    "\u7F0C": "si1",
    "\u7F0D": "do2",
    "\u7F0E": "dyun6/dyun2",
    "\u7F0F": "pin4/bin1",
    "\u7F10": "sin3",
    "\u7F11": "gau1",
    "\u7F12": "zeoi6",
    "\u7F13": "wun6/wun4",
    "\u7F14": "dai3/tai3",
    "\u7F15": "leoi5/lau5/lau2",
    "\u7F16": "pin1",
    "\u7F17": "man4",
    "\u7F18": "jyun4/jyun6",
    "\u7F19": "zeon3",
    "\u7F1A": "bok3/fok3",
    "\u7F1B": "juk6",
    "\u7F1C": "zan2/can2",
    "\u7F1D": "fung4/fung2/fung6",
    "\u7F1E": "ceoi1",
    "\u7F1F": "gou2",
    "\u7F20": "cin4/zin6",
    "\u7F21": "lei4",
    "\u7F22": "ai3/ngai3",
    "\u7F23": "gim1",
    "\u7F24": "ban1",
    "\u7F25": "piu5/piu1",
    "\u7F26": "maan6",
    "\u7F27": "leoi4",
    "\u7F28": "jing1",
    "\u7F29": "suk1",
    "\u7F2A": "mau4/mau6/maau6/miu6/muk6",
    "\u7F2B": "sou1",
    "\u7F2C": "kit3/hit3/lit3",
    "\u7F2D": "liu4/liu1",
    "\u7F2E": "sin6",
    "\u7F2F": "zang1/zang6",
    "\u7F30": "goeng1",
    "\u7F31": "hin2",
    "\u7F32": "zou2/sou1/ciu1",
    "\u7F33": "waan4/waan6",
    "\u7F34": "giu2/zoek3",
    "\u7F35": "zyun2",
    "\u7F36": "fau2",
    "\u7F37": "se3",
    "\u7F38": "gong1",
    "\u7F39": "fau2",
    "\u7F3A": "kyut3",
    "\u7F3B": "fau2",
    "\u7F3C": "kik1",
    "\u7F3D": "but6/but3",
    "\u7F3E": "ping4",
    "\u7F3F": "hong6/hau6",
    "\u7F40": "siu6",
    "\u7F41": "gong1",
    "\u7F42": "aang1/ngaang1",
    "\u7F43": "aang1/ngaang1/ang1/ngang1",
    "\u7F44": "hing3",
    "\u7F45": "laa3",
    "\u7F46": "gun3/gwun3",
    "\u7F47": "zeon1",
    "\u7F48": "taam4",
    "\u7F49": "caang1",
    "\u7F4A": "kai3",
    "\u7F4B": "ung3/ngung3",
    "\u7F4C": "aang1/ngaang1",
    "\u7F4D": "leoi4",
    "\u7F4E": "taam4",
    "\u7F4F": "lou4",
    "\u7F50": "gun3/gwun3",
    "\u7F51": "mong5/mong1",
    "\u7F52": "muk6/sei3.mong5.tau4",
    "\u7F53": "gaau1.caa1.sei3",
    "\u7F54": "mong5",
    "\u7F55": "hon2",
    "\u7F56": "mong5",
    "\u7F57": "lo4/lo2/lo1",
    "\u7F58": "fau4",
    "\u7F59": "sam1",
    "\u7F5A": "fat6",
    "\u7F5B": "gu1/gwu1",
    "\u7F5C": "zyu2/zyu3",
    "\u7F5D": "ze1/zeoi1",
    "\u7F5E": "mung4",
    "\u7F5F": "gu2/gwu2/gu1/gwu1",
    "\u7F60": "man4",
    "\u7F61": "gong1",
    "\u7F62": "baa6/baa2/pei4",
    "\u7F63": "gwaa3/kwaa3",
    "\u7F64": "tai4",
    "\u7F65": "gyun3",
    "\u7F66": "fau4/fu1",
    "\u7F67": "sam1",
    "\u7F68": "jim2/ngap1/ap1",
    "\u7F69": "zaau3",
    "\u7F6A": "zeoi6",
    "\u7F6B": "waa6/gwaai2",
    "\u7F6C": "dyut3",
    "\u7F6D": "wik6",
    "\u7F6E": "zi3",
    "\u7F6F": "am2/ngam2",
    "\u7F70": "fat6",
    "\u7F71": "laam5/naam5",
    "\u7F72": "cyu5/syu5",
    "\u7F73": "si1",
    "\u7F74": "bei1",
    "\u7F75": "maa6/maa3",
    "\u7F76": "lau5",
    "\u7F77": "baa6/baa2/pei4",
    "\u7F78": "fat6",
    "\u7F79": "lei4",
    "\u7F7A": "caau3",
    "\u7F7B": "wai3/wat1",
    "\u7F7C": "bat1",
    "\u7F7D": "gai3",
    "\u7F7E": "zang1",
    "\u7F7F": "cung1/tung4",
    "\u7F80": "lau5",
    "\u7F81": "gei1",
    "\u7F82": "gyun3",
    "\u7F83": "mik6",
    "\u7F84": "zaau3",
    "\u7F85": "lo4/lo2/lo1",
    "\u7F86": "bei1",
    "\u7F87": "gei1",
    "\u7F88": "gei1",
    "\u7F89": "lyun4",
    "\u7F8A": "joeng4/joeng2/coeng4",
    "\u7F8B": "me1/mai5",
    "\u7F8C": "goeng1",
    "\u7F8D": "taat3",
    "\u7F8E": "mei5",
    "\u7F8F": "joeng4",
    "\u7F90": "jau5",
    "\u7F91": "jau5",
    "\u7F92": "fan4",
    "\u7F93": "baa1",
    "\u7F94": "gou1",
    "\u7F95": "joeng6",
    "\u7F96": "gu2/gwu2",
    "\u7F97": "goeng1",
    "\u7F98": "zong1",
    "\u7F99": "gou1",
    "\u7F9A": "ling4",
    "\u7F9B": "ji6/hei3",
    "\u7F9C": "cyu5",
    "\u7F9D": "dai1",
    "\u7F9E": "sau1",
    "\u7F9F": "koeng5/coeng1",
    "\u7FA0": "ji4",
    "\u7FA1": "sin6/jin4",
    "\u7FA2": "jung2/jung4",
    "\u7FA3": "kwan4",
    "\u7FA4": "kwan4",
    "\u7FA5": "koeng5/coeng1",
    "\u7FA6": "wun4",
    "\u7FA7": "so1",
    "\u7FA8": "sin6/jin4",
    "\u7FA9": "ji6",
    "\u7FAA": "loeng4",
    "\u7FAB": "hong1",
    "\u7FAC": "kim4",
    "\u7FAD": "jyu4",
    "\u7FAE": "gang1",
    "\u7FAF": "kit3",
    "\u7FB0": "tong1",
    "\u7FB1": "jyun4",
    "\u7FB2": "hei1",
    "\u7FB3": "faan4",
    "\u7FB4": "zin1/saan1",
    "\u7FB5": "fan4",
    "\u7FB6": "zin1/saan1",
    "\u7FB7": "lim5",
    "\u7FB8": "leoi4",
    "\u7FB9": "gang1",
    "\u7FBA": "nau4/lau4",
    "\u7FBB": "hoeng3",
    "\u7FBC": "caan3",
    "\u7FBD": "jyu5",
    "\u7FBE": "hung4",
    "\u7FBF": "ngai6/ai6",
    "\u7FC0": "cung1",
    "\u7FC1": "jung1",
    "\u7FC2": "fan1",
    "\u7FC3": "wang4",
    "\u7FC4": "ci3",
    "\u7FC5": "ci3",
    "\u7FC6": "ceoi3",
    "\u7FC7": "fat1",
    "\u7FC8": "haap6",
    "\u7FC9": "pun2",
    "\u7FCA": "jik6",
    "\u7FCB": "laap6",
    "\u7FCC": "jik6",
    "\u7FCD": "pei1",
    "\u7FCE": "ling4",
    "\u7FCF": "lau6/liu4/liu6",
    "\u7FD0": "dit6",
    "\u7FD1": "keoi4",
    "\u7FD2": "zaap6",
    "\u7FD3": "kit3",
    "\u7FD4": "coeng4",
    "\u7FD5": "jap1/jap6",
    "\u7FD6": "jap1",
    "\u7FD7": "ke4",
    "\u7FD8": "kiu4/kiu3",
    "\u7FD9": "wai3",
    "\u7FDA": "fai1",
    "\u7FDB": "siu1",
    "\u7FDC": "saap3",
    "\u7FDD": "wang4",
    "\u7FDE": "goeng1",
    "\u7FDF": "dik6/zaak6",
    "\u7FE0": "ceoi3",
    "\u7FE1": "fei2",
    "\u7FE2": "duk6",
    "\u7FE3": "saap3",
    "\u7FE4": "ci3",
    "\u7FE5": "zyu3",
    "\u7FE6": "zin2",
    "\u7FE7": "hyun1",
    "\u7FE8": "ci3",
    "\u7FE9": "pin1",
    "\u7FEA": "zung1",
    "\u7FEB": "wun6/waan2/waan4",
    "\u7FEC": "fai1",
    "\u7FED": "hau4",
    "\u7FEE": "hat6",
    "\u7FEF": "hok6",
    "\u7FF0": "hon6",
    "\u7FF1": "ngou4/ou4",
    "\u7FF2": "piu1",
    "\u7FF3": "ai3/ngai3",
    "\u7FF4": "lin4",
    "\u7FF5": "hau4",
    "\u7FF6": "ngou4/ou4",
    "\u7FF7": "leon4",
    "\u7FF8": "pun2",
    "\u7FF9": "kiu4/kiu3",
    "\u7FFA": "ngou4/ou4",
    "\u7FFB": "faan1",
    "\u7FFC": "jik6/jik2",
    "\u7FFD": "wai3",
    "\u7FFE": "hyun1",
    "\u7FFF": "dou6/tou4",
    "\u8000": "jiu6",
    "\u8001": "lou5",
    "\u8002": "lou5/lou5.zi6.tau4",
    "\u8003": "haau2",
    "\u8004": "mou6",
    "\u8005": "ze2",
    "\u8006": "kei4/zi2/si6",
    "\u8007": "gau2",
    "\u8008": "gau2",
    "\u8009": "gau2",
    "\u800A": "dit6",
    "\u800B": "dit6",
    "\u800C": "ji4/ji2/nang4/lang4",
    "\u800D": "saa2",
    "\u800E": "jyun5",
    "\u800F": "ji4/noi6/loi6",
    "\u8010": "noi6/loi6/noi1/loi1/noi2/loi2",
    "\u8011": "dyun1/zyun1",
    "\u8012": "loi6/leoi6",
    "\u8013": "ting1",
    "\u8014": "zi2",
    "\u8015": "gaang1/gang1",
    "\u8016": "caau3",
    "\u8017": "hou3",
    "\u8018": "wan4",
    "\u8019": "paa4",
    "\u801A": "pei1",
    "\u801B": "toi2",
    "\u801C": "zi6",
    "\u801D": "ceoi3",
    "\u801E": "gaa1",
    "\u801F": "geoi6",
    "\u8020": "hap6",
    "\u8021": "co4",
    "\u8022": "lou6/lou4",
    "\u8023": "leon5",
    "\u8024": "zik6/ze3/ze6",
    "\u8025": "tong2",
    "\u8026": "ngau5/au5",
    "\u8027": "lau4",
    "\u8028": "nau6/lau6",
    "\u8029": "gong2",
    "\u802A": "pong5/pong1",
    "\u802B": "zaa6",
    "\u802C": "lau4",
    "\u802D": "gei1",
    "\u802E": "lou6/lou4",
    "\u802F": "wok6",
    "\u8030": "jau1",
    "\u8031": "mo6",
    "\u8032": "waai4",
    "\u8033": "ji5",
    "\u8034": "ngat6/at6",
    "\u8035": "ding1",
    "\u8036": "je4",
    "\u8037": "daap3/dap1",
    "\u8038": "sung2",
    "\u8039": "kam4",
    "\u803A": "wan4",
    "\u803B": "ci2",
    "\u803C": "daam1",
    "\u803D": "daam1",
    "\u803E": "wang4",
    "\u803F": "gang2",
    "\u8040": "zik1",
    "\u8041": "paan3",
    "\u8042": "nip6/lip6",
    "\u8043": "daam1",
    "\u8044": "can2",
    "\u8045": "cit3",
    "\u8046": "ling4",
    "\u8047": "zing1",
    "\u8048": "jau4",
    "\u8049": "waat6",
    "\u804A": "liu4",
    "\u804B": "lung4/lung2",
    "\u804C": "zik1",
    "\u804D": "ning4/ling4",
    "\u804E": "tiu1",
    "\u804F": "ji4",
    "\u8050": "ngaat6/aat6",
    "\u8051": "dip3",
    "\u8052": "kut3/kwut3",
    "\u8053": "sai3",
    "\u8054": "lyun4/lyun2",
    "\u8055": "hou6",
    "\u8056": "sing3",
    "\u8057": "lip6",
    "\u8058": "ping3",
    "\u8059": "zing1",
    "\u805A": "zeoi6",
    "\u805B": "bei2",
    "\u805C": "dai2",
    "\u805D": "gwok3/gok3/gwik1",
    "\u805E": "man4/man2/man6",
    "\u805F": "sai3",
    "\u8060": "ping1",
    "\u8061": "cung1",
    "\u8062": "ding6",
    "\u8063": "ngai6/ai6",
    "\u8064": "ting4",
    "\u8065": "geoi2",
    "\u8066": "cung1",
    "\u8067": "kwai1",
    "\u8068": "lyun4",
    "\u8069": "kui2/kwui2/kui3/kwui3",
    "\u806A": "cung1",
    "\u806B": "lyun4",
    "\u806C": "jung2",
    "\u806D": "gwai3",
    "\u806E": "lyun4",
    "\u806F": "lyun4/lyun2",
    "\u8070": "cung1",
    "\u8071": "ngou4/ou4",
    "\u8072": "sing1/seng1",
    "\u8073": "sung2",
    "\u8074": "ting1",
    "\u8075": "kui2/kwui2/kui3/kwui3",
    "\u8076": "nip6/lip6",
    "\u8077": "zik1",
    "\u8078": "daam1",
    "\u8079": "ning4/ling4",
    "\u807A": "cit3",
    "\u807B": "zim6",
    "\u807C": "ting1/teng1/ting3",
    "\u807D": "ting1/teng1/ting3",
    "\u807E": "lung4/lung2",
    "\u807F": "wat6/leot6/jyut6",
    "\u8080": "syu1.zi6.tau4",
    "\u8081": "ziu6",
    "\u8082": "si3",
    "\u8083": "suk1",
    "\u8084": "ji6/si3",
    "\u8085": "suk1",
    "\u8086": "si3/sei3",
    "\u8087": "siu6",
    "\u8088": "siu6",
    "\u8089": "juk6/juk2",
    "\u808A": "jik1",
    "\u808B": "lak6/laak6/laak1",
    "\u808C": "gei1",
    "\u808D": "gau6",
    "\u808E": "hang2",
    "\u808F": "caau3",
    "\u8090": "gok3/gaak3/gat1",
    "\u8091": "bok3",
    "\u8092": "wun6",
    "\u8093": "fong1",
    "\u8094": "ci2",
    "\u8095": "jan6",
    "\u8096": "ciu3/siu1",
    "\u8097": "jyu5",
    "\u8098": "zaau2/zau2",
    "\u8099": "jyun1",
    "\u809A": "tou5/tou2",
    "\u809B": "gong1",
    "\u809C": "jung4",
    "\u809D": "gon1",
    "\u809E": "caa1",
    "\u809F": "ok3/ngok3/wu1",
    "\u80A0": "coeng4/coeng2",
    "\u80A1": "gu2/gwu2",
    "\u80A2": "zi1",
    "\u80A3": "ham4",
    "\u80A4": "fu1",
    "\u80A5": "fei4/fei2",
    "\u80A6": "baan1",
    "\u80A7": "pui1/pei1",
    "\u80A8": "bun6",
    "\u80A9": "gin1",
    "\u80AA": "fong1",
    "\u80AB": "zeon1/seon4",
    "\u80AC": "jau4",
    "\u80AD": "neot6/leot6/nat6/lat6/nuk6/luk6",
    "\u80AE": "kon3/ong1/ngong1/ong3/ngong3/hong4",
    "\u80AF": "hang2/hoi2",
    "\u80B0": "jin4",
    "\u80B1": "gwang1",
    "\u80B2": "juk6/jo1",
    "\u80B3": "man5",
    "\u80B4": "ngaau4/aau4",
    "\u80B5": "kei4",
    "\u80B6": "bei2",
    "\u80B7": "him2/hip3",
    "\u80B8": "jat6/bei3",
    "\u80B9": "jat6/bei3",
    "\u80BA": "fai3",
    "\u80BB": "hang2",
    "\u80BC": "zeng2",
    "\u80BD": "taai3",
    "\u80BE": "san5/san2/san6",
    "\u80BF": "zung2",
    "\u80C0": "zoeng3",
    "\u80C1": "hip3",
    "\u80C2": "san6",
    "\u80C3": "wai6",
    "\u80C4": "zau6",
    "\u80C5": "dit3",
    "\u80C6": "daam2",
    "\u80C7": "fai3",
    "\u80C8": "bat6",
    "\u80C9": "bok3",
    "\u80CA": "keoi4",
    "\u80CB": "tim4",
    "\u80CC": "bui3/bui2/bui6",
    "\u80CD": "gwaa1",
    "\u80CE": "toi1",
    "\u80CF": "zi2",
    "\u80D0": "pui3",
    "\u80D1": "zi1/zik1",
    "\u80D2": "nei6/lei6",
    "\u80D3": "ping4",
    "\u80D4": "zi3",
    "\u80D5": "fu1/fu4",
    "\u80D6": "bun6/pun4",
    "\u80D7": "can2/zan1",
    "\u80D8": "jin4",
    "\u80D9": "zou6",
    "\u80DA": "pui1/pei1",
    "\u80DB": "gaap3",
    "\u80DC": "sing3/sing1/saang1",
    "\u80DD": "zi1",
    "\u80DE": "baau1",
    "\u80DF": "mou5",
    "\u80E0": "keoi1",
    "\u80E1": "wu4/wu2",
    "\u80E2": "kaa3",
    "\u80E3": "ci2",
    "\u80E4": "jan6",
    "\u80E5": "seoi1",
    "\u80E6": "joeng1",
    "\u80E7": "lung4",
    "\u80E8": "dung3",
    "\u80E9": "kaa1",
    "\u80EA": "lou4",
    "\u80EB": "hing5/ging3",
    "\u80EC": "nou5/lou5",
    "\u80ED": "jin1",
    "\u80EE": "pong1",
    "\u80EF": "kwaa3",
    "\u80F0": "ji4",
    "\u80F1": "gwong1/gong1",
    "\u80F2": "goi1/goi2/hoi2",
    "\u80F3": "gok3/gaak3/gat1/lok3",
    "\u80F4": "dung6",
    "\u80F5": "ci1/ci3",
    "\u80F6": "gaau1",
    "\u80F7": "hung1",
    "\u80F8": "hung1",
    "\u80F9": "ji4",
    "\u80FA": "on1/ngon1/on3/ngon3/aat3/ngaat3",
    "\u80FB": "hang4",
    "\u80FC": "pin4",
    "\u80FD": "nang4/lang4",
    "\u80FE": "zi3",
    "\u80FF": "gwai1",
    "\u8100": "zing1",
    "\u8101": "tiu2",
    "\u8102": "zi1",
    "\u8103": "ceoi3",
    "\u8104": "mui4",
    "\u8105": "hip3",
    "\u8106": "ceoi3",
    "\u8107": "hip3",
    "\u8108": "mak6",
    "\u8109": "mak6",
    "\u810A": "zik3/zek3",
    "\u810B": "hip3",
    "\u810C": "nin1/lin1",
    "\u810D": "kui2/kwui2",
    "\u810E": "saat3",
    "\u810F": "zong1/zong3/zong6",
    "\u8110": "ci4",
    "\u8111": "nou5/lou5",
    "\u8112": "mai5",
    "\u8113": "nung4/lung4",
    "\u8114": "lyun5/lyun2/lyun4",
    "\u8115": "maan5/maan6",
    "\u8116": "but6",
    "\u8117": "man5",
    "\u8118": "gun2/gwun2/wun2",
    "\u8119": "jau1",
    "\u811A": "goek3",
    "\u811B": "hing5/ging3",
    "\u811C": "jau4",
    "\u811D": "hang1",
    "\u811E": "co2",
    "\u811F": "lyut3/lyun2",
    "\u8120": "zin1",
    "\u8121": "ting2/ting5",
    "\u8122": "mui4",
    "\u8123": "seon4",
    "\u8124": "san5",
    "\u8125": "him2",
    "\u8126": "tik1",
    "\u8127": "zeoi1",
    "\u8128": "cuk1",
    "\u8129": "sau1",
    "\u812A": "jan3",
    "\u812B": "tyut3",
    "\u812C": "paau1",
    "\u812D": "cing4",
    "\u812E": "neoi5/leoi5",
    "\u812F": "fu2/pou2/pou4",
    "\u8130": "dau6",
    "\u8131": "tyut3",
    "\u7C08": "ping4",
    "\u7C09": "zou6",
    "\u7C0A": "gei1",
    "\u7C0B": "gwai2",
    "\u7C0C": "cuk1",
    "\u7C0D": "lau5",
    "\u7C0E": "caak3",
    "\u7C0F": "luk1",
    "\u7C10": "nin2/lin2",
    "\u7C11": "so1",
    "\u7C12": "saan3",
    "\u7C13": "diu1",
    "\u7C14": "so1",
    "\u7C15": "lak6",
    "\u7C16": "dyun6",
    "\u7C17": "loeng4",
    "\u7C18": "siu1",
    "\u7C19": "bok3",
    "\u7C1A": "mik6",
    "\u7C1B": "sai1",
    "\u7C1C": "dong6",
    "\u7C1D": "liu4",
    "\u7C1E": "daan1",
    "\u7C1F": "tim5/dim3",
    "\u7C20": "fu2",
    "\u7C21": "gaan2",
    "\u7C22": "man5",
    "\u7C23": "gwai6",
    "\u7C24": "daai6",
    "\u7C25": "giu1",
    "\u7C26": "dang1",
    "\u7C27": "wong4/wong2",
    "\u7C28": "seon2/seon3",
    "\u7C29": "lou4",
    "\u7C2A": "zaam1",
    "\u7C2B": "siu1",
    "\u7C2C": "lou6",
    "\u7C2D": "sai6",
    "\u7C2E": "zaam1",
    "\u7C2F": "kei4",
    "\u7C30": "paai4",
    "\u7C31": "kei4",
    "\u7C32": "paai4",
    "\u7C33": "gon3/gon2",
    "\u7C34": "geoi6",
    "\u7C35": "lou6",
    "\u7C36": "luk6",
    "\u7C37": "jim4/sim4/jam4",
    "\u7C38": "bo3/bo1/bo2",
    "\u7C39": "dong1",
    "\u7C3A": "coi3",
    "\u7C3B": "zaa1/gwo1/go1",
    "\u7C3C": "gau1",
    "\u7C3D": "cim1",
    "\u7C3E": "lim4/lim2",
    "\u7C3F": "bou6/bou2",
    "\u7C40": "zau6",
    "\u7C41": "laai6",
    "\u7C42": "sik1",
    "\u7C43": "laam4/laam2",
    "\u7C44": "gwai6",
    "\u7C45": "jyu4",
    "\u7C46": "wok6/jyut6",
    "\u7C47": "gou1",
    "\u7C48": "zan1",
    "\u7C49": "toi4",
    "\u7C4A": "tik1/dik6",
    "\u7C4B": "nip6/lip6",
    "\u7C4C": "cau4/cau2",
    "\u7C4D": "zik6",
    "\u7C4E": "ji4",
    "\u7C4F": "kei4",
    "\u7C50": "tang4",
    "\u7C51": "zaan6",
    "\u7C52": "zau6",
    "\u7C53": "faan1",
    "\u7C54": "sou2/sau2",
    "\u7C55": "zau6",
    "\u7C56": "cim1",
    "\u7C57": "zoek3",
    "\u7C58": "tang4",
    "\u7C59": "luk6",
    "\u7C5A": "lou4",
    "\u7C5B": "zin1",
    "\u7C5C": "tok3",
    "\u7C5D": "jing4",
    "\u7C5E": "jyu6",
    "\u7C5F": "laai6",
    "\u7C60": "lung4/lung2/lung5",
    "\u7C61": "gim2",
    "\u7C62": "lim4",
    "\u7C63": "laan4",
    "\u7C64": "cim1",
    "\u7C65": "joek6",
    "\u7C66": "zung1",
    "\u7C67": "keoi4/geoi2",
    "\u7C68": "lim4",
    "\u7C69": "bin1",
    "\u7C6A": "dyun6",
    "\u7C6B": "zyun2",
    "\u7C6C": "lei4/lei1",
    "\u7C6D": "sai1",
    "\u7C6E": "lo4/lo1/lo2",
    "\u7C6F": "jing4",
    "\u7C70": "wok6/jyut6",
    "\u7C71": "zoek3",
    "\u7C72": "jyu6/joek6",
    "\u7C73": "mai5/mai2/mai1",
    "\u7C74": "dek6",
    "\u7C75": "faan4",
    "\u7C76": "san1",
    "\u7C77": "zaak3",
    "\u7C78": "san1/sam2/saam2",
    "\u7C79": "neoi5/leoi5/jyu5",
    "\u7C7A": "hat6",
    "\u7C7B": "leoi6/leoi2",
    "\u7C7C": "sin1",
    "\u7C7D": "zi2",
    "\u7C7E": "nei4/lei4",
    "\u7C7F": "fan1.mai5",
    "\u7C80": "sap6.mai5",
    "\u7C81": "cin1.mai5",
    "\u7C82": "gau2",
    "\u7C83": "bei2",
    "\u7C84": "bun2",
    "\u7C85": "mat6",
    "\u7C86": "saa1",
    "\u7C87": "hong1",
    "\u7C88": "jau2",
    "\u7C89": "fan2",
    "\u7C8A": "bei3",
    "\u7C8B": "seoi6",
    "\u7C8C": "baak3.mai5",
    "\u7C8D": "hou4.mai5",
    "\u7C8E": "mai5",
    "\u7C8F": "taai3",
    "\u7C90": "wu6",
    "\u7C91": "baa1",
    "\u7C92": "nap1/lap1",
    "\u7C93": "gam1",
    "\u7C94": "geoi6/geoi2",
    "\u7C95": "pok3/paak3",
    "\u7C96": "mit6",
    "\u7C97": "cou1",
    "\u7C98": "zim1/nim1/lim1/nim4/lim4",
    "\u7C99": "zau6",
    "\u7C9A": "ci1",
    "\u7C9B": "suk1",
    "\u7C9C": "tiu3",
    "\u7C9D": "lai6",
    "\u7C9E": "sai1",
    "\u7C9F": "suk1",
    "\u7CA0": "hung4",
    "\u7CA1": "tung4",
    "\u7CA2": "zi1",
    "\u7CA3": "saan2",
    "\u7CA4": "jyut6",
    "\u7CA5": "zuk1/juk6",
    "\u7CA6": "leon4",
    "\u7CA7": "zong1",
    "\u7CA8": "baak3.mai5",
    "\u7CA9": "lou5",
    "\u7CAA": "fan3",
    "\u7CAB": "ji4",
    "\u7CAC": "kuk1",
    "\u7CAD": "hap6",
    "\u7CAE": "loeng4",
    "\u7CAF": "haan6",
    "\u7CB0": "fu1",
    "\u7CB1": "loeng4",
    "\u7CB2": "caan3",
    "\u7CB3": "gang1",
    "\u7CB4": "gung1.lei5",
    "\u7CB5": "jyut6",
    "\u7CB6": "luk6",
    "\u7CB7": "guk1",
    "\u7CB8": "kei4",
    "\u7CB9": "seoi6/seoi5/seoi3",
    "\u7CBA": "baai6/bai6/pei4",
    "\u7CBB": "zoeng1",
    "\u7CBC": "leon4",
    "\u7CBD": "zung2/zung3",
    "\u7CBE": "zing1/zeng1",
    "\u7CBF": "gwo2/go2",
    "\u7CC0": "faa1",
    "\u7CC1": "sam2/saam2",
    "\u7CC2": "sam2/saam2",
    "\u7CC3": "tong4",
    "\u7CC4": "bin2",
    "\u7CC5": "jau2/nau6/lau6",
    "\u7CC6": "min6",
    "\u7CC7": "hau4",
    "\u7CC8": "seoi2",
    "\u7CC9": "zung2/zung3",
    "\u7CCA": "wu4/wu2",
    "\u7CCB": "zin3",
    "\u7CCC": "zaam1/zaa1",
    "\u7CCD": "ci4",
    "\u7CCE": "lei4.mai5",
    "\u7CCF": "sit3",
    "\u7CD0": "fu1",
    "\u7CD1": "nik1/lik1",
    "\u7CD2": "bei6",
    "\u7CD3": "guk1",
    "\u7CD4": "sau1",
    "\u7CD5": "gou1",
    "\u7CD6": "tong4/tong2",
    "\u7CD7": "jau2/cau3",
    "\u7CD8": "gaa1",
    "\u7CD9": "cou3",
    "\u7CDA": "zong1",
    "\u7CDB": "tong4",
    "\u7CDC": "mei4",
    "\u7CDD": "sam2/saam2",
    "\u7CDE": "fan3",
    "\u7CDF": "zou1",
    "\u7CE0": "hong1",
    "\u7CE1": "goeng6",
    "\u7CE2": "mou4",
    "\u7CE3": "sam2",
    "\u7CE4": "saan2",
    "\u7CE5": "no6/lo6",
    "\u7CE6": "ci3",
    "\u7CE7": "loeng4",
    "\u7CE8": "goeng6",
    "\u7CE9": "kui2/kwui2",
    "\u7CEA": "baak3",
    "\u7CEB": "waan4",
    "\u7CEC": "syu4",
    "\u7CED": "zung3",
    "\u7CEE": "haam5",
    "\u7CEF": "no6/lo6/no2/lo2",
    "\u7CF0": "tyun4",
    "\u7CF1": "jit6/jip6",
    "\u7CF2": "lai6",
    "\u7CF3": "zok6",
    "\u7CF4": "dek6",
    "\u7CF5": "jit6/jip6",
    "\u7CF6": "tiu3",
    "\u7CF7": "laan6",
    "\u7CF8": "mik6",
    "\u7CF9": "kiu5.si1.bin1",
    "\u7CFA": "gau2/dau2/giu2",
    "\u7CFB": "hai6/hai2/gai3",
    "\u7CFC": "gung1",
    "\u7CFD": "zang2",
    "\u7CFE": "gau2/dau2/giu2",
    "\u7CFF": "jau3",
    "\u7D00": "gei2/gei3",
    "\u7D01": "caa3",
    "\u7D02": "zau6",
    "\u7D03": "ceon4",
    "\u7D04": "joek3/wok6",
    "\u7D05": "hung4/hung2/gung1",
    "\u7D06": "jyu1",
    "\u7D07": "hat6/gat1",
    "\u7D08": "jyun4",
    "\u7D09": "jan6",
    "\u7D0A": "man6/man5",
    "\u7D0B": "man4/man2/man6",
    "\u7D0C": "kau4",
    "\u7D0D": "naap6/laap6",
    "\u7D0E": "zi1",
    "\u7D0F": "tau2",
    "\u7D10": "nau2/lau2",
    "\u7D11": "fau4",
    "\u7D12": "gai3",
    "\u7D13": "syu1",
    "\u7D14": "seon4/zeon2",
    "\u7D15": "pei1/pei4",
    "\u7D16": "zan6/zan3",
    "\u7D17": "saa1",
    "\u7D18": "wang4",
    "\u7D19": "zi2",
    "\u7D1A": "kap1",
    "\u7D1B": "fan1",
    "\u7D1C": "wan4",
    "\u7D1D": "jam6/jam4",
    "\u7D1E": "daam2/dam2",
    "\u7D1F": "gam1/gam3",
    "\u7D20": "sou3",
    "\u7D21": "fong2",
    "\u7D22": "sok3/suk3/saak3",
    "\u7D23": "ceoi3",
    "\u7D24": "gau2",
    "\u7D25": "zaat3",
    "\u7D26": "baa1",
    "\u7D27": "gan2",
    "\u7D28": "fu1",
    "\u7D29": "dit6",
    "\u7D2A": "cai1",
    "\u7D2B": "zi2",
    "\u7D2C": "cau4/cau1",
    "\u7D2D": "wang4",
    "\u7D2E": "zaat3",
    "\u7D2F": "leoi6/leoi5/leoi4",
    "\u7D30": "sai3/sai2",
    "\u7D31": "fat1",
    "\u7D32": "sit3/jai6",
    "\u7D33": "san1",
    "\u7D34": "bo1",
    "\u7D35": "cyu5",
    "\u7D36": "keoi1",
    "\u7D37": "ling4",
    "\u7D38": "zyu3",
    "\u7D39": "siu6",
    "\u7D3A": "gam3",
    "\u7D3B": "joeng2",
    "\u7D3C": "fat1",
    "\u7D3D": "to4",
    "\u7D3E": "zan2/can2",
    "\u7D3F": "doi6/toi5",
    "\u7D40": "zyut3/zyut6/zeot1",
    "\u7D41": "si1",
    "\u7D42": "zung1",
    "\u7D43": "jin4/jyun4",
    "\u7D44": "zou2",
    "\u7D45": "gwing2",
    "\u7D46": "bun6",
    "\u7D47": "keoi4",
    "\u7D48": "mak6",
    "\u7D49": "seot6",
    "\u7D4A": "zeoi3",
    "\u7D4B": "kwong3/kong3",
    "\u7D4C": "ging1",
    "\u7D4D": "jam6/jam4",
    "\u7D4E": "hong4",
    "\u7D4F": "jai6/sit3",
    "\u7D50": "git3/lit3/gai3",
    "\u7D51": "zyu1",
    "\u7D52": "cau4",
    "\u7D53": "gwaa3",
    "\u7D54": "baak3",
    "\u7D55": "zyut6/zyut2",
    "\u7D56": "kwong3/kong3",
    "\u7D57": "wat6",
    "\u7D58": "ci3",
    "\u7D59": "gang1/gang2",
    "\u7D5A": "gang1/gang2",
    "\u7D5B": "tou1",
    "\u7D5C": "git3",
    "\u7D5D": "fu3",
    "\u7D5E": "gaau2",
    "\u7D5F": "cyun1",
    "\u7D60": "goi2",
    "\u7D61": "lok3/lok2/lok6",
    "\u7D62": "hyun3/seon1",
    "\u7D63": "bang1",
    "\u7D64": "sin3",
    "\u7D65": "fuk6/bei6",
    "\u7D66": "kap1",
    "\u7D67": "dung6",
    "\u7D68": "jung2/jung4",
    "\u7D69": "tiu3",
    "\u7D6A": "jan1",
    "\u7D6B": "leoi5",
    "\u7D6C": "sit3",
    "\u7D6D": "gyun3/hyun3",
    "\u7D6E": "seoi5/seoi6",
    "\u7D6F": "goi1",
    "\u7D70": "dit6",
    "\u7D71": "tung2",
    "\u7D72": "si1",
    "\u7D73": "gong3",
    "\u7D74": "coeng4",
    "\u7D75": "kui2/kwui2",
    "\u7D76": "zyut6",
    "\u7D77": "zap1",
    "\u7D78": "gaan2",
    "\u7D79": "gyun3",
    "\u7D7A": "ci1",
    "\u7D7B": "man6/min5",
    "\u7D7C": "zi6",
    "\u7D7D": "leoi5",
    "\u7D7E": "sing4",
    "\u7D7F": "kau4",
    "\u7D80": "so1",
    "\u7D81": "bong2",
    "\u7D82": "tung2",
    "\u7D83": "siu1",
    "\u7D84": "jyun4",
    "\u7D85": "cim1/cam1",
    "\u7D86": "gang2",
    "\u7D87": "sau2",
    "\u7D88": "tai4/tai3",
    "\u7D89": "sau3",
    "\u7D8A": "haap6",
    "\u7D8B": "wang4",
    "\u7D8C": "gwik1",
    "\u7D8D": "fat1",
    "\u7D8E": "ting1/ting4",
    "\u7D8F": "seoi1",
    "\u7D90": "deoi6",
    "\u7D91": "kwan2",
    "\u7D92": "fu1",
    "\u7D93": "ging1",
    "\u7D94": "wu6",
    "\u7D95": "zik1",
    "\u7D96": "jin4/jin1",
    "\u7D97": "gwing2",
    "\u7D98": "fung4",
    "\u7D99": "gai3",
    "\u7D9A": "zuk6",
    "\u7D9B": "jan2",
    "\u7D9C": "zung1/zung3",
    "\u7D9D": "sam1/lam4",
    "\u7D9E": "do2",
    "\u7D9F": "lit6/lai6",
    "\u7DA0": "luk6/luk2",
    "\u7DA1": "loeng4",
    "\u7DA2": "cau4/cau2",
    "\u7DA3": "hyun3",
    "\u7DA4": "siu6",
    "\u7DA5": "kei4",
    "\u7DA6": "kei4",
    "\u7DA7": "zeon2",
    "\u7DA8": "kei4",
    "\u7DA9": "jyun2",
    "\u7DAA": "sin6/zang1",
    "\u7DAB": "sin3",
    "\u7DAC": "sau6",
    "\u7DAD": "wai4",
    "\u7DAE": "hing3/kai2",
    "\u7DAF": "tou4",
    "\u7DB0": "waan2",
    "\u7DB1": "gong1",
    "\u7DB2": "mong5/mong1",
    "\u7DB3": "bang1/mang2/maang1",
    "\u7DB4": "zeoi3/zeoi6/zyut3/zyut6",
    "\u7DB5": "coi2",
    "\u7DB6": "gwo2/go2",
    "\u7DB7": "ceoi3",
    "\u7DB8": "leon4/gwaan1",
    "\u7DB9": "lau5",
    "\u7DBA": "ji2",
    "\u7DBB": "zaan6",
    "\u7DBC": "bik1",
    "\u7DBD": "coek3/caau1",
    "\u7DBE": "ling4",
    "\u7DBF": "min4",
    "\u7DC0": "cai1",
    "\u7DC1": "cip3/zip3/cap1",
    "\u7DC2": "taam1",
    "\u7DC3": "zung1",
    "\u7DC4": "gwan2",
    "\u7DC5": "zau1",
    "\u7DC6": "sik1",
    "\u7DC7": "zi1",
    "\u7DC8": "hang6",
    "\u7DC9": "loeng5",
    "\u7DCA": "gan2",
    "\u7DCB": "fei1",
    "\u7DCC": "jeoi4",
    "\u7DCD": "man4",
    "\u7DCE": "wik6",
    "\u7DCF": "zung2",
    "\u7DD0": "po4/faan4",
    "\u7DD1": "luk6",
    "\u7DD2": "seoi5",
    "\u7DD3": "jing1",
    "\u7DD4": "soeng5",
    "\u7DD5": "cai4",
    "\u7DD6": "seoi5",
    "\u7DD7": "soeng1",
    "\u7DD8": "gaam1/zin1",
    "\u7DD9": "kaak1/kaak3",
    "\u7DDA": "sin3/sin2",
    "\u7DDB": "jyun5",
    "\u7DDC": "min4",
    "\u7DDD": "cap1",
    "\u7DDE": "dyun6/dyun2",
    "\u7DDF": "cung5",
    "\u7DE0": "dai3/tai3",
    "\u7DE1": "man4",
    "\u7DE2": "miu4",
    "\u7DE3": "jyun4/jyun6",
    "\u7DE4": "sit3",
    "\u7DE5": "bou2",
    "\u7DE6": "si1",
    "\u7DE7": "cau1",
    "\u7DE8": "pin1",
    "\u7DE9": "wun6/wun4",
    "\u7DEA": "gang1/gang2",
    "\u7DEB": "zung2",
    "\u7DEC": "min5",
    "\u7DED": "wai6",
    "\u7DEE": "fuk6",
    "\u7DEF": "wai5",
    "\u7DF0": "tau4",
    "\u7DF1": "gau1",
    "\u7DF2": "miu5",
    "\u7DF3": "kit3",
    "\u7DF4": "lin6",
    "\u7DF5": "zung1",
    "\u7DF6": "pin4/bin1",
    "\u7DF7": "wan6",
    "\u7DF8": "jan1",
    "\u7DF9": "tai4",
    "\u7DFA": "gwaa1",
    "\u7DFB": "zi3",
    "\u7DFC": "wan3/wan1",
    "\u7DFD": "cing1",
    "\u7DFE": "cin4",
    "\u7DFF": "doi6",
    "\u7E00": "dyun6",
    "\u7E01": "jyun4",
    "\u7E02": "zung2",
    "\u7E03": "seoi1",
    "\u7E04": "sing4",
    "\u7E05": "wai1",
    "\u7E06": "gang1/gang2",
    "\u7E07": "syun1",
    "\u7E08": "jing4",
    "\u7E09": "zeon3",
    "\u7E0A": "ai3/ngai3",
    "\u7E0B": "zeoi6",
    "\u7E0C": "jik6",
    "\u7E0D": "bong1",
    "\u7E0E": "gwat1",
    "\u7E0F": "pun4",
    "\u7E10": "zau3",
    "\u7E11": "gim1",
    "\u7E12": "ci1",
    "\u7E13": "cyun4/cyun3",
    "\u7E14": "song2",
    "\u7E15": "wan3/wan1",
    "\u7E16": "hat6",
    "\u7E17": "ceoi1",
    "\u7E18": "hai6",
    "\u7E19": "jung4",
    "\u7E1A": "tou1",
    "\u7E1B": "bok3/fok3",
    "\u7E1C": "wan4",
    "\u7E1D": "zan2/can2",
    "\u7E1E": "gou2",
    "\u7E1F": "juk6",
    "\u7E20": "huk6",
    "\u7E21": "zoi2/zoi3",
    "\u7E22": "tang4",
    "\u7E23": "jyun6/jyun2/jyun4",
    "\u7E24": "sou3",
    "\u7E25": "zeon2",
    "\u7E26": "zung3",
    "\u7E27": "tou1",
    "\u7E28": "fong2",
    "\u7E29": "coi3",
    "\u7E2A": "bat1",
    "\u7E2B": "fung4/fung2/fung6",
    "\u7E2C": "zuk1",
    "\u7E2D": "lei4",
    "\u7E2E": "suk1",
    "\u7E2F": "jin2",
    "\u7E30": "si2/saai2",
    "\u7E31": "zung3/zung1",
    "\u7E32": "leoi4",
    "\u7E33": "gyun3",
    "\u7E34": "hin3/hin1",
    "\u7E35": "maan6",
    "\u7E36": "zap1",
    "\u7E37": "leoi5/lau5/lau2",
    "\u7E38": "mou6",
    "\u7E39": "piu5/piu1",
    "\u7E3A": "lin4",
    "\u7E3B": "mei4",
    "\u7E3C": "syun6",
    "\u7E3D": "zung2",
    "\u7E3E": "zik1",
    "\u7E3F": "saam1",
    "\u7E40": "seoi3",
    "\u7E41": "faan4/po4",
    "\u7E42": "leot6",
    "\u7E43": "bang1/mang2/maang1",
    "\u7E44": "ji1",
    "\u7E45": "sou1",
    "\u7E46": "mau4/mau6/maau6/miu6/muk6",
    "\u7E47": "jau4/jiu4/zau6",
    "\u7E48": "koeng5",
    "\u7E49": "wan4",
    "\u7E4A": "cim1",
    "\u7E4B": "hai6",
    "\u7E4C": "zung1",
    "\u7E4D": "sau3",
    "\u7E4E": "jin4",
    "\u7E4F": "syun3",
    "\u7E50": "seoi6/seoi2",
    "\u7E51": "hiu1/kiu5",
    "\u7E52": "zang1/zang6",
    "\u7E53": "dyut3",
    "\u7E54": "zik1/zi3/ci3",
    "\u7E55": "sin6",
    "\u7E56": "saan3",
    "\u7E57": "leon4",
    "\u7E58": "wat6",
    "\u7E59": "faan4/faan1",
    "\u7E5A": "liu4/liu1",
    "\u7E5B": "coek3",
    "\u7E5C": "zeon1",
    "\u7E5D": "gaan3",
    "\u7E5E": "jiu2/jiu5",
    "\u7E5F": "taan4",
    "\u7E60": "jeoi5",
    "\u7E61": "sau3",
    "\u7E62": "kui2/kwui2",
    "\u7E63": "waak6",
    "\u7E64": "zyun2",
    "\u7E65": "hei1",
    "\u7E66": "koeng5",
    "\u7E67": "wan4",
    "\u7E68": "daat6",
    "\u7E69": "sing4/sing2",
    "\u7E6A": "kui2/kwui2/kui3/kwui3",
    "\u7E6B": "hai6/gai3",
    "\u7E6C": "sik1",
    "\u7E6D": "gaan2",
    "\u7E6E": "goeng1",
    "\u7E6F": "waan4/waan6",
    "\u7E70": "zou2/sou1/ciu1",
    "\u7E71": "cung1",
    "\u7E72": "gaai3",
    "\u7E73": "giu2/zoek3",
    "\u7E74": "bik1",
    "\u7E75": "daan6",
    "\u7E76": "jik1",
    "\u7E77": "nung5/lung5",
    "\u7E78": "seoi6",
    "\u7E79": "jik6",
    "\u7E7A": "saai2",
    "\u7E7B": "seoi1/jyu4",
    "\u7E7C": "gai3",
    "\u7E7D": "ban1",
    "\u7E7E": "hin2",
    "\u7E7F": "laam4",
    "\u7E80": "fuk6/buk6",
    "\u7E81": "fan1",
    "\u7E82": "zyun2",
    "\u7E83": "cai4",
    "\u7E84": "pung4",
    "\u7E85": "joek6",
    "\u7E86": "mak6",
    "\u7E87": "leoi6",
    "\u7E88": "kit3/hit3/lit3",
    "\u7E89": "zyun2",
    "\u7E8A": "kwong3/kong3",
    "\u7E8B": "jau1",
    "\u7E8C": "zuk6",
    "\u7E8D": "leoi4/leoi5/leoi6",
    "\u7E8E": "cim1",
    "\u7E8F": "cin4/zin6",
    "\u7E90": "haau1",
    "\u7E91": "lou4",
    "\u7E92": "cin4",
    "\u7E93": "jing1",
    "\u7E94": "coi4",
    "\u7E95": "soeng1/joeng5/joeng4",
    "\u7E96": "cim1",
    "\u7E97": "zeoi1",
    "\u7E98": "zyun2",
    "\u7E99": "lo6",
    "\u7E9A": "saai2/si2/saa2/lei4/lei5/si1",
    "\u7E9B": "duk6/dou6",
    "\u7E9C": "laam6",
    "\u7E9D": "leoi4",
    "\u7E9E": "lyun5",
    "\u7E9F": "gaan2.faa3.kiu5.si1.bin1",
    "\u7EA0": "gau2/dau2/giu2",
    "\u7EA1": "jyu1",
    "\u7EA2": "hung4/hung2/gung1",
    "\u7EA3": "zau6",
    "\u7EA4": "cim1/hin3/hin1",
    "\u7EA5": "hat6/gat1",
    "\u7EA6": "joek3/wok6",
    "\u7EA7": "kap1",
    "\u7EA8": "jyun4",
    "\u7EA9": "kwong3/kong3",
    "\u7EAA": "gei2/gei3",
    "\u7EAB": "jan6",
    "\u7EAC": "wai5",
    "\u7EAD": "wan4",
    "\u7EAE": "wang4",
    "\u7EAF": "seon4/zeon2",
    "\u7EB0": "pei1/pei4",
    "\u7EB1": "saa1",
    "\u792B": "lik1/lok6",
    "\u792C": "faan4",
    "\u792D": "kok3",
    "\u792E": "paau3",
    "\u792F": "jing4",
    "\u7930": "lik6",
    "\u7931": "lung4",
    "\u7932": "lung4",
    "\u7933": "mo6",
    "\u7934": "bok6",
    "\u7935": "soeng1",
    "\u7936": "gun3/gwun3",
    "\u7937": "laam4",
    "\u7938": "caat3",
    "\u7939": "ngaam4/aam4",
    "\u793A": "si6",
    "\u793B": "si6/si6.zi6.bin1",
    "\u793C": "lai5",
    "\u793D": "jing4",
    "\u793E": "se5",
    "\u793F": "joek6",
    "\u7940": "zi6",
    "\u7941": "kei4",
    "\u7942": "taa1",
    "\u7943": "maa6",
    "\u7944": "gaai3",
    "\u7945": "jiu1/jiu2",
    "\u7946": "hin1",
    "\u7947": "kei4/zi2",
    "\u7948": "kei4",
    "\u7949": "zi2",
    "\u794A": "bang1",
    "\u794B": "doi6",
    "\u794C": "zung6",
    "\u794D": "jam6",
    "\u794E": "ji1",
    "\u794F": "sek6",
    "\u7950": "jau6",
    "\u7951": "zat6",
    "\u7952": "tiu4",
    "\u7953": "fat1",
    "\u7954": "fu6",
    "\u7955": "bei3",
    "\u7956": "zou2",
    "\u7957": "zi1",
    "\u7958": "syun3",
    "\u7959": "mei6",
    "\u795A": "zou6",
    "\u795B": "keoi1",
    "\u795C": "wu2/wu6",
    "\u795D": "zuk1/zau3",
    "\u795E": "san4/san2/san1",
    "\u795F": "seoi6",
    "\u7960": "ci4",
    "\u7961": "caai4",
    "\u7962": "nei5/lei5/nei4/lei4",
    "\u7963": "leoi5",
    "\u7964": "jyu5/heoi2",
    "\u7965": "coeng4",
    "\u7966": "ng4/m4",
    "\u7967": "tiu1",
    "\u7968": "piu3/piu2/biu1/piu1",
    "\u7969": "zyu3",
    "\u796A": "gwai2",
    "\u796B": "haap6",
    "\u796C": "zi1",
    "\u796D": "zai3",
    "\u796E": "haau2",
    "\u796F": "zing1",
    "\u7970": "haau2",
    "\u7971": "seoi3",
    "\u7972": "zam1",
    "\u7973": "san6",
    "\u7974": "goi1",
    "\u7975": "kwan2",
    "\u7976": "dai3",
    "\u7977": "tou2/dou2",
    "\u7978": "wo6",
    "\u7979": "tou4",
    "\u797A": "kei4",
    "\u797B": "gu3/gwu3",
    "\u797C": "gun3/gwun3",
    "\u797D": "zeoi3",
    "\u797E": "ling4",
    "\u797F": "luk6",
    "\u7980": "ban2",
    "\u7981": "gam3/kam1/gam1",
    "\u7982": "dou2",
    "\u7983": "zik6",
    "\u7984": "luk6",
    "\u7985": "sim4/sin4/sin6",
    "\u7986": "pei4",
    "\u7987": "cyu5",
    "\u7988": "fai1",
    "\u7989": "jau5",
    "\u798A": "hai6",
    "\u798B": "jan1",
    "\u798C": "zi1",
    "\u798D": "wo6",
    "\u798E": "zing1",
    "\u798F": "fuk1/fu3",
    "\u7990": "jyun6",
    "\u7991": "ng4/m4",
    "\u7992": "sin2",
    "\u7993": "joeng4/soeng1",
    "\u7994": "tai4",
    "\u7995": "ji1",
    "\u7996": "mui4",
    "\u7997": "si1",
    "\u7998": "dai3",
    "\u7999": "bui3",
    "\u799A": "zoek3",
    "\u799B": "zan1",
    "\u799C": "wing6/wing4",
    "\u799D": "zik1",
    "\u799E": "haau2",
    "\u799F": "tong4",
    "\u79A0": "si1",
    "\u79A1": "maa6",
    "\u79A2": "taap3",
    "\u79A3": "bok3",
    "\u79A4": "hyun1",
    "\u79A5": "kei4",
    "\u79A6": "jyu6",
    "\u79A7": "hei1/hei2",
    "\u79A8": "gei1",
    "\u79A9": "zi6",
    "\u79AA": "sim4/sin4/sin6",
    "\u79AB": "taam5",
    "\u79AC": "kui2/kwui2/wui6",
    "\u79AD": "seoi6",
    "\u79AE": "lai5",
    "\u79AF": "nung4/lung4",
    "\u79B0": "nei5/lei5/nei4/lei4",
    "\u79B1": "tou2/dou2",
    "\u79B2": "lai6",
    "\u79B3": "joeng4",
    "\u79B4": "joek6",
    "\u79B5": "tai4",
    "\u79B6": "zaan6",
    "\u79B7": "leoi6",
    "\u79B8": "jau4/maan6.zi6.dai2",
    "\u79B9": "jyu5",
    "\u79BA": "jyu4",
    "\u79BB": "lei4/ci1",
    "\u79BC": "sit3",
    "\u79BD": "kam4",
    "\u79BE": "wo4/wo2",
    "\u79BF": "tuk1",
    "\u79C0": "sau3",
    "\u79C1": "si1",
    "\u79C2": "jan4",
    "\u79C3": "tuk1",
    "\u79C4": "zi2",
    "\u79C5": "caa4",
    "\u79C6": "gon2",
    "\u79C7": "ngai6/ai6",
    "\u79C8": "sin1",
    "\u79C9": "bing2",
    "\u79CA": "nin4/lin4",
    "\u79CB": "cau1",
    "\u79CC": "cau1",
    "\u79CD": "zung2/zung3/cung4",
    "\u79CE": "fan6",
    "\u79CF": "hou3",
    "\u79D0": "wan4",
    "\u79D1": "fo1",
    "\u79D2": "miu5/miu2",
    "\u79D3": "zi1",
    "\u79D4": "gang1",
    "\u79D5": "bei2",
    "\u79D6": "zi2",
    "\u79D7": "jyu3",
    "\u79D8": "bei3",
    "\u79D9": "fu3",
    "\u79DA": "bun6",
    "\u79DB": "pei1",
    "\u79DC": "nei4/lei4",
    "\u79DD": "lik6",
    "\u79DE": "jau4",
    "\u79DF": "zou1",
    "\u79E0": "pei1",
    "\u79E1": "bat3",
    "\u79E2": "ling4",
    "\u79E3": "mut6/mut3",
    "\u79E4": "cing3",
    "\u79E5": "nim4/lim4",
    "\u79E6": "ceon4",
    "\u79E7": "joeng1",
    "\u79E8": "zok6",
    "\u79E9": "dit6",
    "\u79EA": "zi1",
    "\u79EB": "seot6",
    "\u79EC": "geoi6",
    "\u79ED": "zi2",
    "\u79EE": "wut6",
    "\u79EF": "zik1",
    "\u79F0": "cing1/cing3/can3",
    "\u79F1": "tung4",
    "\u79F2": "zi6",
    "\u79F3": "wut6",
    "\u79F4": "hap6",
    "\u79F5": "jan1",
    "\u79F6": "zi1",
    "\u79F7": "zat1",
    "\u79F8": "gaai1",
    "\u79F9": "jam5",
    "\u79FA": "dou6",
    "\u79FB": "ji4",
    "\u79FC": "zyu3",
    "\u79FD": "wai3",
    "\u79FE": "nung4/lung4",
    "\u79FF": "fu6",
    "\u7A00": "hei1",
    "\u7A01": "gou2",
    "\u7A02": "long4",
    "\u7A03": "fu1",
    "\u7A04": "seon3",
    "\u7A05": "seoi3",
    "\u7A06": "leoi5",
    "\u7A07": "kwan2",
    "\u7A08": "gon2",
    "\u7A09": "gang1",
    "\u7A0A": "tai4",
    "\u7A0B": "cing4/cing2",
    "\u7A0C": "tou4",
    "\u7A0D": "saau2",
    "\u7A0E": "seoi3",
    "\u7A0F": "aa3/ngaa3",
    "\u7A10": "leon5",
    "\u7A11": "luk6",
    "\u7A12": "gu3/gwu3",
    "\u7A13": "zok6",
    "\u7A14": "nam5/lam5/nim1/lim1",
    "\u7A15": "zeon3",
    "\u7A16": "bong6/paang5",
    "\u7A17": "baai6/bai6/pei4",
    "\u7A18": "gei1",
    "\u7A19": "zik6",
    "\u7A1A": "zi6",
    "\u7A1B": "kwan2",
    "\u7A1C": "ling4",
    "\u7A1D": "paang4",
    "\u7A1E": "fo1",
    "\u7A1F": "lam5/ban2",
    "\u7A20": "cau4",
    "\u7A21": "zeoi3",
    "\u7A22": "juk1",
    "\u7A23": "sou1",
    "\u7A24": "loek6",
    "\u7A25": "hoeng1",
    "\u7A26": "ji1",
    "\u7A27": "hai6",
    "\u7A28": "bin2",
    "\u7A29": "gei3",
    "\u7A2A": "fuk1",
    "\u7A2B": "pik1",
    "\u7A2C": "no6/lo6",
    "\u7A2D": "gaai1",
    "\u7A2E": "zung2/zung3",
    "\u7A2F": "zung1",
    "\u7A30": "seoi2",
    "\u7A31": "cing1/cing3/can3",
    "\u7A32": "dou6",
    "\u7A33": "wan2",
    "\u7A34": "jim4",
    "\u7A35": "zi1",
    "\u7A36": "juk1",
    "\u7A37": "zik1",
    "\u7A38": "cuk1",
    "\u7A39": "zan2/can2",
    "\u7A3A": "zi6",
    "\u7A3B": "dou6",
    "\u7A3C": "gaa3",
    "\u7A3D": "kai1/kai2",
    "\u7A3E": "gou2",
    "\u7A3F": "gou2",
    "\u7A40": "guk1",
    "\u7A41": "jung4",
    "\u7A42": "seoi6",
    "\u7A43": "jung4",
    "\u7A44": "zai3",
    "\u7A45": "hong1",
    "\u7A46": "muk6",
    "\u7A47": "saam1/caam2",
    "\u7A48": "mun4",
    "\u7A49": "zi6",
    "\u7A4A": "gei3",
    "\u7A4B": "luk6",
    "\u7A4C": "sou1",
    "\u7A4D": "zik1",
    "\u7A4E": "wing6",
    "\u7A4F": "wan2",
    "\u7A50": "cau1",
    "\u7A51": "sik1",
    "\u7A52": "niu5/liu5",
    "\u7A53": "jik6",
    "\u7A54": "wong4",
    "\u7A55": "cip3",
    "\u7A56": "gei1",
    "\u7A57": "seoi6/soei2",
    "\u7A58": "hiu1",
    "\u7A59": "buk6",
    "\u7A5A": "giu1",
    "\u7A5B": "zuk1",
    "\u7A5C": "tung4/zung3/zung2",
    "\u7A5D": "zeoi3",
    "\u7A5E": "leoi5",
    "\u7A5F": "seoi6",
    "\u7A60": "nung4/lung4",
    "\u7A61": "sik1",
    "\u7A62": "wai3",
    "\u7A63": "joeng4",
    "\u7A64": "no6/lo6",
    "\u7A65": "jyu6",
    "\u7A66": "pan1",
    "\u7A67": "zai6/zai3",
    "\u7A68": "teoi4",
    "\u7A69": "wan2",
    "\u7A6A": "cing1",
    "\u7A6B": "wok6",
    "\u7A6C": "kong3/kwong3",
    "\u7A6D": "leoi5",
    "\u7A6E": "biu1",
    "\u7A6F": "sik1",
    "\u7A70": "joeng4/joeng6",
    "\u7A71": "zoek3",
    "\u7A72": "lei4",
    "\u7A73": "cyun4",
    "\u7A74": "jyut6",
    "\u7A75": "waat3/waa1",
    "\u7A76": "gau3/gau2",
    "\u7A77": "kung4",
    "\u7A78": "zik6",
    "\u7A79": "kung4",
    "\u7A7A": "hung1/hung3",
    "\u7A7B": "jyu1",
    "\u7A7C": "sam1",
    "\u7A7D": "zing6/zeng2/zeng6",
    "\u7A7E": "jiu2/jiu3",
    "\u7A7F": "cyun1",
    "\u7A80": "zeon1",
    "\u7A81": "dat6",
    "\u7A82": "lou4",
    "\u7A83": "sit3",
    "\u7A84": "zaak3",
    "\u7A85": "jiu2",
    "\u7A86": "bin2",
    "\u7A87": "bok6",
    "\u7A88": "miu5/jiu2",
    "\u7A89": "bing2",
    "\u7A8A": "waa1",
    "\u7A8B": "zyut3",
    "\u7A8C": "gaau3",
    "\u7A8D": "kiu3/kiu2/hiu3",
    "\u7A8E": "diu3",
    "\u7A8F": "wu1",
    "\u7A90": "waa1",
    "\u7A91": "jiu4",
    "\u7A92": "zat6",
    "\u7A93": "coeng1",
    "\u7A94": "jiu2/jiu3",
    "\u7A95": "tiu5/jiu4",
    "\u7A96": "gaau3",
    "\u7A97": "coeng1",
    "\u7A98": "kwan3",
    "\u7A99": "haau1",
    "\u7A9A": "sing4",
    "\u7A9B": "kau3",
    "\u7A9C": "cyun2/cyun3",
    "\u7A9D": "wo1",
    "\u7A9E": "daam6/ham2",
    "\u7A9F": "fat1/gwat6",
    "\u7AA0": "wo1/fo1",
    "\u7AA1": "zeot1",
    "\u7AA2": "wik6",
    "\u7AA3": "seot1",
    "\u7AA4": "gun1/gwun1",
    "\u7AA5": "kwai1",
    "\u7AA6": "dau6/dau2/dau3/duk6",
    "\u7AA7": "coek3",
    "\u7AA8": "jam3/fan1",
    "\u7AA9": "wo1",
    "\u7AAA": "waa1/gwai1",
    "\u7AAB": "jaak3/aat3/ngaat3",
    "\u7AAC": "jyu4",
    "\u7AAD": "geoi6/lau4",
    "\u7AAE": "kung4",
    "\u7AAF": "jiu4",
    "\u7AB0": "jiu4",
    "\u7AB1": "tiu5",
    "\u7AB2": "caau4",
    "\u7AB3": "jyu5",
    "\u7AB4": "zi3",
    "\u7AB5": "diu3",
    "\u7AB6": "geoi6/lau4",
    "\u7AB7": "liu6",
    "\u7AB8": "sik1",
    "\u7AB9": "ng6/m6",
    "\u7ABA": "kwai1",
    "\u7ABB": "coeng1",
    "\u7ABC": "zaau1",
    "\u7ABD": "fun2",
    "\u7ABE": "fun2",
    "\u7ABF": "lung1/lung4",
    "\u7AC0": "cang1/cing1",
    "\u7AC1": "ceoi3",
    "\u7AC2": "liu4",
    "\u7AC3": "hung1",
    "\u7AC4": "cyun2/cyun3",
    "\u7AC5": "kiu3/kiu2/hiu3",
    "\u7AC6": "kung4",
    "\u7AC7": "dau6/dau2/dau3/duk6",
    "\u7AC8": "zou3",
    "\u7AC9": "lung1",
    "\u7ACA": "sit3",
    "\u7ACB": "lap6/laap6",
    "\u7ACC": "cyu3",
    "\u7ACD": "sap6.sing1",
    "\u7ACE": "fu3",
    "\u7ACF": "cin1.sing1",
    "\u7AD0": "cuk1",
    "\u7AD1": "wang4",
    "\u7AD2": "kei4",
    "\u7AD3": "hou4.sing1",
    "\u7AD4": "sing1",
    "\u7AD5": "fan1.sing1",
    "\u7AD6": "syu6",
    "\u7AD7": "miu6",
    "\u7AD8": "keoi5",
    "\u7AD9": "zaam6",
    "\u7ADA": "cyu5",
    "\u7ADB": "ling4",
    "\u7ADC": "lung4",
    "\u7ADD": "bing6/bing3",
    "\u7ADE": "ging6/ging3",
    "\u7ADF": "ging2",
    "\u7AE0": "zoeng1",
    "\u7AE1": "baak3.sing1",
    "\u7AE2": "zi6",
    "\u7AE3": "zeon3",
    "\u7AE4": "wang4",
    "\u7AE5": "tung4/tung2",
    "\u7AE6": "sung2",
    "\u7AE7": "zing6",
    "\u7AE8": "diu6",
    "\u7AE9": "ji4",
    "\u7AEA": "syu6",
    "\u7AEB": "zing6",
    "\u7AEC": "geoi2",
    "\u7AED": "kit3",
    "\u7AEE": "ping4",
    "\u7AEF": "dyun1",
    "\u7AF0": "lei4.sing1",
    "\u7AF1": "zyun2",
    "\u7AF2": "cang4",
    "\u7AF3": "dang1",
    "\u7AF4": "ceon1",
    "\u7AF5": "waai1/me2",
    "\u7AF6": "ging6/ging3",
    "\u7AF7": "ham2",
    "\u7AF8": "ging6",
    "\u7AF9": "zuk1",
    "\u7AFA": "zuk1",
    "\u7AFB": "lak6",
    "\u7AFC": "pung4",
    "\u7AFD": "jyu4/jyu1",
    "\u7AFE": "ci4",
    "\u7AFF": "gon1",
    "\u7B00": "mong4",
    "\u7B01": "zuk1",
    "\u7B02": "jyun4",
    "\u7B03": "duk1",
    "\u7B04": "gai1",
    "\u7B05": "gaau2",
    "\u7B06": "baa1",
    "\u7B07": "syun3",
    "\u7B08": "kap1",
    "\u7B09": "can2",
    "\u7B0A": "zaau3",
    "\u7B0B": "seon2",
    "\u7B0C": "ngaa4/aa4",
    "\u7B0D": "zeoi3",
    "\u7B0E": "jyun4",
    "\u7B0F": "fat1",
    "\u7B10": "hong4",
    "\u7B11": "siu3/siu2",
    "\u7B12": "sam4",
    "\u7B13": "pei4",
    "\u7B14": "bat1",
    "\u7B15": "gaan2",
    "\u7B16": "ji5",
    "\u7B17": "dung1",
    "\u7B18": "sim1",
    "\u7B19": "sang1/saang1",
    "\u7B1A": "daap3",
    "\u7B1B": "dek6/dek2",
    "\u7B1C": "zeot1",
    "\u7B1D": "naap6/laap6",
    "\u7B1E": "ci1",
    "\u7B1F": "ku1/kwu1",
    "\u7B20": "lap1",
    "\u7B21": "ce3",
    "\u7B22": "man5",
    "\u7B23": "baau1",
    "\u7B24": "tiu4",
    "\u7B25": "zi6",
    "\u7B26": "fu4",
    "\u7B27": "caak3",
    "\u7B28": "ban6",
    "\u7B29": "fat6",
    "\u7B2A": "daat3",
    "\u7B2B": "zi2/ji2",
    "\u7B2C": "dai6/dai2",
    "\u7B2D": "ling4",
    "\u7B2E": "zaak3/zok6/zaa3",
    "\u7B2F": "nou4/lou4",
    "\u7B30": "fat1",
    "\u7B31": "gau2",
    "\u7B32": "faan4",
    "\u7B33": "gaa1",
    "\u7B34": "go2/gon2",
    "\u7B35": "faan6",
    "\u7B36": "ci2",
    "\u7B37": "maau5",
    "\u7B38": "po2",
    "\u7B39": "sai3",
    "\u7B3A": "zin1",
    "\u7B3B": "kung4",
    "\u7B3C": "lung4/lung2/lung5",
    "\u7B3D": "ming5",
    "\u7B3E": "bin1",
    "\u7B3F": "lok3",
    "\u7B40": "gai3",
    "\u7B41": "kuk1",
    "\u7B42": "ci4",
    "\u7B43": "jan1",
    "\u7B44": "jiu6",
    "\u7B45": "sin2",
    "\u7B46": "bat1",
    "\u7B47": "kung4",
    "\u7B48": "kut3/kwut3",
    "\u7B49": "dang2",
    "\u7B4A": "gaau2/gaau3",
    "\u7B4B": "gan1",
    "\u7B4C": "cyun4",
    "\u7B4D": "seon2",
    "\u7B4E": "jyu4",
    "\u7B4F": "fat6",
    "\u7B50": "hong1/kwaang1",
    "\u7B51": "zuk1",
    "\u7B52": "tung4/tung1/tung2",
    "\u7B53": "gai1",
    "\u7B54": "daap3",
    "\u7B55": "hang4/hong4",
    "\u7B56": "caak3",
    "\u7B57": "zung6",
    "\u7B58": "kau3",
    "\u7B59": "loi4",
    "\u7B5A": "bat1",
    "\u7B5B": "sai1",
    "\u7B5C": "dong1",
    "\u7B5D": "zang1/zaang1",
    "\u7B5E": "caak3",
    "\u7B5F": "fu1",
    "\u7B60": "wan4/gwan1",
    "\u7B61": "seoi5",
    "\u7B62": "paa4",
    "\u7B63": "lei4",
    "\u7B64": "long4",
    "\u7B65": "geoi2",
    "\u7B66": "gun2/gwun2",
    "\u7B67": "gaan2",
    "\u7B68": "ham4",
    "\u7B69": "tung4/tung2",
    "\u7B6A": "haap6",
    "\u7B6B": "zi3",
    "\u7B6C": "sing4",
    "\u7B6D": "syun3",
    "\u7B6E": "sai6",
    "\u7B6F": "zyu6/zyu3",
    "\u7B70": "zok6",
    "\u7B71": "siu2/siu6",
    "\u7B72": "saau1",
    "\u7B73": "ting4",
    "\u7B74": "caak3/gaap3",
    "\u7B75": "jin4",
    "\u7B76": "gou3",
    "\u7B77": "faai3/faai2",
    "\u7B78": "gon2",
    "\u7B79": "cau4/cau2",
    "\u7B7A": "hong1",
    "\u7B7B": "gaang3",
    "\u7B7C": "wan4",
    "\u7B7D": "ng4/m4",
    "\u7B7E": "cim1",
    "\u7B7F": "siu2/siu6",
    "\u7B80": "gaan2",
    "\u7B81": "pau4",
    "\u7B82": "loi4",
    "\u7B83": "zau1",
    "\u7B84": "paai4/bei6",
    "\u7B85": "bei3/bai3",
    "\u7B86": "bei6",
    "\u7B87": "go3",
    "\u7B88": "ci4",
    "\u7B89": "gwaai2",
    "\u7B8A": "jyu1",
    "\u7B8B": "zin1",
    "\u7B8C": "dou3",
    "\u7B8D": "ku1/kwu1",
    "\u7B8E": "ci4",
    "\u7B8F": "zang1/zaang1",
    "\u7B90": "zing1/sin6",
    "\u7B91": "saap3/zit6",
    "\u7B92": "zau2/zaau2",
    "\u7B93": "luk6/luk1",
    "\u7B94": "bok6/bok2",
    "\u7B95": "gei1",
    "\u7B96": "lam4",
    "\u7B97": "syun3",
    "\u7B98": "kwan3/kwan2",
    "\u7B99": "fuk6",
    "\u7B9A": "zaap3/zaat3",
    "\u7B9B": "gu1/gwu1",
    "\u7B9C": "hung1",
    "\u7B9D": "kim4",
    "\u7B9E": "hyun1",
    "\u7B9F": "kwan2/kwan3",
    "\u7BA0": "seoi4/ceoi4",
    "\u7BA1": "gun2/gwun2",
    "\u7BA2": "jyun1",
    "\u7BA3": "caak3",
    "\u7BA4": "zyut6",
    "\u7BA5": "bai1",
    "\u7BA6": "zaak3",
    "\u7BA7": "haap6",
    "\u7BA8": "tok3",
    "\u7BA9": "lo4/lo1/lo2",
    "\u7BAA": "daan1",
    "\u7BAB": "siu1",
    "\u7BAC": "joek6",
    "\u7BAD": "zin3",
    "\u7BAE": "hyun1",
    "\u7BAF": "bin1",
    "\u7BB0": "seon2",
    "\u7BB1": "soeng1",
    "\u7BB2": "sin2",
    "\u7BB3": "ping4",
    "\u7BB4": "zam1",
    "\u7BB5": "sing2/sing1",
    "\u7BB6": "wu4",
    "\u7BB7": "ji4",
    "\u7BB8": "zyu6/zyu3",
    "\u7BB9": "ak1/ngak1",
    "\u7BBA": "ceon2",
    "\u7BBB": "leot6",
    "\u7BBC": "uk1/nguk1",
    "\u7BBD": "dung2",
    "\u7BBE": "sok3/siu1",
    "\u7BBF": "zaap6",
    "\u7BC0": "zit3",
    "\u7BC1": "wong4",
    "\u7BC2": "sing1",
    "\u7BC3": "mei6",
    "\u7BC4": "faan6",
    "\u7BC5": "cyun4/syun4",
    "\u7BC6": "syun6",
    "\u7BC7": "pin1",
    "\u7BC8": "fung1",
    "\u7BC9": "zuk1",
    "\u7BCA": "hung4",
    "\u7BCB": "haap6",
    "\u7BCC": "hau4",
    "\u7BCD": "cau1",
    "\u7BCE": "miu5",
    "\u7BCF": "ham3",
    "\u7BD0": "ku1/kwu1",
    "\u7BD1": "gwai6",
    "\u7BD2": "sik6",
    "\u7BD3": "lau5",
    "\u7BD4": "wan4",
    "\u7BD5": "hap6",
    "\u7BD6": "tong4",
    "\u7BD7": "wok6/jyut6",
    "\u7BD8": "cau1",
    "\u7BD9": "gou1",
    "\u7BDA": "fei2",
    "\u7BDB": "joek6",
    "\u7BDC": "zing1",
    "\u7BDD": "gau1/kau1",
    "\u7BDE": "nit6/lit6",
    "\u7BDF": "sin3",
    "\u7BE0": "siu2/siu6",
    "\u7BE1": "saan3",
    "\u7BE2": "gung1/lung5",
    "\u7BE3": "pong4",
    "\u7BE4": "duk1",
    "\u7BE5": "leot6",
    "\u7BE6": "bei6/bei2/bei1",
    "\u7BE7": "zuk1",
    "\u7BE8": "ceoi4/cyu4",
    "\u7BE9": "sai1",
    "\u7BEA": "ci4",
    "\u7BEB": "zuk1",
    "\u7BEC": "coeng1",
    "\u7BED": "lung4",
    "\u7BEE": "laam4/laam2",
    "\u7BEF": "zin1",
    "\u7BF0": "bou6",
    "\u7BF1": "lei4/lei1",
    "\u7BF2": "wai6/seoi6",
    "\u7BF3": "bat1",
    "\u7BF4": "dek6",
    "\u7BF5": "cung1",
    "\u7BF6": "jin1",
    "\u7BF7": "pung4",
    "\u7BF8": "caam2/cam1/zaam1",
    "\u7BF9": "zaan6/zyun2",
    "\u7BFA": "paai4",
    "\u7BFB": "piu3",
    "\u7BFC": "dau1",
    "\u7BFD": "jyu5",
    "\u7BFE": "mit6",
    "\u7BFF": "tyun4/zyun1",
    "\u7C00": "zaak3",
    "\u7C01": "si1",
    "\u7C02": "gwok3/gok3",
    "\u7C03": "jyu4/ji4",
    "\u7C04": "wu6",
    "\u7C05": "caan2",
    "\u7C06": "kau3",
    "\u7C07": "cuk1",
    "\u7695": "bik1",
    "\u7696": "wun2/wun5",
    "\u7697": "cau4",
    "\u7698": "sin3",
    "\u7699": "sik1",
    "\u769A": "ngoi2/oi2/ngoi4/oi4/ji4",
    "\u769B": "kiu5",
    "\u769C": "hou6",
    "\u769D": "fong2",
    "\u769E": "hou6",
    "\u769F": "caak3",
    "\u76A0": "ceoi3",
    "\u76A1": "hou6",
    "\u76A2": "hiu2",
    "\u76A3": "jip6",
    "\u76A4": "po4",
    "\u76A5": "hou6",
    "\u76A6": "giu2",
    "\u76A7": "oi3/ngoi3",
    "\u76A8": "sing1",
    "\u76A9": "fong2",
    "\u76AA": "lik6",
    "\u76AB": "piu2/piu5",
    "\u76AC": "hok6",
    "\u76AD": "zoek3/ziu3/ziu6",
    "\u76AE": "pei4/pei2",
    "\u76AF": "gon2",
    "\u76B0": "paau3",
    "\u76B1": "zau3/caau4",
    "\u76B2": "gwan1",
    "\u76B3": "kau4",
    "\u76B4": "seon1/ceon1",
    "\u76B5": "zoek3/coek3",
    "\u76B6": "zaa1",
    "\u76B7": "gu2/gwu2",
    "\u76B8": "gwan1",
    "\u76B9": "gwan1",
    "\u76BA": "zau3/caau4",
    "\u76BB": "zaa1",
    "\u76BC": "gu2/gwu2",
    "\u76BD": "zin2",
    "\u76BE": "duk6",
    "\u76BF": "ming5/ming2",
    "\u76C0": "hei2",
    "\u76C1": "jing4",
    "\u76C2": "jyu4/jyu1",
    "\u76C3": "bui1",
    "\u76C4": "diu3",
    "\u76C5": "zung1",
    "\u76C6": "pun4/pun2",
    "\u76C7": "hap6",
    "\u76C8": "jing4/jing2",
    "\u76C9": "wo4",
    "\u76CA": "jik1",
    "\u76CB": "but3",
    "\u76CC": "wun2",
    "\u76CD": "hap6",
    "\u76CE": "ong3/ngong3/ong2/ngong2/on1/ngon1",
    "\u76CF": "zaan2",
    "\u76D0": "jim4/jim1/jim6",
    "\u76D1": "gaam1/gaam3",
    "\u76D2": "hap6/hap2/haap6",
    "\u76D3": "jyu1",
    "\u76D4": "kwai1",
    "\u76D5": "faan3",
    "\u76D6": "goi3/koi3/hap1/hap6/gap3",
    "\u76D7": "dou6",
    "\u76D8": "pun4/pun2",
    "\u76D9": "fu2",
    "\u76DA": "kau4",
    "\u76DB": "sing6/sing4/sing2",
    "\u76DC": "dou6",
    "\u76DD": "luk6",
    "\u76DE": "zaan2",
    "\u76DF": "mang4/ming4",
    "\u76E0": "lai4",
    "\u76E1": "zeon6",
    "\u76E2": "gwik1",
    "\u76E3": "gaam1/gaam3",
    "\u76E4": "pun4/pun2",
    "\u76E5": "gun3/gwun3/fun2",
    "\u76E6": "am1/ngam1",
    "\u76E7": "lou4/lou2",
    "\u76E8": "seoi5/so2/seoi2",
    "\u76E9": "zau1",
    "\u76EA": "dong6",
    "\u76EB": "am1/ngam1",
    "\u76EC": "gu2/gwu2",
    "\u76ED": "leoi6/lai6",
    "\u76EE": "muk6",
    "\u76EF": "ding1/deng1",
    "\u76F0": "gon3",
    "\u76F1": "heoi1",
    "\u76F2": "maang4/maang1/maang2",
    "\u76F3": "maang4/mong6",
    "\u76F4": "zik6/zik2",
    "\u76F5": "hei3",
    "\u76F6": "jyun5",
    "\u76F7": "jyun4",
    "\u76F8": "soeng1/soeng3/soeng2",
    "\u76F9": "deon6",
    "\u76FA": "jan1",
    "\u76FB": "hai6",
    "\u76FC": "paan3",
    "\u76FD": "fung1",
    "\u76FE": "teon5",
    "\u76FF": "man4",
    "\u7700": "ming4",
    "\u7701": "saang2/sing2",
    "\u7702": "si6",
    "\u7703": "wan4",
    "\u7704": "min5",
    "\u7705": "paan1",
    "\u7706": "fong2",
    "\u7707": "miu5",
    "\u7708": "daam1",
    "\u7709": "mei4/mei2",
    "\u770A": "mou6",
    "\u770B": "hon3/hon1",
    "\u770C": "jyun6",
    "\u770D": "kau1",
    "\u770E": "si6",
    "\u770F": "ong1/ngong1",
    "\u7710": "zing1",
    "\u7711": "jiu2",
    "\u7712": "san1",
    "\u7713": "kut3/kwut3",
    "\u7714": "daap6",
    "\u7715": "zan2",
    "\u7716": "fong3",
    "\u7717": "geoi1",
    "\u7718": "san6",
    "\u7719": "ci3/ji4",
    "\u771A": "saang2",
    "\u771B": "mui6",
    "\u771C": "mut6/mit6",
    "\u771D": "cyu5/ning5/ling5",
    "\u771E": "zan1",
    "\u771F": "zan1",
    "\u7720": "min4",
    "\u7721": "si6",
    "\u7722": "jyun1",
    "\u7723": "dit6",
    "\u7724": "nik1/lik1",
    "\u7725": "zi6/zaai6",
    "\u7726": "zi6/zaai6",
    "\u7727": "ciu2",
    "\u7728": "zaap3/zaam2",
    "\u7729": "jyun6/jyun4/waan6",
    "\u772A": "bing2",
    "\u772B": "mai5",
    "\u772C": "lung4",
    "\u772D": "kwai4/seoi1",
    "\u772E": "tung4",
    "\u772F": "mai5/mei1/mai4/mi1/mei6",
    "\u7730": "dit6",
    "\u7731": "ji4",
    "\u7732": "nei6/lei6/ngak1/ak1/ngaak1/aak1",
    "\u7733": "ming4",
    "\u7734": "seon1/hyun3/jyun6/seon3",
    "\u7735": "ci1",
    "\u7736": "kwaang1/hong1",
    "\u7737": "gyun3",
    "\u7738": "mau4",
    "\u7739": "zan2",
    "\u773A": "tiu3",
    "\u773B": "joeng4",
    "\u773C": "ngaan5/aan5/ngaan2/aan2",
    "\u773D": "mak6",
    "\u773E": "zung3",
    "\u773F": "mak6",
    "\u7740": "zoek6/zoek3",
    "\u7741": "zang1/zaang1",
    "\u7742": "mei4",
    "\u7743": "so1/zeon3",
    "\u7744": "ciu4/saau3",
    "\u7745": "hon6/hon5",
    "\u7746": "wun2",
    "\u7747": "tai2/dai6",
    "\u7748": "cing2",
    "\u7749": "co4",
    "\u774A": "gyun3",
    "\u774B": "ngo4/o4",
    "\u774C": "maan5",
    "\u774D": "jin2/jin5",
    "\u774E": "hei1",
    "\u774F": "kwan3",
    "\u7750": "loi6",
    "\u7751": "gim2/lim4",
    "\u7752": "sim2/sip3",
    "\u7753": "tin5",
    "\u7754": "gwan3",
    "\u7755": "jyun2/waan1/wun1",
    "\u7756": "ling6",
    "\u7757": "sik1",
    "\u7758": "king4",
    "\u7759": "lit6",
    "\u775A": "ngaai4/aai4",
    "\u775B": "zing1",
    "\u775C": "zang1/zaang1",
    "\u775D": "lei4",
    "\u775E": "loi6",
    "\u775F": "seoi6",
    "\u7760": "gyun3",
    "\u7761": "seoi6",
    "\u7762": "seoi1",
    "\u7763": "duk1",
    "\u7764": "pai5",
    "\u7765": "pai5/pei5",
    "\u7766": "muk6",
    "\u7767": "fan1",
    "\u7768": "ngai6/ai6",
    "\u7769": "luk1/luk6",
    "\u776A": "jik6",
    "\u776B": "zit6",
    "\u776C": "coi2",
    "\u776D": "zau2",
    "\u776E": "jyu4",
    "\u776F": "fan1",
    "\u7770": "maat3",
    "\u7771": "haa6",
    "\u7772": "sing2",
    "\u7773": "fui1",
    "\u7774": "gwan3",
    "\u7775": "zoi1",
    "\u7776": "ceon2",
    "\u7777": "gin1",
    "\u7778": "mei1",
    "\u7779": "dou2",
    "\u777A": "hau4/hau1",
    "\u777B": "hyun1",
    "\u777C": "tin3",
    "\u777D": "kwai4",
    "\u777E": "gou1",
    "\u777F": "jeoi6",
    "\u7780": "mau6",
    "\u7781": "gwik1",
    "\u7782": "fat6",
    "\u7783": "wat1",
    "\u7784": "miu4",
    "\u7785": "cau2",
    "\u7786": "gwai3/kui2/kwui2",
    "\u7787": "mai5/mei1/mai4/mi1",
    "\u7788": "jung2",
    "\u7789": "kau3",
    "\u778A": "dong6",
    "\u778B": "can1/zan1",
    "\u778C": "hap6/hap1",
    "\u778D": "sau2",
    "\u778E": "hat6",
    "\u778F": "king4",
    "\u7790": "mok6",
    "\u7791": "ming4/ming2/ming5",
    "\u7792": "mun4",
    "\u7793": "fan3",
    "\u7794": "zaak3",
    "\u7795": "zoeng3",
    "\u7796": "ai3/ngai3",
    "\u7797": "diu1",
    "\u7798": "kau1",
    "\u7799": "mok6",
    "\u779A": "seon3",
    "\u779B": "cung1",
    "\u779C": "lau1/lau4",
    "\u779D": "ci1",
    "\u779E": "mun4",
    "\u779F": "piu5",
    "\u77A0": "caang1/tong4",
    "\u77A1": "kwai1",
    "\u77A2": "mung4/mung1",
    "\u77A3": "waan6",
    "\u77A4": "seon4/seon3",
    "\u77A5": "pit3",
    "\u77A6": "hei1",
    "\u77A7": "ciu4",
    "\u77A8": "pok3",
    "\u77A9": "zuk1",
    "\u77AA": "dang1/dang6",
    "\u77AB": "sam2",
    "\u77AC": "seon3",
    "\u77AD": "liu4/liu5",
    "\u77AE": "cit3",
    "\u77AF": "gaan3/haan4",
    "\u77B0": "ham3",
    "\u77B1": "jip6",
    "\u77B2": "hyut3",
    "\u77B3": "tung4",
    "\u77B4": "mou4",
    "\u77B5": "leon4",
    "\u77B6": "gwai3/kui2/kwui2",
    "\u77B7": "gaan3",
    "\u77B8": "jip6",
    "\u77B9": "oi3/ngoi3",
    "\u77BA": "wai3",
    "\u77BB": "zim1",
    "\u77BC": "gim2/lim4",
    "\u77BD": "gu2/gwu2",
    "\u77BE": "ziu3",
    "\u77BF": "keoi4/geoi3",
    "\u77C0": "mei4",
    "\u77C1": "cau2",
    "\u77C2": "sou3/cou3",
    "\u77C3": "ning5/ling5",
    "\u77C4": "fan1",
    "\u77C5": "jiu6",
    "\u77C6": "fok3",
    "\u77C7": "mung4/mung1",
    "\u77C8": "min4",
    "\u77C9": "pan4",
    "\u77CA": "min4",
    "\u77CB": "lai6",
    "\u77CC": "kwong3/kong3",
    "\u77CD": "fok3",
    "\u77CE": "hing3/hyun3",
    "\u77CF": "min4",
    "\u77D0": "hok6/kok3",
    "\u77D1": "lou4",
    "\u77D2": "mung4",
    "\u77D3": "lung4",
    "\u77D4": "gun3/gwun3",
    "\u77D5": "maan5",
    "\u77D6": "saai2",
    "\u77D7": "cuk1",
    "\u77D8": "tong2",
    "\u77D9": "ham3",
    "\u77DA": "zuk1",
    "\u77DB": "maau4",
    "\u77DC": "ging1/gwaan1/kan4",
    "\u77DD": "ging1",
    "\u77DE": "wat6",
    "\u77DF": "sok3",
    "\u77E0": "zaak6",
    "\u77E1": "fok3",
    "\u77E2": "ci2/si2",
    "\u77E3": "ji5",
    "\u77E4": "can2",
    "\u77E5": "zi1/zi3",
    "\u77E6": "hau4/hau6",
    "\u77E7": "can2",
    "\u77E8": "jing5",
    "\u77E9": "geoi2",
    "\u77EA": "zau1",
    "\u77EB": "giu2/kiu2",
    "\u77EC": "co4",
    "\u77ED": "dyun2",
    "\u77EE": "ai2/aai2/ngaai2/ngai2",
    "\u77EF": "giu2/kiu2",
    "\u77F0": "zang1",
    "\u77F1": "wok6/wok3",
    "\u77F2": "baa6",
    "\u77F3": "sek6/sek2/daam3",
    "\u77F4": "deng6/ding3",
    "\u77F5": "cai3",
    "\u77F6": "gei1",
    "\u77F7": "zi2",
    "\u77F8": "gon1/gon3",
    "\u77F9": "ngat6/at6",
    "\u77FA": "zaak3/zaak6",
    "\u77FB": "ngat6/at6/fat1",
    "\u77FC": "gong1/hong1",
    "\u77FD": "zik6",
    "\u77FE": "faan4",
    "\u77FF": "kong3/kwong3",
    "\u7800": "dong6",
    "\u7801": "maa5/maa2",
    "\u7802": "saa1",
    "\u7803": "daan1",
    "\u7804": "kyut3",
    "\u7805": "lai6",
    "\u7806": "fu1",
    "\u7807": "man4",
    "\u7808": "ngo5/o5",
    "\u7809": "waak6",
    "\u780A": "kong3/hong1",
    "\u780B": "zi2",
    "\u780C": "cai3",
    "\u780D": "ham2",
    "\u780E": "gaai3",
    "\u780F": "fan1",
    "\u7810": "ngap6/ap6",
    "\u7811": "ngaa6/aa6",
    "\u7812": "pei1",
    "\u7813": "zit3",
    "\u7814": "jin4/jin6/ngaan4/aan4/gin2/gaan2",
    "\u7815": "seoi3",
    "\u7816": "zyun1",
    "\u7817": "ce1",
    "\u7818": "deon6",
    "\u7819": "ngaa5/aa5",
    "\u781A": "jin6/jin2",
    "\u781B": "gaam1",
    "\u781C": "fung1",
    "\u781D": "faat3",
    "\u781E": "mut6",
    "\u781F": "zok6/zaa3/zaa1/zaa2",
    "\u7820": "zeoi1",
    "\u7821": "juk6",
    "\u7822": "lo2/o1/ngo1",
    "\u7823": "to4",
    "\u7824": "to4",
    "\u7825": "dai2/zi2",
    "\u7826": "zaai6",
    "\u7827": "zam1",
    "\u7828": "ak1/ngak1",
    "\u7829": "fat1/fai3",
    "\u782A": "mou5",
    "\u782B": "zyu2/cyu5",
    "\u782C": "laap6/laa1",
    "\u782D": "bin1/bin2",
    "\u782E": "nou5/lou5/nou4/lou4",
    "\u782F": "ping1",
    "\u7830": "ping1",
    "\u7831": "leon4",
    "\u7832": "paau3",
    "\u7833": "laak6",
    "\u7834": "po3",
    "\u7835": "but3/but1",
    "\u7836": "paak3",
    "\u7837": "san1",
    "\u7838": "zaap3",
    "\u7839": "ngaai6/aai6",
    "\u783A": "lai6",
    "\u783B": "lung4",
    "\u783C": "tung4",
    "\u783D": "jung6",
    "\u783E": "lik1/lok6",
    "\u783F": "kong3",
    "\u7840": "co2",
    "\u7841": "hang1/hing3",
    "\u7842": "cyun4",
    "\u7843": "zyu1",
    "\u7844": "hong1",
    "\u7845": "gwai1",
    "\u7846": "ngap6/ap6",
    "\u7847": "naau4/laau4",
    "\u7848": "kit3",
    "\u7849": "leot6",
    "\u784A": "ngai5/ai5",
    "\u784B": "ngoi6/oi6",
    "\u784C": "gok3/lok6/lok3",
    "\u784D": "haan6",
    "\u784E": "jing4",
    "\u784F": "jin4/jin6/ngaan4/aan4/gin2/gaan2",
    "\u7850": "dung6",
    "\u7851": "ping1",
    "\u7852": "sai1",
    "\u7853": "lou5",
    "\u7854": "hung4",
    "\u7855": "sek6",
    "\u7856": "hap6/haap6/gip3",
    "\u7857": "haau1",
    "\u7858": "wui4",
    "\u7859": "wai3/oi4/ngoi4/hoi2",
    "\u785A": "kiu4",
    "\u785B": "zik1",
    "\u785C": "hang1/hing3",
    "\u785D": "siu1",
    "\u785E": "kok3",
    "\u785F": "cin3",
    "\u7860": "long4",
    "\u7861": "wang4/gwang1",
    "\u7862": "jyu4",
    "\u7863": "haau1",
    "\u7864": "hap6/haap6/gip3",
    "\u7865": "mong5",
    "\u7866": "lok6",
    "\u7867": "jung5",
    "\u7868": "ce1",
    "\u7869": "zit3",
    "\u786A": "ngo4/o4",
    "\u786B": "lau4",
    "\u786C": "ngaang6/aang6/ngaang2/aang2",
    "\u786D": "mong4",
    "\u786E": "kok3",
    "\u786F": "jin6/jin2",
    "\u7870": "saa1",
    "\u7871": "kwan2",
    "\u7872": "juk6",
    "\u7873": "cek3",
    "\u7874": "faa1",
    "\u7875": "lou5",
    "\u7876": "cam2",
    "\u7877": "gaan2",
    "\u7878": "joek6",
    "\u7879": "sung1",
    "\u787A": "zoek3",
    "\u787B": "hang1",
    "\u787C": "paang4/pang4",
    "\u787D": "jim1",
    "\u787E": "zeoi6",
    "\u787F": "hung1",
    "\u7880": "cang4",
    "\u7881": "gei1/kei4",
    "\u7882": "zung3",
    "\u7883": "cing3",
    "\u7884": "lam4",
    "\u7885": "kwan1",
    "\u7886": "bo1",
    "\u7887": "ding3",
    "\u7888": "man4",
    "\u7889": "diu1",
    "\u788A": "zin1",
    "\u788B": "ho6",
    "\u788C": "luk1/luk6",
    "\u788D": "ngoi6/oi6",
    "\u788E": "seoi3/seoi2",
    "\u788F": "coek3",
    "\u7890": "ling4",
    "\u7891": "bei1",
    "\u7892": "jam4",
    "\u7893": "deoi3",
    "\u7894": "mou5",
    "\u7895": "kei4",
    "\u7896": "leon5",
    "\u7897": "wun2",
    "\u7898": "din2/din1",
    "\u7899": "naau4/laau4/gong1",
    "\u789A": "pui5/bui3",
    "\u789B": "zik1/zaat3",
    "\u789C": "cam2",
    "\u789D": "jyun5",
    "\u789E": "ngaam4/aam4",
    "\u789F": "dip6/dip2",
    "\u78A0": "ding3",
    "\u78A1": "duk6",
    "\u78A2": "to4",
    "\u78A3": "kit3",
    "\u78A4": "jing1",
    "\u78A5": "bin2",
    "\u78A6": "haak3",
    "\u78A7": "bik1",
    "\u78A8": "wai3/wai2/wui2",
    "\u78A9": "sek6",
    "\u78AA": "zam1",
    "\u78AB": "dyun3",
    "\u78AC": "haa4",
    "\u78AD": "dong6",
    "\u78AE": "tai4",
    "\u78AF": "nou5/lou5",
    "\u78B0": "pung3",
    "\u78B1": "gaan2",
    "\u78B2": "dai3",
    "\u78B3": "taan3",
    "\u78B4": "zaa1/caa4/caa1",
    "\u78B5": "zing1",
    "\u78B6": "kai3",
    "\u78B7": "seon5",
    "\u78B8": "fung1",
    "\u78B9": "syun4",
    "\u78BA": "kok3",
    "\u78BB": "kok3",
    "\u78BC": "maa5/maa2",
    "\u78BD": "gung1",
    "\u78BE": "zin2/nin5/lin5",
    "\u78BF": "seot1",
    "\u78C0": "ngaak6/aak6",
    "\u78C1": "ci4",
    "\u78C2": "lau4",
    "\u78C3": "si1",
    "\u78C4": "tong4",
    "\u78C5": "bong6/bong2/pong4",
    "\u78C6": "waat6",
    "\u78C7": "pei1",
    "\u78C8": "faai3",
    "\u78C9": "song2",
    "\u78CA": "leoi5",
    "\u78CB": "co1",
    "\u78CC": "tin4",
    "\u78CD": "git3",
    "\u78CE": "kai1",
    "\u78CF": "lim4/him1",
    "\u78D0": "pun4",
    "\u78D1": "wai3/oi4/ngoi4/hoi2",
    "\u78D2": "wan5",
    "\u78D3": "deoi1",
    "\u78D4": "zaak6/zaak3",
    "\u78D5": "hap6/ham2",
    "\u78D6": "laap6/laa1",
    "\u78D7": "zyun1",
    "\u78D8": "jiu4",
    "\u78D9": "gwan2",
    "\u78DA": "zyun1",
    "\u78DB": "caam4",
    "\u78DC": "zai3/cai3",
    "\u78DD": "ngou4/ou4",
    "\u78DE": "paang1",
    "\u78DF": "luk6",
    "\u78E0": "lou5",
    "\u78E1": "ham3",
    "\u78E2": "cong2",
    "\u78E3": "cam2",
    "\u78E4": "jan2",
    "\u78E5": "leoi5",
    "\u78E6": "biu1",
    "\u78E7": "zik1/zaat3",
    "\u78E8": "mo4/mo2/mo6",
    "\u78E9": "cik1",
    "\u78EA": "ceoi4",
    "\u78EB": "zung1",
    "\u78EC": "hing3",
    "\u78ED": "coek3",
    "\u78EE": "leon4",
    "\u78EF": "gei1",
    "\u78F0": "sin6",
    "\u78F1": "lou4",
    "\u78F2": "keoi4",
    "\u78F3": "zang1",
    "\u78F4": "dang3",
    "\u78F5": "gaan3",
    "\u78F6": "sik1",
    "\u78F7": "leon4/leon6",
    "\u78F8": "ding3",
    "\u78F9": "taam2",
    "\u78FA": "wong4",
    "\u78FB": "pun4/bo1",
    "\u78FC": "zaap6",
    "\u78FD": "haau1",
    "\u78FE": "dai1",
    "\u78FF": "lik6",
    "\u7900": "gaan3",
    "\u7901": "ziu1",
    "\u7902": "hei1",
    "\u7903": "zoeng2",
    "\u7904": "kiu4",
    "\u7905": "deon1",
    "\u7906": "him2",
    "\u7907": "juk1",
    "\u7908": "zeoi6",
    "\u7909": "hat6",
    "\u790A": "hak1",
    "\u790B": "zaak6",
    "\u790C": "leoi6/leoi5",
    "\u790D": "kit3",
    "\u790E": "co2",
    "\u790F": "jap6",
    "\u7910": "kok3",
    "\u7911": "dong2",
    "\u7912": "ngai5/ai5",
    "\u7913": "goeng1",
    "\u7914": "pik1",
    "\u7915": "pik1",
    "\u7916": "jyu6",
    "\u7917": "pan1",
    "\u7918": "ngap6/ap6",
    "\u7919": "ngoi6/oi6",
    "\u791A": "hap6",
    "\u791B": "laam4",
    "\u791C": "jyu6",
    "\u791D": "jyun5",
    "\u791E": "mung4",
    "\u791F": "paau3",
    "\u7920": "ci4",
    "\u7921": "bok6",
    "\u7922": "joeng5",
    "\u7923": "maat3",
    "\u7924": "caat3",
    "\u7925": "jin4",
    "\u7926": "kong3/kwong3",
    "\u7927": "leoi6/leoi5",
    "\u7928": "leoi5",
    "\u7929": "zat1/zi3/zat6",
    "\u792A": "lai6",
    "\u73D5": "lai6",
    "\u73D6": "gwong1/gong1",
    "\u73D7": "sin1",
    "\u73D8": "zau1",
    "\u73D9": "gung2",
    "\u73DA": "jin1",
    "\u73DB": "jau3",
    "\u73DC": "joeng4",
    "\u73DD": "heoi2",
    "\u73DE": "lok3",
    "\u73DF": "suk1",
    "\u73E0": "zyu1",
    "\u73E1": "kam4",
    "\u73E2": "ngan4/an4",
    "\u73E3": "seon1",
    "\u73E4": "bou2",
    "\u73E5": "nei6/lei6/ji5",
    "\u73E6": "hoeng3",
    "\u73E7": "jiu4",
    "\u73E8": "hap6",
    "\u73E9": "hang4",
    "\u73EA": "gwai1",
    "\u73EB": "cung1",
    "\u73EC": "seot1",
    "\u73ED": "baan1",
    "\u73EE": "pui3",
    "\u73EF": "lou5",
    "\u73F0": "dong1",
    "\u73F1": "jing1",
    "\u73F2": "wan4/fai1",
    "\u73F3": "man4",
    "\u73F4": "ngo4/o4",
    "\u73F5": "cing4",
    "\u73F6": "dai6",
    "\u73F7": "mou5",
    "\u73F8": "ng4/m4",
    "\u73F9": "sing4",
    "\u73FA": "gwan6",
    "\u73FB": "mui4",
    "\u73FC": "bui3",
    "\u73FD": "ting5/ting2",
    "\u73FE": "jin6",
    "\u73FF": "cuk1",
    "\u7400": "ham3",
    "\u7401": "syun4",
    "\u7402": "jin4",
    "\u7403": "kau4",
    "\u7404": "jyun5",
    "\u7405": "long4",
    "\u7406": "lei5/lei1",
    "\u7407": "sau3",
    "\u7408": "fau4",
    "\u7409": "lau4",
    "\u740A": "ngaa4/aa4/je4",
    "\u740B": "hei1",
    "\u740C": "ling4",
    "\u740D": "lei4/lei1",
    "\u740E": "zeon3/zeon1",
    "\u740F": "lin5/lin4",
    "\u7410": "so2",
    "\u7411": "ciu3",
    "\u7412": "fung1",
    "\u7413": "jyun4",
    "\u7414": "din6",
    "\u7415": "pan4",
    "\u7416": "zaan2",
    "\u7417": "ceoi3",
    "\u7418": "man4",
    "\u7419": "wik6",
    "\u741A": "geoi1",
    "\u741B": "sam1",
    "\u741C": "loi4",
    "\u741D": "man4",
    "\u741E": "sing3",
    "\u741F": "wai4",
    "\u7420": "tin2",
    "\u7421": "cuk1",
    "\u7422": "doek3",
    "\u7423": "bung2",
    "\u7424": "zang1/zaang1",
    "\u7425": "fu2",
    "\u7426": "kei4/kei2",
    "\u7427": "ok3/ngok3",
    "\u7428": "kwan1/gwan1",
    "\u7429": "coeng1",
    "\u742A": "kei4",
    "\u742B": "bung2",
    "\u742C": "jyun2",
    "\u742D": "luk6",
    "\u742E": "cung4",
    "\u742F": "gun2/gwun2",
    "\u7430": "jim5",
    "\u7431": "diu1",
    "\u7432": "pui3",
    "\u7433": "lam4",
    "\u7434": "kam4/kam2",
    "\u7435": "pei4",
    "\u7436": "paa4/paa2",
    "\u7437": "kyut3",
    "\u7438": "zoek3",
    "\u7439": "kam4",
    "\u743A": "faat3",
    "\u743B": "cyun4",
    "\u743C": "king4",
    "\u743D": "dou2",
    "\u743E": "gaai3",
    "\u743F": "wan4/fai1",
    "\u7440": "jyu5",
    "\u7441": "mou6/mui6",
    "\u7442": "mei4",
    "\u7443": "ceon1",
    "\u7444": "syun1",
    "\u7445": "tai4",
    "\u7446": "sing1",
    "\u7447": "doi6",
    "\u7448": "jau4",
    "\u7449": "man4",
    "\u744A": "zam1",
    "\u744B": "wai5",
    "\u744C": "jyun5",
    "\u744D": "wun6",
    "\u744E": "haai4",
    "\u744F": "cyun1",
    "\u7450": "zin2",
    "\u7451": "syun6",
    "\u7452": "coeng3/dong6/joeng4",
    "\u7453": "lin6",
    "\u7454": "cyun4",
    "\u7455": "haa4",
    "\u7456": "dyun3",
    "\u7457": "jyun6",
    "\u7458": "ngaa4/aa4/je4",
    "\u7459": "nou5/lou5",
    "\u745A": "wu4",
    "\u745B": "jing1",
    "\u745C": "jyu4",
    "\u745D": "waang4",
    "\u745E": "seoi6",
    "\u745F": "sat1",
    "\u7460": "lau4",
    "\u7461": "si1",
    "\u7462": "jung4",
    "\u7463": "so2",
    "\u7464": "jiu4/jiu2",
    "\u7465": "wan1",
    "\u7466": "wu2",
    "\u7467": "zeon1",
    "\u7468": "zeon3",
    "\u7469": "jing4/jing2",
    "\u746A": "maa5",
    "\u746B": "tou1",
    "\u746C": "lau4",
    "\u746D": "tong4",
    "\u746E": "leot6",
    "\u746F": "long4",
    "\u7470": "gwai1/gwai3",
    "\u7471": "tin3/zan3",
    "\u7472": "coeng1",
    "\u7473": "co1",
    "\u7474": "gok3",
    "\u7475": "zaau2",
    "\u7476": "jiu4",
    "\u7477": "oi3/ngoi3",
    "\u7478": "ban1",
    "\u7479": "syu1",
    "\u747A": "soeng4",
    "\u747B": "kwan1",
    "\u747C": "zyun1",
    "\u747D": "cung1/cung4",
    "\u747E": "gan2",
    "\u747F": "ji1",
    "\u7480": "ceoi1/ceoi2",
    "\u7481": "cung1",
    "\u7482": "kei4",
    "\u7483": "lei4/lei1",
    "\u7484": "ging2",
    "\u7485": "so2/ziu2",
    "\u7486": "kau4",
    "\u7487": "syun4",
    "\u7488": "ngou4/ou4",
    "\u7489": "lin5/lin4",
    "\u748A": "mun4",
    "\u748B": "zoeng1",
    "\u748C": "jan4",
    "\u748D": "jip6",
    "\u748E": "jing1",
    "\u748F": "wai6",
    "\u7490": "lou6",
    "\u7491": "mou4",
    "\u7492": "dang1",
    "\u7493": "sau3",
    "\u7494": "zang1",
    "\u7495": "cam4",
    "\u7496": "keoi4",
    "\u7497": "dong6",
    "\u7498": "leon4",
    "\u7499": "liu4",
    "\u749A": "king4/kyut3",
    "\u749B": "suk1",
    "\u749C": "wong4",
    "\u749D": "gwai1",
    "\u749E": "pok3",
    "\u749F": "ging2",
    "\u74A0": "faan4",
    "\u74A1": "zeon3/zeon1",
    "\u74A2": "lau4",
    "\u74A3": "gei1",
    "\u74A4": "wai6",
    "\u74A5": "ging2",
    "\u74A6": "oi3/ngoi3",
    "\u74A7": "bik1/bik3",
    "\u74A8": "caan3",
    "\u74A9": "keoi4",
    "\u74AA": "zou2",
    "\u74AB": "dong1",
    "\u74AC": "giu2",
    "\u74AD": "gun2/gwun2",
    "\u74AE": "taan2",
    "\u74AF": "wui6",
    "\u74B0": "waan4/waan2",
    "\u74B1": "sat1",
    "\u74B2": "seoi6",
    "\u74B3": "tin4",
    "\u74B4": "co2",
    "\u74B5": "jyu4",
    "\u74B6": "zeon6",
    "\u74B7": "leoi4",
    "\u74B8": "ban1",
    "\u74B9": "sau6/suk6",
    "\u74BA": "man6",
    "\u74BB": "zeoi2",
    "\u74BC": "laam4",
    "\u74BD": "saai2",
    "\u74BE": "zai6",
    "\u74BF": "syun4",
    "\u74C0": "jyun5",
    "\u74C1": "wok6",
    "\u74C2": "koi3",
    "\u74C3": "leoi4",
    "\u74C4": "duk6",
    "\u74C5": "lik1",
    "\u74C6": "zat1",
    "\u74C7": "jau4",
    "\u74C8": "lei4/lei1",
    "\u74C9": "zaan3",
    "\u74CA": "king4",
    "\u74CB": "tik1",
    "\u74CC": "gwai1",
    "\u74CD": "ceoi4",
    "\u74CE": "laat6",
    "\u74CF": "lung4",
    "\u74D0": "lou4",
    "\u74D1": "lik6",
    "\u74D2": "zaan3",
    "\u74D3": "laan6",
    "\u74D4": "jing1",
    "\u74D5": "mei4",
    "\u74D6": "soeng1",
    "\u74D7": "king4",
    "\u74D8": "gun3/gwun3",
    "\u74D9": "dou6",
    "\u74DA": "zaan3",
    "\u74DB": "wun4",
    "\u74DC": "gwaa1",
    "\u74DD": "bok6",
    "\u74DE": "dit6",
    "\u74DF": "bok6",
    "\u74E0": "wu6/wu4/wok6",
    "\u74E1": "zap1",
    "\u74E2": "piu4",
    "\u74E3": "faan6/faan2/baan6",
    "\u74E4": "nong4/long4",
    "\u74E5": "lai6",
    "\u74E6": "ngaa5/aa5/ngaa2/aa2",
    "\u74E7": "sap6.ngaa5",
    "\u74E8": "gong1",
    "\u74E9": "cin1.ngaa5",
    "\u74EA": "baan2",
    "\u74EB": "pun4",
    "\u74EC": "fong2",
    "\u74ED": "dam2",
    "\u74EE": "ung3/ngung3",
    "\u74EF": "au1/ngau1",
    "\u74F0": "fan1.ngaa5",
    "\u74F1": "hou4.ngaa5",
    "\u74F2": "tyun4",
    "\u74F3": "wu4",
    "\u74F4": "ling4",
    "\u74F5": "ji4",
    "\u74F6": "ping4/ping2",
    "\u74F7": "ci4",
    "\u74F8": "baak3.ngaa5",
    "\u74F9": "gyun1",
    "\u74FA": "coeng4",
    "\u74FB": "ci1",
    "\u74FC": "lei5",
    "\u74FD": "dong6",
    "\u74FE": "waa1",
    "\u74FF": "pau2",
    "\u7500": "zeoi6",
    "\u7501": "ping4",
    "\u7502": "pin1",
    "\u7503": "zau3",
    "\u7504": "jan1/zan1",
    "\u7505": "lei4.ngaa5",
    "\u7506": "ci4",
    "\u7507": "aang1/ngaang1",
    "\u7508": "hei3",
    "\u7509": "haam4",
    "\u750A": "lau5",
    "\u750B": "dik1",
    "\u750C": "au1/ngau1",
    "\u750D": "mang4",
    "\u750E": "zyun1",
    "\u750F": "bong3/bong6",
    "\u7510": "leon6",
    "\u7511": "zang6",
    "\u7512": "mou5",
    "\u7513": "pik1",
    "\u7514": "daam1",
    "\u7515": "ung3/ngung3",
    "\u7516": "aang1/ngaang1",
    "\u7517": "jin5/jin2",
    "\u7518": "gam1",
    "\u7519": "doi6",
    "\u751A": "sam6/sap6",
    "\u751B": "tim4",
    "\u751C": "tim4/tim2",
    "\u751D": "hon4",
    "\u751E": "soeng4",
    "\u751F": "sang1/saang1",
    "\u7520": "cing4",
    "\u7521": "san1",
    "\u7522": "caan2",
    "\u7523": "caan2",
    "\u7524": "jeoi6/jeoi4",
    "\u7525": "sang1/saang1",
    "\u7526": "sou1",
    "\u7527": "sam1",
    "\u7528": "jung6/jung2",
    "\u7529": "lat1/seot1",
    "\u752A": "luk6",
    "\u752B": "fu2/pou2/pou1/pou3",
    "\u752C": "jung2",
    "\u752D": "bung2/bung3",
    "\u752E": "fung6/mung6",
    "\u752F": "ning4/ling4/ning6/ling6",
    "\u7530": "tin4/tin2",
    "\u7531": "jau4/jau2",
    "\u7532": "gaap3",
    "\u7533": "san1",
    "\u7534": "zaat6/zat6/zaat2",
    "\u7535": "din6",
    "\u7536": "fat6",
    "\u7537": "naam4/laam4",
    "\u7538": "din6/tin4/din1",
    "\u7539": "ping1",
    "\u753A": "ting5/ding1/ting1",
    "\u753B": "waak6/waak2/waa6/waa2",
    "\u753C": "ting5",
    "\u753D": "hyun2/zan3",
    "\u753E": "zi1/zoi1",
    "\u753F": "maang4/mang4/man4",
    "\u7540": "bei2/bei3",
    "\u7541": "bei2",
    "\u7542": "mau5",
    "\u7543": "seon4",
    "\u7544": "lau4",
    "\u7545": "coeng3",
    "\u7546": "mau5",
    "\u7547": "wan4",
    "\u7548": "faan3",
    "\u7549": "fu4",
    "\u754A": "gaang1/gang1",
    "\u754B": "tin4",
    "\u754C": "gaai3",
    "\u754D": "gaai3",
    "\u754E": "hyun2",
    "\u754F": "wai3",
    "\u7550": "fuk6",
    "\u7551": "tin4",
    "\u7552": "mau5",
    "\u7553": "cyun4",
    "\u7554": "bun6",
    "\u7555": "goeng1",
    "\u7556": "waa1",
    "\u7557": "daap3",
    "\u7558": "naam4/laam4",
    "\u7559": "lau4/lau1",
    "\u755A": "bun2",
    "\u755B": "zan2/can2",
    "\u755C": "cuk1/cuk6",
    "\u755D": "mau5",
    "\u755E": "mau5",
    "\u755F": "cak1",
    "\u7560": "tin4/zi1",
    "\u7561": "goi1",
    "\u7562": "bat1",
    "\u7563": "daap3",
    "\u7564": "zi6",
    "\u7565": "loek6/loek2",
    "\u7566": "kwai4",
    "\u7567": "loek6",
    "\u7568": "faan1",
    "\u7569": "ji1",
    "\u756A": "faan1/pun1/po4",
    "\u756B": "waak6/waak2/waa6/waa2",
    "\u756C": "jyu4/se1",
    "\u756D": "jyu4",
    "\u756E": "mau5",
    "\u756F": "zeon3",
    "\u7570": "ji6",
    "\u7571": "lau4",
    "\u7572": "se4/se1",
    "\u7573": "dip6",
    "\u7574": "cau4",
    "\u7575": "waak6",
    "\u7576": "dong1/dong3",
    "\u7577": "zyut3/zeoi3",
    "\u7578": "kei1/gei1",
    "\u7579": "jyun2",
    "\u757A": "goeng1",
    "\u757B": "sing4",
    "\u757C": "coeng4",
    "\u757D": "teon2",
    "\u757E": "leoi4",
    "\u757F": "gei1",
    "\u7580": "caap3",
    "\u7581": "lau4",
    "\u7582": "dip6",
    "\u7583": "teon2",
    "\u7584": "leon6",
    "\u7585": "goeng1",
    "\u7586": "goeng1",
    "\u7587": "cau4",
    "\u7588": "bik1",
    "\u7589": "dip6/daap6",
    "\u758A": "dip6/daap6",
    "\u758B": "ngaa5/aa5/so1/pat1",
    "\u758C": "zit3",
    "\u758D": "daan6/daan2",
    "\u758E": "so1",
    "\u758F": "so1/so3",
    "\u7590": "zi3/dai3",
    "\u7591": "ji4",
    "\u7592": "nik6/lik6/cong4/beng6.zi6.tau4",
    "\u7593": "naai5/laai5",
    "\u7594": "ding1/deng1",
    "\u7595": "bei2",
    "\u7596": "zit3",
    "\u7597": "liu4",
    "\u7598": "gong1",
    "\u7599": "gat1/ngat6/at6",
    "\u759A": "gau3",
    "\u759B": "zau2",
    "\u759C": "haa6",
    "\u759D": "saan3",
    "\u759E": "heoi1",
    "\u759F": "joek6",
    "\u75A0": "lai6",
    "\u75A1": "joeng4",
    "\u75A2": "can3/can2",
    "\u75A3": "jau4",
    "\u75A4": "baa1/baan1",
    "\u75A5": "gaai3",
    "\u75A6": "kyut3",
    "\u75A7": "kei4",
    "\u75A8": "haa1/ngaa4/aa4",
    "\u75A9": "seoi6",
    "\u75AA": "bei3",
    "\u75AB": "jik6",
    "\u75AC": "lik6/lek6",
    "\u75AD": "zung3",
    "\u75AE": "cong1",
    "\u75AF": "fung1",
    "\u75B0": "zyu3",
    "\u75B1": "paau3",
    "\u75B2": "pei4",
    "\u75B3": "gam1",
    "\u75B4": "o1/ngo1",
    "\u75B5": "ci1/ci4",
    "\u75B6": "sit3",
    "\u75B7": "zi1",
    "\u75B8": "taan2/daap3",
    "\u75B9": "can2/zan2",
    "\u75BA": "fat6",
    "\u75BB": "zi2",
    "\u75BC": "tang4/tung3",
    "\u75BD": "zeoi1",
    "\u75BE": "zat6",
    "\u75BF": "fai2/fai6/fai3/fei2",
    "\u75C0": "keoi1",
    "\u75C1": "dim3/zim1/sim1",
    "\u75C2": "gaa1",
    "\u75C3": "jin4/jyun4",
    "\u75C4": "zaa3",
    "\u75C5": "beng6/bing6",
    "\u75C6": "naat6/laat6",
    "\u75C7": "zing3/zing1",
    "\u75C8": "jung1",
    "\u75C9": "ging3/ging6",
    "\u75CA": "cyun4",
    "\u75CB": "tang4",
    "\u75CC": "tung1",
    "\u75CD": "ji4",
    "\u75CE": "gaai1",
    "\u75CF": "fui2/wai5",
    "\u75D0": "wui4",
    "\u75D1": "taan1",
    "\u75D2": "joeng5/joeng4",
    "\u75D3": "ci3",
    "\u75D4": "zi6",
    "\u75D5": "han4/han2",
    "\u75D6": "aa2/ngaa2",
    "\u75D7": "mui6",
    "\u75D8": "dau6/dau2",
    "\u75D9": "ging3/ging6",
    "\u75DA": "haau1",
    "\u75DB": "tung3",
    "\u75DC": "tuk1",
    "\u75DD": "mong4",
    "\u75DE": "pei2/mau1",
    "\u75DF": "siu1",
    "\u75E0": "syun1",
    "\u75E1": "pou1/fu1",
    "\u75E2": "lei6/lei1",
    "\u75E3": "zi3",
    "\u75E4": "co4",
    "\u75E5": "dyut6",
    "\u75E6": "ng6/m6",
    "\u75E7": "saa1",
    "\u75E8": "lou4",
    "\u75E9": "sau3",
    "\u75EA": "wun6",
    "\u75EB": "gaan2/haan4",
    "\u75EC": "jik6",
    "\u75ED": "bang1",
    "\u75EE": "zoeng3",
    "\u75EF": "gun2/gwun2",
    "\u75F0": "taam4",
    "\u75F1": "fai2/fai6/fai3/fei2/fei4/fei1",
    "\u75F2": "maa4/lam4",
    "\u75F3": "maa4/lam4",
    "\u75F4": "ci1",
    "\u75F5": "gwai3",
    "\u75F6": "din2",
    "\u75F7": "am1/ngam1",
    "\u75F8": "cai3",
    "\u75F9": "bei3",
    "\u75FA": "bei3",
    "\u75FB": "man4",
    "\u75FC": "gu3/gwu3",
    "\u75FD": "deoi1",
    "\u75FE": "o1/ngo1",
    "\u75FF": "wai2",
    "\u7600": "jyu2/jyu1",
    "\u7601": "seoi6/seoi5",
    "\u7602": "aa2/ngaa2",
    "\u7603": "zuk6/zuk1/zuk3",
    "\u7604": "cou3",
    "\u7605": "daan3/daan1",
    "\u7606": "sam3",
    "\u7607": "zung2",
    "\u7608": "zai3/kai3/gai3",
    "\u7609": "jyu5/jyu6",
    "\u760A": "hau4",
    "\u760B": "fung1",
    "\u760C": "laat3/laat6",
    "\u760D": "joeng4",
    "\u760E": "sam4",
    "\u760F": "tou4",
    "\u7610": "jyu5",
    "\u7611": "gwo1/go1",
    "\u7612": "wan4",
    "\u7613": "wun6",
    "\u7614": "fu2",
    "\u7615": "gaa2/haa4",
    "\u7616": "jam1/jam3/am1/ngam1",
    "\u7617": "ji3",
    "\u7618": "lau6",
    "\u7619": "sou3",
    "\u761A": "kyut3",
    "\u761B": "kai3/gai3/zai3",
    "\u761C": "sik1",
    "\u761D": "gwaan1",
    "\u761E": "ji3",
    "\u761F": "wan1",
    "\u7620": "zek3/zik3",
    "\u7621": "cong1",
    "\u7622": "baan1",
    "\u7623": "wui6",
    "\u7624": "lau4/lau2",
    "\u7625": "caai3/co4",
    "\u7626": "sau3",
    "\u7627": "joek6",
    "\u7628": "din1",
    "\u7629": "daap3",
    "\u762A": "bit6",
    "\u762B": "taan1/taan2",
    "\u762C": "zoeng3",
    "\u762D": "biu1",
    "\u762E": "sam3",
    "\u762F": "cuk1",
    "\u7630": "lo2",
    "\u7631": "ai3/ngai3/ji3",
    "\u7632": "zung3",
    "\u7633": "cau1",
    "\u7634": "zoeng3",
    "\u7635": "zaai3",
    "\u7636": "sau3",
    "\u7637": "zek3",
    "\u7638": "ke4",
    "\u7639": "diu3",
    "\u763A": "lau6",
    "\u763B": "lau6",
    "\u763C": "mok6/mok2",
    "\u763D": "kan4",
    "\u763E": "jan5",
    "\u763F": "jing2",
    "\u7640": "wong4",
    "\u7641": "fuk6",
    "\u7642": "liu4",
    "\u7643": "lung4",
    "\u7644": "ciu4",
    "\u7645": "lau4",
    "\u7646": "lou4",
    "\u7647": "gaan2/haan4",
    "\u7648": "fai3",
    "\u7649": "daan3/daan1",
    "\u764A": "jam3",
    "\u764B": "hok3",
    "\u764C": "ngaam4/aam4",
    "\u764D": "baan1",
    "\u764E": "gaan2/haan4",
    "\u764F": "gwaan1",
    "\u7650": "gui6/gwui6",
    "\u7651": "nung6/lung6",
    "\u7652": "jyu6",
    "\u7653": "mei4",
    "\u7654": "ji3",
    "\u7655": "jung1",
    "\u7656": "pik1",
    "\u7657": "leoi5",
    "\u7658": "lai6",
    "\u7659": "syu2",
    "\u765A": "daam3",
    "\u765B": "lam5",
    "\u765C": "din6",
    "\u765D": "lam5",
    "\u765E": "laai3",
    "\u765F": "bit6",
    "\u7660": "zek3/zik3",
    "\u7661": "ci1",
    "\u7662": "joeng5",
    "\u7663": "sin2",
    "\u7664": "zit3",
    "\u7665": "zing1",
    "\u7666": "mak6/mak2",
    "\u7667": "lik6/lek6",
    "\u7668": "fok3",
    "\u7669": "laai3",
    "\u766A": "zik1",
    "\u766B": "din1",
    "\u766C": "sin2",
    "\u766D": "jing2",
    "\u766E": "jan5",
    "\u766F": "keoi4",
    "\u7670": "jung1",
    "\u7671": "taan1/taan2",
    "\u7672": "din1",
    "\u7673": "lo2",
    "\u7674": "lyun4",
    "\u7675": "lyun4",
    "\u7676": "but6/dang1.zi6.tau4",
    "\u7677": "gon1",
    "\u7678": "gwai3",
    "\u7679": "bat6",
    "\u767A": "faat3",
    "\u767B": "dang1",
    "\u767C": "faat3",
    "\u767D": "baak6/baak2",
    "\u767E": "baak3",
    "\u767F": "ke4",
    "\u7680": "bik1",
    "\u7681": "zou6/zou3",
    "\u7682": "zou6/zou3",
    "\u7683": "maau6",
    "\u7684": "dik1",
    "\u7685": "paa1",
    "\u7686": "gaai1",
    "\u7687": "wong4",
    "\u7688": "gwai1",
    "\u7689": "cai2",
    "\u768A": "ling4",
    "\u768B": "gou1",
    "\u768C": "mut6",
    "\u768D": "zik1",
    "\u768E": "gaau2/giu2",
    "\u768F": "pang2",
    "\u7690": "gou1",
    "\u7691": "ngoi2/oi2/ngoi4/oi4/ji4",
    "\u7692": "ngo4/o4",
    "\u7693": "hou6",
    "\u7694": "hon5",
    "\u7119": "bui6",
    "\u711A": "fan4",
    "\u711B": "leon6",
    "\u711C": "kwan1",
    "\u711D": "fan3",
    "\u711E": "seon4/tan1",
    "\u711F": "sik1",
    "\u7120": "ceoi3/seoi6",
    "\u7121": "mou4/mo4",
    "\u7122": "hung1",
    "\u7123": "caau2",
    "\u7124": "fu6",
    "\u7125": "waat3",
    "\u7126": "ziu1",
    "\u7127": "cung1",
    "\u7128": "fung3",
    "\u7129": "pang4",
    "\u712A": "hung3",
    "\u712B": "jyut3/jyut6/naat3/laat3",
    "\u712C": "sik1",
    "\u712D": "king4",
    "\u712E": "jan1",
    "\u712F": "zoek3/coek3",
    "\u7130": "jim6/jim4",
    "\u7131": "jim6",
    "\u7132": "jik6",
    "\u7133": "zoek3",
    "\u7134": "juk1",
    "\u7135": "gong3",
    "\u7136": "jin4/jin2",
    "\u7137": "pei4",
    "\u7138": "hing2",
    "\u7139": "gong3",
    "\u713A": "sing1",
    "\u713B": "coeng3",
    "\u713C": "siu1",
    "\u713D": "ming4",
    "\u713E": "nam4/lam4",
    "\u713F": "gang1",
    "\u7140": "wat1",
    "\u7141": "sam4",
    "\u7142": "haak3",
    "\u7143": "kwai2",
    "\u7144": "zung2",
    "\u7145": "dyun3/dyun6",
    "\u7146": "haa6",
    "\u7147": "wai1/wan6/fai1",
    "\u7148": "fung3",
    "\u7149": "lin6",
    "\u714A": "hyun1",
    "\u714B": "sing1",
    "\u714C": "wong4",
    "\u714D": "ziu2",
    "\u714E": "zin1",
    "\u714F": "bik1",
    "\u7150": "jing1",
    "\u7151": "zyu2",
    "\u7152": "wai5",
    "\u7153": "tyun1",
    "\u7154": "sim2",
    "\u7155": "hei1",
    "\u7156": "hyun1/nyun5/lyun5",
    "\u7157": "nyun5/lyun5",
    "\u7158": "cim4",
    "\u7159": "jin1",
    "\u715A": "gwing2",
    "\u715B": "gwing2",
    "\u715C": "juk1",
    "\u715D": "mei6",
    "\u715E": "saat3",
    "\u715F": "wai6",
    "\u7160": "zaa3",
    "\u7161": "zeon6",
    "\u7162": "king4",
    "\u7163": "jau2",
    "\u7164": "mui4",
    "\u7165": "wun6",
    "\u7166": "heoi2/heoi3",
    "\u7167": "ziu3",
    "\u7168": "wui1",
    "\u7169": "faan4",
    "\u716A": "cau4",
    "\u716B": "seoi6",
    "\u716C": "joeng4/joeng6",
    "\u716D": "lit6",
    "\u716E": "zyu2",
    "\u716F": "gaai1",
    "\u7170": "cou3",
    "\u7171": "wo1",
    "\u7172": "bou1",
    "\u7173": "wu4",
    "\u7174": "wan1",
    "\u7175": "naam4/laam4",
    "\u7176": "zik6",
    "\u7177": "fo2",
    "\u7178": "pin1/bin1",
    "\u7179": "gau3",
    "\u717A": "teoi3",
    "\u717B": "tong4",
    "\u717C": "caau2",
    "\u717D": "sin3",
    "\u717E": "jan1",
    "\u717F": "bok3",
    "\u7180": "fong2",
    "\u7181": "hip3",
    "\u7182": "hei3",
    "\u7183": "mou6",
    "\u7184": "sik1",
    "\u7185": "wan1",
    "\u7186": "hap6",
    "\u7187": "huk6/kok3/hok3",
    "\u7188": "hei1",
    "\u7189": "jyun4",
    "\u718A": "hung4",
    "\u718B": "noi4/loi4",
    "\u718C": "sim3",
    "\u718D": "hung3",
    "\u718E": "jiu3",
    "\u718F": "fan1",
    "\u7190": "mik6",
    "\u7191": "lim4",
    "\u7192": "jing4",
    "\u7193": "wat1",
    "\u7194": "jung4",
    "\u7195": "gung3",
    "\u7196": "jim6",
    "\u7197": "coeng3",
    "\u7198": "lau6/liu1/lau4",
    "\u7199": "hei1",
    "\u719A": "bat1",
    "\u719B": "biu1",
    "\u719C": "zung2/cung1",
    "\u719D": "luk6",
    "\u719E": "gin1",
    "\u719F": "suk6",
    "\u71A0": "jap1/saap6",
    "\u71A1": "lau4",
    "\u71A2": "pung4",
    "\u71A3": "seoi1",
    "\u71A4": "jik6",
    "\u71A5": "tung1",
    "\u71A6": "zoek3",
    "\u71A7": "zung1",
    "\u71A8": "tong3/wan6/wat1/wai3",
    "\u71A9": "wu6",
    "\u71AA": "ji4",
    "\u71AB": "zek3",
    "\u71AC": "ngaau4/aau4/ngou4/ou4",
    "\u71AD": "wai6",
    "\u71AE": "lau5",
    "\u71AF": "hon3",
    "\u71B0": "au1/ngau1",
    "\u71B1": "jit6/jit2",
    "\u71B2": "gwing2/gang2",
    "\u71B3": "maan6",
    "\u71B4": "kwan1",
    "\u71B5": "soeng1",
    "\u71B6": "cyun3",
    "\u71B7": "zang1",
    "\u71B8": "zim1",
    "\u71B9": "hei1",
    "\u71BA": "hei1",
    "\u71BB": "jap1",
    "\u71BC": "jik6",
    "\u71BD": "siu3",
    "\u71BE": "ci3",
    "\u71BF": "wong4",
    "\u71C0": "cin2/daan6",
    "\u71C1": "jip6",
    "\u71C2": "taam4/cim4/cam4",
    "\u71C3": "jin4",
    "\u71C4": "jim6/jim4",
    "\u71C5": "cam4/cim4",
    "\u71C6": "hiu4",
    "\u71C7": "zeon3",
    "\u71C8": "dang1",
    "\u71C9": "dan6/deon6",
    "\u71CA": "san1",
    "\u71CB": "ziu1/ciu4",
    "\u71CC": "fan4",
    "\u71CD": "si1",
    "\u71CE": "liu4/liu6",
    "\u71CF": "wat6",
    "\u71D0": "leon4",
    "\u71D1": "tung4",
    "\u71D2": "siu1",
    "\u71D3": "fan4",
    "\u71D4": "faan4",
    "\u71D5": "jin3/jin2/jin1",
    "\u71D6": "cam4",
    "\u71D7": "laan6",
    "\u71D8": "mui5",
    "\u71D9": "tong3",
    "\u71DA": "jik6",
    "\u71DB": "gwing2",
    "\u71DC": "mun6",
    "\u71DD": "ging2",
    "\u71DE": "ziu3",
    "\u71DF": "jing4",
    "\u71E0": "juk1/ou2/ngou2/jyu3",
    "\u71E1": "jik6",
    "\u71E2": "hok6",
    "\u71E3": "laam4",
    "\u71E4": "taai3",
    "\u71E5": "cou3",
    "\u71E6": "caan3",
    "\u71E7": "seoi6",
    "\u71E8": "hei1",
    "\u71E9": "kok3",
    "\u71EA": "zung2",
    "\u71EB": "lim4",
    "\u71EC": "wai2",
    "\u71ED": "zuk1",
    "\u71EE": "sit3",
    "\u71EF": "ling4",
    "\u71F0": "wui1",
    "\u71F1": "ji3",
    "\u71F2": "hip3",
    "\u71F3": "ziu3",
    "\u71F4": "wui6",
    "\u71F5": "daat6",
    "\u71F6": "nung1/lung1",
    "\u71F7": "laam4",
    "\u71F8": "jyu4",
    "\u71F9": "sin2",
    "\u71FA": "huk6",
    "\u71FB": "fan1",
    "\u71FC": "zeon6/zeon2",
    "\u71FD": "cau4",
    "\u71FE": "tou4/dou6",
    "\u71FF": "soek3/jiu6",
    "\u7200": "haak1",
    "\u7201": "laam6/laam5",
    "\u7202": "biu1",
    "\u7203": "wing4",
    "\u7204": "lai6",
    "\u7205": "mak6",
    "\u7206": "baau3",
    "\u7207": "jyut3/jyut6",
    "\u7208": "leoi4",
    "\u7209": "laap6",
    "\u720A": "ngaau4/aau4/ngou4/ou4",
    "\u720B": "fan1",
    "\u720C": "kong3/kwong3",
    "\u720D": "soek3/lik1",
    "\u720E": "liu4",
    "\u720F": "lik6",
    "\u7210": "lou4/lou2",
    "\u7211": "zoek3",
    "\u7212": "liu5",
    "\u7213": "jim6/jim4/cam4/cim4",
    "\u7214": "hei1",
    "\u7215": "sit3",
    "\u7216": "lung4",
    "\u7217": "jip6",
    "\u7218": "caan1",
    "\u7219": "joeng5",
    "\u721A": "joek6",
    "\u721B": "laan6/laan2",
    "\u721C": "cung4",
    "\u721D": "zoek3/ziu3",
    "\u721E": "tung4/cung4",
    "\u721F": "gun3/gwun3",
    "\u7220": "keoi4",
    "\u7221": "cit3",
    "\u7222": "mei4",
    "\u7223": "tong2",
    "\u7224": "laan6",
    "\u7225": "zuk1",
    "\u7226": "laam5",
    "\u7227": "ling4",
    "\u7228": "cyun3",
    "\u7229": "wat1",
    "\u722A": "zaau2",
    "\u722B": "zaau2/zaau2.zi6.tau4",
    "\u722C": "paa4",
    "\u722D": "zang1/zaang1/zang3/zaang3/caang1",
    "\u722E": "paau4",
    "\u722F": "cing1",
    "\u7230": "wun4/jyun4",
    "\u7231": "oi3/ngoi3",
    "\u7232": "wai4/wai6",
    "\u7233": "wai4",
    "\u7234": "fok3",
    "\u7235": "zoek3",
    "\u7236": "fu6/fu2",
    "\u7237": "je4/je1/je2",
    "\u7238": "baa1/baa4",
    "\u7239": "de1",
    "\u723A": "je4/je1/je2",
    "\u723B": "ngaau4/aau4",
    "\u723C": "zo2",
    "\u723D": "song2",
    "\u723E": "ji5",
    "\u723F": "baan6/coeng4",
    "\u7240": "cong4",
    "\u7241": "o1/ngo1/go1",
    "\u7242": "zong1",
    "\u7243": "dip6",
    "\u7244": "coeng1",
    "\u7245": "jung4",
    "\u7246": "coeng4",
    "\u7247": "pin3/pin2",
    "\u7248": "baan2",
    "\u7249": "pun3",
    "\u724A": "ciu4",
    "\u724B": "zin1",
    "\u724C": "paai4/paai2",
    "\u724D": "duk6/duk2",
    "\u724E": "coeng1",
    "\u724F": "jyu4/tau4",
    "\u7250": "zaap6",
    "\u7251": "bin1",
    "\u7252": "dip6",
    "\u7253": "bong2",
    "\u7254": "bok3",
    "\u7255": "coeng1",
    "\u7256": "jau5",
    "\u7257": "jau5",
    "\u7258": "duk6/duk2",
    "\u7259": "ngaa4/aa4/ngaa2/aa2",
    "\u725A": "caang1",
    "\u725B": "ngau4/au4/ngau2/au2",
    "\u725C": "zo2.pong4.ngau4",
    "\u725D": "pan5",
    "\u725E": "kau1",
    "\u725F": "mau4",
    "\u7260": "taa1/to1",
    "\u7261": "maau5/mau5",
    "\u7262": "lou4/lou6",
    "\u7263": "jan6",
    "\u7264": "mong1/mong4",
    "\u7265": "fong1",
    "\u7266": "mou4/lei4",
    "\u7267": "muk6",
    "\u7268": "gong1",
    "\u7269": "mat6/mat2",
    "\u726A": "jyun6",
    "\u726B": "go1",
    "\u726C": "bui3",
    "\u726D": "sei3",
    "\u726E": "zin3",
    "\u726F": "gu2/gwu2",
    "\u7270": "jau6",
    "\u7271": "o1/ngo1",
    "\u7272": "sang1/saang1",
    "\u7273": "mau5",
    "\u7274": "dai2",
    "\u7275": "hin1",
    "\u7276": "hyun3",
    "\u7277": "cyun4",
    "\u7278": "zi6",
    "\u7279": "dak6",
    "\u727A": "hei1",
    "\u727B": "mong4",
    "\u727C": "hang1",
    "\u727D": "hin1",
    "\u727E": "ng5/m5",
    "\u727F": "guk1",
    "\u7280": "sai1",
    "\u7281": "lai4",
    "\u7282": "lai4",
    "\u7283": "bau6",
    "\u7284": "gei1/ji2",
    "\u7285": "gong1",
    "\u7286": "dat6/dak6/zik6",
    "\u7287": "ban1",
    "\u7288": "kyun4",
    "\u7289": "seon4",
    "\u728A": "duk6",
    "\u728B": "geoi6",
    "\u728C": "gaa1",
    "\u728D": "gin1/kin4",
    "\u728E": "fung1",
    "\u728F": "pin1",
    "\u7290": "fo1",
    "\u7291": "gwik1",
    "\u7292": "hou3",
    "\u7293": "co1",
    "\u7294": "hei3",
    "\u7295": "bei6",
    "\u7296": "lok3/lok6",
    "\u7297": "gaai3",
    "\u7298": "maa4",
    "\u7299": "saam1",
    "\u729A": "wai3",
    "\u729B": "mou4/lei4",
    "\u729C": "deon1",
    "\u729D": "tung4",
    "\u729E": "kiu4",
    "\u729F": "goeng6",
    "\u72A0": "ji6",
    "\u72A1": "lai6",
    "\u72A2": "duk6",
    "\u72A3": "lip6",
    "\u72A4": "bei1",
    "\u72A5": "piu1",
    "\u72A6": "bok6/baau3",
    "\u72A7": "hei1",
    "\u72A8": "cau4/cau1",
    "\u72A9": "ngai4/ai4",
    "\u72AA": "kwai4",
    "\u72AB": "cau1/cau4",
    "\u72AC": "hyun2",
    "\u72AD": "gau2.zaau2.bin1",
    "\u72AE": "bat6",
    "\u72AF": "faan6/faan2/fan6",
    "\u72B0": "kau4",
    "\u72B1": "gik1",
    "\u72B2": "caai4",
    "\u72B3": "zoek3",
    "\u72B4": "ngon6/on6/hon6/hon4",
    "\u72B5": "hat1",
    "\u72B6": "zong6/zong2",
    "\u72B7": "gwong2/gong2/kwong3/kong3",
    "\u72B8": "maa5/maa6",
    "\u72B9": "jau4",
    "\u72BA": "kong3",
    "\u72BB": "but6",
    "\u72BC": "hau3",
    "\u72BD": "ngaa6/aa6",
    "\u72BE": "ngan4/an4",
    "\u72BF": "fun1/faan1",
    "\u72C0": "zong6/zong2",
    "\u72C1": "wan5",
    "\u72C2": "kong4/kwong4",
    "\u72C3": "nau2/lau2",
    "\u72C4": "dik6/tik1",
    "\u72C5": "kong4",
    "\u72C6": "zung1",
    "\u72C7": "muk6",
    "\u72C8": "bui3",
    "\u72C9": "pei1",
    "\u72CA": "gwik1",
    "\u72CB": "ji4/ngan4/an4",
    "\u72CC": "sing1/sang1",
    "\u72CD": "paau4",
    "\u72CE": "haap6",
    "\u72CF": "to4",
    "\u72D0": "wu4",
    "\u72D1": "ling4",
    "\u72D2": "fai3/fei6/fat1",
    "\u72D3": "pei1",
    "\u72D4": "nei5/lei5",
    "\u72D5": "maa1",
    "\u72D6": "jau6",
    "\u72D7": "gau2",
    "\u72D8": "hyut3",
    "\u72D9": "zeoi1",
    "\u72DA": "daan3",
    "\u72DB": "baak3",
    "\u72DC": "gu2/gwu2",
    "\u72DD": "sin2",
    "\u72DE": "ning4/ling4",
    "\u72DF": "wun4",
    "\u72E0": "han2",
    "\u72E1": "gaau2",
    "\u72E2": "hok6",
    "\u72E3": "ziu6",
    "\u72E4": "gat1",
    "\u72E5": "seon1/seon6/ceon4",
    "\u72E6": "saan1",
    "\u72E7": "daat3",
    "\u72E8": "jung4",
    "\u72E9": "sau3/sau2",
    "\u72EA": "tung4",
    "\u72EB": "lou5",
    "\u72EC": "duk6",
    "\u72ED": "haap6/haap3/hap6/gip6",
    "\u72EE": "si1",
    "\u72EF": "kui2/kwui2",
    "\u72F0": "zang1/zaang1",
    "\u72F1": "juk6",
    "\u72F2": "syun1",
    "\u72F3": "jyu4",
    "\u72F4": "bai6",
    "\u72F5": "mong4",
    "\u72F6": "hei1",
    "\u72F7": "gyun3/gyun1",
    "\u72F8": "lei4/lei2",
    "\u72F9": "haap6/haap3/hap6/gip6",
    "\u72FA": "ngan4/an4",
    "\u72FB": "syun1",
    "\u72FC": "long4/long2",
    "\u72FD": "bui3",
    "\u72FE": "zai3",
    "\u72FF": "jin4",
    "\u7300": "saa1",
    "\u7301": "lei6",
    "\u7302": "hon5/hon6",
    "\u7303": "him2",
    "\u7304": "geng1",
    "\u7305": "paai4",
    "\u7306": "fei1",
    "\u7307": "haau1",
    "\u7308": "baa6",
    "\u7309": "kei4",
    "\u730A": "ngai4/ai4",
    "\u730B": "biu1",
    "\u730C": "ngan6/an6",
    "\u730D": "loi4",
    "\u730E": "lip6",
    "\u730F": "gin1",
    "\u7310": "goeng1",
    "\u7311": "kwan1",
    "\u7312": "jim3/aat3/ngaat3",
    "\u7313": "gwo2/go2",
    "\u7314": "zung3",
    "\u7315": "mei4/nei4/lei4",
    "\u7316": "coeng1",
    "\u7317": "ji1/ji2",
    "\u7318": "zai3",
    "\u7319": "zang1/zaang1",
    "\u731A": "ngaai4/aai4",
    "\u731B": "maang5",
    "\u731C": "caai1",
    "\u731D": "cyut3",
    "\u731E": "se3",
    "\u731F": "lip6",
    "\u7320": "din2",
    "\u7321": "lo4",
    "\u7322": "wu4",
    "\u7323": "zung1",
    "\u7324": "gwai3",
    "\u7325": "wai2/wui1",
    "\u7326": "fung1",
    "\u7327": "wo1",
    "\u7328": "jyun4",
    "\u7329": "sing1",
    "\u732A": "zyu1",
    "\u732B": "maau1",
    "\u732C": "wai6",
    "\u732D": "cyun1",
    "\u732E": "hin3",
    "\u732F": "teon1",
    "\u7330": "aat3/ngaat3/jaak3",
    "\u7331": "naau4/laau4",
    "\u7332": "hit3/hot3",
    "\u7333": "gaa1",
    "\u7334": "hau4",
    "\u7335": "bin1",
    "\u7336": "jau4",
    "\u7337": "jau4",
    "\u7338": "mei4",
    "\u7339": "zaa1",
    "\u733A": "jiu4",
    "\u733B": "syun1",
    "\u733C": "bok3/pok3",
    "\u733D": "ming4",
    "\u733E": "waat6",
    "\u733F": "jyun4",
    "\u7340": "sau1/sau2",
    "\u7341": "maa5/maa6",
    "\u7342": "wun4/jyun4",
    "\u7343": "ngoi4/oi4/daai1",
    "\u7344": "juk6",
    "\u7345": "si1",
    "\u7346": "hou4",
    "\u7347": "goeng1",
    "\u7348": "jik6",
    "\u7349": "zeon1",
    "\u734A": "cong1",
    "\u734B": "hou4",
    "\u734C": "maan6",
    "\u734D": "ging3",
    "\u734E": "zoeng2",
    "\u734F": "mok6",
    "\u7350": "zoeng1",
    "\u7351": "caam4",
    "\u7352": "ngou4/ou4",
    "\u7353": "ngou4/ou4",
    "\u7354": "hou4",
    "\u7355": "ceoi1",
    "\u7356": "ban6",
    "\u7357": "kyut3",
    "\u7358": "bai6",
    "\u7359": "bai6",
    "\u735A": "wong4",
    "\u735B": "buk1",
    "\u735C": "leon4",
    "\u735D": "wat6",
    "\u735E": "tung4/zong6",
    "\u735F": "hiu1",
    "\u7360": "liu4/lou5",
    "\u7361": "soek3",
    "\u7362": "hiu1",
    "\u7363": "sau3",
    "\u7364": "deon1",
    "\u7365": "giu3",
    "\u7366": "got3",
    "\u7367": "gyun3/gyun1",
    "\u7368": "duk6",
    "\u7369": "wai3",
    "\u736A": "kui2/kwui2",
    "\u736B": "him2",
    "\u736C": "haai5",
    "\u736D": "caat3",
    "\u736E": "sin2",
    "\u736F": "fan1",
    "\u7370": "ning4/ling4",
    "\u7371": "ban1/bin1",
    "\u7372": "wok6",
    "\u7373": "nau6/lau6",
    "\u7374": "mung4",
    "\u7375": "lip6",
    "\u7376": "naau4/laau4/nou4/lou4",
    "\u7377": "gwong2/gong2/kwong3/kong3",
    "\u7378": "sau3",
    "\u7379": "lou4",
    "\u737A": "caat3",
    "\u737B": "hin3",
    "\u737C": "mei4/nei4/lei4",
    "\u737D": "joeng4",
    "\u737E": "fun1",
    "\u737F": "naau4/laau4/nou4/lou4",
    "\u7380": "lo4",
    "\u7381": "him2",
    "\u7382": "kei4",
    "\u7383": "fok3",
    "\u7384": "jyun4",
    "\u7385": "miu6",
    "\u7386": "zi1/jyun4",
    "\u7387": "seot1/leot6/leot2",
    "\u7388": "lou4",
    "\u7389": "juk6/juk2",
    "\u738A": "suk1",
    "\u738B": "wong4/wong2/wong6",
    "\u738C": "kau4",
    "\u738D": "gaa2/gaat3",
    "\u738E": "ding1",
    "\u738F": "lak6",
    "\u7390": "baat3",
    "\u7391": "gei1",
    "\u7392": "gung1",
    "\u7393": "dik1",
    "\u7394": "cyun3/cyun1",
    "\u7395": "gon1",
    "\u7396": "gau2",
    "\u7397": "jyu1",
    "\u7398": "hei2",
    "\u7399": "jyu4",
    "\u739A": "coeng3/dong6/joeng4",
    "\u739B": "maa5",
    "\u739C": "gung1",
    "\u739D": "ng5/m5",
    "\u739E": "fu1",
    "\u739F": "man4",
    "\u73A0": "gaai3",
    "\u73A1": "ngaa4/aa4/je4",
    "\u73A2": "ban1/fan1",
    "\u73A3": "bin6",
    "\u73A4": "bung2",
    "\u73A5": "jyut6",
    "\u73A6": "kyut3",
    "\u73A7": "mun4",
    "\u73A8": "gok3",
    "\u73A9": "wun6/wun2/waan2/waan4",
    "\u73AA": "gaam1",
    "\u73AB": "mui4",
    "\u73AC": "taan2",
    "\u73AD": "pan4/pin4",
    "\u73AE": "wai5",
    "\u73AF": "waan4/waan2",
    "\u73B0": "jin6",
    "\u73B1": "coeng1",
    "\u73B2": "ling4/ling2",
    "\u73B3": "doi6",
    "\u73B4": "jai6",
    "\u73B5": "ngam4/am4",
    "\u73B6": "ping4",
    "\u73B7": "dim3",
    "\u73B8": "fu4",
    "\u73B9": "jyun4",
    "\u73BA": "saai2",
    "\u73BB": "bo1",
    "\u73BC": "ci1/ci2",
    "\u73BD": "gau2",
    "\u73BE": "gaap3",
    "\u73BF": "siu4",
    "\u73C0": "paak3",
    "\u73C1": "ci4",
    "\u73C2": "o1/ngo1",
    "\u73C3": "jim5",
    "\u73C4": "sang1",
    "\u73C5": "san1",
    "\u73C6": "ji4",
    "\u73C7": "zou2",
    "\u73C8": "gaa1",
    "\u73C9": "man4",
    "\u73CA": "saan1",
    "\u73CB": "lau5",
    "\u73CC": "bit1/bat1",
    "\u73CD": "zan1",
    "\u73CE": "zan1",
    "\u73CF": "gok3",
    "\u73D0": "faat3",
    "\u73D1": "lung4",
    "\u73D2": "zeon1",
    "\u73D3": "gaau3",
    "\u73D4": "zin6",
    "\u6E51": "seoi1/seoi2",
    "\u6E52": "cap1",
    "\u6E53": "pun4",
    "\u6E54": "zin1/zin3",
    "\u6E55": "gin2",
    "\u6E56": "wu4",
    "\u6E57": "fung6",
    "\u6E58": "soeng1",
    "\u6E59": "jik6",
    "\u6E5A": "jan6",
    "\u6E5B": "zaam3/daam1/cam4/taam4",
    "\u6E5C": "zik6/sat6",
    "\u6E5D": "gaai1",
    "\u6E5E": "zing1",
    "\u6E5F": "wong4",
    "\u6E60": "taan3",
    "\u6E61": "jyu4",
    "\u6E62": "bik1",
    "\u6E63": "man5",
    "\u6E64": "si1",
    "\u6E65": "teot1",
    "\u6E66": "sang1",
    "\u6E67": "jung2",
    "\u6E68": "gwik1",
    "\u6E69": "dung6/dung3",
    "\u6E6A": "teon3",
    "\u6E6B": "zau1/cau1/ziu2",
    "\u6E6C": "zau1",
    "\u6E6D": "cau4",
    "\u6E6E": "jin1/jan1",
    "\u6E6F": "tong1/soeng1/tong3/joeng4",
    "\u6E70": "lung4",
    "\u6E71": "waak6",
    "\u6E72": "jyun4/wun4",
    "\u6E73": "naam5/laam5",
    "\u6E74": "baan6",
    "\u6E75": "jau5",
    "\u6E76": "cyun4",
    "\u6E77": "zong1",
    "\u6E78": "loeng6",
    "\u6E79": "cin4",
    "\u6E7A": "jin4",
    "\u6E7B": "seon4",
    "\u6E7C": "nip6/lip6",
    "\u6E7D": "zi1",
    "\u6E7E": "waan1/wan1/waan4",
    "\u6E7F": "sap1",
    "\u6E80": "mun5",
    "\u6E81": "jing4",
    "\u6E82": "laat6",
    "\u6E83": "kui2/kwui2",
    "\u6E84": "fung4",
    "\u6E85": "zin3/zin1",
    "\u6E86": "zeoi6",
    "\u6E87": "lau4",
    "\u6E88": "gwai1",
    "\u6E89": "koi3",
    "\u6E8A": "bo1",
    "\u6E8B": "jing4",
    "\u6E8C": "put3",
    "\u6E8D": "zeon3",
    "\u6E8E": "gwai3",
    "\u6E8F": "tong4",
    "\u6E90": "jyun4",
    "\u6E91": "so2",
    "\u6E92": "jyun4",
    "\u6E93": "lim5",
    "\u6E94": "jiu5",
    "\u6E95": "mung4",
    "\u6E96": "zeon2",
    "\u6E97": "sing4",
    "\u6E98": "hap6",
    "\u6E99": "taai3",
    "\u6E9A": "taap3/daap3",
    "\u6E9B": "waa1",
    "\u6E9C": "lau6/lau1/liu1/lau4",
    "\u6E9D": "kau1/gau1",
    "\u6E9E": "sou1",
    "\u6E9F": "ming4/ming5",
    "\u6EA0": "zaa3",
    "\u6EA1": "si4",
    "\u6EA2": "jat6",
    "\u6EA3": "leon6",
    "\u6EA4": "maa5",
    "\u6EA5": "pou2",
    "\u6EA6": "mei4/mei1",
    "\u6EA7": "leot6",
    "\u6EA8": "zoi1",
    "\u6EA9": "wu2",
    "\u6EAA": "kai1",
    "\u6EAB": "wan1",
    "\u6EAC": "goeng1",
    "\u6EAD": "zik1",
    "\u6EAE": "si1",
    "\u6EAF": "sou3",
    "\u6EB0": "ji4",
    "\u6EB1": "zeon1/ceon4",
    "\u6EB2": "sau1",
    "\u6EB3": "wan4",
    "\u6EB4": "cau3",
    "\u6EB5": "jan1/jan2",
    "\u6EB6": "jung4",
    "\u6EB7": "wan6",
    "\u6EB8": "sou3",
    "\u6EB9": "sok3",
    "\u6EBA": "nik6/lik6/nik1/lik1/niu6/liu6",
    "\u6EBB": "taap3",
    "\u6EBC": "sap1",
    "\u6EBD": "juk6",
    "\u6EBE": "aai1/ngaai1",
    "\u6EBF": "pun3",
    "\u6EC0": "cuk1",
    "\u6EC1": "cyu4/ceoi4",
    "\u6EC2": "pong4/pong1",
    "\u6EC3": "jung2/jung1",
    "\u6EC4": "cong1",
    "\u6EC5": "mit6",
    "\u6EC6": "gaak3",
    "\u6EC7": "tin4/din1",
    "\u6EC8": "hou6",
    "\u6EC9": "fong2",
    "\u6ECA": "hei3",
    "\u6ECB": "zi1",
    "\u6ECC": "dik6",
    "\u6ECD": "zi6",
    "\u6ECE": "jing4",
    "\u6ECF": "fu2",
    "\u6ED0": "git6",
    "\u6ED1": "waat6/waat2/gwat1",
    "\u6ED2": "go1",
    "\u6ED3": "zi2",
    "\u6ED4": "tou1",
    "\u6ED5": "tang4",
    "\u6ED6": "seoi1",
    "\u6ED7": "bei3",
    "\u6ED8": "gaau3",
    "\u6ED9": "wui6",
    "\u6EDA": "gwan2",
    "\u6EDB": "jam4",
    "\u6EDC": "gou1",
    "\u6EDD": "lung4",
    "\u6EDE": "zai6",
    "\u6EDF": "jim6",
    "\u6EE0": "sip3",
    "\u6EE1": "mun5/mun2",
    "\u6EE2": "jing4/jing6",
    "\u6EE3": "seon4",
    "\u6EE4": "leoi6",
    "\u6EE5": "laam6/laam5",
    "\u6EE6": "lyun4",
    "\u6EE7": "haau6",
    "\u6EE8": "ban1",
    "\u6EE9": "taan1",
    "\u6EEA": "jyu6",
    "\u6EEB": "sau1/sau2/sau3",
    "\u6EEC": "wu6",
    "\u6EED": "bat1",
    "\u6EEE": "biu1",
    "\u6EEF": "zai6",
    "\u6EF0": "koeng5",
    "\u6EF1": "kau3",
    "\u6EF2": "sam3",
    "\u6EF3": "soeng1",
    "\u6EF4": "dik6/dik1",
    "\u6EF5": "mat6",
    "\u6EF6": "ngou4/ou4",
    "\u6EF7": "lou5",
    "\u6EF8": "wu2/heoi2",
    "\u6EF9": "fu1",
    "\u6EFA": "jau4/dik6",
    "\u6EFB": "caan2",
    "\u6EFC": "paan3",
    "\u6EFD": "jung4",
    "\u6EFE": "gwan2",
    "\u6EFF": "mun5/mun2",
    "\u6F00": "hing2",
    "\u6F01": "jyu4",
    "\u6F02": "piu1/piu3",
    "\u6F03": "zik6",
    "\u6F04": "ngaai4/aai4",
    "\u6F05": "ziu2",
    "\u6F06": "cat1/cit3",
    "\u6F07": "saai2",
    "\u6F08": "zai3",
    "\u6F09": "luk6",
    "\u6F0A": "lau4",
    "\u6F0B": "lung4",
    "\u6F0C": "gan2",
    "\u6F0D": "gwok3/gok3",
    "\u6F0E": "cung4/sung2",
    "\u6F0F": "lau6/lau2",
    "\u6F10": "zap6",
    "\u6F11": "koi3",
    "\u6F12": "koeng4",
    "\u6F13": "lei4",
    "\u6F14": "jin2/jin5",
    "\u6F15": "cou4",
    "\u6F16": "gaau3",
    "\u6F17": "cung1",
    "\u6F18": "seon4",
    "\u6F19": "tyun4",
    "\u6F1A": "au3/ngau3/au1/ngau1",
    "\u6F1B": "tang4",
    "\u6F1C": "je5",
    "\u6F1D": "zaap6",
    "\u6F1E": "mik6",
    "\u6F1F": "tong4",
    "\u6F20": "mok6",
    "\u6F21": "tong1",
    "\u6F22": "hon3",
    "\u6F23": "lin4",
    "\u6F24": "laam5/laam6",
    "\u6F25": "waa1",
    "\u6F26": "lei4",
    "\u6F27": "gon1",
    "\u6F28": "fung4",
    "\u6F29": "syun4",
    "\u6F2A": "ji1/ji2",
    "\u6F2B": "maan6",
    "\u6F2C": "zi3/zik1",
    "\u6F2D": "mong5",
    "\u6F2E": "hong1",
    "\u6F2F": "taap3/leoi5/leoi6/lok3/lo6",
    "\u6F30": "paang1",
    "\u6F31": "sau3/sou3",
    "\u6F32": "zoeng2/zoeng3",
    "\u6F33": "zoeng1",
    "\u6F34": "zong6",
    "\u6F35": "zeoi6",
    "\u6F36": "waan6",
    "\u6F37": "gwok3/gok3/kwok3/kok3/fok3",
    "\u6F38": "zim6/zim2/zim1",
    "\u6F39": "jin4",
    "\u6F3A": "song2",
    "\u6F3B": "liu4/lau4",
    "\u6F3C": "ceoi2",
    "\u6F3D": "tai4",
    "\u6F3E": "joeng6",
    "\u6F3F": "zoeng1",
    "\u6F40": "cung4",
    "\u6F41": "wing6",
    "\u6F42": "hung4",
    "\u6F43": "sau1",
    "\u6F44": "sau3/sou3",
    "\u6F45": "gun3/gwun3",
    "\u6F46": "jing4",
    "\u6F47": "siu1",
    "\u6F48": "zung1",
    "\u6F49": "wan6",
    "\u6F4A": "zeoi6",
    "\u6F4B": "lim6",
    "\u6F4C": "zat6",
    "\u6F4D": "wai4",
    "\u6F4E": "pit3",
    "\u6F4F": "kyut3/wat6/seot6",
    "\u6F50": "ziu3",
    "\u6F51": "put3/but3",
    "\u6F52": "dong6",
    "\u6F53": "wai6",
    "\u6F54": "git3",
    "\u6F55": "mou5",
    "\u6F56": "paa4",
    "\u6F57": "cap1",
    "\u6F58": "pun1",
    "\u6F59": "gwai1",
    "\u6F5A": "suk1",
    "\u6F5B": "cim4",
    "\u6F5C": "cim4",
    "\u6F5D": "kap1",
    "\u6F5E": "lou6/lou2",
    "\u6F5F": "sik1",
    "\u6F60": "seon3",
    "\u6F61": "dan6",
    "\u6F62": "wong4",
    "\u6F63": "man5",
    "\u6F64": "jeon6/jeon2",
    "\u6F65": "suk1",
    "\u6F66": "lou5/liu4/liu2/liu5/lou6",
    "\u6F67": "zeon1",
    "\u6F68": "zung1",
    "\u6F69": "ji6",
    "\u6F6A": "zik6",
    "\u6F6B": "waan1",
    "\u6F6C": "taan1",
    "\u6F6D": "taam4",
    "\u6F6E": "ciu4",
    "\u6F6F": "cam4",
    "\u6F70": "kui2/kwui2",
    "\u6F71": "jan1",
    "\u6F72": "saau3",
    "\u6F73": "tou4",
    "\u6F74": "zyu1",
    "\u6F75": "saat3/saan3",
    "\u6F76": "hak1",
    "\u6F77": "bei3",
    "\u6F78": "saan1",
    "\u6F79": "saan4",
    "\u6F7A": "saan4",
    "\u6F7B": "syu2",
    "\u6F7C": "tung4",
    "\u6F7D": "pou1",
    "\u6F7E": "leon4",
    "\u6F7F": "wai4",
    "\u6F80": "gip3/sik1/sap1",
    "\u6F81": "gip3/sik1/sap1",
    "\u6F82": "cing4",
    "\u6F83": "gwing3",
    "\u6F84": "cing4/dang6",
    "\u6F85": "waa6",
    "\u6F86": "hiu1/giu1/ngou6/ou6",
    "\u6F87": "lou6/lou4",
    "\u6F88": "cit3",
    "\u6F89": "gam2",
    "\u6F8A": "cyun1",
    "\u6F8B": "wang6",
    "\u6F8C": "si1",
    "\u6F8D": "syu6",
    "\u6F8E": "paang4/paang1",
    "\u6F8F": "ham4",
    "\u6F90": "wan4",
    "\u6F91": "lau6",
    "\u6F92": "hung6/hung3",
    "\u6F93": "fuk6",
    "\u6F94": "hou6",
    "\u6F95": "wo4",
    "\u6F96": "haan4",
    "\u6F97": "gaan3/gaan2",
    "\u6F98": "saan1",
    "\u6F99": "sik1",
    "\u6F9A": "jyut6",
    "\u6F9B": "lou5",
    "\u6F9C": "laan4",
    "\u6F9D": "ning6/ling6",
    "\u6F9E": "jyu4",
    "\u6F9F": "lam5",
    "\u6FA0": "man5/sing4",
    "\u6FA1": "cou3/zou2",
    "\u6FA2": "dong1",
    "\u6FA3": "wun5/wun2",
    "\u6FA4": "zaak6/sik1",
    "\u6FA5": "haai5",
    "\u6FA6": "jyu6",
    "\u6FA7": "lai5",
    "\u6FA8": "sai6",
    "\u6FA9": "hok6",
    "\u6FAA": "ling4",
    "\u6FAB": "maan6",
    "\u6FAC": "zi1",
    "\u6FAD": "jung1",
    "\u6FAE": "kui2/kwui2",
    "\u6FAF": "caan3",
    "\u6FB0": "lim6",
    "\u6FB1": "din6",
    "\u6FB2": "jip6",
    "\u6FB3": "ou3/ngou3/juk1",
    "\u6FB4": "waan4",
    "\u6FB5": "zeon1",
    "\u6FB6": "sin4/sim4/daan3",
    "\u6FB7": "maan6",
    "\u6FB8": "dam2",
    "\u6FB9": "daam6/taam4",
    "\u6FBA": "jik1",
    "\u6FBB": "seoi6",
    "\u6FBC": "pik1",
    "\u6FBD": "geoi6/geoi3",
    "\u6FBE": "taat3",
    "\u6FBF": "kam4",
    "\u6FC0": "gik1",
    "\u6FC1": "zuk6",
    "\u6FC2": "lim4",
    "\u6FC3": "nung4/lung4",
    "\u6FC4": "wo1",
    "\u6FC5": "zam3",
    "\u6FC6": "fan4/pan3",
    "\u6FC7": "gip3/sik1/sap1",
    "\u6FC8": "cap1",
    "\u6FC9": "seoi1",
    "\u6FCA": "wai3/kut3/kwut3",
    "\u6FCB": "co2",
    "\u6FCC": "taap3",
    "\u6FCD": "sung1",
    "\u6FCE": "ding2/ting5",
    "\u6FCF": "sat1",
    "\u6FD0": "zyu2",
    "\u6FD1": "laai6",
    "\u6FD2": "ban1/pan4",
    "\u6FD3": "lim4",
    "\u6FD4": "mei4/mei5/nei4/lei4",
    "\u6FD5": "sap1",
    "\u6FD6": "syu6",
    "\u6FD7": "mik6",
    "\u6FD8": "ning6/ling6/ning4/ling4",
    "\u6FD9": "jing4",
    "\u6FDA": "jing4",
    "\u6FDB": "mung4",
    "\u6FDC": "zeon6",
    "\u6FDD": "kei4",
    "\u6FDE": "pei3",
    "\u6FDF": "zai3/zai2",
    "\u6FE0": "hou4",
    "\u6FE1": "jyu4",
    "\u6FE2": "ceoi3",
    "\u6FE3": "waat3",
    "\u6FE4": "tou4",
    "\u6FE5": "jan5",
    "\u6FE6": "jan1/jan2",
    "\u6FE7": "deoi6",
    "\u6FE8": "ci4",
    "\u6FE9": "wok6/wu6",
    "\u6FEA": "cing3",
    "\u6FEB": "laam6/laam5",
    "\u6FEC": "zeon3/seon3",
    "\u6FED": "oi3/ngoi3",
    "\u6FEE": "buk6",
    "\u6FEF": "zok6",
    "\u6FF0": "wai4",
    "\u6FF1": "ban1",
    "\u6FF2": "guk1",
    "\u6FF3": "cim4",
    "\u6FF4": "jing4",
    "\u6FF5": "ban1",
    "\u6FF6": "fut3",
    "\u6FF7": "fai3",
    "\u6FF8": "cong1",
    "\u6FF9": "mak6",
    "\u6FFA": "zin3/zin1",
    "\u6FFB": "wai5",
    "\u6FFC": "lok6/bok6/lik1",
    "\u6FFD": "zaan3",
    "\u6FFE": "leoi6",
    "\u6FFF": "lai6",
    "\u7000": "jau1",
    "\u7001": "joeng6/joeng5",
    "\u7002": "lou5",
    "\u7003": "ci3",
    "\u7004": "zit1/zit3",
    "\u7005": "jing4/jing6",
    "\u7006": "duk6/dau6",
    "\u7007": "wong2",
    "\u7008": "fai1",
    "\u7009": "se3/se2",
    "\u700A": "pun4",
    "\u700B": "sam2",
    "\u700C": "biu1",
    "\u700D": "cin4",
    "\u700E": "mut3",
    "\u700F": "lau4",
    "\u7010": "zim1",
    "\u7011": "buk6/puk6/bou6",
    "\u7012": "gip3",
    "\u7013": "cing4",
    "\u7014": "guk1",
    "\u7015": "ban1/pan4",
    "\u7016": "fok3",
    "\u7017": "hin3",
    "\u7018": "lou4",
    "\u7019": "can3",
    "\u701A": "hon6",
    "\u701B": "jing4",
    "\u701C": "jung4",
    "\u701D": "lik6/lik1/lek6",
    "\u701E": "zing6",
    "\u701F": "siu1",
    "\u7020": "jing4",
    "\u7021": "seoi5",
    "\u7022": "wai5",
    "\u7023": "haai6",
    "\u7024": "waai4",
    "\u7025": "hou6",
    "\u7026": "zyu1",
    "\u7027": "lung4/soeng1",
    "\u7028": "laai6",
    "\u7029": "deoi6",
    "\u702A": "faan6",
    "\u702B": "huk6",
    "\u702C": "laai6",
    "\u702D": "syu1",
    "\u702E": "lam4",
    "\u702F": "jing4",
    "\u7030": "nei4/lei4/mei4",
    "\u7031": "gai3",
    "\u7032": "lim6",
    "\u7033": "zin6",
    "\u7034": "jing1/jing2",
    "\u7035": "fan3",
    "\u7036": "lam4",
    "\u7037": "jik6",
    "\u7038": "zim1",
    "\u7039": "joek6",
    "\u703A": "caam4",
    "\u703B": "daai3",
    "\u703C": "joeng4/joeng5",
    "\u703D": "zin2/gin2",
    "\u703E": "laan4",
    "\u703F": "faan4",
    "\u7040": "soeng3",
    "\u7041": "jyun1",
    "\u7042": "zok6/ziu3",
    "\u7043": "fung1",
    "\u7044": "sip3",
    "\u7045": "leoi5",
    "\u7046": "laam4",
    "\u7047": "cung4",
    "\u7048": "keoi4",
    "\u7049": "jung1",
    "\u704A": "cim4",
    "\u704B": "faat3",
    "\u704C": "gun3/gwun3",
    "\u704D": "kyut3",
    "\u704E": "jim6",
    "\u704F": "hou6",
    "\u7050": "jing4",
    "\u7051": "saa2",
    "\u7052": "zaan3",
    "\u7053": "lyun4",
    "\u7054": "jim6",
    "\u7055": "lei4",
    "\u7056": "mei5",
    "\u7057": "sin5",
    "\u7058": "taan1",
    "\u7059": "dong2",
    "\u705A": "gaau2",
    "\u705B": "cin2",
    "\u705C": "jing4",
    "\u705D": "hou6",
    "\u705E": "baa3",
    "\u705F": "zuk1",
    "\u7060": "laam5/laam6",
    "\u7061": "laan4",
    "\u7062": "nong5/long5",
    "\u7063": "waan1/wan1/waan4",
    "\u7064": "lyun4",
    "\u7065": "ceon4",
    "\u7066": "hin2",
    "\u7067": "jim6",
    "\u7068": "gam3",
    "\u7069": "jim6",
    "\u706A": "wat1",
    "\u706B": "fo2",
    "\u706C": "biu1/sei3.dim2",
    "\u706D": "mit6",
    "\u706E": "gwong1/gong1",
    "\u706F": "dang1",
    "\u7070": "fui1",
    "\u7071": "haau1",
    "\u7072": "haau1",
    "\u7073": "fai1",
    "\u7074": "hung4",
    "\u7075": "ling4/ling2/leng4",
    "\u7076": "zou3",
    "\u7077": "zyun6",
    "\u7078": "gau3",
    "\u7079": "zaa3",
    "\u707A": "se3/ce5/ce2",
    "\u707B": "cek3",
    "\u707C": "coek3/zoek3",
    "\u707D": "zoi1",
    "\u707E": "zoi1",
    "\u707F": "caan3",
    "\u7080": "joeng4/joeng6",
    "\u7081": "hei3",
    "\u7082": "zung1",
    "\u7083": "fan4",
    "\u7084": "nau5/lau5",
    "\u7085": "gwing2/gwai3/gwai6",
    "\u7086": "man1",
    "\u7087": "pok3",
    "\u7088": "jik6",
    "\u7089": "lou4/lou2",
    "\u708A": "ceoi1",
    "\u708B": "pui1",
    "\u708C": "kaai3",
    "\u708D": "pun3",
    "\u708E": "jim4",
    "\u708F": "kaai3",
    "\u7090": "pong3",
    "\u7091": "muk6",
    "\u7092": "caau2",
    "\u7093": "liu6",
    "\u7094": "kyut3/gai3/gwai3",
    "\u7095": "kong3/hong3",
    "\u7096": "dan6/deon6",
    "\u7097": "gwong1/gong1",
    "\u7098": "jan1",
    "\u7099": "zek3/zik3",
    "\u709A": "gwong1/gong1",
    "\u709B": "gwong1/gong1",
    "\u709C": "wai5",
    "\u709D": "coeng3",
    "\u709E": "bin6",
    "\u709F": "daat3",
    "\u70A0": "saap6",
    "\u70A1": "zing1",
    "\u70A2": "seot6",
    "\u70A3": "ho2",
    "\u70A4": "ciu1/ziu1/ziu3",
    "\u70A5": "fat6",
    "\u70A6": "bat6",
    "\u70A7": "se3/ce5/ce2",
    "\u70A8": "se3",
    "\u70A9": "ling6",
    "\u70AA": "dyut3",
    "\u70AB": "jyun6/jyun4",
    "\u70AC": "geoi6",
    "\u70AD": "taan3",
    "\u70AE": "paau3/paau4/baau3",
    "\u70AF": "gwing2",
    "\u70B0": "paau4/fau2",
    "\u70B1": "toi4",
    "\u70B2": "toi4",
    "\u70B3": "bing2",
    "\u70B4": "joeng2",
    "\u70B5": "tung1",
    "\u70B6": "sim2",
    "\u70B7": "zyu3",
    "\u70B8": "zaa3",
    "\u70B9": "dim2",
    "\u70BA": "wai4/wai2/wai6",
    "\u70BB": "sek6",
    "\u70BC": "lin6/lin2",
    "\u70BD": "ci3",
    "\u70BE": "fong2",
    "\u70BF": "zau1",
    "\u70C0": "fu1",
    "\u70C1": "soek3/lik1",
    "\u70C2": "laan6/laan2",
    "\u70C3": "ting1",
    "\u70C4": "gaau2",
    "\u70C5": "gwik1",
    "\u70C6": "hang4",
    "\u70C7": "cyun2",
    "\u70C8": "lit6",
    "\u70C9": "wun6",
    "\u70CA": "joeng4/joeng2",
    "\u70CB": "haau1/jau1",
    "\u70CC": "jau1",
    "\u70CD": "sin2",
    "\u70CE": "cim4",
    "\u70CF": "wu1",
    "\u70D0": "zau1",
    "\u70D1": "jiu4",
    "\u70D2": "sik1",
    "\u70D3": "gwing1",
    "\u70D4": "tung4/cung4",
    "\u70D5": "hyut3/kyut3/mit6",
    "\u70D6": "zoi1",
    "\u70D7": "kaai3",
    "\u70D8": "hung3/hung1/hong3/hung4",
    "\u70D9": "lok3",
    "\u70DA": "hap6",
    "\u70DB": "zuk1",
    "\u70DC": "hyun2/hyun1",
    "\u70DD": "zing1",
    "\u70DE": "pok3",
    "\u70DF": "jin1/jan1",
    "\u70E0": "wui4",
    "\u70E1": "gwong1/gong1",
    "\u70E2": "caak3",
    "\u70E3": "fui1",
    "\u70E4": "haau1/haau2",
    "\u70E5": "geoi6",
    "\u70E6": "faan4",
    "\u70E7": "siu1",
    "\u70E8": "jip6",
    "\u70E9": "wui6",
    "\u70EA": "gwaan1",
    "\u70EB": "tong3",
    "\u70EC": "zeon6/zeon2",
    "\u70ED": "jit6/jit2",
    "\u70EE": "lit6",
    "\u70EF": "hei1",
    "\u70F0": "fau4",
    "\u70F1": "gwing2",
    "\u70F2": "hit3",
    "\u70F3": "pou2",
    "\u70F4": "ting1",
    "\u70F5": "zoek3",
    "\u70F6": "ting5",
    "\u70F7": "jyun2/jyun4",
    "\u70F8": "hoi2",
    "\u70F9": "paang1",
    "\u70FA": "long5",
    "\u70FB": "jin3",
    "\u70FC": "fat1",
    "\u70FD": "fung1",
    "\u70FE": "cek3",
    "\u70FF": "jung4",
    "\u7100": "huk6",
    "\u7101": "hei1",
    "\u7102": "suk1",
    "\u7103": "haak1",
    "\u7104": "fan1",
    "\u7105": "guk6",
    "\u7106": "gyun1",
    "\u7107": "siu1",
    "\u7108": "hei1",
    "\u7109": "jin1/jin4",
    "\u710A": "hon6",
    "\u710B": "zong3",
    "\u710C": "zeon3/zeot1",
    "\u710D": "dai6",
    "\u710E": "hit3",
    "\u710F": "gik1",
    "\u7110": "ng6/m6",
    "\u7111": "jin1",
    "\u7112": "leoi5",
    "\u7113": "ham4",
    "\u7114": "jim6",
    "\u7115": "wun6",
    "\u7116": "mun6",
    "\u7117": "guk6",
    "\u7118": "tou4/dou6",
    "\u373A": "zaan2",
    "\u373B": "lyun2",
    "\u373C": "zat6",
    "\u373D": "zi2",
    "\u373E": "haai4",
    "\u373F": "zeoi6",
    "\u3740": "hou2",
    "\u3741": "hyun1",
    "\u3742": "zai3",
    "\u3743": "min5",
    "\u3744": "seon4",
    "\u3745": "gau3",
    "\u3746": "hei2",
    "\u3747": "seon4",
    "\u3748": "lyun4",
    "\u3749": "cyu5",
    "\u374A": "sau2",
    "\u374B": "liu4",
    "\u374C": "gau3",
    "\u374D": "se2",
    "\u374E": "ding6",
    "\u374F": "gaai3",
    "\u3750": "jung4",
    "\u3751": "pong4",
    "\u3752": "geoi1",
    "\u3753": "hap1",
    "\u3754": "jiu2/jiu3",
    "\u3755": "ning4/ling4",
    "\u3756": "ji4",
    "\u3757": "long4/long6",
    "\u3758": "jung4",
    "\u3759": "jan4",
    "\u375A": "jin4",
    "\u375B": "suk1/sau3",
    "\u375C": "sik1",
    "\u375D": "lam4",
    "\u375E": "aa1/ngaa1",
    "\u375F": "mou6",
    "\u3760": "ming4/ming5",
    "\u3761": "zeoi3",
    "\u3762": "jyu5",
    "\u3763": "ai3/ngai3",
    "\u3764": "gau3",
    "\u3765": "mai4",
    "\u3766": "zeon3",
    "\u3767": "wan2",
    "\u3768": "jyun4",
    "\u3769": "hoi1/hong1",
    "\u376A": "dim3",
    "\u376B": "lung4",
    "\u376C": "wu4",
    "\u376D": "sing2",
    "\u376E": "ceoi3",
    "\u376F": "kiu4",
    "\u3770": "min4",
    "\u3771": "mung6/mung4",
    "\u3772": "cam2",
    "\u3773": "sam1",
    "\u3774": "jyun4",
    "\u3775": "dak1",
    "\u3776": "dak1",
    "\u3777": "cam4",
    "\u3778": "bin6",
    "\u3779": "nau4/lau4",
    "\u377A": "lim4",
    "\u377B": "gan2",
    "\u377C": "jyu1",
    "\u377D": "seoi2",
    "\u377E": "zo2",
    "\u377F": "bai1/bo2/bei3",
    "\u3780": "fui1",
    "\u3781": "jiu6",
    "\u3782": "teoi2",
    "\u3783": "kek6",
    "\u3784": "am1/ngam1",
    "\u3785": "lo6",
    "\u3786": "gei2",
    "\u3787": "wui2",
    "\u3788": "but3",
    "\u3789": "zaat3",
    "\u378A": "seot1",
    "\u378B": "nin2/lin2",
    "\u378C": "jan6",
    "\u378D": "jyun4",
    "\u378E": "baa2",
    "\u378F": "zaap6",
    "\u3790": "geoi1/gei1",
    "\u3791": "mei5",
    "\u3792": "ai3/ngai3/hei3",
    "\u3793": "hei3",
    "\u3794": "ji4",
    "\u3795": "sit3",
    "\u3796": "ci1",
    "\u3797": "kau4/gau1",
    "\u3798": "duk1",
    "\u3799": "niu6/liu6",
    "\u379A": "cap1",
    "\u379B": "gei2",
    "\u379C": "teoi1",
    "\u379D": "cik1",
    "\u379E": "sung4/cung4",
    "\u379F": "din6",
    "\u37A0": "liu4",
    "\u37A1": "zin2",
    "\u37A2": "zi1",
    "\u37A3": "fan1",
    "\u37A4": "jam4",
    "\u37A5": "sam4",
    "\u37A6": "gei2",
    "\u37A7": "wui6",
    "\u37A8": "zi2",
    "\u37A9": "laam4",
    "\u37AA": "nou4/lou4",
    "\u37AB": "zau2",
    "\u37AC": "jan2",
    "\u37AD": "daai6",
    "\u37AE": "ngai4/ai4",
    "\u37AF": "hei2",
    "\u37B0": "heoi2",
    "\u37B1": "sung1",
    "\u37B2": "jung6",
    "\u37B3": "dau2",
    "\u37B4": "ci4",
    "\u37B5": "tou1",
    "\u37B6": "man4",
    "\u37B7": "wong4",
    "\u37B8": "seoi3",
    "\u37B9": "ho2",
    "\u37BA": "zuk6",
    "\u37BB": "hou6",
    "\u37BC": "sing4",
    "\u37BD": "hyut3",
    "\u37BE": "nei4/lei4",
    "\u37BF": "kei4",
    "\u37C0": "lin4",
    "\u37C1": "ngon6/on6",
    "\u37C2": "mou5",
    "\u37C3": "si1",
    "\u37C4": "coeng4",
    "\u37C5": "ngong4/ong4",
    "\u37C6": "waa4",
    "\u37C7": "zo3",
    "\u37C8": "kau4",
    "\u37C9": "lou4",
    "\u37CA": "fau4",
    "\u37CB": "deoi6",
    "\u37CC": "mong4",
    "\u37CD": "long4",
    "\u37CE": "to2",
    "\u37CF": "ham4",
    "\u37D0": "mong5",
    "\u37D1": "but6",
    "\u37D2": "kwan1",
    "\u37D3": "kei4",
    "\u37D4": "ham4",
    "\u37D5": "giu3",
    "\u37D6": "lung6",
    "\u37D7": "ban1",
    "\u37D8": "tiu4",
    "\u37D9": "zaak6",
    "\u37DA": "kei4",
    "\u37DB": "zaam6",
    "\u37DC": "mei4",
    "\u37DD": "pui4",
    "\u37DE": "zaan6",
    "\u37DF": "hong6",
    "\u37E0": "gong1",
    "\u37E1": "kwai5",
    "\u37E2": "kei1",
    "\u37E3": "sung1",
    "\u37E4": "luk6",
    "\u37E5": "cam1/caam1",
    "\u37E6": "wan6",
    "\u37E7": "ngok6/ok6",
    "\u37E8": "dyun1",
    "\u37E9": "man4",
    "\u37EA": "wai3",
    "\u37EB": "cyun4",
    "\u37EC": "sau2",
    "\u37ED": "man4",
    "\u37EE": "dat6",
    "\u37EF": "ngaak6/aak6",
    "\u37F0": "ming5",
    "\u37F1": "jiu5",
    "\u37F2": "jyun4",
    "\u37F3": "leot6",
    "\u37F4": "faai3",
    "\u37F5": "gong1",
    "\u37F6": "jyun4",
    "\u37F7": "daat3",
    "\u37F8": "gou1",
    "\u37F9": "lou4",
    "\u37FA": "lau5",
    "\u37FB": "cim3",
    "\u37FC": "ngou6/ou6",
    "\u37FD": "biu2",
    "\u37FE": "jung4",
    "\u37FF": "mang3",
    "\u3800": "dou2",
    "\u3801": "cam1/caam1",
    "\u3802": "ngou6/ou6",
    "\u3803": "dik1",
    "\u3804": "zaap6",
    "\u3805": "fuk6",
    "\u3806": "daan1",
    "\u3807": "zau6",
    "\u3808": "jeon6",
    "\u3809": "tung4",
    "\u380A": "heoi1",
    "\u380B": "ngok6/ok6",
    "\u380C": "kai1",
    "\u380D": "cap1",
    "\u380E": "zaap6",
    "\u380F": "waa4",
    "\u3810": "giu6",
    "\u3811": "zeoi6",
    "\u3812": "biu2",
    "\u3813": "mung4",
    "\u3814": "baai3",
    "\u3815": "ngai4/ai4",
    "\u3816": "ngai5/ai5",
    "\u3817": "ou3/ngou3",
    "\u3818": "zeoi6",
    "\u3819": "hou4",
    "\u381A": "deoi6",
    "\u381B": "waak6",
    "\u381C": "jik6",
    "\u381D": "cyun4",
    "\u381E": "zing1",
    "\u381F": "lai4",
    "\u3820": "leoi4",
    "\u3821": "niu5/liu5",
    "\u3822": "waai4",
    "\u3823": "lik6",
    "\u3824": "soeng1",
    "\u3825": "leot6",
    "\u3826": "fung1",
    "\u3827": "mei5",
    "\u3828": "wat1",
    "\u3829": "fong1",
    "\u382A": "geoi6",
    "\u382B": "faan4",
    "\u382C": "hau2",
    "\u382D": "zin2",
    "\u382E": "pung1",
    "\u382F": "ji5",
    "\u3830": "gaa1",
    "\u3831": "gei6",
    "\u3832": "bei2",
    "\u3833": "jap6",
    "\u3834": "jan6",
    "\u3835": "fong1",
    "\u3836": "faan4",
    "\u3837": "gap3",
    "\u3838": "fu1",
    "\u3839": "gaai3",
    "\u383A": "saa1",
    "\u383B": "hei1",
    "\u383C": "si1",
    "\u383D": "tung4",
    "\u383E": "jyun1",
    "\u383F": "zi1",
    "\u3840": "bai6",
    "\u3841": "kwaa2",
    "\u3842": "lai6",
    "\u3843": "fong1",
    "\u3844": "seon1",
    "\u3845": "no5/lo5",
    "\u3846": "fong1",
    "\u3847": "zip3",
    "\u3848": "man6",
    "\u3849": "gin1",
    "\u384A": "hap1",
    "\u384B": "jip3",
    "\u384C": "mou6/mou2",
    "\u384D": "mok6",
    "\u384E": "saam1",
    "\u384F": "syu1",
    "\u3850": "zin1",
    "\u3851": "ciu1",
    "\u3852": "zeon1",
    "\u3853": "gwan1",
    "\u3854": "mou6",
    "\u3855": "joeng1",
    "\u3856": "cong4",
    "\u3857": "tai4",
    "\u3858": "lim4",
    "\u3859": "bai1",
    "\u385A": "kau1",
    "\u385B": "mong4/fong1",
    "\u385C": "sit3",
    "\u385D": "fung6",
    "\u385E": "lau4",
    "\u385F": "zou1",
    "\u3860": "zing3",
    "\u3861": "cyu4/ceoi4",
    "\u3862": "maan6",
    "\u3863": "lung4",
    "\u3864": "jip6",
    "\u3865": "jan3",
    "\u3866": "pan1",
    "\u3867": "zing3",
    "\u3868": "zim1",
    "\u3869": "lyun4",
    "\u386A": "fan1",
    "\u386B": "ai3/ngai3",
    "\u386C": "gei2",
    "\u386D": "gai3",
    "\u386E": "gat6",
    "\u386F": "zaak6",
    "\u3870": "jyu5",
    "\u3871": "gau3",
    "\u3872": "waan4",
    "\u3873": "zi2",
    "\u3874": "laap6",
    "\u3875": "ling4",
    "\u3876": "zi2",
    "\u3877": "bun2",
    "\u3878": "zaa6",
    "\u3879": "ci3",
    "\u387A": "daan3",
    "\u387B": "liu6",
    "\u387C": "ji6",
    "\u387D": "ziu6",
    "\u387E": "haan6",
    "\u387F": "cik1",
    "\u3880": "ci3",
    "\u3881": "ci2",
    "\u3882": "jim5",
    "\u3883": "long4",
    "\u3884": "dau6",
    "\u3885": "lung6",
    "\u3886": "cin4",
    "\u3887": "jin4",
    "\u3888": "teoi4",
    "\u3889": "caa4",
    "\u388A": "ai2/ngai2",
    "\u388B": "ci2",
    "\u388C": "aa3/ngaa3",
    "\u388D": "jing2",
    "\u388E": "zip3",
    "\u388F": "tau4",
    "\u3890": "waa1",
    "\u3891": "teoi4",
    "\u3892": "caa4",
    "\u3893": "zoeng3",
    "\u3894": "zung2",
    "\u3895": "jung1",
    "\u3896": "pun1",
    "\u3897": "hiu3",
    "\u3898": "lim4",
    "\u3899": "kan4",
    "\u389A": "lou5",
    "\u389B": "jim6",
    "\u389C": "kong2",
    "\u389D": "sou1",
    "\u389E": "jik6",
    "\u389F": "cin1",
    "\u38A0": "gwing2",
    "\u38A1": "zoeng2",
    "\u38A2": "bai6",
    "\u38A3": "king4",
    "\u38A4": "zoi1",
    "\u38A5": "dung6",
    "\u38A6": "go1",
    "\u38A7": "gyun2",
    "\u38A8": "hon6",
    "\u38A9": "dik1",
    "\u38AA": "wu1",
    "\u38AB": "saan1",
    "\u38AC": "wang4",
    "\u38AD": "tou1",
    "\u38AE": "ci4",
    "\u38AF": "deon1",
    "\u38B0": "bei6",
    "\u38B1": "nei4/lei4",
    "\u38B2": "seon3",
    "\u38B3": "lou4",
    "\u38B4": "sai1",
    "\u38B5": "hip3",
    "\u38B6": "bat6",
    "\u38B7": "seoi3",
    "\u38B8": "bat6",
    "\u38B9": "san1",
    "\u38BA": "jin4",
    "\u38BB": "jeoi6",
    "\u38BC": "bit3",
    "\u38BD": "nei6/lei6",
    "\u38BE": "gyun3",
    "\u38BF": "hau4",
    "\u38C0": "zan3",
    "\u38C1": "bei6",
    "\u38C2": "ngaak6/aak6",
    "\u38C3": "juk6",
    "\u38C4": "keoi4",
    "\u38C5": "zaam6",
    "\u38C6": "mei4",
    "\u38C7": "dai6",
    "\u38C8": "si3",
    "\u38C9": "gung1",
    "\u38CA": "man4",
    "\u38CB": "daan1",
    "\u38CC": "saam3",
    "\u38CD": "toi4",
    "\u38CE": "muk6",
    "\u38CF": "zing6",
    "\u38D0": "bin3",
    "\u38D1": "jung4",
    "\u38D2": "cing3",
    "\u38D3": "caan3",
    "\u38D4": "ding1",
    "\u38D5": "daai6",
    "\u38D6": "taai3",
    "\u38D7": "wu6",
    "\u38D8": "keoi1",
    "\u38D9": "dik6",
    "\u38DA": "tung2",
    "\u38DB": "taap3",
    "\u38DC": "jing4",
    "\u38DD": "sung1",
    "\u38DE": "dyut6",
    "\u38DF": "hat1",
    "\u38E0": "tou1",
    "\u38E1": "zung6",
    "\u38E2": "tai4",
    "\u38E3": "sim3",
    "\u38E4": "cin5",
    "\u38E5": "zi6",
    "\u38E6": "wai1",
    "\u38E7": "jan6",
    "\u38E8": "gu1/gwu1",
    "\u38E9": "lam4",
    "\u38EA": "wun6",
    "\u38EB": "zung2",
    "\u38EC": "cap1",
    "\u38ED": "zung1",
    "\u38EE": "naam4/laam4",
    "\u38EF": "sit3",
    "\u38F0": "sat1",
    "\u38F1": "zaak6",
    "\u38F2": "mei4",
    "\u38F3": "mou4",
    "\u38F4": "wong4",
    "\u38F5": "taat3",
    "\u38F6": "zaan1",
    "\u38F7": "ning6/ling6",
    "\u38F8": "jeoi6",
    "\u38F9": "jing3",
    "\u38FA": "sam1/zang1.dim2.syu6.sam1.bin1",
    "\u38FB": "ngaai6/aai6",
    "\u38FC": "jan2",
    "\u38FD": "syu3",
    "\u38FE": "caa3",
    "\u38FF": "zoek3",
    "\u3900": "mong4",
    "\u3901": "tim2",
    "\u3902": "gap1",
    "\u3903": "fong1",
    "\u3904": "pui3",
    "\u3905": "oi3/ngoi3",
    "\u3906": "faan3",
    "\u3907": "ou3/ngou3",
    "\u3908": "cam3",
    "\u3909": "kaa1",
    "\u390A": "haau6",
    "\u390B": "fan1",
    "\u390C": "gam1",
    "\u390D": "haau1",
    "\u390E": "go1",
    "\u390F": "dung2",
    "\u3910": "tip3",
    "\u3911": "jau1",
    "\u3912": "gou1",
    "\u3913": "ban6",
    "\u3914": "fu6",
    "\u3915": "ceot1",
    "\u3916": "no6/lo6",
    "\u3917": "taai3",
    "\u3918": "zau3/cau1",
    "\u3919": "jan1",
    "\u391A": "hong4",
    "\u391B": "jam6",
    "\u391C": "seot6",
    "\u391D": "cung1",
    "\u391E": "caa3/dok6",
    "\u391F": "hung2",
    "\u3920": "lit6",
    "\u3921": "lai6",
    "\u3922": "juk1",
    "\u3923": "paang1",
    "\u3924": "jyu4",
    "\u3925": "hoi6",
    "\u3926": "lei6",
    "\u3927": "hau4",
    "\u3928": "gung2",
    "\u3929": "kok3",
    "\u392A": "jyun3",
    "\u392B": "dak1",
    "\u392C": "wai6",
    "\u392D": "giu1",
    "\u392E": "gwong3/gong3",
    "\u392F": "gwing2",
    "\u3930": "zok3/zok6",
    "\u3931": "fu3",
    "\u3932": "hip3",
    "\u3933": "bui2",
    "\u3934": "cip3",
    "\u3935": "ci4",
    "\u3936": "mong4",
    "\u3937": "ham1",
    "\u3938": "hik1",
    "\u3939": "kau4",
    "\u393A": "fong1",
    "\u393B": "tung4",
    "\u393C": "gip3",
    "\u393D": "cau4",
    "\u393E": "saam3",
    "\u393F": "jim1",
    "\u3940": "zik6",
    "\u3941": "dak1",
    "\u3942": "tik1",
    "\u3943": "mun6",
    "\u3944": "ling4",
    "\u3945": "sau6",
    "\u3946": "teoi3",
    "\u3947": "caan4",
    "\u3948": "dip6",
    "\u3949": "cai3",
    "\u394A": "pang4",
    "\u394B": "ji1",
    "\u394C": "guk1",
    "\u394D": "gei6",
    "\u394E": "lei4",
    "\u394F": "tin5/tin2",
    "\u3950": "jyun3",
    "\u3951": "jau1",
    "\u3952": "coi2",
    "\u3953": "kei1",
    "\u3954": "juk6",
    "\u3955": "lin4",
    "\u3956": "cung1",
    "\u3957": "man5",
    "\u3958": "gip3",
    "\u3959": "zung1",
    "\u395A": "jyu4",
    "\u395B": "gik6",
    "\u395C": "wai6",
    "\u395D": "mei5",
    "\u395E": "seoi3",
    "\u395F": "haai4",
    "\u3960": "seoi1",
    "\u3961": "ci3",
    "\u3962": "cau4",
    "\u3963": "wai6",
    "\u3964": "ging1",
    "\u3965": "jyu4",
    "\u3966": "hip3/hip6",
    "\u3967": "seon6",
    "\u3968": "seoi6",
    "\u3969": "do2",
    "\u396A": "lau4",
    "\u396B": "deon1",
    "\u396C": "pong4",
    "\u396D": "taai3",
    "\u396E": "zau3/cau1",
    "\u396F": "jan2",
    "\u3970": "sou1",
    "\u3971": "fei2",
    "\u3972": "can1",
    "\u3973": "jyun4",
    "\u3974": "ji4",
    "\u3975": "wan6",
    "\u3976": "sak1",
    "\u3977": "ai3/ngai3",
    "\u3978": "man5",
    "\u3979": "fan2",
    "\u397A": "hap6",
    "\u397B": "cik1",
    "\u397C": "jan3",
    "\u397D": "caak3",
    "\u397E": "nik6/lik6",
    "\u397F": "ngou6/ou6",
    "\u3980": "fung4",
    "\u3981": "lin4",
    "\u3982": "soeng4",
    "\u3983": "caan2",
    "\u3984": "maa4",
    "\u3985": "dit6",
    "\u3986": "fu1",
    "\u3987": "luk6",
    "\u3988": "oi3/ngoi3",
    "\u3989": "ji3",
    "\u398A": "waa4",
    "\u398B": "zaa1",
    "\u398C": "fat1",
    "\u398D": "ngok6/ok6",
    "\u398E": "waak6",
    "\u398F": "seon2",
    "\u3990": "nei6/lei6",
    "\u3991": "haam3",
    "\u3992": "lai2",
    "\u3993": "jin6",
    "\u3994": "jim1",
    "\u3995": "lung4",
    "\u3996": "mun6",
    "\u3997": "gam1",
    "\u3998": "gik1",
    "\u3999": "jyu4",
    "\u399A": "bin2",
    "\u399B": "jyu4",
    "\u399C": "wok6",
    "\u399D": "mok6",
    "\u399E": "cau4",
    "\u399F": "maai4",
    "\u39A0": "deoi6",
    "\u39A1": "lok6",
    "\u39A2": "zit3",
    "\u39A3": "wai6",
    "\u39A4": "ji3",
    "\u39A5": "hyun1",
    "\u39A6": "hik1",
    "\u39A7": "caam2",
    "\u39A8": "laan5",
    "\u39A9": "jan2",
    "\u39AA": "sip3",
    "\u39AB": "zaat3",
    "\u39AC": "lo5",
    "\u39AD": "lin4",
    "\u39AE": "zin1",
    "\u39AF": "waak6",
    "\u39B0": "zim1",
    "\u39B1": "ngo5/o5",
    "\u39B2": "zoi1",
    "\u39B3": "ngo5/o5",
    "\u39B4": "gaak3",
    "\u39B5": "zyu1",
    "\u39B6": "dit6",
    "\u39B7": "jung5",
    "\u39B8": "gik1",
    "\u39B9": "joeng4",
    "\u39BA": "juk6",
    "\u39BB": "zaap6",
    "\u39BC": "soeng3",
    "\u39BD": "juk1",
    "\u39BE": "ji4",
    "\u39BF": "haam2",
    "\u39C0": "gap6",
    "\u39C1": "heoi3",
    "\u39C2": "tin4",
    "\u39C3": "sau1",
    "\u39C4": "ham2",
    "\u39C5": "muk6",
    "\u39C6": "gan3",
    "\u39C7": "mou6",
    "\u39C8": "jan5",
    "\u39C9": "goi3",
    "\u39CA": "put3",
    "\u39CB": "hyun2",
    "\u39CC": "mou4",
    "\u39CD": "fong2",
    "\u39CE": "ngaa4/aa4",
    "\u39CF": "gong1",
    "\u39D0": "sung2",
    "\u39D1": "fai1",
    "\u39D2": "wat6",
    "\u39D3": "gwaa1",
    "\u39D4": "gwaai3",
    "\u39D5": "lau5",
    "\u39D6": "ak1/aak1/ngaak1/ngak1",
    "\u39D7": "zi2",
    "\u39D8": "zi6",
    "\u39D9": "pit3",
    "\u39DA": "ngaa5/aa5",
    "\u39DB": "laam5/laam2",
    "\u39DC": "laap6",
    "\u39DD": "ke2",
    "\u39DE": "bat6",
    "\u39DF": "kwaai5",
    "\u39E0": "mei4",
    "\u39E1": "hoi6",
    "\u39E2": "jan1",
    "\u39E3": "zyu1",
    "\u39E4": "cung3",
    "\u39E5": "sin2",
    "\u39E6": "hyun3",
    "\u39E7": "so1",
    "\u39E8": "kau4",
    "\u39E9": "bui6",
    "\u39EA": "gwai2",
    "\u39EB": "ji4",
    "\u39EC": "gung2/ngung2/ung2",
    "\u39ED": "kung4",
    "\u39EE": "fat1",
    "\u39EF": "lou5",
    "\u39F0": "lik6/loek6",
    "\u39F1": "naa4/laa4",
    "\u39F2": "sam2",
    "\u39F3": "zeoi6",
    "\u39F4": "ngo5/o5",
    "\u39F5": "pau4",
    "\u39F6": "hang1",
    "\u39F7": "tan3",
    "\u39F8": "paang1",
    "\u39F9": "tik1",
    "\u39FA": "taap3",
    "\u39FB": "duk1",
    "\u39FC": "biu2",
    "\u39FD": "gu3/gwu3",
    "\u39FE": "fat1",
    "\u39FF": "cung1",
    "\u3A00": "bing2",
    "\u3A01": "zi6",
    "\u3A02": "dung2",
    "\u3A03": "deoi2",
    "\u3A04": "zau1",
    "\u3A05": "neoi6/leoi6",
    "\u3A06": "lam5/lam6",
    "\u3A07": "po4",
    "\u3A08": "zai1",
    "\u3A09": "man4",
    "\u3A0A": "wai5",
    "\u3A0B": "ce2",
    "\u3A0C": "gau3",
    "\u3A0D": "bong1",
    "\u3A0E": "jyu5",
    "\u3A0F": "taan1",
    "\u3A10": "bau2",
    "\u3A11": "zung1",
    "\u3A12": "fui1",
    "\u3A13": "lou4",
    "\u3A14": "ham6",
    "\u3A15": "jing4",
    "\u3A16": "zi3",
    "\u3A17": "zit6/zit3/cip3",
    "\u3A18": "saang2/sang3",
    "\u3A19": "haai4",
    "\u3A1A": "seon1",
    "\u3A1B": "sim2",
    "\u3A1C": "kin4",
    "\u3A1D": "sit3",
    "\u3A1E": "sou3",
    "\u3A1F": "goi1",
    "\u3A20": "mik6",
    "\u3A21": "wat6",
    "\u3A22": "pei1",
    "\u3A23": "jung2",
    "\u3A24": "kwaai5",
    "\u3A25": "naap6/laap6",
    "\u3A26": "sung2",
    "\u3A27": "ban6",
    "\u3A28": "cau1",
    "\u3A29": "zit6",
    "\u3A2A": "fong2",
    "\u3A2B": "laam5",
    "\u3A2C": "jyun4",
    "\u3A2D": "wu6",
    "\u3A2E": "dau1",
    "\u3A2F": "kwok3/kok3",
    "\u3A30": "gwan3",
    "\u3A31": "jiu4",
    "\u3A32": "caak3",
    "\u3A33": "gwai2",
    "\u3A34": "kin2",
    "\u3A35": "zin2",
    "\u3A36": "dou2",
    "\u3A37": "gan3",
    "\u3A38": "maat3",
    "\u3A39": "wai6",
    "\u3A3A": "min5",
    "\u3A3B": "caam4",
    "\u3A3C": "loek6",
    "\u3A3D": "bik1",
    "\u3A3E": "joeng6",
    "\u3A3F": "geoi3",
    "\u3A40": "geoi3",
    "\u3A41": "kok1",
    "\u3A42": "huk6",
    "\u3A43": "gin2",
    "\u3A44": "saai1",
    "\u3A45": "cau1",
    "\u3A46": "zau3",
    "\u3A47": "waak6",
    "\u3A48": "wan5",
    "\u3A49": "daap3",
    "\u3A4A": "syun1",
    "\u3A4B": "sok1/siu1",
    "\u3A4C": "fei6",
    "\u3A4D": "caak3",
    "\u3A4E": "jip3",
    "\u3A4F": "hak1",
    "\u3A50": "dan3/dan6",
    "\u3A51": "saap3",
    "\u3A52": "gam6",
    "\u3A53": "wai2",
    "\u3A54": "tyun4",
    "\u3A55": "ling1",
    "\u3A56": "koeng4",
    "\u3A57": "kwai4",
    "\u3A58": "ji5",
    "\u3A59": "sak1",
    "\u3A5A": "mung4",
    "\u3A5B": "tyun4",
    "\u3A5C": "laam5/laam2",
    "\u3A5D": "hou4",
    "\u3A5E": "caak3",
    "\u3A5F": "zaai6",
    "\u3A60": "ou1/ngou1",
    "\u3A61": "lo2",
    "\u3A62": "mit6",
    "\u3A63": "fai1",
    "\u3A64": "fu1",
    "\u3A65": "cim1",
    "\u3A66": "kwai4",
    "\u3A67": "bok1",
    "\u3A68": "wai6",
    "\u3A69": "king2",
    "\u3A6A": "kit3",
    "\u3A6B": "zat1",
    "\u3A6C": "hei1",
    "\u3A6D": "gaau2",
    "\u3A6E": "geoi2",
    "\u3A6F": "pun4",
    "\u3A70": "ziu2",
    "\u3A71": "zoek3",
    "\u3A72": "kyun4",
    "\u3A73": "sung2",
    "\u3A74": "guk1",
    "\u3A75": "ngaat6/aat6",
    "\u3A76": "nip6/lip6",
    "\u3A77": "hin1",
    "\u3A78": "dip6",
    "\u3A79": "dip6",
    "\u3A7A": "pei1",
    "\u3A7B": "kei1",
    "\u3A7C": "zi1",
    "\u3A7D": "kei4",
    "\u3A7E": "zeoi1",
    "\u3A7F": "fat1",
    "\u3A80": "jyu1",
    "\u3A81": "kam4",
    "\u3A82": "fat1",
    "\u3A83": "ho2",
    "\u3A84": "fat6",
    "\u3A85": "gang1",
    "\u3A86": "dai2",
    "\u3A87": "sin3",
    "\u3A88": "gwai3",
    "\u3A89": "hap6",
    "\u3A8A": "kwan4",
    "\u3A8B": "hon6",
    "\u3A8C": "tung2",
    "\u3A8D": "bui6/but6",
    "\u3A8E": "sim2",
    "\u3A8F": "bai2",
    "\u3A90": "leot6",
    "\u3A91": "jip3",
    "\u3A92": "ngai4/ai4",
    "\u3A93": "ceoi4",
    "\u3A94": "saan3",
    "\u3A95": "diu6",
    "\u3A96": "luk6",
    "\u3A97": "tau2",
    "\u3A98": "lim5",
    "\u3A99": "fo2",
    "\u3A9A": "saan3/saan2",
    "\u3A9B": "zam2",
    "\u3A9C": "ceoi2",
    "\u3A9D": "lin6",
    "\u3A9E": "mou6",
    "\u3A9F": "deon1/deoi1/deoi3/tyun4",
    "\u3AA0": "zaam1",
    "\u3AA1": "koi3",
    "\u3AA2": "saau2",
    "\u3AA3": "hiu1",
    "\u3AA4": "bat1",
    "\u3AA5": "zaa1",
    "\u3AA6": "jan6",
    "\u3AA7": "jap1",
    "\u3AA8": "sin6",
    "\u3AA9": "sok1",
    "\u3AAA": "saap3",
    "\u3AAB": "jeoi6",
    "\u3AAC": "coek3",
    "\u3AAD": "lou4",
    "\u3AAE": "ling4",
    "\u3AAF": "geoi2",
    "\u3AB0": "zaai1",
    "\u3AB1": "wun6",
    "\u3AB2": "dau2",
    "\u3AB3": "dau2",
    "\u3AB4": "git3",
    "\u3AB5": "bun3",
    "\u3AB6": "huk6",
    "\u3AB7": "dau2",
    "\u3AB8": "zam1",
    "\u3AB9": "lau5",
    "\u3ABA": "keoi1",
    "\u3ABB": "gyun3",
    "\u3ABC": "ho2",
    "\u3ABD": "so2",
    "\u3ABE": "lok6",
    "\u3ABF": "zit3",
    "\u3AC0": "ding2",
    "\u3AC1": "dyun6",
    "\u3AC2": "zyu3",
    "\u3AC3": "jin2",
    "\u3AC4": "pong4",
    "\u3AC5": "kei4",
    "\u3AC6": "ji5",
    "\u3AC7": "jyu1",
    "\u3AC8": "jyu1",
    "\u3AC9": "ngai4/ai4",
    "\u3ACA": "ji2",
    "\u3ACB": "zin1",
    "\u3ACC": "syun4",
    "\u3ACD": "jau4",
    "\u3ACE": "fai1",
    "\u3ACF": "jiu2",
    "\u3AD0": "jiu2",
    "\u3AD1": "zi2",
    "\u3AD2": "gung1",
    "\u3AD3": "hei3",
    "\u3AD4": "gan3",
    "\u3AD5": "gwong1/gong1",
    "\u3AD6": "zi2",
    "\u3AD7": "hau5",
    "\u3AD8": "mat6",
    "\u3AD9": "fu4",
    "\u3ADA": "fat1",
    "\u3ADB": "gwong3/gong3",
    "\u3ADC": "taan2",
    "\u3ADD": "dai1",
    "\u3ADE": "tou1",
    "\u3ADF": "jyun4",
    "\u3AE0": "bun3",
    "\u3AE1": "dung1",
    "\u3AE2": "heoi3",
    "\u3AE3": "man5",
    "\u3AE4": "cong2",
    "\u3AE5": "ming4",
    "\u3AE6": "tou1",
    "\u3AE7": "bou6",
    "\u3AE8": "on1/ngon1",
    "\u3AE9": "ceon1",
    "\u3AEA": "zung1",
    "\u3AEB": "hin2",
    "\u3AEC": "ceon4",
    "\u3AED": "si4",
    "\u3AEE": "ci2",
    "\u3AEF": "mou6",
    "\u3AF0": "long6",
    "\u3AF1": "naan5/laan5",
    "\u3AF2": "pui3",
    "\u3AF3": "san4",
    "\u3AF4": "haau1",
    "\u3AF5": "fei1",
    "\u3AF6": "zau2",
    "\u3AF7": "gei1",
    "\u3AF8": "zip3",
    "\u3AF9": "so3",
    "\u3AFA": "sik1",
    "\u3AFB": "gwan3",
    "\u3AFC": "zit3",
    "\u3AFD": "luk6",
    "\u3AFE": "soeng6",
    "\u3AFF": "zeoi1",
    "\u3B00": "hoeng2",
    "\u3B01": "caap3",
    "\u3B02": "jyu4",
    "\u3B03": "toi4",
    "\u3B04": "caan3",
    "\u3B05": "maan6",
    "\u3B06": "man5",
    "\u3B07": "wun6",
    "\u3B08": "wan1",
    "\u3B09": "nyun5/lyun5",
    "\u3B0A": "wun6",
    "\u3B0B": "hau4",
    "\u3B0C": "ging2",
    "\u3B0D": "bok3",
    "\u3B0E": "hin2",
    "\u3B0F": "lik6",
    "\u3B10": "zeon3",
    "\u3B11": "gwok3/gok3",
    "\u3B12": "mong5",
    "\u3B13": "piu3",
    "\u3B14": "hou4",
    "\u3B15": "joeng4",
    "\u3B16": "kai2",
    "\u3B17": "nin6/lin6",
    "\u3B18": "suk1",
    "\u3B19": "wai5",
    "\u3B1A": "cit3",
    "\u3B1B": "kap1",
    "\u3B1C": "zeon3",
    "\u3B1D": "cang4",
    "\u3B1E": "hot3",
    "\u3B1F": "fan1",
    "\u3B20": "saai3/saat3",
    "\u3B21": "ling4",
    "\u3B22": "hei1",
    "\u3B23": "deoi6",
    "\u3B24": "jap1",
    "\u3B25": "bou6/buk6",
    "\u3B26": "wok3",
    "\u3B27": "bou6",
    "\u3B28": "haak1",
    "\u3B29": "wai3",
    "\u3B2A": "dip6/daap6",
    "\u3B2B": "jin3",
    "\u3B2C": "keoi4",
    "\u3B2D": "zoek3/ziu3/ziu6",
    "\u3B2E": "naan6/laan6",
    "\u3B2F": "lip6",
    "\u3B30": "jyu4",
    "\u3B31": "tai3",
    "\u3B32": "tim1",
    "\u3B33": "ng5/m5",
    "\u3B34": "hung2",
    "\u3B35": "gaau1",
    "\u3B36": "hou6",
    "\u3B37": "kwan3",
    "\u3B38": "tiu1",
    "\u3B39": "zaang1",
    "\u3B3A": "tang4",
    "\u3B3B": "fong1",
    "\u3B3C": "fuk6",
    "\u3B3D": "ngok6/ok6",
    "\u3B3E": "tyun4",
    "\u3B3F": "tan1",
    "\u3B40": "sai6",
    "\u3B41": "jing4",
    "\u3B42": "niu1/liu1",
    "\u3B43": "gong1",
    "\u3B44": "seon3",
    "\u3B45": "saam1",
    "\u3B46": "naai5/laai5",
    "\u3B47": "jyun6",
    "\u3B48": "kyut3",
    "\u3B49": "waa4",
    "\u3B4A": "sik1/cik1",
    "\u3B4B": "paang5",
    "\u3B4C": "jyu4",
    "\u3B4D": "cat1",
    "\u3B4E": "gong1/gong3",
    "\u3B4F": "wai5",
    "\u3B50": "daai6",
    "\u3B51": "mui6",
    "\u3B52": "zi6",
    "\u3B53": "bin6",
    "\u3B54": "lou4",
    "\u3B55": "keoi1",
    "\u3B56": "doi6",
    "\u3B57": "ming5",
    "\u3B58": "gap3",
    "\u3B59": "zaak6",
    "\u3B5A": "leoi5",
    "\u3B5B": "paai3",
    "\u3B5C": "jung4",
    "\u3B5D": "kau4",
    "\u3B5E": "lyut3",
    "\u3B5F": "gung2",
    "\u3B60": "sin2",
    "\u3B61": "sai3",
    "\u3B62": "hing1",
    "\u3B63": "man6",
    "\u3B64": "niu5/liu5",
    "\u3B65": "fu6",
    "\u3B66": "zaak6",
    "\u3B67": "zau1",
    "\u3B68": "je4",
    "\u3B69": "lyut6",
    "\u3B6A": "fu1",
    "\u3B6B": "co4",
    "\u3B6C": "doek3",
    "\u3B6D": "baat3",
    "\u3B6E": "zaat3",
    "\u3B6F": "zip3",
    "\u3B70": "zeoi2",
    "\u3B71": "haap6",
    "\u3B72": "gik6",
    "\u3B73": "haau3",
    "\u3B74": "gin1",
    "\u3B75": "din6",
    "\u3B76": "fong1",
    "\u3B77": "naam4/laam4",
    "\u3B78": "tou4",
    "\u3B79": "jin4",
    "\u3B7A": "jim2",
    "\u3B7B": "tong4",
    "\u3B7C": "taap3",
    "\u3B7D": "dai2",
    "\u3B7E": "gwat6",
    "\u3B7F": "ngong4/ong4",
    "\u3B80": "haam4",
    "\u3B81": "haau4",
    "\u3B82": "guk1",
    "\u3B83": "wai1",
    "\u3B84": "bong2",
    "\u3B85": "zeoi1",
    "\u3B86": "jit6",
    "\u3B87": "tim3",
    "\u3B88": "noi6/loi6",
    "\u3B89": "hap6",
    "\u3B8A": "mau6",
    "\u3B8B": "jau5",
    "\u3B8C": "min4",
    "\u3B8D": "zin1",
    "\u3B8E": "bui1",
    "\u3B8F": "noi6/loi6",
    "\u3B90": "saang2",
    "\u3B91": "caap3",
    "\u3B92": "jim5",
    "\u3B93": "gang2",
    "\u3B94": "cung3",
    "\u3B95": "jyun5",
    "\u3B96": "git3",
    "\u3B97": "ging1",
    "\u3B98": "mou4",
    "\u3B99": "ngok6/ok6",
    "\u3B9A": "leot6",
    "\u3B9B": "ci4",
    "\u3B9C": "zong1",
    "\u3B9D": "hat6",
    "\u3B9E": "zit3",
    "\u3B9F": "nin2/lin2",
    "\u3BA0": "wing4",
    "\u3BA1": "gun3/gwun3",
    "\u3BA2": "hau4",
    "\u3BA3": "koi3",
    "\u3BA4": "cung4",
    "\u3BA5": "ban6",
    "\u3BA6": "sok3",
    "\u3BA7": "wu1",
    "\u3BA8": "zik1",
    "\u3BA9": "sik1",
    "\u3BAA": "kung4",
    "\u3BAB": "hot6",
    "\u3BAC": "jung1",
    "\u3BAD": "gaam1",
    "\u3BAE": "git3",
    "\u3BAF": "wan4",
    "\u3BB0": "pei4",
    "\u3BB1": "sing1",
    "\u3BB2": "cau1",
    "\u3BB3": "zan6",
    "\u3BB4": "sau1",
    "\u3BB5": "zin1",
    "\u3BB6": "sok3",
    "\u3BB7": "gai1",
    "\u3BB8": "sung3",
    "\u3BB9": "zi2",
    "\u3BBA": "bun2",
    "\u3BBB": "sou1",
    "\u3BBC": "sin3",
    "\u3BBD": "pun4",
    "\u3BBE": "long5",
    "\u3BBF": "bat1",
    "\u3BC0": "syun6",
    "\u3BC1": "pui4",
    "\u3BC2": "daai3",
    "\u3BC3": "cat1",
    "\u3BC4": "zi1",
    "\u3BC5": "pei4",
    "\u3BC6": "caan2",
    "\u3BC7": "bai6",
    "\u3BC8": "cuk1",
    "\u3BC9": "wok6",
    "\u3BCA": "han4",
    "\u3BCB": "gwing2",
    "\u3BCC": "cyun4",
    "\u3BCD": "zoeng2",
    "\u3BCE": "nyun6/lyun6",
    "\u3BCF": "guk1",
    "\u3BD0": "to5",
    "\u3BD1": "zoeng1",
    "\u3BD2": "mik6",
    "\u3BD3": "taap3",
    "\u3BD4": "ceoi3",
    "\u3BD5": "sai1",
    "\u3BD6": "dak6",
    "\u3BD7": "haan4",
    "\u3BD8": "fun2",
    "\u3BD9": "zit6",
    "\u3BDA": "daap3",
    "\u3BDB": "wu4",
    "\u3BDC": "zyut6",
    "\u3BDD": "lou6",
    "\u3BDE": "gyun3",
    "\u3BDF": "luk1",
    "\u3BE0": "hin3",
    "\u3BE1": "paau3",
    "\u3BE2": "zam6",
    "\u3BE3": "fan1",
    "\u3BE4": "gik1",
    "\u3BE5": "cou4",
    "\u3BE6": "kei4",
    "\u3BE7": "ciu1",
    "\u3BE8": "suk1",
    "\u3BE9": "tai3",
    "\u3BEA": "ling4",
    "\u3BEB": "keoi4",
    "\u3BEC": "lim5",
    "\u3BED": "lou5",
    "\u3BEE": "suk6",
    "\u3BEF": "gung3",
    "\u3BF0": "zik6",
    "\u3BF1": "pou1",
    "\u3BF2": "gam3",
    "\u3BF3": "king4",
    "\u3BF4": "jung4",
    "\u3BF5": "dung2",
    "\u3BF6": "zung1",
    "\u3BF7": "buk6",
    "\u3BF8": "zeon2",
    "\u3BF9": "biu2",
    "\u3BFA": "haam6",
    "\u3BFB": "gwan2",
    "\u3BFC": "goi3",
    "\u3BFD": "ban1",
    "\u3BFE": "zou1",
    "\u3BFF": "lip6",
    "\u3C00": "lai4",
    "\u3C01": "lo5",
    "\u3C02": "sam2",
    "\u3C03": "min4",
    "\u3C04": "zin1",
    "\u3C05": "dik1",
    "\u3C06": "bai6",
    "\u3C07": "cim1",
    "\u3C08": "lim5",
    "\u3C09": "zeon1",
    "\u3C0A": "cim4",
    "\u3C0B": "pan4",
    "\u3C0C": "kok3",
    "\u3C0D": "lung4",
    "\u3C0E": "zeoi3",
    "\u3C0F": "gou1",
    "\u3C10": "to5",
    "\u3C11": "saam1",
    "\u3C12": "hok6",
    "\u3C13": "laam5",
    "\u3C14": "sip3",
    "\u3C15": "hei1",
    "\u3C16": "laam5",
    "\u3C17": "cik1",
    "\u3C18": "ji4",
    "\u3C19": "no4/lo4",
    "\u3C1A": "lei4",
    "\u3C1B": "joek6",
    "\u3C1C": "din1",
    "\u3C1D": "ji5",
    "\u3C1E": "ci1",
    "\u3C1F": "gat1",
    "\u3C20": "hong1",
    "\u3C21": "haai3",
    "\u3C22": "hang1",
    "\u3C23": "zi1",
    "\u3C24": "ho1",
    "\u3C25": "hai3",
    "\u3C26": "heoi3",
    "\u3C27": "hoi1",
    "\u3C28": "haai1",
    "\u3C29": "hoi1",
    "\u3C2A": "gwai1",
    "\u3C2B": "caam1",
    "\u3C2C": "seon1",
    "\u3C2D": "heoi1",
    "\u3C2E": "san6",
    "\u3C2F": "tau3",
    "\u3C30": "gaap3",
    "\u3C31": "saap3",
    "\u3C32": "juk1",
    "\u3C33": "aa3/ngaa3",
    "\u3C34": "fau6",
    "\u3C35": "zeot1",
    "\u3C36": "jau2",
    "\u3C37": "zi3",
    "\u3C38": "lim5",
    "\u3C39": "him1",
    "\u3C3A": "haa6",
    "\u3C3B": "ji2",
    "\u3C3C": "sip3",
    "\u3C3D": "jin3",
    "\u3C3E": "giu3",
    "\u3C3F": "hei1",
    "\u3C40": "zyut3",
    "\u3C41": "seoi3",
    "\u3C42": "hong1",
    "\u3C43": "jam2/jam3",
    "\u3C44": "hak1",
    "\u3C45": "ji3",
    "\u3C46": "hei1",
    "\u3C47": "sik1",
    "\u3C48": "gam6",
    "\u3C49": "jip6",
    "\u3C4A": "jau1",
    "\u3C4B": "kok3",
    "\u3C4C": "jip3",
    "\u3C4D": "lyun4",
    "\u3C4E": "gwan1",
    "\u3C4F": "zing3",
    "\u3C50": "zing3",
    "\u3C51": "seoi3",
    "\u3C52": "ho1",
    "\u3C53": "ling4",
    "\u3C54": "se1",
    "\u3C55": "gwai1",
    "\u3C56": "seoi6",
    "\u3C57": "jau1",
    "\u3C58": "jim2",
    "\u3C59": "nau2/lau2/jau2",
    "\u3C5A": "caan4",
    "\u3C5B": "daai2",
    "\u3C5C": "zaat3",
    "\u3C5D": "sei2",
    "\u3C5E": "ngap6/ap6",
    "\u3C5F": "pei1",
    "\u3C60": "fu1",
    "\u3C61": "sing1",
    "\u3C62": "long4",
    "\u3C63": "teoi2",
    "\u3C64": "sik1",
    "\u3C65": "ling4",
    "\u3C66": "kei1",
    "\u3C67": "waat3",
    "\u3C68": "lim5/lim6",
    "\u3C69": "duk6",
    "\u3C6A": "fan1",
    "\u3C6B": "laan6",
    "\u3C6C": "wui2",
    "\u3C6D": "dyun6",
    "\u3C6E": "kui2/kwui2",
    "\u3C6F": "ngoi4/oi4",
    "\u3C70": "zoi2",
    "\u3C71": "wui6",
    "\u3C72": "ji3",
    "\u3C73": "mok6",
    "\u3C74": "zi6",
    "\u3C75": "fan3",
    "\u3C76": "pang4",
    "\u3C77": "zaap6",
    "\u3C78": "pik1",
    "\u3C79": "lik6",
    "\u3C7A": "leoi4",
    "\u3C7B": "lo6",
    "\u3C7C": "hoi1",
    "\u3C7D": "dam2",
    "\u3C7E": "goi1",
    "\u3C7F": "kok3",
    "\u3C80": "zan1",
    "\u3C81": "hung1",
    "\u3C82": "cang4",
    "\u3C83": "gau3",
    "\u3C84": "huk1",
    "\u3C85": "gai3",
    "\u3C86": "ling4",
    "\u3C87": "dung1",
    "\u3C88": "siu4",
    "\u3C89": "kok3",
    "\u3C8A": "jeoi6",
    "\u3C8B": "coek3",
    "\u3C8C": "ning6/ling6",
    "\u3C8D": "zi1",
    "\u3C8E": "leoi4",
    "\u3C8F": "pou1",
    "\u3C90": "gam1",
    "\u3C91": "seoi2",
    "\u3C92": "bou6",
    "\u3C93": "syu3",
    "\u3C94": "sin1",
    "\u3C95": "laai6",
    "\u3C96": "siu1",
    "\u3C97": "fu1",
    "\u3C98": "keoi4",
    "\u3C99": "sau1",
    "\u3C9A": "saa1",
    "\u3C9B": "zi2",
    "\u3C9C": "taan2",
    "\u3C9D": "jung5",
    "\u3C9E": "seot1",
    "\u3C9F": "jing2",
    "\u3CA0": "mou4",
    "\u3CA1": "noi6/loi6",
    "\u3CA2": "bin6",
    "\u3CA3": "sau1",
    "\u3CA4": "seoi1",
    "\u3CA5": "tong4",
    "\u3CA6": "hon6",
    "\u3CA7": "sou3",
    "\u3CA8": "jung4",
    "\u3CA9": "taap3",
    "\u3CAA": "dang1",
    "\u3CAB": "buk6",
    "\u3CAC": "ziu1",
    "\u3CAD": "taan2",
    "\u3CAE": "taap3",
    "\u3CAF": "laam4",
    "\u3CB0": "ning4/ling4",
    "\u3CB1": "lip6",
    "\u3CB2": "dip6",
    "\u3CB3": "dit6",
    "\u3CB4": "zung3",
    "\u3CB5": "siu1",
    "\u3CB6": "lou5",
    "\u3CB7": "daam6",
    "\u3CB8": "kap1",
    "\u3CB9": "gwai2",
    "\u3CBA": "cat1",
    "\u3CBB": "nik6/lik6",
    "\u3CBC": "ngaai6/aai6",
    "\u3CBD": "nin6/lin6",
    "\u3CBE": "jyu5",
    "\u3CBF": "wong2",
    "\u3CC0": "gwo3/go3",
    "\u3CC1": "zak1",
    "\u3CC2": "jyun4",
    "\u3CC3": "ceoi3",
    "\u3CC4": "jin4",
    "\u3CC5": "lau4",
    "\u3CC6": "tau2",
    "\u3CC7": "fu6",
    "\u3CC8": "pui3",
    "\u3CC9": "jyut6",
    "\u3CCA": "jau4",
    "\u3CCB": "jau1",
    "\u3CCC": "aap3/ngaap3",
    "\u3CCD": "bou3",
    "\u3CCE": "bin6",
    "\u3CCF": "si3",
    "\u3CD0": "zaat6",
    "\u3CD1": "jat6",
    "\u3CD2": "faat3",
    "\u3CD3": "jau6",
    "\u3CD4": "deoi6",
    "\u3CD5": "laan4",
    "\u3CD6": "ji1",
    "\u3CD7": "caai3",
    "\u3CD8": "cung1",
    "\u3CD9": "gyun1",
    "\u3CDA": "wat1",
    "\u3CDB": "jyu4",
    "\u3CDC": "jau1",
    "\u3CDD": "hong1",
    "\u3CDE": "cung1",
    "\u3CDF": "hung4",
    "\u3CE0": "taat3",
    "\u3CE1": "wo1",
    "\u3CE2": "kiu4",
    "\u3CE3": "lou5",
    "\u3CE4": "suk6",
    "\u3CE5": "lung6",
    "\u3CE6": "haai6",
    "\u3CE7": "cip3",
    "\u3CE8": "zaat3",
    "\u3CE9": "taam1",
    "\u3CEA": "pei3",
    "\u3CEB": "zaam2",
    "\u3CEC": "syun4",
    "\u3CED": "jin4",
    "\u3CEE": "niu6/liu6",
    "\u3CEF": "san1",
    "\u3CF0": "kau1",
    "\u3CF1": "joeng4",
    "\u3CF2": "taai3",
    "\u3CF3": "hak1",
    "\u3CF4": "mat6",
    "\u3CF5": "gwai3",
    "\u3CF6": "nau5/lau5",
    "\u3CF7": "fui3",
    "\u3CF8": "faa1",
    "\u3CF9": "wong2",
    "\u3CFA": "jau4",
    "\u3CFB": "zaak3",
    "\u3CFC": "bat1",
    "\u3CFD": "nei4/lei4",
    "\u3CFE": "goeng1",
    "\u3CFF": "sit3",
    "\u3D00": "faan1",
    "\u3D01": "jik1",
    "\u3D02": "taam1",
    "\u3D03": "leoi6",
    "\u3D04": "wang2",
    "\u3D05": "siu1",
    "\u3D06": "zam3",
    "\u3D07": "sip3",
    "\u3D08": "ngan6/an6",
    "\u3D09": "zai3",
    "\u3D0A": "jyun1",
    "\u3D0B": "suk1",
    "\u3D0C": "gu1/gwu1",
    "\u3D0D": "sing4",
    "\u3D0E": "noi6/loi6",
    "\u3D0F": "wong2",
    "\u3D10": "min6",
    "\u3D11": "sou3",
    "\u3D12": "jik6",
    "\u3D13": "saai1",
    "\u3D14": "kap1",
    "\u3D15": "wo4",
    "\u3D16": "lok6",
    "\u3D17": "jau1",
    "\u3D18": "mou6",
    "\u3D19": "zaap3",
    "\u3D1A": "seoi6",
    "\u3D1B": "zi3",
    "\u3D1C": "pin3",
    "\u3D1D": "lai4",
    "\u3D1E": "tou1",
    "\u3D1F": "hau5",
    "\u3D20": "haam4",
    "\u3D21": "hoeng1",
    "\u3D22": "cung1",
    "\u3D23": "ji4",
    "\u3D24": "cyu5",
    "\u3D25": "ciu3",
    "\u3D26": "gun3/gwun3",
    "\u3D27": "sik1",
    "\u3D28": "zam6",
    "\u3D29": "jung1",
    "\u3D2A": "jit6",
    "\u3D2B": "gwan3",
    "\u3D2C": "ze6",
    "\u3D2D": "jiu2",
    "\u3D2E": "sit3",
    "\u3D2F": "zi1",
    "\u3D30": "nang4/lang4",
    "\u3D31": "sam1",
    "\u3D32": "si1",
    "\u3D33": "lung5",
    "\u3D34": "zaam3",
    "\u3D35": "mat6",
    "\u3D36": "kok3",
    "\u3D37": "daam1",
    "\u3D38": "sim2",
    "\u3D39": "mai4",
    "\u3D3A": "zip3",
    "\u3D3B": "syu6",
    "\u3D3C": "suk1",
    "\u3D3D": "sit3",
    "\u3D3E": "but6",
    "\u3D3F": "ding2",
    "\u3D40": "zuk6",
    "\u3D41": "fong1",
    "\u3D42": "syu3",
    "\u3D43": "se4",
    "\u3D44": "hon3",
    "\u3D45": "taam1",
    "\u3D46": "gou2",
    "\u3D47": "tim4",
    "\u3D48": "gu1/gwu1",
    "\u3D49": "lam4",
    "\u3D4A": "naap6/laap6",
    "\u3D4B": "mik6",
    "\u3D4C": "ceon4",
    "\u3D4D": "mun5",
    "\u3D4E": "gaan3",
    "\u3D4F": "ceoi2",
    "\u3D50": "kyut3",
    "\u3D51": "ho6",
    "\u3D52": "fai3",
    "\u3D53": "zik6",
    "\u3D54": "ce2",
    "\u3D55": "sam3",
    "\u3D56": "neoi6/leoi6",
    "\u3D57": "pang4",
    "\u3D58": "maan6",
    "\u3D59": "hei2",
    "\u3D5A": "fu2",
    "\u3D5B": "sin6",
    "\u3D5C": "naam5/laam5",
    "\u3D5D": "jeoi6",
    "\u3D5E": "sau4",
    "\u3D5F": "mei4",
    "\u3D60": "fat1",
    "\u3D61": "bok6",
    "\u3D62": "leoi4",
    "\u3D63": "hot3",
    "\u3D64": "saap3",
    "\u3D65": "mat6",
    "\u3D66": "seoi5",
    "\u3D67": "got3",
    "\u3D68": "pei3",
    "\u3D69": "jai6",
    "\u3D6A": "jin4",
    "\u3D6B": "nap6/lap6",
    "\u3D6C": "jing4",
    "\u3D6D": "zyu2",
    "\u3D6E": "seon4",
    "\u3D6F": "fung4",
    "\u3D70": "zeoi6",
    "\u3D71": "piu2",
    "\u3D72": "mou5",
    "\u3D73": "liu4",
    "\u3D74": "cong4",
    "\u3D75": "zau6",
    "\u3D76": "zit3",
    "\u3D77": "bin6",
    "\u3D78": "joek6",
    "\u3D79": "wun4",
    "\u3D7A": "paai4",
    "\u3D7B": "jau1",
    "\u3D7C": "se3",
    "\u3D7D": "leoi5",
    "\u3D7E": "cing3",
    "\u3D7F": "jiu5",
    "\u3D80": "gaau1",
    "\u3D81": "gwik1",
    "\u3D82": "wong4",
    "\u3D83": "mou5",
    "\u3D84": "jim4",
    "\u3D85": "hok6",
    "\u3D86": "zyu1",
    "\u3D87": "waang4",
    "\u3D88": "jing4",
    "\u3D89": "kai1",
    "\u3D8A": "can2",
    "\u3D8B": "jeoi6",
    "\u3D8C": "lin4",
    "\u3D8D": "sin2",
    "\u3D8E": "waan4",
    "\u3D8F": "jan1/jan2",
    "\u3D90": "jing3",
    "\u3D91": "lim6",
    "\u3D92": "sim2",
    "\u3D93": "cong4",
    "\u3D94": "baai6",
    "\u3D95": "gaan2",
    "\u3D96": "suk1",
    "\u3D97": "faan6",
    "\u3D98": "tim5",
    "\u3D99": "jeoi6",
    "\u3D9A": "baa3",
    "\u3D9B": "jyu4",
    "\u3D9C": "jyun1",
    "\u3D9D": "jing3",
    "\u3D9E": "nong5/long5",
    "\u3D9F": "leoi5",
    "\u3DA0": "jik6",
    "\u3DA1": "daai6",
    "\u3DA2": "gau2",
    "\u3DA3": "cim4",
    "\u3DA4": "caau2",
    "\u3DA5": "gon1",
    "\u3DA6": "zeon6",
    "\u3DA7": "nyun6/lyun6",
    "\u3DA8": "pui1",
    "\u3DA9": "jam4",
    "\u3DAA": "pui1",
    "\u3DAB": "liu5",
    "\u3DAC": "mut6",
    "\u3DAD": "jau2",
    "\u3DAE": "siu1",
    "\u3DAF": "lau6",
    "\u3DB0": "ham4",
    "\u3DB1": "bun2",
    "\u3DB2": "jung6",
    "\u3DB3": "zeon6/zeon2",
    "\u3DB4": "ci2",
    "\u3DB5": "jam6",
    "\u3DB6": "nung1/lung1",
    "\u3DB7": "ceon4",
    "\u3DB8": "hip3",
    "\u3DB9": "hung6",
    "\u3DBA": "tim3",
    "\u3DBB": "fung1",
    "\u3DBC": "zeon3",
    "\u3DBD": "wo1",
    "\u3DBE": "biu6",
    "\u3DBF": "but6",
    "\u3DC0": "king4",
    "\u3DC1": "jung2",
    "\u3DC2": "seoi5",
    "\u3DC3": "ceoi2",
    "\u3DC4": "fui2",
    "\u3DC5": "caau2",
    "\u3DC6": "fau6",
    "\u3DC7": "fui1",
    "\u3DC8": "ap1/ngap1",
    "\u3DC9": "wai3",
    "\u3DCA": "fan4",
    "\u3DCB": "taam4",
    "\u3DCC": "zau2",
    "\u3DCD": "leon4",
    "\u3DCE": "hot3",
    "\u3DCF": "jung2",
    "\u3DD0": "wai2",
    "\u3DD1": "jin1",
    "\u3DD2": "jyu4",
    "\u3DD3": "zung2",
    "\u3DD4": "jim6",
    "\u3DD5": "cau4",
    "\u3DD6": "ziu3",
    "\u3DD7": "gwing2",
    "\u3DD8": "toi4",
    "\u3DD9": "zin1",
    "\u3DDA": "ting4",
    "\u3DDB": "bou1",
    "\u3DDC": "jik6",
    "\u3DDD": "dat6",
    "\u3DDE": "hau5",
    "\u3DDF": "teoi3",
    "\u3DE0": "leon4",
    "\u3DE1": "gwing2",
    "\u3DE2": "zaa2",
    "\u3DE3": "sing1",
    "\u3DE4": "huk1",
    "\u3DE5": "zing1",
    "\u3DE6": "gwik1",
    "\u3DE7": "jyun4",
    "\u3DE8": "fung1",
    "\u3DE9": "hei1",
    "\u3DEA": "zeon3",
    "\u3DEB": "hing3",
    "\u3DEC": "mok6",
    "\u3DED": "fung1",
    "\u3DEE": "zou1",
    "\u3DEF": "bung6",
    "\u3DF0": "ci1",
    "\u3DF1": "hung4",
    "\u3DF2": "dung6",
    "\u3DF3": "ngon6/on6",
    "\u3DF4": "lik6",
    "\u3DF5": "mak6",
    "\u3DF6": "bik1",
    "\u3DF7": "zeon3",
    "\u3DF8": "jip6",
    "\u3DF9": "zaau3",
    "\u3DFA": "saat3",
    "\u3DFB": "mou4",
    "\u3DFC": "jin3",
    "\u3DFD": "sin6",
    "\u3DFE": "koek3",
    "\u3DFF": "him1",
    "\u3E00": "toi4",
    "\u3E01": "hon3",
    "\u3E02": "seoi6",
    "\u3E03": "dim2",
    "\u3E04": "zai6",
    "\u3E05": "zit3",
    "\u3E06": "kaau3",
    "\u3E07": "zyun3",
    "\u3E08": "ziu1",
    "\u3E09": "sit3",
    "\u3E0A": "laai6",
    "\u3E0B": "faan4",
    "\u3E0C": "fok3",
    "\u3E0D": "hei3",
    "\u3E0E": "nip6/lip6",
    "\u3E0F": "mei4",
    "\u3E10": "jin4",
    "\u3E11": "cyun3",
    "\u3E12": "jam4",
    "\u3E13": "mat6",
    "\u3E14": "hon3",
    "\u3E15": "fok3",
    "\u3E16": "ceoi1",
    "\u3E17": "tung4",
    "\u3E18": "maan6",
    "\u3E19": "ze1",
    "\u3E1A": "lei5",
    "\u3E1B": "siu4",
    "\u3E1C": "hung3",
    "\u3E1D": "him1",
    "\u3E1E": "zit3",
    "\u3E1F": "zi1",
    "\u3E20": "tiu5",
    "\u3E21": "syu4",
    "\u3E22": "bei6",
    "\u3E23": "jip6",
    "\u3E24": "pin3",
    "\u3E25": "zaam6",
    "\u3E26": "wu6",
    "\u3E27": "ngan4/an4",
    "\u3E28": "kau1",
    "\u3E29": "ngon4/on4",
    "\u3E2A": "seon4",
    "\u3E2B": "gin1",
    "\u3E2C": "bui3",
    "\u3E2D": "baa1",
    "\u3E2E": "fan4",
    "\u3E2F": "fo1",
    "\u3E30": "fo1",
    "\u3E31": "fo1",
    "\u3E32": "zok6",
    "\u3E33": "ling4",
    "\u3E34": "sek6",
    "\u3E35": "gwai2",
    "\u3E36": "jin1",
    "\u3E37": "sai6",
    "\u3E38": "hau6",
    "\u3E39": "lyut6",
    "\u3E3A": "saa1",
    "\u3E3B": "zi6",
    "\u3E3C": "fung1",
    "\u3E3D": "bui3",
    "\u3E3E": "jan6",
    "\u3E3F": "duk6",
    "\u3E40": "bui6",
    "\u3E41": "loeng4",
    "\u3E42": "jin4",
    "\u3E43": "he3/fe3",
    "\u3E44": "zik1",
    "\u3E45": "zung2",
    "\u3E46": "fai1",
    "\u3E47": "hot6",
    "\u3E48": "mou4",
    "\u3E49": "jyun4",
    "\u3E4A": "ngok6/ok6",
    "\u3E4B": "sau1",
    "\u3E4C": "caan2",
    "\u3E4D": "dik6",
    "\u3E4E": "leoi4",
    "\u3E4F": "gan2",
    "\u3E50": "sung4",
    "\u3E51": "sei3",
    "\u3E52": "pok3",
    "\u3E53": "jiu5",
    "\u3E54": "goeng1",
    "\u3E55": "waan4",
    "\u3E56": "waan6",
    "\u3E57": "tou1",
    "\u3E58": "jyu6",
    "\u3E59": "wang2",
    "\u3E5A": "wang2",
    "\u3E5B": "jiu4",
    "\u3E5C": "ngan4/an4",
    "\u3E5D": "si6",
    "\u3E5E": "ngan4/an4",
    "\u3E5F": "kyut3",
    "\u3E60": "tyun4",
    "\u3E61": "jyun4",
    "\u3E62": "gaa1",
    "\u3E63": "zung1",
    "\u3E64": "hip3",
    "\u3E65": "zyu3",
    "\u3E66": "diu1",
    "\u3E67": "ong1/ngong1",
    "\u3E68": "jau6",
    "\u3E69": "hing5",
    "\u3E6A": "saan1",
    "\u3E6B": "ji4",
    "\u3E6C": "si2",
    "\u3E6D": "jai6",
    "\u3E6E": "mak6",
    "\u3E6F": "jau1",
    "\u3E70": "gwong1/gong1",
    "\u3E71": "zoek3/coek3",
    "\u3E72": "haau1",
    "\u3E73": "ng4/m4",
    "\u3E74": "gang1",
    "\u3E75": "jing5",
    "\u3E76": "ting4",
    "\u3E77": "hei1",
    "\u3E78": "maau6",
    "\u3E79": "gang1",
    "\u3E7A": "daat3",
    "\u3E7B": "wo1",
    "\u3E7C": "guk1",
    "\u3E7D": "caan2",
    "\u3E7E": "piu5",
    "\u3E7F": "zuk6",
    "\u3E80": "fat1",
    "\u3E81": "nou5/lou5",
    "\u3E82": "ngaam4/aam4",
    "\u3E83": "gau2",
    "\u3E84": "jyu5",
    "\u3E85": "hau4",
    "\u3E86": "ban6",
    "\u3E87": "si1",
    "\u3E88": "ci1",
    "\u3E89": "kau3",
    "\u3E8A": "joeng6",
    "\u3E8B": "jung1",
    "\u3E8C": "laam6",
    "\u3E8D": "ban1/bin1",
    "\u3E8E": "jung4",
    "\u3E8F": "lau4/lau1",
    "\u3E90": "liu4",
    "\u3E91": "saam1",
    "\u3E92": "haau1",
    "\u3E93": "zaak3",
    "\u3E94": "hoi3",
    "\u3E95": "faan4",
    "\u3E96": "haam2",
    "\u3E97": "caan1",
    "\u3E98": "zaam3",
    "\u3E99": "sat6",
    "\u3E9A": "caat3",
    "\u3E9B": "zyu3",
    "\u3E9C": "nung4/lung4",
    "\u3E9D": "haam5",
    "\u3E9E": "jyu4",
    "\u3E9F": "zok6",
    "\u3EA0": "jau6",
    "\u3EA1": "lik6",
    "\u3EA2": "fok3/o1/ngo1",
    "\u3EA3": "hei1",
    "\u3EA4": "cim1",
    "\u3EA5": "caam4",
    "\u3EA6": "lin4",
    "\u3EA7": "hiu1",
    "\u3EA8": "si1",
    "\u3EA9": "gau6",
    "\u3EAA": "pok3",
    "\u3EAB": "kau4",
    "\u3EAC": "gung2",
    "\u3EAD": "zi2",
    "\u3EAE": "jyu1",
    "\u3EAF": "lung6",
    "\u3EB0": "si1",
    "\u3EB1": "jing4",
    "\u3EB2": "nau5/lau5",
    "\u3EB3": "mui4",
    "\u3EB4": "baat3",
    "\u3EB5": "gau2",
    "\u3EB6": "dau2",
    "\u3EB7": "seot1",
    "\u3EB8": "ping4",
    "\u3EB9": "bin6",
    "\u3EBA": "mou6",
    "\u3EBB": "fat1",
    "\u3EBC": "pat1",
    "\u3EBD": "pei1",
    "\u3EBE": "gwing1",
    "\u3EBF": "ji4",
    "\u3EC0": "jyu4",
    "\u3EC1": "gwai1",
    "\u3EC2": "ping4",
    "\u3EC3": "kuk1",
    "\u3EC4": "bou2",
    "\u3EC5": "wui6",
    "\u3EC6": "jyun5",
    "\u3EC7": "cyun4",
    "\u3EC8": "hau6",
    "\u3EC9": "bou6",
    "\u3ECA": "mun4",
    "\u3ECB": "laat6",
    "\u3ECC": "tou4",
    "\u3ECD": "ng4/m4",
    "\u3ECE": "sat1",
    "\u3ECF": "ling4",
    "\u3ED0": "ceon1",
    "\u3ED1": "gwai3",
    "\u3ED2": "kwan5",
    "\u3ED3": "zau1",
    "\u3ED4": "do2",
    "\u3ED5": "gwat6",
    "\u3ED6": "doi6",
    "\u3ED7": "pui3",
    "\u3ED8": "sam2",
    "\u3ED9": "juk6",
    "\u3EDA": "pang4",
    "\u3EDB": "ji6",
    "\u3EDC": "cung1",
    "\u3EDD": "laat6",
    "\u3EDE": "ban1",
    "\u3EDF": "ceoi4",
    "\u3EE0": "dat6",
    "\u3EE1": "sit3",
    "\u3EE2": "si1",
    "\u3EE3": "sam6",
    "\u3EE4": "gik1",
    "\u3EE5": "jau4",
    "\u3EE6": "jyu4",
    "\u3EE7": "do6",
    "\u3EE8": "jyun2",
    "\u3EE9": "gim1",
    "\u3EEA": "zeon3",
    "\u3EEB": "bit1/bat1",
    "\u3EEC": "tou1",
    "\u3EED": "sat1",
    "\u3EEE": "caan3",
    "\u3EEF": "tou1",
    "\u3EF0": "wai6",
    "\u3EF1": "fung4",
    "\u3EF2": "leoi5",
    "\u3EF3": "lei6",
    "\u3EF4": "maan6",
    "\u3EF5": "zaan6",
    "\u3EF6": "bat1",
    "\u3EF7": "gik1",
    "\u3EF8": "zam1",
    "\u3EF9": "hyun1",
    "\u3EFA": "lik6",
    "\u3EFB": "deon1",
    "\u3EFC": "taam4",
    "\u3EFD": "zeoi6",
    "\u3EFE": "jung1",
    "\u3EFF": "suk6",
    "\u3F00": "daat6",
    "\u3F01": "ji6",
    "\u3F02": "man6",
    "\u3F03": "laap6",
    "\u3F04": "gei1",
    "\u3F05": "gwong2/gong2",
    "\u3F06": "jing4",
    "\u3F07": "king4",
    "\u3F08": "lo4",
    "\u3F09": "zam6",
    "\u3F0A": "tyun4",
    "\u3F0B": "gu1/gwu1",
    "\u3F0C": "jyu5",
    "\u3F0D": "leoi5",
    "\u3F0E": "bok6",
    "\u3F0F": "neoi5/leoi5",
    "\u3F10": "pin4",
    "\u3F11": "lin6",
    "\u3F12": "tong2",
    "\u3F13": "lim4",
    "\u3F14": "wan1",
    "\u3F15": "dong1",
    "\u3F16": "lai6",
    "\u3F17": "ting4",
    "\u3F18": "ngaa5/aa5",
    "\u3F19": "zau3",
    "\u3F1A": "gong1",
    "\u3F1B": "jing4",
    "\u3F1C": "ong3/ngong3/ong2/ngong2/on1/ngon1",
    "\u3F1D": "wun2",
    "\u3F1E": "pang3",
    "\u3F1F": "baak6",
    "\u3F20": "to4",
    "\u3F21": "syu4",
    "\u3F22": "ji4",
    "\u3F23": "baak3",
    "\u3F24": "kit3",
    "\u3F25": "tau2",
    "\u3F26": "gung2",
    "\u3F27": "tung4",
    "\u3F28": "ham4",
    "\u3F29": "sing4",
    "\u3F2A": "zip3",
    "\u3F2B": "wun6",
    "\u3F2C": "hang6",
    "\u3F2D": "dim6",
    "\u3F2E": "caai1",
    "\u3F2F": "dung3",
    "\u3F30": "pei4",
    "\u3F31": "jyun5",
    "\u3F32": "lip6",
    "\u3F33": "saang2",
    "\u3F34": "ngau5/au5",
    "\u3F35": "tai5",
    "\u3F36": "jyu4",
    "\u3F37": "zyun1",
    "\u3F38": "jung4",
    "\u3F39": "hong1",
    "\u3F3A": "tong4",
    "\u3F3B": "cung4",
    "\u3F3C": "piu4",
    "\u3F3D": "cong2",
    "\u3F3E": "luk6",
    "\u3F3F": "tung4",
    "\u3F40": "zeng6",
    "\u3F41": "lik6",
    "\u3F42": "saap3",
    "\u3F43": "pun1",
    "\u3F44": "si1",
    "\u3F45": "dang1",
    "\u3F46": "dong1",
    "\u3F47": "huk6",
    "\u3F48": "ji6",
    "\u3F49": "haam6",
    "\u3F4A": "sip3",
    "\u3F4B": "lo4",
    "\u3F4C": "lau6",
    "\u3F4D": "ham1",
    "\u3F4E": "taam4",
    "\u3F4F": "gam3",
    "\u3F50": "him1",
    "\u3F51": "taam4",
    "\u3F52": "sang1",
    "\u3F53": "san1",
    "\u3F54": "jeoi6",
    "\u3F55": "jau4",
    "\u3F56": "naam4/laam4",
    "\u3F57": "din6",
    "\u3F58": "gong2",
    "\u3F59": "zeon3",
    "\u3F5A": "cik1",
    "\u3F5B": "kau1",
    "\u3F5C": "jyun2",
    "\u3F5D": "lai6",
    "\u3F5E": "lau4",
    "\u3F5F": "lyut3",
    "\u3F60": "haap6",
    "\u3F61": "bei1",
    "\u3F62": "am2/ngam2",
    "\u3F63": "wik6",
    "\u3F64": "guk1",
    "\u3F65": "jau4",
    "\u3F66": "wan4",
    "\u3F67": "zi1",
    "\u3F68": "co4",
    "\u3F69": "cam3",
    "\u3F6A": "zang2",
    "\u3F6B": "jung1",
    "\u3F6C": "fu3",
    "\u3F6D": "jyun4",
    "\u3F6E": "sing1",
    "\u3F6F": "kwai4",
    "\u3F70": "so1",
    "\u3F71": "gaau2",
    "\u3F72": "gaau2",
    "\u3F73": "heoi1",
    "\u3F74": "zoeng6",
    "\u3F75": "zong1",
    "\u3F76": "gei2",
    "\u3F77": "seoi3",
    "\u3F78": "sam4",
    "\u3F79": "faan2",
    "\u3F7A": "gap1",
    "\u3F7B": "zi1",
    "\u3F7C": "jan5",
    "\u3F7D": "gu3/gwu3",
    "\u3F7E": "ngat6/at6",
    "\u3F7F": "gwo1/go1",
    "\u3F80": "hip3",
    "\u3F81": "fat1",
    "\u3F82": "hoi1",
    "\u3F83": "to4",
    "\u3F84": "duk6",
    "\u3F85": "zi2",
    "\u3F86": "cim1",
    "\u3F87": "muk6",
    "\u3F88": "fu6",
    "\u3F89": "ling4",
    "\u3F8A": "zek3",
    "\u3F8B": "jau1",
    "\u3F8C": "sin2",
    "\u3F8D": "noi4/loi4",
    "\u3F8E": "aap3/ngaap3",
    "\u3F8F": "gaai3",
    "\u3F90": "lai6",
    "\u3F91": "daap3",
    "\u3F92": "jyu4",
    "\u3F93": "jyun1",
    "\u3F94": "leoi5",
    "\u3F95": "sam2",
    "\u3F96": "lei5",
    "\u3F97": "loeng6",
    "\u3F98": "gang2",
    "\u3F99": "jan3",
    "\u3F9A": "se1",
    "\u3F9B": "cam2",
    "\u3F9C": "hip3",
    "\u3F9D": "ce3",
    "\u3F9E": "jau4",
    "\u3F9F": "bou6",
    "\u3FA0": "kong4",
    "\u3FA1": "koek3",
    "\u3FA2": "loi6",
    "\u3FA3": "ham1",
    "\u3FA4": "hong1",
    "\u3FA5": "cuk1",
    "\u3FA6": "pui1",
    "\u3FA7": "fo3",
    "\u3FA8": "ji1",
    "\u3FA9": "gwaai1",
    "\u3FAA": "saang2",
    "\u3FAB": "pin1",
    "\u3FAC": "gaai1",
    "\u3FAD": "zau3",
    "\u3FAE": "wong4",
    "\u3FAF": "fui1",
    "\u3FB0": "wu4",
    "\u3FB1": "fai3",
    "\u3FB2": "ngou4/ou4",
    "\u3FB3": "zi1",
    "\u3FB4": "caa4",
    "\u3FB5": "gai3",
    "\u3FB6": "gwat1",
    "\u3FB7": "sai1",
    "\u3FB8": "gou2",
    "\u3FB9": "caai4",
    "\u3FBA": "maa6",
    "\u3FBB": "zyu6",
    "\u3FBC": "teoi2",
    "\u3FBD": "zeoi6",
    "\u3FBE": "him1",
    "\u3FBF": "long4",
    "\u3FC0": "baan1",
    "\u3FC1": "hiu1",
    "\u3FC2": "zing1",
    "\u3FC3": "zai6",
    "\u3FC4": "aai3/ngaai3",
    "\u3FC5": "sin2",
    "\u3FC6": "gwo1/go1",
    "\u3FC7": "zaap6",
    "\u3FC8": "jung1",
    "\u3FC9": "teoi4",
    "\u3FCA": "caam2",
    "\u3FCB": "sou3",
    "\u3FCC": "him1",
    "\u3FCD": "gaai3",
    "\u3FCE": "fan6",
    "\u3FCF": "kwan4",
    "\u3FD0": "ceoi1",
    "\u3FD1": "joek6",
    "\u3FD2": "dou2",
    "\u3FD3": "gaap3",
    "\u3FD4": "leoi5",
    "\u3FD5": "jim4",
    "\u3FD6": "lou4",
    "\u3FD7": "teoi4",
    "\u3FD8": "jing4",
    "\u3FD9": "pei3",
    "\u3FDA": "lo6",
    "\u3FDB": "lai6",
    "\u3FDC": "bit6",
    "\u3FDD": "hoeng1",
    "\u3FDE": "mou6",
    "\u3FDF": "baak6",
    "\u3FE0": "gwong1/gong1",
    "\u3FE1": "dau1",
    "\u3FE2": "jiu6",
    "\u3FE3": "hot3",
    "\u3FE4": "ceon2",
    "\u3FE5": "hok6",
    "\u3FE6": "ning6/ling6",
    "\u3FE7": "cau4",
    "\u3FE8": "lik6",
    "\u3FE9": "tong2",
    "\u3FEA": "jyun4",
    "\u3FEB": "bei3",
    "\u3FEC": "baa1",
    "\u3FED": "caak3",
    "\u3FEE": "joeng3",
    "\u3FEF": "daap3",
    "\u3FF0": "ngaau4/aau4",
    "\u3FF1": "zyut6",
    "\u3FF2": "ji1",
    "\u3FF3": "zi1",
    "\u3FF4": "daap3",
    "\u3FF5": "lou4",
    "\u3FF6": "bong1",
    "\u3FF7": "co4",
    "\u3FF8": "maan5",
    "\u3FF9": "taat3",
    "\u3FFA": "pok1",
    "\u3FFB": "gon1",
    "\u3FFC": "jin4",
    "\u3FFD": "hei1",
    "\u3FFE": "cyu5",
    "\u3FFF": "ngaa5/aa5",
    "\u4000": "faan3",
    "\u4001": "jau6",
    "\u4002": "on1/ngon1",
    "\u4003": "teoi4",
    "\u4004": "mung4",
    "\u4005": "se5",
    "\u4006": "zeon6",
    "\u4007": "gu2/gwu2",
    "\u4008": "kei3",
    "\u4009": "kiu4",
    "\u400A": "gaau2",
    "\u400B": "jim4",
    "\u400C": "sik1",
    "\u400D": "ham3",
    "\u400E": "min5",
    "\u400F": "jyun6",
    "\u4010": "saam1",
    "\u4011": "waat3",
    "\u4012": "cin1",
    "\u4013": "wun6",
    "\u4014": "jan6",
    "\u4015": "zan6",
    "\u4016": "tin1",
    "\u4017": "kyut3",
    "\u4018": "kwai4",
    "\u4019": "cai3",
    "\u401A": "ngong4/ong4",
    "\u401B": "maai6",
    "\u401C": "maai6",
    "\u401D": "bei2",
    "\u401E": "tou1",
    "\u401F": "fai6",
    "\u4020": "keoi4",
    "\u4021": "zim1",
    "\u4022": "seon3",
    "\u4023": "bei3",
    "\u4024": "mau6",
    "\u4025": "soek3",
    "\u4026": "gu2/gwu2",
    "\u4027": "hung2",
    "\u4028": "gwaat3",
    "\u4029": "lok6",
    "\u402A": "hong4",
    "\u402B": "gaap3",
    "\u402C": "cyun4",
    "\u402D": "goi1",
    "\u402E": "fong1",
    "\u402F": "bou2",
    "\u4030": "guk1",
    "\u4031": "fung1",
    "\u4032": "muk6",
    "\u4033": "laat6",
    "\u4034": "jing5",
    "\u4035": "seon3",
    "\u4036": "loeng6",
    "\u4037": "gip3",
    "\u4038": "cai3",
    "\u4039": "sim2/sip3/zip3/zaap3/gap6",
    "\u403A": "cau1",
    "\u403B": "ping3",
    "\u403C": "can1",
    "\u403D": "jin4",
    "\u403E": "dou2",
    "\u403F": "cai3",
    "\u4040": "dai3",
    "\u4041": "loeng6",
    "\u4042": "haan6",
    "\u4043": "biu1",
    "\u4044": "jing6",
    "\u4045": "maang5",
    "\u4046": "jip3",
    "\u4047": "mik6",
    "\u4048": "kai3",
    "\u4049": "kai3",
    "\u404A": "waat3",
    "\u404B": "hip3",
    "\u404C": "wat6",
    "\u404D": "hap1",
    "\u404E": "caang4",
    "\u404F": "jiu2",
    "\u4050": "jing1",
    "\u4051": "joeng4",
    "\u4052": "cap1",
    "\u4053": "zung1",
    "\u4054": "hyun1",
    "\u4055": "man4",
    "\u4056": "lau1/lau4",
    "\u4057": "hoi2",
    "\u4058": "jiu5",
    "\u4059": "aan3/ngaan3",
    "\u405A": "syun2",
    "\u405B": "gwai3",
    "\u405C": "fong2",
    "\u405D": "jing4",
    "\u405E": "saang2",
    "\u405F": "caa4",
    "\u4060": "lim4",
    "\u4061": "sim2",
    "\u4062": "syun4",
    "\u4063": "syun4",
    "\u4064": "caak3",
    "\u4065": "nik1/lik1",
    "\u4066": "ceoi3",
    "\u4067": "miu4",
    "\u4068": "fok3",
    "\u4069": "jyu4",
    "\u406A": "zaam2",
    "\u406B": "wat6",
    "\u406C": "cang4",
    "\u406D": "biu1",
    "\u406E": "cim4",
    "\u406F": "hap1",
    "\u4070": "hong2",
    "\u4071": "kau1",
    "\u4072": "maai4",
    "\u4073": "mong5",
    "\u4074": "zin2",
    "\u4075": "bin2",
    "\u4076": "gik1",
    "\u4077": "gok3",
    "\u4078": "nong4/long4",
    "\u4079": "pai5",
    "\u407A": "sik1",
    "\u407B": "soek3",
    "\u407C": "mak6",
    "\u407D": "laap3",
    "\u407E": "mit6",
    "\u407F": "mak6",
    "\u4080": "hei1",
    "\u4081": "caam4",
    "\u4082": "keoi4",
    "\u4083": "ziu3",
    "\u4084": "fok3",
    "\u4085": "haan1",
    "\u4086": "gwik1",
    "\u4087": "nuk6/luk6",
    "\u4088": "tung4",
    "\u4089": "hau4",
    "\u408A": "jyu6",
    "\u408B": "jau5",
    "\u408C": "cung1",
    "\u408D": "bok6",
    "\u408E": "zyun2",
    "\u408F": "diu1",
    "\u4090": "dyut3",
    "\u4091": "zai1",
    "\u4092": "kit3",
    "\u4093": "kwai1",
    "\u4094": "jing6",
    "\u4095": "wai3",
    "\u4096": "sek6",
    "\u4097": "fat1",
    "\u4098": "caai1",
    "\u4099": "deoi1",
    "\u409A": "haau4",
    "\u409B": "jyu4",
    "\u409C": "pong5",
    "\u409D": "zaak3",
    "\u409E": "ze3",
    "\u409F": "gaa1",
    "\u40A0": "si2",
    "\u40A1": "dai2",
    "\u40A2": "dung2",
    "\u40A3": "ci1",
    "\u40A4": "fu6",
    "\u40A5": "man4",
    "\u40A6": "zan1",
    "\u40A7": "can2",
    "\u40A8": "cik1",
    "\u40A9": "jin6",
    "\u40AA": "haau1",
    "\u40AB": "haang1",
    "\u40AC": "gung2",
    "\u40AD": "haau1",
    "\u40AE": "loek6",
    "\u40AF": "gwaai3",
    "\u40B0": "laap6",
    "\u40B1": "jeoi6",
    "\u40B2": "faat3",
    "\u40B3": "co2",
    "\u40B4": "jin4",
    "\u40B5": "gung1",
    "\u40B6": "gip3",
    "\u40B7": "gwaai1",
    "\u40B8": "gwok3/gok3",
    "\u40B9": "saak3",
    "\u40BA": "wo2",
    "\u40BB": "zaang6",
    "\u40BC": "nit6/lit6",
    "\u40BD": "diu6",
    "\u40BE": "loi5",
    "\u40BF": "daap6",
    "\u40C0": "ceoi3",
    "\u40C1": "aa1/ngaa1",
    "\u40C2": "gwan2",
    "\u40C3": "mong5",
    "\u40C4": "ging1",
    "\u40C5": "dai1",
    "\u40C6": "kei4",
    "\u40C7": "min4",
    "\u40C8": "gaai1",
    "\u40C9": "man4",
    "\u40CA": "zeoi2",
    "\u40CB": "jyu4",
    "\u40CC": "zan1",
    "\u40CD": "zeoi6",
    "\u40CE": "zaa3",
    "\u40CF": "sing1",
    "\u40D0": "dat6",
    "\u40D1": "baan1",
    "\u40D2": "hat6",
    "\u40D3": "gau3",
    "\u40D4": "hung4",
    "\u40D5": "lou4",
    "\u40D6": "wu2",
    "\u40D7": "bok1",
    "\u40D8": "hang1",
    "\u40D9": "luk6",
    "\u40DA": "zuk6",
    "\u40DB": "lin6",
    "\u40DC": "ji1",
    "\u40DD": "hat6",
    "\u40DE": "suk6",
    "\u40DF": "saan3",
    "\u40E0": "syun4",
    "\u40E1": "zam1",
    "\u40E2": "jam1",
    "\u40E3": "wai2",
    "\u40E4": "suk1",
    "\u40E5": "cong4",
    "\u40E6": "deon1",
    "\u40E7": "lung4",
    "\u40E8": "koeng4",
    "\u40E9": "naau4/laau4",
    "\u40EA": "taan4",
    "\u40EB": "daam2",
    "\u40EC": "ngai5/ai5",
    "\u40ED": "gam2",
    "\u40EE": "daat6",
    "\u40EF": "lik1",
    "\u40F0": "caat3",
    "\u40F1": "cim3",
    "\u40F2": "pun4",
    "\u40F3": "laap6",
    "\u40F4": "zyu1",
    "\u40F5": "niu5/liu5",
    "\u40F6": "waai4",
    "\u40F7": "jing4",
    "\u40F8": "cim3",
    "\u40F9": "laan6",
    "\u40FA": "mo4/mo6",
    "\u40FB": "baa3",
    "\u40FC": "buk1",
    "\u40FD": "gwai2",
    "\u40FE": "bei2",
    "\u40FF": "fu1",
    "\u4100": "wo6",
    "\u4101": "jai6",
    "\u4102": "lau6",
    "\u4103": "joeng1",
    "\u4104": "jan1",
    "\u4105": "gyun3",
    "\u4106": "wut6",
    "\u4107": "cing4",
    "\u4108": "dau6",
    "\u4109": "ngo4/o4",
    "\u410A": "zi3",
    "\u410B": "jim2",
    "\u410C": "zeoi3",
    "\u410D": "zaa3",
    "\u410E": "kei2",
    "\u410F": "hin1",
    "\u4110": "hyun3",
    "\u4111": "wut6",
    "\u4112": "nam5/lam5",
    "\u4113": "waang4",
    "\u4114": "geoi2",
    "\u4115": "se5",
    "\u4116": "jyu4",
    "\u4117": "jyun1",
    "\u4118": "paang4",
    "\u4119": "ming4",
    "\u411A": "cou4",
    "\u411B": "leoi4",
    "\u411C": "lei4",
    "\u411D": "cong1",
    "\u411E": "zai3",
    "\u411F": "ceoi3",
    "\u4120": "sim4",
    "\u4121": "daam1",
    "\u4122": "zaai1",
    "\u4123": "suk6",
    "\u4124": "laai6",
    "\u4125": "ling4",
    "\u4126": "liu5",
    "\u4127": "jing4",
    "\u4128": "jyu4",
    "\u4129": "jik6",
    "\u412A": "tiu2",
    "\u412B": "hei2",
    "\u412C": "ji4",
    "\u412D": "nin4/lin4",
    "\u412E": "fu1",
    "\u412F": "gin2",
    "\u4130": "ngaa4/aa4",
    "\u4131": "fong1",
    "\u4132": "jeoi6",
    "\u4133": "sin1",
    "\u4134": "jyut6",
    "\u4135": "lai4",
    "\u4136": "bat6",
    "\u4137": "sek6",
    "\u4138": "pok3",
    "\u4139": "nin4/lin4",
    "\u413A": "zi6",
    "\u413B": "tou4",
    "\u413C": "tim2",
    "\u413D": "sin1",
    "\u413E": "juk6",
    "\u413F": "jai6",
    "\u4140": "lit6",
    "\u4141": "on3/ngon3",
    "\u4142": "hok6",
    "\u4143": "kung4",
    "\u4144": "lai6",
    "\u4145": "gwai1",
    "\u4146": "zi3",
    "\u4147": "suk1",
    "\u4148": "jyun2",
    "\u4149": "aa3/ngaa3",
    "\u414A": "caa4",
    "\u414B": "maan5",
    "\u414C": "gyun1",
    "\u414D": "ting5",
    "\u414E": "jau5",
    "\u414F": "mei6",
    "\u4150": "gin2",
    "\u4151": "jeoi4",
    "\u4152": "mong4",
    "\u4153": "geoi2",
    "\u4154": "zi1",
    "\u4155": "geoi1",
    "\u4156": "am1/ngam1",
    "\u4157": "seoi3",
    "\u4158": "loi4",
    "\u4159": "muk6",
    "\u415A": "hyun2",
    "\u415B": "coeng1",
    "\u415C": "do6",
    "\u415D": "hung1",
    "\u415E": "nak6/lak6",
    "\u415F": "saam1/caam2",
    "\u4160": "tai4",
    "\u4161": "seoi2",
    "\u4162": "zau3",
    "\u4163": "wong4",
    "\u4164": "cap1",
    "\u4165": "git3",
    "\u4166": "maau4",
    "\u4167": "jim1",
    "\u4168": "hoeng1",
    "\u4169": "zi2",
    "\u416A": "teoi4",
    "\u416B": "loek6",
    "\u416C": "aai3/ngaai3",
    "\u416D": "pong4",
    "\u416E": "cong3",
    "\u416F": "tong4",
    "\u4170": "an2/ngan2",
    "\u4171": "ngan6/an6",
    "\u4172": "kei4",
    "\u4173": "co4",
    "\u4174": "sok3",
    "\u4175": "zoek3",
    "\u4176": "nau6/lau6",
    "\u4177": "tou4",
    "\u4178": "san1",
    "\u4179": "lau4",
    "\u417A": "biu1",
    "\u417B": "lei4",
    "\u417C": "maan4",
    "\u417D": "hing1",
    "\u417E": "sam4",
    "\u417F": "waa4",
    "\u4180": "mui5",
    "\u4181": "gou1",
    "\u4182": "lim4",
    "\u4183": "dou6",
    "\u4184": "zin2",
    "\u4185": "ci4",
    "\u4186": "cou3",
    "\u4187": "fung6",
    "\u4188": "zi6",
    "\u4189": "baa6",
    "\u418A": "seoi6",
    "\u418B": "cau1",
    "\u418C": "kai1",
    "\u418D": "lung4",
    "\u418E": "cim1",
    "\u418F": "fai6",
    "\u4190": "gwok3/gok3",
    "\u4191": "caang4",
    "\u4192": "gau3",
    "\u4193": "ngaai6/aai6",
    "\u4194": "cung1",
    "\u4195": "jyut3",
    "\u4196": "wang4",
    "\u4197": "jiu2",
    "\u4198": "aap3/ngaap3",
    "\u4199": "jiu4",
    "\u419A": "tung4",
    "\u419B": "zaa3",
    "\u419C": "jau6",
    "\u419D": "hyut3",
    "\u419E": "jiu2",
    "\u419F": "hap1",
    "\u41A0": "waan6",
    "\u41A1": "laang1",
    "\u41A2": "jyut3",
    "\u41A3": "san4",
    "\u41A4": "cyun1",
    "\u41A5": "cyun1",
    "\u41A6": "sam1",
    "\u41A7": "wo1",
    "\u41A8": "ning4/ling4",
    "\u41A9": "ming4",
    "\u41AA": "hung1",
    "\u41AB": "coeng1",
    "\u41AC": "wan5",
    "\u41AD": "hin1",
    "\u41AE": "zam3",
    "\u41AF": "zeot1",
    "\u41B0": "jyu1",
    "\u41B1": "taam1",
    "\u41B2": "kwaang1",
    "\u41B3": "seoi6",
    "\u41B4": "gwai1",
    "\u41B5": "caang4",
    "\u41B6": "zau1",
    "\u41B7": "hyut3",
    "\u41B8": "zang1",
    "\u41B9": "cung1",
    "\u41BA": "pun1",
    "\u41BB": "kiu3",
    "\u41BC": "wo1",
    "\u41BD": "keoi4",
    "\u41BE": "laam4",
    "\u41BF": "ngai6/ai6",
    "\u41C0": "jung4",
    "\u41C1": "si1",
    "\u41C2": "hin1",
    "\u41C3": "zi6",
    "\u41C4": "hat1",
    "\u41C5": "fat6",
    "\u41C6": "sap6.sing1",
    "\u41C7": "maang4",
    "\u41C8": "waa6",
    "\u41C9": "baak3.sing1",
    "\u41CA": "gwong2/gong2",
    "\u41CB": "hoi6",
    "\u41CC": "ciu3",
    "\u41CD": "cuk1",
    "\u41CE": "coek3",
    "\u41CF": "deoi2",
    "\u41D0": "lei6",
    "\u41D1": "baa6",
    "\u41D2": "gaai3",
    "\u41D3": "seoi1",
    "\u41D4": "lo6",
    "\u41D5": "seoi1",
    "\u41D6": "wan5",
    "\u41D7": "zung1",
    "\u41D8": "wu6",
    "\u41D9": "jan5",
    "\u41DA": "pok3",
    "\u41DB": "zi2",
    "\u41DC": "him2",
    "\u41DD": "zim1",
    "\u41DE": "gam1",
    "\u41DF": "gin3",
    "\u41E0": "cyu5",
    "\u41E1": "cyu5",
    "\u41E2": "fu2",
    "\u41E3": "nip6/lip6",
    "\u41E4": "jeoi6",
    "\u41E5": "zaak3",
    "\u41E6": "joeng2",
    "\u41E7": "zai6",
    "\u41E8": "gung3",
    "\u41E9": "jai6",
    "\u41EA": "ci1",
    "\u41EB": "gei1",
    "\u41EC": "zyu1",
    "\u41ED": "lou5",
    "\u41EE": "jam6",
    "\u41EF": "jung4",
    "\u41F0": "zing1",
    "\u41F1": "naap6/laap6",
    "\u41F2": "caak3/gaap3",
    "\u41F3": "zin1",
    "\u41F4": "sai1",
    "\u41F5": "ngan4/an4",
    "\u41F6": "gok3",
    "\u41F7": "bit6",
    "\u41F8": "cing4",
    "\u41F9": "kwan3/kwan2",
    "\u41FA": "dau6",
    "\u41FB": "mei5",
    "\u41FC": "jap1",
    "\u41FD": "zai3/zit3",
    "\u41FE": "jin4",
    "\u41FF": "cuk1",
    "\u4200": "saan1",
    "\u4201": "leon4",
    "\u4202": "ping4",
    "\u4203": "ziu2",
    "\u4204": "ham4",
    "\u4205": "wok6/jyut6/wik6",
    "\u4206": "daai6",
    "\u4207": "zaau3",
    "\u4208": "fei4",
    "\u4209": "saap3",
    "\u420A": "ling4",
    "\u420B": "taap3",
    "\u420C": "ceoi1",
    "\u420D": "mang4",
    "\u420E": "jip6",
    "\u420F": "bok6",
    "\u4210": "kui2/kwui2",
    "\u4211": "gwaa2",
    "\u4212": "naam5/laam5",
    "\u4213": "got3",
    "\u4214": "gaa1",
    "\u4215": "si4",
    "\u4216": "fo1",
    "\u4217": "so2",
    "\u4218": "ci4",
    "\u4219": "zau6",
    "\u421A": "doi6",
    "\u421B": "faai3",
    "\u421C": "cam3",
    "\u421D": "seoi1",
    "\u421E": "zuk1",
    "\u421F": "zit3",
    "\u4220": "wun6",
    "\u4221": "cung1",
    "\u4222": "soi2",
    "\u4223": "zing3",
    "\u4224": "kim4",
    "\u4225": "gan1",
    "\u4226": "zung1",
    "\u4227": "wai5",
    "\u4228": "haan6",
    "\u4229": "gim3",
    "\u422A": "hik1",
    "\u422B": "naap6/laap6",
    "\u422C": "pou4",
    "\u422D": "sau1",
    "\u422E": "geoi3",
    "\u422F": "zan1",
    "\u4230": "saau1",
    "\u4231": "tou1",
    "\u4232": "bun1",
    "\u4233": "daap6",
    "\u4234": "him3",
    "\u4235": "jung1",
    "\u4236": "jung4",
    "\u4237": "gaak3",
    "\u4238": "huk6",
    "\u4239": "sou2",
    "\u423A": "zung1",
    "\u423B": "pou4",
    "\u423C": "mit6",
    "\u423D": "gan1",
    "\u423E": "saau1",
    "\u423F": "mik6",
    "\u4240": "syu3",
    "\u4241": "ling4",
    "\u4242": "leoi5",
    "\u4243": "zoeng2",
    "\u4244": "ling4",
    "\u4245": "zap1",
    "\u4246": "niu5/liu5",
    "\u4247": "zaam1",
    "\u4248": "saan2",
    "\u4249": "gu1/gwu1",
    "\u424A": "faan6",
    "\u424B": "mei6",
    "\u424C": "seoi6",
    "\u424D": "gaan2",
    "\u424E": "tong4",
    "\u424F": "haai5",
    "\u4250": "fu1",
    "\u4251": "mou4",
    "\u4252": "faan1",
    "\u4253": "lo6",
    "\u4254": "caan1",
    "\u4255": "cang4",
    "\u4256": "ling4",
    "\u4257": "jap1",
    "\u4258": "soeng3",
    "\u4259": "wan4",
    "\u425A": "mang4",
    "\u425B": "juk1",
    "\u425C": "zi6",
    "\u425D": "ngai5/ai5",
    "\u425E": "dam2",
    "\u425F": "wok6",
    "\u4260": "mei4",
    "\u4261": "taan4",
    "\u4262": "sik1",
    "\u4263": "se3",
    "\u4264": "sou2/sau2",
    "\u4265": "sung1",
    "\u4266": "cin1",
    "\u4267": "lau4",
    "\u4268": "ngai6/ai6",
    "\u4269": "au1/ngau1",
    "\u426A": "leoi6",
    "\u426B": "lai4",
    "\u426C": "fai3",
    "\u426D": "lip6",
    "\u426E": "leon6",
    "\u426F": "haan6",
    "\u4270": "haau6",
    "\u4271": "au1/ngau1",
    "\u4272": "nei4/lei4",
    "\u4273": "sin1",
    "\u4274": "joeng4",
    "\u4275": "zaan6/zaan3",
    "\u4276": "soeng1",
    "\u4277": "jim4",
    "\u4278": "bin6",
    "\u4279": "ling4",
    "\u427A": "hung4/hong2",
    "\u427B": "kei4",
    "\u427C": "liu6",
    "\u427D": "bun2",
    "\u427E": "bei3",
    "\u427F": "wu4",
    "\u4280": "wu4",
    "\u4281": "san1",
    "\u4282": "caak3",
    "\u4283": "bui6",
    "\u4284": "kung4",
    "\u4285": "ming4",
    "\u4286": "kau5",
    "\u4287": "bou1",
    "\u4288": "mui4",
    "\u4289": "sam2",
    "\u428A": "mei6",
    "\u428B": "zong1",
    "\u428C": "bei3",
    "\u428D": "lei4",
    "\u428E": "hyun2",
    "\u428F": "sam2",
    "\u4290": "wan4",
    "\u4291": "hoeng2",
    "\u4292": "zing1",
    "\u4293": "si6",
    "\u4294": "jing1",
    "\u4295": "zin1",
    "\u4296": "naam5/laam5",
    "\u4297": "wong4",
    "\u4298": "zau3",
    "\u4299": "jin4",
    "\u429A": "deoi1",
    "\u429B": "saat3",
    "\u429C": "tyun4",
    "\u429D": "sit3",
    "\u429E": "zaak6",
    "\u429F": "mun4",
    "\u42A0": "hei3",
    "\u42A1": "mun4",
    "\u42A2": "zoeng1",
    "\u42A3": "wong4",
    "\u42A4": "taam4",
    "\u42A5": "siu3",
    "\u42A6": "jit3",
    "\u42A7": "pei3",
    "\u42A8": "lo4",
    "\u42A9": "faan4",
    "\u42AA": "lai6",
    "\u42AB": "ceoi2",
    "\u42AC": "caa2",
    "\u42AD": "dou6",
    "\u42AE": "dik6",
    "\u42AF": "kong3",
    "\u42B0": "cyu4",
    "\u42B1": "cim1",
    "\u42B2": "caan3",
    "\u42B3": "mei4",
    "\u42B4": "cim3",
    "\u42B5": "kau4",
    "\u42B6": "zan6",
    "\u42B7": "zi1",
    "\u42B8": "jyu1",
    "\u42B9": "cin1",
    "\u42BA": "wu6",
    "\u42BB": "gam1",
    "\u42BC": "ci2",
    "\u42BD": "gwaai3",
    "\u42BE": "muk6",
    "\u42BF": "fu1",
    "\u42C0": "waa5",
    "\u42C1": "gang2",
    "\u42C2": "haau4",
    "\u42C3": "mou6",
    "\u42C4": "mong5",
    "\u42C5": "ngau4/au4",
    "\u42C6": "wu6",
    "\u42C7": "jik6",
    "\u42C8": "neoi4/leoi4",
    "\u42C9": "jyut6",
    "\u42CA": "zing1",
    "\u42CB": "man4",
    "\u42CC": "goeng2",
    "\u42CD": "o1/ngo1",
    "\u42CE": "zaan6",
    "\u42CF": "zok6",
    "\u42D0": "jyut6",
    "\u42D1": "lit6",
    "\u42D2": "syu1",
    "\u42D3": "zau3",
    "\u42D4": "pei1",
    "\u42D5": "jam6",
    "\u42D6": "jyut6",
    "\u42D7": "gin1",
    "\u42D8": "zeoi6",
    "\u42D9": "ji5",
    "\u42DA": "jik6",
    "\u42DB": "mai5",
    "\u42DC": "hing3",
    "\u42DD": "jing1",
    "\u42DE": "mong5",
    "\u42DF": "gei6",
    "\u42E0": "bou2",
    "\u42E1": "syu1",
    "\u42E2": "pit3",
    "\u42E3": "faan4",
    "\u42E4": "joek6",
    "\u42E5": "lei4",
    "\u42E6": "faan4",
    "\u42E7": "keoi4",
    "\u42E8": "fu2",
    "\u42E9": "ji4",
    "\u42EA": "o1/ngo1",
    "\u42EB": "zang1",
    "\u42EC": "tim1",
    "\u42ED": "juk6",
    "\u42EE": "gam1",
    "\u42EF": "hing3",
    "\u42F0": "guk1",
    "\u42F1": "lei4",
    "\u42F2": "sing4",
    "\u42F3": "bui3",
    "\u42F4": "nau6/lau6",
    "\u42F5": "ai3/ngai3",
    "\u42F6": "seoi1",
    "\u42F7": "mau4",
    "\u42F8": "ceon4",
    "\u42F9": "fuk1",
    "\u42FA": "cau1",
    "\u42FB": "nam4/lam4",
    "\u42FC": "ting1",
    "\u42FD": "bung2",
    "\u42FE": "zaa2",
    "\u42FF": "wui1",
    "\u4300": "fo1",
    "\u4301": "jiu1",
    "\u4302": "ak1/ngak1",
    "\u4303": "siu1",
    "\u4304": "gang2",
    "\u4305": "tong4",
    "\u4306": "gwai3",
    "\u4307": "sok3",
    "\u4308": "taap3",
    "\u4309": "gong1",
    "\u430A": "jau4",
    "\u430B": "daap3",
    "\u430C": "cip3/zip3/cap1",
    "\u430D": "gan2",
    "\u430E": "loek6",
    "\u430F": "mat6",
    "\u4310": "mik6",
    "\u4311": "gin1",
    "\u4312": "luk6",
    "\u4313": "faan4",
    "\u4314": "au1/ngau1",
    "\u4315": "mei4",
    "\u4316": "cap1",
    "\u4317": "fu2",
    "\u4318": "bit3",
    "\u4319": "wong6",
    "\u431A": "suk1",
    "\u431B": "jau4",
    "\u431C": "nip6/lip6",
    "\u431D": "gam1",
    "\u431E": "lim5",
    "\u431F": "baak6",
    "\u4320": "gaam1",
    "\u4321": "tai2",
    "\u4322": "ling4",
    "\u4323": "zyun2",
    "\u4324": "si1",
    "\u4325": "jan5",
    "\u4326": "dou6",
    "\u4327": "cau4",
    "\u4328": "coi3",
    "\u4329": "mit6",
    "\u432A": "jim5",
    "\u432B": "laam6",
    "\u432C": "cung4",
    "\u432D": "ziu1",
    "\u432E": "soeng1",
    "\u432F": "hyun1",
    "\u4330": "nip6/lip6",
    "\u4331": "lo6",
    "\u4332": "fan1",
    "\u4333": "si1",
    "\u4334": "lo6",
    "\u4335": "zuk1",
    "\u4336": "zi1",
    "\u4337": "cau4/cau1",
    "\u4338": "gyun3",
    "\u4339": "gwing2",
    "\u433A": "ji5",
    "\u433B": "jik6",
    "\u433C": "deoi6",
    "\u433D": "coi2",
    "\u433E": "nam4/lam4",
    "\u433F": "fuk1",
    "\u4340": "laam4",
    "\u4341": "seoi6",
    "\u4342": "jyu4",
    "\u4343": "jau4",
    "\u4344": "dim2",
    "\u4345": "ling4",
    "\u4346": "zyu2",
    "\u4347": "daap6",
    "\u4348": "ping4",
    "\u4349": "zaak3",
    "\u434A": "gaau1",
    "\u434B": "seoi4",
    "\u434C": "pau2",
    "\u434D": "kau3",
    "\u434E": "cyun3",
    "\u434F": "jyun4",
    "\u4350": "hon2",
    "\u4351": "hon2",
    "\u4352": "mau5",
    "\u4353": "wu6",
    "\u4354": "gwang1",
    "\u4355": "dai1",
    "\u4356": "fau4",
    "\u4357": "jyun6",
    "\u4358": "bei1",
    "\u4359": "mui4",
    "\u435A": "long6",
    "\u435B": "gu3/gwu3",
    "\u435C": "zaau3",
    "\u435D": "taap3",
    "\u435E": "wik6",
    "\u435F": "zung1",
    "\u4360": "lei4",
    "\u4361": "luk6",
    "\u4362": "mou5",
    "\u4363": "leoi4",
    "\u4364": "zai2",
    "\u4365": "lik6",
    "\u4366": "lei4",
    "\u4367": "zong1",
    "\u4368": "but3",
    "\u4369": "joeng5",
    "\u436A": "mat6",
    "\u436B": "to4",
    "\u436C": "paang1",
    "\u436D": "zong1",
    "\u436E": "siu6",
    "\u436F": "gwai2",
    "\u4370": "jin1",
    "\u4371": "ceoi4",
    "\u4372": "naai4/laai4",
    "\u4373": "kyut3",
    "\u4374": "wai2",
    "\u4375": "zang1",
    "\u4376": "dung1",
    "\u4377": "wai5",
    "\u4378": "bok3",
    "\u4379": "zin1",
    "\u437A": "waan4",
    "\u437B": "syun3",
    "\u437C": "zaam1",
    "\u437D": "lik6",
    "\u437E": "jin5",
    "\u437F": "wong4",
    "\u4380": "hyut3",
    "\u4381": "wu4",
    "\u4382": "bou2",
    "\u4383": "jim5",
    "\u4384": "hiu1",
    "\u4385": "pok3",
    "\u4386": "liu6",
    "\u4387": "zau1",
    "\u4388": "jai6",
    "\u4389": "wat1",
    "\u438A": "lok6",
    "\u438B": "kaau3",
    "\u438C": "cuk1",
    "\u438D": "fu1",
    "\u438E": "nip6/lip6",
    "\u438F": "ham1",
    "\u4390": "caau2",
    "\u4391": "luk6",
    "\u4392": "zaan2",
    "\u4393": "daap6",
    "\u4394": "fu1",
    "\u4395": "gwang1",
    "\u4396": "zang1",
    "\u4397": "kiu4",
    "\u4398": "suk1",
    "\u4399": "pan1",
    "\u439A": "wai6",
    "\u439B": "lou5",
    "\u439C": "fan1",
    "\u439D": "zyu3",
    "\u439E": "ze2",
    "\u439F": "ji4",
    "\u43A0": "ji4",
    "\u43A1": "jyun5",
    "\u43A2": "hat1",
    "\u43A3": "zi6",
    "\u43A4": "guk6",
    "\u43A5": "gaak3",
    "\u43A6": "jim5",
    "\u43A7": "pong5",
    "\u43A8": "jip3",
    "\u43A9": "zi1",
    "\u43AA": "nak6/lak6",
    "\u43AB": "zung1",
    "\u43AC": "paa4",
    "\u43AD": "cou1",
    "\u43AE": "tai3",
    "\u43AF": "hon3",
    "\u43B0": "zok6",
    "\u43B1": "paa4",
    "\u43B2": "zip3",
    "\u43B3": "waat6",
    "\u43B4": "gaang1",
    "\u43B5": "bei3",
    "\u43B6": "nei6/lei6",
    "\u43B7": "zyu3",
    "\u43B8": "ng6/m6",
    "\u43B9": "man4",
    "\u43BA": "zai3",
    "\u43BB": "zau3",
    "\u43BC": "luk6",
    "\u43BD": "man4",
    "\u43BE": "gwan3",
    "\u43BF": "cau4",
    "\u43C0": "laat6",
    "\u43C1": "zoi2",
    "\u43C2": "sau2",
    "\u43C3": "min4",
    "\u43C4": "dai2",
    "\u43C5": "cai3",
    "\u43C6": "cou4",
    "\u43C7": "piu3",
    "\u43C8": "lyun4",
    "\u43C9": "sap1",
    "\u43CA": "lung4",
    "\u43CB": "suk1",
    "\u43CC": "hat1",
    "\u43CD": "jyun1",
    "\u43CE": "fung4",
    "\u43CF": "heoi1",
    "\u43D0": "kyut3",
    "\u43D1": "zek3",
    "\u43D2": "pin3",
    "\u43D3": "gun2/gwun2",
    "\u43D4": "nau5/lau5",
    "\u43D5": "jam6",
    "\u43D6": "zan6",
    "\u43D7": "gui3/gwui3",
    "\u43D8": "pat1",
    "\u43D9": "dam1",
    "\u43DA": "cau2",
    "\u43DB": "ceon2",
    "\u43DC": "hap1",
    "\u43DD": "zyun1/seon4",
    "\u43DE": "mut6",
    "\u43DF": "bit6",
    "\u43E0": "jap1",
    "\u43E1": "si6",
    "\u43E2": "bei2",
    "\u43E3": "zeoi1",
    "\u43E4": "seon3",
    "\u43E5": "taam1",
    "\u43E6": "gwaat3",
    "\u43E7": "naa6/laa6",
    "\u43E8": "fui2",
    "\u43E9": "hip3",
    "\u43EA": "nei6/lei6",
    "\u43EB": "jau1",
    "\u43EC": "mau4",
    "\u43ED": "zyu1",
    "\u43EE": "hip3",
    "\u43EF": "zi3",
    "\u43F0": "jeon6",
    "\u43F1": "guk1",
    "\u43F2": "dit6",
    "\u43F3": "zit3",
    "\u43F4": "saau3",
    "\u43F5": "mung5",
    "\u43F6": "bai3",
    "\u43F7": "hon6",
    "\u43F8": "jyu4",
    "\u43F9": "jin6",
    "\u43FA": "pong1",
    "\u43FB": "nang4/lang4",
    "\u43FC": "caan4",
    "\u43FD": "bau6",
    "\u43FE": "pong1",
    "\u43FF": "kai2",
    "\u4400": "gei3",
    "\u4401": "duk1",
    "\u4402": "luk6",
    "\u4403": "kwan5",
    "\u4404": "haam6",
    "\u4405": "hei1",
    "\u4406": "coi2",
    "\u4407": "man5",
    "\u4408": "zik1",
    "\u4409": "zi3",
    "\u440A": "gwan1",
    "\u440B": "cung1",
    "\u440C": "tin2",
    "\u440D": "zo3",
    "\u440E": "dai1",
    "\u440F": "ceon2",
    "\u4410": "cau1",
    "\u4411": "zip3",
    "\u4412": "zaa1",
    "\u4413": "jau4",
    "\u4414": "ban2",
    "\u4415": "cap1",
    "\u4416": "si1",
    "\u4417": "zyu1",
    "\u4418": "koek6",
    "\u4419": "gaak3",
    "\u441A": "zik1",
    "\u441B": "dap1/daap1",
    "\u441C": "can1",
    "\u441D": "so3",
    "\u441E": "joek6",
    "\u441F": "hong2",
    "\u4420": "fong1",
    "\u4421": "ci4",
    "\u4422": "zo3",
    "\u4423": "seon3",
    "\u4424": "caai1",
    "\u4425": "ung3/ngung3/ong3/ngong3",
    "\u4426": "hap1",
    "\u4427": "hou3",
    "\u4428": "guk1",
    "\u4429": "goi1",
    "\u442A": "zeon3",
    "\u442B": "cung1",
    "\u442C": "cou4",
    "\u442D": "zai6",
    "\u442E": "caan2",
    "\u442F": "leoi4",
    "\u4430": "sau1",
    "\u4431": "zaai3",
    "\u4432": "zaap6",
    "\u4433": "jyu4",
    "\u4434": "gui3/gwui3",
    "\u4435": "gwang1",
    "\u4436": "zaam1",
    "\u4437": "daan1",
    "\u4438": "waak6",
    "\u4439": "sau1",
    "\u443A": "taam3",
    "\u443B": "gu1/gwu1",
    "\u443C": "hai6",
    "\u443D": "mun4",
    "\u443E": "dok6",
    "\u443F": "ou3/ngou3",
    "\u4440": "pik1",
    "\u4441": "uk1/nguk1",
    "\u4442": "jaai5",
    "\u4443": "mung4",
    "\u4444": "bei6",
    "\u4445": "mang4",
    "\u4446": "joeng5",
    "\u4447": "zat1",
    "\u4448": "bok1",
    "\u4449": "jing4",
    "\u444A": "wai4",
    "\u444B": "joeng5",
    "\u444C": "laan4",
    "\u444D": "jin1",
    "\u444E": "caam2",
    "\u444F": "kyun4",
    "\u4450": "can2",
    "\u4451": "buk6",
    "\u4452": "dou3",
    "\u4453": "toi4",
    "\u4454": "fai3",
    "\u4455": "syu2",
    "\u4456": "zit3",
    "\u4457": "tong4",
    "\u4458": "co4",
    "\u4459": "daam1",
    "\u445A": "tim4",
    "\u445B": "saai5",
    "\u445C": "taap3",
    "\u445D": "gaa2",
    "\u445E": "seon3",
    "\u445F": "wong4",
    "\u4460": "liu5",
    "\u4461": "caa1",
    "\u4462": "ngat6/at6",
    "\u4463": "cam1",
    "\u4464": "gam6",
    "\u4465": "ngap6/ap6",
    "\u4466": "kau1",
    "\u4467": "fu1",
    "\u4468": "to4",
    "\u4469": "gu2/gwu2",
    "\u446A": "ngap6/ap6",
    "\u446B": "bang1",
    "\u446C": "tou1",
    "\u446D": "dai3",
    "\u446E": "do2",
    "\u446F": "tai5",
    "\u4470": "bou6",
    "\u4471": "jyun2",
    "\u4472": "zaau6",
    "\u4473": "leon4",
    "\u4474": "kei4",
    "\u4475": "muk6",
    "\u4476": "sin3",
    "\u4477": "gin1",
    "\u4478": "zung1",
    "\u4479": "sau1",
    "\u447A": "faan4",
    "\u447B": "jau4",
    "\u447C": "zau1",
    "\u447D": "taap3",
    "\u447E": "zek3",
    "\u447F": "suk1",
    "\u4480": "fu1/bou6",
    "\u4481": "zaap6",
    "\u4482": "zoeng2",
    "\u4483": "zou6",
    "\u4484": "fu3",
    "\u4485": "tang4",
    "\u4486": "cit3",
    "\u4487": "fu3",
    "\u4488": "fei6",
    "\u4489": "mou5",
    "\u448A": "hei1",
    "\u448B": "joeng2",
    "\u448C": "ming6",
    "\u448D": "pong2",
    "\u448E": "mong5",
    "\u448F": "zang2",
    "\u4490": "mang4",
    "\u4491": "baat3/bing6.zi6.tau4",
    "\u4492": "tiu4",
    "\u4493": "kaai2",
    "\u4494": "baai3",
    "\u4495": "siu2",
    "\u4496": "seon3",
    "\u4497": "hat1",
    "\u4498": "seoi1",
    "\u4499": "cong4",
    "\u449A": "siu2",
    "\u449B": "waan6",
    "\u449C": "ngau4/au4",
    "\u449D": "haau4",
    "\u449E": "cam4",
    "\u449F": "daan1",
    "\u44A0": "fung1",
    "\u44A1": "jan5",
    "\u44A2": "ngong4/ong4",
    "\u44A3": "jim5",
    "\u44A4": "jat6",
    "\u44A5": "mun4",
    "\u44A6": "faan3",
    "\u44A7": "keoi1",
    "\u44A8": "si2",
    "\u44A9": "wo4",
    "\u44AA": "bin6",
    "\u44AB": "doi6",
    "\u44AC": "mok6",
    "\u44AD": "dang2",
    "\u44AE": "gong1",
    "\u44AF": "jyun4",
    "\u44B0": "hong1",
    "\u44B1": "zing1",
    "\u44B2": "zaa3",
    "\u44B3": "do2",
    "\u44B4": "jau5",
    "\u44B5": "hou1",
    "\u44B6": "tin1",
    "\u44B7": "gwaa1",
    "\u44B8": "hyut3",
    "\u44B9": "loi6",
    "\u44BA": "gan2",
    "\u44BB": "hei2",
    "\u44BC": "kuk1",
    "\u44BD": "mong5",
    "\u44BE": "ji1",
    "\u44BF": "liu4",
    "\u44C0": "gat1",
    "\u44C1": "dang2",
    "\u44C2": "jin4",
    "\u44C3": "jap1",
    "\u44C4": "ngan4/an4",
    "\u44C5": "kan4",
    "\u44C6": "zit3",
    "\u44C7": "jik1",
    "\u44C8": "jik6",
    "\u44C9": "je4",
    "\u44CA": "ng4/m4",
    "\u44CB": "zi1",
    "\u44CC": "zi3",
    "\u44CD": "hon2",
    "\u44CE": "cuk1",
    "\u44CF": "fu1",
    "\u44D0": "seon4",
    "\u44D1": "ping4",
    "\u44D2": "gwaai2",
    "\u44D3": "cau4",
    "\u44D4": "haau3",
    "\u44D5": "jyun5/wai2",
    "\u44D6": "kung4",
    "\u44D7": "cung1",
    "\u44D8": "gou1",
    "\u44D9": "kwaa1",
    "\u44DA": "ceoi1",
    "\u44DB": "wat1/gwat1",
    "\u44DC": "zi1",
    "\u44DD": "maang6",
    "\u44DE": "leoi6",
    "\u44DF": "zau1",
    "\u44E0": "taap3",
    "\u44E1": "zi1",
    "\u44E2": "gu3/gwu3",
    "\u44E3": "loeng5",
    "\u44E4": "fat1",
    "\u44E5": "laat6",
    "\u44E6": "din2",
    "\u44E7": "gik1",
    "\u44E8": "aang1/ngaang1/ang1/ngang1",
    "\u44E9": "zi1",
    "\u44EA": "ji6",
    "\u44EB": "kei4",
    "\u44EC": "coek3",
    "\u44ED": "saat3",
    "\u44EE": "mau6",
    "\u44EF": "duk6",
    "\u44F0": "jan1",
    "\u44F1": "caai4",
    "\u44F2": "jeoi6",
    "\u44F3": "han2",
    "\u44F4": "jyun5",
    "\u44F5": "fu1",
    "\u44F6": "laai6",
    "\u44F7": "hang6",
    "\u44F8": "gaan1",
    "\u44F9": "ji3",
    "\u44FA": "mei5",
    "\u44FB": "kau3",
    "\u44FC": "mong4",
    "\u44FD": "gei3",
    "\u44FE": "so1",
    "\u44FF": "ham6",
    "\u4500": "seoi1",
    "\u4501": "leot6",
    "\u4502": "zi2",
    "\u4503": "zou2",
    "\u4504": "jiu4",
    "\u4505": "go1",
    "\u4506": "lei4",
    "\u4507": "hei2/oi2/ngoi2",
    "\u4508": "gung3",
    "\u4509": "lik6",
    "\u450A": "bang1",
    "\u450B": "so1",
    "\u450C": "gou1",
    "\u450D": "duk1",
    "\u450E": "suk1",
    "\u450F": "cau3",
    "\u4510": "zin1",
    "\u4511": "ce4",
    "\u4512": "pui5",
    "\u4513": "heoi2",
    "\u4514": "ging3",
    "\u4515": "pou4",
    "\u4516": "ling4",
    "\u4517": "coeng4",
    "\u4518": "zou6",
    "\u4519": "diu3",
    "\u451A": "seon4",
    "\u451B": "king2/gwing2",
    "\u451C": "naam4/laam4",
    "\u451D": "zaai1",
    "\u451E": "leot6",
    "\u451F": "ji4",
    "\u4520": "saau2",
    "\u4521": "jyu4",
    "\u4522": "waa4",
    "\u4523": "lai4",
    "\u4524": "paa1",
    "\u4525": "siu1",
    "\u4526": "mui4",
    "\u4527": "lei4",
    "\u4528": "ung3/ngung3",
    "\u4529": "cik1",
    "\u452A": "song2",
    "\u452B": "so1",
    "\u452C": "ji6",
    "\u452D": "ning5/ling5",
    "\u452E": "si1",
    "\u452F": "fu3",
    "\u4530": "fu3",
    "\u4531": "jap1",
    "\u4532": "dang1",
    "\u4533": "jin4",
    "\u4534": "cak1",
    "\u4535": "gaan1",
    "\u4536": "tai4",
    "\u4537": "kam4",
    "\u4538": "biu2",
    "\u4539": "seoi6",
    "\u453A": "wai4",
    "\u453B": "deon1",
    "\u453C": "sap1",
    "\u453D": "oi3/ngoi3",
    "\u453E": "hei3",
    "\u453F": "zyun2",
    "\u4540": "fun2",
    "\u4541": "fei2",
    "\u4542": "jyun5",
    "\u4543": "jam1",
    "\u4544": "zing1",
    "\u4545": "sou2",
    "\u4546": "dau6",
    "\u4547": "wui6",
    "\u4548": "sip3",
    "\u4549": "zaak6",
    "\u454A": "taan4",
    "\u454B": "tong4",
    "\u454C": "zi6",
    "\u454D": "jai6",
    "\u454E": "fuk1",
    "\u454F": "ngo4/o4",
    "\u4550": "fuk1",
    "\u4551": "seoi1",
    "\u4552": "gaa1",
    "\u4553": "caat3",
    "\u4554": "haam4",
    "\u4555": "maan6",
    "\u4556": "syun1",
    "\u4557": "bei6",
    "\u4558": "ling4",
    "\u4559": "zit6",
    "\u455A": "gwai6",
    "\u455B": "gaap3",
    "\u455C": "ceoi3",
    "\u455D": "cing1",
    "\u455E": "long6",
    "\u455F": "hing1",
    "\u4560": "fai3",
    "\u4561": "leoi4",
    "\u4562": "zaa2",
    "\u4563": "hot6",
    "\u4564": "kei4",
    "\u4565": "nei5/lei5",
    "\u4566": "jing4",
    "\u4567": "gaau1",
    "\u4568": "tang4",
    "\u4569": "lou5",
    "\u456A": "zaak6",
    "\u456B": "kwai4",
    "\u456C": "goeng1",
    "\u456D": "cam4/cim4",
    "\u456E": "guk1",
    "\u456F": "piu1",
    "\u4570": "faan4",
    "\u4571": "tau4",
    "\u4572": "lam5",
    "\u4573": "mei4",
    "\u4574": "zuk1",
    "\u4575": "kit3",
    "\u4576": "wu6",
    "\u4577": "mei4",
    "\u4578": "gaai1",
    "\u4579": "zaap6",
    "\u457A": "cung4",
    "\u457B": "lai6",
    "\u457C": "jin4",
    "\u457D": "zuk6",
    "\u457E": "jam4",
    "\u457F": "hon3",
    "\u4580": "hiu1",
    "\u4581": "jik1",
    "\u4582": "lyun4",
    "\u4583": "joek6",
    "\u4584": "jin4",
    "\u4585": "ling4",
    "\u4586": "noeng6/loeng6",
    "\u4587": "wat1",
    "\u4588": "joek6",
    "\u4589": "heoi1",
    "\u458A": "ngaai6/aai6",
    "\u458B": "joek6",
    "\u458C": "ngat6/at6",
    "\u458D": "kin4",
    "\u458E": "haap6",
    "\u458F": "cyu5/cyu2/cyu3/syu3",
    "\u4590": "ngan4/an4",
    "\u4591": "mik6",
    "\u4592": "hei1",
    "\u4593": "neot6/leot6",
    "\u4594": "ham2",
    "\u4595": "zou2",
    "\u4596": "haap6",
    "\u4597": "ngaam4/aam4",
    "\u4598": "tou4",
    "\u4599": "tai1",
    "\u459A": "wu1",
    "\u459B": "sok3",
    "\u459C": "wui4",
    "\u459D": "cung4",
    "\u459E": "zau2",
    "\u459F": "mong4",
    "\u45A0": "jyun4",
    "\u45A1": "nuk6/luk6",
    "\u45A2": "miu4",
    "\u45A3": "zou2",
    "\u45A4": "jyun1",
    "\u45A5": "maau4",
    "\u45A6": "wat1",
    "\u45A7": "naat6/laat6",
    "\u45A8": "sek6",
    "\u45A9": "bat6",
    "\u45AA": "zi1",
    "\u45AB": "pong5",
    "\u45AC": "gaap3",
    "\u45AD": "gyun3",
    "\u45AE": "hoeng2",
    "\u45AF": "kwai1",
    "\u45B0": "paai3",
    "\u45B1": "hong1",
    "\u45B2": "ceon4",
    "\u45B3": "zaa3/caa3/zit3",
    "\u45B4": "jiu4",
    "\u45B5": "kwan1",
    "\u45B6": "fui1",
    "\u45B7": "hei1",
    "\u45B8": "ngo4/o4",
    "\u45B9": "mei5",
    "\u45BA": "tiu4",
    "\u45BB": "lau4",
    "\u45BC": "koek6",
    "\u45BD": "lei4",
    "\u45BE": "jyun4",
    "\u45BF": "lei4",
    "\u45C0": "cing1",
    "\u45C1": "gei6",
    "\u45C2": "fu2",
    "\u45C3": "zaan6",
    "\u45C4": "fu2",
    "\u45C5": "jau4",
    "\u45C6": "gun2/gwun2",
    "\u45C7": "guk6",
    "\u45C8": "mong4",
    "\u45C9": "coeng1",
    "\u45CA": "taam3",
    "\u45CB": "mau4",
    "\u45CC": "sing1",
    "\u45CD": "lai5",
    "\u45CE": "jin1",
    "\u45CF": "sau1",
    "\u45D0": "si1",
    "\u45D1": "jap6",
    "\u45D2": "bing6",
    "\u45D3": "cung1",
    "\u45D4": "hau4",
    "\u45D5": "jyun1",
    "\u45D6": "dai3",
    "\u45D7": "hin1",
    "\u45D8": "gap3",
    "\u45D9": "hon4",
    "\u45DA": "bok3",
    "\u45DB": "sau1",
    "\u45DC": "lau4",
    "\u45DD": "caam4",
    "\u45DE": "caam4",
    "\u45DF": "ai3/ngai3",
    "\u45E0": "syun4",
    "\u45E1": "jin4",
    "\u45E2": "zou2",
    "\u45E3": "haam4",
    "\u45E4": "jung4",
    "\u45E5": "zung1",
    "\u45E6": "fung1",
    "\u45E7": "hong1",
    "\u45E8": "jyu4",
    "\u45E9": "cik1",
    "\u45EA": "ze3",
    "\u45EB": "maa4",
    "\u45EC": "fung1",
    "\u45ED": "waan6",
    "\u45EE": "song2",
    "\u45EF": "zeon3",
    "\u45F0": "gun3/gwun3",
    "\u45F1": "buk6",
    "\u45F2": "leon6",
    "\u45F3": "dang1",
    "\u45F4": "ting4",
    "\u45F5": "goeng1",
    "\u45F6": "laap6",
    "\u45F7": "ji3",
    "\u45F8": "jung1",
    "\u45F9": "ci3",
    "\u45FA": "jin5",
    "\u45FB": "zit3",
    "\u45FC": "fan1",
    "\u45FD": "wai6",
    "\u45FE": "hin2",
    "\u45FF": "ning4/ling4",
    "\u4600": "fau6",
    "\u4601": "zit3",
    "\u4602": "zim1",
    "\u4603": "mak6",
    "\u4604": "zyu3",
    "\u4605": "noi6/loi6",
    "\u4606": "hyun2/hin2",
    "\u4607": "man1",
    "\u4608": "lai6",
    "\u4609": "caam4",
    "\u460A": "mit6",
    "\u460B": "zim1",
    "\u460C": "nik1/lik1",
    "\u460D": "caai3",
    "\u460E": "waan1",
    "\u460F": "seot1",
    "\u4610": "nuk6/luk6",
    "\u4611": "mak6",
    "\u4612": "zeoi1/zyun1/zeon1/syun1",
    "\u4613": "ham3",
    "\u4614": "kaak3",
    "\u4615": "hong4",
    "\u4616": "haam4",
    "\u4617": "fai1",
    "\u4618": "jyu6",
    "\u4619": "wai6",
    "\u461A": "zeot1",
    "\u461B": "gei1",
    "\u461C": "gan1",
    "\u461D": "jik6",
    "\u461E": "maa6",
    "\u461F": "diu1",
    "\u4620": "fat1",
    "\u4621": "bei6",
    "\u4622": "zyu2",
    "\u4623": "zi2",
    "\u4624": "seot6",
    "\u4625": "haap6",
    "\u4626": "nai4/lai4",
    "\u4627": "joeng1",
    "\u4628": "giu2",
    "\u4629": "seon1",
    "\u462A": "cung1",
    "\u462B": "jyu4",
    "\u462C": "jung4",
    "\u462D": "zi3",
    "\u462E": "song1/song3",
    "\u462F": "saau1",
    "\u4630": "sin1",
    "\u4631": "jyu6",
    "\u4632": "zam1",
    "\u4633": "kam1/gam1",
    "\u4634": "zung1",
    "\u4635": "luk6",
    "\u4636": "haam4",
    "\u4637": "bit3",
    "\u4638": "jik6",
    "\u4639": "zeoi3",
    "\u463A": "zaan6",
    "\u463B": "juk6",
    "\u463C": "jyun2",
    "\u463D": "ngai4/ai4",
    "\u463E": "gun2/gwun2",
    "\u463F": "gwat6",
    "\u4640": "bang1",
    "\u4641": "zin1",
    "\u4642": "zung1",
    "\u4643": "do6",
    "\u4644": "cap1",
    "\u4645": "jiu1",
    "\u4646": "wai3",
    "\u4647": "jyun4",
    "\u4648": "hau4",
    "\u4649": "ceon4",
    "\u464A": "daai3",
    "\u464B": "syun1",
    "\u464C": "kui2/kwui2",
    "\u464D": "fei1",
    "\u464E": "haai4",
    "\u464F": "bok3",
    "\u4650": "hak1",
    "\u4651": "ceoi1",
    "\u4652": "cuk1",
    "\u4653": "baai2/bei1",
    "\u4654": "au1/ngau1",
    "\u4655": "zung2",
    "\u4656": "bang1",
    "\u4657": "tai3",
    "\u4658": "co2",
    "\u4659": "ci4",
    "\u465A": "niu5/liu5",
    "\u465B": "gwan2",
    "\u465C": "fung4",
    "\u465D": "dip6",
    "\u465E": "dang1",
    "\u465F": "wai4",
    "\u4660": "gyut6",
    "\u4661": "kui2/kwui2",
    "\u4662": "zang3",
    "\u4663": "saap3",
    "\u4664": "do2",
    "\u4665": "ling4",
    "\u4666": "mung4",
    "\u4667": "fan1",
    "\u4668": "gwo2/go2",
    "\u4669": "mung4",
    "\u466A": "paan3",
    "\u466B": "kei3",
    "\u466C": "ang3/ngang3",
    "\u466D": "hin1",
    "\u466E": "gyun6",
    "\u466F": "zuk1",
    "\u4670": "lei4",
    "\u4671": "suk6",
    "\u4672": "cin1",
    "\u4673": "biu1",
    "\u4674": "cin1",
    "\u4675": "kwai4",
    "\u4676": "nung4/lung4",
    "\u4677": "dak1",
    "\u4678": "dak1",
    "\u4679": "jin6",
    "\u467A": "lim4",
    "\u467B": "ci1",
    "\u467C": "siu6",
    "\u467D": "kit3",
    "\u467E": "si1",
    "\u467F": "mei6",
    "\u4680": "cam1",
    "\u4681": "cam1",
    "\u4682": "haak3",
    "\u4683": "jau4",
    "\u4684": "luk6",
    "\u4685": "loi6",
    "\u4686": "jing2",
    "\u4687": "saang2",
    "\u4688": "gyun3",
    "\u4689": "kai3",
    "\u468A": "gyun1",
    "\u468B": "wan6",
    "\u468C": "gou1",
    "\u468D": "cik1",
    "\u468E": "cong1",
    "\u468F": "leon6",
    "\u4690": "zik6",
    "\u4691": "maai4",
    "\u4692": "cong4",
    "\u4693": "sam2",
    "\u4694": "ban1",
    "\u4695": "lai6/saai2",
    "\u4696": "ling4",
    "\u4697": "gong1",
    "\u4698": "caang4",
    "\u4699": "hyun1",
    "\u469A": "sin2",
    "\u469B": "huk6",
    "\u469C": "bai1",
    "\u469D": "zyut6",
    "\u469E": "daai2",
    "\u469F": "daai2",
    "\u46A0": "wan6",
    "\u46A1": "soi1",
    "\u46A2": "cit3",
    "\u46A3": "tai4",
    "\u46A4": "jyu4",
    "\u46A5": "nok6/lok6",
    "\u46A6": "zi6/zaai6",
    "\u46A7": "lau4",
    "\u46A8": "fai3",
    "\u46A9": "giu2",
    "\u46AA": "gwaan1",
    "\u46AB": "hat6",
    "\u46AC": "leon4",
    "\u46AD": "hyun1",
    "\u46AE": "jing4",
    "\u46AF": "tou2",
    "\u46B0": "pei2",
    "\u46B1": "seon3",
    "\u46B2": "saan3",
    "\u46B3": "zi3",
    "\u46B4": "waat6",
    "\u46B5": "tau2",
    "\u46B6": "tin1",
    "\u46B7": "ji1",
    "\u46B8": "haai6",
    "\u46B9": "pei2",
    "\u46BA": "jiu4",
    "\u46BB": "jiu4",
    "\u46BC": "nuk6/luk6",
    "\u46BD": "hou3",
    "\u46BE": "jam4",
    "\u46BF": "jam6",
    "\u46C0": "faan2",
    "\u46C1": "naam4/laam4",
    "\u46C2": "ci4",
    "\u46C3": "wun6",
    "\u46C4": "jyun3",
    "\u46C5": "haap3",
    "\u46C6": "zau6",
    "\u46C7": "jin5",
    "\u46C8": "si3",
    "\u46C9": "min6",
    "\u46CA": "hei1",
    "\u46CB": "gei6",
    "\u46CC": "tou4",
    "\u46CD": "fai3",
    "\u46CE": "hyut3",
    "\u46CF": "nai4/lai4",
    "\u46D0": "ci4",
    "\u46D1": "mat6",
    "\u46D2": "bin6",
    "\u46D3": "gaam1",
    "\u46D4": "naa4/laa4",
    "\u46D5": "jyu4",
    "\u46D6": "jai6",
    "\u46D7": "zi2",
    "\u46D8": "jam4",
    "\u46D9": "juk1",
    "\u46DA": "loek6",
    "\u46DB": "fui3",
    "\u46DC": "seon3",
    "\u46DD": "nou4/lou4",
    "\u46DE": "hon5",
    "\u46DF": "gip3",
    "\u46E0": "dau3",
    "\u46E1": "waa6",
    "\u46E2": "tuk1",
    "\u46E3": "ping1",
    "\u46E4": "cuk1",
    "\u46E5": "hat1",
    "\u46E6": "zung6",
    "\u46E7": "mai4",
    "\u46E8": "seon3",
    "\u46E9": "wu2",
    "\u46EA": "hung3",
    "\u46EB": "zoeng1",
    "\u46EC": "tou4",
    "\u46ED": "hang6",
    "\u46EE": "kau5",
    "\u46EF": "geoi3",
    "\u46F0": "wan6",
    "\u46F1": "tai4",
    "\u46F2": "maan4",
    "\u46F3": "jim3",
    "\u46F4": "gei1",
    "\u46F5": "sau6",
    "\u46F6": "loi6",
    "\u46F7": "jyun2",
    "\u46F8": "zaam1",
    "\u46F9": "sin3",
    "\u46FA": "gaai3",
    "\u46FB": "jau5",
    "\u46FC": "wai2",
    "\u46FD": "zaap3",
    "\u46FE": "sou3",
    "\u46FF": "gaak3",
    "\u4700": "nou5/lou5",
    "\u4701": "hai6",
    "\u4702": "hou4",
    "\u4703": "deoi1",
    "\u4704": "ci4",
    "\u4705": "wai4",
    "\u4706": "zip3",
    "\u4707": "gwan2",
    "\u4708": "ziu2",
    "\u4709": "cat1",
    "\u470A": "zou1",
    "\u470B": "wui6",
    "\u470C": "lyun4",
    "\u470D": "liu4",
    "\u470E": "lou4",
    "\u470F": "to1",
    "\u4710": "fai1",
    "\u4711": "wu3",
    "\u4712": "ou3/ngou3",
    "\u4713": "sip3",
    "\u4714": "ceoi4",
    "\u4715": "maai6",
    "\u4716": "taam4",
    "\u4717": "jam3",
    "\u4718": "ging2",
    "\u4719": "ngam4/am4",
    "\u471A": "daap6",
    "\u471B": "caam4",
    "\u471C": "wai6",
    "\u471D": "tyun2",
    "\u471E": "zai1",
    "\u471F": "cam3",
    "\u4720": "zat1",
    "\u4721": "juk1",
    "\u4722": "hin2",
    "\u4723": "jan1/hei1/ngan4/an4",
    "\u4724": "hung6",
    "\u4725": "daan3",
    "\u4726": "seon1",
    "\u4727": "nou5/lou5",
    "\u4728": "waan6",
    "\u4729": "jin3",
    "\u472A": "kau4",
    "\u472B": "gong1",
    "\u472C": "zau6",
    "\u472D": "zeon3",
    "\u472E": "liu4",
    "\u472F": "guk6",
    "\u4730": "hou1",
    "\u4731": "mun4",
    "\u4732": "lip6",
    "\u4733": "jyut3",
    "\u4734": "co3",
    "\u4735": "si6",
    "\u4736": "gong3",
    "\u4737": "cam1",
    "\u4738": "mui5",
    "\u4739": "cuk1",
    "\u473A": "caak3",
    "\u473B": "si6",
    "\u473C": "guk1",
    "\u473D": "jyu4",
    "\u473E": "jam1",
    "\u473F": "syu6",
    "\u4740": "lau4",
    "\u4741": "lou4",
    "\u4742": "syu6",
    "\u4743": "zip6",
    "\u4744": "soeng1",
    "\u4745": "fui1",
    "\u4746": "fat1",
    "\u4747": "fui1",
    "\u4748": "ak1/ngak1",
    "\u4749": "mung4",
    "\u474A": "saap3",
    "\u474B": "zung3/zung1",
    "\u474C": "kyut3",
    "\u474D": "gwan3",
    "\u474E": "teon1",
    "\u474F": "lau4/lau1",
    "\u4750": "wai4",
    "\u4751": "cung1",
    "\u4752": "zo6",
    "\u4753": "lip6",
    "\u4754": "fun1",
    "\u4755": "zip3",
    "\u4756": "zaau2",
    "\u4757": "jau1",
    "\u4758": "ngai6/ai6",
    "\u4759": "ceoi1",
    "\u475A": "nei4/lei4",
    "\u475B": "bo1",
    "\u475C": "syun1",
    "\u475D": "ji1",
    "\u475E": "fu2",
    "\u475F": "aat3/ngaat3/jaak3",
    "\u4760": "jyun4/wun4",
    "\u4761": "maan6",
    "\u4762": "maan6",
    "\u4763": "keoi4",
    "\u4764": "lou5",
    "\u4765": "hou4",
    "\u4766": "zung1",
    "\u4767": "man4",
    "\u4768": "jin4",
    "\u4769": "zan3",
    "\u476A": "so2",
    "\u476B": "zok6",
    "\u476C": "zyu3",
    "\u476D": "gau3",
    "\u476E": "jyun6",
    "\u476F": "ji4/ji6",
    "\u4770": "zi6",
    "\u4771": "hip3",
    "\u4772": "zeon2",
    "\u4773": "caan4",
    "\u4774": "zai1",
    "\u4775": "bou6",
    "\u4776": "loeng4",
    "\u4777": "zi1",
    "\u4778": "gei6",
    "\u4779": "wun2",
    "\u477A": "gun3/gwun3",
    "\u477B": "geoi1",
    "\u477C": "cing4/cing2/zing6",
    "\u477D": "ngaai6/aai6",
    "\u477E": "fu3",
    "\u477F": "gwai3",
    "\u4780": "hau6",
    "\u4781": "jin3",
    "\u4782": "jyun5",
    "\u4783": "zi3",
    "\u4784": "biu3",
    "\u4785": "ji4",
    "\u4786": "so3",
    "\u4787": "zi3",
    "\u4788": "gwai3",
    "\u4789": "sing6",
    "\u478A": "seon3",
    "\u478B": "can3",
    "\u478C": "sit6",
    "\u478D": "cing4/cing2/zing6",
    "\u478E": "coeng1",
    "\u478F": "si1",
    "\u4790": "seon2",
    "\u4791": "hung4",
    "\u4792": "dung6",
    "\u4793": "cing1",
    "\u4794": "mei5",
    "\u4795": "jyu4",
    "\u4796": "suk6",
    "\u4797": "caai1",
    "\u4798": "gat1/gat6",
    "\u4799": "zaap3",
    "\u479A": "kei4",
    "\u479B": "jin1",
    "\u479C": "fu3",
    "\u479D": "juk6",
    "\u479E": "fat6",
    "\u479F": "paak3",
    "\u47A0": "zek3",
    "\u47A1": "taan2",
    "\u47A2": "zok3",
    "\u47A3": "ce2",
    "\u47A4": "keoi4",
    "\u47A5": "jau6",
    "\u47A6": "haak6",
    "\u47A7": "hau6",
    "\u47A8": "kwai2",
    "\u47A9": "ap1/ngap1",
    "\u47AA": "zoeng6",
    "\u47AB": "wan5",
    "\u47AC": "tau3",
    "\u47AD": "ceon1",
    "\u47AE": "tou1",
    "\u47AF": "fu3",
    "\u47B0": "zaak6",
    "\u47B1": "huk6",
    "\u47B2": "ngo5/o5",
    "\u47B3": "baak6",
    "\u47B4": "zaau1",
    "\u47B5": "kyut3",
    "\u47B6": "tong1",
    "\u47B7": "gyut6",
    "\u47B8": "fu3",
    "\u47B9": "wong4",
    "\u47BA": "ceon1",
    "\u47BB": "jung5",
    "\u47BC": "cyun2",
    "\u47BD": "saak3",
    "\u47BE": "ci4",
    "\u47BF": "hin1",
    "\u47C0": "caai1",
    "\u47C1": "haau1",
    "\u47C2": "mun4",
    "\u47C3": "caam1",
    "\u47C4": "cik1",
    "\u47C5": "zim6",
    "\u47C6": "bat1",
    "\u47C7": "gei1",
    "\u47C8": "zat6",
    "\u47C9": "zuk1",
    "\u47CA": "keoi4",
    "\u47CB": "zim2",
    "\u47CC": "zit6",
    "\u47CD": "bin1",
    "\u47CE": "zaan2",
    "\u47CF": "lik6",
    "\u47D0": "lik6",
    "\u47D1": "joek6",
    "\u47D2": "kyun4",
    "\u47D3": "caang1",
    "\u47D4": "fu6",
    "\u47D5": "caa1",
    "\u47D6": "tong3",
    "\u47D7": "si6",
    "\u47D8": "hong6",
    "\u47D9": "cit3",
    "\u47DA": "gei1",
    "\u47DB": "bat6",
    "\u47DC": "neot6/leot6",
    "\u47DD": "tau3",
    "\u47DE": "cyu4",
    "\u47DF": "cuk1",
    "\u47E0": "jyut6",
    "\u47E1": "dai3/zi1",
    "\u47E2": "nin2/lin2",
    "\u47E3": "ceot1",
    "\u47E4": "bai6",
    "\u47E5": "mung4",
    "\u47E6": "bat6",
    "\u47E7": "tin4",
    "\u47E8": "man4",
    "\u47E9": "le5",
    "\u47EA": "fung2",
    "\u47EB": "caang1",
    "\u47EC": "jau3",
    "\u47ED": "tiu3",
    "\u47EE": "fuk6",
    "\u47EF": "kut3/kwut3",
    "\u47F0": "gin2",
    "\u47F1": "zik1",
    "\u47F2": "cung1",
    "\u47F3": "cuk1",
    "\u47F4": "an3/ngan3",
    "\u47F5": "kau4",
    "\u47F6": "co3",
    "\u47F7": "cai3",
    "\u47F8": "kwai4",
    "\u47F9": "lyut6",
    "\u47FA": "bui3",
    "\u47FB": "dou6",
    "\u47FC": "mou5",
    "\u47FD": "so1",
    "\u47FE": "dyut3",
    "\u47FF": "luk6",
    "\u4800": "tong3/tong2/tong1",
    "\u4801": "zai1",
    "\u4802": "co2",
    "\u4803": "loeng5",
    "\u4804": "tin2",
    "\u4805": "kwan2",
    "\u4806": "coeng4",
    "\u4807": "gwat6",
    "\u4808": "teot1",
    "\u4809": "wun6",
    "\u480A": "fei6/fai3",
    "\u480B": "pe5",
    "\u480C": "daap6",
    "\u480D": "haa4",
    "\u480E": "ak1/ngak1",
    "\u480F": "gwai6",
    "\u4810": "kwik1",
    "\u4811": "kwai2",
    "\u4812": "wu4",
    "\u4813": "cau1",
    "\u4814": "seoi6",
    "\u4815": "caai1",
    "\u4816": "zi1",
    "\u4817": "jau3",
    "\u4818": "pei3",
    "\u4819": "pong4",
    "\u481A": "waa2",
    "\u481B": "jiu4",
    "\u481C": "jung4",
    "\u481D": "hyun1",
    "\u481E": "cuk1",
    "\u481F": "dip6",
    "\u4820": "cai3",
    "\u4821": "co4",
    "\u4822": "mung6",
    "\u4823": "syun2",
    "\u4824": "do2",
    "\u4825": "bit6",
    "\u4826": "zi3",
    "\u4827": "caa4",
    "\u4828": "cim3",
    "\u4829": "gwai6",
    "\u482A": "teon2",
    "\u482B": "zau6",
    "\u482C": "dang3",
    "\u482D": "laai6",
    "\u482E": "tang4",
    "\u482F": "joek6",
    "\u4830": "kyun4",
    "\u4831": "zuk6",
    "\u4832": "ling4",
    "\u4833": "can1",
    "\u4834": "zan2",
    "\u4835": "fu6",
    "\u4836": "se6/jik6/je6",
    "\u4837": "tiu1",
    "\u4838": "kwaa1",
    "\u4839": "haai4",
    "\u483A": "man6",
    "\u483B": "hung3",
    "\u483C": "syu3",
    "\u483D": "haai4",
    "\u483E": "sim2",
    "\u483F": "waai6",
    "\u4840": "zin2",
    "\u4841": "lung5",
    "\u4842": "kau1",
    "\u4843": "leot6",
    "\u4844": "gei1",
    "\u4845": "ceon1",
    "\u4846": "jung4",
    "\u4847": "jyut6",
    "\u4848": "gok3",
    "\u4849": "hong2",
    "\u484A": "faan2",
    "\u484B": "kei4",
    "\u484C": "wang4",
    "\u484D": "fu4",
    "\u484E": "lou4",
    "\u484F": "wang4",
    "\u4850": "to4",
    "\u4851": "man4",
    "\u4852": "tin4",
    "\u4853": "gyun3",
    "\u4854": "kai2",
    "\u4855": "sing4",
    "\u4856": "hing3",
    "\u4857": "gung2",
    "\u4858": "tin4",
    "\u4859": "long4",
    "\u485A": "maau6",
    "\u485B": "jan6",
    "\u485C": "luk6",
    "\u485D": "jyun1",
    "\u485E": "guk1",
    "\u485F": "pai3",
    "\u4860": "hang1",
    "\u4861": "haai4",
    "\u4862": "bin6",
    "\u4863": "wan4",
    "\u4864": "zyu1",
    "\u4865": "jung4",
    "\u4866": "song2",
    "\u4867": "wu1",
    "\u4868": "caai4",
    "\u4869": "hang1",
    "\u486A": "sin3",
    "\u486B": "pung4",
    "\u486C": "maan6",
    "\u486D": "sau1",
    "\u486E": "zung1",
    "\u486F": "cung1",
    "\u4870": "hang1",
    "\u4871": "zyun2",
    "\u4872": "saan4",
    "\u4873": "si1",
    "\u4874": "cung1",
    "\u4875": "seoi6",
    "\u4876": "pik1",
    "\u4877": "hat6",
    "\u4878": "mit6",
    "\u4879": "zi3",
    "\u487A": "wai6",
    "\u487B": "min4",
    "\u487C": "ling4",
    "\u487D": "zyun1",
    "\u487E": "jit6",
    "\u487F": "ling4",
    "\u4880": "ngat6/at6",
    "\u4881": "jyut6",
    "\u4882": "lip1",
    "\u4883": "ngaai6/aai6",
    "\u4884": "saai2",
    "\u4885": "san4",
    "\u4886": "jung2",
    "\u4887": "jung5",
    "\u4888": "wui6",
    "\u4889": "nung4/lung4",
    "\u488A": "jau4",
    "\u488B": "gei3",
    "\u488C": "but3",
    "\u488D": "fong6",
    "\u488E": "gei3",
    "\u488F": "dau2",
    "\u4890": "cou4",
    "\u4891": "dai2",
    "\u4892": "gaau1",
    "\u4893": "jyu4",
    "\u4894": "hap6",
    "\u4895": "wat1",
    "\u4896": "jyut6",
    "\u4897": "kuk1",
    "\u4898": "sau2",
    "\u4899": "baai6",
    "\u489A": "gang1",
    "\u489B": "gwing2",
    "\u489C": "gwai1",
    "\u489D": "aa3/ngaa3",
    "\u489E": "seot6",
    "\u489F": "jau4",
    "\u48A0": "sung3",
    "\u48A1": "jip6",
    "\u48A2": "cong3",
    "\u48A3": "jiu4",
    "\u48A4": "seot6",
    "\u48A5": "jin4",
    "\u48A6": "seot1",
    "\u48A7": "liu6",
    "\u48A8": "cung1",
    "\u48A9": "jyu6",
    "\u48AA": "hiu1",
    "\u48AB": "ceoi4",
    "\u48AC": "cin1",
    "\u48AD": "jin6",
    "\u48AE": "leoi5",
    "\u48AF": "leon4",
    "\u48B0": "tik1",
    "\u48B1": "duk6",
    "\u48B2": "wok6",
    "\u48B3": "gei2",
    "\u48B4": "cin1",
    "\u48B5": "wan4",
    "\u48B6": "bong1",
    "\u48B7": "daan1",
    "\u48B8": "zeoi1",
    "\u48B9": "geoi2",
    "\u48BA": "ceot1",
    "\u48BB": "san4",
    "\u48BC": "gung1",
    "\u48BD": "hong6",
    "\u48BE": "san1",
    "\u48BF": "on1/ngon1",
    "\u48C0": "gwai2",
    "\u48C1": "jyu5",
    "\u48C2": "leoi5",
    "\u48C3": "se3",
    "\u48C4": "tou4",
    "\u48C5": "san4",
    "\u48C6": "jing4",
    "\u48C7": "kau4",
    "\u48C8": "hong6",
    "\u48C9": "saa1",
    "\u48CA": "dong2",
    "\u48CB": "coi2",
    "\u48CC": "dai2",
    "\u48CD": "jim2",
    "\u48CE": "zi1",
    "\u48CF": "gung1",
    "\u48D0": "jing1",
    "\u48D1": "cin4",
    "\u48D2": "gwai3",
    "\u48D3": "lai4",
    "\u48D4": "so2",
    "\u48D5": "maa5",
    "\u48D6": "maa5",
    "\u48D7": "gou1",
    "\u48D8": "tong4",
    "\u48D9": "pui4",
    "\u48DA": "lau4",
    "\u48DB": "sat1",
    "\u48DC": "co4",
    "\u48DD": "tou4",
    "\u48DE": "ngok6/ok6",
    "\u48DF": "caam4",
    "\u48E0": "ze6",
    "\u48E1": "ji4",
    "\u48E2": "zik6",
    "\u48E3": "dong2",
    "\u48E4": "fok3",
    "\u48E5": "bei2",
    "\u48E6": "leoi6",
    "\u48E7": "jik6",
    "\u48E8": "seon4",
    "\u48E9": "seon4",
    "\u48EA": "put3",
    "\u48EB": "ci1",
    "\u48EC": "seon4",
    "\u48ED": "jau5",
    "\u48EE": "put3",
    "\u48EF": "cou4",
    "\u48F0": "geoi6",
    "\u48F1": "jyu3/heoi3/heoi2",
    "\u48F2": "faan3",
    "\u48F3": "si1",
    "\u48F4": "jyu3",
    "\u48F5": "nei6/lei6",
    "\u48F6": "wut6",
    "\u48F7": "zyu1",
    "\u48F8": "jim5",
    "\u48F9": "fat6",
    "\u48FA": "gyun3",
    "\u48FB": "ham1",
    "\u48FC": "loeng4",
    "\u48FD": "zi1",
    "\u48FE": "mik6",
    "\u48FF": "jyu4",
    "\u4900": "joek6",
    "\u4901": "cam4",
    "\u4902": "mui4",
    "\u4903": "jam1",
    "\u4904": "min5",
    "\u4905": "tou4",
    "\u4906": "kwai4",
    "\u4907": "sau1",
    "\u4908": "hei1",
    "\u4909": "mat6",
    "\u490A": "jung4",
    "\u490B": "juk1",
    "\u490C": "coeng1",
    "\u490D": "mai4",
    "\u490E": "gwat1",
    "\u490F": "pei5",
    "\u4910": "zam2",
    "\u4911": "ong3/ngong3",
    "\u4912": "gei6",
    "\u4913": "mung4",
    "\u4914": "zim6",
    "\u4915": "hok3",
    "\u4916": "bou6",
    "\u4917": "gam2",
    "\u4918": "caam2",
    "\u4919": "lik6",
    "\u491A": "lei5",
    "\u491B": "kau4",
    "\u491C": "deon6",
    "\u491D": "ngaang6/aang6",
    "\u491E": "wan5",
    "\u491F": "cam4",
    "\u4920": "zi2",
    "\u4921": "jim5",
    "\u4922": "baat3",
    "\u4923": "lyut3",
    "\u4924": "hoi1",
    "\u4925": "gwai2",
    "\u4926": "jyut6",
    "\u4927": "fui3",
    "\u4928": "pik1",
    "\u4929": "zaak6",
    "\u492A": "do2",
    "\u492B": "caam4",
    "\u492C": "so1/saa1",
    "\u492D": "sik1",
    "\u492E": "sip3",
    "\u492F": "jing4",
    "\u4930": "jing4",
    "\u4931": "sai6",
    "\u4932": "cek3",
    "\u4933": "ze6",
    "\u4934": "ham4",
    "\u4935": "fei6",
    "\u4936": "jip3",
    "\u4937": "jin2",
    "\u4938": "cyun3",
    "\u4939": "sau1",
    "\u493A": "gan1",
    "\u493B": "do6",
    "\u493C": "sin3",
    "\u493D": "gwaan1",
    "\u493E": "tou1",
    "\u493F": "kit3",
    "\u4940": "cin2",
    "\u4941": "ham4",
    "\u4942": "mung6",
    "\u4943": "ngok6/ok6",
    "\u4944": "cou3",
    "\u4945": "kam4",
    "\u4946": "kam4",
    "\u4947": "sin3",
    "\u4948": "mou5/mong5",
    "\u4949": "jyun1",
    "\u494A": "coeng1",
    "\u494B": "paang1",
    "\u494C": "zing3",
    "\u494D": "zi3",
    "\u494E": "seon4",
    "\u494F": "jyu5",
    "\u4950": "mau4",
    "\u4951": "faan6",
    "\u4952": "koeng5",
    "\u4953": "gei1",
    "\u4954": "suk1",
    "\u4955": "pit3",
    "\u4956": "tin4",
    "\u4957": "fun2",
    "\u4958": "co3",
    "\u4959": "seoi6",
    "\u495A": "co1",
    "\u495B": "git3",
    "\u495C": "gaan2",
    "\u495D": "ou1/ngou1/ngou4/ou4/juk1",
    "\u495E": "giu2",
    "\u495F": "jit3",
    "\u4960": "zam1",
    "\u4961": "jip6",
    "\u4962": "lung4",
    "\u4963": "zok6",
    "\u4964": "bok6",
    "\u4965": "lim4",
    "\u4966": "ceoi4",
    "\u4967": "syun4",
    "\u4968": "leoi6",
    "\u4969": "mei4",
    "\u496A": "hin2",
    "\u496B": "tit3",
    "\u496C": "bok3",
    "\u496D": "zing3",
    "\u496E": "zuk1",
    "\u496F": "bei1",
    "\u4970": "mang4",
    "\u4971": "se2",
    "\u4972": "au1/ngau1",
    "\u4973": "jau1",
    "\u4974": "kwai4",
    "\u4975": "hiu2",
    "\u4976": "lik6",
    "\u4977": "zaap6",
    "\u4978": "bei1",
    "\u4979": "ngit6/it6",
    "\u497A": "je4/ngaa4/aa4",
    "\u497B": "mou4",
    "\u497C": "mat6",
    "\u497D": "put3",
    "\u497E": "se2",
    "\u497F": "lai6",
    "\u4980": "jyu5",
    "\u4981": "bong1",
    "\u4982": "sin3",
    "\u4983": "zoek3/zoek6",
    "\u4984": "wai6",
    "\u4985": "sin3/sin6",
    "\u4986": "fok3/kyut3",
    "\u4987": "gai3",
    "\u4988": "ze1",
    "\u4989": "sei3",
    "\u498A": "niu5/liu5",
    "\u498B": "ngou4/ou4",
    "\u498C": "cyu3",
    "\u498D": "ngat6/at6",
    "\u498E": "gun2/gwun2",
    "\u498F": "haai6",
    "\u4990": "ting2",
    "\u4991": "hyut3",
    "\u4992": "dong6",
    "\u4993": "zaam1",
    "\u4994": "taan2",
    "\u4995": "ping1",
    "\u4996": "kit3",
    "\u4997": "gwik1",
    "\u4998": "haan6",
    "\u4999": "zi6",
    "\u499A": "fut3",
    "\u499B": "zang3/zaang1/zaang3",
    "\u499C": "ng4/m4",
    "\u499D": "waak6",
    "\u499E": "jeon6",
    "\u499F": "caai2/ceoi3/ceoi2",
    "\u49A0": "si2",
    "\u49A1": "wun4",
    "\u49A2": "fut3",
    "\u49A3": "fu3",
    "\u49A4": "ceoi3",
    "\u49A5": "haan4",
    "\u49A6": "kam4",
    "\u49A7": "jik1",
    "\u49A8": "laan4",
    "\u49A9": "man4",
    "\u49AA": "ngaat6/aat6",
    "\u49AB": "jing1",
    "\u49AC": "kyut3",
    "\u49AD": "hong1",
    "\u49AE": "ceon2",
    "\u49AF": "zi3",
    "\u49B0": "gau1",
    "\u49B1": "wai2",
    "\u49B2": "jim4",
    "\u49B3": "hoeng3",
    "\u49B4": "jik6",
    "\u49B5": "nai5/lai5",
    "\u49B6": "zang3/zaang1/zaang3",
    "\u49B7": "caai2/ceoi3/ceoi2",
    "\u49B8": "jyu6",
    "\u49B9": "sap6",
    "\u49BA": "ding1",
    "\u49BB": "zi2",
    "\u49BC": "kyut3",
    "\u49BD": "zeoi6",
    "\u49BE": "jyun4",
    "\u49BF": "zung1",
    "\u49C0": "gwang1",
    "\u49C1": "heoi2",
    "\u49C2": "ziu3",
    "\u49C3": "tin4",
    "\u49C4": "gok3",
    "\u49C5": "ji4",
    "\u49C6": "hung4",
    "\u49C7": "ji1",
    "\u49C8": "sai1",
    "\u49C9": "lei5",
    "\u49CA": "huk1",
    "\u49CB": "hin2",
    "\u49CC": "seoi1",
    "\u49CD": "gwik1",
    "\u49CE": "jyun5",
    "\u49CF": "fung1",
    "\u49D0": "gwok3/gok3",
    "\u49D1": "dai1",
    "\u49D2": "loi4",
    "\u49D3": "zau1",
    "\u49D4": "nim6/lim6",
    "\u49D5": "wik6",
    "\u49D6": "cin5",
    "\u49D7": "bik1",
    "\u49D8": "zyun6",
    "\u49D9": "ling4",
    "\u49DA": "hou6",
    "\u49DB": "bong6",
    "\u49DC": "tong4",
    "\u49DD": "ci1",
    "\u49DE": "maa6",
    "\u49DF": "haam6",
    "\u49E0": "zyun1",
    "\u49E1": "jung4",
    "\u49E2": "keoi1",
    "\u49E3": "jan1",
    "\u49E4": "buk1",
    "\u49E5": "wai6",
    "\u49E6": "wai4",
    "\u49E7": "ngai5/ai5",
    "\u49E8": "jip6",
    "\u49E9": "gam2",
    "\u49EA": "cip3",
    "\u49EB": "hou4",
    "\u49EC": "ban1",
    "\u49ED": "si1",
    "\u49EE": "hin3",
    "\u49EF": "caam4",
    "\u49F0": "wan6",
    "\u49F1": "gau1",
    "\u49F2": "gon1",
    "\u49F3": "ci1",
    "\u49F4": "zi1",
    "\u49F5": "zam6",
    "\u49F6": "kwai4",
    "\u49F7": "jau4",
    "\u49F8": "gu1/gwu1",
    "\u49F9": "jing1",
    "\u49FA": "hung4",
    "\u49FB": "gap3",
    "\u49FC": "huk6",
    "\u49FD": "ceoi2",
    "\u49FE": "syu1",
    "\u49FF": "zoek3",
    "\u4A00": "dek6",
    "\u4A01": "mou6",
    "\u4A02": "cau1",
    "\u4A03": "aan3/ngaan3",
    "\u4A04": "am1/ngam1",
    "\u4A05": "liu4",
    "\u4A06": "bai3",
    "\u4A07": "soeng1",
    "\u4A08": "ban1",
    "\u4A09": "jing1",
    "\u4A0A": "jyun1",
    "\u4A0B": "joek6",
    "\u4A0C": "bok6",
    "\u4A0D": "jing2",
    "\u4A0E": "wang4",
    "\u4A0F": "ci4",
    "\u4A10": "hap6",
    "\u4A11": "tai4",
    "\u4A12": "jyu6",
    "\u4A13": "leoi4",
    "\u4A14": "bok6",
    "\u4A15": "jyu1",
    "\u4A16": "zai3",
    "\u4A17": "fau4",
    "\u4A18": "sin3",
    "\u4A19": "jam4",
    "\u4A1A": "fat1",
    "\u4A1B": "saak3",
    "\u4A1C": "bang1",
    "\u4A1D": "cing1",
    "\u4A1E": "jyu5",
    "\u4A1F": "waa1",
    "\u4A20": "oi3/ngoi3",
    "\u4A21": "ham4",
    "\u4A22": "daam6",
    "\u4A23": "gaak3",
    "\u4A24": "dik6",
    "\u4A25": "wok6",
    "\u4A26": "pong1/pong4",
    "\u4A27": "jam1",
    "\u4A28": "zeoi1",
    "\u4A29": "ling4",
    "\u4A2A": "maai4",
    "\u4A2B": "mak6",
    "\u4A2C": "lim4",
    "\u4A2D": "siu1",
    "\u4A2E": "syut3",
    "\u4A2F": "zan6",
    "\u4A30": "pok3",
    "\u4A31": "fuk1",
    "\u4A32": "nau4/lau4",
    "\u4A33": "hei3",
    "\u4A34": "deoi6/deoi3",
    "\u4A35": "daam6",
    "\u4A36": "wan5",
    "\u4A37": "sin3",
    "\u4A38": "jan2",
    "\u4A39": "suk1",
    "\u4A3A": "deoi6",
    "\u4A3B": "bang6",
    "\u4A3C": "wu6",
    "\u4A3D": "fei2",
    "\u4A3E": "fai6",
    "\u4A3F": "zaap6",
    "\u4A40": "bei6",
    "\u4A41": "fei1",
    "\u4A42": "haam1",
    "\u4A43": "si6",
    "\u4A44": "tin2/min5",
    "\u4A45": "zin2",
    "\u4A46": "zaan2",
    "\u4A47": "zaam1",
    "\u4A48": "fui3",
    "\u4A49": "fu6",
    "\u4A4A": "jyun2",
    "\u4A4B": "mo5",
    "\u4A4C": "ciu4",
    "\u4A4D": "liu5",
    "\u4A4E": "cim1",
    "\u4A4F": "mit6",
    "\u4A50": "fat1",
    "\u4A51": "wang4",
    "\u4A52": "jyu4",
    "\u4A53": "kei4",
    "\u4A54": "do6",
    "\u4A55": "ngong4/ong4",
    "\u4A56": "saa1",
    "\u4A57": "baa3",
    "\u4A58": "dai3",
    "\u4A59": "jyun5",
    "\u4A5A": "dai3",
    "\u4A5B": "bat6",
    "\u4A5C": "zau6",
    "\u4A5D": "pok3",
    "\u4A5E": "tip3",
    "\u4A5F": "ji4",
    "\u4A60": "ting1",
    "\u4A61": "gaap3",
    "\u4A62": "zai3",
    "\u4A63": "tou4",
    "\u4A64": "kit3",
    "\u4A65": "daan6",
    "\u4A66": "tiu4",
    "\u4A67": "kit3",
    "\u4A68": "coeng3",
    "\u4A69": "jyun2",
    "\u4A6A": "gun2/gwun2",
    "\u4A6B": "loeng5",
    "\u4A6C": "bung2",
    "\u4A6D": "gei1",
    "\u4A6E": "luk6",
    "\u4A6F": "gik1",
    "\u4A70": "jyun5",
    "\u4A71": "syu3",
    "\u4A72": "dou1",
    "\u4A73": "sau1",
    "\u4A74": "wu4",
    "\u4A75": "wan6",
    "\u4A76": "cin2",
    "\u4A77": "bong1",
    "\u4A78": "jung4",
    "\u4A79": "ngaak6/aak6",
    "\u4A7A": "jung1",
    "\u4A7B": "baa3",
    "\u4A7C": "fung4",
    "\u4A7D": "jyu1",
    "\u4A7E": "ze3",
    "\u4A7F": "fan4",
    "\u4A80": "gun2/gwun2",
    "\u4A81": "buk6",
    "\u4A82": "gaak3",
    "\u4A83": "deon1",
    "\u4A84": "wong4",
    "\u4A85": "duk6",
    "\u4A86": "tai2",
    "\u4A87": "bok6",
    "\u4A88": "hin3",
    "\u4A89": "lip6",
    "\u4A8A": "lung4",
    "\u4A8B": "wai6",
    "\u4A8C": "zaam6",
    "\u4A8D": "laan4",
    "\u4A8E": "seoi1",
    "\u4A8F": "naap6/laap6",
    "\u4A90": "bei3",
    "\u4A91": "to4",
    "\u4A92": "zyu3",
    "\u4A93": "dip3",
    "\u4A94": "bou2",
    "\u4A95": "guk6",
    "\u4A96": "pok3",
    "\u4A97": "haa4",
    "\u4A98": "wai5",
    "\u4A99": "pok3",
    "\u4A9A": "daap3",
    "\u4A9B": "faan1",
    "\u4A9C": "cim1",
    "\u4A9D": "waak6",
    "\u4A9E": "zaap6",
    "\u4A9F": "zai1",
    "\u4AA0": "zai1",
    "\u4AA1": "zai1",
    "\u4AA2": "zai1",
    "\u4AA3": "zai1",
    "\u4AA4": "faan4",
    "\u4AA5": "haai6",
    "\u4AA6": "hung4",
    "\u4AA7": "ci4",
    "\u4AA8": "bok3",
    "\u4AA9": "jam4",
    "\u4AAA": "gaa1",
    "\u4AAB": "hang4",
    "\u4AAC": "put3",
    "\u4AAD": "jyun2",
    "\u4AAE": "cau2",
    "\u4AAF": "jing4",
    "\u4AB0": "ji1",
    "\u4AB1": "goi2",
    "\u4AB2": "ngat6/at6",
    "\u4AB3": "wan5",
    "\u4AB4": "zam2",
    "\u4AB5": "ngaa5/aa5",
    "\u4AB6": "zeoi1",
    "\u4AB7": "kau3",
    "\u4AB8": "man4",
    "\u4AB9": "pei1",
    "\u4ABA": "gap3",
    "\u4ABB": "bin6",
    "\u4ABC": "dyut3",
    "\u4ABD": "hou6",
    "\u4ABE": "can2",
    "\u4ABF": "seon3",
    "\u4AC0": "gan2",
    "\u4AC1": "bei6",
    "\u4AC2": "do2",
    "\u4AC3": "seon4",
    "\u4AC4": "caat1",
    "\u4AC5": "saam3",
    "\u4AC6": "sing4",
    "\u4AC7": "jim4",
    "\u4AC8": "zam6",
    "\u4AC9": "maau6",
    "\u4ACA": "pui4",
    "\u4ACB": "wai1",
    "\u4ACC": "pai2",
    "\u4ACD": "fu2",
    "\u4ACE": "dyut3",
    "\u4ACF": "hei1",
    "\u4AD0": "lam4",
    "\u4AD1": "ji1",
    "\u4AD2": "mun4",
    "\u4AD3": "ng4/m4",
    "\u4AD4": "kai3",
    "\u4AD5": "dit3",
    "\u4AD6": "cam2",
    "\u4AD7": "haa4",
    "\u4AD8": "hot6",
    "\u4AD9": "song2",
    "\u4ADA": "gwaa1",
    "\u4ADB": "hau4",
    "\u4ADC": "au1/ngau1",
    "\u4ADD": "fuk1",
    "\u4ADE": "hiu1",
    "\u4ADF": "wan6",
    "\u4AE0": "pei1",
    "\u4AE1": "ngaam4/aam4",
    "\u4AE2": "si1",
    "\u4AE3": "hai4",
    "\u4AE4": "mang1",
    "\u4AE5": "fui2",
    "\u4AE6": "gap3",
    "\u4AE7": "hou6",
    "\u4AE8": "zeoi6",
    "\u4AE9": "sam2",
    "\u4AEA": "song2",
    "\u4AEB": "lau4",
    "\u4AEC": "zam2",
    "\u4AED": "wui6",
    "\u4AEE": "saam4",
    "\u4AEF": "ji1",
    "\u4AF0": "leon6",
    "\u4AF1": "jyu4",
    "\u4AF2": "ham3",
    "\u4AF3": "duk6",
    "\u4AF4": "gam6",
    "\u4AF5": "min4",
    "\u4AF6": "fan4",
    "\u4AF7": "ngok6/ok6",
    "\u4AF8": "caau1",
    "\u4AF9": "hung4",
    "\u4AFA": "wang4",
    "\u4AFB": "jat6",
    "\u4AFC": "hyut3",
    "\u4AFD": "pou1",
    "\u4AFE": "bik1",
    "\u4AFF": "ciu1",
    "\u4B00": "jau5",
    "\u4B01": "ji4",
    "\u4B02": "hyut3",
    "\u4B03": "saap3",
    "\u4B04": "hyut3",
    "\u4B05": "lai6",
    "\u4B06": "leot6",
    "\u4B07": "jyun6",
    "\u4B08": "deoi6",
    "\u4B09": "waak6",
    "\u4B0A": "saap3",
    "\u4B0B": "ling4",
    "\u4B0C": "piu1",
    "\u4B0D": "fat1",
    "\u4B0E": "gwok3/gok3",
    "\u4B0F": "bau6",
    "\u4B10": "jeoi4",
    "\u4B11": "wai6",
    "\u4B12": "sau1",
    "\u4B13": "am3/ngam3",
    "\u4B14": "jyu4",
    "\u4B15": "hong1",
    "\u4B16": "waang4",
    "\u4B17": "joeng4",
    "\u4B18": "haau1",
    "\u4B19": "jiu4",
    "\u4B1A": "faan4",
    "\u4B1B": "bat1",
    "\u4B1C": "ci1",
    "\u4B1D": "waang4",
    "\u4B1E": "tou4",
    "\u4B1F": "lau4",
    "\u4B20": "fei1",
    "\u4B21": "zyu3",
    "\u4B22": "tou1",
    "\u4B23": "hat1",
    "\u4B24": "zaan3",
    "\u4B25": "ji3",
    "\u4B26": "dau3",
    "\u4B27": "jyun4",
    "\u4B28": "gau3",
    "\u4B29": "zaai1",
    "\u4B2A": "bok3",
    "\u4B2B": "tai4",
    "\u4B2C": "joeng3",
    "\u4B2D": "tou1",
    "\u4B2E": "ji4",
    "\u4B2F": "nim4/lim4",
    "\u4B30": "siu6",
    "\u4B31": "ban6",
    "\u4B32": "kau1",
    "\u4B33": "bun2/baan2",
    "\u4B34": "mut6/mut3",
    "\u4B35": "goi1",
    "\u4B36": "ngan6/an6",
    "\u4B37": "se2",
    "\u4B38": "caan1",
    "\u4B39": "zat1",
    "\u4B3A": "joeng6",
    "\u4B3B": "zin3",
    "\u4B3C": "jyun3",
    "\u4B3D": "seoi3",
    "\u4B3E": "tai4",
    "\u4B3F": "mei5",
    "\u4B40": "seon3",
    "\u4B41": "zai3",
    "\u4B42": "jap1",
    "\u4B43": "jam5",
    "\u4B44": "si6",
    "\u4B45": "wu4",
    "\u4B46": "nak6/lak6",
    "\u4B47": "jit3",
    "\u4B48": "gin1",
    "\u4B49": "seoi2",
    "\u4B4A": "jing2",
    "\u4B4B": "baau2",
    "\u4B4C": "wu4",
    "\u4B4D": "wu4",
    "\u4B4E": "jip6",
    "\u4B4F": "bin2",
    "\u4B50": "joeng6",
    "\u4B51": "lim5",
    "\u4B52": "sik1",
    "\u4B53": "ngan6/an6",
    "\u4B54": "deoi1",
    "\u4B55": "zaam2",
    "\u4B56": "zyu3",
    "\u4B57": "jing2",
    "\u4B58": "jing2",
    "\u4B59": "zam2",
    "\u4B5A": "cong4",
    "\u4B5B": "daam6",
    "\u4B5C": "liu4",
    "\u4B5D": "kui2/kwui2",
    "\u4B5E": "jik6",
    "\u4B5F": "jip6",
    "\u4B60": "gim2",
    "\u4B61": "an3/ngan3",
    "\u4B62": "ning4/ling4",
    "\u4B63": "ci4",
    "\u4B64": "hin3",
    "\u4B65": "joeng6",
    "\u4B66": "bok6",
    "\u4B67": "mei5",
    "\u4B68": "seoi3",
    "\u4B69": "mo4",
    "\u4B6A": "loeng4",
    "\u4B6B": "kai2",
    "\u4B6C": "kai2",
    "\u4B6D": "sau2",
    "\u4B6E": "fat1",
    "\u4B6F": "but6",
    "\u4B70": "bung6",
    "\u4B71": "bit6",
    "\u4B72": "ji2",
    "\u4B73": "ngai6/ai6",
    "\u4B74": "waan4",
    "\u4B75": "faan4",
    "\u4B76": "kei4",
    "\u4B77": "mou4",
    "\u4B78": "fu6",
    "\u4B79": "ngong4/ong4",
    "\u4B7A": "ngong5/ong5",
    "\u4B7B": "fan1",
    "\u4B7C": "kei4",
    "\u4B7D": "kwan4",
    "\u4B7E": "to4/do6",
    "\u4B7F": "jat6",
    "\u4B80": "but6",
    "\u4B81": "pin4",
    "\u4B82": "but6/bat6",
    "\u4B83": "keoi1",
    "\u4B84": "jyun4",
    "\u4B85": "jyut6",
    "\u4B86": "pei1",
    "\u4B87": "wat6",
    "\u4B88": "ci4",
    "\u4B89": "leoi6",
    "\u4B8A": "ji4",
    "\u4B8B": "lit6",
    "\u4B8C": "jau1",
    "\u4B8D": "niu5/liu5",
    "\u4B8E": "hei3",
    "\u4B8F": "ng4/m4",
    "\u4B90": "gwing1",
    "\u4B91": "leoi6",
    "\u4B92": "pou1",
    "\u4B93": "zoek3",
    "\u4B94": "zeoi1",
    "\u4B95": "zyut3",
    "\u4B96": "coeng1",
    "\u4B97": "ngon6/on6",
    "\u4B98": "ji4",
    "\u4B99": "wik6",
    "\u4B9A": "lang6",
    "\u4B9B": "fu6",
    "\u4B9C": "zaap6",
    "\u4B9D": "wan4",
    "\u4B9E": "ceon2",
    "\u4B9F": "sau1",
    "\u4BA0": "bik1",
    "\u4BA1": "bat6",
    "\u4BA2": "zaap6",
    "\u4BA3": "song1",
    "\u4BA4": "hok6",
    "\u4BA5": "lik6",
    "\u4BA6": "giu1",
    "\u4BA7": "hon6/hon4",
    "\u4BA8": "zoi2",
    "\u4BA9": "gwat1",
    "\u4BAA": "sing4",
    "\u4BAB": "lau4",
    "\u4BAC": "mok6",
    "\u4BAD": "mik6",
    "\u4BAE": "mak6",
    "\u4BAF": "ngou4/ou4",
    "\u4BB0": "zaak6",
    "\u4BB1": "zuk6",
    "\u4BB2": "wong4",
    "\u4BB3": "faan4",
    "\u4BB4": "dang6",
    "\u4BB5": "tung4",
    "\u4BB6": "biu1",
    "\u4BB7": "duk6",
    "\u4BB8": "ak1/ngak1",
    "\u4BB9": "wai3",
    "\u4BBA": "zai1",
    "\u4BBB": "dou2",
    "\u4BBC": "leon4",
    "\u4BBD": "biu1",
    "\u4BBE": "pung4",
    "\u4BBF": "gin2",
    "\u4BC0": "nip6/lip6",
    "\u4BC1": "leoi4",
    "\u4BC2": "san1",
    "\u4BC3": "on1/ngon1",
    "\u4BC4": "waa1",
    "\u4BC5": "nip6/lip6",
    "\u4BC6": "jik6",
    "\u4BC7": "fat1",
    "\u4BC8": "jyun4",
    "\u4BC9": "waat3",
    "\u4BCA": "kaa3",
    "\u4BCB": "bat6",
    "\u4BCC": "hou1",
    "\u4BCD": "ling4",
    "\u4BCE": "gon3",
    "\u4BCF": "kut3/kwut3",
    "\u4BD0": "haai4",
    "\u4BD1": "kwong1/kong1",
    "\u4BD2": "hang4",
    "\u4BD3": "kwai1",
    "\u4BD4": "zaak3",
    "\u4BD5": "ting1",
    "\u4BD6": "long4",
    "\u4BD7": "bei2",
    "\u4BD8": "jyun6",
    "\u4BD9": "bok3",
    "\u4BDA": "jiu5",
    "\u4BDB": "wun3",
    "\u4BDC": "tik1",
    "\u4BDD": "seoi5",
    "\u4BDE": "kwaa1",
    "\u4BDF": "deoi6",
    "\u4BE0": "ou2/ngou2",
    "\u4BE1": "gim3",
    "\u4BE2": "mo4",
    "\u4BE3": "kwai3",
    "\u4BE4": "kui2/kwui2",
    "\u4BE5": "ngam6/am6",
    "\u4BE6": "maat3",
    "\u4BE7": "king2",
    "\u4BE8": "haau1",
    "\u4BE9": "hou6",
    "\u4BEA": "haau2",
    "\u4BEB": "hou6",
    "\u4BEC": "do2",
    "\u4BED": "cim1",
    "\u4BEE": "noi4/loi4",
    "\u4BEF": "so1",
    "\u4BF0": "gaai3",
    "\u4BF1": "pei1",
    "\u4BF2": "paa1",
    "\u4BF3": "sung1",
    "\u4BF4": "coeng4",
    "\u4BF5": "ngot6/ot6",
    "\u4BF6": "maan4",
    "\u4BF7": "sung1",
    "\u4BF8": "ci3",
    "\u4BF9": "cim1",
    "\u4BFA": "kut3/kwut3",
    "\u4BFB": "gou3",
    "\u4BFC": "dik6",
    "\u4BFD": "pau4",
    "\u4BFE": "cau4",
    "\u4BFF": "zeot1",
    "\u4C00": "wo2/wo1",
    "\u4C01": "fai3",
    "\u4C02": "coi3",
    "\u4C03": "paang4",
    "\u4C04": "soi1",
    "\u4C05": "sou1",
    "\u4C06": "jau4",
    "\u4C07": "kei4",
    "\u4C08": "co4",
    "\u4C09": "pun4/baan1",
    "\u4C0A": "bok3",
    "\u4C0B": "faat3",
    "\u4C0C": "zung2",
    "\u4C0D": "jau1",
    "\u4C0E": "kwai3",
    "\u4C0F": "zit3",
    "\u4C10": "laam4",
    "\u4C11": "sou1",
    "\u4C12": "mung4",
    "\u4C13": "min4",
    "\u4C14": "pun4",
    "\u4C15": "lou4",
    "\u4C16": "zaan3",
    "\u4C17": "gau1",
    "\u4C18": "lau4",
    "\u4C19": "ngai5/ai5",
    "\u4C1A": "man4",
    "\u4C1B": "lik6",
    "\u4C1C": "lik6",
    "\u4C1D": "zang6",
    "\u4C1E": "zyu2",
    "\u4C1F": "wan4",
    "\u4C20": "san1",
    "\u4C21": "ci3",
    "\u4C22": "hang4",
    "\u4C23": "mong5",
    "\u4C24": "dung1",
    "\u4C25": "waak6",
    "\u4C26": "pai2",
    "\u4C27": "fu1",
    "\u4C28": "mei6",
    "\u4C29": "ce2",
    "\u4C2A": "mei6",
    "\u4C2B": "caau1",
    "\u4C2C": "gwat6",
    "\u4C2D": "jyu4",
    "\u4C2E": "ji6",
    "\u4C2F": "ji6",
    "\u4C30": "jyu4",
    "\u4C31": "ling4",
    "\u4C32": "aat3/ngaat3",
    "\u4C33": "ding1",
    "\u4C34": "gat1",
    "\u4C35": "zi2",
    "\u4C36": "mong1",
    "\u4C37": "pong5",
    "\u4C38": "gung1",
    "\u4C39": "caak6",
    "\u4C3A": "gaai3",
    "\u4C3B": "jyu4",
    "\u4C3C": "cam4",
    "\u4C3D": "pui3",
    "\u4C3E": "baa1/bat6",
    "\u4C3F": "to4",
    "\u4C40": "joeng1",
    "\u4C41": "kiu4",
    "\u4C42": "jau1",
    "\u4C43": "zat6",
    "\u4C44": "gaai3",
    "\u4C45": "mut6",
    "\u4C46": "jing6",
    "\u4C47": "sin5",
    "\u4C48": "ngai6/ai6",
    "\u4C49": "sin5",
    "\u4C4A": "mai5",
    "\u4C4B": "gung2",
    "\u4C4C": "ji4",
    "\u4C4D": "gang2",
    "\u4C4E": "gang2",
    "\u4C4F": "tau2",
    "\u4C50": "fu1",
    "\u4C51": "zyut6",
    "\u4C52": "jip3",
    "\u4C53": "ting4",
    "\u4C54": "tiu4",
    "\u4C55": "mau4",
    "\u4C56": "lau4",
    "\u4C57": "caan1",
    "\u4C58": "lei4",
    "\u4C59": "suk1",
    "\u4C5A": "luk6",
    "\u4C5B": "kwik1/gwik1",
    "\u4C5C": "cok3",
    "\u4C5D": "paai4",
    "\u4C5E": "noi6/loi6",
    "\u4C5F": "geoi3",
    "\u4C60": "zaan6",
    "\u4C61": "guk1",
    "\u4C62": "zang1",
    "\u4C63": "zeot1",
    "\u4C64": "haam6",
    "\u4C65": "zai3",
    "\u4C66": "zeoi1",
    "\u4C67": "gyun2",
    "\u4C68": "ci3",
    "\u4C69": "mong5",
    "\u4C6A": "biu2",
    "\u4C6B": "laat6",
    "\u4C6C": "seoi1",
    "\u4C6D": "gang2",
    "\u4C6E": "ngaak6/aak6",
    "\u4C6F": "mou4",
    "\u4C70": "zung6",
    "\u4C71": "tai4",
    "\u4C72": "jyun4",
    "\u4C73": "zin1",
    "\u4C74": "gang2",
    "\u4C75": "jung1",
    "\u4C76": "long4",
    "\u4C77": "jyu4",
    "\u4C78": "sau1",
    "\u4C79": "zaa2",
    "\u4C7A": "haai4",
    "\u4C7B": "waat6",
    "\u4C7C": "zin2",
    "\u4C7D": "cong1",
    "\u4C7E": "lau4",
    "\u4C7F": "caam3",
    "\u4C80": "zi3",
    "\u4C81": "wai3",
    "\u4C82": "syun4",
    "\u4C83": "zou2",
    "\u4C84": "man5",
    "\u4C85": "kwai1",
    "\u4C86": "jyu4",
    "\u4C87": "cuk1",
    "\u4C88": "maa4",
    "\u4C89": "si1",
    "\u4C8A": "do6",
    "\u4C8B": "sam4",
    "\u4C8C": "fun2",
    "\u4C8D": "tang4",
    "\u4C8E": "neoi5/leoi5",
    "\u4C8F": "lou4",
    "\u4C90": "lou5",
    "\u4C91": "ji4",
    "\u4C92": "haai5",
    "\u4C93": "jim2",
    "\u4C94": "king4",
    "\u4C95": "pou1",
    "\u4C96": "cau4",
    "\u4C97": "haam4",
    "\u4C98": "gun2/gwun2",
    "\u4C99": "zit3",
    "\u4C9A": "laai6",
    "\u4C9B": "mung5",
    "\u4C9C": "jip6",
    "\u4C9D": "cong1",
    "\u4C9E": "lap6",
    "\u4C9F": "jan3",
    "\u4CA0": "ceon1",
    "\u4CA1": "cau1",
    "\u4CA2": "tang4",
    "\u4CA3": "jyu4",
    "\u4CA4": "zau2",
    "\u4CA5": "gau1",
    "\u4CA6": "daai6",
    "\u4CA7": "dou6",
    "\u4CA8": "hung4",
    "\u4CA9": "si1",
    "\u4CAA": "ji6",
    "\u4CAB": "gau1",
    "\u4CAC": "kei4",
    "\u4CAD": "ci1",
    "\u4CAE": "jyun4",
    "\u4CAF": "kap6",
    "\u4CB0": "wan6",
    "\u4CB1": "fong2",
    "\u4CB2": "gung1",
    "\u4CB3": "hong4",
    "\u4CB4": "zam6",
    "\u4CB5": "zoek3",
    "\u4CB6": "jyun4",
    "\u4CB7": "niu5/liu5",
    "\u4CB8": "gaai3",
    "\u4CB9": "pei4",
    "\u4CBA": "gam3",
    "\u4CBB": "jyun4",
    "\u4CBC": "sang1",
    "\u4CBD": "sek6",
    "\u4CBE": "haau2",
    "\u4CBF": "ci4",
    "\u4CC0": "dit6",
    "\u4CC1": "bat6",
    "\u4CC2": "diu1",
    "\u4CC3": "jyun2",
    "\u4CC4": "ci1",
    "\u4CC5": "zi2",
    "\u4CC6": "baak6",
    "\u4CC7": "mou5",
    "\u4CC8": "bou2",
    "\u4CC9": "dung1",
    "\u4CCA": "bat6",
    "\u4CCB": "tung4",
    "\u4CCC": "gyun1",
    "\u4CCD": "gung6/gung1",
    "\u4CCE": "kau5",
    "\u4CCF": "gwai3/kyut3",
    "\u4CD0": "ci3",
    "\u4CD1": "jau5",
    "\u4CD2": "jyun1/jyun4",
    "\u4CD3": "lou5",
    "\u4CD4": "guk1",
    "\u4CD5": "fau4",
    "\u4CD6": "nip6/lip6",
    "\u4CD7": "ngo4/o4",
    "\u4CD8": "ngo4/o4",
    "\u4CD9": "hing2",
    "\u4CDA": "hon2/hot3",
    "\u4CDB": "aan3/ngaan3",
    "\u4CDC": "tou4",
    "\u4CDD": "pau2",
    "\u4CDE": "bung2",
    "\u4CDF": "ming4",
    "\u4CE0": "seoi6",
    "\u4CE1": "aan3/ngaan3",
    "\u4CE2": "kei4",
    "\u4CE3": "jyun1",
    "\u4CE4": "bit3",
    "\u4CE5": "ling4",
    "\u4CE6": "syun1",
    "\u4CE7": "hau1",
    "\u4CE8": "wong4",
    "\u4CE9": "jiu1",
    "\u4CEA": "tyun4",
    "\u4CEB": "kwai4",
    "\u4CEC": "jik6",
    "\u4CED": "zik3",
    "\u4CEE": "mak6",
    "\u4CEF": "cung4",
    "\u4CF0": "bou2",
    "\u4CF1": "mou6",
    "\u4CF2": "zan3",
    "\u4CF3": "seot1",
    "\u4CF4": "taap3",
    "\u4CF5": "cik1",
    "\u4CF6": "kai1",
    "\u4CF7": "cung4",
    "\u4CF8": "maa4",
    "\u4CF9": "kau3",
    "\u4CFA": "am1/ngam1/aan3/ngaan3",
    "\u4CFB": "caam4",
    "\u4CFC": "au1/ngau1",
    "\u4CFD": "hok6",
    "\u4CFE": "dang1",
    "\u4CFF": "jin4",
    "\u4D00": "tung4",
    "\u4D01": "jyu6",
    "\u4D02": "zoeng6",
    "\u4D03": "naau4/laau4",
    "\u4D04": "seon3",
    "\u4D05": "fan4",
    "\u4D06": "buk6",
    "\u4D07": "ling4",
    "\u4D08": "ou2/ngou2/ou3/ngou3",
    "\u4D09": "syun4/waan4",
    "\u4D0A": "ji4",
    "\u4D0B": "waan4",
    "\u4D0C": "mung4",
    "\u4D0D": "ang1/ngang1",
    "\u4D0E": "leoi5",
    "\u4D0F": "jin3",
    "\u4D10": "bou2",
    "\u4D11": "dip6",
    "\u4D12": "ling4",
    "\u4D13": "si1",
    "\u4D14": "gaau1",
    "\u4D15": "lit6",
    "\u4D16": "zing1",
    "\u4D17": "gwik1",
    "\u4D18": "tai1",
    "\u4D19": "pik1",
    "\u4D1A": "gong2",
    "\u4D1B": "siu1",
    "\u4D1C": "waai1",
    "\u4D1D": "ceoi3",
    "\u4D1E": "dik6",
    "\u4D1F": "wun4",
    "\u4D20": "ou2/ngou2/jiu2",
    "\u4D21": "lai6",
    "\u4D22": "mei4",
    "\u4D23": "fu1",
    "\u4D24": "sang1",
    "\u4D25": "gaa1",
    "\u4D26": "ngan4/an4",
    "\u4D27": "wai1",
    "\u4D28": "jyun4",
    "\u4D29": "piu4",
    "\u4D2A": "luk6",
    "\u4D2B": "ling4",
    "\u4D2C": "jik6",
    "\u4D2D": "coi4",
    "\u4D2E": "saan3",
    "\u4D2F": "fat1",
    "\u4D30": "suk6",
    "\u4D31": "to1",
    "\u4D32": "mut6",
    "\u4D33": "waat6",
    "\u4D34": "tip3",
    "\u4D35": "bing2",
    "\u4D36": "pung4",
    "\u4D37": "wan4",
    "\u4D38": "fu1",
    "\u4D39": "gwo2/go2",
    "\u4D3A": "bau6",
    "\u4D3B": "lei4",
    "\u4D3C": "caan3",
    "\u4D3D": "pei4",
    "\u4D3E": "co4",
    "\u4D3F": "mung4",
    "\u4D40": "so2",
    "\u4D41": "coeng3",
    "\u4D42": "zik6",
    "\u4D43": "kwong3/kong3",
    "\u4D44": "fung1",
    "\u4D45": "ngaau4/aau4",
    "\u4D46": "mung4",
    "\u4D47": "sin3",
    "\u4D48": "huk1",
    "\u4D49": "tau4",
    "\u4D4A": "tan1",
    "\u4D4B": "wai5",
    "\u4D4C": "him1",
    "\u4D4D": "tan1",
    "\u4D4E": "teon1",
    "\u4D4F": "lou6",
    "\u4D50": "cin2",
    "\u4D51": "nik1/lik1",
    "\u4D52": "nik1/lik1",
    "\u4D53": "syu2",
    "\u4D54": "dung2",
    "\u4D55": "geoi3",
    "\u4D56": "hin3",
    "\u4D57": "baak6",
    "\u4D58": "saai3",
    "\u4D59": "zaa1",
    "\u4D5A": "tou2",
    "\u4D5B": "hin3",
    "\u4D5C": "nung5/lung5",
    "\u4D5D": "ji3",
    "\u4D5E": "king4",
    "\u4D5F": "gon2",
    "\u4D60": "dik1",
    "\u4D61": "jin6",
    "\u4D62": "mui6",
    "\u4D63": "daat3",
    "\u4D64": "gin2",
    "\u4D65": "wat1",
    "\u4D66": "ze6",
    "\u4D67": "zoi3",
    "\u4D68": "mong4",
    "\u4D69": "lai4",
    "\u4D6A": "gwan3",
    "\u4D6B": "fan1",
    "\u4D6C": "daap6",
    "\u4D6D": "ze3",
    "\u4D6E": "joeng4",
    "\u4D6F": "teon2",
    "\u4D70": "soeng1",
    "\u4D71": "hik1",
    "\u4D72": "ciu1",
    "\u4D73": "wai3",
    "\u4D74": "wan6",
    "\u4D75": "caat3",
    "\u4D76": "keoi4",
    "\u4D77": "waa1",
    "\u4D78": "cuk1",
    "\u4D79": "zi1",
    "\u4D7A": "ting5",
    "\u4D7B": "seoi6",
    "\u4D7C": "soeng1",
    "\u4D7D": "caap3",
    "\u4D7E": "fu4",
    "\u4D7F": "tip3",
    "\u4D80": "taap3/daap6",
    "\u4D81": "taap3",
    "\u4D82": "zoek3",
    "\u4D83": "ham4",
    "\u4D84": "ping4",
    "\u4D85": "hok6",
    "\u4D86": "zeoi1",
    "\u4D87": "zau6",
    "\u4D88": "bok3",
    "\u4D89": "lau4",
    "\u4D8A": "nuk6/luk6",
    "\u4D8B": "hap1",
    "\u4D8C": "paau3",
    "\u4D8D": "tai3",
    "\u4D8E": "hap1",
    "\u4D8F": "ji4",
    "\u4D90": "wui3",
    "\u4D91": "tai3",
    "\u4D92": "cai4",
    "\u4D93": "zai3",
    "\u4D94": "ci4",
    "\u4D95": "baa6",
    "\u4D96": "gam6",
    "\u4D97": "kaa1/haap3",
    "\u4D98": "laap6",
    "\u4D99": "geoi6",
    "\u4D9A": "geoi2",
    "\u4D9B": "laat6",
    "\u4D9C": "guk1",
    "\u4D9D": "haap6",
    "\u4D9E": "kei4",
    "\u4D9F": "haam6",
    "\u4DA0": "gaam1",
    "\u4DA1": "zit6",
    "\u4DA2": "gaam1",
    "\u4DA3": "ngoi4/oi4",
    "\u4DA4": "hat6",
    "\u4DA5": "zaa1/zeoi2",
    "\u4DA6": "caak3",
    "\u4DA7": "ngaau5/aau5",
    "\u4DA8": "zaam1",
    "\u4DA9": "zai6",
    "\u4DAA": "caat3",
    "\u4DAB": "jim6",
    "\u4DAC": "gin1",
    "\u4DAD": "wong1",
    "\u4DAE": "jim5/jim2",
    "\u4DAF": "kwai1",
    "\u4DB0": "ziu1",
    "\u4DB1": "tung4",
    "\u4DB2": "jim4",
    "\u4DB3": "joek6",
    "\u4DB4": "ceoi1",
    "\u4DB5": "ci4",
    "\u4E00": "jat1/waang4",
    "\u4E01": "ding1/zaang1/zang1",
    "\u4E02": "haau2",
    "\u4E03": "cat1",
    "\u4E04": "soeng6",
    "\u4E05": "haa6",
    "\u4E06": "daan1/jat1.waang4.jat1.pit3",
    "\u4E07": "maan6/mak6",
    "\u4E08": "zoeng6/zoeng2",
    "\u4E09": "saam1/saam3",
    "\u4E0A": "soeng6/soeng5",
    "\u4E0B": "haa6/haa1/haa2/haa5",
    "\u4E0C": "gei1/kei4",
    "\u4E0D": "bat1/fau2/pei1",
    "\u4E0E": "jyu5/jyu4/jyu6",
    "\u4E0F": "min5",
    "\u4E10": "koi3",
    "\u4E11": "cau2",
    "\u4E12": "ng5/m5",
    "\u4E13": "zyun1",
    "\u4E14": "ce2/zeoi1/cou4",
    "\u4E15": "pei1",
    "\u4E16": "sai3/sai2",
    "\u4E17": "sai3",
    "\u4E18": "jau1",
    "\u4E19": "bing2",
    "\u4E1A": "jip6",
    "\u4E1B": "cung4",
    "\u4E1C": "dung1",
    "\u4E1D": "si1",
    "\u4E1E": "sing4",
    "\u4E1F": "diu1",
    "\u4E20": "kei3",
    "\u4E21": "loeng2",
    "\u4E22": "diu1",
    "\u4E23": "jau5",
    "\u4E24": "loeng5/loeng2/loeng6",
    "\u4E25": "jim4",
    "\u4E26": "bing6/bing3",
    "\u4E27": "song1/song3",
    "\u4E28": "gwan2/syu6",
    "\u4E29": "gau2",
    "\u4E2A": "go3/go2",
    "\u4E2B": "aa1/ngaa1",
    "\u4E2C": "baan6/gaan2.baan6.bin1",
    "\u4E2D": "zung1/zung3",
    "\u4E2E": "gik1",
    "\u4E2F": "gaai3",
    "\u4E30": "fung1",
    "\u4E31": "gwaan3/kong3/kwong3",
    "\u4E32": "cyun3/cyun2/gwaan3",
    "\u4E33": "caan2",
    "\u4E34": "lam4/lam1",
    "\u4E35": "zok6",
    "\u4E36": "zyu2/dim2",
    "\u4E37": "baat3/baat3.zi6.tau4",
    "\u4E38": "jyun4/jyun2",
    "\u4E39": "daan1",
    "\u4E3A": "wai4/wai2/wai6",
    "\u4E3B": "zyu2",
    "\u4E3C": "zeng2",
    "\u4E3D": "lai6/lai4/lei4",
    "\u4E3E": "geoi2",
    "\u4E3F": "pit3",
    "\u4E40": "fat1",
    "\u4E41": "ji4",
    "\u4E42": "ngaai6/aai6",
    "\u4E43": "naai5/laai5/oi2/ngoi2",
    "\u4E44": "ngau1.mei5.gaau1.caa1",
    "\u4E45": "gau2",
    "\u4E46": "gau2",
    "\u4E47": "tok3/zaak6",
    "\u4E48": "maa1/jiu1/mo1",
    "\u4E49": "ji6",
    "\u4E4A": "fu4.zi6.tau4",
    "\u4E4B": "zi1",
    "\u4E4C": "wu1",
    "\u4E4D": "zaa3/zaa6/zok3",
    "\u4E4E": "fu4/fu1/wu4",
    "\u4E4F": "fat6",
    "\u4E50": "lok6/ngok6/ok6/ngaau6/aau6/ngaau4/aau4",
    "\u4E51": "jam4",
    "\u4E52": "bing1/ping1",
    "\u4E53": "bam1/pong1",
    "\u4E54": "kiu4",
    "\u4E55": "fu2",
    "\u4E56": "gwaai1",
    "\u4E57": "sing4/sing6",
    "\u4E58": "sing4/sing6",
    "\u4E59": "jyut3/jyut6",
    "\u4E5A": "jyut3/jan2",
    "\u4E5B": "waang4.ngau1",
    "\u4E5C": "mat1/me1/me5/ne6/le6/me6",
    "\u4E5D": "gau2",
    "\u4E5E": "hat1/hei3",
    "\u4E5F": "jaa5",
    "\u4E60": "zaap6",
    "\u4E61": "hoeng1/hoeng3",
    "\u4E62": "goi3",
    "\u4E63": "gau2",
    "\u4E64": "haa6",
    "\u4E65": "fu4",
    "\u4E66": "syu1",
    "\u4E67": "dau2",
    "\u4E68": "ci2",
    "\u4E69": "gei1",
    "\u4E6A": "kek6",
    "\u4E6B": "gaa1",
    "\u4E6C": "geoi6",
    "\u4E6D": "sek6",
    "\u4E6E": "maau5",
    "\u4E6F": "fu4",
    "\u4E70": "maai5",
    "\u4E71": "lyun6/lyun2",
    "\u4E72": "ci3",
    "\u4E73": "jyu5",
    "\u4E74": "zyut6",
    "\u4E75": "jim5",
    "\u4E76": "fu2",
    "\u4E77": "saa1",
    "\u4E78": "naa2/laa2",
    "\u4E79": "kin4/gon1",
    "\u4E7A": "so2",
    "\u4E7B": "jyu1",
    "\u4E7C": "zyu3",
    "\u4E7D": "ze2",
    "\u4E7E": "kin4/gon1",
    "\u4E7F": "zi6",
    "\u4E80": "gwai1",
    "\u4E81": "gon1",
    "\u4E82": "lyun6/lyun2",
    "\u4E83": "leon5",
    "\u4E84": "ji3",
    "\u4E85": "kyut3/ngau1",
    "\u4E86": "liu5/liu2",
    "\u4E87": "ding1",
    "\u4E88": "jyu4/jyu5",
    "\u4E89": "zang1/zaang1/zang3/zaang3/caang1",
    "\u4E8A": "si6",
    "\u4E8B": "si6/si2",
    "\u4E8C": "ji6/ji2",
    "\u4E8D": "cuk1",
    "\u4E8E": "jyu1/jyu4",
    "\u4E8F": "kwai1",
    "\u4E90": "jyu1",
    "\u4E91": "wan4/wan2",
    "\u4E92": "wu6",
    "\u4E93": "kei4",
    "\u4E94": "ng5/m5",
    "\u4E95": "zeng2/zing2",
    "\u4E96": "sei3",
    "\u4E97": "seoi3",
    "\u4E98": "gang2",
    "\u4E99": "gang2",
    "\u4E9A": "aa3/ngaa3/aa1/ngaa1",
    "\u4E9B": "se1/so3/so1/saa1",
    "\u4E9C": "aa3/ngaa3",
    "\u4E9D": "cai4/zaai1",
    "\u4E9E": "aa3/ngaa3/aa1/ngaa1",
    "\u4E9F": "gik1/kei3",
    "\u4EA0": "tau4/jat1.dim2.jat1.waang4",
    "\u4EA1": "mong4/mou4",
    "\u4EA2": "kong3/gong1",
    "\u4EA3": "daai6",
    "\u4EA4": "gaau1",
    "\u4EA5": "hoi6",
    "\u4EA6": "jik6",
    "\u4EA7": "caan2",
    "\u4EA8": "hang1/paang1",
    "\u4EA9": "mau5",
    "\u4EAA": "bin3",
    "\u4EAB": "hoeng2",
    "\u4EAC": "ging1",
    "\u4EAD": "ting4/ting2",
    "\u4EAE": "loeng6",
    "\u4EAF": "hang1/paang1/hoeng2",
    "\u4EB0": "ging1",
    "\u4EB1": "je6",
    "\u4EB2": "can1/can3",
    "\u4EB3": "bok3",
    "\u4EB4": "jau6",
    "\u4EB5": "sit3",
    "\u4EB6": "taan2/daan6",
    "\u4EB7": "lim4",
    "\u4EB8": "do2",
    "\u4EB9": "mei5/mun4",
    "\u4EBA": "jan4/jan1/jan2",
    "\u4EBB": "jan4/kei5.jan4.bin1",
    "\u4EBC": "zaap6/zap6",
    "\u4EBD": "zaap6",
    "\u4EBE": "mou4/mong4",
    "\u4EBF": "jik1",
    "\u4EC0": "sap6/sam6/zaap6",
    "\u4EC1": "jan4",
    "\u4EC2": "lak6/lik6",
    "\u4EC3": "ding1",
    "\u4EC4": "zak1",
    "\u4EC5": "gan2/gan6",
    "\u4EC6": "fu6/puk6/puk1/buk6",
    "\u4EC7": "sau4/cau4/kau4",
    "\u4EC8": "baat3",
    "\u4EC9": "zoeng2",
    "\u4ECA": "gam1",
    "\u4ECB": "gaai3",
    "\u4ECC": "bing1",
    "\u4ECD": "jing4",
    "\u4ECE": "cung4/sung1/zung1/zung3",
    "\u4ECF": "fat6",
    "\u4ED0": "tou1",
    "\u4ED1": "leon4/leon2",
    "\u4ED2": "bing1",
    "\u4ED3": "cong1",
    "\u4ED4": "zai2/zai4/zi2/zi1",
    "\u4ED5": "si6",
    "\u4ED6": "taa1",
    "\u4ED7": "zoeng6/zoeng2/zoeng3",
    "\u4ED8": "fu6",
    "\u4ED9": "sin1",
    "\u4EDA": "hin1",
    "\u4EDB": "tok3",
    "\u4EDC": "hung4",
    "\u4EDD": "tung4",
    "\u4EDE": "jan6",
    "\u4EDF": "cin1",
    "\u4EE0": "gon2",
    "\u4EE1": "ngat6/at6/go1/gat1",
    "\u4EE2": "bok6",
    "\u4EE3": "doi6",
    "\u4EE4": "ling6/ling2/ling4/ling1/lim1",
    "\u4EE5": "ji5",
    "\u4EE6": "caau3",
    "\u4EE7": "coeng4",
    "\u4EE8": "saam1/saa1",
    "\u4EE9": "coeng4",
    "\u4EEA": "ji4",
    "\u4EEB": "muk6/mo1",
    "\u4EEC": "mun4",
    "\u4EED": "jan6",
    "\u4EEE": "faan2",
    "\u4EEF": "caau3",
    "\u4EF0": "joeng5/ngong5/ong5",
    "\u4EF1": "kim4",
    "\u4EF2": "zung6",
    "\u4EF3": "pei2/pei4",
    "\u4EF4": "wut6",
    "\u4EF5": "ng5/m5",
    "\u4EF6": "gin6/gin2",
    "\u4EF7": "gaai3/gaa3",
    "\u4EF8": "jiu2",
    "\u4EF9": "fung1",
    "\u4EFA": "cong1",
    "\u4EFB": "jam6/jam4",
    "\u4EFC": "wong4",
    "\u4EFD": "fan6/fan2/ban1",
    "\u4EFE": "dai1",
    "\u4EFF": "fong2",
    "\u4F00": "zung1",
    "\u4F01": "kei5/kei2",
    "\u4F02": "pui3",
    "\u4F03": "jyu4",
    "\u4F04": "diu3",
    "\u4F05": "dan6",
    "\u4F06": "mat6",
    "\u4F07": "jik6",
    "\u4F08": "sam2",
    "\u4F09": "kong3",
    "\u4F0A": "ji1",
    "\u4F0B": "kap1",
    "\u4F0C": "aai3/ngaai3",
    "\u4F0D": "ng5/m5",
    "\u4F0E": "gei6/kei4",
    "\u4F0F": "fuk6/buk6",
    "\u4F10": "fat6",
    "\u4F11": "jau1",
    "\u4F12": "gan3",
    "\u4F13": "pei1",
    "\u4F14": "dam2",
    "\u4F15": "fu1",
    "\u4F16": "tong2",
    "\u4F17": "zung3",
    "\u4F18": "jau1",
    "\u4F19": "fo2",
    "\u4F1A": "wui6/wui2/wui5/kui2/kwui2",
    "\u4F1B": "jyu2",
    "\u4F1C": "ceoi3",
    "\u4F1D": "cyun4",
    "\u4F1E": "saan3",
    "\u4F1F": "wai5",
    "\u4F20": "cyun4/zyun6/zyun2",
    "\u4F21": "ce1",
    "\u4F22": "ngaa4/aa4",
    "\u4F23": "jin5",
    "\u4F24": "soeng1",
    "\u4F25": "coeng1/caang1/caang4",
    "\u4F26": "leon4",
    "\u4F27": "cong1",
    "\u4F28": "seon1",
    "\u4F29": "seon3",
    "\u4F2A": "ngai6/ai6",
    "\u4F2B": "cyu5",
    "\u4F2C": "cek3",
    "\u4F2D": "jin4",
    "\u4F2E": "nou5/lou5",
    "\u4F2F": "baak3/baa3/mak6",
    "\u4F30": "gu2/gwu2/gu3/gwu3",
    "\u4F31": "nei5/lei5",
    "\u4F32": "nei4/lei4",
    "\u4F33": "sit3",
    "\u4F34": "bun6/pun5/pun2/pun3",
    "\u4F35": "gwik1",
    "\u4F36": "ling4/ling1",
    "\u4F37": "zau6",
    "\u4F38": "san1",
    "\u4F39": "ceoi1",
    "\u4F3A": "zi6/si6",
    "\u4F3B": "ping1",
    "\u4F3C": "ci5",
    "\u4F3D": "gaa1/ke4",
    "\u4F3E": "pei1",
    "\u4F3F": "ji6",
    "\u4F40": "ci5",
    "\u4F41": "ji5",
    "\u4F42": "zing1",
    "\u4F43": "din6/tin4",
    "\u4F44": "ham4",
    "\u4F45": "mui6/maai6",
    "\u4F46": "daan6",
    "\u4F47": "ning4/ling4/cyu5",
    "\u4F48": "bou3",
    "\u4F49": "keoi1",
    "\u4F4A": "bei2",
    "\u4F4B": "siu6",
    "\u4F4C": "ci2",
    "\u4F4D": "wai6/wai2",
    "\u4F4E": "dai1",
    "\u4F4F": "zyu6/zyu2",
    "\u4F50": "zo3",
    "\u4F51": "jau6",
    "\u4F52": "joeng5/ngong5/ong5",
    "\u4F53": "tai2/ban6",
    "\u4F54": "zim3",
    "\u4F55": "ho4/ho2/ho6",
    "\u4F56": "bit1",
    "\u4F57": "to4/to1",
    "\u4F58": "se4",
    "\u4F59": "jyu4/ceoi4",
    "\u4F5A": "jat6/dit6",
    "\u4F5B": "fat6/fat1/bat6",
    "\u4F5C": "zok3/zok2",
    "\u4F5D": "keoi1/gau1/kau3",
    "\u4F5E": "ning6/ling6",
    "\u4F5F": "tung4",
    "\u4F60": "nei5/lei5",
    "\u4F61": "hin1",
    "\u4F62": "keoi5/heoi5",
    "\u4F63": "jung2/jung4",
    "\u4F64": "ngaa5/aa5",
    "\u4F65": "cim1",
    "\u4F66": "jau6",
    "\u4F67": "kaa1",
    "\u4F68": "baau1",
    "\u4F69": "pui3",
    "\u4F6A": "wui4",
    "\u4F6B": "hok6",
    "\u4F6C": "lou2/lou5",
    "\u4F6D": "gong3",
    "\u4F6E": "gap3",
    "\u4F6F": "joeng4",
    "\u4F70": "baak3/mak6",
    "\u4F71": "faat3",
    "\u4F72": "ming5",
    "\u4F73": "gaai1",
    "\u4F74": "ji6/ji5/noi6/loi6",
    "\u4F75": "bing3/ping3/bing6",
    "\u4F76": "gat1/git3",
    "\u4F77": "han2",
    "\u4F78": "kut3/kwut3/wut6",
    "\u4F79": "gwai2",
    "\u4F7A": "cyun4",
    "\u4F7B": "tiu1/tiu3/tiu4",
    "\u4F7C": "gaau2/gaau1",
    "\u4F7D": "ci3",
    "\u4F7E": "jat6",
    "\u4F7F": "si2/sai2/si3",
    "\u4F80": "jing4",
    "\u4F81": "san1",
    "\u4F82": "tok3",
    "\u4F83": "hon2",
    "\u4F84": "zat6",
    "\u4F85": "goi1",
    "\u4F86": "loi4/loi2/loi6/lai4/lai2",
    "\u4F87": "ji4",
    "\u4F88": "ci2",
    "\u4F89": "kwaa2/kwaa1",
    "\u4F8A": "gwong1/gong1",
    "\u4F8B": "lai6",
    "\u4F8C": "jam1",
    "\u4F8D": "si6/si2",
    "\u4F8E": "mei5",
    "\u4F8F": "zyu1",
    "\u4F90": "gwik1",
    "\u4F91": "jau6",
    "\u4F92": "on1/ngon1",
    "\u4F93": "leot6",
    "\u4F94": "mau4",
    "\u4F95": "ji4",
    "\u4F96": "leon4/leon2",
    "\u4F97": "tung4/tung2/dung6",
    "\u4F98": "caa3",
    "\u4F99": "cik1",
    "\u4F9A": "seon1/seon6/ceon4",
    "\u4F9B": "gung1/gung3",
    "\u4F9C": "zau1",
    "\u4F9D": "ji1/ji2",
    "\u4F9E": "jyu4",
    "\u4F9F": "cyun4",
    "\u4FA0": "hap6/haap6",
    "\u4FA1": "ci5",
    "\u4FA2": "daai3",
    "\u4FA3": "leoi5",
    "\u4FA4": "haau2",
    "\u4FA5": "hiu1/jiu4",
    "\u4FA6": "zing1",
    "\u4FA7": "zak1",
    "\u4FA8": "kiu4",
    "\u4FA9": "kui2/kwui2/kui3/kwui3",
    "\u4FAA": "caai4",
    "\u4FAB": "ning6/ling6",
    "\u4FAC": "nung4/lung4",
    "\u4FAD": "zeon2",
    "\u4FAE": "mou5",
    "\u4FAF": "hau4/hau6",
    "\u4FB0": "kwan3",
    "\u4FB1": "cing2",
    "\u4FB2": "zan3",
    "\u4FB3": "zo6/co3",
    "\u4FB4": "cau2",
    "\u4FB5": "cam1",
    "\u4FB6": "leoi5",
    "\u4FB7": "guk6",
    "\u4FB8": "syu6",
    "\u4FB9": "ting5",
    "\u4FBA": "sam6",
    "\u4FBB": "teoi3/tyut3",
    "\u4FBC": "but6",
    "\u4FBD": "naam4/laam4",
    "\u4FBE": "haau1",
    "\u4FBF": "bin6/bin2/pin4",
    "\u4FC0": "teoi2",
    "\u4FC1": "jyu5",
    "\u4FC2": "hai6/hai2",
    "\u4FC3": "cuk1",
    "\u4FC4": "ngo4/o4",
    "\u4FC5": "kau4",
    "\u4FC6": "ceoi4/syu1",
    "\u4FC7": "gwaang6/hong1",
    "\u4FC8": "guk1",
    "\u4FC9": "ng6/m6",
    "\u4FCA": "zeon3",
    "\u4FCB": "jap1",
    "\u4FCC": "fu6",
    "\u4FCD": "loeng4",
    "\u4FCE": "zo2",
    "\u4FCF": "ciu3",
    "\u4FD0": "lei6",
    "\u4FD1": "jung2",
    "\u4FD2": "wan6",
    "\u4FD3": "ging3",
    "\u4FD4": "jin5",
    "\u4FD5": "saam3",
    "\u4FD6": "pui2",
    "\u4FD7": "zuk6",
    "\u4FD8": "fu1",
    "\u4FD9": "hei1",
    "\u4FDA": "lei5",
    "\u4FDB": "min5/fu2",
    "\u4FDC": "ping1",
    "\u4FDD": "bou2",
    "\u4FDE": "jyu4/jyu6/syu3",
    "\u4FDF": "zi6/kei4",
    "\u4FE0": "hap6/haap6",
    "\u4FE1": "seon3/seon2/san1",
    "\u4FE2": "sau1",
    "\u4FE3": "jyu5",
    "\u4FE4": "dai6",
    "\u4FE5": "ce1",
    "\u4FE6": "cau4",
    "\u4FE7": "zi3",
    "\u4FE8": "jim5",
    "\u4FE9": "loeng5",
    "\u4FEA": "lai6",
    "\u4FEB": "loi4/loi6",
    "\u4FEC": "si1",
    "\u4FED": "gim6",
    "\u4FEE": "sau1",
    "\u4FEF": "fu2",
    "\u4FF0": "wo6",
    "\u4FF1": "keoi1/geoi1",
    "\u4FF2": "haau6",
    "\u4FF3": "paai4/pui4",
    "\u4FF4": "cin5",
    "\u4FF5": "biu2",
    "\u4FF6": "cuk1/tik1",
    "\u4FF7": "fai3",
    "\u4FF8": "fung6/fung2",
    "\u4FF9": "aa3/ngaa3",
    "\u4FFA": "aan2/ngaan2/jim3",
    "\u4FFB": "bei6",
    "\u4FFC": "juk6",
    "\u4FFD": "jan1",
    "\u4FFE": "bei2",
    "\u4FFF": "fu2",
    "\u5000": "coeng1/caang1/caang4",
    "\u5001": "zi1",
    "\u5002": "bing3/ping3/bing6",
    "\u5003": "gau6/zaa1",
    "\u5004": "haau4",
    "\u5005": "ceoi3/zeot1/cyut3",
    "\u5006": "loeng5",
    "\u5007": "jyun2",
    "\u5008": "loi4/loi6",
    "\u5009": "cong1",
    "\u500A": "zung3",
    "\u500B": "go3/go2",
    "\u500C": "gun1/gwun1",
    "\u500D": "pui5/bui3",
    "\u500E": "tin2",
    "\u500F": "suk1",
    "\u5010": "suk1",
    "\u5011": "mun4",
    "\u5012": "dou2/dou3",
    "\u5013": "taam4",
    "\u5014": "gwat6",
    "\u5015": "seoi4",
    "\u5016": "hang6",
    "\u5017": "pang4",
    "\u5018": "tong2/soeng4",
    "\u5019": "hau6/hau1/hau2",
    "\u501A": "ji2/kei1",
    "\u501B": "hei1",
    "\u501C": "tik1/zau1",
    "\u501D": "gon3",
    "\u501E": "ging6/loeng6",
    "\u501F": "ze3/ze2",
    "\u5020": "seoi1",
    "\u5021": "coeng1/coeng3",
    "\u5022": "zit3/zit6",
    "\u5023": "fong2",
    "\u5024": "zik6",
    "\u5025": "hung1/hung2",
    "\u5026": "gyun6",
    "\u5027": "zung1",
    "\u5028": "geoi3",
    "\u5029": "sin6",
    "\u502A": "ngai4/ai4/ngai6/ai6",
    "\u502B": "leon4",
    "\u502C": "coek3",
    "\u502D": "wai1/wo1/wo2",
    "\u502E": "lo2",
    "\u502F": "sung1",
    "\u5030": "ling4",
    "\u5031": "wan6",
    "\u5032": "dung1",
    "\u5033": "zi3",
    "\u5034": "ban6/ban3",
    "\u5035": "mou5",
    "\u5036": "keoi1",
    "\u5037": "noi6/loi6/naai5/laai5",
    "\u5038": "coi2",
    "\u5039": "gim6",
    "\u503A": "zaai3",
    "\u503B": "je4",
    "\u503C": "zik6",
    "\u503D": "saa2",
    "\u503E": "king1",
    "\u503F": "ning6/ling6",
    "\u5040": "jing1",
    "\u5041": "cing1",
    "\u5042": "cin4",
    "\u5043": "jin2/jim2",
    "\u5044": "jyun5",
    "\u5045": "zung3",
    "\u5046": "ceon2",
    "\u5047": "gaa2/gaa1/gaa3/haa4",
    "\u5048": "git6/gai6/gai2",
    "\u5049": "wai5",
    "\u504A": "jyu2/geoi2/jyu5",
    "\u504B": "bing2",
    "\u504C": "je6/joek6",
    "\u504D": "tai4",
    "\u504E": "wui1",
    "\u504F": "pin1",
    "\u5050": "ngaan6/aan6",
    "\u5051": "fung1",
    "\u5052": "tong2",
    "\u5053": "ak1/ngak1/aak1/ngaak1",
    "\u5054": "ngok6/ok6",
    "\u5055": "gaai1/haai4",
    "\u5056": "ce2",
    "\u5057": "saang2",
    "\u5058": "hon2",
    "\u5059": "dai3",
    "\u505A": "zou6",
    "\u505B": "zaap3",
    "\u505C": "ting4/ting2",
    "\u505D": "bui3",
    "\u505E": "jip6",
    "\u505F": "wong4",
    "\u5060": "jiu2/jiu5",
    "\u5061": "zaam6",
    "\u5062": "cau1/cau2/ciu2",
    "\u5063": "jim1",
    "\u5064": "jau4",
    "\u5065": "gin6",
    "\u5066": "seoi2",
    "\u5067": "zaa3",
    "\u5068": "ci1/zi1",
    "\u5069": "fu6",
    "\u506A": "bik1",
    "\u506B": "zi6",
    "\u506C": "zung2",
    "\u506D": "min5",
    "\u506E": "cap1",
    "\u506F": "ji2",
    "\u5070": "sit3",
    "\u5071": "seon1",
    "\u5072": "si1/caai1/soi1",
    "\u5073": "dyun1",
    "\u5074": "zak1",
    "\u5075": "zing1",
    "\u5076": "ngau5/au5",
    "\u5077": "tau1",
    "\u5078": "tau1",
    "\u5079": "bei6",
    "\u507A": "zaa1",
    "\u507B": "leoi5/lau4",
    "\u507C": "zit3",
    "\u507D": "ngai6/ai6",
    "\u507E": "fan5",
    "\u507F": "soeng4",
    "\u5080": "faai3/gwai1",
    "\u5081": "sau2",
    "\u5082": "ci4/zi6",
    "\u5083": "sou3",
    "\u5084": "gwaat3",
    "\u5085": "fu6/fu2",
    "\u5086": "jyun6",
    "\u5087": "jung5",
    "\u5088": "leot6",
    "\u5089": "nuk6/luk6",
    "\u508A": "wan6",
    "\u508B": "gong2",
    "\u508C": "maa6/maa3",
    "\u508D": "bong6/pong4",
    "\u508E": "din1",
    "\u508F": "tong4",
    "\u5090": "hou6",
    "\u5091": "git6",
    "\u5092": "hai4/hai6",
    "\u5093": "sin3",
    "\u5094": "him3",
    "\u5095": "gok3",
    "\u5096": "cong1",
    "\u5097": "cuk1",
    "\u5098": "saan3",
    "\u5099": "bei6",
    "\u509A": "haau6",
    "\u509B": "jung5/jung6/jung4",
    "\u509C": "jiu4",
    "\u509D": "taam3",
    "\u509E": "co1",
    "\u509F": "ong2/ngong2",
    "\u50A0": "fat6",
    "\u50A1": "bing6",
    "\u50A2": "gaa1",
    "\u50A3": "daai2/taai3",
    "\u50A4": "zoi3",
    "\u50A5": "tong2",
    "\u50A6": "gwat1",
    "\u50A7": "ban3/ban1",
    "\u50A8": "cyu5",
    "\u50A9": "no4/lo4",
    "\u50AA": "caam1",
    "\u50AB": "leoi5",
    "\u50AC": "ceoi1",
    "\u50AD": "jung4",
    "\u50AE": "zou1/cou4",
    "\u50AF": "zung2",
    "\u50B0": "pang4",
    "\u50B1": "sung2",
    "\u50B2": "ngou6/ou6",
    "\u50B3": "cyun4/zyun6/zyun2",
    "\u50B4": "jyu2",
    "\u50B5": "zaai3",
    "\u50B6": "cik1",
    "\u50B7": "soeng1",
    "\u50B8": "cong2",
    "\u50B9": "goeng1",
    "\u50BA": "cai3",
    "\u50BB": "so4/so2",
    "\u50BC": "hon3",
    "\u50BD": "zoeng1",
    "\u50BE": "king1",
    "\u50BF": "jin3",
    "\u50C0": "dai3",
    "\u50C1": "sit3",
    "\u50C2": "leoi5/lau4",
    "\u50C3": "bei6",
    "\u50C4": "piu1/piu3",
    "\u50C5": "gan2/gan6",
    "\u50C6": "lin5/leng1",
    "\u50C7": "luk6",
    "\u50C8": "maan6",
    "\u50C9": "cim1",
    "\u50CA": "sin1",
    "\u50CB": "taam3",
    "\u50CC": "jing4",
    "\u50CD": "dung6",
    "\u50CE": "zaan6",
    "\u50CF": "zoeng6",
    "\u50D0": "sin6",
    "\u50D1": "kiu4",
    "\u50D2": "kwan3",
    "\u50D3": "teoi4",
    "\u50D4": "zyun2",
    "\u50D5": "buk6",
    "\u50D6": "hei1",
    "\u50D7": "lou4",
    "\u50D8": "cong2",
    "\u50D9": "gwong1/gong1",
    "\u50DA": "liu4/lou5",
    "\u50DB": "hei1",
    "\u50DC": "cing1",
    "\u50DD": "saan4/caan4",
    "\u50DE": "ngai6/ai6",
    "\u50DF": "gei1",
    "\u50E0": "faan1",
    "\u50E1": "wai6",
    "\u50E2": "cyun2",
    "\u50E3": "tit3",
    "\u50E4": "daan6",
    "\u50E5": "hiu1/jiu4",
    "\u50E6": "zau6",
    "\u50E7": "zang1/sang1",
    "\u50E8": "fan5",
    "\u50E9": "haan5",
    "\u50EA": "gwat6",
    "\u50EB": "ok3/ngok3",
    "\u50EC": "ziu1/ziu3",
    "\u50ED": "cim3/zim3/cim5",
    "\u50EE": "tung4/zong6",
    "\u50EF": "leon4",
    "\u50F0": "baak6/bok3",
    "\u50F1": "gu3/gwu3",
    "\u50F2": "sin1",
    "\u50F3": "suk1",
    "\u50F4": "haan5",
    "\u50F5": "goeng1",
    "\u50F6": "man5",
    "\u50F7": "jip6",
    "\u50F8": "gam3",
    "\u50F9": "gaa3",
    "\u50FA": "ciu3",
    "\u50FB": "pik1/bui6",
    "\u50FC": "fung1",
    "\u50FD": "zau3/zau6",
    "\u50FE": "oi3/ngoi3",
    "\u50FF": "si1",
    "\u5100": "ji4",
    "\u5101": "zeon3",
    "\u5102": "nung4/lung4",
    "\u5103": "sin4/taan2",
    "\u5104": "jik1",
    "\u5105": "dong1",
    "\u5106": "ging2",
    "\u5107": "hyun1",
    "\u5108": "kui2/kwui2/kui3/kwui3",
    "\u5109": "gim6",
    "\u510A": "co3",
    "\u510B": "daam1",
    "\u510C": "giu2/giu1/hiu1",
    "\u510D": "so4",
    "\u510E": "zoi3",
    "\u510F": "caan3",
    "\u5110": "ban3/ban1",
    "\u5111": "ngaam4/aam4",
    "\u5112": "jyu4",
    "\u5113": "toi4",
    "\u5114": "cau4",
    "\u5115": "caai4",
    "\u5116": "laam4",
    "\u5117": "ji5/ji4",
    "\u5118": "zeon2",
    "\u5119": "hin3",
    "\u511A": "mung4",
    "\u511B": "mou5",
    "\u511C": "ning4/ling4",
    "\u511D": "king4",
    "\u511E": "nei5/lei5",
    "\u511F": "soeng4",
    "\u5120": "lip6",
    "\u5121": "leoi5",
    "\u5122": "leoi5",
    "\u5123": "kwong2/kong2",
    "\u5124": "bou3",
    "\u5125": "juk6",
    "\u5126": "biu1",
    "\u5127": "zaan2",
    "\u5128": "zat1",
    "\u5129": "ci3",
    "\u512A": "jau1",
    "\u512B": "hou4",
    "\u512C": "cing3",
    "\u512D": "can3",
    "\u512E": "lik6",
    "\u512F": "tang4",
    "\u5130": "wai5",
    "\u5131": "lung5",
    "\u5132": "cyu5",
    "\u5133": "caam3",
    "\u5134": "joeng4/soeng1",
    "\u5135": "suk1",
    "\u5136": "wai6",
    "\u5137": "lai6",
    "\u5138": "lo4",
    "\u5139": "zaan2/zyun2",
    "\u513A": "no4/lo4",
    "\u513B": "tong2",
    "\u513C": "jim5",
    "\u513D": "leoi5/leoi4",
    "\u513E": "nong6/long6",
    "\u513F": "ji4/ji1/jan4/gaan2.faa3.ji4",
    "\u5140": "ngat6/at6",
    "\u5141": "wan5",
    "\u5142": "zaam1",
    "\u5143": "jyun4",
    "\u5144": "hing1",
    "\u5145": "cung1",
    "\u5146": "siu6",
    "\u5147": "hung1",
    "\u5148": "sin1",
    "\u5149": "gwong1/gong1",
    "\u514A": "deoi3",
    "\u514B": "hak1/haak1",
    "\u514C": "deoi3/deoi6",
    "\u514D": "min5",
    "\u514E": "tou3",
    "\u514F": "coeng4",
    "\u5150": "ji4",
    "\u5151": "deoi3/deoi6",
    "\u5152": "ngai4/ai4/ji4/ji1",
    "\u5153": "zam1",
    "\u5154": "tou3",
    "\u5155": "zi6",
    "\u5156": "jin2/jin5",
    "\u5157": "jin2/jin5",
    "\u5158": "ci2",
    "\u5159": "sap6.hak1",
    "\u515A": "dong2/tong2",
    "\u515B": "cin1.hak1",
    "\u515C": "dau1",
    "\u515D": "fan1.hak1",
    "\u515E": "hou4.hak1",
    "\u515F": "san1",
    "\u5160": "dau1",
    "\u5161": "baak3.hak1",
    "\u5162": "ging1",
    "\u5163": "lei4.hak1",
    "\u5164": "fong2",
    "\u5165": "jap6",
    "\u5166": "mong4/mou4",
    "\u5167": "noi6/loi6/naap6/laap6",
    "\u5168": "cyun4/cyun2",
    "\u5169": "loeng5/loeng2/loeng6",
    "\u516A": "jyu4/jyu6/syu3",
    "\u516B": "baat3/baat2",
    "\u516C": "gung1/gung4",
    "\u516D": "luk6/luk2/liu1",
    "\u516E": "hai4",
    "\u516F": "zit3",
    "\u5170": "laan4/laan1/laan2",
    "\u5171": "gung6/gung1/gung2",
    "\u5172": "tin1",
    "\u5173": "gwaan1",
    "\u5174": "hing1/hing3",
    "\u5175": "bing1",
    "\u5176": "kei4/gei1",
    "\u5177": "geoi6",
    "\u5178": "din2",
    "\u5179": "zi1/ci4",
    "\u517A": "fan1",
    "\u517B": "joeng5/joeng6",
    "\u517C": "gim1",
    "\u517D": "sau3",
    "\u517E": "kei3",
    "\u517F": "ngai6/ai6",
    "\u5180": "kei3",
    "\u5181": "cin2/zin2",
    "\u5182": "gwing1/tung4.zi6.kwaang1",
    "\u5183": "mou6",
    "\u5184": "jim5",
    "\u5185": "noi6/loi6/naap6/laap6",
    "\u5186": "jyun4",
    "\u5187": "mou5",
    "\u5188": "gong1",
    "\u5189": "jim5/jim2",
    "\u518A": "caak3",
    "\u518B": "gwing1",
    "\u518C": "caak3",
    "\u518D": "zoi3",
    "\u518E": "gwaa2",
    "\u518F": "gwing2",
    "\u5190": "mou6/mak6",
    "\u5191": "zau6",
    "\u5192": "mou6/mak6",
    "\u5193": "kau3/gau3/kau1/gau1",
    "\u5194": "heoi2",
    "\u5195": "min5",
    "\u5196": "mik6",
    "\u5197": "jung2",
    "\u5198": "jam4/jau4",
    "\u5199": "se2",
    "\u519A": "kam2/ham6",
    "\u519B": "gwan1",
    "\u519C": "nung4/lung4",
    "\u519D": "ji4",
    "\u519E": "mei4",
    "\u519F": "sik1",
    "\u51A0": "gun1/gwun1/gun3/gwun3",
    "\u51A1": "mung4",
    "\u51A2": "cung2",
    "\u51A3": "zeoi3",
    "\u51A4": "jyun1",
    "\u51A5": "ming4/ming5",
    "\u51A6": "kau3",
    "\u51A7": "lam1/lam3",
    "\u51A8": "fu3",
    "\u51A9": "se2",
    "\u51AA": "mik6",
    "\u51AB": "bing1/loeng5.dim2.seoi2",
    "\u51AC": "dung1",
    "\u51AD": "taai3",
    "\u51AE": "gong1",
    "\u51AF": "fung4/pang4",
    "\u51B0": "bing1/jing4/king4",
    "\u51B1": "wu6",
    "\u51B2": "cung1/cung3",
    "\u51B3": "kyut3/hyut3",
    "\u51B4": "wu6",
    "\u51B5": "fong3",
    "\u51B6": "je5",
    "\u51B7": "laang5/laang1",
    "\u51B8": "pun3",
    "\u51B9": "fat1",
    "\u51BA": "man5",
    "\u51BB": "dung3/dung2",
    "\u51BC": "sin2",
    "\u51BD": "lit6",
    "\u51BE": "hap1",
    "\u51BF": "zin1",
    "\u51C0": "zing6/zeng6",
    "\u51C1": "sau1",
    "\u51C2": "mui5",
    "\u51C3": "tou4",
    "\u51C4": "cai1",
    "\u51C5": "gu3/gwu3",
    "\u51C6": "zeon2",
    "\u51C7": "sung1",
    "\u51C8": "zing6/zeng6",
    "\u51C9": "loeng4/loeng6",
    "\u51CA": "zing6",
    "\u51CB": "diu1",
    "\u51CC": "ling4",
    "\u51CD": "dung3/dung2",
    "\u51CE": "gam3",
    "\u51CF": "gaam2",
    "\u51D0": "jan1",
    "\u51D1": "cau3",
    "\u51D2": "ngoi2/oi2",
    "\u51D3": "leot6",
    "\u51D4": "cong1",
    "\u51D5": "ming5",
    "\u51D6": "zeon2",
    "\u51D7": "ceoi4",
    "\u51D8": "si1",
    "\u51D9": "dok6",
    "\u51DA": "gam6",
    "\u51DB": "lam5",
    "\u51DC": "lam5",
    "\u51DD": "jing4/king4",
    "\u51DE": "hei1",
    "\u51DF": "duk6",
    "\u51E0": "gei2/gei1",
    "\u51E1": "faan4",
    "\u51E2": "faan4",
    "\u51E3": "faan4",
    "\u51E4": "fung6/fung2",
    "\u51E5": "geoi1",
    "\u51E6": "cyu5/cyu2/cyu3/syu3",
    "\u51E7": "kei4",
    "\u51E8": "fung1",
    "\u51E9": "do2",
    "\u51EA": "jau1",
    "\u51EB": "fu4",
    "\u51EC": "fung1",
    "\u51ED": "pang4/peng1/bang6",
    "\u51EE": "fung1",
    "\u51EF": "hoi2/ngoi2/oi2",
    "\u51F0": "wong4/wong2",
    "\u51F1": "hoi2/ngoi2/oi2",
    "\u51F2": "gaam1",
    "\u51F3": "dang3/dang2",
    "\u51F4": "pang4/bang6",
    "\u51F5": "ham3/hung1.zi6.kwaang1",
    "\u51F6": "hung1",
    "\u51F7": "faai3",
    "\u51F8": "dat6",
    "\u51F9": "aau3/ngaau3/aau1/ngaau1/nap1/lap1/waa1",
    "\u51FA": "ceot1",
    "\u51FB": "gik1",
    "\u51FC": "tam5",
    "\u51FD": "haam4",
    "\u51FE": "haam4",
    "\u51FF": "zok6/zok2",
    "\u5200": "dou1",
    "\u5201": "diu1",
    "\u5202": "dou1/lei6.dou1.bin1",
    "\u5203": "jan6",
    "\u5204": "jan6",
    "\u5205": "cong1",
    "\u5206": "fan1/fan6",
    "\u5207": "cit3/cai3",
    "\u5208": "ngaai6/aai6",
    "\u5209": "gei1",
    "\u520A": "hon1/hon2",
    "\u520B": "cin3",
    "\u520C": "cyun2",
    "\u520D": "co1",
    "\u520E": "man5",
    "\u520F": "gei1",
    "\u5210": "daan2",
    "\u5211": "jing4",
    "\u5212": "waak6/waa1/waa4/faa3",
    "\u5213": "jyun4",
    "\u5214": "kyut3",
    "\u5215": "lei4",
    "\u5216": "jyut6",
    "\u5217": "lit6/laat6",
    "\u5218": "lau4/lau2",
    "\u5219": "zak1",
    "\u521A": "gong1",
    "\u521B": "cong3/cong1",
    "\u521C": "fat1/fat6",
    "\u521D": "co1",
    "\u521E": "ceoi3",
    "\u521F": "diu1",
    "\u5220": "saan1",
    "\u5221": "man5",
    "\u5222": "ling4",
    "\u5223": "zung1",
    "\u5224": "pun3",
    "\u5225": "bit6/bit3",
    "\u5226": "gip3",
    "\u5227": "gip3",
    "\u5228": "paau4/paau2",
    "\u5229": "lei6/lei2",
    "\u522A": "saan1",
    "\u522B": "bit6/bit3",
    "\u522C": "caan2",
    "\u522D": "ging2",
    "\u522E": "gwaat3/gwaat2",
    "\u522F": "gang1",
    "\u5230": "dou3/dou2",
    "\u5231": "cong3/cong1",
    "\u5232": "gwai1",
    "\u5233": "fu1",
    "\u5234": "doek3/do2",
    "\u5235": "ji6",
    "\u5236": "zai3",
    "\u5237": "caat3/caat2/saat3",
    "\u5238": "hyun3/gyun3",
    "\u5239": "caat3/saat3",
    "\u523A": "ci3/cik3/cik1/sik3",
    "\u523B": "hak1/haak1",
    "\u523C": "gip3",
    "\u523D": "kui2/kwui2",
    "\u523E": "ci3/cik3",
    "\u523F": "gwai3",
    "\u5240": "hoi2",
    "\u5241": "doek3/do2",
    "\u5242": "zai1",
    "\u5243": "tai3",
    "\u5244": "ging2",
    "\u5245": "lau4",
    "\u5246": "lo5",
    "\u5247": "zak1",
    "\u5248": "jyun1",
    "\u5249": "co3",
    "\u524A": "soek3/ciu3",
    "\u524B": "hak1/haak1",
    "\u524C": "laat6/laa1/laai1",
    "\u524D": "cin4",
    "\u524E": "caat3/saat3",
    "\u524F": "cong3/cong1",
    "\u5250": "gwaa2/waa2",
    "\u5251": "gim3",
    "\u5252": "cok3/co3",
    "\u5253": "lei4",
    "\u5254": "tik1/tai3",
    "\u5255": "fei6/fai3",
    "\u5256": "fau2/pau2",
    "\u5257": "caan2",
    "\u5258": "kei4",
    "\u5259": "cong3/cong1",
    "\u525A": "zi3",
    "\u525B": "gong1",
    "\u525C": "wun1/wun2",
    "\u525D": "mok1/pok3",
    "\u525E": "gei1/gei2",
    "\u525F": "zyut3",
    "\u5260": "loek6/king4",
    "\u5261": "jim5/sim6",
    "\u5262": "duk1",
    "\u5263": "gim3",
    "\u5264": "zai1",
    "\u5265": "mok1/pok3",
    "\u5266": "jim2",
    "\u5267": "kek6",
    "\u5268": "waak6",
    "\u5269": "sing6/zing6",
    "\u526A": "zin2",
    "\u526B": "dok6",
    "\u526C": "zai3/tyun4",
    "\u526D": "uk1/nguk1",
    "\u526E": "gwaa2/waa2",
    "\u526F": "fu3/pik1",
    "\u5270": "sing6",
    "\u5271": "gim3",
    "\u5272": "got3",
    "\u5273": "zaat3/zaap3",
    "\u5274": "hoi2",
    "\u5275": "cong3/cong1",
    "\u5276": "cyun1",
    "\u5277": "caan2",
    "\u5278": "tyun4",
    "\u5279": "luk6",
    "\u527A": "lei4/lai5",
    "\u527B": "pang2",
    "\u527C": "saam1",
    "\u527D": "piu3/piu5/piu4",
    "\u527E": "kau1",
    "\u527F": "ziu2/caau1",
    "\u5280": "gwaat3",
    "\u5281": "ciu4",
    "\u5282": "kyut3/gyut3",
    "\u5283": "waak6",
    "\u5284": "zaat3/zaap3",
    "\u5285": "zoek3",
    "\u5286": "lim4",
    "\u5287": "kek6",
    "\u5288": "pik1/pek3/pek6",
    "\u5289": "lau4/lau2",
    "\u528A": "kui2/kwui2",
    "\u528B": "ziu2",
    "\u528C": "gwai3",
    "\u528D": "gim3",
    "\u528E": "gim3",
    "\u528F": "tong1",
    "\u5290": "fok3/wok6/wok3/hap6",
    "\u5291": "zai1",
    "\u5292": "gim3",
    "\u5293": "ji6",
    "\u5294": "gim3",
    "\u5295": "zat1",
    "\u5296": "caam4/caam5",
    "\u5297": "zin2",
    "\u5298": "mo4",
    "\u5299": "lai5/lei4",
    "\u529A": "zuk1",
    "\u529B": "lik6/lik1",
    "\u529C": "aat3/ngaat3",
    "\u529D": "hyun3",
    "\u529E": "baan6/baan2",
    "\u529F": "gung1",
    "\u52A0": "gaa1/gaa3",
    "\u52A1": "mou6",
    "\u52A2": "maai6",
    "\u52A3": "lyut3/lyut6",
    "\u52A4": "ging6",
    "\u52A5": "haang1",
    "\u52A6": "hip3/hip6",
    "\u52A7": "zi2",
    "\u52A8": "dung6",
    "\u52A9": "zo6",
    "\u52AA": "nou5/lou5",
    "\u52AB": "gip3",
    "\u52AC": "keoi4",
    "\u52AD": "siu6",
    "\u52AE": "jat6",
    "\u52AF": "zyu2",
    "\u52B0": "mok6",
    "\u52B1": "lai6",
    "\u52B2": "ging6/ging3",
    "\u52B3": "lou4/lou2/lou6",
    "\u52B4": "lou4",
    "\u52B5": "hyun3/gyun3",
    "\u52B6": "hau2",
    "\u52B7": "lik6",
    "\u52B8": "aai1/ngaai1",
    "\u52B9": "haau6",
    "\u52BA": "mau4",
    "\u52BB": "hong1",
    "\u52BC": "kit3",
    "\u52BD": "lit6",
    "\u52BE": "hat6",
    "\u52BF": "sai3",
    "\u52C0": "hak1",
    "\u52C1": "ging6/ging3",
    "\u52C2": "hou4",
    "\u52C3": "but6",
    "\u52C4": "man5",
    "\u52C5": "cik1",
    "\u52C6": "long4",
    "\u52C7": "jung5",
    "\u52C8": "jung5",
    "\u52C9": "min5",
    "\u52CA": "hak1",
    "\u52CB": "fan1",
    "\u52CC": "gyun6",
    "\u52CD": "king4",
    "\u52CE": "luk6",
    "\u52CF": "bau6",
    "\u52D0": "maang5",
    "\u52D1": "loi6/cik1",
    "\u52D2": "lak6/laak6",
    "\u52D3": "hat6",
    "\u52D4": "min5",
    "\u52D5": "dung6",
    "\u52D6": "juk1",
    "\u52D7": "juk1",
    "\u52D8": "ham3/ham1",
    "\u52D9": "mou6",
    "\u52DA": "ji6/jai6",
    "\u52DB": "fan1",
    "\u52DC": "jung2",
    "\u52DD": "sing3/sing1",
    "\u52DE": "lou4/lou2/lou6",
    "\u52DF": "mou6",
    "\u52E0": "luk6",
    "\u52E1": "piu3",
    "\u52E2": "sai3",
    "\u52E3": "zik1",
    "\u52E4": "kan4",
    "\u52E5": "koeng5/goeng6",
    "\u52E6": "ziu2/caau1",
    "\u52E7": "hyun3",
    "\u52E8": "zoeng6",
    "\u52E9": "ji6/jai6",
    "\u52EA": "kiu5",
    "\u52EB": "faan1",
    "\u52EC": "gyun1",
    "\u52ED": "tung4",
    "\u52EE": "geoi6/geoi3",
    "\u52EF": "daan1",
    "\u52F0": "hip3",
    "\u52F1": "maai6",
    "\u52F2": "fan1",
    "\u52F3": "fan1",
    "\u52F4": "leoi6",
    "\u52F5": "lai6",
    "\u52F6": "cit3",
    "\u52F7": "joeng4/soeng1",
    "\u52F8": "hyun3",
    "\u52F9": "baau1/baau1.zi6.tau4",
    "\u52FA": "zoek3/coek3/soek3",
    "\u52FB": "wan4",
    "\u52FC": "gau1",
    "\u52FD": "bou6",
    "\u52FE": "ngau1/au1/gau1",
    "\u52FF": "mat6",
    "\u5300": "wan4",
    "\u5301": "jan6",
    "\u5302": "hung1",
    "\u5303": "koi3",
    "\u5304": "koi3",
    "\u5305": "baau1",
    "\u5306": "cung1",
    "\u5307": "cung1",
    "\u5308": "hung1",
    "\u5309": "ping1/paang1",
    "\u530A": "guk1",
    "\u530B": "tou4",
    "\u530C": "gap3/hap6",
    "\u530D": "pou4",
    "\u530E": "ap1/ngap1",
    "\u530F": "paau4",
    "\u5310": "fuk6/baak6",
    "\u5311": "gung1",
    "\u5312": "daap3",
    "\u5313": "gau3",
    "\u5314": "kung4",
    "\u5315": "bei3/bei2/bei6",
    "\u5316": "faa3/faa2/faa1",
    "\u5317": "bak1/bui3/bei3",
    "\u5318": "nou5/lou5",
    "\u5319": "ci4/ci2/si4",
    "\u531A": "fong1/hong1.zi6.kwaang1",
    "\u531B": "gau6",
    "\u531C": "ji4",
    "\u531D": "zaap3",
    "\u531E": "zoeng6",
    "\u531F": "kong3",
    "\u5320": "zoeng6/zoeng2",
    "\u5321": "hong1",
    "\u5322": "fat1",
    "\u5323": "haap6/hap6",
    "\u5324": "kuk1",
    "\u5325": "faan4",
    "\u5326": "gwai2",
    "\u5327": "haap6",
    "\u5328": "zong1",
    "\u5329": "hong1",
    "\u532A": "fei2/fei1",
    "\u532B": "fat1",
    "\u532C": "jyu6",
    "\u532D": "gwai2",
    "\u532E": "gwai6",
    "\u532F": "wui6",
    "\u5330": "dan1/daan1",
    "\u5331": "gwai6",
    "\u5332": "lim4",
    "\u5333": "lim4",
    "\u5334": "syun3",
    "\u5335": "duk6",
    "\u5336": "gau3/gau6",
    "\u5337": "goek3",
    "\u5338": "hai5",
    "\u5339": "pat1",
    "\u533A": "keoi1/au1/ngau1",
    "\u533B": "ji1/ai3/ngai3",
    "\u533C": "hap1/am2/ngam2/o1/ngo1",
    "\u533D": "jin2",
    "\u533E": "bin2",
    "\u533F": "nik1/lik1/tik1",
    "\u5340": "keoi1/au1/ngau1",
    "\u5341": "sap6",
    "\u5342": "seon3",
    "\u5343": "cin1",
    "\u5344": "nim6/lim6/jaa6/je6",
    "\u5345": "saa1.aa6",
    "\u5346": "zeot1",
    "\u5347": "sing1",
    "\u5348": "ng5/m5/ng2/m2",
    "\u5349": "wai2/wai5",
    "\u534A": "bun3",
    "\u534B": "sai3",
    "\u534C": "sei3.aa6",
    "\u534D": "maan6",
    "\u534E": "waa4/waa2/waa6/faa1",
    "\u534F": "hip3",
    "\u5350": "maan6",
    "\u5351": "bei1",
    "\u5352": "zeot1/cyut3",
    "\u5353": "coek3/zoek3",
    "\u5354": "hip3",
    "\u5355": "daan1/sin6/sin4/sim4",
    "\u5356": "maai6/maai2",
    "\u5357": "naam4/laam4/naam2/laam2/naa4/laa4/naa1/laa1",
    "\u5358": "daan1",
    "\u5359": "zap1",
    "\u535A": "bok3",
    "\u535B": "seot1",
    "\u535C": "baak6/buk1",
    "\u535D": "gwaan3/kong3/kwong3",
    "\u535E": "bin6",
    "\u535F": "buk1",
    "\u5360": "zim1/zim3",
    "\u5361": "kaa1/kaa2/kaat1",
    "\u5362": "lou4/lou2",
    "\u5363": "jau5",
    "\u5364": "lou5",
    "\u5365": "sai1",
    "\u5366": "gwaa3",
    "\u5367": "ngo6/o6",
    "\u5368": "sit3",
    "\u5369": "zit3/daan1.ji5.dou1",
    "\u536A": "zit3",
    "\u536B": "wai6",
    "\u536C": "ngong4/ong4/joeng5",
    "\u536D": "kung4",
    "\u536E": "zi1",
    "\u536F": "maau5",
    "\u5370": "jan3/ngan3/an3",
    "\u5371": "ngai4/ai4",
    "\u5372": "siu6",
    "\u5373": "zik1",
    "\u5374": "koek3",
    "\u5375": "leon2/leon5",
    "\u5376": "ci2",
    "\u5377": "gyun2/gyun3/kyun4",
    "\u5378": "se3",
    "\u5379": "seot1",
    "\u537A": "gan2",
    "\u537B": "koek3",
    "\u537C": "ngat6/at6",
    "\u537D": "zik1",
    "\u537E": "ngok6/ok6",
    "\u537F": "hing1",
    "\u5380": "sat1",
    "\u5381": "ce4",
    "\u5382": "cong2/hon3/ngon6/on6/am1/ngam1",
    "\u5383": "ngai5/ai5",
    "\u5384": "ak1/aak1/ngaak1/ngak1",
    "\u5385": "teng1/ting1",
    "\u5386": "lik6",
    "\u5387": "zaak6",
    "\u5388": "hon3",
    "\u5389": "lai6",
    "\u538A": "ngaa5/aa5",
    "\u538B": "aat3/ngaat3",
    "\u538C": "jim3/aat3/ngaat3/jim1/jim2",
    "\u538D": "se3",
    "\u538E": "zi2",
    "\u538F": "zaa3",
    "\u5390": "pong4",
    "\u5391": "ngaai4/aai4",
    "\u5392": "hip3",
    "\u5393": "ngaai4/aai4",
    "\u5394": "zat6",
    "\u5395": "ci3/cak1",
    "\u5396": "pong4/mong4",
    "\u5397": "tai4",
    "\u5398": "lei4/lei2",
    "\u5399": "se3",
    "\u539A": "hau5",
    "\u539B": "teng1",
    "\u539C": "seoi4",
    "\u539D": "cou3",
    "\u539E": "fei6",
    "\u539F": "jyun4/jyun6",
    "\u53A0": "ci3/cak1",
    "\u53A1": "jyun4",
    "\u53A2": "soeng1",
    "\u53A3": "jim2",
    "\u53A4": "lik6",
    "\u53A5": "kyut3",
    "\u53A6": "haa6",
    "\u53A7": "din1",
    "\u53A8": "cyu4/ceoi4",
    "\u53A9": "gau3",
    "\u53AA": "kan4/gan2",
    "\u53AB": "ngou4/ou4",
    "\u53AC": "gwai2",
    "\u53AD": "jim3/aat3/ngaat3/jim1/jim2",
    "\u53AE": "si1",
    "\u53AF": "lik6",
    "\u53B0": "cong2",
    "\u53B1": "laam4/cim1",
    "\u53B2": "lai6",
    "\u53B3": "jim4",
    "\u53B4": "jim2",
    "\u53B5": "jyun4",
    "\u53B6": "si1/mau5",
    "\u53B7": "gwang1",
    "\u53B8": "leon4",
    "\u53B9": "kau4/jau4",
    "\u53BA": "heoi3",
    "\u53BB": "heoi3/heoi2",
    "\u53BC": "ji5",
    "\u53BD": "leoi5",
    "\u53BE": "duk1",
    "\u53BF": "jyun6/jyun2/jyun4",
    "\u53C0": "zyun1",
    "\u53C1": "saam1/saam3",
    "\u53C2": "caam1/saam1/saam3/sam1/cam1",
    "\u53C3": "caam1/saam1/saam3/sam1/cam1",
    "\u53C4": "caam1",
    "\u53C5": "caam1",
    "\u53C6": "oi2/ngoi2",
    "\u53C7": "doi6",
    "\u53C8": "jau6",
    "\u53C9": "caa1/caa5",
    "\u53CA": "kap6/gap6",
    "\u53CB": "jau5/jau2",
    "\u53CC": "soeng1/sung1",
    "\u53CD": "faan2/faan1",
    "\u53CE": "sau1",
    "\u53CF": "gwaai3",
    "\u53D0": "bat6",
    "\u53D1": "faat3",
    "\u53D2": "joek6",
    "\u53D3": "si6",
    "\u53D4": "suk1",
    "\u53D5": "zyut3",
    "\u53D6": "ceoi2",
    "\u53D7": "sau6",
    "\u53D8": "bin3",
    "\u53D9": "zeoi6",
    "\u53DA": "gaa2",
    "\u53DB": "bun6",
    "\u53DC": "sau2",
    "\u53DD": "gap1",
    "\u53DE": "wai3",
    "\u53DF": "sau2",
    "\u53E0": "dip6/daap6",
    "\u53E1": "jeoi6",
    "\u53E2": "cung4",
    "\u53E3": "hau2",
    "\u53E4": "gu2/gwu2/gu1/gwu1",
    "\u53E5": "geoi3/geoi2/ngau1/au1/gau1",
    "\u53E6": "ling6",
    "\u53E7": "waa1",
    "\u53E8": "tou1/dou1",
    "\u53E9": "kau3",
    "\u53EA": "zi2/zi1/zek3",
    "\u53EB": "giu3",
    "\u53EC": "ziu6/siu6",
    "\u53ED": "baa1",
    "\u53EE": "ding1/deng1",
    "\u53EF": "ho2/hak1",
    "\u53F0": "toi4/ji4/toi2",
    "\u53F1": "cik1",
    "\u53F2": "si2",
    "\u53F3": "jau6/jau2",
    "\u53F4": "kau4",
    "\u53F5": "po2",
    "\u53F6": "jip6/jip2/sip3/hip3/hip6",
    "\u53F7": "hou6/hou2/hou4",
    "\u53F8": "si1",
    "\u53F9": "taan3",
    "\u53FA": "cek3",
    "\u53FB": "lak6/laak6/lik1/lek1",
    "\u53FC": "diu1",
    "\u53FD": "gei1",
    "\u53FE": "duk1",
    "\u53FF": "hung1",
    "\u5400": "mei5",
    "\u5401": "jyu6/joek6/heoi1/jyu1",
    "\u5402": "mong4",
    "\u5403": "hek3/jaak3/hat1/gat1",
    "\u5404": "gok3",
    "\u5405": "hyun1",
    "\u5406": "jiu1",
    "\u5407": "zi2",
    "\u5408": "hap6/gap3/gaap3/ho4",
    "\u5409": "gat1",
    "\u540A": "diu3/diu2/diu4",
    "\u540B": "cyun3/jing1.cyun3",
    "\u540C": "tung4",
    "\u540D": "ming4/meng2/meng4",
    "\u540E": "hau6/hau2",
    "\u540F": "lei6",
    "\u5410": "tou3/tou2/dat6",
    "\u5411": "hoeng3/hoeng2",
    "\u5412": "zaa1/zaa3/caak1",
    "\u5413": "haak3/haak1/haa1/haa2/haa5",
    "\u5414": "jaa1/jaa2/jaa4/jaak3/je5",
    "\u5415": "leoi5",
    "\u5416": "aa1/ngaa1/aa3/ngaa3",
    "\u5417": "maa1/maa3/maa5",
    "\u5418": "ngau5/au5",
    "\u5419": "hoe1",
    "\u541A": "ji1",
    "\u541B": "gwan1",
    "\u541C": "cau2",
    "\u541D": "leon6",
    "\u541E": "tan1",
    "\u541F": "jam4/ngam4/am4",
    "\u5420": "fai6",
    "\u5421": "pei2/bei2",
    "\u5422": "cam3",
    "\u5423": "cam3",
    "\u5424": "gaai3",
    "\u5425": "bat1",
    "\u5426": "fau2/pei2",
    "\u5427": "baa6/baa1",
    "\u5428": "deon1",
    "\u5429": "fan1",
    "\u542A": "ngo4/o4/faa4",
    "\u542B": "ham4",
    "\u542C": "ting1/teng1/ting3/jan5",
    "\u542D": "hong4/hang1",
    "\u542E": "syun5",
    "\u542F": "kai2",
    "\u5430": "wang4",
    "\u5431": "zi1/gei1",
    "\u5432": "jan5",
    "\u5433": "ng4/m4",
    "\u5434": "ng4/m4",
    "\u5435": "caau2",
    "\u5436": "naap6/laap6/neot6/leot6/nat6/lat6/naa3/laa3/ne1/le1",
    "\u5437": "hyut3",
    "\u5438": "kap1",
    "\u5439": "ceoi1/ceoi3",
    "\u543A": "dau1",
    "\u543B": "man5",
    "\u543C": "hau3/haau1/hau1",
    "\u543D": "ngau4/au4/hau1/hau3/hau2/hung1/ngau6/au6",
    "\u543E": "ng4/m4",
    "\u543F": "gou3/guk1",
    "\u5440": "aa1/ngaa1/aa3/ngaa3",
    "\u5441": "gwan3",
    "\u5442": "leoi5",
    "\u5443": "ak1/ngak1/aak1/ngaak1/aai3/ngaai3",
    "\u5444": "gak1",
    "\u5445": "mui4",
    "\u5446": "ngoi4/oi4/daai1",
    "\u5447": "kai2",
    "\u5448": "cing4",
    "\u5449": "ng4/m4",
    "\u544A": "gou3/guk1",
    "\u544B": "fu1",
    "\u544C": "giu3",
    "\u544D": "ngau4/au4",
    "\u544E": "cek3/jing1.cek3",
    "\u544F": "sing1",
    "\u5450": "naap6/laap6/neot6/leot6/nat6/lat6/naa3/laa3/ne1/le1",
    "\u5451": "tan1",
    "\u5452": "fu2/mou5",
    "\u5453": "ngai6/ai6",
    "\u5454": "taai1/toi2",
    "\u5455": "au2/ngau2/au1/ngau1/au3/ngau3/heoi1",
    "\u5456": "lik6/lik1",
    "\u5457": "baai6/be6/bui6",
    "\u5458": "jyun4/jyun2/wan6/wan4",
    "\u5459": "waa1/gwo1/go1",
    "\u545A": "mui4",
    "\u545B": "coeng1/coeng3",
    "\u545C": "wu1",
    "\u545D": "ak1/ngak1/aak1/ngaak1",
    "\u545E": "si1/ci1",
    "\u545F": "gyun2",
    "\u5460": "pan3",
    "\u5461": "man5",
    "\u5462": "nei4/lei4/nai4/lai4/ne1/le1/ni1/li1/nei1/lei1",
    "\u5463": "m2/ngm2/m6/ngm6",
    "\u5464": "ling4/ling6",
    "\u5465": "jim4/jam1",
    "\u5466": "jau1",
    "\u5467": "dai2",
    "\u5468": "zau1",
    "\u5469": "si3",
    "\u546A": "zau3",
    "\u546B": "tip3/cip3",
    "\u546C": "hei3",
    "\u546D": "jai6",
    "\u546E": "kei4",
    "\u546F": "ping4",
    "\u5470": "zi2",
    "\u5471": "gu1/gwu1/gwaa1",
    "\u5472": "zi1/ci1",
    "\u5473": "mei6/mei1/mei2",
    "\u5474": "heoi3/heoi2/heoi1/hau3/hau1",
    "\u5475": "ho1/aa3/ngaa3/ho2",
    "\u5476": "naau4/laau4",
    "\u5477": "haap3/gaat3",
    "\u5478": "pei1",
    "\u5479": "jat6/cik1",
    "\u547A": "hiu1/hou4",
    "\u547B": "san1",
    "\u547C": "fu1",
    "\u547D": "ming6/meng2/meng6",
    "\u547E": "daat3",
    "\u547F": "keoi1",
    "\u5480": "zeoi2",
    "\u5481": "gam2/gam3",
    "\u5482": "zaap3",
    "\u5483": "to1",
    "\u5484": "deot1/zyut3/cyut3/dyut1",
    "\u5485": "tau3",
    "\u5486": "paau4",
    "\u5487": "bit6/bat6/bit1",
    "\u5488": "fat6",
    "\u5489": "joeng1",
    "\u548A": "wo4/wo6/wu4/gwo3/go3",
    "\u548B": "zaa3/zaa2/zaak3/zaa1",
    "\u548C": "wo4/wo1/wo6/wu4/gwo3/go3",
    "\u548D": "hoi1",
    "\u548E": "gau3/gou1",
    "\u548F": "wing6",
    "\u5490": "fu3/fu6",
    "\u5491": "daa1",
    "\u5492": "zau3",
    "\u5493": "aa5/ngaa5",
    "\u5494": "kaa1/kaa4",
    "\u5495": "gu1/gwu1",
    "\u5496": "gaa3/kaa1",
    "\u5497": "zo2",
    "\u5498": "bou3",
    "\u5499": "lung4",
    "\u549A": "dung1",
    "\u549B": "ning4/ling4",
    "\u549C": "taa1",
    "\u549D": "si1",
    "\u549E": "jin6",
    "\u549F": "waak1",
    "\u54A0": "cap1",
    "\u54A1": "ji6",
    "\u54A2": "ngok6/ok6",
    "\u54A3": "gwong1/gong1",
    "\u54A4": "zaa3/caak1/caa3",
    "\u54A5": "hei3/dit6",
    "\u54A6": "ji4/ji2/hi1",
    "\u54A7": "le2/lit6/le1/le3",
    "\u54A8": "zi1",
    "\u54A9": "me1",
    "\u54AA": "mai1/mei1/mi1/mai5/mai6/mi4",
    "\u54AB": "zi2",
    "\u54AC": "ngaau5/aau5/gaau1",
    "\u54AD": "gat1/kat1/kaat1",
    "\u54AE": "zau3",
    "\u54AF": "gok1/gok3/kaak3/haak3/lok3/lo1/lo3/lok6",
    "\u54B0": "seot1",
    "\u54B1": "zaa1",
    "\u54B2": "siu3",
    "\u54B3": "kat1/haai1/haai4/hoi4/koi3",
    "\u54B4": "fui1",
    "\u54B5": "kwaa1/kwaa2",
    "\u54B6": "waat6",
    "\u54B7": "tou4",
    "\u54B8": "haam4/haam2",
    "\u54B9": "hon1",
    "\u54BA": "hyun2/hyun1",
    "\u54BB": "jau1/heoi2",
    "\u54BC": "waa1/gwo1/go1",
    "\u54BD": "jin1/jin3/jit3",
    "\u54BE": "lou5",
    "\u54BF": "ji1",
    "\u54C0": "oi1/ngoi1",
    "\u54C1": "ban2",
    "\u54C2": "can2/saai3",
    "\u54C3": "tung4",
    "\u54C4": "hung1/hung3/hung6",
    "\u54C5": "hung1",
    "\u54C6": "do1/ci2/ce2",
    "\u54C7": "waa1",
    "\u54C8": "haa1",
    "\u54C9": "zoi1",
    "\u54CA": "juk6",
    "\u54CB": "dei6/dei2/di4",
    "\u54CC": "paai3",
    "\u54CD": "hoeng2",
    "\u54CE": "aai1/ngaai1/ai3/ngai3",
    "\u54CF": "han2/gan1",
    "\u54D0": "hong1",
    "\u54D1": "aa2/ngaa2/aa1/ngaa1/ak1/ngak1",
    "\u54D2": "daat6/daat3",
    "\u54D3": "hiu1",
    "\u54D4": "bat1",
    "\u54D5": "jyut6/wai3",
    "\u54D6": "nin4/lin4",
    "\u54D7": "waa1/waa4",
    "\u54D8": "hang4",
    "\u54D9": "faai3",
    "\u54DA": "doe2/do2",
    "\u54DB": "fan1",
    "\u54DC": "zai6",
    "\u54DD": "nung4/lung4",
    "\u54DE": "mau1/mau4",
    "\u54DF": "jo1",
    "\u54E0": "hou6",
    "\u54E1": "jyun4/jyun2/wan6/wan4",
    "\u54E2": "lung6",
    "\u54E3": "dau6",
    "\u54E4": "mong4",
    "\u54E5": "go1/go4",
    "\u54E6": "ngo4/o4/o2/ngo2/o6/ngo6",
    "\u54E7": "ci1/cik1",
    "\u54E8": "saau3/saau2",
    "\u54E9": "li1/le1/lei5/jing1.lei5",
    "\u54EA": "naa5/laa5/naa1/laa1/naa4/laa4",
    "\u54EB": "zuk1",
    "\u54EC": "ho4",
    "\u54ED": "huk1",
    "\u54EE": "haau1",
    "\u54EF": "jin6",
    "\u54F0": "lou4",
    "\u54F1": "but6/but3",
    "\u54F2": "zit3",
    "\u54F3": "zaat3",
    "\u54F4": "loeng6/long4",
    "\u54F5": "baat3",
    "\u54F6": "me1",
    "\u54F7": "lyut3",
    "\u54F8": "ceoi1",
    "\u54F9": "fau4",
    "\u54FA": "bou6",
    "\u54FB": "hon4",
    "\u54FC": "hang1/hng6/hm6",
    "\u54FD": "gang2/ang2/ngang2",
    "\u54FE": "syut3",
    "\u54FF": "go2/go1/ho2",
    "\u5500": "jau5",
    "\u5501": "jin6/jin3",
    "\u5502": "guk1",
    "\u5503": "guk1",
    "\u5504": "baai6/be6/bui6",
    "\u5505": "ham4/ham3",
    "\u5506": "so1",
    "\u5507": "seon4",
    "\u5508": "jap1",
    "\u5509": "aai1/ngaai1/aai6/ngaai6/aai3/ngaai3",
    "\u550A": "gaap3",
    "\u550B": "tou1",
    "\u550C": "jin4",
    "\u550D": "waan5",
    "\u550E": "li1",
    "\u550F": "hei1",
    "\u5510": "tong4/tong2",
    "\u5511": "zo6",
    "\u5512": "cau4",
    "\u5513": "ce1",
    "\u5514": "m4/ngm4/ng4",
    "\u5515": "zou6",
    "\u5516": "aa2/ngaa2",
    "\u5517": "dau1",
    "\u5518": "kai2",
    "\u5519": "dik6/dik1",
    "\u551A": "cam3",
    "\u551B": "mak1",
    "\u551C": "mut6",
    "\u551D": "fung2/hung2/gung3",
    "\u551E": "tau2",
    "\u551F": "heoi3",
    "\u5520": "lou4",
    "\u5521": "loeng2/jing1.loeng2",
    "\u5522": "so2",
    "\u5523": "zou6",
    "\u5524": "wun6",
    "\u5525": "laang6/laang4/laang1",
    "\u5526": "saa1",
    "\u5527": "zik1/zit1/zek1",
    "\u5528": "zo2",
    "\u5529": "wo1",
    "\u552A": "fung2/bung2/baang6",
    "\u552B": "gam3/jam4/ngam4/am4",
    "\u552C": "fu2/haak3/haau1",
    "\u552D": "kei3",
    "\u552E": "sau6",
    "\u552F": "wai4/wai2",
    "\u5530": "caat3",
    "\u5531": "coeng3",
    "\u5532": "ji4/waa1",
    "\u5533": "leoi6",
    "\u5534": "goeng6",
    "\u5535": "am2/ngam2",
    "\u5536": "ze3/zaak3",
    "\u5537": "jo1",
    "\u5538": "din6/nim6/lim6",
    "\u5539": "jyu1",
    "\u553A": "tin2",
    "\u553B": "loi6",
    "\u553C": "saap3/zaap3/zit6/cip3/dip6",
    "\u553D": "sik1",
    "\u553E": "to3/toe3/toe5",
    "\u553F": "fat1",
    "\u5540": "ngaai4/aai4",
    "\u5541": "zau1/zaau1",
    "\u5542": "nau5/lau5",
    "\u5543": "hang2",
    "\u5544": "doek3/doeng1/zau3",
    "\u5545": "doek3",
    "\u5546": "soeng1",
    "\u5547": "dik1",
    "\u5548": "hang1/hng6/hm6",
    "\u5549": "laam4/lam4/lam1",
    "\u554A": "aa1/ngaa1/aa2/ngaa2/aa6/ngaa6/aa3/ngaa3/aa4/ngaa4",
    "\u554B": "coi1",
    "\u554C": "hong1",
    "\u554D": "teon1",
    "\u554E": "ng5/m5",
    "\u554F": "man6",
    "\u5550": "ceoi3/seoi6",
    "\u5551": "saap3/zaap3/zit6/cip3/dip6",
    "\u5552": "gwat1",
    "\u5553": "kai2",
    "\u5554": "kai2",
    "\u5555": "tou4",
    "\u5556": "daam6",
    "\u5557": "daam6",
    "\u5558": "waa1",
    "\u5559": "zi2",
    "\u555A": "pei2/tou4",
    "\u555B": "ceoi3",
    "\u555C": "zyut3/zyut1/ceoi3",
    "\u555D": "wo3/wo4",
    "\u555E": "aa2/ngaa2/aa1/ngaa1/ak1/ngak1",
    "\u555F": "kai2",
    "\u5560": "zit3",
    "\u5561": "fe1/fei1/pei1",
    "\u5562": "loeng2/jing1.loeng2",
    "\u5563": "haam4/ham4",
    "\u5564": "be1/bi1/bi4/pe1",
    "\u5565": "saa2",
    "\u5566": "laa1/laa2/laa3/laa4",
    "\u5567": "zaak3/zik1",
    "\u5568": "jing1",
    "\u5569": "gwaa3",
    "\u556A": "paak1/paak2/paak4",
    "\u556B": "ze1/zek1/zoe1",
    "\u556C": "sik1",
    "\u556D": "zyun2",
    "\u556E": "ngit6/it6/jit6/ngaat6/aat6",
    "\u556F": "gwok3/gok3",
    "\u5570": "lo1/lo4/lo3",
    "\u5571": "ngaam1/aam1/ngam1/am1",
    "\u5572": "di1/dit1/di4/ti4",
    "\u5573": "kyun4",
    "\u5574": "taan1/cin2/zin2",
    "\u5575": "bo3/bo1",
    "\u5576": "ding6",
    "\u5577": "long1",
    "\u5578": "siu3",
    "\u5579": "goe1/koe1",
    "\u557A": "tong4",
    "\u557B": "ci3",
    "\u557C": "tai4",
    "\u557D": "am4/ngam4/ngap1/ap1",
    "\u557E": "zau1",
    "\u557F": "daam6",
    "\u5580": "kaak3/haak3/kaa3/kaa1",
    "\u5581": "jung4/jyu4",
    "\u5582": "wai3/wai2",
    "\u5583": "naam4/laam4",
    "\u5584": "sin6",
    "\u5585": "juk6",
    "\u5586": "zit3",
    "\u5587": "laa3/laa5/laa1/laat3",
    "\u5588": "gaai1",
    "\u5589": "hau4/hau2",
    "\u558A": "haam3",
    "\u558B": "dip6/zaap3",
    "\u558C": "zau1/zuk1",
    "\u558D": "caai4",
    "\u558E": "waa1/wo5/wo3",
    "\u558F": "je5/nok6/lok6/no6/lo6",
    "\u5590": "juk1",
    "\u5591": "jam1/jam3/ngam6/am6",
    "\u5592": "zaa1",
    "\u5593": "jiu1",
    "\u5594": "ak1/ngak1/aak1/ngaak1/o1/ngo1/o2/ngo2",
    "\u5595": "min5",
    "\u5596": "wu4",
    "\u5597": "wan5",
    "\u5598": "cyun2",
    "\u5599": "fui3/zau3",
    "\u559A": "wun6",
    "\u559B": "wun6",
    "\u559C": "hei2",
    "\u559D": "hot3",
    "\u559E": "zik1/zit1/zek1",
    "\u559F": "wai2/wai6",
    "\u55A0": "zung2",
    "\u55A1": "wai4",
    "\u55A2": "saap3",
    "\u55A3": "heoi2",
    "\u55A4": "wong4",
    "\u55A5": "dok6",
    "\u55A6": "ngaam4/aam4",
    "\u55A7": "hyun1",
    "\u55A8": "loeng6",
    "\u55A9": "jyu6",
    "\u55AA": "song1/song3",
    "\u55AB": "hek3/jaak3/hat1/gat1",
    "\u55AC": "kiu4",
    "\u55AD": "jin6",
    "\u55AE": "daan1/sin6/sin4/sim4",
    "\u55AF": "pan3",
    "\u55B0": "caan1",
    "\u55B1": "lei1/lei2",
    "\u55B2": "jo1",
    "\u55B3": "zaa1/caa1",
    "\u55B4": "wai1/wi1",
    "\u55B5": "miu1",
    "\u55B6": "jing4",
    "\u55B7": "pan3/fan5/pan1",
    "\u55B8": "fu2",
    "\u55B9": "fui1/kwai4",
    "\u55BA": "hai2",
    "\u55BB": "jyu6",
    "\u55BC": "gip1/kip1/gep1/kep1",
    "\u55BD": "lau4/lau1",
    "\u55BE": "guk1",
    "\u55BF": "cou3",
    "\u55C0": "hok3",
    "\u55C1": "tai4",
    "\u55C2": "jiu4",
    "\u55C3": "hok3/haau1/haau3",
    "\u55C4": "aa2/ngaa2/saa3",
    "\u55C5": "cau3/hung3",
    "\u55C6": "coeng1/coeng3",
    "\u55C7": "sik1",
    "\u55C8": "jung1",
    "\u55C9": "sou3/seoi3",
    "\u55CA": "fung2/hung2/gung3",
    "\u55CB": "hip3",
    "\u55CC": "jik1/aai3/ngaai3",
    "\u55CD": "sok3",
    "\u55CE": "maa1/maa3/maa5",
    "\u55CF": "caa1",
    "\u55D0": "haai6/hoi6",
    "\u55D1": "haap3/hap6",
    "\u55D2": "taap3/daat3/daap1/taap1",
    "\u55D3": "song2/song1",
    "\u55D4": "can1/zan1/tin4",
    "\u55D5": "juk6",
    "\u55D6": "sau1",
    "\u55D7": "waat3/gut2/gwut2/gut6/gwut6/gwat1/gut4/gwut4",
    "\u55D8": "gai1",
    "\u55D9": "pong5/bong2/pong3/bang1",
    "\u55DA": "wu1",
    "\u55DB": "haam4/ham4/him3/him2/hip6/hip3/him1",
    "\u55DC": "si3",
    "\u55DD": "gaak3",
    "\u55DE": "zi1",
    "\u55DF": "ze1",
    "\u55E0": "lok6",
    "\u55E1": "jung1",
    "\u55E2": "wat1",
    "\u55E3": "zi6",
    "\u55E4": "ci1",
    "\u55E5": "hou4",
    "\u55E6": "so1/sok3",
    "\u55E7": "gaa1.leon4",
    "\u55E8": "hoi1/hei1/haai1",
    "\u55E9": "so2",
    "\u55EA": "ceon4",
    "\u55EB": "zip3/nip6/lip6",
    "\u55EC": "ho4/ho2",
    "\u55ED": "zik6",
    "\u55EE": "saai3",
    "\u55EF": "ng6/m6/ng2/m2/ng5/m5",
    "\u55F0": "go2",
    "\u55F1": "naa4/laa4",
    "\u55F2": "de2/de4",
    "\u55F3": "oi2/ngoi2/aai1/ngaai1",
    "\u55F4": "goeng1",
    "\u55F5": "tung1",
    "\u55F6": "bat1",
    "\u55F7": "ngou4/ou4",
    "\u55F8": "ngou4/ou4",
    "\u55F9": "lin4",
    "\u55FA": "ceoi1",
    "\u55FB": "ze1",
    "\u55FC": "mok6",
    "\u55FD": "sau3/sok3",
    "\u55FE": "sau2/zuk6",
    "\u55FF": "taam2",
    "\u5600": "dik6/dik1",
    "\u5601": "ci1/cik1",
    "\u5602": "giu3",
    "\u5603": "cung1",
    "\u5604": "hiu1",
    "\u5605": "ge3/ge2/koi3",
    "\u5606": "taan3",
    "\u5607": "saam1",
    "\u5608": "cou4",
    "\u5609": "gaa1",
    "\u560A": "ngaai4/aai4",
    "\u560B": "haau1",
    "\u560C": "piu1/piu3",
    "\u560D": "lau4/lau1",
    "\u560E": "gaat3/gaa1",
    "\u560F": "gu2/gwu2/gaa2",
    "\u5610": "haau1/gaau1",
    "\u5611": "fu3/laa3/fu1",
    "\u5612": "wai3",
    "\u5613": "gwok3/gok3",
    "\u5614": "au2/ngau2/au1/ngau1/au3/ngau3/heoi1",
    "\u5615": "hin1",
    "\u5616": "zaak3/zik1",
    "\u5617": "soeng4",
    "\u5618": "heoi1/syu4",
    "\u5619": "po4",
    "\u561A": "dak1",
    "\u561B": "maa1/maa3/maa4",
    "\u561C": "mak1",
    "\u561D": "huk6",
    "\u561E": "laa3/laak3/laa1",
    "\u561F": "dou1",
    "\u5620": "gaat3/gaa1",
    "\u5621": "tong1",
    "\u5622": "je5",
    "\u5623": "bang1",
    "\u5624": "jing1",
    "\u5625": "saai1/saai4",
    "\u5626": "ziu3",
    "\u5627": "mat6",
    "\u5628": "siu3",
    "\u5629": "waa1/waa4",
    "\u562A": "maai5",
    "\u562B": "jin4",
    "\u562C": "caai3/zyut3",
    "\u562D": "paang4/baang4/paang1",
    "\u562E": "lou4",
    "\u562F": "siu3",
    "\u5630": "gei1",
    "\u5631": "zuk1",
    "\u5632": "zaau1",
    "\u5633": "wai2/kwaai3",
    "\u5634": "zeoi2",
    "\u5635": "hiu1",
    "\u5636": "sai1/si1",
    "\u5637": "hou4",
    "\u5638": "fu2/mou5",
    "\u5639": "liu4",
    "\u563A": "kiu4",
    "\u563B": "hei1",
    "\u563C": "cuk1",
    "\u563D": "taan1/cin2/zin2",
    "\u563E": "daam6",
    "\u563F": "hei1/mak6",
    "\u5640": "seon3",
    "\u5641": "ok3/ngok3/wu3",
    "\u5642": "zyun2",
    "\u5643": "bo3",
    "\u5644": "hek3",
    "\u5645": "fai1",
    "\u5646": "cam2/caam2/zam2/cam3",
    "\u5647": "cong4/zong6",
    "\u5648": "zuk1",
    "\u5649": "gam2/gum2/daam6",
    "\u564A": "jyut6",
    "\u564B": "teon1",
    "\u564C": "zang1/cang1",
    "\u564D": "ziu6/ziu3/ziu1/zau1",
    "\u564E": "jit3",
    "\u564F": "kap1/ngap1/ap1",
    "\u5650": "hei3",
    "\u5651": "hou4",
    "\u5652": "leon1",
    "\u5653": "heoi1/syu4",
    "\u5654": "dang1/dang6",
    "\u5655": "fai1",
    "\u5656": "jam4",
    "\u5657": "pok3",
    "\u5658": "kyut3",
    "\u5659": "kam4",
    "\u565A": "cam4/jing1.cam4",
    "\u565B": "ngit6/it6",
    "\u565C": "lou1",
    "\u565D": "si1",
    "\u565E": "jim2/jim1",
    "\u565F": "jing3",
    "\u5660": "daat6/daat3",
    "\u5661": "zim1",
    "\u5662": "jyu2/o1/ngo1/ou3/ngou3",
    "\u5663": "zau3/doek3",
    "\u5664": "gam3/kam1",
    "\u5665": "nung4/lung4",
    "\u5666": "jyut6/wai3",
    "\u5667": "haai3",
    "\u5668": "hei3",
    "\u5669": "ngok6/ok6",
    "\u566A": "cou3",
    "\u566B": "ji1",
    "\u566C": "sai6",
    "\u566D": "giu3/kiu3",
    "\u566E": "jyun3",
    "\u566F": "oi2/ngoi2/aai1/ngaai1",
    "\u5670": "jung1",
    "\u5671": "koek6/koek3/hoe4/coek3",
    "\u5672": "faai3",
    "\u5673": "jyu5",
    "\u5674": "pan3/fan5/pan1",
    "\u5675": "dou6",
    "\u5676": "gaa1/gaat3/got3",
    "\u5677": "hm1",
    "\u5678": "deon1",
    "\u5679": "dong1",
    "\u567A": "san1",
    "\u567B": "sak1",
    "\u567C": "pik1/pek1/pet1/pet6",
    "\u567D": "pei2",
    "\u567E": "jam1",
    "\u567F": "zeoi2",
    "\u5680": "ning4/ling4",
    "\u5681": "dik6",
    "\u5682": "laam6/laam4",
    "\u5683": "daap6/taap3",
    "\u5684": "o2/ngo2/wok6/ho1",
    "\u5685": "jyu4",
    "\u5686": "hou1",
    "\u5687": "haak3/haak1/haa1",
    "\u5688": "jip3/aat3/ngaat3",
    "\u5689": "deoi3",
    "\u568A": "be6/bei6",
    "\u568B": "cau4",
    "\u568C": "zai6",
    "\u568D": "zeon3",
    "\u568E": "hou4",
    "\u568F": "tai3",
    "\u5690": "soeng4",
    "\u5691": "fan1",
    "\u5692": "mo1",
    "\u5693": "caat3",
    "\u5694": "dai3",
    "\u5695": "lou1",
    "\u5696": "wai3",
    "\u5697": "bok3",
    "\u5698": "jau1",
    "\u5699": "ngit6/it6/jit6/ngaat6/aat6",
    "\u569A": "ngan4/an4",
    "\u569B": "huk1",
    "\u569C": "mak6/maa1/mak1",
    "\u569D": "gwang1",
    "\u569E": "zit3",
    "\u569F": "lai4/lei4/lai2",
    "\u56A0": "lau4",
    "\u56A1": "haai4",
    "\u56A2": "nong4/long4",
    "\u56A3": "hiu1",
    "\u56A4": "mo1",
    "\u56A5": "jin3",
    "\u56A6": "lik6/lik1",
    "\u56A7": "lou4",
    "\u56A8": "lung4",
    "\u56A9": "bok3",
    "\u56AA": "daam6",
    "\u56AB": "can3",
    "\u56AC": "pan4",
    "\u56AD": "pei2",
    "\u56AE": "hoeng3/hoeng2",
    "\u56AF": "ho1",
    "\u56B0": "jiu1",
    "\u56B1": "hei3",
    "\u56B2": "do2",
    "\u56B3": "guk1",
    "\u56B4": "jim4",
    "\u56B5": "caam4",
    "\u56B6": "jing1",
    "\u56B7": "joeng6/joeng5",
    "\u56B8": "dim2",
    "\u56B9": "laa3/laa4",
    "\u56BA": "daap6",
    "\u56BB": "hiu1",
    "\u56BC": "zoek3/ziu6/ziu3",
    "\u56BD": "zyut3",
    "\u56BE": "fun1",
    "\u56BF": "gau6",
    "\u56C0": "zyun2",
    "\u56C1": "zip3/nip6/lip6",
    "\u56C2": "hiu1",
    "\u56C3": "caap3",
    "\u56C4": "lei4",
    "\u56C5": "cin2/zin2",
    "\u56C6": "caai3",
    "\u56C7": "lai6",
    "\u56C8": "ngai6/ai6",
    "\u56C9": "lo1/lo4/lo3",
    "\u56CA": "nong4/long4/nong1/long1/nong2/long2",
    "\u56CB": "zaan3",
    "\u56CC": "sou1",
    "\u56CD": "hei2",
    "\u56CE": "zang6",
    "\u56CF": "gaan1",
    "\u56D0": "zaan3",
    "\u56D1": "zuk1",
    "\u56D2": "laan4",
    "\u56D3": "ngit6/it6/jit6/ngaat6/aat6",
    "\u56D4": "nong4/long4",
    "\u56D5": "hei3",
    "\u56D6": "lo1",
    "\u56D7": "wai4",
    "\u56D8": "wui4",
    "\u56D9": "jan1",
    "\u56DA": "cau4",
    "\u56DB": "sei3/si3",
    "\u56DC": "nan4/lan4",
    "\u56DD": "zai2/naam4/laam4",
    "\u56DE": "wui4/wui2",
    "\u56DF": "seon3/seon2",
    "\u56E0": "jan1",
    "\u56E1": "naam4/laam4",
    "\u56E2": "tyun4/tyun2",
    "\u56E3": "tyun4",
    "\u56E4": "deon6/tyun4",
    "\u56E5": "kong3",
    "\u56E6": "jyun1",
    "\u56E7": "gwing2",
    "\u56E8": "pin1",
    "\u56E9": "wan4",
    "\u56EA": "cung1",
    "\u56EB": "fat1",
    "\u56EC": "wui4",
    "\u56ED": "jyun4/jyun2",
    "\u56EE": "ngo4/o4/jau4",
    "\u56EF": "gwok3/gok3",
    "\u56F0": "kwan3",
    "\u56F1": "cung1/coeng1",
    "\u56F2": "tung1",
    "\u56F3": "tou4",
    "\u56F4": "wai4",
    "\u56F5": "leon4",
    "\u56F6": "gwok3/gok3",
    "\u56F7": "kwan1",
    "\u56F8": "jat6",
    "\u56F9": "ling4",
    "\u56FA": "gu3/gwu3",
    "\u56FB": "gwok3/gok3",
    "\u56FC": "toi1",
    "\u56FD": "gwok3/gok3",
    "\u56FE": "tou4",
    "\u56FF": "jau6",
    "\u5700": "gwok3/gok3",
    "\u5701": "ngan4/an4",
    "\u5702": "wan6",
    "\u5703": "pou2/bou2",
    "\u5704": "jyu5",
    "\u5705": "haam4",
    "\u5706": "jyun4/jyun2",
    "\u5707": "leon4",
    "\u5708": "hyun1/gyun6",
    "\u5709": "jyu5",
    "\u570A": "cing1",
    "\u570B": "gwok3/gok3",
    "\u570C": "cyun4/seoi4",
    "\u570D": "wai4",
    "\u570E": "jyun4",
    "\u570F": "hyun1",
    "\u5710": "ku1/kwu1",
    "\u5711": "pou2",
    "\u5712": "jyun4/jyun2",
    "\u5713": "jyun4/jyun2",
    "\u5714": "aap3/ngaap3",
    "\u5715": "syu1",
    "\u5716": "tou4",
    "\u5717": "tou4",
    "\u5718": "tyun4/tyun2",
    "\u5719": "loek6",
    "\u571A": "kui2/kwui2",
    "\u571B": "jik6",
    "\u571C": "jyun4/waan4",
    "\u571D": "lyun4",
    "\u571E": "lyun4",
    "\u571F": "tou2",
    "\u5720": "aat3/ngaat3/caak3",
    "\u5721": "tou2",
    "\u5722": "ting5",
    "\u5723": "sing3",
    "\u5724": "pok3",
    "\u5725": "luk6",
    "\u5726": "faai3",
    "\u5727": "zong1",
    "\u5728": "zoi6/zoi2",
    "\u5729": "wai4/jyu4/heoi1",
    "\u572A": "ngat6/at6/gat3",
    "\u572B": "ou3/ngou3",
    "\u572C": "wu1",
    "\u572D": "gwai1",
    "\u572E": "pei2",
    "\u572F": "ji4",
    "\u5730": "dei6/dei2/deng6",
    "\u5731": "cin1",
    "\u5732": "cin1",
    "\u5733": "zan3",
    "\u5734": "zoek3",
    "\u5735": "joeng6",
    "\u5736": "haap3",
    "\u5737": "haa6",
    "\u5738": "saan1",
    "\u5739": "kwong3/kong3",
    "\u573A": "coeng4/coeng2",
    "\u573B": "kei4/ngan4/an4",
    "\u573C": "nit6/lit6",
    "\u573D": "mut6",
    "\u573E": "saap3/kap1",
    "\u573F": "git3",
    "\u5740": "zi2",
    "\u5741": "zi2",
    "\u5742": "baan2/faan2",
    "\u5743": "hyun1",
    "\u5744": "jik6",
    "\u5745": "jam2",
    "\u5746": "mui4",
    "\u5747": "gwan1/kwan1/wan6/wan5",
    "\u5748": "haang1",
    "\u5749": "tyun4/nang4/lang4",
    "\u574A": "fong1/fong2/fong4",
    "\u574B": "fan6/fan5/ban6",
    "\u574C": "ban6",
    "\u574D": "taan1",
    "\u574E": "ham2/ham1/ham3",
    "\u574F": "waai6/waai2/pui1",
    "\u5750": "zo6/co5",
    "\u5751": "haang1",
    "\u5752": "bei6/bai6",
    "\u5753": "zing6",
    "\u5754": "dei6",
    "\u5755": "ging1",
    "\u5756": "gei6",
    "\u5757": "faai3",
    "\u5758": "ci4",
    "\u5759": "ging1",
    "\u575A": "gin1",
    "\u575B": "taan4/taam4",
    "\u575C": "lek6/lik6",
    "\u575D": "baa3",
    "\u575E": "wu2/ou3/ngou3",
    "\u575F": "fan4",
    "\u5760": "zeoi6",
    "\u5761": "po1/bo1",
    "\u5762": "bun3",
    "\u5763": "tong4",
    "\u5764": "kwan1",
    "\u5765": "ceoi1",
    "\u5766": "taan2",
    "\u5767": "zek3",
    "\u5768": "to4",
    "\u5769": "ham1/kim4",
    "\u576A": "ping4",
    "\u576B": "dim3",
    "\u576C": "gwaa3",
    "\u576D": "nai4/lai4/nai2/lai2",
    "\u576E": "toi4",
    "\u576F": "pui1",
    "\u5770": "gwing1",
    "\u5771": "joeng2/joeng5",
    "\u5772": "fat6",
    "\u5773": "aau3/ngaau3/aau1/ngaau1",
    "\u5774": "luk6",
    "\u5775": "jau1",
    "\u5776": "muk6",
    "\u5777": "ho2/ho1",
    "\u5778": "gau3",
    "\u5779": "jyut6",
    "\u577A": "paat6/baat6",
    "\u577B": "ci4/dai2/zi2",
    "\u577C": "caak3",
    "\u577D": "ling4",
    "\u577E": "cyu5",
    "\u577F": "fu6",
    "\u5780": "fu1",
    "\u5781": "zi6",
    "\u5782": "seoi4",
    "\u5783": "laap6/laai1/laa1",
    "\u5784": "lung5",
    "\u5785": "lung5",
    "\u5786": "lou4",
    "\u5787": "aau3/ngaau3/aau1/ngaau1",
    "\u5788": "doi6",
    "\u5789": "paau4",
    "\u578A": "man4",
    "\u578B": "jing4",
    "\u578C": "dung6/tung4",
    "\u578D": "gei6/gei3",
    "\u578E": "haak6",
    "\u578F": "leot6",
    "\u5790": "ci4",
    "\u5791": "ci2",
    "\u5792": "leoi5/leoi6/leoi4/leot6",
    "\u5793": "goi1",
    "\u5794": "jan1",
    "\u5795": "hau6/hau5",
    "\u5796": "deoi1",
    "\u5797": "ziu6",
    "\u5798": "baak6",
    "\u5799": "gwong1/gong1",
    "\u579A": "jiu4",
    "\u579B": "do2",
    "\u579C": "do2",
    "\u579D": "gwai2",
    "\u579E": "caa4",
    "\u579F": "joeng4",
    "\u57A0": "ngan4/an4",
    "\u57A1": "fat6",
    "\u57A2": "gau3/hau4",
    "\u57A3": "wun4",
    "\u57A4": "dit6",
    "\u57A5": "hip3",
    "\u57A6": "han2",
    "\u57A7": "hoeng2",
    "\u57A8": "sau2",
    "\u57A9": "ok3/ngok3",
    "\u57AA": "bing6",
    "\u57AB": "dim3/din3/zin3/zin2/din2/din6/dip6",
    "\u57AC": "hung4",
    "\u57AD": "aa3/ngaa3",
    "\u57AE": "kwaa1",
    "\u57AF": "daat3/daat6",
    "\u57B0": "lung6",
    "\u57B1": "dong3/dong2",
    "\u57B2": "hoi2",
    "\u57B3": "hang4",
    "\u57B4": "nou5/lou5",
    "\u57B5": "am2/ngam2",
    "\u57B6": "sing1",
    "\u57B7": "jin6",
    "\u57B8": "jyun6/wun2",
    "\u57B9": "bong1",
    "\u57BA": "pau4/fu1",
    "\u57BB": "bui3/baa3",
    "\u57BC": "jik6",
    "\u57BD": "ngan6/an6",
    "\u57BE": "hon6",
    "\u57BF": "zeoi6",
    "\u57C0": "seoi4",
    "\u57C1": "cam4",
    "\u57C2": "gang2",
    "\u57C3": "oi1/ngoi1/aai1/ngaai1",
    "\u57C4": "bung6",
    "\u57C5": "fong4",
    "\u57C6": "kok3/gok3",
    "\u57C7": "jung2/cung1",
    "\u57C8": "seon3",
    "\u57C9": "gaap3",
    "\u57CA": "dei6/deng6",
    "\u57CB": "maai4",
    "\u57CC": "long6",
    "\u57CD": "gyun2",
    "\u57CE": "sing4/seng2/sing2/seng4",
    "\u57CF": "jin4/sin1/saan1",
    "\u57D0": "zam1",
    "\u57D1": "zit3",
    "\u57D2": "lyut3",
    "\u57D3": "lyut3",
    "\u57D4": "bou3/pou2",
    "\u57D5": "cing4",
    "\u57D6": "faa1",
    "\u57D7": "bou6/bou2",
    "\u57D8": "si4",
    "\u57D9": "hyun1/fan1",
    "\u57DA": "wo1",
    "\u57DB": "gwing1",
    "\u57DC": "je5",
    "\u57DD": "nim6/lim6/nap1/lap1",
    "\u57DE": "deng6",
    "\u57DF": "wik6",
    "\u57E0": "bou6/fau6/fau2",
    "\u57E1": "aa3/ngaa3",
    "\u57E2": "gyun3",
    "\u57E3": "seoi3",
    "\u57E4": "pei4/bei1/bei3/bai3",
    "\u57E5": "cing1",
    "\u57E6": "wun2",
    "\u57E7": "geoi6",
    "\u57E8": "leon4",
    "\u57E9": "zang1",
    "\u57EA": "hung1",
    "\u57EB": "cung2",
    "\u57EC": "dung1",
    "\u57ED": "dai6/doi6",
    "\u57EE": "taam3",
    "\u57EF": "am2/ngam2",
    "\u57F0": "coi3",
    "\u57F1": "cuk1",
    "\u57F2": "bung6/bong6/pung1",
    "\u57F3": "ham2/ham1/ham3",
    "\u57F4": "zik6",
    "\u57F5": "do2/do3",
    "\u57F6": "ngai6/ai6/sai3",
    "\u57F7": "zap1",
    "\u57F8": "jik6",
    "\u57F9": "pui4/pau2",
    "\u57FA": "gei1",
    "\u57FB": "zeon2/deoi1",
    "\u57FC": "kei4",
    "\u57FD": "sou3/sou2",
    "\u57FE": "zeoi6",
    "\u57FF": "nai4/lai4/baan6",
    "\u5800": "fat1/gwat6",
    "\u5801": "fo3/fo2",
    "\u5802": "tong4/tong2",
    "\u5803": "kwan1",
    "\u5804": "ngai6/ai6",
    "\u5805": "gin1",
    "\u5806": "deoi1",
    "\u5807": "gan2/kan4/gan6",
    "\u5808": "gong1",
    "\u5809": "juk6",
    "\u580A": "ok3/ngok3",
    "\u580B": "pang4/bang6/bang1",
    "\u580C": "gu3/gwu3",
    "\u580D": "tou3",
    "\u580E": "ling4",
    "\u580F": "fong4",
    "\u5810": "ngaai4/aai4",
    "\u5811": "cim3",
    "\u5812": "kwan1",
    "\u5813": "ngon6/on6",
    "\u5814": "sam1",
    "\u5815": "do6/fai1",
    "\u5816": "nou5/lou5",
    "\u5817": "dat6",
    "\u5818": "sing4",
    "\u5819": "jan1",
    "\u581A": "waan4",
    "\u581B": "pik1",
    "\u581C": "lin6",
    "\u581D": "wo1",
    "\u581E": "dip6",
    "\u581F": "zyun6",
    "\u5820": "hau6",
    "\u5821": "bou2/pou3",
    "\u5822": "bou2",
    "\u5823": "jyu4",
    "\u5824": "tai4",
    "\u5825": "mou4",
    "\u5826": "gaai1",
    "\u5827": "jyun4",
    "\u5828": "aat3/ngaat3/oi2/ngoi2",
    "\u5829": "gang2",
    "\u582A": "ham1",
    "\u582B": "zung1",
    "\u582C": "jyu4",
    "\u582D": "wong4",
    "\u582E": "ngok6/ok6",
    "\u582F": "jiu4",
    "\u5830": "jin2",
    "\u5831": "bou3",
    "\u5832": "zik1",
    "\u5833": "mei4",
    "\u5834": "coeng4/coeng2",
    "\u5835": "dou2/ze2",
    "\u5836": "to4",
    "\u5837": "jam3",
    "\u5838": "fung4",
    "\u5839": "zung3",
    "\u583A": "gaai3",
    "\u583B": "zeon1",
    "\u583C": "hang6",
    "\u583D": "gong1",
    "\u583E": "ceon1/ceon2/cyun2",
    "\u583F": "haam4/ham3/gaan2",
    "\u5840": "ping4",
    "\u5841": "leoi5",
    "\u5842": "hong4",
    "\u5843": "fong1",
    "\u5844": "ling4",
    "\u5845": "dyun6",
    "\u5846": "waan1",
    "\u5847": "syun1",
    "\u5848": "hei3/kei3/gei3",
    "\u5849": "zik6",
    "\u584A": "faai3",
    "\u584B": "jing4",
    "\u584C": "taap3/dap1",
    "\u584D": "sing4",
    "\u584E": "jung5",
    "\u584F": "hoi2",
    "\u5850": "sou3",
    "\u5851": "sou3/sok3",
    "\u5852": "si4",
    "\u5853": "mik6",
    "\u5854": "taap3/taap2",
    "\u5855": "jung2",
    "\u5856": "sing4",
    "\u5857": "tou4",
    "\u5858": "tong4",
    "\u5859": "kok3",
    "\u585A": "cung2",
    "\u585B": "leot6",
    "\u585C": "bung6",
    "\u585D": "bong6",
    "\u585E": "sak1/coi3",
    "\u585F": "zong3",
    "\u5860": "deoi1",
    "\u5861": "tin4",
    "\u5862": "wu2/ou3/ngou3",
    "\u5863": "zing6",
    "\u5864": "hyun1/fan1",
    "\u5865": "gaak3",
    "\u5866": "zan6",
    "\u5867": "aai3/ngaai3",
    "\u5868": "gung1",
    "\u5869": "jim4",
    "\u586A": "ham2",
    "\u586B": "tin4",
    "\u586C": "jyun4",
    "\u586D": "wan1",
    "\u586E": "ze6",
    "\u586F": "lau6",
    "\u5870": "hoi2",
    "\u5871": "long5",
    "\u5872": "coeng4",
    "\u5873": "bung6/pung1",
    "\u5874": "bang6/bang1",
    "\u5875": "can4",
    "\u5876": "luk6",
    "\u5877": "lou5",
    "\u5878": "au2/ngau2",
    "\u5879": "cim3",
    "\u587A": "mui4/mo6",
    "\u587B": "mok6",
    "\u587C": "zyun1",
    "\u587D": "song2",
    "\u587E": "suk6",
    "\u587F": "lau5/lau4",
    "\u5880": "ci4",
    "\u5881": "maan6",
    "\u5882": "biu1",
    "\u5883": "ging2",
    "\u5884": "cak1",
    "\u5885": "seoi6/seoi5",
    "\u5886": "dit6/dai3",
    "\u5887": "zoeng3",
    "\u5888": "ham3",
    "\u5889": "jung4",
    "\u588A": "dim3/din3/zin3/zin2/din2/din6/dip6",
    "\u588B": "cam2",
    "\u588C": "zek3",
    "\u588D": "hei3/kei3/gei3",
    "\u588E": "gwok3/gok3",
    "\u588F": "coeng2",
    "\u5890": "gan6/gan2",
    "\u5891": "dik1",
    "\u5892": "soeng1",
    "\u5893": "mou6",
    "\u5894": "ceoi4",
    "\u5895": "jin2",
    "\u5896": "taap3",
    "\u5897": "zang1",
    "\u5898": "kin4",
    "\u5899": "coeng4",
    "\u589A": "loeng4",
    "\u589B": "wai3",
    "\u589C": "zeoi6",
    "\u589D": "haau1",
    "\u589E": "zang1/cang4",
    "\u589F": "heoi1",
    "\u58A0": "sin6",
    "\u58A1": "sin6",
    "\u58A2": "baat6",
    "\u58A3": "pok3",
    "\u58A4": "faai3",
    "\u58A5": "dung2",
    "\u58A6": "faan4",
    "\u58A7": "kok3",
    "\u58A8": "mak6",
    "\u58A9": "deon1/dan1/dan2",
    "\u58AA": "deon1/dan1/dan2",
    "\u58AB": "deon1/zeon1/cyun4",
    "\u58AC": "dei6/deng6",
    "\u58AD": "sing6",
    "\u58AE": "do6/fai1",
    "\u58AF": "do6/fai1",
    "\u58B0": "taam4",
    "\u58B1": "dang3",
    "\u58B2": "mou4",
    "\u58B3": "fan4",
    "\u58B4": "wong4",
    "\u58B5": "taam4",
    "\u58B6": "daat3/daat6",
    "\u58B7": "jip6",
    "\u58B8": "zyu3",
    "\u58B9": "gaan1",
    "\u58BA": "ou3/ngou3",
    "\u58BB": "coeng4",
    "\u58BC": "gik1",
    "\u58BD": "hiu1",
    "\u58BE": "han2",
    "\u58BF": "jik6",
    "\u58C0": "pei4",
    "\u58C1": "bik1/bek3/bik3",
    "\u58C2": "din6",
    "\u58C3": "goeng1",
    "\u58C4": "je5",
    "\u58C5": "jung1/jung2/ung1/ngung1",
    "\u58C6": "bok3",
    "\u58C7": "taan4",
    "\u58C8": "lam5",
    "\u58C9": "geoi6",
    "\u58CA": "waai6",
    "\u58CB": "dong3/dong2",
    "\u58CC": "joeng6",
    "\u58CD": "cim3",
    "\u58CE": "hyun1/fan1",
    "\u58CF": "haam5",
    "\u58D0": "saai2",
    "\u58D1": "kok3",
    "\u58D2": "oi2/ngoi2",
    "\u58D3": "aat3/ngaat3",
    "\u58D4": "dou2",
    "\u58D5": "hou4",
    "\u58D6": "jyun4",
    "\u58D7": "zeon6",
    "\u58D8": "leoi5/leoi6/leoi4/leot6",
    "\u58D9": "kwong3/kong3",
    "\u58DA": "lou4",
    "\u58DB": "jim4/sim4/jam4",
    "\u58DC": "taam4",
    "\u58DD": "wai4/wai5/wai2",
    "\u58DE": "waai6/waai2",
    "\u58DF": "lung5",
    "\u58E0": "lung5",
    "\u58E1": "jeoi6",
    "\u58E2": "lek6/lik6",
    "\u58E3": "leon4",
    "\u58E4": "joeng6",
    "\u58E5": "cin4",
    "\u58E6": "hyun1",
    "\u58E7": "ngaam4/aam4",
    "\u58E8": "leoi4",
    "\u58E9": "baa3",
    "\u58EA": "waan1",
    "\u58EB": "si6/si2",
    "\u58EC": "jam4",
    "\u58ED": "si6",
    "\u58EE": "zong3/zong1",
    "\u58EF": "zong3/zong1",
    "\u58F0": "sing1/seng1",
    "\u58F1": "jat1",
    "\u58F2": "maai6",
    "\u58F3": "hok3",
    "\u58F4": "zyu3",
    "\u58F5": "zong3",
    "\u58F6": "wu4/wu2",
    "\u58F7": "wu4",
    "\u58F8": "kwan2",
    "\u58F9": "jat1/jik1",
    "\u58FA": "wu4/wu2",
    "\u58FB": "sai3",
    "\u58FC": "kwan2",
    "\u58FD": "sau6",
    "\u58FE": "mong5",
    "\u58FF": "cyun4",
    "\u5900": "sau6",
    "\u5901": "jat1",
    "\u5902": "zi2/zung1/pit3.pong4.jau6",
    "\u5903": "gu2/gwu2",
    "\u5904": "cyu5/cyu2/cyu3/syu2/syu3",
    "\u5905": "gong3",
    "\u5906": "fung1",
    "\u5907": "bei6",
    "\u5908": "zaai1",
    "\u5909": "bin3",
    "\u590A": "seoi1/pit3.soek3.jau6",
    "\u590B": "ceon1",
    "\u590C": "ling4",
    "\u590D": "fuk6/fuk1/fau6",
    "\u590E": "zo3",
    "\u590F": "haa6/gaa2",
    "\u5910": "hyun3",
    "\u5911": "sit3",
    "\u5912": "naau4/laau4/nou4/lou4",
    "\u5913": "haa6",
    "\u5914": "kwai4",
    "\u5915": "zik6/zik2",
    "\u5916": "ngoi6/oi6/ngoi2/oi2",
    "\u5917": "jyun3/jyun2",
    "\u5918": "maau5",
    "\u5919": "suk1",
    "\u591A": "do1",
    "\u591B": "do1",
    "\u591C": "je6/je2",
    "\u591D": "cing4/ceng4",
    "\u591E": "ngoi6/oi6",
    "\u591F": "gau3",
    "\u5920": "gau3",
    "\u5921": "hei3",
    "\u5922": "mung6/mung4",
    "\u5923": "mung6",
    "\u5924": "jan4",
    "\u5925": "fo2",
    "\u5926": "cam2",
    "\u5927": "daai6/daai1/daai2/taai3",
    "\u5928": "zak1",
    "\u5929": "tin1",
    "\u592A": "taai3/taai2",
    "\u592B": "fu1/fu4",
    "\u592C": "gwaai3/kyut3",
    "\u592D": "jiu1/jiu2",
    "\u592E": "joeng1",
    "\u592F": "haang1/ban6",
    "\u5930": "gou2",
    "\u5931": "sat1/jat6",
    "\u5932": "tou1",
    "\u5933": "taai3",
    "\u5934": "tau4/tau2",
    "\u5935": "jim5",
    "\u5936": "bei2",
    "\u5937": "ji4",
    "\u5938": "kwaa1",
    "\u5939": "gaap3/gaap2/gep6/gip6/gip2/gap3/gaak3/hip3",
    "\u593A": "dyut6",
    "\u593B": "ng4/m4",
    "\u593C": "kwong3/kong3",
    "\u593D": "wan5",
    "\u593E": "gaap3/gaap2/gep6/gip6/gip2/gap3/gaak3/hip3",
    "\u593F": "baa1",
    "\u5940": "ngan1/an1",
    "\u5941": "lim4",
    "\u5942": "wun6",
    "\u5943": "dai1",
    "\u5944": "jim2/jim1",
    "\u5945": "paau3",
    "\u5946": "gyun6",
    "\u5947": "kei4/gei1",
    "\u5948": "noi6/loi6",
    "\u5949": "fung6/fung2",
    "\u594A": "kit3/kwai4/hai5",
    "\u594B": "fan5",
    "\u594C": "dim2",
    "\u594D": "hyun3",
    "\u594E": "fui1/kwai1",
    "\u594F": "zau3/cau3",
    "\u5950": "wun6",
    "\u5951": "kai3/kit3/sit3",
    "\u5952": "hoi1",
    "\u5953": "zaa3/zaa6/ce1/se1/ci2/zaa1",
    "\u5954": "ban1/ban3",
    "\u5955": "jik6",
    "\u5956": "zoeng2",
    "\u5957": "tou3/tou2",
    "\u5958": "zong6/zong1",
    "\u5959": "bun2",
    "\u595A": "hai4",
    "\u595B": "kong3",
    "\u595C": "fei2",
    "\u595D": "diu1",
    "\u595E": "seon3",
    "\u595F": "bang1",
    "\u5960": "din6",
    "\u5961": "ngou6/ou6",
    "\u5962": "ce1/se1",
    "\u5963": "wang2",
    "\u5964": "haa5",
    "\u5965": "ou3/ngou3/juk1/ou2/ngou2",
    "\u5966": "mou6",
    "\u5967": "ou3/ngou3/juk1/ou2/ngou2",
    "\u5968": "zoeng2",
    "\u5969": "lim4",
    "\u596A": "dyut6",
    "\u596B": "wan1",
    "\u596C": "zoeng2",
    "\u596D": "sik1",
    "\u596E": "fan5",
    "\u596F": "kut3/kwut3",
    "\u5970": "bei6/bai3",
    "\u5971": "lyun4",
    "\u5972": "do2/ce2",
    "\u5973": "neoi5/leoi5/neoi4/leoi4/neoi2/leoi2/neoi6/leoi6/jyu5",
    "\u5974": "nou4/lou4",
    "\u5975": "ding2",
    "\u5976": "naai5/laai5/naai2/laai2/naai4/laai4/naai1/laai1",
    "\u5977": "cin1",
    "\u5978": "gaan1",
    "\u5979": "taa1",
    "\u597A": "gau2",
    "\u597B": "nyun4/lyun4",
    "\u597C": "caa3",
    "\u597D": "hou2/hou3",
    "\u597E": "sin1",
    "\u597F": "faan3",
    "\u5980": "gei2",
    "\u5981": "zoek3",
    "\u5982": "jyu4",
    "\u5983": "fei1/pui3",
    "\u5984": "mong5",
    "\u5985": "hung4",
    "\u5986": "zong1",
    "\u5987": "fu5",
    "\u5988": "maa1/maa4/maa2/maa5",
    "\u5989": "daam1",
    "\u598A": "jam6/jam4",
    "\u598B": "fu1",
    "\u598C": "zing6",
    "\u598D": "jin4",
    "\u598E": "hoi6",
    "\u598F": "man6",
    "\u5990": "zung1",
    "\u5991": "paa1",
    "\u5992": "dou3",
    "\u5993": "gei6",
    "\u5994": "haang1",
    "\u5995": "zung3",
    "\u5996": "jiu1/jiu2",
    "\u5997": "kam5/kam2",
    "\u5998": "wan4",
    "\u5999": "miu6",
    "\u599A": "fau2",
    "\u599B": "ci1",
    "\u599C": "jyut3",
    "\u599D": "zong1",
    "\u599E": "nau2/lau2",
    "\u599F": "aan3/ngaan3",
    "\u59A0": "naap6/laap6",
    "\u59A1": "jan1",
    "\u59A2": "fan4",
    "\u59A3": "bei2",
    "\u59A4": "jyu4",
    "\u59A5": "to5",
    "\u59A6": "fung1",
    "\u59A7": "wun6",
    "\u59A8": "fong4",
    "\u59A9": "mou5/mou4",
    "\u59AA": "jyu3/jyu2",
    "\u59AB": "gwai1",
    "\u59AC": "dou3",
    "\u59AD": "bat6",
    "\u59AE": "nei4/lei4",
    "\u59AF": "zuk6/cau1",
    "\u59B0": "zoek3",
    "\u59B1": "ziu1",
    "\u59B2": "daat3/taan2",
    "\u59B3": "naai5/laai5/naai4/laai4/nei5/lei5",
    "\u59B4": "jyun2",
    "\u59B5": "tau2",
    "\u59B6": "jin4",
    "\u59B7": "zat6",
    "\u59B8": "o2/ngo2/o1/ngo1",
    "\u59B9": "mui6/mui2/mui4/mui1",
    "\u59BA": "mut6",
    "\u59BB": "cai1/cai3",
    "\u59BC": "bat6",
    "\u59BD": "san1",
    "\u59BE": "cip3",
    "\u59BF": "aa3/ngaa3",
    "\u59C0": "wo4",
    "\u59C1": "heoi2/heoi1",
    "\u59C2": "fat6",
    "\u59C3": "zing1",
    "\u59C4": "man4",
    "\u59C5": "bun3/pun3",
    "\u59C6": "mou5",
    "\u59C7": "fu1",
    "\u59C8": "ling4",
    "\u59C9": "zi2/ze2",
    "\u59CA": "zi2/ze2",
    "\u59CB": "ci2",
    "\u59CC": "jim5",
    "\u59CD": "saan1",
    "\u59CE": "ong1/ngong1",
    "\u59CF": "maan4",
    "\u59D0": "ze2/ze1/ze4",
    "\u59D1": "gu1/gwu1",
    "\u59D2": "ci5",
    "\u59D3": "sing3/seng3",
    "\u59D4": "wai2/wai1",
    "\u59D5": "zi1",
    "\u59D6": "geoi6",
    "\u59D7": "saan1",
    "\u59D8": "ping1",
    "\u59D9": "jam6/jam4",
    "\u59DA": "jiu4",
    "\u59DB": "dung6",
    "\u59DC": "goeng1",
    "\u59DD": "syu1/zyu1",
    "\u59DE": "gat1",
    "\u59DF": "goi1",
    "\u59E0": "hoeng3",
    "\u59E1": "waat6",
    "\u59E2": "gyun1",
    "\u59E3": "gaau2/haau4",
    "\u59E4": "gau3",
    "\u59E5": "mou5/lou5",
    "\u59E6": "gaan1",
    "\u59E7": "gaan1",
    "\u59E8": "ji4/ji1",
    "\u59E9": "nin6/lin6",
    "\u59EA": "zat6/zat2",
    "\u59EB": "can2",
    "\u59EC": "gei1",
    "\u59ED": "him3",
    "\u59EE": "hang4",
    "\u59EF": "gwong1/gong1",
    "\u59F0": "gwan1",
    "\u59F1": "kwaa1",
    "\u59F2": "aan3/ngaan3",
    "\u59F3": "ming5",
    "\u59F4": "lit6",
    "\u59F5": "bui6",
    "\u59F6": "ap1/ngap1",
    "\u59F7": "jau6",
    "\u59F8": "jin4",
    "\u59F9": "caa3",
    "\u59FA": "san1/sin2",
    "\u59FB": "jan1",
    "\u59FC": "ci2/si4",
    "\u59FD": "gwai2",
    "\u59FE": "cyun4",
    "\u59FF": "zi1",
    "\u5A00": "sung1",
    "\u5A01": "wai1",
    "\u5A02": "hung4",
    "\u5A03": "waa1",
    "\u5A04": "lau4",
    "\u5A05": "aa3/ngaa3",
    "\u5A06": "jiu2/jiu4",
    "\u5A07": "giu1",
    "\u5A08": "lyun2/lyun5",
    "\u5A09": "ping1",
    "\u5A0A": "jin6",
    "\u5A0B": "saau3",
    "\u5A0C": "lei5",
    "\u5A0D": "sing4",
    "\u5A0E": "hit3",
    "\u5A0F": "mong4",
    "\u5A10": "fu1",
    "\u5A11": "so1",
    "\u5A12": "mou5/mui4",
    "\u5A13": "mei5",
    "\u5A14": "hak1",
    "\u5A15": "cuk1",
    "\u5A16": "cok3/coek3/cuk1",
    "\u5A17": "ting5",
    "\u5A18": "noeng4/loeng4/noeng2/loeng2",
    "\u5A19": "jing4",
    "\u5A1A": "naam4/laam4",
    "\u5A1B": "jyu4",
    "\u5A1C": "no5/lo5/no4/lo4/naa4/laa4",
    "\u5A1D": "pau1",
    "\u5A1E": "neoi5/leoi5",
    "\u5A1F": "gyun1",
    "\u5A20": "san1/zan3",
    "\u5A21": "zi3",
    "\u5A22": "ham4",
    "\u5A23": "tai5/dai6",
    "\u5A24": "zong1",
    "\u5A25": "ngo4/o4",
    "\u5A26": "pan4",
    "\u5A27": "teoi3",
    "\u5A28": "haan6",
    "\u5A29": "min5/maan5",
    "\u5A2A": "ng4/m4",
    "\u5A2B": "jin4",
    "\u5A2C": "mou5/mou4",
    "\u5A2D": "hei1/oi1/ngoi1/aai1/ngaai1",
    "\u5A2E": "jin4",
    "\u5A2F": "jyu4",
    "\u5A30": "ci5",
    "\u5A31": "jyu4",
    "\u5A32": "wo1",
    "\u5A33": "lei6",
    "\u5A34": "haan4",
    "\u5A35": "zyu1/zeoi1",
    "\u5A36": "ceoi2/cou2/ceoi3",
    "\u5A37": "zeoi3",
    "\u5A38": "hei1",
    "\u5A39": "jin4",
    "\u5A3A": "to3",
    "\u5A3B": "dung1",
    "\u5A3C": "coeng1",
    "\u5A3D": "luk6",
    "\u5A3E": "ngaai6/aai6",
    "\u5A3F": "o2/ngo2/o1/ngo1",
    "\u5A40": "o2/ngo2/o1/ngo1",
    "\u5A41": "lau4",
    "\u5A42": "min4",
    "\u5A43": "cung4",
    "\u5A44": "pau3",
    "\u5A45": "guk1",
    "\u5A46": "po4/po1/po2",
    "\u5A47": "coi2",
    "\u5A48": "ling4",
    "\u5A49": "jyun2",
    "\u5A4A": "biu2",
    "\u5A4B": "haau1",
    "\u5A4C": "suk6",
    "\u5A4D": "kei2",
    "\u5A4E": "fai1",
    "\u5A4F": "faan3",
    "\u5A50": "wo2/o2/ngo2/o1/ngo1",
    "\u5A51": "wo2",
    "\u5A52": "taam4",
    "\u5A53": "fei1/fei4",
    "\u5A54": "fei1",
    "\u5A55": "zit3",
    "\u5A56": "tim1",
    "\u5A57": "ngai4/ai4",
    "\u5A58": "kyun4/gyun3",
    "\u5A59": "zing6",
    "\u5A5A": "fan1",
    "\u5A5B": "ging1",
    "\u5A5C": "haan1",
    "\u5A5D": "din6",
    "\u5A5E": "hang6",
    "\u5A5F": "wu6",
    "\u5A60": "wun1/waat3",
    "\u5A61": "loi4",
    "\u5A62": "pei5",
    "\u5A63": "jan1",
    "\u5A64": "zau1",
    "\u5A65": "coek3",
    "\u5A66": "fu5",
    "\u5A67": "zing6",
    "\u5A68": "leon4",
    "\u5A69": "ngon6/on6",
    "\u5A6A": "laam4",
    "\u5A6B": "gwan1",
    "\u5A6C": "jam4",
    "\u5A6D": "aa3/ngaa3",
    "\u5A6E": "geoi1",
    "\u5A6F": "lai6",
    "\u5A70": "din2",
    "\u5A71": "jin4",
    "\u5A72": "waa6",
    "\u5A73": "waak6",
    "\u5A74": "jing1",
    "\u5A75": "sim4",
    "\u5A76": "sam2",
    "\u5A77": "ting4/ting2",
    "\u5A78": "dong6",
    "\u5A79": "jiu2",
    "\u5A7A": "mou6",
    "\u5A7B": "naam6/laam6",
    "\u5A7C": "joek6/coek3",
    "\u5A7D": "gaa2",
    "\u5A7E": "jyu4/tau1",
    "\u5A7F": "sai3/sai2",
    "\u5A80": "jyu6",
    "\u5A81": "wai4",
    "\u5A82": "dai3",
    "\u5A83": "jau4",
    "\u5A84": "mei5",
    "\u5A85": "daam1",
    "\u5A86": "jyun5",
    "\u5A87": "can1",
    "\u5A88": "fai1",
    "\u5A89": "ak1/ngak1",
    "\u5A8A": "zin2",
    "\u5A8B": "ceon1",
    "\u5A8C": "maau4",
    "\u5A8D": "fu5",
    "\u5A8E": "ze2",
    "\u5A8F": "dyun1",
    "\u5A90": "hei1",
    "\u5A91": "zung6",
    "\u5A92": "mui4/mui2",
    "\u5A93": "wong4",
    "\u5A94": "min4",
    "\u5A95": "am1/ngam1",
    "\u5A96": "jing1",
    "\u5A97": "hyun1",
    "\u5A98": "gaai1",
    "\u5A99": "wai1",
    "\u5A9A": "mei6/mei4",
    "\u5A9B": "jyun6/jyun4/wun4",
    "\u5A9C": "zing1",
    "\u5A9D": "cau1",
    "\u5A9E": "tai4/tai5",
    "\u5A9F": "sit3",
    "\u5AA0": "to5/do6",
    "\u5AA1": "lin6",
    "\u5AA2": "mou6",
    "\u5AA3": "gam1",
    "\u5AA4": "si1",
    "\u5AA5": "pin1",
    "\u5AA6": "wai6",
    "\u5AA7": "wo1",
    "\u5AA8": "cuk1",
    "\u5AA9": "wu4",
    "\u5AAA": "ou2/ngou2",
    "\u5AAB": "zit3",
    "\u5AAC": "bou2",
    "\u5AAD": "seoi1",
    "\u5AAE": "jyu4/tau1",
    "\u5AAF": "gwai1",
    "\u5AB0": "co4",
    "\u5AB1": "jiu4",
    "\u5AB2": "pei3/bei2",
    "\u5AB3": "sik1",
    "\u5AB4": "jyun4",
    "\u5AB5": "jing6",
    "\u5AB6": "jung4",
    "\u5AB7": "juk6",
    "\u5AB8": "ci1",
    "\u5AB9": "lau4",
    "\u5ABA": "mei5",
    "\u5ABB": "pun4",
    "\u5ABC": "ou2/ngou2",
    "\u5ABD": "maa1/maa4/maa2/maa5",
    "\u5ABE": "gau3/kau3",
    "\u5ABF": "gwai2/kwai5/kwai3",
    "\u5AC0": "ceon4",
    "\u5AC1": "gaa3",
    "\u5AC2": "sou2",
    "\u5AC3": "zan1",
    "\u5AC4": "jyun4",
    "\u5AC5": "ze1",
    "\u5AC6": "jung4",
    "\u5AC7": "ming4",
    "\u5AC8": "jing1",
    "\u5AC9": "zat6",
    "\u5ACA": "sou3",
    "\u5ACB": "niu1/liu1/niu5/liu5",
    "\u5ACC": "jim4",
    "\u5ACD": "tou1",
    "\u5ACE": "pong4",
    "\u5ACF": "long4",
    "\u5AD0": "nou5/lou5",
    "\u5AD1": "biu3",
    "\u5AD2": "oi3/ngoi3/oi2/ngoi2",
    "\u5AD3": "pei3",
    "\u5AD4": "pan4/ban3",
    "\u5AD5": "ai3/ngai3/ji3",
    "\u5AD6": "piu4/piu1/piu3",
    "\u5AD7": "jyu3/jyu2",
    "\u5AD8": "leoi4",
    "\u5AD9": "syun4",
    "\u5ADA": "maan6",
    "\u5ADB": "ji1",
    "\u5ADC": "zoeng1",
    "\u5ADD": "hong1",
    "\u5ADE": "sung4",
    "\u5ADF": "nik1/lik1",
    "\u5AE0": "lei4",
    "\u5AE1": "dik1",
    "\u5AE2": "kwai1",
    "\u5AE3": "jin1",
    "\u5AE4": "gan2",
    "\u5AE5": "zyun1",
    "\u5AE6": "soeng4",
    "\u5AE7": "zaak3",
    "\u5AE8": "hon1",
    "\u5AE9": "nyun6/lyun6",
    "\u5AEA": "lou6",
    "\u5AEB": "mou4",
    "\u5AEC": "ze1",
    "\u5AED": "wu6",
    "\u5AEE": "wu6",
    "\u5AEF": "ngou6/ou6",
    "\u5AF0": "nyun6/lyun6",
    "\u5AF1": "coeng4",
    "\u5AF2": "maa4",
    "\u5AF3": "pit3",
    "\u5AF4": "gu1/gwu1",
    "\u5AF5": "mou5/mou4",
    "\u5AF6": "ciu4/ziu1",
    "\u5AF7": "to5",
    "\u5AF8": "zin2",
    "\u5AF9": "maau4",
    "\u5AFA": "haan4",
    "\u5AFB": "haan4",
    "\u5AFC": "aat3/ngaat3",
    "\u5AFD": "liu4",
    "\u5AFE": "lin4",
    "\u5AFF": "waak6",
    "\u5B00": "gwai1",
    "\u5B01": "dang1",
    "\u5B02": "zik1",
    "\u5B03": "seoi1",
    "\u5B04": "jat1",
    "\u5B05": "waa6",
    "\u5B06": "jap1",
    "\u5B07": "wui6",
    "\u5B08": "jiu2/jiu4",
    "\u5B09": "hei1",
    "\u5B0A": "jin2",
    "\u5B0B": "sim4",
    "\u5B0C": "giu1",
    "\u5B0D": "mei5",
    "\u5B0E": "faan3",
    "\u5B0F": "faan1",
    "\u5B10": "cim1",
    "\u5B11": "ji3",
    "\u5B12": "wai3",
    "\u5B13": "giu3",
    "\u5B14": "faan3",
    "\u5B15": "sik1",
    "\u5B16": "pei3",
    "\u5B17": "sin6",
    "\u5B18": "seoi6",
    "\u5B19": "coeng4",
    "\u5B1A": "lim5",
    "\u5B1B": "waan4/king4/hyun1",
    "\u5B1C": "jam1",
    "\u5B1D": "niu5/liu5",
    "\u5B1E": "dung2",
    "\u5B1F": "ji6",
    "\u5B20": "caam2",
    "\u5B21": "oi3/ngoi3/oi2/ngoi2",
    "\u5B22": "noeng4/loeng4",
    "\u5B23": "ning4/ling4",
    "\u5B24": "maa1/maa4",
    "\u5B25": "tiu5/tiu4",
    "\u5B26": "cau4",
    "\u5B27": "zeon6",
    "\u5B28": "ci4",
    "\u5B29": "jyu4",
    "\u5B2A": "pan4/ban3",
    "\u5B2B": "wing4",
    "\u5B2C": "jyu4",
    "\u5B2D": "naai5/laai5/naai4/laai4",
    "\u5B2E": "jim1/jim3",
    "\u5B2F": "toi4",
    "\u5B30": "jing1",
    "\u5B31": "cim3",
    "\u5B32": "niu5/liu5/nau1/lau1",
    "\u5B33": "wok6",
    "\u5B34": "jing4",
    "\u5B35": "min4",
    "\u5B36": "bei6",
    "\u5B37": "maa1/maa4",
    "\u5B38": "sam2",
    "\u5B39": "hing1",
    "\u5B3A": "nik1/lik1",
    "\u5B3B": "duk6",
    "\u5B3C": "lau5",
    "\u5B3D": "bei6",
    "\u5B3E": "laan5",
    "\u5B3F": "jin2/jin3",
    "\u5B40": "soeng1",
    "\u5B41": "ling4",
    "\u5B42": "giu2",
    "\u5B43": "noeng4/loeng4",
    "\u5B44": "laan5",
    "\u5B45": "cim1",
    "\u5B46": "jing1",
    "\u5B47": "soeng1",
    "\u5B48": "wai3",
    "\u5B49": "kyun4",
    "\u5B4A": "mei5",
    "\u5B4B": "lei4",
    "\u5B4C": "lyun2/lyun5",
    "\u5B4D": "jim4",
    "\u5B4E": "zuk1",
    "\u5B4F": "laan5",
    "\u5B50": "zi2",
    "\u5B51": "kit3",
    "\u5B52": "kyut3",
    "\u5B53": "kyut3",
    "\u5B54": "hung2",
    "\u5B55": "jan6",
    "\u5B56": "zi1/maa1",
    "\u5B57": "zi6/zi2",
    "\u5B58": "cyun4",
    "\u5B59": "syun1/seon3",
    "\u5B5A": "fu1",
    "\u5B5B": "bui6/but6",
    "\u5B5C": "zi1",
    "\u5B5D": "haau3",
    "\u5B5E": "seon3",
    "\u5B5F": "maang6/maang2",
    "\u5B60": "zi6",
    "\u5B61": "toi1",
    "\u5B62": "baau1",
    "\u5B63": "gwai3",
    "\u5B64": "gu1/gwu1",
    "\u5B65": "nou4/lou4",
    "\u5B66": "hok6/hok2",
    "\u5B67": "jau3",
    "\u5B68": "zyun2",
    "\u5B69": "haai4/hoi4",
    "\u5B6A": "lyun4",
    "\u5B6B": "syun1/seon3",
    "\u5B6C": "bou2/naau1/laau1/jai5",
    "\u5B6D": "me1",
    "\u5B6E": "cung4",
    "\u5B6F": "haan1",
    "\u5B70": "suk6",
    "\u5B71": "saan4/caan3",
    "\u5B72": "aa1/ngaa1",
    "\u5B73": "zi1/zi3",
    "\u5B74": "ji5",
    "\u5B75": "fu1",
    "\u5B76": "zi1/zi3",
    "\u5B77": "lei4",
    "\u5B78": "hok6/hok2",
    "\u5B79": "maak3",
    "\u5B7A": "jyu6/jyu4",
    "\u5B7B": "laai1",
    "\u5B7C": "jit6/jip6",
    "\u5B7D": "jit6/jip6",
    "\u5B7E": "jing1",
    "\u5B7F": "lyun4",
    "\u5B80": "min4/lam1.pung4.tau2",
    "\u5B81": "ning4/ling4/ning6/ling6/cyu5",
    "\u5B82": "jung2",
    "\u5B83": "taa1/to1",
    "\u5B84": "gwai2",
    "\u5B85": "zaak6/zaak2",
    "\u5B86": "kung4",
    "\u5B87": "jyu5",
    "\u5B88": "sau2/sau3",
    "\u5B89": "on1/ngon1",
    "\u5B8A": "dat6",
    "\u5B8B": "sung3",
    "\u5B8C": "jyun4",
    "\u5B8D": "juk6",
    "\u5B8E": "jiu2/jiu3",
    "\u5B8F": "wang4",
    "\u5B90": "ji4",
    "\u5B91": "jing2",
    "\u5B92": "zeon1",
    "\u5B93": "mat6/fuk6",
    "\u5B94": "zyu2",
    "\u5B95": "dong6",
    "\u5B96": "wang4",
    "\u5B97": "zung1",
    "\u5B98": "gun1/gwun1",
    "\u5B99": "zau6",
    "\u5B9A": "ding6/ding2/deng6/deng2",
    "\u5B9B": "jyun2/jyun1",
    "\u5B9C": "ji4/ji2",
    "\u5B9D": "bou2",
    "\u5B9E": "sat6",
    "\u5B9F": "sat6",
    "\u5BA0": "cung2",
    "\u5BA1": "sam2",
    "\u5BA2": "haak3/haak2",
    "\u5BA3": "syun1",
    "\u5BA4": "sat1",
    "\u5BA5": "jau6",
    "\u5BA6": "waan6",
    "\u5BA7": "ji4",
    "\u5BA8": "tiu2",
    "\u5BA9": "si2",
    "\u5BAA": "hin3",
    "\u5BAB": "gung1",
    "\u5BAC": "sing4",
    "\u5BAD": "kwan4",
    "\u5BAE": "gung1",
    "\u5BAF": "haau1",
    "\u5BB0": "zoi2",
    "\u5BB1": "zaa6",
    "\u5BB2": "bou2",
    "\u5BB3": "hoi6/hot3",
    "\u5BB4": "jin3",
    "\u5BB5": "siu1",
    "\u5BB6": "gaa1/gu1/gwu1/gaa3",
    "\u5BB7": "sam2",
    "\u5BB8": "san4",
    "\u5BB9": "jung4",
    "\u5BBA": "fong2",
    "\u5BBB": "mat6",
    "\u5BBC": "kau3",
    "\u5BBD": "fun1",
    "\u5BBE": "ban1/ban3",
    "\u5BBF": "suk1/sau3",
    "\u5BC0": "coi2/coi3",
    "\u5BC1": "zaam2/zit6",
    "\u5BC2": "zik6",
    "\u5BC3": "jyun1",
    "\u5BC4": "gei3",
    "\u5BC5": "jan4",
    "\u5BC6": "mat6",
    "\u5BC7": "kau3",
    "\u5BC8": "cing1",
    "\u5BC9": "hok6",
    "\u5BCA": "zing1",
    "\u5BCB": "gin6",
    "\u5BCC": "fu3",
    "\u5BCD": "ning4/ling4",
    "\u5BCE": "bing3/bing2",
    "\u5BCF": "jyun4",
    "\u5BD0": "mei6",
    "\u5BD1": "cam2",
    "\u5BD2": "hon4",
    "\u5BD3": "jyu6",
    "\u5BD4": "sat6",
    "\u5BD5": "ning4/ling4/ning6/ling6",
    "\u5BD6": "zam3",
    "\u5BD7": "ning4/ling4/ning6/ling6",
    "\u5BD8": "tin4/zi3",
    "\u5BD9": "jyu5",
    "\u5BDA": "bou2",
    "\u5BDB": "fun1",
    "\u5BDC": "ning4/ling4",
    "\u5BDD": "cam2",
    "\u5BDE": "mok6",
    "\u5BDF": "caat3",
    "\u5BE0": "geoi6/lau4",
    "\u5BE1": "gwaa2",
    "\u5BE2": "cam2",
    "\u5BE3": "fat1",
    "\u5BE4": "ng6/m6",
    "\u5BE5": "liu4",
    "\u5BE6": "sat6",
    "\u5BE7": "ning4/ling4/ning6/ling6",
    "\u5BE8": "zaai6/zaai2",
    "\u5BE9": "sam2",
    "\u5BEA": "wai2",
    "\u5BEB": "se2",
    "\u5BEC": "fun1",
    "\u5BED": "wai6",
    "\u5BEE": "liu4/liu2",
    "\u5BEF": "zeon3",
    "\u5BF0": "waan4",
    "\u5BF1": "ngai6/ai6",
    "\u5BF2": "ji4",
    "\u5BF3": "bou2",
    "\u5BF4": "can1",
    "\u5BF5": "cung2",
    "\u5BF6": "bou2",
    "\u5BF7": "fung1",
    "\u5BF8": "cyun3/cyun2",
    "\u5BF9": "deoi3/deoi2",
    "\u5BFA": "zi6/zi2",
    "\u5BFB": "cam4",
    "\u5BFC": "dou6",
    "\u5BFD": "lyut3",
    "\u5BFE": "deoi3",
    "\u5BFF": "sau6",
    "\u5C00": "po2",
    "\u5C01": "fung1",
    "\u5C02": "zyun1",
    "\u5C03": "fu1",
    "\u5C04": "se6/jik6/je6",
    "\u5C05": "hak1/haak1",
    "\u5C06": "zoeng1/zoeng3/coeng1",
    "\u5C07": "zoeng1/zoeng3/coeng1",
    "\u5C08": "zyun1",
    "\u5C09": "wai3/wat1/wan6",
    "\u5C0A": "zyun1/zeon1",
    "\u5C0B": "cam4",
    "\u5C0C": "syu6",
    "\u5C0D": "deoi3/deoi2",
    "\u5C0E": "dou6",
    "\u5C0F": "siu2",
    "\u5C10": "zit3",
    "\u5C11": "siu2/siu3",
    "\u5C12": "ji5",
    "\u5C13": "ji5",
    "\u5C14": "ji5",
    "\u5C15": "gaa1",
    "\u5C16": "zim1",
    "\u5C17": "suk6",
    "\u5C18": "can4",
    "\u5C19": "soeng6",
    "\u5C1A": "soeng6/soeng2",
    "\u5C1B": "mo1",
    "\u5C1C": "gaat3/gaa1",
    "\u5C1D": "soeng4",
    "\u5C1E": "liu4",
    "\u5C1F": "sin2",
    "\u5C20": "sin2",
    "\u5C21": "kwan1",
    "\u5C22": "wong1/jau4/jau4.zi6.pong4",
    "\u5C23": "wong1/baat3.jan4",
    "\u5C24": "jau4",
    "\u5C25": "liu6",
    "\u5C26": "liu6",
    "\u5C27": "jiu4",
    "\u5C28": "mong4/mung4/pong4",
    "\u5C29": "wong1",
    "\u5C2A": "wong1",
    "\u5C2B": "wong1",
    "\u5C2C": "gaai3",
    "\u5C2D": "jiu4",
    "\u5C2E": "do3",
    "\u5C2F": "kwai3",
    "\u5C30": "zung2",
    "\u5C31": "zau6",
    "\u5C32": "gaam1/gaam3",
    "\u5C33": "gwat1",
    "\u5C34": "gaam1/gaam3",
    "\u5C35": "teoi4",
    "\u5C36": "gaam1",
    "\u5C37": "gaam1/gaam3",
    "\u5C38": "si1",
    "\u5C39": "wan5",
    "\u5C3A": "cek3/cek2/ce2",
    "\u5C3B": "haau1",
    "\u5C3C": "nei4/lei4",
    "\u5C3D": "zeon6/zeon2",
    "\u5C3E": "mei5/mei1",
    "\u5C3F": "niu6/liu6/niu2/liu2/seoi1",
    "\u5C40": "guk6/guk2",
    "\u5C41": "pei3",
    "\u5C42": "cang4",
    "\u5C43": "ai3/ngai3/hei3",
    "\u5C44": "bei1",
    "\u5C45": "geoi1/gei1",
    "\u5C46": "gaai3",
    "\u5C47": "tin4",
    "\u5C48": "wat1",
    "\u5C49": "tai3",
    "\u5C4A": "gaai3",
    "\u5C4B": "uk1/nguk1",
    "\u5C4C": "diu2",
    "\u5C4D": "si1",
    "\u5C4E": "si2/hei1",
    "\u5C4F": "ping4/ping2/bing2/bing3/bing1",
    "\u5C50": "kek6",
    "\u5C51": "sit3",
    "\u5C52": "zan2",
    "\u5C53": "ai3/ngai3/hei3",
    "\u5C54": "nai4/lai4",
    "\u5C55": "zin2",
    "\u5C56": "sai1",
    "\u5C57": "cyun3",
    "\u5C58": "mei1",
    "\u5C59": "o1/ngo1",
    "\u5C5A": "lau6",
    "\u5C5B": "ping4/bing2/bing3/bing1",
    "\u5C5C": "tai3",
    "\u5C5D": "fei2",
    "\u5C5E": "suk6/zuk1",
    "\u5C5F": "sit3/sip3",
    "\u5C60": "tou4",
    "\u5C61": "leoi5",
    "\u5C62": "leoi5",
    "\u5C63": "saai2",
    "\u5C64": "cang4",
    "\u5C65": "lei5/leoi5",
    "\u5C66": "geoi3",
    "\u5C67": "sit3/sip3",
    "\u5C68": "geoi3",
    "\u5C69": "goek3",
    "\u5C6A": "liu4",
    "\u5C6B": "goek3",
    "\u5C6C": "suk6/zuk1",
    "\u5C6D": "ai3/ngai3/hei3",
    "\u5C6E": "cit3/bun3.bin1.cou2",
    "\u5C6F": "tyun4/zeon1",
    "\u5C70": "jik6",
    "\u5C71": "saan1",
    "\u5C72": "saan1",
    "\u5C73": "sin1",
    "\u5C74": "lik6/lak6",
    "\u5C75": "ngaat6/aat6",
    "\u5C76": "wui6",
    "\u5C77": "wui6",
    "\u5C78": "lung4",
    "\u5C79": "ngat6/at6/gat1",
    "\u5C7A": "hei2",
    "\u5C7B": "jan6",
    "\u5C7C": "ngat6/at6",
    "\u5C7D": "hon6",
    "\u5C7E": "san1",
    "\u5C7F": "zeoi6/jyu5/jyu4",
    "\u5C80": "ceot1",
    "\u5C81": "seoi3",
    "\u5C82": "hei2/hoi2",
    "\u5C83": "jan6",
    "\u5C84": "jyut6",
    "\u5C85": "baan2/faan2",
    "\u5C86": "jiu2",
    "\u5C87": "ngong4/ong4",
    "\u5C88": "ngaa4/aa4/haa1",
    "\u5C89": "mat6",
    "\u5C8A": "zit3",
    "\u5C8B": "ngap6/ap6",
    "\u5C8C": "kap1/ngap6/ap6/gap6",
    "\u5C8D": "hin1",
    "\u5C8E": "fan4",
    "\u5C8F": "jyun4",
    "\u5C90": "kei4",
    "\u5C91": "sam4",
    "\u5C92": "kim4",
    "\u5C93": "kei4",
    "\u5C94": "caa3",
    "\u5C95": "gaai3",
    "\u5C96": "keoi1",
    "\u5C97": "gong1",
    "\u5C98": "jin6",
    "\u5C99": "ou3/ngou3/aau3/ngaau3",
    "\u5C9A": "laam4/laam2",
    "\u5C9B": "dou2",
    "\u5C9C": "baa1",
    "\u5C9D": "zok3",
    "\u5C9E": "zok3/zok6",
    "\u5C9F": "joeng2",
    "\u5CA0": "geoi6",
    "\u5CA1": "gong1",
    "\u5CA2": "ho2",
    "\u5CA3": "gau2",
    "\u5CA4": "jyut6",
    "\u5CA5": "bei1/po1/pei4",
    "\u5CA6": "laap6",
    "\u5CA7": "tiu4",
    "\u5CA8": "zeoi1/zeoi2",
    "\u5CA9": "ngaam4/aam4",
    "\u5CAA": "fat6",
    "\u5CAB": "zau6",
    "\u5CAC": "gaap3",
    "\u5CAD": "ling5/leng5/ling4",
    "\u5CAE": "to4",
    "\u5CAF": "pei4",
    "\u5CB0": "au3/ngau3",
    "\u5CB1": "doi6",
    "\u5CB2": "fong3",
    "\u5CB3": "ngok6/ok6",
    "\u5CB4": "keoi1",
    "\u5CB5": "wu6",
    "\u5CB6": "paak3",
    "\u5CB7": "man4",
    "\u5CB8": "ngon6/on6",
    "\u5CB9": "tiu4",
    "\u5CBA": "ling4",
    "\u5CBB": "ci4",
    "\u5CBC": "ping4",
    "\u5CBD": "dung1",
    "\u5CBE": "zim1",
    "\u5CBF": "kwai1",
    "\u5CC0": "bong1",
    "\u5CC1": "maau5",
    "\u5CC2": "tung4",
    "\u5CC3": "hok6",
    "\u5CC4": "jik6",
    "\u5CC5": "bin6",
    "\u5CC6": "hap6",
    "\u5CC7": "baa1/hap1",
    "\u5CC8": "lok6",
    "\u5CC9": "ngaak6/aak6",
    "\u5CCA": "fau6",
    "\u5CCB": "seon1",
    "\u5CCC": "dit6",
    "\u5CCD": "leot6",
    "\u5CCE": "jan2",
    "\u5CCF": "ji4",
    "\u5CD0": "goi1",
    "\u5CD1": "cyun1",
    "\u5CD2": "tung4/dung6",
    "\u5CD3": "ji4",
    "\u5CD4": "mou5",
    "\u5CD5": "si4",
    "\u5CD6": "on1/ngon1",
    "\u5CD7": "ngai4/ai4",
    "\u5CD8": "wun4",
    "\u5CD9": "zi6/ci5/si6",
    "\u5CDA": "mat6",
    "\u5CDB": "lei5",
    "\u5CDC": "gai3",
    "\u5CDD": "tung4/dung6",
    "\u5CDE": "ngai4/ai4",
    "\u5CDF": "jau6",
    "\u5CE0": "kaa1",
    "\u5CE1": "haap6/haap3/hap6",
    "\u5CE2": "lit6",
    "\u5CE3": "jiu4",
    "\u5CE4": "giu6/kiu4",
    "\u5CE5": "zang1/zaang1",
    "\u5CE6": "lyun4",
    "\u5CE7": "gaau1",
    "\u5CE8": "ngo4/o4",
    "\u5CE9": "ngo4/o4",
    "\u5CEA": "juk6/jyu6",
    "\u5CEB": "je4",
    "\u5CEC": "bou1",
    "\u5CED": "ciu3",
    "\u5CEE": "kwan1",
    "\u5CEF": "fung1",
    "\u5CF0": "fung1",
    "\u5CF1": "naau4/laau4",
    "\u5CF2": "lei5",
    "\u5CF3": "jau4",
    "\u5CF4": "jin6",
    "\u5CF5": "wing4",
    "\u5CF6": "dou2",
    "\u5CF7": "san1",
    "\u5CF8": "sing4",
    "\u5CF9": "tou4",
    "\u5CFA": "gang2",
    "\u5CFB": "zeon3",
    "\u5CFC": "kuk1",
    "\u5CFD": "haap6/haap3/hap6",
    "\u5CFE": "ngan4/an4",
    "\u5CFF": "jyu5",
    "\u5D00": "long6/long5",
    "\u5D01": "ham3",
    "\u5D02": "lou4",
    "\u5D03": "loi4",
    "\u5D04": "him2",
    "\u5D05": "gok3",
    "\u5D06": "hung1",
    "\u5D07": "sung4",
    "\u5D08": "sung4",
    "\u5D09": "daap6",
    "\u5D0A": "lam4",
    "\u5D0B": "waa4/waa6",
    "\u5D0C": "geoi1",
    "\u5D0D": "loi4",
    "\u5D0E": "kei1/kei4",
    "\u5D0F": "man4",
    "\u5D10": "kwan1",
    "\u5D11": "kwan1",
    "\u5D12": "zyut6/zeot1",
    "\u5D13": "gu3/gwu3",
    "\u5D14": "ceoi1",
    "\u5D15": "ngaai4/aai4",
    "\u5D16": "ngaai4/aai4",
    "\u5D17": "gong1",
    "\u5D18": "leon4",
    "\u5D19": "leon4",
    "\u5D1A": "ling4",
    "\u5D1B": "gwat6",
    "\u5D1C": "do1",
    "\u5D1D": "zang1/zaang1",
    "\u5D1E": "gwok3/gok3",
    "\u5D1F": "jam4",
    "\u5D20": "dung3",
    "\u5D21": "haam4",
    "\u5D22": "zang1/zaang1",
    "\u5D23": "wai2",
    "\u5D24": "ngaau4/aau4",
    "\u5D25": "pei4",
    "\u5D26": "jim1",
    "\u5D27": "sung1",
    "\u5D28": "zip6",
    "\u5D29": "bang1",
    "\u5D2A": "zyut6/zeot1",
    "\u5D2B": "fat1",
    "\u5D2C": "dung1",
    "\u5D2D": "zaam2/zaam3",
    "\u5D2E": "gu3/gwu3",
    "\u5D2F": "jam4",
    "\u5D30": "zi1",
    "\u5D31": "zak1",
    "\u5D32": "wong4",
    "\u5D33": "jyu4",
    "\u5D34": "wai1",
    "\u5D35": "joeng4",
    "\u5D36": "fung1",
    "\u5D37": "cau4",
    "\u5D38": "ngong4/ong4",
    "\u5D39": "tai4",
    "\u5D3A": "ji5",
    "\u5D3B": "zi6",
    "\u5D3C": "si6",
    "\u5D3D": "zai2/zoi2",
    "\u5D3E": "jiu5",
    "\u5D3F": "ngok6/ok6",
    "\u5D40": "cyu5",
    "\u5D41": "ham1",
    "\u5D42": "leot6",
    "\u5D43": "jin5",
    "\u5D44": "mei5",
    "\u5D45": "haam4",
    "\u5D46": "kai1",
    "\u5D47": "kai1/hai4",
    "\u5D48": "wun6",
    "\u5D49": "ting4",
    "\u5D4A": "sing6",
    "\u5D4B": "mei4",
    "\u5D4C": "ham3/ham6/haam1",
    "\u5D4D": "mou6",
    "\u5D4E": "jyu4",
    "\u5D4F": "zung1",
    "\u5D50": "laam4/laam2",
    "\u5D51": "hot3/kit3",
    "\u5D52": "ngaam4/aam4",
    "\u5D53": "ngaam4/aam4",
    "\u5D54": "wai3",
    "\u5D55": "zung1",
    "\u5D56": "caa4/zaa6",
    "\u5D57": "seoi3",
    "\u5D58": "wing4",
    "\u5D59": "fo1",
    "\u5D5A": "jam1",
    "\u5D5B": "jyu4",
    "\u5D5C": "kei1",
    "\u5D5D": "lau5",
    "\u5D5E": "tou4",
    "\u5D5F": "deoi1",
    "\u5D60": "kai1",
    "\u5D61": "jung2",
    "\u5D62": "cong1",
    "\u5D63": "dong6",
    "\u5D64": "wing4",
    "\u5D65": "git6",
    "\u5D66": "hoi2",
    "\u5D67": "lau4",
    "\u5D68": "wu2",
    "\u5D69": "sung1",
    "\u5D6A": "hiu1",
    "\u5D6B": "zi1",
    "\u5D6C": "ngai4/ai4",
    "\u5D6D": "bang1",
    "\u5D6E": "din1",
    "\u5D6F": "co1/ci1",
    "\u5D70": "him2",
    "\u5D71": "jung2/jung4",
    "\u5D72": "jit6",
    "\u5D73": "co1",
    "\u5D74": "zek3",
    "\u5D75": "zi6",
    "\u5D76": "joek6",
    "\u5D77": "sung2",
    "\u5D78": "zung1",
    "\u5D79": "koeng4",
    "\u5D7A": "liu4",
    "\u5D7B": "hong1",
    "\u5D7C": "caan2",
    "\u5D7D": "dit6/dai6",
    "\u5D7E": "cam1/caam1",
    "\u5D7F": "ding2",
    "\u5D80": "tou1",
    "\u5D81": "lau5",
    "\u5D82": "zoeng3",
    "\u5D83": "zaam2/zaam3",
    "\u5D84": "zaam2/zaam3",
    "\u5D85": "ngou4/ou4",
    "\u5D86": "cou4",
    "\u5D87": "keoi1",
    "\u5D88": "coeng1",
    "\u5D89": "ceoi1",
    "\u5D8A": "zeoi2",
    "\u5D8B": "dou2",
    "\u5D8C": "dou2",
    "\u5D8D": "zaap6",
    "\u5D8E": "wai3",
    "\u5D8F": "pui3",
    "\u5D90": "lung4",
    "\u5D91": "zoeng6",
    "\u5D92": "cang4/zang1/zaang1",
    "\u5D93": "bo1",
    "\u5D94": "jam1",
    "\u5D95": "ciu4",
    "\u5D96": "jim1",
    "\u5D97": "lou4",
    "\u5D98": "zaan6",
    "\u5D99": "leon4",
    "\u5D9A": "liu4",
    "\u5D9B": "liu4",
    "\u5D9C": "zam1",
    "\u5D9D": "dang3",
    "\u5D9E": "do6",
    "\u5D9F": "zeon1",
    "\u5DA0": "giu6/kiu4",
    "\u5DA1": "gwai3",
    "\u5DA2": "jiu4",
    "\u5DA3": "ciu4",
    "\u5DA4": "jiu4",
    "\u5DA5": "gwai3",
    "\u5DA6": "zim1",
    "\u5DA7": "jik6",
    "\u5DA8": "hok6",
    "\u5DA9": "naau4/laau4",
    "\u5DAA": "jip6",
    "\u5DAB": "jip6",
    "\u5DAC": "ngai4/ai4",
    "\u5DAD": "jit6",
    "\u5DAE": "him2",
    "\u5DAF": "cap1",
    "\u5DB0": "haai5",
    "\u5DB1": "got3",
    "\u5DB2": "kwai1/seoi5",
    "\u5DB3": "dei6",
    "\u5DB4": "ou3/ngou3/aau3/ngaau3",
    "\u5DB5": "zeoi2",
    "\u5DB6": "mei4",
    "\u5DB7": "jik6/ji4",
    "\u5DB8": "wing4",
    "\u5DB9": "dou2",
    "\u5DBA": "ling5/leng5",
    "\u5DBB": "zit3",
    "\u5DBC": "zeoi6/jyu5/jyu4",
    "\u5DBD": "ngok6/ok6",
    "\u5DBE": "jan2",
    "\u5DBF": "seoi1",
    "\u5DC0": "zit3",
    "\u5DC1": "lai6",
    "\u5DC2": "kwai1/seoi5",
    "\u5DC3": "lung4",
    "\u5DC4": "lung4",
    "\u5DC5": "din1",
    "\u5DC6": "wing4",
    "\u5DC7": "hei1",
    "\u5DC8": "guk1",
    "\u5DC9": "caam4",
    "\u5DCA": "jing2",
    "\u5DCB": "kwai1",
    "\u5DCC": "ngaam4/aam4",
    "\u5DCD": "ngai4/ai4",
    "\u5DCE": "naau4/laau4",
    "\u5DCF": "kyun4",
    "\u5DD0": "ciu2",
    "\u5DD1": "cyun4",
    "\u5DD2": "lyun4",
    "\u5DD3": "din1",
    "\u5DD4": "din1",
    "\u5DD5": "jit6",
    "\u5DD6": "ngaam4/aam4",
    "\u5DD7": "ngaam4/aam4",
    "\u5DD8": "jin2/jin5",
    "\u5DD9": "naau4/laau4",
    "\u5DDA": "jin2",
    "\u5DDB": "cyun1/kwan1",
    "\u5DDC": "kui2/kwui2",
    "\u5DDD": "cyun1",
    "\u5DDE": "zau1",
    "\u5DDF": "fong1",
    "\u5DE0": "ging1",
    "\u5DE1": "ceon4",
    "\u5DE2": "caau4",
    "\u5DE3": "caau4",
    "\u5DE4": "lip6",
    "\u5DE5": "gung1",
    "\u5DE6": "zo2",
    "\u5DE7": "haau2/kiu2",
    "\u5DE8": "geoi6",
    "\u5DE9": "gung2",
    "\u5DEA": "geoi6",
    "\u5DEB": "mou4",
    "\u5DEC": "gei1",
    "\u5DED": "gung1",
    "\u5DEE": "caa1/caai1/ci1",
    "\u5DEF": "kau4",
    "\u5DF0": "kau4",
    "\u5DF1": "gei2/gei1",
    "\u5DF2": "ji5",
    "\u5DF3": "zi6",
    "\u5DF4": "baa1/baa2",
    "\u5DF5": "zi1",
    "\u5DF6": "ciu1",
    "\u5DF7": "hong6/hong2",
    "\u5DF8": "ji4",
    "\u5DF9": "gan2",
    "\u5DFA": "seon3",
    "\u5DFB": "gyun2",
    "\u5DFC": "baa1",
    "\u5DFD": "seon3",
    "\u5DFE": "gan1",
    "\u5DFF": "fat1",
    "\u5E00": "zaap3",
    "\u5E01": "bai6",
    "\u5E02": "si5/si2",
    "\u5E03": "bou3",
    "\u5E04": "ding1",
    "\u5E05": "seoi3/seot1",
    "\u5E06": "faan4",
    "\u5E07": "nip6/lip6",
    "\u5E08": "si1",
    "\u5E09": "fan1",
    "\u5E0A": "paa3",
    "\u5E0B": "zi2",
    "\u5E0C": "hei1",
    "\u5E0D": "wu6",
    "\u5E0E": "daam3",
    "\u5E0F": "wai4",
    "\u5E10": "zoeng3/zoeng2",
    "\u5E11": "tong2/nou4/lou4",
    "\u5E12": "doi6",
    "\u5E13": "mat6",
    "\u5E14": "pei3/pei1",
    "\u5E15": "paak3/mak6",
    "\u5E16": "tip3/tip2",
    "\u5E17": "fat1",
    "\u5E18": "lim4/lim2",
    "\u5E19": "dit6",
    "\u5E1A": "zau2/zaau2",
    "\u5E1B": "baak6",
    "\u5E1C": "ci3",
    "\u5E1D": "dai3",
    "\u5E1E": "mak6",
    "\u5E1F": "jik6",
    "\u5E20": "jit6",
    "\u5E21": "ping4",
    "\u5E22": "hap1",
    "\u5E23": "gyun3",
    "\u5E24": "jyu4",
    "\u5E25": "seoi3/seot1",
    "\u5E26": "daai3/daai2",
    "\u5E27": "zing3",
    "\u5E28": "seoi3",
    "\u5E29": "ciu3",
    "\u5E2A": "zan1",
    "\u5E2B": "si1",
    "\u5E2C": "kwan4",
    "\u5E2D": "zik6/zek6",
    "\u5E2E": "bong1",
    "\u5E2F": "daai3",
    "\u5E30": "gwai1",
    "\u5E31": "cau4/dou6/tou4",
    "\u5E32": "ping4",
    "\u5E33": "zoeng3/zoeng2",
    "\u5E34": "zin2/zin1",
    "\u5E35": "wun1/jyun2",
    "\u5E36": "daai3/daai2",
    "\u5E37": "wai4",
    "\u5E38": "soeng4",
    "\u5E39": "saap3",
    "\u5E3A": "kei4",
    "\u5E3B": "zik1/zaak3",
    "\u5E3C": "gwok3/gok3",
    "\u5E3D": "mou6/mou2",
    "\u5E3E": "dou2",
    "\u5E3F": "hau4",
    "\u5E40": "zing3",
    "\u5E41": "seoi1",
    "\u5E42": "mik6",
    "\u5E43": "wai4",
    "\u5E44": "ak1/aak1/ngaak1/ngak1",
    "\u5E45": "fuk1",
    "\u5E46": "ai3/ngai3",
    "\u5E47": "bong1",
    "\u5E48": "ping4",
    "\u5E49": "jip6",
    "\u5E4A": "gung1",
    "\u5E4B": "pun4",
    "\u5E4C": "fong2",
    "\u5E4D": "tou1",
    "\u5E4E": "mik6",
    "\u5E4F": "gaa3",
    "\u5E50": "tang4",
    "\u5E51": "fai1",
    "\u5E52": "zung1",
    "\u5E53": "saam1",
    "\u5E54": "maan6",
    "\u5E55": "mok6",
    "\u5E56": "biu1",
    "\u5E57": "gwok3/gok3",
    "\u5E58": "zik1/zaak3",
    "\u5E59": "mok6",
    "\u5E5A": "bong1",
    "\u5E5B": "zoeng3",
    "\u5E5C": "ging2",
    "\u5E5D": "cin2",
    "\u5E5E": "fuk6/buk6",
    "\u5E5F": "ci3",
    "\u5E60": "fu1",
    "\u5E61": "faan1",
    "\u5E62": "cong4/zong6/tong4",
    "\u5E63": "bai6",
    "\u5E64": "bai6",
    "\u5E65": "zoeng2",
    "\u5E66": "mik6",
    "\u5E67": "ciu1",
    "\u5E68": "cim1/zim1/cim3",
    "\u5E69": "fan4",
    "\u5E6A": "mung4/mung2",
    "\u5E6B": "bong1",
    "\u5E6C": "cau4/dou6/tou4",
    "\u5E6D": "mit6",
    "\u5E6E": "cyu4/ceoi4",
    "\u5E6F": "zit3",
    "\u5E70": "hin2",
    "\u5E71": "laan4",
    "\u5E72": "gon1/gon3/hon4",
    "\u5E73": "ping4/peng4",
    "\u5E74": "nin4/lin4/nin2/lin2",
    "\u5E75": "hin1",
    "\u5E76": "bing6/bing3/ping3/bing1",
    "\u5E77": "bing6/bing3/ping3/bing1",
    "\u5E78": "hang6",
    "\u5E79": "gon3/hon4",
    "\u5E7A": "jiu1",
    "\u5E7B": "waan6",
    "\u5E7C": "jau3/jiu3",
    "\u5E7D": "jau1",
    "\u5E7E": "gei2/gei1",
    "\u5E7F": "gwong2/gong2/jim5/am1/ngam1/gwong2.zi6.tau4",
    "\u5E80": "pei2",
    "\u5E81": "ting1",
    "\u5E82": "zak1",
    "\u5E83": "gwong2/gong2",
    "\u5E84": "zong1",
    "\u5E85": "mo1",
    "\u5E86": "hing3",
    "\u5E87": "bei3",
    "\u5E88": "kam4",
    "\u5E89": "deon6",
    "\u5E8A": "cong4",
    "\u5E8B": "gwai2/gei2",
    "\u5E8C": "ngaa5/aa5",
    "\u5E8D": "baai3",
    "\u5E8E": "gaai3",
    "\u5E8F": "zeoi6/zeoi2",
    "\u5E90": "lou4",
    "\u5E91": "mou5/mou4",
    "\u5E92": "zong1",
    "\u5E93": "fu3",
    "\u5E94": "jing3/jing1",
    "\u5E95": "dai2/dai1",
    "\u5E96": "paau4",
    "\u5E97": "dim3",
    "\u5E98": "aap3/ngaap3",
    "\u5E99": "miu6/miu2",
    "\u5E9A": "gang1",
    "\u5E9B": "ci3",
    "\u5E9C": "fu2",
    "\u5E9D": "tung4",
    "\u5E9E": "pong4",
    "\u5E9F": "fai3",
    "\u5EA0": "coeng4",
    "\u5EA1": "ji2",
    "\u5EA2": "zat6",
    "\u5EA3": "tiu1",
    "\u5EA4": "zi6",
    "\u5EA5": "jau1",
    "\u5EA6": "dou6/dou2/dok6",
    "\u5EA7": "zo6/zo2",
    "\u5EA8": "haau1",
    "\u5EA9": "tou4",
    "\u5EAA": "gwai2/gei2",
    "\u5EAB": "fu3",
    "\u5EAC": "pong4/mong4",
    "\u5EAD": "ting4",
    "\u5EAE": "jau5/jau4",
    "\u5EAF": "bou1",
    "\u5EB0": "bing6",
    "\u5EB1": "cing2",
    "\u5EB2": "loi4",
    "\u5EB3": "bei1/pei5",
    "\u5EB4": "zik6",
    "\u5EB5": "am1/ngam1",
    "\u5EB6": "syu3",
    "\u5EB7": "hong1",
    "\u5EB8": "jung4",
    "\u5EB9": "tok3",
    "\u5EBA": "cung4",
    "\u5EBB": "syu3",
    "\u5EBC": "king2",
    "\u5EBD": "jyu6",
    "\u5EBE": "jyu4/jyu5",
    "\u5EBF": "miu6/miu2",
    "\u5EC0": "sau1",
    "\u5EC1": "ci3/cak1",
    "\u5EC2": "soeng1",
    "\u5EC3": "fai3",
    "\u5EC4": "gau3",
    "\u5EC5": "ap1/ngap1",
    "\u5EC6": "gwai1/wai2",
    "\u5EC7": "lau6",
    "\u5EC8": "haa6",
    "\u5EC9": "lim4/lim1",
    "\u5ECA": "long4/long2",
    "\u5ECB": "sau1",
    "\u5ECC": "zi6/zaai6",
    "\u5ECD": "bou6",
    "\u5ECE": "king2",
    "\u5ECF": "gau3",
    "\u5ED0": "gau3",
    "\u5ED1": "kan4/gan2",
    "\u5ED2": "ngou4/ou4",
    "\u5ED3": "gwok3/gok3/kwok3/kok3",
    "\u5ED4": "lau4",
    "\u5ED5": "jam3",
    "\u5ED6": "liu6",
    "\u5ED7": "daai3",
    "\u5ED8": "luk6",
    "\u5ED9": "ji6",
    "\u5EDA": "cyu4/cyu2/ceoi4/ceoi2",
    "\u5EDB": "cin4",
    "\u5EDC": "tou4",
    "\u5EDD": "si1",
    "\u5EDE": "jam1",
    "\u5EDF": "miu6/miu2",
    "\u5EE0": "cong2",
    "\u5EE1": "mou5/mou4",
    "\u5EE2": "fai3",
    "\u5EE3": "gwong2/gong2",
    "\u5EE4": "fu3",
    "\u5EE5": "kui2/kwui2",
    "\u5EE6": "bik1",
    "\u5EE7": "coeng4",
    "\u5EE8": "haai6/gaai3",
    "\u5EE9": "lam5",
    "\u5EEA": "lam5",
    "\u5EEB": "liu4",
    "\u5EEC": "lou4",
    "\u5EED": "zik1",
    "\u5EEE": "jing2",
    "\u5EEF": "sin1",
    "\u5EF0": "teng1",
    "\u5EF1": "jung1",
    "\u5EF2": "lai4",
    "\u5EF3": "teng1/ting1",
    "\u5EF4": "jan5/gin3.zi6.pong4",
    "\u5EF5": "ceon4",
    "\u5EF6": "jin4",
    "\u5EF7": "ting4",
    "\u5EF8": "dik6",
    "\u5EF9": "baak1/bik1",
    "\u5EFA": "gin3",
    "\u5EFB": "wui4",
    "\u5EFC": "naai5/laai5",
    "\u5EFD": "wui4",
    "\u5EFE": "gung2/lung6.zi6.dai2",
    "\u5EFF": "nim6/lim6/je6/jaa6",
    "\u5F00": "hoi1",
    "\u5F01": "bin6/pun4",
    "\u5F02": "ji6",
    "\u5F03": "hei3",
    "\u5F04": "lung6/nung6",
    "\u5F05": "fan5",
    "\u5F06": "geoi2",
    "\u5F07": "jim2/jim1",
    "\u5F08": "jik6",
    "\u5F09": "zong6",
    "\u5F0A": "bai6",
    "\u5F0B": "jik6",
    "\u5F0C": "jat1",
    "\u5F0D": "ji6",
    "\u5F0E": "saam1/saam3",
    "\u5F0F": "sik1",
    "\u5F10": "ji6",
    "\u5F11": "si3",
    "\u5F12": "si3",
    "\u5F13": "gung1",
    "\u5F14": "diu3",
    "\u5F15": "jan5",
    "\u5F16": "gung1",
    "\u5F17": "fat1/fik1",
    "\u5F18": "wang4",
    "\u5F19": "wu1",
    "\u5F1A": "dai6",
    "\u5F1B": "ci4",
    "\u5F1C": "koeng5",
    "\u5F1D": "baa3",
    "\u5F1E": "can2",
    "\u5F1F": "dai6/dai2/dai4/di2/di4/tai5",
    "\u5F20": "zoeng1/zoeng3",
    "\u5F21": "gwat6",
    "\u5F22": "tou1",
    "\u5F23": "fu2",
    "\u5F24": "dai2",
    "\u5F25": "nei4/lei4/mei4",
    "\u5F26": "jin4/jyun4",
    "\u5F27": "wu4",
    "\u5F28": "ciu1",
    "\u5F29": "nou5/lou5",
    "\u5F2A": "ging3",
    "\u5F2B": "can2",
    "\u5F2C": "ji4",
    "\u5F2D": "mai5/mei5",
    "\u5F2E": "hyun1",
    "\u5F2F": "waan1",
    "\u5F30": "saau1",
    "\u5F31": "joek6",
    "\u5F32": "hyun1",
    "\u5F33": "ging3",
    "\u5F34": "diu1",
    "\u5F35": "zoeng1/zoeng3",
    "\u5F36": "koeng5",
    "\u5F37": "koeng4/koeng5/goeng6",
    "\u5F38": "paang4/ping1/pang4",
    "\u5F39": "daan6/daan2/taan4",
    "\u5F3A": "koeng4/koeng5/goeng6",
    "\u5F3B": "bat6",
    "\u5F3C": "bat6",
    "\u5F3D": "sip3",
    "\u5F3E": "daan6",
    "\u5F3F": "gin2",
    "\u5F40": "gau3",
    "\u5F41": "go1",
    "\u5F42": "faat3",
    "\u5F43": "bat1",
    "\u5F44": "kau1",
    "\u5F45": "zin2",
    "\u5F46": "bit3",
    "\u5F47": "siu1",
    "\u5F48": "daan6/daan2/taan4",
    "\u5F49": "kwok3/kok3/gwok3/gok3",
    "\u5F4A": "goeng1/koeng4/koeng5/goeng6",
    "\u5F4B": "wang4/waang4",
    "\u5F4C": "nei4/lei4/mei4",
    "\u5F4D": "kwok3/kok3/gwok3/gok3",
    "\u5F4E": "waan1",
    "\u5F4F": "fok3/gok3",
    "\u5F50": "gai3/gaan2.faa3.luk6.zi6.tau4",
    "\u5F51": "gai3/kyut3.tau4.wu6",
    "\u5F52": "gwai1",
    "\u5F53": "dong1/dong3",
    "\u5F54": "luk6",
    "\u5F55": "luk6/luk2",
    "\u5F56": "teon3",
    "\u5F57": "wai6/seoi6",
    "\u5F58": "zi6/zai6",
    "\u5F59": "wai6/wui6",
    "\u5F5A": "wai6",
    "\u5F5B": "ji4",
    "\u5F5C": "ji4",
    "\u5F5D": "ji4",
    "\u5F5E": "ji4",
    "\u5F5F": "wok6/wok3",
    "\u5F60": "wok6/wok3",
    "\u5F61": "saam1/saam1.pit3",
    "\u5F62": "jing4",
    "\u5F63": "man4",
    "\u5F64": "tung4",
    "\u5F65": "jin6",
    "\u5F66": "jin6",
    "\u5F67": "juk1",
    "\u5F68": "ci1",
    "\u5F69": "coi2",
    "\u5F6A": "biu1",
    "\u5F6B": "diu1",
    "\u5F6C": "ban1",
    "\u5F6D": "paang4",
    "\u5F6E": "jung5",
    "\u5F6F": "piu1",
    "\u5F70": "zoeng1",
    "\u5F71": "jing2",
    "\u5F72": "ci1",
    "\u5F73": "cik1/soeng1.kei5.jan2",
    "\u5F74": "zoek3",
    "\u5F75": "to5",
    "\u5F76": "gap1",
    "\u5F77": "pong4/fong2",
    "\u5F78": "zung1",
    "\u5F79": "jik6",
    "\u5F7A": "wong4",
    "\u5F7B": "cit3",
    "\u5F7C": "bei2",
    "\u5F7D": "ci4/dai1",
    "\u5F7E": "ling4",
    "\u5F7F": "fat1",
    "\u5F80": "wong5",
    "\u5F81": "zing1/cing4",
    "\u5F82": "cou4",
    "\u5F83": "wong5",
    "\u5F84": "ging3/gaang3",
    "\u5F85": "doi6",
    "\u5F86": "sai1",
    "\u5F87": "seon1/seon6/ceon4",
    "\u5F88": "han2",
    "\u5F89": "joeng4",
    "\u5F8A": "wui4",
    "\u5F8B": "leot6/leot2",
    "\u5F8C": "hau6/hau2",
    "\u5F8D": "wong5",
    "\u5F8E": "cing2",
    "\u5F8F": "zik1",
    "\u5F90": "ceoi4",
    "\u5F91": "ging3/gaang3",
    "\u5F92": "tou4/tou2",
    "\u5F93": "cung4",
    "\u5F94": "zi1",
    "\u5F95": "loi4/loi6",
    "\u5F96": "cung4",
    "\u5F97": "dak1",
    "\u5F98": "pui4",
    "\u5F99": "saai2",
    "\u5F9A": "gaan2",
    "\u5F9B": "gei6/kei5/gei3",
    "\u5F9C": "soeng4",
    "\u5F9D": "zi3",
    "\u5F9E": "cung4/sung1/zung1/zung3",
    "\u5F9F": "zau1",
    "\u5FA0": "loi4/loi6",
    "\u5FA1": "jyu6/ngaa6/aa6",
    "\u5FA2": "sip3",
    "\u5FA3": "ze3",
    "\u5FA4": "gin6",
    "\u5FA5": "si6",
    "\u5FA6": "gaa2",
    "\u5FA7": "pin3",
    "\u5FA8": "wong4",
    "\u5FA9": "fuk6/fuk1/fau6",
    "\u5FAA": "ceon4",
    "\u5FAB": "wai5",
    "\u5FAC": "pong4",
    "\u5FAD": "jiu4",
    "\u5FAE": "mei4/mei1/mei2",
    "\u5FAF": "hai4",
    "\u5FB0": "zing1",
    "\u5FB1": "piu3",
    "\u5FB2": "tai4",
    "\u5FB3": "dak1",
    "\u5FB4": "zing1",
    "\u5FB5": "zi2/zing1/cing4",
    "\u5FB6": "bit3/pit3",
    "\u5FB7": "dak1",
    "\u5FB8": "cung1",
    "\u5FB9": "cit3",
    "\u5FBA": "hiu1",
    "\u5FBB": "wai3",
    "\u5FBC": "giu3/giu1/hiu1/giu2/jiu1",
    "\u5FBD": "fai1",
    "\u5FBE": "mei4",
    "\u5FBF": "lung6",
    "\u5FC0": "soeng1",
    "\u5FC1": "bou3",
    "\u5FC2": "keoi4",
    "\u5FC3": "sam1",
    "\u5FC4": "syu6/syu6.sam1.bin1",
    "\u5FC5": "bit1",
    "\u5FC6": "jik1",
    "\u5FC7": "lak6",
    "\u5FC8": "jan4",
    "\u5FC9": "dou1/tou1",
    "\u5FCA": "ding6",
    "\u5FCB": "goi2",
    "\u5FCC": "gei6/gei2",
    "\u5FCD": "jan2",
    "\u5FCE": "jan4",
    "\u5FCF": "caam3",
    "\u5FD0": "taan2",
    "\u5FD1": "tik1",
    "\u5FD2": "tik1",
    "\u5FD3": "gon1",
    "\u5FD4": "ngat6/at6/hat1/jat6",
    "\u5FD5": "sai6/taai3",
    "\u5FD6": "cyun2",
    "\u5FD7": "zi3",
    "\u5FD8": "mong4",
    "\u5FD9": "mong4",
    "\u5FDA": "hei1",
    "\u5FDB": "faan4",
    "\u5FDC": "jing3",
    "\u5FDD": "tim2",
    "\u5FDE": "man4/man2",
    "\u5FDF": "man4/mang2",
    "\u5FE0": "zung1",
    "\u5FE1": "cung1",
    "\u5FE2": "ng6/m6",
    "\u5FE3": "gap1",
    "\u5FE4": "ng5/m5",
    "\u5FE5": "hei3",
    "\u5FE6": "git3",
    "\u5FE7": "jau1",
    "\u5FE8": "wun6",
    "\u5FE9": "cung1",
    "\u5FEA": "zung1/sung1",
    "\u5FEB": "faai3/faai1/faai2",
    "\u5FEC": "jyu6",
    "\u5FED": "bin6",
    "\u5FEE": "zi3",
    "\u5FEF": "kei4",
    "\u5FF0": "seoi6",
    "\u5FF1": "sam4",
    "\u5FF2": "taai3",
    "\u5FF3": "tyun4/zeon1",
    "\u5FF4": "kim4",
    "\u5FF5": "nim6/lim6/je6/jaa6",
    "\u5FF6": "wan4",
    "\u5FF7": "hung1",
    "\u5FF8": "nau2/lau2/nuk6/luk6",
    "\u5FF9": "kong4",
    "\u5FFA": "hin1/him1",
    "\u5FFB": "jan1",
    "\u5FFC": "kong2/hong2",
    "\u5FFD": "fat1",
    "\u5FFE": "koi3",
    "\u5FFF": "fan5/fan6",
    "\u6000": "waai4",
    "\u6001": "taai3",
    "\u6002": "sung2",
    "\u6003": "mou5",
    "\u6004": "au3/ngau3/au1/ngau1",
    "\u6005": "coeng3/zoeng3",
    "\u6006": "cong3",
    "\u6007": "geoi6",
    "\u6008": "jai6",
    "\u6009": "baau2",
    "\u600A": "ciu1/tiu4",
    "\u600B": "man4",
    "\u600C": "pei1",
    "\u600D": "zok3/zok6",
    "\u600E": "zam2",
    "\u600F": "joeng2/joeng3",
    "\u6010": "kau3",
    "\u6011": "bun6",
    "\u6012": "nou6/lou6",
    "\u6013": "naau4/laau4",
    "\u6014": "zing1",
    "\u6015": "paa3/paa2",
    "\u6016": "bou3",
    "\u6017": "tip3/zim1",
    "\u6018": "gu3/gwu3",
    "\u6019": "wu6",
    "\u601A": "zeoi6",
    "\u601B": "daat3/taan2",
    "\u601C": "lin4",
    "\u601D": "si1/si3/soi1",
    "\u601E": "jau4/zau6/cau4",
    "\u601F": "dai3",
    "\u6020": "toi5/doi6",
    "\u6021": "ji4",
    "\u6022": "dat6",
    "\u6023": "jau4",
    "\u6024": "fu1",
    "\u6025": "gap1",
    "\u6026": "ping1",
    "\u6027": "sing3",
    "\u6028": "jyun3",
    "\u6029": "nei4/lei4",
    "\u602A": "gwaai3/gwaai2",
    "\u602B": "fat6/fai3/bui6",
    "\u602C": "hei3",
    "\u602D": "bit1",
    "\u602E": "jau1",
    "\u602F": "hip3",
    "\u6030": "jyun6",
    "\u6031": "cung1",
    "\u6032": "bing2",
    "\u6033": "fong2",
    "\u6034": "wat1",
    "\u6035": "zeot1",
    "\u6036": "bei3",
    "\u6037": "sik1",
    "\u6038": "sik1",
    "\u6039": "taa1",
    "\u603A": "wing5",
    "\u603B": "zung2",
    "\u603C": "deoi6/zeoi6",
    "\u603D": "mei6",
    "\u603E": "sik1/ci3",
    "\u603F": "jik6",
    "\u6040": "zi2/si6/ci2",
    "\u6041": "jam6",
    "\u6042": "seon1",
    "\u6043": "ci5",
    "\u6044": "hat1",
    "\u6045": "lou5",
    "\u6046": "hang4/gang2",
    "\u6047": "hong1",
    "\u6048": "mau4",
    "\u6049": "zi2",
    "\u604A": "hip3",
    "\u604B": "lyun2/lyun5",
    "\u604C": "tiu1",
    "\u604D": "fong2",
    "\u604E": "dit6",
    "\u604F": "hou2",
    "\u6050": "hung2",
    "\u6051": "gwai2",
    "\u6052": "hang4/hang2/gang2",
    "\u6053": "sai1",
    "\u6054": "haau6",
    "\u6055": "syu3",
    "\u6056": "si1",
    "\u6057": "fu1",
    "\u6058": "jau1",
    "\u6059": "joeng6",
    "\u605A": "wai6",
    "\u605B": "wui4",
    "\u605C": "cik1/sik1",
    "\u605D": "gaat3/aat3/ngaat3",
    "\u605E": "ji4",
    "\u605F": "hung1",
    "\u6060": "gwaai3",
    "\u6061": "leon6",
    "\u6062": "fui1",
    "\u6063": "zi3/ci3/zi1",
    "\u6064": "seot1",
    "\u6065": "ci2",
    "\u6066": "soeng3",
    "\u6067": "nuk6/luk6",
    "\u6068": "han6",
    "\u6069": "jan1",
    "\u606A": "kok3",
    "\u606B": "dung6/tung1",
    "\u606C": "tim4/tim5",
    "\u606D": "gung1",
    "\u606E": "cyun4",
    "\u606F": "sik1",
    "\u6070": "hap1",
    "\u6071": "jyut6",
    "\u6072": "paang1",
    "\u6073": "han2",
    "\u6074": "dak1",
    "\u6075": "wai6",
    "\u6076": "ok3/ngok3/wu3/wu1",
    "\u6077": "jau1",
    "\u6078": "dung6",
    "\u6079": "jim1",
    "\u607A": "hoi2",
    "\u607B": "cak1/caak1",
    "\u607C": "nou5/lou5",
    "\u607D": "wan6",
    "\u607E": "mong4",
    "\u607F": "jung2",
    "\u6080": "jung5",
    "\u6081": "gyun3/jyun1/gyun1",
    "\u6082": "pei1/pai1",
    "\u6083": "kwan2",
    "\u6084": "ciu2/ciu3/ciu5",
    "\u6085": "jyut6",
    "\u6086": "jyu6",
    "\u6087": "tou4",
    "\u6088": "gaai3",
    "\u6089": "sik1",
    "\u608A": "zit3",
    "\u608B": "leon6",
    "\u608C": "dai6/tai5",
    "\u608D": "hon5/hon6",
    "\u608E": "hou6",
    "\u608F": "hip3",
    "\u6090": "tik1",
    "\u6091": "bou3",
    "\u6092": "jap1",
    "\u6093": "jin5",
    "\u6094": "fui3",
    "\u6095": "hei1",
    "\u6096": "bui6/bui3/but6",
    "\u6097": "mun5/mun4",
    "\u6098": "ji1",
    "\u6099": "hang1",
    "\u609A": "sung2",
    "\u609B": "syun1",
    "\u609C": "cing2",
    "\u609D": "fui1/lei5/kwai1",
    "\u609E": "ng6/m6",
    "\u609F": "ng6/m6/ng4/m4",
    "\u60A0": "jau4",
    "\u60A1": "lei4",
    "\u60A2": "loeng6/long5",
    "\u60A3": "waan6",
    "\u60A4": "cung1",
    "\u60A5": "ji3",
    "\u60A6": "jyut6",
    "\u60A7": "lei4",
    "\u60A8": "nei5/lei5",
    "\u60A9": "nou5/lou5",
    "\u60AA": "ok3/ngok3",
    "\u60AB": "kok3",
    "\u60AC": "jyun4",
    "\u60AD": "haan1",
    "\u60AE": "ng6/m6",
    "\u60AF": "man5",
    "\u60B0": "cung4",
    "\u60B1": "fei2",
    "\u60B2": "bei1",
    "\u60B3": "dak1",
    "\u60B4": "seoi6/seoi5",
    "\u60B5": "coeng3/zoeng3",
    "\u60B6": "mun6",
    "\u60B7": "lai6/leoi6",
    "\u60B8": "gwai3",
    "\u60B9": "gun3/gwun3",
    "\u60BA": "gun3/gwun3",
    "\u60BB": "hang6/hang5",
    "\u60BC": "dou6",
    "\u60BD": "cai1",
    "\u60BE": "hung1",
    "\u60BF": "tim2",
    "\u60C0": "leon4",
    "\u60C1": "sik1",
    "\u60C2": "ham2",
    "\u60C3": "gwan2",
    "\u60C4": "nik6/lik6",
    "\u60C5": "cing4/cing2",
    "\u60C6": "cau4",
    "\u60C7": "deon1",
    "\u60C8": "gwo2/go2",
    "\u60C9": "zim1",
    "\u60CA": "ging1/geng1",
    "\u60CB": "wun2/jyun2",
    "\u60CC": "jyun1/jyun3",
    "\u60CD": "gam1",
    "\u60CE": "gei6",
    "\u60CF": "lam4/laam4",
    "\u60D0": "wik6",
    "\u60D1": "waak6",
    "\u60D2": "wo4",
    "\u60D3": "kyun4/gyun3",
    "\u60D4": "taam4/daam6",
    "\u60D5": "tik1",
    "\u60D6": "tik1",
    "\u60D7": "nam2/lam2",
    "\u60D8": "mong5",
    "\u60D9": "zyut3",
    "\u60DA": "fat1",
    "\u60DB": "fan1",
    "\u60DC": "sik1/sek3",
    "\u60DD": "cong2/tong2",
    "\u60DE": "jan1",
    "\u60DF": "wai4",
    "\u60E0": "wai6",
    "\u60E1": "ok3/ngok3/wu3/wu1",
    "\u60E2": "so2",
    "\u60E3": "zung2",
    "\u60E4": "gin1",
    "\u60E5": "jung2",
    "\u60E6": "dim3",
    "\u60E7": "geoi6",
    "\u60E8": "caam2",
    "\u60E9": "cing4",
    "\u60EA": "dak1",
    "\u60EB": "bei6/baai6",
    "\u60EC": "hip3/hip6",
    "\u60ED": "caam4",
    "\u60EE": "daan6",
    "\u60EF": "gwaan3",
    "\u60F0": "do6",
    "\u60F1": "nou5/lou5",
    "\u60F2": "wan6",
    "\u60F3": "soeng2",
    "\u60F4": "zeoi3",
    "\u60F5": "dip6",
    "\u60F6": "wong4",
    "\u60F7": "ceon2",
    "\u60F8": "king4",
    "\u60F9": "je5",
    "\u60FA": "sing1",
    "\u60FB": "cak1/caak1",
    "\u60FC": "bin2/pin2",
    "\u60FD": "fan1/man5",
    "\u60FE": "zung1",
    "\u60FF": "tai4",
    "\u6100": "ciu2",
    "\u6101": "sau4",
    "\u6102": "bui6",
    "\u6103": "syun1",
    "\u6104": "wui1",
    "\u6105": "gaak3",
    "\u6106": "hin1",
    "\u6107": "wai5",
    "\u6108": "jyu6",
    "\u6109": "jyu4/jyu6/tau1",
    "\u610A": "bik1",
    "\u610B": "hyun1",
    "\u610C": "wun6",
    "\u610D": "man5",
    "\u610E": "bik1",
    "\u610F": "ji3/ji1/ji2",
    "\u6110": "min5",
    "\u6111": "jung5",
    "\u6112": "koi3/kai3/hei3/hot3",
    "\u6113": "dong6/soeng1",
    "\u6114": "jam1",
    "\u6115": "ngok6/ok6",
    "\u6116": "sam4",
    "\u6117": "mau6",
    "\u6118": "kok3",
    "\u6119": "kok3",
    "\u611A": "jyu4",
    "\u611B": "oi3/ngoi3",
    "\u611C": "hip3/hip6",
    "\u611D": "jin2",
    "\u611E": "no6/lo6/jyun5",
    "\u611F": "gam2",
    "\u6120": "wan3",
    "\u6121": "zung2",
    "\u6122": "soi1",
    "\u6123": "ling6/ling4",
    "\u6124": "fan5",
    "\u6125": "jing1",
    "\u6126": "kui2/kwui2",
    "\u6127": "kwai5/kwai3",
    "\u6128": "kok3",
    "\u6129": "gung1",
    "\u612A": "wan4",
    "\u612B": "sou3",
    "\u612C": "saak3/sou3",
    "\u612D": "kei4",
    "\u612E": "jiu4",
    "\u612F": "sung2",
    "\u6130": "fong2",
    "\u6131": "zat6",
    "\u6132": "gwat1",
    "\u6133": "geoi6",
    "\u6134": "cong3",
    "\u6135": "nik6/lik6",
    "\u6136": "hip3",
    "\u6137": "hoi2",
    "\u6138": "zing2",
    "\u6139": "jung5",
    "\u613A": "cou2",
    "\u613B": "seon3",
    "\u613C": "san6",
    "\u613D": "bok3",
    "\u613E": "koi3",
    "\u613F": "jyun6/jyun2",
    "\u6140": "hai6",
    "\u6141": "wan6",
    "\u6142": "jung2",
    "\u6143": "ong2/ngong2",
    "\u6144": "leot6",
    "\u6145": "cou2/sou1",
    "\u6146": "tou1",
    "\u6147": "jan1",
    "\u6148": "ci4",
    "\u6149": "cuk1",
    "\u614A": "him3/hip3/jim4",
    "\u614B": "taai3",
    "\u614C": "fong1/fong2",
    "\u614D": "wan3",
    "\u614E": "san6",
    "\u614F": "ming5",
    "\u6150": "gung1",
    "\u6151": "sip3/zip3",
    "\u6152": "cung4",
    "\u6153": "piu3/piu5/piu4",
    "\u6154": "mou6",
    "\u6155": "mou6",
    "\u6156": "gwok3/gok3",
    "\u6157": "cik1",
    "\u6158": "caam2",
    "\u6159": "caam4",
    "\u615A": "caam4",
    "\u615B": "ceoi4",
    "\u615C": "man5",
    "\u615D": "tik1",
    "\u615E": "zoeng1",
    "\u615F": "dung6",
    "\u6160": "ngou6/ou6",
    "\u6161": "song2",
    "\u6162": "maan6/maan2",
    "\u6163": "gwaan3",
    "\u6164": "kok3",
    "\u6165": "zou6/cou3",
    "\u6166": "gau3",
    "\u6167": "wai6/wai2/wai4/wai3",
    "\u6168": "koi3",
    "\u6169": "lin4",
    "\u616A": "au3/ngau3/au1/ngau1",
    "\u616B": "sung2",
    "\u616C": "kan4",
    "\u616D": "jan6",
    "\u616E": "leoi6",
    "\u616F": "soeng1",
    "\u6170": "wai3",
    "\u6171": "tyun4",
    "\u6172": "mun4",
    "\u6173": "haan1",
    "\u6174": "sip3/zip3",
    "\u6175": "jung4",
    "\u6176": "hing3",
    "\u6177": "kong2/hong2",
    "\u6178": "dai3",
    "\u6179": "zap1/zip3",
    "\u617A": "lau4",
    "\u617B": "gyun3",
    "\u617C": "cik1",
    "\u617D": "cik1",
    "\u617E": "juk6",
    "\u617F": "pang4",
    "\u6180": "liu4",
    "\u6181": "zung2",
    "\u6182": "jau1",
    "\u6183": "cung1/zung1",
    "\u6184": "zi3",
    "\u6185": "dung6",
    "\u6186": "caang1",
    "\u6187": "hei3",
    "\u6188": "keoi1",
    "\u6189": "paang4",
    "\u618A": "bei6/baai6",
    "\u618B": "bit3",
    "\u618C": "king4",
    "\u618D": "giu1",
    "\u618E": "zang1",
    "\u618F": "cai3/zai3",
    "\u6190": "lin4",
    "\u6191": "pang4/peng1/bang6",
    "\u6192": "kui2/kwui2",
    "\u6193": "wai6",
    "\u6194": "ciu4",
    "\u6195": "cing4",
    "\u6196": "jan6",
    "\u6197": "jan6",
    "\u6198": "hei2",
    "\u6199": "hei2",
    "\u619A": "daan6",
    "\u619B": "taam4",
    "\u619C": "do6",
    "\u619D": "deoi6",
    "\u619E": "deoi6",
    "\u619F": "suk1",
    "\u61A0": "kyut3",
    "\u61A1": "caak3",
    "\u61A2": "hiu1",
    "\u61A3": "faan1",
    "\u61A4": "fan5",
    "\u61A5": "lou4",
    "\u61A6": "lou6",
    "\u61A7": "cung1",
    "\u61A8": "ham1",
    "\u61A9": "hei3",
    "\u61AA": "haan4/haan6",
    "\u61AB": "man5",
    "\u61AC": "ging2",
    "\u61AD": "liu5/liu4",
    "\u61AE": "mou5",
    "\u61AF": "caam2",
    "\u61B0": "kyut3",
    "\u61B1": "cuk1",
    "\u61B2": "hin3",
    "\u61B3": "taam2",
    "\u61B4": "sing4",
    "\u61B5": "pik1",
    "\u61B6": "jik1",
    "\u61B7": "co2/zeot1",
    "\u61B8": "cim1",
    "\u61B9": "nou4/lou4/nou5/lou5/nung4/lung4",
    "\u61BA": "daam6",
    "\u61BB": "taan2",
    "\u61BC": "ging2/ging3",
    "\u61BD": "sung1",
    "\u61BE": "ham6",
    "\u61BF": "giu1",
    "\u61C0": "wai3",
    "\u61C1": "hyun1",
    "\u61C2": "dung2",
    "\u61C3": "kan4",
    "\u61C4": "kan4",
    "\u61C5": "keoi4",
    "\u61C6": "cou2",
    "\u61C7": "han2",
    "\u61C8": "haai6/haai5/gaai3",
    "\u61C9": "jing3/jing1",
    "\u61CA": "ou3/ngou3",
    "\u61CB": "mau6",
    "\u61CC": "jik6",
    "\u61CD": "lam5",
    "\u61CE": "sik1",
    "\u61CF": "zeon3",
    "\u61D0": "waai4",
    "\u61D1": "mun6",
    "\u61D2": "laan5",
    "\u61D3": "oi3/ngoi3",
    "\u61D4": "lam5",
    "\u61D5": "jim1",
    "\u61D6": "kut3/kwut3",
    "\u61D7": "haa3",
    "\u61D8": "cit3",
    "\u61D9": "jyu5/jyu4",
    "\u61DA": "jan3",
    "\u61DB": "daai1",
    "\u61DC": "mung2/mung4/mung5",
    "\u61DD": "ngoi6/oi6",
    "\u61DE": "mung4",
    "\u61DF": "deoi6/zeoi6",
    "\u61E0": "cai4",
    "\u61E1": "mo5",
    "\u61E2": "laam4",
    "\u61E3": "mun6",
    "\u61E4": "cau4",
    "\u61E5": "zi3",
    "\u61E6": "no6/lo6",
    "\u61E7": "no6/lo6",
    "\u61E8": "jim1",
    "\u61E9": "joeng5",
    "\u61EA": "bok6",
    "\u61EB": "zi3",
    "\u61EC": "kwong3/kong3",
    "\u61ED": "kong3/kwong3",
    "\u61EE": "jau1/jau2",
    "\u61EF": "fu1",
    "\u61F0": "lau4",
    "\u61F1": "mit6",
    "\u61F2": "cing4",
    "\u61F3": "wai6",
    "\u61F4": "caam3",
    "\u61F5": "mung2/mung4/mung5",
    "\u61F6": "laan5",
    "\u61F7": "waai4",
    "\u61F8": "jyun4",
    "\u61F9": "joeng6",
    "\u61FA": "caam3",
    "\u61FB": "gei3",
    "\u61FC": "geoi6",
    "\u61FD": "fun1",
    "\u61FE": "sip3/zip3",
    "\u61FF": "ji3",
    "\u6200": "lyun2/lyun5",
    "\u6201": "naan5/laan5",
    "\u6202": "mei4",
    "\u6203": "tong2/cong2",
    "\u6204": "fok3",
    "\u6205": "zong3/ngong6/ong6",
    "\u6206": "zong3/ngong6/ong6",
    "\u6207": "zong3/ngong6/ong6",
    "\u6208": "gwo1/go1",
    "\u6209": "jyut6",
    "\u620A": "mou6",
    "\u620B": "zin1",
    "\u620C": "seot1",
    "\u620D": "syu3",
    "\u620E": "jung4",
    "\u620F": "hei3/hei1/fu1",
    "\u6210": "sing4/seng4/cing4",
    "\u6211": "ngo5/o5",
    "\u6212": "gaai3",
    "\u6213": "gap3",
    "\u6214": "zin1",
    "\u6215": "coeng4",
    "\u6216": "waak6/wik6",
    "\u6217": "coeng1/coeng3",
    "\u6218": "zin3",
    "\u6219": "dung6/dung2/dong6",
    "\u621A": "cik1/cuk1",
    "\u621B": "gaat3",
    "\u621C": "dit6",
    "\u621D": "caak3",
    "\u621E": "gaat3",
    "\u621F": "gik1",
    "\u6220": "zik1",
    "\u6221": "ham1",
    "\u6222": "cap1",
    "\u6223": "kwai4",
    "\u6224": "koi3",
    "\u6225": "dang2/dang6",
    "\u6226": "zin3",
    "\u6227": "coeng1/coeng3",
    "\u6228": "go1",
    "\u6229": "zin2",
    "\u622A": "zit6/zit2",
    "\u622B": "juk1",
    "\u622C": "zin2",
    "\u622D": "jan5/jin2",
    "\u622E": "luk6",
    "\u622F": "hei3/fu1",
    "\u6230": "zin3",
    "\u6231": "hei3/fu1",
    "\u6232": "hei3/hei1/fu1",
    "\u6233": "coek3/cok3",
    "\u6234": "daai3",
    "\u6235": "keoi4",
    "\u6236": "wu6",
    "\u6237": "wu6",
    "\u6238": "wu6",
    "\u6239": "ak1/aak1/ngaak1/ngak1",
    "\u623A": "si6",
    "\u623B": "dai6",
    "\u623C": "maau5",
    "\u623D": "fu3",
    "\u623E": "leoi6/lit6/lai2",
    "\u623F": "fong4/fong2/pong4",
    "\u6240": "so2",
    "\u6241": "bin2/pin1",
    "\u6242": "dim3",
    "\u6243": "gwing1/gwing2",
    "\u6244": "soeng2",
    "\u6245": "ji4",
    "\u6246": "ji2",
    "\u6247": "sin3/sin2",
    "\u6248": "wu6",
    "\u6249": "fei1",
    "\u624A": "jim5",
    "\u624B": "sau2",
    "\u624C": "sau2/tik1.sau2.bin1",
    "\u624D": "coi4/coi2",
    "\u624E": "zaat3/zaat2",
    "\u624F": "kau4",
    "\u6250": "lak6/lik1",
    "\u6251": "pok3/puk1/bik1",
    "\u6252": "paa4/paa2/paa1",
    "\u6253": "daa2/daa1",
    "\u6254": "jing4/wing1",
    "\u6255": "faan2",
    "\u6256": "jap6",
    "\u6257": "zoi6",
    "\u6258": "tok3/tok2",
    "\u6259": "zoeng6",
    "\u625A": "tiu2",
    "\u625B": "gong1/kong1",
    "\u625C": "jyu1",
    "\u625D": "fu1",
    "\u625E": "gon2/hon6/hon2/hon5",
    "\u625F": "san1",
    "\u6260": "caa1",
    "\u6261": "ci2/to1",
    "\u6262": "gwat1/ngat6/at6",
    "\u6263": "kau3/kau2",
    "\u6264": "ngaat6/aat6/ngat6/at6/wat6/ngat1/at1",
    "\u6265": "dan3",
    "\u6266": "cin1",
    "\u6267": "zap1",
    "\u6268": "jan6",
    "\u6269": "kwok3/kok3/kong3/kwong3",
    "\u626A": "mun4",
    "\u626B": "sou3/sou2",
    "\u626C": "joeng4/joeng2",
    "\u626D": "nau2/lau2",
    "\u626E": "baan6/baan3",
    "\u626F": "ce2",
    "\u6270": "jiu2/jiu5",
    "\u6271": "kap1/caap3",
    "\u6272": "ngam4/am4/kam4",
    "\u6273": "paan1/baan2",
    "\u6274": "git3",
    "\u6275": "jyu1/wu1",
    "\u6276": "fu4",
    "\u6277": "ou3/ngou3",
    "\u6278": "sik1",
    "\u6279": "pai1/pei4",
    "\u627A": "zi2",
    "\u627B": "ham2/ham6/zit3",
    "\u627C": "ak1/aak1/ngaak1/ngak1",
    "\u627D": "dan3/dan6",
    "\u627E": "zaau2",
    "\u627F": "sing4",
    "\u6280": "gei6",
    "\u6281": "jin5",
    "\u6282": "kwong4/kong4",
    "\u6283": "bin6",
    "\u6284": "caau1",
    "\u6285": "keoi1",
    "\u6286": "man5/man2",
    "\u6287": "wat6",
    "\u6288": "jyut6",
    "\u6289": "kyut3",
    "\u628A": "baa2/baa3/paa4",
    "\u628B": "cam3",
    "\u628C": "dam2",
    "\u628D": "sing1",
    "\u628E": "wan5",
    "\u628F": "jyun4/waan4/wun6",
    "\u6290": "neot6/leot6",
    "\u6291": "jik1",
    "\u6292": "syu1",
    "\u6293": "zaau2/zaa1/aau1/ngaau1/waa2",
    "\u6294": "pau4",
    "\u6295": "tau4",
    "\u6296": "dau2",
    "\u6297": "kong3",
    "\u6298": "zit3/zip3/zip2",
    "\u6299": "pau4",
    "\u629A": "fu2",
    "\u629B": "paau1",
    "\u629C": "bat6",
    "\u629D": "aau2/ngaau2/aau3/ngaau3",
    "\u629E": "zaak6",
    "\u629F": "tyun4/zyun1",
    "\u62A0": "kau1",
    "\u62A1": "leon4",
    "\u62A2": "coeng2/coeng1",
    "\u62A3": "gwan1",
    "\u62A4": "wu6",
    "\u62A5": "bou3",
    "\u62A6": "bing2",
    "\u62A7": "zi2",
    "\u62A8": "ping1/ping4/paang1",
    "\u62A9": "naam4/laam4",
    "\u62AA": "bo3",
    "\u62AB": "pei1",
    "\u62AC": "toi4",
    "\u62AD": "jiu5",
    "\u62AE": "zan2/hin2",
    "\u62AF": "zaa1",
    "\u62B0": "joeng2",
    "\u62B1": "pou5/bou6",
    "\u62B2": "ho1",
    "\u62B3": "nei5/lei5",
    "\u62B4": "jit6/jai6",
    "\u62B5": "dai2",
    "\u62B6": "cik1",
    "\u62B7": "pei1",
    "\u62B8": "hip3",
    "\u62B9": "mut3/maat3",
    "\u62BA": "mui6",
    "\u62BB": "can2",
    "\u62BC": "aat3/ngaat3/aat2/ngaat2/aap3/ngaap3",
    "\u62BD": "cau1",
    "\u62BE": "gip3/keoi1/hei1",
    "\u62BF": "man5/man2",
    "\u62C0": "zuk1",
    "\u62C1": "ke2",
    "\u62C2": "fat1/bat6",
    "\u62C3": "zaa3/zaa6",
    "\u62C4": "zyu2",
    "\u62C5": "daam1/daam3/daam2",
    "\u62C6": "caak3",
    "\u62C7": "mou5",
    "\u62C8": "nim1/lim1/nim2/lim2/nin2/lin2/nin5/lin5/dim1",
    "\u62C9": "laai1/laai6/laat6/laap6",
    "\u62CA": "fu2",
    "\u62CB": "paau1",
    "\u62CC": "bun6/pun3",
    "\u62CD": "paak3/paak2",
    "\u62CE": "ling1/ning1",
    "\u62CF": "naa4/laa4",
    "\u62D0": "gwaai2",
    "\u62D1": "kim4",
    "\u62D2": "keoi5",
    "\u62D3": "tok3/taap3",
    "\u62D4": "bat6",
    "\u62D5": "to1",
    "\u62D6": "to1",
    "\u62D7": "aau2/ngaau2/aau3/ngaau3",
    "\u62D8": "keoi1",
    "\u62D9": "zyut3/zyut6",
    "\u62DA": "pun3/pun2/ping1/bin6",
    "\u62DB": "ziu1",
    "\u62DC": "baai3/baai1",
    "\u62DD": "baai3",
    "\u62DE": "dai2",
    "\u62DF": "ji5/ji4",
    "\u62E0": "geoi3",
    "\u62E1": "kwok3/kok3",
    "\u62E2": "lung5/lung2",
    "\u62E3": "gaan2",
    "\u62E4": "kaa1",
    "\u62E5": "jung2",
    "\u62E6": "laan4",
    "\u62E7": "ning6/ling6/ning2/ling2/ning4/ling4",
    "\u62E8": "but6/but2",
    "\u62E9": "zaak6",
    "\u62EA": "cin1",
    "\u62EB": "hang4",
    "\u62EC": "kut3/kwut3/gwaat3",
    "\u62ED": "sik1",
    "\u62EE": "git3/gaat3",
    "\u62EF": "cing2",
    "\u62F0": "nam5/lam5",
    "\u62F1": "gung2",
    "\u62F2": "gung2",
    "\u62F3": "kyun4/kyun2",
    "\u62F4": "saan1/cyun4",
    "\u62F5": "cyun4",
    "\u62F6": "zaat3/zaan2",
    "\u62F7": "haau2/haau1",
    "\u62F8": "ji4",
    "\u62F9": "hip3",
    "\u62FA": "caak3",
    "\u62FB": "fui1",
    "\u62FC": "ping1/ping3/pun3/pun2",
    "\u62FD": "jai6/jit6",
    "\u62FE": "sap6/sip3/gip6",
    "\u62FF": "naa4/laa4/naa2/laa2",
    "\u6300": "baak3",
    "\u6301": "ci4/ci2",
    "\u6302": "gwaa3/kwaa3",
    "\u6303": "zat6",
    "\u6304": "kwok3/kok3",
    "\u6305": "do2",
    "\u6306": "do2",
    "\u6307": "zi2",
    "\u6308": "kit3",
    "\u6309": "on3/ngon3",
    "\u630A": "lung6",
    "\u630B": "zan3",
    "\u630C": "gaak3",
    "\u630D": "haau6",
    "\u630E": "kwaa3/fu1",
    "\u630F": "dung6/tung4",
    "\u6310": "jyu4/naau4/laau4/naa4/laa4",
    "\u6311": "tiu1/tou1/tiu5",
    "\u6312": "lit6",
    "\u6313": "zaa1",
    "\u6314": "leoi5",
    "\u6315": "dip3",
    "\u6316": "waat3/waat2/waa1",
    "\u6317": "kyut3",
    "\u6318": "lyut3",
    "\u6319": "geoi2",
    "\u631A": "zi3",
    "\u631B": "lyun4/lyun1",
    "\u631C": "aa3/ngaa6/aa6/ngaa3",
    "\u631D": "zaa1/wo1",
    "\u631E": "taat3/taat1",
    "\u631F": "hip3/haap6/gaap3/hip6",
    "\u6320": "naau4/laau4/naau2/laau2/naau5/laau5",
    "\u6321": "dong2/dong3",
    "\u6322": "giu2",
    "\u6323": "zang1/zaang1/zaang6",
    "\u6324": "zai1",
    "\u6325": "fai1",
    "\u6326": "cam4/cim4",
    "\u6327": "jyu5",
    "\u6328": "aai1/ngaai1/ngaai4/aai4",
    "\u6329": "tyut3/seoi3",
    "\u632A": "no4/lo4",
    "\u632B": "co3",
    "\u632C": "but6",
    "\u632D": "gaang3",
    "\u632E": "tai2",
    "\u632F": "zan3",
    "\u6330": "caang4",
    "\u6331": "so1/saa1",
    "\u6332": "so1/saa1",
    "\u6333": "hang1",
    "\u6334": "mui5",
    "\u6335": "lung6",
    "\u6336": "guk6/guk1",
    "\u6337": "pong3",
    "\u6338": "gin2",
    "\u6339": "jap1",
    "\u633A": "ting5/ting2",
    "\u633B": "saan1",
    "\u633C": "no4/lo4",
    "\u633D": "waan5/maan5",
    "\u633E": "hip3/haap6/gaap3/hip6",
    "\u633F": "caap3",
    "\u6340": "fung4",
    "\u6341": "gaau2",
    "\u6342": "wu2/ng6/m6",
    "\u6343": "kwan2/kwan3",
    "\u6344": "kau4/geoi1/gau3",
    "\u6345": "tung2",
    "\u6346": "kwan2",
    "\u6347": "waak6",
    "\u6348": "tou4",
    "\u6349": "zuk1/zuk3",
    "\u634A": "pau4",
    "\u634B": "lyut3",
    "\u634C": "baat3",
    "\u634D": "hon6/hon2/hon5",
    "\u634E": "saau1",
    "\u634F": "nip6/lip6",
    "\u6350": "gyun1",
    "\u6351": "zik6",
    "\u6352": "cuk1",
    "\u6353": "je4",
    "\u6354": "gok3",
    "\u6355": "bou6",
    "\u6356": "gwaat3/jyun4",
    "\u6357": "bou6",
    "\u6358": "zyun3/zeon3",
    "\u6359": "jai6",
    "\u635A": "zaai1",
    "\u635B": "leoi5",
    "\u635C": "sau1",
    "\u635D": "tyut3/seoi3",
    "\u635E": "laau4/laau1/lou1/lou4",
    "\u635F": "syun2",
    "\u6360": "bang1",
    "\u6361": "gim2",
    "\u6362": "wun6",
    "\u6363": "dou2",
    "\u6364": "mei5",
    "\u6365": "wun2",
    "\u6366": "kam4",
    "\u6367": "pung2/bung2",
    "\u6368": "se2/se5",
    "\u6369": "lit6/lai6/leoi6",
    "\u636A": "man4",
    "\u636B": "mun4",
    "\u636C": "fu2",
    "\u636D": "baai2",
    "\u636E": "geoi3/geoi1",
    "\u636F": "dou3",
    "\u6370": "wo2",
    "\u6371": "ngaai4/aai4",
    "\u6372": "gyun2",
    "\u6373": "ngok6/ok6",
    "\u6374": "zung2",
    "\u6375": "tin2/din2/can2",
    "\u6376": "ceoi4",
    "\u6377": "zit6/zit3/cip3",
    "\u6378": "teot1",
    "\u6379": "ban3/fing6/fang6",
    "\u637A": "naat6/laat6",
    "\u637B": "nim2/lim2/nin2/lin2/nip6/lip6",
    "\u637C": "no4/lo4",
    "\u637D": "zeot1/cyut3/zyut6",
    "\u637E": "wut6",
    "\u637F": "cai1",
    "\u6380": "hin1",
    "\u6381": "caang4",
    "\u6382": "dim1/dim6/dim3",
    "\u6383": "sou3/sou2",
    "\u6384": "leon4",
    "\u6385": "cing3",
    "\u6386": "gong1",
    "\u6387": "zyut3/dyut3",
    "\u6388": "sau6",
    "\u6389": "diu6/zaau6/deu6",
    "\u638A": "pau2/pau4",
    "\u638B": "dai2",
    "\u638C": "zoeng2",
    "\u638D": "wan6/gwan2",
    "\u638E": "gei2/gei1",
    "\u638F": "tou4/tou1",
    "\u6390": "haap3",
    "\u6391": "kei4",
    "\u6392": "paai4/paai2",
    "\u6393": "suk1",
    "\u6394": "haan1/hin1",
    "\u6395": "ling4",
    "\u6396": "jik6/jip3",
    "\u6397": "aa3/ngaa6/aa6/ngaa3",
    "\u6398": "gwat6",
    "\u6399": "zang1/zaang1/zaang6",
    "\u639A": "loeng5",
    "\u639B": "gwaa3/kwaa3",
    "\u639C": "ngai5/ai5/nip6/lip6",
    "\u639D": "waak6",
    "\u639E": "sim3/jim5/jim6",
    "\u639F": "deng3",
    "\u63A0": "loek6",
    "\u63A1": "coi2",
    "\u63A2": "taam3/taam1",
    "\u63A3": "zai3/cit3",
    "\u63A4": "bing1",
    "\u63A5": "zip3",
    "\u63A6": "tik1",
    "\u63A7": "hung3",
    "\u63A8": "teoi1",
    "\u63A9": "jim2",
    "\u63AA": "cou3",
    "\u63AB": "zau1",
    "\u63AC": "guk1",
    "\u63AD": "tim5/tim3",
    "\u63AE": "kin4",
    "\u63AF": "kang3",
    "\u63B0": "maak3/baai1",
    "\u63B1": "paa4",
    "\u63B2": "kit3",
    "\u63B3": "lou5",
    "\u63B4": "gwaak3/gwok3/gok3",
    "\u63B5": "ming6",
    "\u63B6": "zit6",
    "\u63B7": "zaak6",
    "\u63B8": "daan6/sin6",
    "\u63B9": "mang1/mang3",
    "\u63BA": "caam1/saam1/cam1/cam3",
    "\u63BB": "sou1",
    "\u63BC": "gwaan3",
    "\u63BD": "pung3",
    "\u63BE": "jyun6",
    "\u63BF": "nok6/lok6",
    "\u63C0": "gaan2",
    "\u63C1": "zing1",
    "\u63C2": "zau1",
    "\u63C3": "zin2/zin1",
    "\u63C4": "jyu4",
    "\u63C5": "jin4",
    "\u63C6": "kwai4/kwai5",
    "\u63C7": "naam5/laam5/naam3/laam3",
    "\u63C8": "fang4/gwang1",
    "\u63C9": "jau4",
    "\u63CA": "bik1",
    "\u63CB": "wui1",
    "\u63CC": "sak1",
    "\u63CD": "zau3",
    "\u63CE": "syun1",
    "\u63CF": "miu4",
    "\u63D0": "tai4",
    "\u63D1": "nip6/lip6",
    "\u63D2": "caap3/caap2",
    "\u63D3": "ci3",
    "\u63D4": "zung2",
    "\u63D5": "zam3",
    "\u63D6": "jap1/cap1",
    "\u63D7": "tan4",
    "\u63D8": "wing4",
    "\u63D9": "bin1",
    "\u63DA": "joeng4/joeng2",
    "\u63DB": "wun6",
    "\u63DC": "jim2",
    "\u63DD": "zaan2/zaan6",
    "\u63DE": "am2/ngam2",
    "\u63DF": "seoi1",
    "\u63E0": "aat3/ngaat3",
    "\u63E1": "ak1/aak1/ngaak1/ngak1/au3/ngau3",
    "\u63E2": "kaa1/kik1/kaak3/kak1",
    "\u63E3": "ceoi2/cyun2/caai1",
    "\u63E4": "zat1/zeot1",
    "\u63E5": "dai3/tai3",
    "\u63E6": "laa2/laa5/laa3",
    "\u63E7": "laat6",
    "\u63E8": "caang4",
    "\u63E9": "haai1",
    "\u63EA": "zau1",
    "\u63EB": "zau1",
    "\u63EC": "dat6",
    "\u63ED": "kit3/kai3/gai6",
    "\u63EE": "fai1",
    "\u63EF": "gang1",
    "\u63F0": "cung3",
    "\u63F1": "siu1/sok3",
    "\u63F2": "sit3/dip6/jip6",
    "\u63F3": "sit3/sip3",
    "\u63F4": "wun4/jyun4/jyun6",
    "\u63F5": "kin4",
    "\u63F6": "je4",
    "\u63F7": "caap3",
    "\u63F8": "zaa1/zaa2",
    "\u63F9": "bui3",
    "\u63FA": "jiu4",
    "\u63FB": "wai1",
    "\u63FC": "dam1/dam3/dam2/dap6/dam4",
    "\u63FD": "laam5/laam2",
    "\u63FE": "wan2/wan3",
    "\u63FF": "gam6",
    "\u6400": "caam1",
    "\u6401": "gok3",
    "\u6402": "lau1/lau2/lau5/lau4",
    "\u6403": "zung2",
    "\u6404": "gang1",
    "\u6405": "gaau2",
    "\u6406": "kau3/gau3",
    "\u6407": "kam2/gam6",
    "\u6408": "jung4",
    "\u6409": "kok1/kok3",
    "\u640A": "cau1/cai1",
    "\u640B": "caai1",
    "\u640C": "zin2",
    "\u640D": "syun2",
    "\u640E": "syun1",
    "\u640F": "bok3",
    "\u6410": "cuk1",
    "\u6411": "jung4",
    "\u6412": "pong3/paang4",
    "\u6413": "co1",
    "\u6414": "sou1",
    "\u6415": "hap6/ap1/ngap1",
    "\u6416": "jiu4/jiu2",
    "\u6417": "dou2",
    "\u6418": "zi1",
    "\u6419": "nuk6/luk6",
    "\u641A": "lap6/laap6",
    "\u641B": "gim1",
    "\u641C": "sau1/sau2",
    "\u641D": "hau2",
    "\u641E": "gaau2",
    "\u641F": "hin2",
    "\u6420": "sok3",
    "\u6421": "song2",
    "\u6422": "zeon3",
    "\u6423": "mit1",
    "\u6424": "ak1/aak1/ngaak1/ngak1",
    "\u6425": "ceoi4",
    "\u6426": "nik1/lik1/nok6/lok6",
    "\u6427": "sin3",
    "\u6428": "taap3",
    "\u6429": "git6",
    "\u642A": "tong4/tong2/tong5",
    "\u642B": "pun4",
    "\u642C": "bun1",
    "\u642D": "daap3",
    "\u642E": "leot6",
    "\u642F": "tou1/tou4",
    "\u6430": "wat6/fat1",
    "\u6431": "zi6",
    "\u6432": "waa2/we2",
    "\u6433": "waak6",
    "\u6434": "hin1",
    "\u6435": "wan2/wan3",
    "\u6436": "coeng2/coeng1",
    "\u6437": "tin4",
    "\u6438": "zeon1",
    "\u6439": "ngak1/ak1/gaak3",
    "\u643A": "kwai4",
    "\u643B": "nik1/lik1/nok6/lok6",
    "\u643C": "kyun4",
    "\u643D": "caa4",
    "\u643E": "zaa3",
    "\u643F": "gaap3/gap3",
    "\u6440": "wu2/ng6/m6",
    "\u6441": "on3/ngon3",
    "\u6442": "sip3",
    "\u6443": "kong1/gong1",
    "\u6444": "sip3/zip3/nip6/lip6",
    "\u6445": "syu1",
    "\u6446": "baai2/bei1",
    "\u6447": "jiu4",
    "\u6448": "ban3",
    "\u6449": "sau1",
    "\u644A": "taan1",
    "\u644B": "saat3",
    "\u644C": "caan2",
    "\u644D": "suk1",
    "\u644E": "gau1/lau4",
    "\u644F": "zung1",
    "\u6450": "cung1/coeng1",
    "\u6451": "gwaak3/gwok3/gok3",
    "\u6452": "bing3/bing2",
    "\u6453": "fung4",
    "\u6454": "seot1",
    "\u6455": "dai3",
    "\u6456": "cai3",
    "\u6457": "cuk1",
    "\u6458": "zaak6",
    "\u6459": "lin5/lin2",
    "\u645A": "tong3",
    "\u645B": "ci1/lei4",
    "\u645C": "gwaan3",
    "\u645D": "luk6",
    "\u645E": "lo3/lo6",
    "\u645F": "lau1/lau2/lau5/lau4",
    "\u6460": "zung2",
    "\u6461": "goi3",
    "\u6462": "wu6",
    "\u6463": "zaa1",
    "\u6464": "coeng2",
    "\u6465": "tong3",
    "\u6466": "waa6",
    "\u6467": "ceoi1",
    "\u6468": "naai4/laai4",
    "\u6469": "mo1/maa1",
    "\u646A": "zoeng1",
    "\u646B": "kwai1",
    "\u646C": "jing2",
    "\u646D": "zek3",
    "\u646E": "ngou4/ou4",
    "\u646F": "zi3",
    "\u6470": "jit6",
    "\u6471": "maan1",
    "\u6472": "saam3",
    "\u6473": "kau1",
    "\u6474": "syu1",
    "\u6475": "saak3/cik1",
    "\u6476": "tyun4/zyun1",
    "\u6477": "ziu6",
    "\u6478": "mo2/mou4",
    "\u6479": "mou4",
    "\u647A": "zip3/zaap3/zip2",
    "\u647B": "caam1/saam1/cam1/cam3",
    "\u647C": "hang1",
    "\u647D": "biu1/piu1/piu5",
    "\u647E": "koeng5",
    "\u647F": "jiu4",
    "\u6480": "gau3",
    "\u6481": "hin1",
    "\u6482": "liu1",
    "\u6483": "gik1",
    "\u6484": "jing1",
    "\u6485": "kyut3/gwat6/gwai3",
    "\u6486": "pit3",
    "\u6487": "pit3",
    "\u6488": "laau4/laau1/lou1/lou4",
    "\u6489": "dan3",
    "\u648A": "haan6/haan5",
    "\u648B": "jyun4/no4/lo4",
    "\u648C": "gwai6",
    "\u648D": "zaan2/cim4",
    "\u648E": "ji3",
    "\u648F": "cam4/cim4",
    "\u6490": "caang1/caang3",
    "\u6491": "caang1",
    "\u6492": "saat3",
    "\u6493": "naau4/laau4/naau2/laau2/naau5/laau5",
    "\u6494": "wang6",
    "\u6495": "si1",
    "\u6496": "hon6/ham5",
    "\u6497": "gwong3/gong3",
    "\u6498": "daap3",
    "\u6499": "zyun2",
    "\u649A": "nan2/lan2/nim2/lim2/nin2/lin2/nin5/lin5",
    "\u649B": "leon5",
    "\u649C": "cing2/caang4",
    "\u649D": "fai1",
    "\u649E": "zong6/zong2",
    "\u649F": "giu2",
    "\u64A0": "gik1",
    "\u64A1": "cou1/cou3",
    "\u64A2": "taam3/taam2/ngam4/am4/daan6",
    "\u64A3": "daan6/sin6",
    "\u64A4": "cit3",
    "\u64A5": "but6/but2",
    "\u64A6": "ce2",
    "\u64A7": "zyut6/zyut3",
    "\u64A8": "siu1",
    "\u64A9": "liu4/liu1",
    "\u64AA": "ban6",
    "\u64AB": "fu2",
    "\u64AC": "giu6/hiu3",
    "\u64AD": "bo3",
    "\u64AE": "cyut3/caai2",
    "\u64AF": "zoek3",
    "\u64B0": "zaan6/zaan3",
    "\u64B1": "wai5",
    "\u64B2": "pok3/puk1",
    "\u64B3": "gam6",
    "\u64B4": "deon1/dan3",
    "\u64B5": "lin5",
    "\u64B6": "waa1",
    "\u64B7": "kit3/git3",
    "\u64B8": "lou5",
    "\u64B9": "gaau2",
    "\u64BA": "cyun3/cyun2",
    "\u64BB": "taat3/taat1",
    "\u64BC": "ham6/ham2",
    "\u64BD": "gik1/kiu3/haau3",
    "\u64BE": "zaa1/wo1",
    "\u64BF": "gim2",
    "\u64C0": "gon2",
    "\u64C1": "jung2",
    "\u64C2": "leoi4",
    "\u64C3": "nong5/long5",
    "\u64C4": "lou5",
    "\u64C5": "sin6",
    "\u64C6": "zoek3",
    "\u64C7": "zaak6",
    "\u64C8": "pok3",
    "\u64C9": "cok3",
    "\u64CA": "gik1",
    "\u64CB": "dong2/dong3",
    "\u64CC": "saak3",
    "\u64CD": "cou1/cou3",
    "\u64CE": "king4",
    "\u64CF": "king4/geng6",
    "\u64D0": "gwaan3/gwaan1",
    "\u64D1": "zip3",
    "\u64D2": "kam4",
    "\u64D3": "kwaai5",
    "\u64D4": "daam1/daam3/daam2",
    "\u64D5": "kwai4",
    "\u64D6": "kaa1/kaat3/gaat3/jip6",
    "\u64D7": "pik1/pek6",
    "\u64D8": "maak3/baai1",
    "\u64D9": "ngou1/ou1",
    "\u64DA": "geoi3",
    "\u64DB": "jip6",
    "\u64DC": "ngaat6/aat6",
    "\u64DD": "mang1",
    "\u64DE": "sau2/sau3",
    "\u64DF": "mei4",
    "\u64E0": "zai1",
    "\u64E1": "toi4",
    "\u64E2": "zok6",
    "\u64E3": "dou2",
    "\u64E4": "sang3",
    "\u64E5": "laam5/laam2",
    "\u64E6": "caat3/caat2",
    "\u64E7": "geoi2",
    "\u64E8": "je4",
    "\u64E9": "jyu5/jeoi5/jyu6",
    "\u64EA": "jip3/aap3/ngaap3",
    "\u64EB": "jip3",
    "\u64EC": "ji5/ji4",
    "\u64ED": "wok6",
    "\u64EE": "zit6",
    "\u64EF": "ban3",
    "\u64F0": "ning6/ling6/ning2/ling2/ning4/ling4",
    "\u64F1": "gok3",
    "\u64F2": "zaak6",
    "\u64F3": "zit1",
    "\u64F4": "kwok3/kok3/kong3/kwong3",
    "\u64F5": "mo1",
    "\u64F6": "zin3",
    "\u64F7": "kit3/git3",
    "\u64F8": "laap3/lip6/laap6",
    "\u64F9": "taan1",
    "\u64FA": "baai2",
    "\u64FB": "sau2/sau3",
    "\u64FC": "lou5",
    "\u64FD": "lik6/loek6",
    "\u64FE": "jiu2/jiu5",
    "\u64FF": "tik1/zaak6/zek3",
    "\u6500": "paan1",
    "\u6501": "joeng5",
    "\u6502": "leoi4",
    "\u6503": "caat3",
    "\u6504": "syu1",
    "\u6505": "cyun4",
    "\u6506": "lin5",
    "\u6507": "hin2",
    "\u6508": "kwan2/kwan3",
    "\u6509": "fok3/kok3",
    "\u650A": "lik6",
    "\u650B": "laai6",
    "\u650C": "waan6",
    "\u650D": "jing4",
    "\u650E": "lou4",
    "\u650F": "lung5/lung2",
    "\u6510": "hin1",
    "\u6511": "hin1",
    "\u6512": "cyun4/zaan2/zyun2",
    "\u6513": "hin1",
    "\u6514": "laan4",
    "\u6515": "cim1/saam1",
    "\u6516": "jing1",
    "\u6517": "mei4",
    "\u6518": "joeng4/joeng5/joeng6",
    "\u6519": "caam1",
    "\u651A": "jing4",
    "\u651B": "cyun3/cyun2",
    "\u651C": "kwai4",
    "\u651D": "sip3/zip3/nip6/lip6",
    "\u651E": "lyut3/lo2/lo1",
    "\u651F": "kwan2/kwan3",
    "\u6520": "mei4",
    "\u6521": "ci1/lei4",
    "\u6522": "cyun4/zaan2/zyun2",
    "\u6523": "lyun4/lyun1",
    "\u6524": "taan1",
    "\u6525": "zaan6",
    "\u6526": "lai6",
    "\u6527": "din1/dit6",
    "\u6528": "waa2",
    "\u6529": "dong2",
    "\u652A": "gaau2",
    "\u652B": "fok3",
    "\u652C": "laam5/laam2",
    "\u652D": "lai5/lai6",
    "\u652E": "nong5/long5",
    "\u652F": "zi1",
    "\u6530": "gui6/gwui6",
    "\u6531": "gwai2",
    "\u6532": "kei1",
    "\u6533": "cam4",
    "\u6534": "pok3/bok1",
    "\u6535": "pok3/faan2.man4.bin1",
    "\u6536": "sau1",
    "\u6537": "haau2",
    "\u6538": "jau4",
    "\u6539": "goi2",
    "\u653A": "ji5",
    "\u653B": "gung1",
    "\u653C": "gon1",
    "\u653D": "baan1/ban1",
    "\u653E": "fong3/fong2",
    "\u653F": "zing3",
    "\u6540": "baak3",
    "\u6541": "dim1",
    "\u6542": "kau3",
    "\u6543": "man5",
    "\u6544": "mou6",
    "\u6545": "gu3/gwu3/gu2/gwu2",
    "\u6546": "hap6",
    "\u6547": "caak3",
    "\u6548": "haau6",
    "\u6549": "mei5/mai5",
    "\u654A": "cuk1",
    "\u654B": "gok3",
    "\u654C": "dik6",
    "\u654D": "zeoi6",
    "\u654E": "gaau3/gaau1",
    "\u654F": "man5",
    "\u6550": "san4",
    "\u6551": "gau3",
    "\u6552": "san1",
    "\u6553": "dyut6",
    "\u6554": "jyu5",
    "\u6555": "cik1",
    "\u6556": "ngou4/ou4/ngou6/ou6",
    "\u6557": "baai6",
    "\u6558": "zeoi6",
    "\u6559": "gaau3/gaau1",
    "\u655A": "dyut6",
    "\u655B": "lim5/lim6",
    "\u655C": "nip6/lip6",
    "\u655D": "bai6",
    "\u655E": "cong2",
    "\u655F": "din2",
    "\u6560": "zyut3/dyut3",
    "\u6561": "ji6",
    "\u6562": "gam2",
    "\u6563": "saan3/saan2",
    "\u6564": "fo2",
    "\u6565": "jim6",
    "\u6566": "deon1/deoi1/deoi3/tyun4",
    "\u6567": "gei1",
    "\u6568": "tau2",
    "\u6569": "haau6/hok6",
    "\u656A": "zyut3",
    "\u656B": "giu3/giu2",
    "\u656C": "ging3",
    "\u656D": "joeng4",
    "\u656E": "hap1",
    "\u656F": "man5",
    "\u6570": "sou3/sou2/sok3/cuk1",
    "\u6571": "ngoi4/oi4",
    "\u6572": "haau1",
    "\u6573": "ngoi4/oi4",
    "\u6574": "zing2",
    "\u6575": "dik6",
    "\u6576": "can4",
    "\u6577": "fu1",
    "\u6578": "sou3/sou2/sok3/cuk1",
    "\u6579": "liu4",
    "\u657A": "keoi1",
    "\u657B": "hing3/hyun3",
    "\u657C": "ji2",
    "\u657D": "giu2",
    "\u657E": "sin6",
    "\u657F": "giu2",
    "\u6580": "zoek3",
    "\u6581": "jik6/dou3",
    "\u6582": "lim5/lim6",
    "\u6583": "bai6",
    "\u6584": "lei4/toi4",
    "\u6585": "haau6/hok6",
    "\u6586": "haau6/hok6",
    "\u6587": "man4/man2/man6/man1",
    "\u6588": "hok6",
    "\u6589": "cai4",
    "\u658A": "cai4",
    "\u658B": "zaai1",
    "\u658C": "ban1",
    "\u658D": "gok3",
    "\u658E": "zaai1",
    "\u658F": "loeng4",
    "\u6590": "fei2/fei1",
    "\u6591": "baan1",
    "\u6592": "baan1",
    "\u6593": "laan4/laan6",
    "\u6594": "jyu4",
    "\u6595": "laan4/laan6",
    "\u6596": "mei5",
    "\u6597": "dau3/dau2",
    "\u6598": "sing1",
    "\u6599": "liu6/liu2",
    "\u659A": "gaa2",
    "\u659B": "huk6/fuk6",
    "\u659C": "ce4/ce2/ce3/je4",
    "\u659D": "gaa2",
    "\u659E": "jyu4/jyu5",
    "\u659F": "zam1",
    "\u65A0": "gaau3/gok3",
    "\u65A1": "waat3/gun2/gwun2",
    "\u65A2": "tau3",
    "\u65A3": "dau3",
    "\u65A4": "gan1",
    "\u65A5": "cik1",
    "\u65A6": "ngan4/an4",
    "\u65A7": "fu2",
    "\u65A8": "coeng1",
    "\u65A9": "zaam2",
    "\u65AA": "keoi4",
    "\u65AB": "zoek3",
    "\u65AC": "zaam2",
    "\u65AD": "dyun6/tyun5/dyun3",
    "\u65AE": "zoek3",
    "\u65AF": "si1",
    "\u65B0": "san1",
    "\u65B1": "zoek3",
    "\u65B2": "zoek3",
    "\u65B3": "kan4",
    "\u65B4": "leon4",
    "\u65B5": "zoek3",
    "\u65B6": "cuk1/zuk1",
    "\u65B7": "dyun6/tyun5/dyun3",
    "\u65B8": "zuk1",
    "\u65B9": "fong1",
    "\u65BA": "cin2",
    "\u65BB": "hong4",
    "\u65BC": "jyu1/wu1",
    "\u65BD": "si1/ji6",
    "\u65BE": "pui3",
    "\u65BF": "jau4/lau4",
    "\u65C0": "ji5",
    "\u65C1": "pong4/bong6",
    "\u65C2": "kei4",
    "\u65C3": "zin1",
    "\u65C4": "mou4/mou6",
    "\u65C5": "leoi5",
    "\u65C6": "pui3",
    "\u65C7": "pei1",
    "\u65C8": "lau4",
    "\u65C9": "fu1",
    "\u65CA": "fong2",
    "\u65CB": "syun4/syun6",
    "\u65CC": "zing1/sing1",
    "\u65CD": "zing1/sing1",
    "\u65CE": "nei5/lei5",
    "\u65CF": "zuk6/cau3",
    "\u65D0": "siu6",
    "\u65D1": "ji2",
    "\u65D2": "lau4",
    "\u65D3": "saau1",
    "\u65D4": "gin3",
    "\u65D5": "jyu1",
    "\u65D6": "ji2",
    "\u65D7": "kei4/kei2",
    "\u65D8": "ci3",
    "\u65D9": "faan1",
    "\u65DA": "piu1",
    "\u65DB": "faan1",
    "\u65DC": "zin1",
    "\u65DD": "kui2/kwui2",
    "\u65DE": "seoi6",
    "\u65DF": "jyu4",
    "\u65E0": "mou4/mo4",
    "\u65E1": "gei3",
    "\u65E2": "gei3",
    "\u65E3": "gei3",
    "\u65E4": "wo6",
    "\u65E5": "jat6/jat2",
    "\u65E6": "daan3/daan2/daan6",
    "\u65E7": "gau6",
    "\u65E8": "zi2",
    "\u65E9": "zou2",
    "\u65EA": "hip3",
    "\u65EB": "tiu1",
    "\u65EC": "ceon4",
    "\u65ED": "juk1",
    "\u65EE": "go1/kaa3/gok3",
    "\u65EF": "lo1/laa1/lok1",
    "\u65F0": "gon3/hon6",
    "\u65F1": "hon5",
    "\u65F2": "toi4",
    "\u65F3": "dik1",
    "\u65F4": "heoi1",
    "\u65F5": "caam2",
    "\u65F6": "si4/si2",
    "\u65F7": "kwong3/kong3",
    "\u65F8": "joeng4",
    "\u65F9": "si4",
    "\u65FA": "wong6",
    "\u65FB": "man4",
    "\u65FC": "man4",
    "\u65FD": "tan1",
    "\u65FE": "ceon1",
    "\u65FF": "ng5/m5",
    "\u6600": "wan4",
    "\u6601": "bui3",
    "\u6602": "ngong4/ong4/ngong5/ong5",
    "\u6603": "zak1",
    "\u6604": "baan2",
    "\u6605": "gip6",
    "\u6606": "kwan1/gwan1",
    "\u6607": "sing1",
    "\u6608": "wu6",
    "\u6609": "fong2",
    "\u660A": "hou6",
    "\u660B": "gwai3",
    "\u660C": "coeng1",
    "\u660D": "hyun1",
    "\u660E": "ming4/ming2",
    "\u660F": "fan1",
    "\u6610": "fan1",
    "\u6611": "jam2",
    "\u6612": "fat1/mat6",
    "\u6613": "ji6/jik6",
    "\u6614": "sik1",
    "\u6615": "jan1",
    "\u6616": "jyun4",
    "\u6617": "zak1",
    "\u6618": "fong2",
    "\u6619": "taam4",
    "\u661A": "san6",
    "\u661B": "geoi6",
    "\u661C": "joeng4",
    "\u661D": "zaan2",
    "\u661E": "bing2/fong2",
    "\u661F": "sing1",
    "\u6620": "jing2",
    "\u6621": "jyun6",
    "\u6622": "pui3/put6",
    "\u6623": "can2",
    "\u6624": "ling4",
    "\u6625": "ceon1",
    "\u6626": "hou6",
    "\u6627": "mui6",
    "\u6628": "zok6/zok3",
    "\u6629": "mut6",
    "\u662A": "bin6",
    "\u662B": "heoi2/heoi3",
    "\u662C": "fan1",
    "\u662D": "ciu1/ziu1",
    "\u662E": "zung6",
    "\u662F": "si6/si2",
    "\u6630": "haa6/si6",
    "\u6631": "juk1",
    "\u6632": "fai3",
    "\u6633": "dit6/jat6",
    "\u6634": "maau5/mau5",
    "\u6635": "nik1/lik1",
    "\u6636": "cong2",
    "\u6637": "wan1",
    "\u6638": "dung1",
    "\u6639": "oi2/ngoi2",
    "\u663A": "bing2",
    "\u663B": "ngong4/ong4",
    "\u663C": "zau3",
    "\u663D": "lung4",
    "\u663E": "hin2",
    "\u663F": "kwong3/kong3",
    "\u6640": "tiu2",
    "\u6641": "ciu4",
    "\u6642": "si4/si2",
    "\u6643": "fong2",
    "\u6644": "fong2",
    "\u6645": "hyun1/syun2",
    "\u6646": "kwai1",
    "\u6647": "heoi1",
    "\u6648": "gaau2",
    "\u6649": "zeon3",
    "\u664A": "zat1",
    "\u664B": "zeon3",
    "\u664C": "hoeng2",
    "\u664D": "tung4",
    "\u664E": "hung2",
    "\u664F": "aan3/ngaan3",
    "\u6650": "goi1",
    "\u6651": "hoeng2",
    "\u6652": "saai3",
    "\u6653": "hiu2",
    "\u6654": "jip6",
    "\u6655": "wan4/wan6",
    "\u6656": "fai1",
    "\u6657": "ham4",
    "\u6658": "waan5",
    "\u6659": "zeon3",
    "\u665A": "maan5/maan1/maan2",
    "\u665B": "jin5/jin2",
    "\u665C": "kwan1",
    "\u665D": "zau3",
    "\u665E": "hei1",
    "\u665F": "sing4/sing6",
    "\u6660": "cou4",
    "\u6661": "bou1",
    "\u6662": "zit3/zai3",
    "\u6663": "zit3/zai3",
    "\u6664": "ng6/m6",
    "\u6665": "wun5",
    "\u6666": "fui3",
    "\u6667": "hou6",
    "\u6668": "san4",
    "\u6669": "maan5",
    "\u666A": "long4",
    "\u666B": "zoek3",
    "\u666C": "zeoi3",
    "\u666D": "zau2",
    "\u666E": "pou2",
    "\u666F": "ging2/jing2",
    "\u6670": "sik1",
    "\u6671": "sim2",
    "\u6672": "ngai5/ai5",
    "\u6673": "sik1",
    "\u6674": "cing4/ceng4",
    "\u6675": "kai2",
    "\u6676": "zing1",
    "\u6677": "gwai2",
    "\u6678": "zing2",
    "\u6679": "sik1",
    "\u667A": "zi3",
    "\u667B": "am2/ngam2/jim2/am3/ngam3",
    "\u667C": "jyun2",
    "\u667D": "lam4",
    "\u667E": "long6",
    "\u667F": "coeng1",
    "\u6680": "wong2/wong6",
    "\u6681": "hiu2",
    "\u6682": "zaam6",
    "\u6683": "fei1",
    "\u6684": "hyun1",
    "\u6685": "hyun1/syun2",
    "\u6686": "ji4",
    "\u6687": "haa6/haa4/haa1",
    "\u6688": "wan4/wan6",
    "\u6689": "fai1",
    "\u668A": "seoi2",
    "\u668B": "man5/man4",
    "\u668C": "kwai4",
    "\u668D": "hot3",
    "\u668E": "jing2",
    "\u668F": "syu6",
    "\u6690": "wai5",
    "\u6691": "syu2",
    "\u6692": "cing4",
    "\u6693": "mau6",
    "\u6694": "naam4/laam4",
    "\u6695": "gaan2",
    "\u6696": "nyun5/lyun5/nyun2/lyun2",
    "\u6697": "am3/ngam3",
    "\u6698": "joeng4",
    "\u6699": "ceon1",
    "\u669A": "jiu4",
    "\u669B": "so2",
    "\u669C": "pou2",
    "\u669D": "ming4/ming6/ming5",
    "\u669E": "giu2",
    "\u669F": "hoi2",
    "\u66A0": "gou2/hou6",
    "\u66A1": "jung2",
    "\u66A2": "coeng3",
    "\u66A3": "hei3",
    "\u66A4": "hou6",
    "\u66A5": "aan3/ngaan3",
    "\u66A6": "lik6",
    "\u66A7": "oi3/ngoi3/oi2/ngoi2",
    "\u66A8": "kei3",
    "\u66A9": "zai3",
    "\u66AA": "mun5",
    "\u66AB": "zaam6",
    "\u66AC": "sit3",
    "\u66AD": "hou6",
    "\u66AE": "mou6",
    "\u66AF": "mok6",
    "\u66B0": "cung1",
    "\u66B1": "nik1/lik1",
    "\u66B2": "zoeng1",
    "\u66B3": "wai3",
    "\u66B4": "bou6/bou2/buk6/bok3",
    "\u66B5": "hon3",
    "\u66B6": "syun4",
    "\u66B7": "cyun4",
    "\u66B8": "liu4",
    "\u66B9": "cim3/cim1",
    "\u66BA": "taan2",
    "\u66BB": "ging2",
    "\u66BC": "pit3",
    "\u66BD": "leon4",
    "\u66BE": "tan1",
    "\u66BF": "hei2",
    "\u66C0": "ai3/ngai3",
    "\u66C1": "kei3",
    "\u66C2": "wong6",
    "\u66C3": "doi6",
    "\u66C4": "jip6",
    "\u66C5": "jip6",
    "\u66C6": "lik6",
    "\u66C7": "taam4",
    "\u66C8": "tung4",
    "\u66C9": "hiu2",
    "\u66CA": "fai3",
    "\u66CB": "sam2",
    "\u66CC": "ziu3",
    "\u66CD": "hou6",
    "\u66CE": "jik6",
    "\u66CF": "hoeng2/hoeng3",
    "\u66D0": "sing1",
    "\u66D1": "sam1",
    "\u66D2": "giu2",
    "\u66D3": "bou6",
    "\u66D4": "ging6",
    "\u66D5": "jim6",
    "\u66D6": "oi3/ngoi3/oi2/ngoi2",
    "\u66D7": "jip6",
    "\u66D8": "jyu4",
    "\u66D9": "cyu5/syu5",
    "\u66DA": "mung4/mung1",
    "\u66DB": "fan1",
    "\u66DC": "jiu6",
    "\u66DD": "buk6",
    "\u66DE": "lai6",
    "\u66DF": "san4",
    "\u66E0": "kwong3/kong3",
    "\u66E1": "dip6/daap6",
    "\u66E2": "liu4",
    "\u66E3": "jin3",
    "\u66E4": "fok3",
    "\u66E5": "lou4",
    "\u66E6": "hei1",
    "\u66E7": "jung4",
    "\u66E8": "lung4",
    "\u66E9": "nong5/long5",
    "\u66EA": "lo2",
    "\u66EB": "lyun4",
    "\u66EC": "saai3",
    "\u66ED": "tong2",
    "\u66EE": "jim5",
    "\u66EF": "zuk1",
    "\u66F0": "joek6/jyut6",
    "\u66F1": "gaat6/gat6",
    "\u66F2": "kuk1/guk1",
    "\u66F3": "jai6/jai5",
    "\u66F4": "gang1/gaang1/gang3",
    "\u66F5": "jai6",
    "\u66F6": "fat1/mat6",
    "\u66F7": "hot3/aat3/ngaat3",
    "\u66F8": "syu1",
    "\u66F9": "cou4",
    "\u66FA": "cou4",
    "\u66FB": "cyun2",
    "\u66FC": "maan6",
    "\u66FD": "zang1",
    "\u66FE": "zang1/cang4",
    "\u66FF": "tai3",
    "\u6700": "zeoi3",
    "\u6701": "caam2",
    "\u6702": "juk1",
    "\u6703": "wui6/wui2/wui5/kui2/kwui2",
    "\u6704": "jan5/jan6",
    "\u6705": "kit3/hot3",
    "\u6706": "fan1",
    "\u6707": "pei4",
    "\u6708": "jyut6/jyut2",
    "\u6709": "jau5/jau6",
    "\u670A": "jyun2/gun2/gwun2",
    "\u670B": "pang4/pang2",
    "\u670C": "fan4/baan1",
    "\u670D": "fuk6",
    "\u670E": "ling4",
    "\u670F": "fei2",
    "\u6710": "keoi4",
    "\u6711": "sai3",
    "\u6712": "nuk6/luk6/muk6",
    "\u6713": "tiu3/tiu1/tiu5",
    "\u6714": "sok3",
    "\u6715": "zam6",
    "\u6716": "long5",
    "\u6717": "long5",
    "\u6718": "zeoi1/zyun1/zeon1/syun1",
    "\u6719": "ming4",
    "\u671A": "fong1",
    "\u671B": "mong6/mong2",
    "\u671C": "tan1",
    "\u671D": "ciu4/ziu1",
    "\u671E": "gei1",
    "\u671F": "kei4/gei1",
    "\u6720": "jing1",
    "\u6721": "zung1",
    "\u6722": "mong6",
    "\u6723": "tung4",
    "\u6724": "long5",
    "\u6725": "lou4",
    "\u6726": "mung4",
    "\u6727": "lung4",
    "\u6728": "muk6",
    "\u6729": "muk6",
    "\u672A": "mei6",
    "\u672B": "mut6/mut2/mo1",
    "\u672C": "bun2",
    "\u672D": "zaat3/zaat2/zaap3/aat3/ngaat3",
    "\u672E": "seot6",
    "\u672F": "seot6/seot2",
    "\u6730": "zaat3",
    "\u6731": "zyu1",
    "\u6732": "jan4",
    "\u6733": "baat3",
    "\u6734": "pok3/pok2/buk6/po1/piu4",
    "\u6735": "do2/doe2",
    "\u6736": "do2/doe2",
    "\u6737": "dou1",
    "\u6738": "lak6/lik6",
    "\u6739": "kau4/gwai2",
    "\u673A": "gei1",
    "\u673B": "gau1",
    "\u673C": "pei4",
    "\u673D": "nau2/lau2/jau2",
    "\u673E": "caang4/ting1",
    "\u673F": "ci3",
    "\u6740": "saat3/saai3",
    "\u6741": "jan4",
    "\u6742": "zaap6/zaap2",
    "\u6743": "kyun4",
    "\u6744": "cin1",
    "\u6745": "jyu1",
    "\u6746": "gon1/gon2",
    "\u6747": "wu1",
    "\u6748": "caa1/caa3",
    "\u6749": "caam3",
    "\u674A": "ceon4",
    "\u674B": "faan4",
    "\u674C": "ngat6/at6",
    "\u674D": "zi2",
    "\u674E": "lei5/lei2",
    "\u674F": "hang6",
    "\u6750": "coi4",
    "\u6751": "cyun1",
    "\u6752": "jan6",
    "\u6753": "soek3/zoek3/biu1",
    "\u6754": "tok3",
    "\u6755": "dai6",
    "\u6756": "zoeng6/zoeng2",
    "\u6757": "mong4",
    "\u6758": "ci3",
    "\u6759": "jik6",
    "\u675A": "koi3",
    "\u675B": "gung1",
    "\u675C": "dou6",
    "\u675D": "ji4/ci2/zi2/lei4",
    "\u675E": "gei2",
    "\u675F": "cuk1/ci3",
    "\u6760": "gong3/gong1",
    "\u6761": "tiu4/tiu2/tiu5",
    "\u6762": "gong3",
    "\u6763": "min4",
    "\u6764": "maan6",
    "\u6765": "loi4/loi2/loi6/lai4/lai2",
    "\u6766": "gau2",
    "\u6767": "mong1/mong4",
    "\u6768": "joeng4/joeng2",
    "\u6769": "maa5/maa6",
    "\u676A": "miu5",
    "\u676B": "ci3",
    "\u676C": "jyun4/laam5/laam2",
    "\u676D": "hong4",
    "\u676E": "fai3/ci5",
    "\u676F": "bui1",
    "\u6770": "git6",
    "\u6771": "dung1",
    "\u6772": "gou2",
    "\u6773": "miu5/jiu2",
    "\u6774": "him1/hin1",
    "\u6775": "cyu5",
    "\u6776": "ceon1",
    "\u6777": "paa4",
    "\u6778": "syu4",
    "\u6779": "faa3",
    "\u677A": "sam1",
    "\u677B": "cau2/nau2/lau2",
    "\u677C": "cyu5",
    "\u677D": "cau2",
    "\u677E": "cung4/cung2/sung1",
    "\u677F": "baan2",
    "\u6780": "cung4/sung1",
    "\u6781": "gik6",
    "\u6782": "wut6",
    "\u6783": "zeon3",
    "\u6784": "kau3/gau3",
    "\u6785": "gai1",
    "\u6786": "mou4",
    "\u6787": "pei4",
    "\u6788": "bei3",
    "\u6789": "wong2",
    "\u678A": "ngong6/ong6",
    "\u678B": "fong1",
    "\u678C": "fan4",
    "\u678D": "jai6",
    "\u678E": "fu4",
    "\u678F": "naam4/laam4",
    "\u6790": "sik1/cik1",
    "\u6791": "wu6",
    "\u6792": "aa1/ngaa1",
    "\u6793": "dau2/zyu2",
    "\u6794": "cam4",
    "\u6795": "zam2/zam3",
    "\u6796": "jiu1",
    "\u6797": "lam4/lam2",
    "\u6798": "jeoi6",
    "\u6799": "ngo4/o4",
    "\u679A": "mui4/mui2",
    "\u679B": "zaau3",
    "\u679C": "gwo2/go2",
    "\u679D": "zi1/kei4",
    "\u679E": "cung1/zung1",
    "\u679F": "taan4/wan4",
    "\u67A0": "zyut6",
    "\u67A1": "sing1",
    "\u67A2": "syu1",
    "\u67A3": "zou2",
    "\u67A4": "dai6",
    "\u67A5": "lik1",
    "\u67A6": "lou4",
    "\u67A7": "gaan2",
    "\u67A8": "caang4",
    "\u67A9": "cung4",
    "\u67AA": "coeng1",
    "\u67AB": "fung1",
    "\u67AC": "zin1",
    "\u67AD": "hiu1",
    "\u67AE": "cim1",
    "\u67AF": "fu1",
    "\u67B0": "ping4",
    "\u67B1": "toi2/toi4",
    "\u67B2": "saai2",
    "\u67B3": "zi2/zik1",
    "\u67B4": "gwaai2",
    "\u67B5": "hiu1",
    "\u67B6": "gaa3/gaa1/gaa2",
    "\u67B7": "gaa1",
    "\u67B8": "gau2/geoi2",
    "\u67B9": "baau1/fu1",
    "\u67BA": "mut6",
    "\u67BB": "jai6",
    "\u67BC": "jip6",
    "\u67BD": "jip6",
    "\u67BE": "si6",
    "\u67BF": "jit6/jip6",
    "\u67C0": "bei2",
    "\u67C1": "to4/to5",
    "\u67C2": "ji4/to4/to5",
    "\u67C3": "ling4",
    "\u67C4": "beng3/bing3",
    "\u67C5": "nei5/lei5",
    "\u67C6": "laap6",
    "\u67C7": "wo4",
    "\u67C8": "bun6/pun4",
    "\u67C9": "faan4",
    "\u67CA": "dung1",
    "\u67CB": "doi6",
    "\u67CC": "ci4",
    "\u67CD": "joeng1/joeng2",
    "\u67CE": "fu1/fu2",
    "\u67CF": "paak3/baak3",
    "\u67D0": "mau5",
    "\u67D1": "gam1",
    "\u67D2": "cat1",
    "\u67D3": "jim5",
    "\u67D4": "jau4",
    "\u67D5": "mau6",
    "\u67D6": "siu4",
    "\u67D7": "cung4",
    "\u67D8": "ze3",
    "\u67D9": "haap6/aat3/ngaat3/gaap3",
    "\u67DA": "jau2/jau4/jau6/zuk6",
    "\u67DB": "san1",
    "\u67DC": "gwai6/gwai2/geoi2",
    "\u67DD": "tok3",
    "\u67DE": "zok6/zaak3/zaa3/zaa6",
    "\u67DF": "naam4/laam4",
    "\u67E0": "ning4/ling4",
    "\u67E1": "wing5",
    "\u67E2": "dai2",
    "\u67E3": "dit6",
    "\u67E4": "zaa1",
    "\u67E5": "caa4/caa2/zaa1",
    "\u67E6": "daan6",
    "\u67E7": "gu1/gwu1",
    "\u67E8": "bou3",
    "\u67E9": "gau6/gau3",
    "\u67EA": "au1/ngau1",
    "\u67EB": "fat1",
    "\u67EC": "gaan2",
    "\u67ED": "baat3",
    "\u67EE": "deot1/dut1",
    "\u67EF": "o1/ngo1",
    "\u67F0": "noi6/loi6",
    "\u67F1": "cyu5/cyu2",
    "\u67F2": "bei3",
    "\u67F3": "lau5",
    "\u67F4": "caai4/caai2",
    "\u67F5": "caak3/saan1",
    "\u67F6": "si3",
    "\u67F7": "zuk1",
    "\u67F8": "pui1",
    "\u67F9": "ci2/si5/ci5",
    "\u67FA": "gwaai2",
    "\u67FB": "caa4/zaa1",
    "\u67FC": "jiu2",
    "\u67FD": "cing1",
    "\u67FE": "gau6",
    "\u67FF": "ci2/si5/ci5",
    "\u6800": "zi1",
    "\u6801": "lau5",
    "\u6802": "mui4",
    "\u6803": "lai6",
    "\u6804": "wing4",
    "\u6805": "caak3/saan1",
    "\u6806": "zou2",
    "\u6807": "biu1",
    "\u6808": "zaan6/zaan2",
    "\u6809": "zit3",
    "\u680A": "lung4",
    "\u680B": "dung6/dung3",
    "\u680C": "lou4",
    "\u680D": "sang1",
    "\u680E": "lik1/joek6",
    "\u680F": "laan4/laan1",
    "\u6810": "wing5",
    "\u6811": "syu6",
    "\u6812": "ceon4/seon2",
    "\u6813": "saan1",
    "\u6814": "kai3/kit3",
    "\u6815": "san4",
    "\u6816": "cai1/sai1",
    "\u6817": "leot6/leot2",
    "\u6818": "ji4",
    "\u6819": "hong4",
    "\u681A": "zam6",
    "\u681B": "lai6",
    "\u681C": "saak3",
    "\u681D": "kut3/kwut3/gwaa1",
    "\u681E": "hon1/hon2",
    "\u681F": "bing1/ban1",
    "\u6820": "jam6",
    "\u6821": "haau6/gaau3",
    "\u6822": "paak3",
    "\u6823": "jam6",
    "\u6824": "bing6",
    "\u6825": "zi1",
    "\u6826": "cau4",
    "\u6827": "jai6",
    "\u6828": "ci3",
    "\u6829": "heoi2",
    "\u682A": "zyu1",
    "\u682B": "zin3",
    "\u682C": "zeoi3",
    "\u682D": "ji4",
    "\u682E": "ji5",
    "\u682F": "jau5",
    "\u6830": "fat6",
    "\u6831": "gung2",
    "\u6832": "haau2",
    "\u6833": "lou5",
    "\u6834": "zin1",
    "\u6835": "lai6",
    "\u6836": "jan1",
    "\u6837": "joeng6/joeng2/joeng4",
    "\u6838": "hat6/wat6/wat2/goi1",
    "\u6839": "gan1",
    "\u683A": "ngai6/ai6",
    "\u683B": "sik1",
    "\u683C": "gaak3/gaak2",
    "\u683D": "zoi1",
    "\u683E": "lyun4",
    "\u683F": "fuk6",
    "\u6840": "git6",
    "\u6841": "hang4/haang4/haang2/hong4/hong6",
    "\u6842": "gwai3",
    "\u6843": "tou4/tou2",
    "\u6844": "gwong3/gong3/waang6/gwong1/gong1/gwong2/gong2",
    "\u6845": "wai4/ngai4/ai4/ngai2/ai2",
    "\u6846": "kwaang1/hong1",
    "\u6847": "jyu4",
    "\u6848": "on3/ngon3/on2/ngon2",
    "\u6849": "on1/ngon1/on3/ngon3",
    "\u684A": "gyun3",
    "\u684B": "ji4",
    "\u684C": "coek3/zoek3",
    "\u684D": "fu1",
    "\u684E": "zat6",
    "\u684F": "kung4",
    "\u6850": "tung4",
    "\u6851": "song1",
    "\u6852": "song1",
    "\u6853": "wun4",
    "\u6854": "gat1/git3",
    "\u6855": "kau5/kau3",
    "\u6856": "hyut3",
    "\u6857": "do3",
    "\u6858": "ceoi4",
    "\u6859": "jyu4",
    "\u685A": "zaat3",
    "\u685B": "lung6",
    "\u685C": "jing1",
    "\u685D": "git6",
    "\u685E": "lau5",
    "\u685F": "zaan6",
    "\u6860": "aa1/ngaa1",
    "\u6861": "naau4/laau4/jiu4",
    "\u6862": "zing1",
    "\u6863": "dong2/dong3",
    "\u6864": "hei2/kei1/hei1",
    "\u6865": "kiu4/kiu2",
    "\u6866": "waa4/waa6",
    "\u6867": "kui2/kwui2",
    "\u6868": "zoeng2",
    "\u6869": "zong1",
    "\u686A": "cam4",
    "\u686B": "so1",
    "\u686C": "saa1",
    "\u686D": "san4",
    "\u686E": "bui1",
    "\u686F": "ting1/jing4",
    "\u6870": "kut3/kwut3",
    "\u6871": "ging3",
    "\u6872": "but6",
    "\u6873": "ban6",
    "\u6874": "fu1/fau4",
    "\u6875": "jeoi4",
    "\u6876": "tung2",
    "\u6877": "gok3/gok2",
    "\u6878": "hei1",
    "\u6879": "long4",
    "\u687A": "lau5",
    "\u687B": "fung1",
    "\u687C": "cat1",
    "\u687D": "wan2",
    "\u687E": "gwan1",
    "\u687F": "gon3/gon2/gon1",
    "\u6880": "saak3",
    "\u6881": "loeng4/loeng2",
    "\u6882": "kau4",
    "\u6883": "ting5",
    "\u6884": "jau5",
    "\u6885": "mui4/mui1/mui2",
    "\u6886": "bong1",
    "\u6887": "lung6",
    "\u6888": "paang1",
    "\u6889": "zong1",
    "\u688A": "dai3",
    "\u688B": "hyun1",
    "\u688C": "tou4",
    "\u688D": "zou6",
    "\u688E": "au1/ngau1",
    "\u688F": "guk1/gok3",
    "\u6890": "bai6",
    "\u6891": "dik6",
    "\u6892": "ham4",
    "\u6893": "zi2",
    "\u6894": "zi1",
    "\u6895": "jan6",
    "\u6896": "bui3",
    "\u6897": "gang2/gwaang2",
    "\u6898": "gaan2",
    "\u6899": "waan6",
    "\u689A": "maan5",
    "\u689B": "naa4/laa4",
    "\u689C": "gaap3",
    "\u689D": "tiu4/tiu2/tiu5",
    "\u689E": "gei6",
    "\u689F": "hiu1",
    "\u68A0": "leoi5",
    "\u68A1": "fun2",
    "\u68A2": "saau1",
    "\u68A3": "sam4",
    "\u68A4": "fan4",
    "\u68A5": "cung4",
    "\u68A6": "mung6/mung4",
    "\u68A7": "ng4/m4/ng6/m6",
    "\u68A8": "lei4/lei2",
    "\u68A9": "lei4",
    "\u68AA": "dau6",
    "\u68AB": "caam1/cam2",
    "\u68AC": "jing5",
    "\u68AD": "so1",
    "\u68AE": "guk6/guk1",
    "\u68AF": "tai1",
    "\u68B0": "haai6",
    "\u68B1": "kwan2",
    "\u68B2": "zyut3/tyut3",
    "\u68B3": "so1",
    "\u68B4": "cin1",
    "\u68B5": "faan6/faan4",
    "\u68B6": "mei5",
    "\u68B7": "zing6",
    "\u68B8": "lei4",
    "\u68B9": "ban1",
    "\u68BA": "haa6",
    "\u68BB": "fat6",
    "\u68BC": "tou4",
    "\u68BD": "zi3",
    "\u68BE": "loi4",
    "\u68BF": "lin4/lin2",
    "\u68C0": "gim2",
    "\u68C1": "zyut3/tyut3",
    "\u68C2": "ling4",
    "\u68C3": "lei4",
    "\u68C4": "hei3",
    "\u68C5": "bing3/beng3",
    "\u68C6": "leon4",
    "\u68C7": "sung2",
    "\u68C8": "sin3",
    "\u68C9": "min4/min2",
    "\u68CA": "kei4",
    "\u68CB": "kei4/kei2",
    "\u68CC": "coi3",
    "\u68CD": "gwan3",
    "\u68CE": "sim4",
    "\u68CF": "dak6",
    "\u68D0": "fei2",
    "\u68D1": "paai4",
    "\u68D2": "paang5",
    "\u68D3": "paang5/bui6/pui5/pui4",
    "\u68D4": "fan1",
    "\u68D5": "zung1",
    "\u68D6": "caang4",
    "\u68D7": "zou2",
    "\u68D8": "gik1/kik1",
    "\u68D9": "lai6/lit6",
    "\u68DA": "paang4/paang2",
    "\u68DB": "juk6",
    "\u68DC": "jyu3",
    "\u68DD": "gu3/gwu3",
    "\u68DE": "gwan6",
    "\u68DF": "dung6/dung3",
    "\u68E0": "tong4/tong2",
    "\u68E1": "gong1/gong3",
    "\u68E2": "mong5",
    "\u68E3": "dai6",
    "\u68E4": "co3",
    "\u68E5": "faan4",
    "\u68E6": "caang1",
    "\u68E7": "zaan6/zaan2",
    "\u68E8": "kai2",
    "\u68E9": "jyun1",
    "\u68EA": "jim5",
    "\u68EB": "wik6",
    "\u68EC": "hyun1/gyun3",
    "\u68ED": "jik6",
    "\u68EE": "sam1",
    "\u68EF": "nim1/lim1/nim6/lim6",
    "\u68F0": "ceoi4",
    "\u68F1": "ling4",
    "\u68F2": "cai1/sai1",
    "\u68F3": "zyut3",
    "\u68F4": "fuk6",
    "\u68F5": "fo2/fo1/po1",
    "\u68F6": "loi4",
    "\u68F7": "zau1/sau2",
    "\u68F8": "zau1",
    "\u68F9": "zaau6/zoek3/coek3",
    "\u68FA": "gun1/gwun1",
    "\u68FB": "fan1",
    "\u68FC": "fan4/fan1",
    "\u68FD": "cam1/cam4",
    "\u68FE": "king4",
    "\u68FF": "ngai4/ai4",
    "\u6900": "wun2",
    "\u6901": "gwok3/gok3",
    "\u6902": "luk6",
    "\u6903": "hou4",
    "\u6904": "zip3",
    "\u6905": "ji2/ji1",
    "\u6906": "cau4",
    "\u6907": "geoi2",
    "\u6908": "guk1",
    "\u6909": "sing4/sing6",
    "\u690A": "zyut6",
    "\u690B": "loeng4",
    "\u690C": "hong1",
    "\u690D": "zik6",
    "\u690E": "ceoi4/zeoi1",
    "\u690F": "aa1/ngaa1",
    "\u6910": "geoi1",
    "\u6911": "pei4/bei1/pik1",
    "\u6912": "ziu1",
    "\u6913": "doek3",
    "\u6914": "zi1",
    "\u6915": "ban1",
    "\u6916": "paang4",
    "\u6917": "ding3",
    "\u6918": "co2",
    "\u6919": "coeng1",
    "\u691A": "haan4",
    "\u691B": "waa4",
    "\u691C": "gim2",
    "\u691D": "kwai1",
    "\u691E": "sap1",
    "\u691F": "duk6",
    "\u6920": "cim3",
    "\u6921": "dou3",
    "\u6922": "gui3/gwui3",
    "\u6923": "din2",
    "\u6924": "lo4",
    "\u6925": "zi1",
    "\u6926": "hyun1",
    "\u6927": "ming6",
    "\u6928": "fu2",
    "\u6929": "gang1",
    "\u692A": "pung3",
    "\u692B": "sin6/zin2",
    "\u692C": "ji4",
    "\u692D": "to5",
    "\u692E": "sam1",
    "\u692F": "do2",
    "\u6930": "je4/je2",
    "\u6931": "fuk6",
    "\u6932": "wai5",
    "\u6933": "wui1",
    "\u6934": "dyun6",
    "\u6935": "gaa2/gaa1",
    "\u6936": "zung1",
    "\u6937": "haam4/gaam1/zin1",
    "\u6938": "ji4",
    "\u6939": "zam1/sam6",
    "\u693A": "hat6",
    "\u693B": "jin3",
    "\u693C": "jin5",
    "\u693D": "cyun4",
    "\u693E": "zin1",
    "\u693F": "ceon1",
    "\u6940": "jyu5",
    "\u6941": "haak6",
    "\u6942": "zaa1/caa4",
    "\u6943": "ak1/ngak1",
    "\u6944": "pin4",
    "\u6945": "bik1",
    "\u6946": "jiu1",
    "\u6947": "gwo2/go2",
    "\u6948": "seoi1",
    "\u6949": "joek6",
    "\u694A": "joeng4/joeng2",
    "\u694B": "lip6",
    "\u694C": "ngaan4/aan4",
    "\u694D": "bun2",
    "\u694E": "wan4/fai1",
    "\u694F": "fui1",
    "\u6950": "gaai3",
    "\u6951": "kwai5",
    "\u6952": "si1",
    "\u6953": "fung1",
    "\u6954": "sit3",
    "\u6955": "to5",
    "\u6956": "zit3",
    "\u6957": "gin6/gin2",
    "\u6958": "mou6/muk6",
    "\u6959": "mau6",
    "\u695A": "co2",
    "\u695B": "fu2/wu6",
    "\u695C": "wu4",
    "\u695D": "lin6",
    "\u695E": "ling4/ling6",
    "\u695F": "ting4",
    "\u6960": "naam4/laam4",
    "\u6961": "jyu4",
    "\u6962": "jau4",
    "\u6963": "mei4",
    "\u6964": "sung2",
    "\u6965": "jyun4/hyun3",
    "\u6966": "hyun3",
    "\u6967": "joeng1",
    "\u6968": "zing1",
    "\u6969": "pin4",
    "\u696A": "dip6/jip6",
    "\u696B": "zip3",
    "\u696C": "git6/hat6/kit3",
    "\u696D": "jip6",
    "\u696E": "cyu5",
    "\u696F": "seon5/ceon4/teon5",
    "\u6970": "jyu4",
    "\u6971": "cau3",
    "\u6972": "wai1",
    "\u6973": "mui4",
    "\u6974": "tai3",
    "\u6975": "gik6",
    "\u6976": "zit3",
    "\u6977": "kaai2/gaai1",
    "\u6978": "cau1",
    "\u6979": "jing4",
    "\u697A": "jau2",
    "\u697B": "hang4",
    "\u697C": "lau4/lau2",
    "\u697D": "lok6",
    "\u697E": "cyun4",
    "\u697F": "hoeng1",
    "\u6980": "ban2",
    "\u6981": "sat1",
    "\u6982": "koi3/koi2",
    "\u6983": "dam4/tam4",
    "\u6984": "laam5/laam2",
    "\u6985": "wat1/wan1",
    "\u6986": "jyu4",
    "\u6987": "can3",
    "\u6988": "leoi4/leoi3",
    "\u6989": "geoi2",
    "\u698A": "san4",
    "\u698B": "song1",
    "\u698C": "fei1",
    "\u698D": "sit3",
    "\u698E": "gaa2",
    "\u698F": "jik6",
    "\u6990": "zin2",
    "\u6991": "fu4",
    "\u6992": "nik1/lik1",
    "\u6993": "mat6",
    "\u6994": "long4",
    "\u6995": "jung4",
    "\u6996": "guk1",
    "\u6997": "zin3",
    "\u6998": "geoi2",
    "\u6999": "daap6",
    "\u699A": "jiu5",
    "\u699B": "zeon1",
    "\u699C": "bong2/pong3/bong6/paang4",
    "\u699D": "saat3",
    "\u699E": "jyun4",
    "\u699F": "zi2",
    "\u69A0": "ming4",
    "\u69A1": "sou3",
    "\u69A2": "gaa3",
    "\u69A3": "jiu4",
    "\u69A4": "git6",
    "\u69A5": "fong2",
    "\u69A6": "gon3/hon4",
    "\u69A7": "fei2",
    "\u69A8": "zaa3",
    "\u69A9": "kin4",
    "\u69AA": "maa5/maa6",
    "\u69AB": "seon2",
    "\u69AC": "jyun4",
    "\u69AD": "ze6",
    "\u69AE": "wing4",
    "\u69AF": "si4",
    "\u69B0": "zi1",
    "\u69B1": "ceoi1",
    "\u69B2": "wat1/wan1",
    "\u69B3": "ting4",
    "\u69B4": "lau4/lau2",
    "\u69B5": "jung4",
    "\u69B6": "tong4",
    "\u69B7": "kok3",
    "\u69B8": "zaai1",
    "\u69B9": "si1",
    "\u69BA": "sing3",
    "\u69BB": "taap3",
    "\u69BC": "hap6",
    "\u69BD": "hai4",
    "\u69BE": "gwat1/gat1",
    "\u69BF": "hei2/kei1/hei1",
    "\u69C0": "gou2",
    "\u69C1": "gou2",
    "\u69C2": "syun1",
    "\u69C3": "pun4",
    "\u69C4": "tou1",
    "\u69C5": "gaak3/hat6",
    "\u69C6": "ceon1",
    "\u69C7": "din1",
    "\u69C8": "nau6/lau6",
    "\u69C9": "zat6",
    "\u69CA": "sok3",
    "\u69CB": "kau3/gau3",
    "\u69CC": "ceoi4",
    "\u69CD": "coeng1",
    "\u69CE": "caa4",
    "\u69CF": "haam2",
    "\u69D0": "waai4",
    "\u69D1": "mui4",
    "\u69D2": "cuk1",
    "\u69D3": "lung5/gung3/gong3",
    "\u69D4": "gou1",
    "\u69D5": "coek3/zoek3",
    "\u69D6": "tok3",
    "\u69D7": "kiu4",
    "\u69D8": "joeng4",
    "\u69D9": "din1",
    "\u69DA": "gaa2",
    "\u69DB": "laam6/haam5/kaam5",
    "\u69DC": "zeoi3",
    "\u69DD": "dou2",
    "\u69DE": "lung4",
    "\u69DF": "ban1",
    "\u69E0": "zyu1",
    "\u69E1": "song1",
    "\u69E2": "zaap6",
    "\u69E3": "gei1",
    "\u69E4": "lin4/lin2",
    "\u69E5": "seoi6/wai6",
    "\u69E6": "jung4",
    "\u69E7": "cim3",
    "\u69E8": "gwok3/gok3",
    "\u69E9": "koi3",
    "\u69EA": "koi3",
    "\u69EB": "tyun4",
    "\u69EC": "waa6",
    "\u69ED": "cik1",
    "\u69EE": "sam1",
    "\u69EF": "ceoi4",
    "\u69F0": "bung6",
    "\u69F1": "jau5",
    "\u69F2": "huk6",
    "\u69F3": "zoeng2",
    "\u69F4": "wu6",
    "\u69F5": "waan6",
    "\u69F6": "gui3/gwui3",
    "\u69F7": "jit6/nip6/lip6/sit3",
    "\u69F8": "ngai6/ai6",
    "\u69F9": "gou1",
    "\u69FA": "hong1",
    "\u69FB": "kwai1",
    "\u69FC": "kwai1",
    "\u69FD": "cou4",
    "\u69FE": "maan6",
    "\u69FF": "gan2",
    "\u6A00": "dik1",
    "\u6A01": "zong1",
    "\u6A02": "lok6/ngok6/ok6/ngaau6/aau6/ngaau4/aau4",
    "\u6A03": "long5",
    "\u6A04": "can4",
    "\u6A05": "cung1/zung1",
    "\u6A06": "lei4",
    "\u6A07": "sau1",
    "\u6A08": "king4",
    "\u6A09": "song2",
    "\u6A0A": "faan4",
    "\u6A0B": "tung1",
    "\u6A0C": "gun3/gwun3",
    "\u6A0D": "zik1",
    "\u6A0E": "suk1",
    "\u6A0F": "leoi4",
    "\u6A10": "lou5",
    "\u6A11": "loeng4/loeng2",
    "\u6A12": "mat6",
    "\u6A13": "lau4/lau2",
    "\u6A14": "caau4/ziu2",
    "\u6A15": "cuk1",
    "\u6A16": "po1",
    "\u6A17": "syu1",
    "\u6A18": "tong4",
    "\u6A19": "biu1",
    "\u6A1A": "luk6",
    "\u6A1B": "gau1",
    "\u6A1C": "ze3",
    "\u6A1D": "zaa1",
    "\u6A1E": "syu1",
    "\u6A1F": "zoeng1",
    "\u6A20": "mun4",
    "\u6A21": "mou4/mou2",
    "\u6A22": "niu5/liu5",
    "\u6A23": "joeng6/joeng2",
    "\u6A24": "tiu4",
    "\u6A25": "pung4",
    "\u6A26": "cyu5",
    "\u6A27": "saat3",
    "\u6A28": "sai1",
    "\u6A29": "kyun4",
    "\u6A2A": "waang4/waang6",
    "\u6A2B": "gin1",
    "\u6A2C": "sung2",
    "\u6A2D": "kei4",
    "\u6A2E": "jim5",
    "\u6A2F": "coeng4",
    "\u6A30": "syut3",
    "\u6A31": "jing1",
    "\u6A32": "ji6",
    "\u6A33": "cam4",
    "\u6A34": "zik1",
    "\u6A35": "ciu4",
    "\u6A36": "zeoi1",
    "\u6A37": "cung4",
    "\u6A38": "pok3/buk6",
    "\u6A39": "syu6",
    "\u6A3A": "waa4/waa6",
    "\u6A3B": "gwai6",
    "\u6A3C": "zeon1",
    "\u6A3D": "zeon1",
    "\u6A3E": "jyut6",
    "\u6A3F": "sin6/zin2",
    "\u6A40": "hei1",
    "\u6A41": "ceon1",
    "\u6A42": "din6",
    "\u6A43": "fat6",
    "\u6A44": "gam2/gaam3/gam3",
    "\u6A45": "mou4",
    "\u6A46": "mou4",
    "\u6A47": "hiu1/ceoi3",
    "\u6A48": "naau4/laau4/jiu4",
    "\u6A49": "leon6",
    "\u6A4A": "lau4",
    "\u6A4B": "kiu4/kiu2",
    "\u6A4C": "haan5",
    "\u6A4D": "jeon6",
    "\u6A4E": "faan2",
    "\u6A4F": "zin2",
    "\u6A50": "tok3/lok6",
    "\u6A51": "lou5/liu4",
    "\u6A52": "wan4",
    "\u6A53": "seon3",
    "\u6A54": "deon1",
    "\u6A55": "caang1",
    "\u6A56": "tong4",
    "\u6A57": "mang4",
    "\u6A58": "gwat1",
    "\u6A59": "caang2/caang4/dang3",
    "\u6A5A": "suk1/siu1",
    "\u6A5B": "kyut3/gyut6/kyut6",
    "\u6A5C": "kyut3/gyut6/kyut6",
    "\u6A5D": "taam4",
    "\u6A5E": "wai6",
    "\u6A5F": "gei1",
    "\u6A60": "no5/lo5",
    "\u6A61": "zoeng6",
    "\u6A62": "to5",
    "\u6A63": "ning5/ling5",
    "\u6A64": "jeoi5/jeoi6",
    "\u6A65": "zyu1",
    "\u6A66": "tung4/cong4",
    "\u6A67": "zang1",
    "\u6A68": "fan4",
    "\u6A69": "king4",
    "\u6A6A": "jim5",
    "\u6A6B": "waang4/waang1/waang6",
    "\u6A6C": "cim4",
    "\u6A6D": "gu1/gwu1",
    "\u6A6E": "lau5",
    "\u6A6F": "lou6",
    "\u6A70": "gou1",
    "\u6A71": "ceoi4/cyu4",
    "\u6A72": "hei2",
    "\u6A73": "sing3",
    "\u6A74": "zi2",
    "\u6A75": "saan3",
    "\u6A76": "gik1",
    "\u6A77": "dau1",
    "\u6A78": "zing1",
    "\u6A79": "lou5",
    "\u6A7A": "gaan3",
    "\u6A7B": "cau2",
    "\u6A7C": "jyun4",
    "\u6A7D": "taat3",
    "\u6A7E": "syu1",
    "\u6A7F": "goeng1",
    "\u6A80": "taan4/taan2",
    "\u6A81": "lam5",
    "\u6A82": "nung4/lung4",
    "\u6A83": "jan2",
    "\u6A84": "hat6",
    "\u6A85": "seoi6",
    "\u6A86": "caam3",
    "\u6A87": "zeoi3",
    "\u6A88": "syun4",
    "\u6A89": "cing1",
    "\u6A8A": "gon1",
    "\u6A8B": "guk6",
    "\u6A8C": "seoi4",
    "\u6A8D": "jik1",
    "\u6A8E": "kam4",
    "\u6A8F": "pok3",
    "\u6A90": "jim4/sim4/jam4/jam2",
    "\u6A91": "leoi4",
    "\u6A92": "fung1",
    "\u6A93": "wai2",
    "\u6A94": "dong2/dong3",
    "\u6A95": "hai6",
    "\u6A96": "seoi6",
    "\u6A97": "paak3/baak3",
    "\u6A98": "ping4",
    "\u6A99": "caang4",
    "\u6A9A": "co2",
    "\u6A9B": "zaa1",
    "\u6A9C": "kui2/kwui2",
    "\u6A9D": "zip3",
    "\u6A9E": "gaai2/haai5",
    "\u6A9F": "gaa2",
    "\u6AA0": "king4",
    "\u6AA1": "sik1",
    "\u6AA2": "gim2",
    "\u6AA3": "coeng4",
    "\u6AA4": "dou6",
    "\u6AA5": "ngai5/ai5",
    "\u6AA6": "biu2",
    "\u6AA7": "sung1",
    "\u6AA8": "ce1",
    "\u6AA9": "lam5",
    "\u6AAA": "lik1",
    "\u6AAB": "caat3",
    "\u6AAC": "mung1/mung4",
    "\u6AAD": "ngan4/an4",
    "\u6AAE": "tou4",
    "\u6AAF": "toi2/toi4",
    "\u6AB0": "min4",
    "\u6AB1": "kei4",
    "\u6AB2": "tyun4",
    "\u6AB3": "ban1",
    "\u6AB4": "wok6",
    "\u6AB5": "gai3",
    "\u6AB6": "him1",
    "\u6AB7": "nai5/lai5",
    "\u6AB8": "ning4/ling4",
    "\u6AB9": "ji1",
    "\u6ABA": "gou2",
    "\u6ABB": "laam6/haam5/kaam5",
    "\u6ABC": "jan2",
    "\u6ABD": "nau6/lau6",
    "\u6ABE": "king2/gwing2",
    "\u6ABF": "jim2",
    "\u6AC0": "kei4",
    "\u6AC1": "mat6",
    "\u6AC2": "zaau6",
    "\u6AC3": "gwai6/gwai2",
    "\u6AC4": "ceon1",
    "\u6AC5": "zai1",
    "\u6AC6": "fui1",
    "\u6AC7": "po4",
    "\u6AC8": "dang3",
    "\u6AC9": "ceoi4",
    "\u6ACA": "gok3",
    "\u6ACB": "min4",
    "\u6ACC": "jau1",
    "\u6ACD": "zat1",
    "\u6ACE": "fong2",
    "\u6ACF": "cin1",
    "\u6AD0": "leoi5",
    "\u6AD1": "leoi4/leoi5",
    "\u6AD2": "saat3",
    "\u6AD3": "lou5",
    "\u6AD4": "lai6",
    "\u6AD5": "cyun4",
    "\u6AD6": "leoi6",
    "\u6AD7": "mit6",
    "\u6AD8": "seoi6",
    "\u6AD9": "au1/ngau1",
    "\u6ADA": "leoi4/leoi3",
    "\u6ADB": "zit3",
    "\u6ADC": "gou1",
    "\u6ADD": "duk6",
    "\u6ADE": "jyun4",
    "\u6ADF": "lik1/joek6",
    "\u6AE0": "fai3",
    "\u6AE1": "zoek3/zyu6",
    "\u6AE2": "sau2",
    "\u6AE3": "lin4",
    "\u6AE4": "zin3",
    "\u6AE5": "ceoi4/cyu4",
    "\u6AE6": "hing3",
    "\u6AE7": "zyu1",
    "\u6AE8": "lou4",
    "\u6AE9": "jim4",
    "\u6AEA": "lik1",
    "\u6AEB": "zyu1",
    "\u6AEC": "can3",
    "\u6AED": "git6",
    "\u6AEE": "ngok6/ok6",
    "\u6AEF": "sou1",
    "\u6AF0": "waai4",
    "\u6AF1": "jit6/jip6/nip6/lip6",
    "\u6AF2": "jyu6",
    "\u6AF3": "lung4",
    "\u6AF4": "laai6",
    "\u6AF5": "ciu4",
    "\u6AF6": "hin2",
    "\u6AF7": "gwai1",
    "\u6AF8": "geoi2",
    "\u6AF9": "suk1/siu1",
    "\u6AFA": "ling4",
    "\u6AFB": "jing1",
    "\u6AFC": "cim1/zim1",
    "\u6AFD": "jan2",
    "\u6AFE": "jau2/jau6/jau4",
    "\u6AFF": "jing4",
    "\u6B00": "soeng1",
    "\u6B01": "nung4/lung4",
    "\u6B02": "bok3/bok6",
    "\u6B03": "caam4",
    "\u6B04": "laan4/laan1",
    "\u6B05": "geoi2",
    "\u6B06": "soeng1",
    "\u6B07": "sip3",
    "\u6B08": "wai4",
    "\u6B09": "cung4",
    "\u6B0A": "kyun4",
    "\u6B0B": "keoi4",
    "\u6B0C": "cong4",
    "\u6B0D": "kau5",
    "\u6B0E": "wat1",
    "\u6B0F": "lo4",
    "\u6B10": "lai6",
    "\u6B11": "cyun4",
    "\u6B12": "lyun4",
    "\u6B13": "dong2",
    "\u6B14": "fok3",
    "\u6B15": "jim4",
    "\u6B16": "laam5/laam2",
    "\u6B17": "laan4",
    "\u6B18": "zuk1",
    "\u6B19": "leoi4",
    "\u6B1A": "lai5",
    "\u6B1B": "baa3",
    "\u6B1C": "nong4/long4",
    "\u6B1D": "wat1",
    "\u6B1E": "ling4",
    "\u6B1F": "gun1/gwun1",
    "\u6B20": "him3",
    "\u6B21": "ci3/zi1",
    "\u6B22": "fun1",
    "\u6B23": "jan1",
    "\u6B24": "jyu4",
    "\u6B25": "him3",
    "\u6B26": "him1",
    "\u6B27": "au1/ngau1/au2/ngau2",
    "\u6B28": "heoi2/heoi1",
    "\u6B29": "ciu1",
    "\u6B2A": "ceot1",
    "\u6B2B": "kik1",
    "\u6B2C": "kat1/haai1/haai4/hoi4/koi3",
    "\u6B2D": "ji3",
    "\u6B2E": "kyut3",
    "\u6B2F": "hat1",
    "\u6B30": "seot1",
    "\u6B31": "hap6/hot3",
    "\u6B32": "juk6",
    "\u6B33": "wai2",
    "\u6B34": "long4",
    "\u6B35": "fun2",
    "\u6B36": "sok3",
    "\u6B37": "hei1",
    "\u6B38": "ei6/ngei6/ei1/ngei1/ei3/ngei3/oi1/ngoi1/aai2/ngaai2",
    "\u6B39": "ji1/kei1",
    "\u6B3A": "hei1",
    "\u6B3B": "fat1/caat3",
    "\u6B3C": "zyut3",
    "\u6B3D": "jam1",
    "\u6B3E": "fun2",
    "\u6B3F": "ham2/daam6",
    "\u6B40": "fun2",
    "\u6B41": "ham2",
    "\u6B42": "cyun4/cyun2",
    "\u6B43": "saap3",
    "\u6B44": "gwaa1",
    "\u6B45": "jan1",
    "\u6B46": "jam1",
    "\u6B47": "hit3",
    "\u6B48": "jyu4",
    "\u6B49": "hip3/him3",
    "\u6B4A": "hiu1",
    "\u6B4B": "ji4",
    "\u6B4C": "go1",
    "\u6B4D": "wu1",
    "\u6B4E": "taan3",
    "\u6B4F": "gan6",
    "\u6B50": "au1/ngau1/au2/ngau2",
    "\u6B51": "fu1",
    "\u6B52": "tik1",
    "\u6B53": "fun1",
    "\u6B54": "heoi1",
    "\u6B55": "pan3/fan5/pan1",
    "\u6B56": "hei2",
    "\u6B57": "siu3",
    "\u6B58": "fat1/caat3",
    "\u6B59": "kap1/sip3",
    "\u6B5A": "sin6",
    "\u6B5B": "lim5/lim6",
    "\u6B5C": "cuk1",
    "\u6B5D": "jik6",
    "\u6B5E": "ngap6/ap6",
    "\u6B5F": "jyu4",
    "\u6B60": "zyut3",
    "\u6B61": "fun1",
    "\u6B62": "zi2",
    "\u6B63": "zing3/zing1/zeng3",
    "\u6B64": "ci2",
    "\u6B65": "bou6",
    "\u6B66": "mou5",
    "\u6B67": "kei4",
    "\u6B68": "bou6",
    "\u6B69": "bou6",
    "\u6B6A": "waai1/me2",
    "\u6B6B": "keoi5/geoi6",
    "\u6B6C": "cin4",
    "\u6B6D": "ci4",
    "\u6B6E": "gip3",
    "\u6B6F": "ci2",
    "\u6B70": "sap1/saap3",
    "\u6B71": "zung2/dung2",
    "\u6B72": "seoi3",
    "\u6B73": "seoi3",
    "\u6B74": "lik6",
    "\u6B75": "zaak6",
    "\u6B76": "jyu4",
    "\u6B77": "lik6",
    "\u6B78": "gwai1",
    "\u6B79": "daai2",
    "\u6B7A": "aat3/ngaat3",
    "\u6B7B": "sei2/si2",
    "\u6B7C": "cim1",
    "\u6B7D": "zit3",
    "\u6B7E": "mut6/man5",
    "\u6B7F": "mut6",
    "\u6B80": "jiu2",
    "\u6B81": "mut6",
    "\u6B82": "cou4",
    "\u6B83": "joeng1",
    "\u6B84": "tin5/tim5",
    "\u6B85": "sang1",
    "\u6B86": "toi5/doi6",
    "\u6B87": "soeng1",
    "\u6B88": "gwik1",
    "\u6B89": "seon1/seon6",
    "\u6B8A": "syu4",
    "\u6B8B": "caan4",
    "\u6B8C": "kyut3",
    "\u6B8D": "piu5/fu1",
    "\u6B8E": "haap3",
    "\u6B8F": "kau4",
    "\u6B90": "suk1",
    "\u6B91": "king4/ging6",
    "\u6B92": "wan5",
    "\u6B93": "lim5/lim6",
    "\u6B94": "ji6",
    "\u6B95": "fau2",
    "\u6B96": "zik6",
    "\u6B97": "jip3",
    "\u6B98": "caan4",
    "\u6B99": "fan1",
    "\u6B9A": "daan1",
    "\u6B9B": "gik1",
    "\u6B9C": "jip6/dip6",
    "\u6B9D": "zeon1",
    "\u6B9E": "wan5",
    "\u6B9F": "wan1",
    "\u6BA0": "cau3",
    "\u6BA1": "ban3",
    "\u6BA2": "tai3",
    "\u6BA3": "gan2",
    "\u6BA4": "soeng1",
    "\u6BA5": "jan4",
    "\u6BA6": "diu1",
    "\u6BA7": "zau6",
    "\u6BA8": "kui2/kwui2",
    "\u6BA9": "cyun3",
    "\u6BAA": "ji3",
    "\u6BAB": "daan1",
    "\u6BAC": "dou3",
    "\u6BAD": "goeng1",
    "\u6BAE": "lim5/lim6",
    "\u6BAF": "ban3",
    "\u6BB0": "duk6",
    "\u6BB1": "cim1",
    "\u6BB2": "cim1",
    "\u6BB3": "syu4",
    "\u6BB4": "au2/ngau2/au1/ngau1",
    "\u6BB5": "dyun6",
    "\u6BB6": "zyu3",
    "\u6BB7": "jan1/jan2/jin1",
    "\u6BB8": "hing3",
    "\u6BB9": "ai3/ngai3",
    "\u6BBA": "saat3/saai3",
    "\u6BBB": "hok3",
    "\u6BBC": "hok3/hok2",
    "\u6BBD": "ngaau4/aau4",
    "\u6BBE": "seon3",
    "\u6BBF": "din6",
    "\u6BC0": "wai2",
    "\u6BC1": "wai2",
    "\u6BC2": "guk1/gu1/gwu1",
    "\u6BC3": "kok3",
    "\u6BC4": "gik1",
    "\u6BC5": "ngai6/ai6",
    "\u6BC6": "au2/ngau2/au1/ngau1",
    "\u6BC7": "wai2",
    "\u6BC8": "dyun6",
    "\u6BC9": "ji1",
    "\u6BCA": "hiu1",
    "\u6BCB": "mou4",
    "\u6BCC": "gun3/gwun3",
    "\u6BCD": "mou5/mou2",
    "\u6BCE": "mui5",
    "\u6BCF": "mui5",
    "\u6BD0": "oi2/ngoi2",
    "\u6BD1": "ze2",
    "\u6BD2": "duk6/dou6/doi6",
    "\u6BD3": "juk1/juk6",
    "\u6BD4": "bei2/bei6/pei4",
    "\u6BD5": "bat1",
    "\u6BD6": "bei3",
    "\u6BD7": "pei4/bei2",
    "\u6BD8": "pei4/bei2",
    "\u6BD9": "bai6",
    "\u6BDA": "caam4",
    "\u6BDB": "mou4/mou1",
    "\u6BDC": "hou4",
    "\u6BDD": "coi2",
    "\u6BDE": "pei4",
    "\u6BDF": "siu2",
    "\u6BE0": "gaa1",
    "\u6BE1": "zin1",
    "\u6BE2": "soi1",
    "\u6BE3": "muk6",
    "\u6BE4": "teoi3",
    "\u6BE5": "seon1",
    "\u6BE6": "nei6/lei6",
    "\u6BE7": "jung2/jung4",
    "\u6BE8": "sin2",
    "\u6BE9": "guk1",
    "\u6BEA": "mou4/mau4",
    "\u6BEB": "hou4/hou2",
    "\u6BEC": "kau4",
    "\u6BED": "dau6",
    "\u6BEE": "caau1",
    "\u6BEF": "taan2/taam2",
    "\u6BF0": "pui4",
    "\u6BF1": "guk1",
    "\u6BF2": "zyut3",
    "\u6BF3": "ceoi3",
    "\u6BF4": "bei1",
    "\u6BF5": "saam1",
    "\u6BF6": "saam1",
    "\u6BF7": "mou6",
    "\u6BF8": "soi1",
    "\u6BF9": "syu1/jyu4",
    "\u6BFA": "syu1/jyu4",
    "\u6BFB": "teoi3",
    "\u6BFC": "hot3",
    "\u6BFD": "gin3/jin2",
    "\u6BFE": "taap3",
    "\u6BFF": "saam1",
    "\u6C00": "leoi4",
    "\u6C01": "mou4",
    "\u6C02": "mou4/lei4",
    "\u6C03": "tung4",
    "\u6C04": "jung2/jung5",
    "\u6C05": "cong2",
    "\u6C06": "pou2",
    "\u6C07": "lou5",
    "\u6C08": "zin1",
    "\u6C09": "cou3/sou3",
    "\u6C0A": "zin1",
    "\u6C0B": "mung4",
    "\u6C0C": "lou5",
    "\u6C0D": "keoi4",
    "\u6C0E": "dip6",
    "\u6C0F": "si6/zi1",
    "\u6C10": "dai1/dai2",
    "\u6C11": "man4",
    "\u6C12": "kyut3",
    "\u6C13": "maang4/mang4/man4/mong4",
    "\u6C14": "hei3",
    "\u6C15": "pit3",
    "\u6C16": "naai5/laai5",
    "\u6C17": "hei3",
    "\u6C18": "dou1",
    "\u6C19": "sin1/saan3",
    "\u6C1A": "cyun1",
    "\u6C1B": "fan1",
    "\u6C1C": "joeng4",
    "\u6C1D": "noi6/loi6",
    "\u6C1E": "bing2",
    "\u6C1F": "fat1",
    "\u6C20": "san1",
    "\u6C21": "dung1",
    "\u6C22": "hing1",
    "\u6C23": "hei3",
    "\u6C24": "jan1",
    "\u6C25": "sai1",
    "\u6C26": "hoi6",
    "\u6C27": "joeng5",
    "\u6C28": "on1/ngon1",
    "\u6C29": "aa3/ngaa3",
    "\u6C2A": "hak1",
    "\u6C2B": "hing1",
    "\u6C2C": "aa3/ngaa3",
    "\u6C2D": "dung1",
    "\u6C2E": "daam6",
    "\u6C2F": "luk6",
    "\u6C30": "cing1",
    "\u6C31": "joeng4",
    "\u6C32": "wan1",
    "\u6C33": "wan1",
    "\u6C34": "seoi2",
    "\u6C35": "seoi2/saam1.dim2.seoi2",
    "\u6C36": "cing2",
    "\u6C37": "bing1",
    "\u6C38": "wing5",
    "\u6C39": "tam3/dam4/tam5",
    "\u6C3A": "seoi2/taai3.zi6.dai2",
    "\u6C3B": "lak6",
    "\u6C3C": "nik6/lik6",
    "\u6C3D": "dan2/tan1/tan2",
    "\u6C3E": "faan4/faan3/faan6",
    "\u6C3F": "gwai2/gau2",
    "\u6C40": "ting1/ding1",
    "\u6C41": "zap1",
    "\u6C42": "kau4",
    "\u6C43": "ban1/paak3/paat3",
    "\u6C44": "zak1",
    "\u6C45": "min5",
    "\u6C46": "cyun1",
    "\u6C47": "wui6",
    "\u6C48": "diu1",
    "\u6C49": "hon3",
    "\u6C4A": "caa3",
    "\u6C4B": "joek6/zoek3",
    "\u6C4C": "cyun3",
    "\u6C4D": "jyun4",
    "\u6C4E": "faan4/faan3/faan6",
    "\u6C4F": "daai6/taai3",
    "\u6C50": "zik6",
    "\u6C51": "tok3",
    "\u6C52": "mong4",
    "\u6C53": "cau4",
    "\u6C54": "ngat6/at6",
    "\u6C55": "saan3",
    "\u6C56": "pan3",
    "\u6C57": "hon6/hon4",
    "\u6C58": "cim4",
    "\u6C59": "waa1/wu1/wu3",
    "\u6C5A": "wu1/wu3",
    "\u6C5B": "seon3",
    "\u6C5C": "ci5",
    "\u6C5D": "jyu5",
    "\u6C5E": "hung3",
    "\u6C5F": "gong1",
    "\u6C60": "ci4",
    "\u6C61": "wu1/wu3",
    "\u6C62": "tou2",
    "\u6C63": "gwai2",
    "\u6C64": "tong1/soeng1/tong3/joeng4",
    "\u6C65": "zi1",
    "\u6C66": "zi2",
    "\u6C67": "hin1",
    "\u6C68": "mik6",
    "\u6C69": "gwat1",
    "\u6C6A": "wong1",
    "\u6C6B": "zeng2",
    "\u6C6C": "zing6",
    "\u6C6D": "jeoi6",
    "\u6C6E": "gwan1",
    "\u6C6F": "wang4",
    "\u6C70": "taai3",
    "\u6C71": "gyun2",
    "\u6C72": "kap1",
    "\u6C73": "bin6",
    "\u6C74": "bin6",
    "\u6C75": "gam3",
    "\u6C76": "man6/man4",
    "\u6C77": "zung1",
    "\u6C78": "fong1/pong1/pong4",
    "\u6C79": "hung1",
    "\u6C7A": "kyut3/hyut3",
    "\u6C7B": "wu2",
    "\u6C7C": "ngau4/au4",
    "\u6C7D": "hei3",
    "\u6C7E": "fan4",
    "\u6C7F": "zeoi6",
    "\u6C80": "zeoi6",
    "\u6C81": "sam3",
    "\u6C82": "ji4/ngan4/an4",
    "\u6C83": "juk1",
    "\u6C84": "wan4",
    "\u6C85": "jyun4",
    "\u6C86": "hong4/hong5",
    "\u6C87": "jin5/jin2",
    "\u6C88": "sam2/cam4",
    "\u6C89": "cam4",
    "\u6C8A": "dam2",
    "\u6C8B": "jau4",
    "\u6C8C": "deon6",
    "\u6C8D": "wu6",
    "\u6C8E": "fo3",
    "\u6C8F": "cai3/cit3",
    "\u6C90": "muk6",
    "\u6C91": "nuk6/luk6",
    "\u6C92": "mut6",
    "\u6C93": "daap6",
    "\u6C94": "min5",
    "\u6C95": "mat6",
    "\u6C96": "cung1",
    "\u6C97": "tim1",
    "\u6C98": "bei2",
    "\u6C99": "saa1",
    "\u6C9A": "zi2",
    "\u6C9B": "pui3",
    "\u6C9C": "pun3",
    "\u6C9D": "zeoi2",
    "\u6C9E": "zaap3",
    "\u6C9F": "kau1/gau1",
    "\u6CA0": "paai3",
    "\u6CA1": "mut6",
    "\u6CA2": "zaak6",
    "\u6CA3": "fung1",
    "\u6CA4": "au3/ngau3/au1/ngau1",
    "\u6CA5": "lik6/lik1/lek6",
    "\u6CA6": "leon4",
    "\u6CA7": "cong1",
    "\u6CA8": "fung1/fung4",
    "\u6CA9": "gwai1",
    "\u6CAA": "wu6",
    "\u6CAB": "mut6",
    "\u6CAC": "mui6",
    "\u6CAD": "seot6",
    "\u6CAE": "zeoi1/zeoi2/zeoi3",
    "\u6CAF": "zaat3",
    "\u6CB0": "tok3",
    "\u6CB1": "to4",
    "\u6CB2": "to4",
    "\u6CB3": "ho4/ho2",
    "\u6CB4": "leoi6",
    "\u6CB5": "leoi6/mei4/mei5/nei4/lei4",
    "\u6CB6": "ji4",
    "\u6CB7": "faat3",
    "\u6CB8": "fai3",
    "\u6CB9": "jau4/jau2",
    "\u6CBA": "tin4",
    "\u6CBB": "zi6/ci4",
    "\u6CBC": "ziu2",
    "\u6CBD": "gu1/gwu1/gu2/gwu2",
    "\u6CBE": "zim1",
    "\u6CBF": "jyun4",
    "\u6CC0": "si1",
    "\u6CC1": "fong3/fong2",
    "\u6CC2": "gwing2",
    "\u6CC3": "keoi1/gau1",
    "\u6CC4": "sit3/jai6",
    "\u6CC5": "cau4",
    "\u6CC6": "jat6",
    "\u6CC7": "gaa1",
    "\u6CC8": "zung1",
    "\u6CC9": "cyun4",
    "\u6CCA": "bok6/paak3",
    "\u6CCB": "wai3",
    "\u6CCC": "bei3/bat6",
    "\u6CCD": "ban1",
    "\u6CCE": "zaak6",
    "\u6CCF": "zeot1",
    "\u6CD0": "lak6/laak6",
    "\u6CD1": "jau2/jau1",
    "\u6CD2": "gu1/gwu1",
    "\u6CD3": "wang4",
    "\u6CD4": "gam1",
    "\u6CD5": "faat3/faat2",
    "\u6CD6": "maau5",
    "\u6CD7": "si3",
    "\u6CD8": "fu1",
    "\u6CD9": "paang1/ping4",
    "\u6CDA": "ci2",
    "\u6CDB": "faan3/faan6/faan4",
    "\u6CDC": "ci4/zi6/zi1",
    "\u6CDD": "sou3",
    "\u6CDE": "ning6/ling6/ning4/ling4",
    "\u6CDF": "zaa1",
    "\u6CE0": "ling4",
    "\u6CE1": "paau1/pou5/paau3/paau2/pau3",
    "\u6CE2": "bo1",
    "\u6CE3": "jap1",
    "\u6CE4": "ci5",
    "\u6CE5": "nai4/lai4/nai2/lai2/nei6/lei6",
    "\u6CE6": "guk1",
    "\u6CE7": "kut3/kwut3",
    "\u6CE8": "zyu3",
    "\u6CE9": "sang1",
    "\u6CEA": "leoi6",
    "\u6CEB": "jyun5",
    "\u6CEC": "kyut3/hyut3",
    "\u6CED": "fu1",
    "\u6CEE": "pun3/bun6",
    "\u6CEF": "man5",
    "\u6CF0": "taai3",
    "\u6CF1": "joeng1",
    "\u6CF2": "zai3/zai2/zi2",
    "\u6CF3": "wing6",
    "\u6CF4": "gun3/gwun3",
    "\u6CF5": "bam1",
    "\u6CF6": "hok6",
    "\u6CF7": "lung4/soeng1",
    "\u6CF8": "lou4",
    "\u6CF9": "daan3",
    "\u6CFA": "lok6/bok6/lik1",
    "\u6CFB": "se3/se2",
    "\u6CFC": "put3/but3",
    "\u6CFD": "zaak6/sik1",
    "\u6CFE": "ging1",
    "\u6CFF": "ngan4/an4",
    "\u6D00": "zau1/pun4",
    "\u6D01": "git3",
    "\u6D02": "jik6",
    "\u6D03": "fui1",
    "\u6D04": "wui4",
    "\u6D05": "zoi3",
    "\u6D06": "sing4",
    "\u6D07": "jan1",
    "\u6D08": "ngai4/ai4",
    "\u6D09": "hau6",
    "\u6D0A": "zin3",
    "\u6D0B": "joeng4/joeng2",
    "\u6D0C": "lit6",
    "\u6D0D": "ci5",
    "\u6D0E": "gei3/gei6",
    "\u6D0F": "ji4",
    "\u6D10": "hang4",
    "\u6D11": "fuk6/fu4",
    "\u6D12": "saa2/sai2/sin2",
    "\u6D13": "saak3",
    "\u6D14": "zi2",
    "\u6D15": "jan5",
    "\u6D16": "ng4/m4",
    "\u6D17": "sai2/sin2",
    "\u6D18": "haau2",
    "\u6D19": "zyu1",
    "\u6D1A": "gong3/hung4",
    "\u6D1B": "lok3/lok6",
    "\u6D1C": "lok3",
    "\u6D1D": "on3/ngon3",
    "\u6D1E": "dung6/dung2/tung4",
    "\u6D1F": "ji4/tai3",
    "\u6D20": "mau4",
    "\u6D21": "leoi6",
    "\u6D22": "ji1",
    "\u6D23": "mai5",
    "\u6D24": "cyun4",
    "\u6D25": "zeon1",
    "\u6D26": "paak3",
    "\u6D27": "fui2",
    "\u6D28": "ngaau4/aau4",
    "\u6D29": "jai6/sit3",
    "\u6D2A": "hung4",
    "\u6D2B": "gwik1",
    "\u6D2C": "suk1",
    "\u6D2D": "hong1",
    "\u6D2E": "tou4/jiu4",
    "\u6D2F": "kit3",
    "\u6D30": "keoi4",
    "\u6D31": "ji5/nei5/lei5/nei2/lei2",
    "\u6D32": "zau1",
    "\u6D33": "jyu6",
    "\u6D34": "ping4/paang1",
    "\u6D35": "seon1",
    "\u6D36": "hung1",
    "\u6D37": "zat6",
    "\u6D38": "gwong1/gong1",
    "\u6D39": "wun4/jyun4",
    "\u6D3A": "ming4",
    "\u6D3B": "wut6/gut3/gwut3",
    "\u6D3C": "waa1/gwai1",
    "\u6D3D": "hap1/hap6",
    "\u6D3E": "paai3/paai1/paai2",
    "\u6D3F": "wu1",
    "\u6D40": "kuk1",
    "\u6D41": "lau4/lau2",
    "\u6D42": "gun3/gwun3",
    "\u6D43": "zip3/gaap3",
    "\u6D44": "zing6/zeng6",
    "\u6D45": "cin2/zin1",
    "\u6D46": "zoeng1",
    "\u6D47": "hiu1/giu1/ngou6/ou6",
    "\u6D48": "zing1",
    "\u6D49": "si1",
    "\u6D4A": "zuk6",
    "\u6D4B": "cak1/caak1",
    "\u6D4C": "fat6",
    "\u6D4D": "kui2/kwui2",
    "\u6D4E": "zai3/zai2",
    "\u6D4F": "lau4",
    "\u6D50": "caan2",
    "\u6D51": "wan4/wan6",
    "\u6D52": "wu2/heoi2",
    "\u6D53": "nung4/lung4",
    "\u6D54": "cam4",
    "\u6D55": "zeon6",
    "\u6D56": "lyut6",
    "\u6D57": "kau4",
    "\u6D58": "mei5",
    "\u6D59": "zit3",
    "\u6D5A": "zeon3/seon3",
    "\u6D5B": "ham4",
    "\u6D5C": "bong1/ban1",
    "\u6D5D": "mong4",
    "\u6D5E": "zuk1/zok6",
    "\u6D5F": "jau4/dik6",
    "\u6D60": "hei1",
    "\u6D61": "but6",
    "\u6D62": "dau6",
    "\u6D63": "wun5/wun2",
    "\u6D64": "wang4",
    "\u6D65": "jap1/aap3/ngaap3",
    "\u6D66": "pou2/pou4",
    "\u6D67": "jing5",
    "\u6D68": "lam5",
    "\u6D69": "hou6",
    "\u6D6A": "long6/long4",
    "\u6D6B": "hon2",
    "\u6D6C": "lei5/hoi2.lei5",
    "\u6D6D": "gang1/gaang3",
    "\u6D6E": "fau4",
    "\u6D6F": "ng4/m4",
    "\u6D70": "lin6/lei6",
    "\u6D71": "seon4",
    "\u6D72": "fung4",
    "\u6D73": "jik6",
    "\u6D74": "juk6",
    "\u6D75": "tung4",
    "\u6D76": "lou4",
    "\u6D77": "hoi2",
    "\u6D78": "zam3/cam1",
    "\u6D79": "zip3/gaap3",
    "\u6D7A": "cung1",
    "\u6D7B": "gwing2",
    "\u6D7C": "mui5",
    "\u6D7D": "seoi1",
    "\u6D7E": "zaa1",
    "\u6D7F": "bui3",
    "\u6D80": "jin6",
    "\u6D81": "sam3",
    "\u6D82": "tou4/ceoi4",
    "\u6D83": "kwan3",
    "\u6D84": "ping1",
    "\u6D85": "nip6/lip6",
    "\u6D86": "hon6",
    "\u6D87": "ging1",
    "\u6D88": "siu1",
    "\u6D89": "sip3/dip6",
    "\u6D8A": "nin5/lin5",
    "\u6D8B": "teot1",
    "\u6D8C": "cung1/jung2",
    "\u6D8D": "haau3",
    "\u6D8E": "jin4",
    "\u6D8F": "ting5",
    "\u6D90": "ngo4/o4",
    "\u6D91": "cuk1",
    "\u6D92": "tan1",
    "\u6D93": "gyun1",
    "\u6D94": "sam4",
    "\u6D95": "tai3",
    "\u6D96": "lei6",
    "\u6D97": "seoi3",
    "\u6D98": "zi6",
    "\u6D99": "leoi6",
    "\u6D9A": "seoi3",
    "\u6D9B": "tou4",
    "\u6D9C": "duk6",
    "\u6D9D": "lou6/lou4",
    "\u6D9E": "loi4",
    "\u6D9F": "lin4",
    "\u6DA0": "wai4",
    "\u6DA1": "wo1/gwo1/go1",
    "\u6DA2": "wan4",
    "\u6DA3": "wun6",
    "\u6DA4": "dik6",
    "\u6DA5": "hang1",
    "\u6DA6": "jeon6/jeon2",
    "\u6DA7": "gaan3/gaan2",
    "\u6DA8": "zoeng2/zoeng3",
    "\u6DA9": "gip3/sik1/sap1",
    "\u6DAA": "fau4",
    "\u6DAB": "gun3/gwun3",
    "\u6DAC": "hang6",
    "\u6DAD": "sau6",
    "\u6DAE": "saan3",
    "\u6DAF": "ngaai4/aai4",
    "\u6DB0": "zyut3",
    "\u6DB1": "zoeng2",
    "\u6DB2": "jik6",
    "\u6DB3": "hung1",
    "\u6DB4": "wo3/jyun2",
    "\u6DB5": "haam4",
    "\u6DB6": "to1",
    "\u6DB7": "dung1/dung3",
    "\u6DB8": "kok3",
    "\u6DB9": "wo1",
    "\u6DBA": "geoi1",
    "\u6DBB": "se3",
    "\u6DBC": "loeng4/loeng2/loeng6",
    "\u6DBD": "fan1",
    "\u6DBE": "taap3",
    "\u6DBF": "doek3",
    "\u6DC0": "din6",
    "\u6DC1": "cip3",
    "\u6DC2": "dak1",
    "\u6DC3": "gyun6",
    "\u6DC4": "zi1",
    "\u6DC5": "sik1",
    "\u6DC6": "ngaau4/aau4",
    "\u6DC7": "kei4",
    "\u6DC8": "gwat1",
    "\u6DC9": "gwo2/go2",
    "\u6DCA": "jim1",
    "\u6DCB": "lam4/lam2/lam6",
    "\u6DCC": "tong2",
    "\u6DCD": "zau1",
    "\u6DCE": "fung2",
    "\u6DCF": "hou6",
    "\u6DD0": "coeng1",
    "\u6DD1": "suk6",
    "\u6DD2": "cai1",
    "\u6DD3": "fong1",
    "\u6DD4": "zik6",
    "\u6DD5": "luk6",
    "\u6DD6": "naau6/laau6/coek3/zoek3",
    "\u6DD7": "guk1",
    "\u6DD8": "tou4",
    "\u6DD9": "cung4/zung1",
    "\u6DDA": "lai6/leoi6",
    "\u6DDB": "zit3",
    "\u6DDC": "pang4/ping1",
    "\u6DDD": "fei4",
    "\u6DDE": "sung1",
    "\u6DDF": "tin2",
    "\u6DE0": "pei3/pui3",
    "\u6DE1": "daam6/taam5",
    "\u6DE2": "wik6/gwik1",
    "\u6DE3": "ngai4/ai4",
    "\u6DE4": "jyu1/jyu2/ji1",
    "\u6DE5": "luk6",
    "\u6DE6": "gam3/gaam3",
    "\u6DE7": "mat6",
    "\u6DE8": "zing6/zeng6",
    "\u6DE9": "ling4",
    "\u6DEA": "leon4",
    "\u6DEB": "jam4",
    "\u6DEC": "ceoi3/seoi6",
    "\u6DED": "keoi4",
    "\u6DEE": "waai4",
    "\u6DEF": "juk6",
    "\u6DF0": "naam5/laam5/nam6/lam6/nam4/lam4/sam2",
    "\u6DF1": "sam1",
    "\u6DF2": "piu4",
    "\u6DF3": "seon4",
    "\u6DF4": "fat1",
    "\u6DF5": "jyun1",
    "\u6DF6": "loi4",
    "\u6DF7": "wan6/wan4",
    "\u6DF8": "cing1",
    "\u6DF9": "jim1",
    "\u6DFA": "cin2/zin1",
    "\u6DFB": "tim1",
    "\u6DFC": "miu5",
    "\u6DFD": "zi2",
    "\u6DFE": "jam2",
    "\u6DFF": "bok6",
    "\u6E00": "ban6",
    "\u6E01": "jyun1",
    "\u6E02": "man6",
    "\u6E03": "joek6",
    "\u6E04": "fei1",
    "\u6E05": "cing1",
    "\u6E06": "jyun1",
    "\u6E07": "hot3",
    "\u6E08": "zai3",
    "\u6E09": "sip3",
    "\u6E0A": "jyun1",
    "\u6E0B": "gip3",
    "\u6E0C": "luk6",
    "\u6E0D": "zi3/zik1",
    "\u6E0E": "duk6/dau6",
    "\u6E0F": "ji1",
    "\u6E10": "zim6/zim2/zim1",
    "\u6E11": "man5/sing4",
    "\u6E12": "bei1",
    "\u6E13": "kai1",
    "\u6E14": "jyu4",
    "\u6E15": "jyun1",
    "\u6E16": "sam2",
    "\u6E17": "sam3",
    "\u6E18": "jau4",
    "\u6E19": "wun6",
    "\u6E1A": "zyu2",
    "\u6E1B": "gaam2",
    "\u6E1C": "nyun5/lyun5",
    "\u6E1D": "jyu4",
    "\u6E1E": "cau4",
    "\u6E1F": "ting4",
    "\u6E20": "keoi4/keoi5/heoi5",
    "\u6E21": "dou6/dou2",
    "\u6E22": "fung1/fung4",
    "\u6E23": "zaa1",
    "\u6E24": "but6",
    "\u6E25": "ak1/ngak1/aak1/ngaak1",
    "\u6E26": "wo1/gwo1/go1",
    "\u6E27": "dai3",
    "\u6E28": "wui1/wai2",
    "\u6E29": "wan1",
    "\u6E2A": "jyu4",
    "\u6E2B": "sit3/dip6",
    "\u6E2C": "cak1/caak1",
    "\u6E2D": "wai6",
    "\u6E2E": "ho4",
    "\u6E2F": "gong2",
    "\u6E30": "jim2/jim1",
    "\u6E31": "hung4",
    "\u6E32": "hyun1/syun3/syun1",
    "\u6E33": "mai5",
    "\u6E34": "hot3/kit3",
    "\u6E35": "maau4",
    "\u6E36": "jing1",
    "\u6E37": "jin5",
    "\u6E38": "jau4",
    "\u6E39": "gwang1",
    "\u6E3A": "miu5",
    "\u6E3B": "saang2/sing2",
    "\u6E3C": "mei5",
    "\u6E3D": "zoi1",
    "\u6E3E": "wan4/wan6",
    "\u6E3F": "noi6/loi6",
    "\u6E40": "gwai2",
    "\u6E41": "cap1",
    "\u6E42": "ngok6/ok6",
    "\u6E43": "baai3/paai3",
    "\u6E44": "mei4",
    "\u6E45": "lin6",
    "\u6E46": "jap1",
    "\u6E47": "jap1",
    "\u6E48": "mui4",
    "\u6E49": "tim4",
    "\u6E4A": "cau3",
    "\u6E4B": "wai4/wai5",
    "\u6E4C": "caan1",
    "\u6E4D": "teon1/cyun2/zyun1",
    "\u6E4E": "min5",
    "\u6E4F": "mui6",
    "\u6E50": "paak3"
};

//# sourceMappingURL=jyutruby.c6decb82.js.map
